(function() {
  'use strict';

  angular
    .module('storeLocator', [ 'ngSanitize','ngAria', 'restangular', 'ui.router', 'ui.bootstrap',
    'underscore.string', 'ngRetina', 'angulartics', 'angulartics.google.analytics', 'angulartics.facebook.pixel', 'mgcrea.ngStrap', 'smoothScroll', 'ngAnimate', 'mj.scrollingTabs', 'ui.date']).config(function ($analyticsProvider) {
    $analyticsProvider.firstPageview(true); /* Records pages that don't use $state or $route */
    $analyticsProvider.withAutoBase(false);  /* Records full path */
        });
})();

(function () {
  'use strict';

  angular
    .module('storeLocator')
    .factory('carouselAccessibilityService', carouselAccessibilityService);

  function carouselAccessibilityService($timeout, $window) {
    /**
     * Service for handling accessibility concerns in carousels
     * Manages ARIA attributes for cards to ensure proper keyboard navigation
     */
    var service = {
      initCarousel: initCarousel,
      updateAriaVisibility: updateAriaVisibility,
      cleanupEventListeners: cleanupEventListeners
    };

    // Store references to event listeners for cleanup
    var eventListeners = {};

    return service;

    /**
     * Initialize accessibility support for a carousel
     * @param {Object} options - Configuration object
     * @param {string} options.carouselId - ID of the carousel element
     * @param {string} options.cardSelector - CSS selector for cards
     * @param {Function} options.dataChangeWatcher - Function that returns data to watch
     * @param {Object} options.$scope - Angular scope for watchers and lifecycle
     */
    function initCarousel(options) {
      var carouselId = options.carouselId;
      var cardSelector = options.cardSelector || '.datepicker-carousel-card';
      var $scope = options.$scope;

      // Watch for data changes if specified
      if (options.dataChangeWatcher) {
        $scope.$watch(options.dataChangeWatcher, function (newVal) {
          if (newVal && newVal.length > 0) {
            $timeout(function () {
              updateAriaVisibility(carouselId, cardSelector);
            }, 100);
          }
        });
      }

      // Initialize once and handle window resizing
      $timeout(function () {
        updateAriaVisibility(carouselId, cardSelector);
      }, 500);

      // Add resize handler
      var resizeHandler = function () {
        updateAriaVisibility(carouselId, cardSelector);
      };

      angular.element($window).on('resize', resizeHandler);
      eventListeners[carouselId] = resizeHandler;

      // Proper cleanup
      $scope.$on('$destroy', function () {
        cleanupEventListeners(carouselId);
      });

      return {
        update: function () {
          $timeout(function () {
            updateAriaVisibility(carouselId, cardSelector);
          }, 100);
        }
      };
    }

    /**
     * Remove event listeners for a carousel
     * @param {string} carouselId - ID of the carousel to clean up
     */
    function cleanupEventListeners(carouselId) {
      if (eventListeners[carouselId]) {
        angular.element($window).off('resize', eventListeners[carouselId]);
        delete eventListeners[carouselId];
      }
    }

    /**
     * Updates ARIA attributes on carousel date cards
     * @param {string} carouselId - ID of the carousel element
     * @param {string} cardSelector - CSS selector for cards
     */
    function updateAriaVisibility(carouselId, cardSelector) {
      // Process ARIA attributes on carousel date cards
      var cards = document.querySelectorAll(cardSelector);
      if (!cards.length) return;

      var carousel = document.getElementById(carouselId);
      var carouselWrapper = carousel.closest('.datepicker-carousel-wrapper');
      if (!carouselWrapper || !carousel) return;

      // Reset all cards to hidden/not focusable
      cards.forEach(function (card) {
        card.setAttribute('aria-hidden', 'true');
        card.setAttribute('tabindex', '-1');
      });

      // Calculate current position and visible cards
      var offset = calculateCardOffset(carousel);
      var dimensions = calculateVisibleCards(cards, carouselWrapper);

      // Mark visible cards as accessible
      for (var i = offset; i < offset + dimensions.visibleCount && i < cards.length; i++) {
        if (cards[i]) {
          cards[i].setAttribute('aria-hidden', 'false');
          cards[i].setAttribute('tabindex', '0');
        }
      }
    }

    /**
     * Calculates the current offset of the carousel based on its transform
     * @param {HTMLElement} carousel - The carousel element
     * @returns {number} - The current offset index
     */
    function calculateCardOffset(carousel) {
      var transformValue = carousel.style.transform || '';
      var offset = 0;

      if (transformValue.includes('translate(')) {
        var match = transformValue.match(/translate\((-?\d+)px\)/);
        if (match && match[1]) {
          offset = Math.abs(parseInt(match[1]) / 100);
        }
      }

      return Math.round(offset);
    }

    /**
     * Calculates how many cards are visible in the carousel viewport
     * @param {NodeList} cards - The card elements
     * @param {HTMLElement} wrapper - The carousel wrapper element
     * @returns {Object} - Dimensions object with card width and visibility counts
     */
    function calculateVisibleCards(cards, wrapper) {
      var wrapperWidth = wrapper.offsetWidth;

      // Get actual card width with margins
      var cardWidth = 100; // Default fallback
      if (cards.length > 0) {
        var card = cards[0];
        var styles = window.getComputedStyle(card);
        cardWidth = card.offsetWidth + parseInt(styles.marginLeft) + parseInt(styles.marginRight);
      }

      var fullVisibleCount = Math.floor(wrapperWidth / cardWidth);
      var remainingSpace = wrapperWidth - (fullVisibleCount * cardWidth);

      // A card is considered visible if 35% or more is showing
      var partialThreshold = 0.35;
      var extraPartialCard = (remainingSpace / cardWidth >= partialThreshold) ? 1 : 0;
      var visibleCount = Math.max(1, fullVisibleCount + extraPartialCard);

      return {
        cardWidth: cardWidth,
        fullVisible: fullVisibleCount,
        visibleCount: visibleCount
      };
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('storeLocator')
    .service('burberryFilterService', burberryFilterService);

  // This service is created to handle some special logic applied for Burberry:
  // Burberry needs to display certain Tags depending on the tag's "type"
  // the "type" corresponds to the STORE_LOCATOR_FILTERS types.
  function burberryFilterService(storeLocatorCache, DEFAULT_LANGUAGE, STORE_LOCATOR_FILTERS) {

    var storeServices = {};
    var language = storeLocatorCache.get('language') || DEFAULT_LANGUAGE;
    var storeLocatorFilters = typeof STORE_LOCATOR_FILTERS === "object" ? STORE_LOCATOR_FILTERS : JSON.parse(STORE_LOCATOR_FILTERS);

    function setStoreServicesMessages(){
      storeServices = {
        private_store_appointment: {
          label: setLabelByValue('private_store_appointment'),
          url: 'https://www.burberry.com/appointment-booking/'
        },
        aftercare_appointment: {
          label: setLabelByValue('aftercare_appointment'),
          url: 'https://www.burberry.com/appointment-booking/'
        },
        alterations: {
          label: setLabelByValue('alterations'),
          url: 'https://www.burberry.com/c/burberry-services/#product-help-and-advice'
        },
        monogram_your_product: {
          label: setLabelByValue('monogram_your_product'),
          url: 'https://www.burberry.com/c/personalisation-and-monogramming/'
        },
        gift_packaging: {
          label: setLabelByValue('gift_packaging'),
          url: 'https://www.burberry.com/c/burberry-services/'
        },
        collect_in_store: {
          label: setLabelByValue('collect_in_store'),
          url: 'https://www.burberry.com/c/burberry-services/'
        },
        return_in_store: {
          label: setLabelByValue('return_in_store'),
          url: 'https://www.burberry.com/c/burberry-services/#delivery-and-returns'
        },
      };
    }

    function setLabelByValue(valueToFind){
      var result = storeLocatorFilters[language].filter(function(item) {
        return item.value === valueToFind;
      });
      if(result.length > 0){
        return result[0].label;
      }
      return null;
    }

    this.getLocationStoreType = function (locationTags, filters) {
      if (locationTags) {
        var typeOfStoreFilters = getFiltersByType('Type of store', filters);
        var foundFilter = typeOfStoreFilters.find(function (filter) {
          return locationTags.indexOf(filter.value) !== -1
        });
        return foundFilter ? foundFilter.value === 'flagships' ? 'Flagship' : foundFilter.label : null;
      }
    };

    function getFiltersByType(type, storeLocatorFilters) {
      return storeLocatorFilters.filter(function (filter) {
        return filter.type === type;
      });
    }

    this.getStoreServices = function() {
      language = storeLocatorCache.get('language') || DEFAULT_LANGUAGE;
      setStoreServicesMessages();
      return storeServices;
    }

  }
})();

(function () {
  'use strict';

  angular
    .module('storeLocator')
    .directive('storeServicesLocalStoreCard', storeServicesLocalStoreCard);

  function storeServicesLocalStoreCard() {
    return {
      transclude: true,
      replace: true,
      scope: {
        locationTags: '=',
        locationId: '@',
        translatedMessages: '='
      },
      templateUrl: 'app/custom/clients/burberry/directives/storeServicesLocalStoreCard.directive.html',
      restrict: 'AE',
      bindToController: true,
      controllerAs: 'storeServicesLocalStoreC',
      controller: function ($element, $transclude, burberryFilterService) {

        var vm = this;
        vm.hasTranscludeData = false;
        vm.isExpanded = false;
        vm.maxServicesToShowWithoutShowMore = 4;

        $transclude(function(transcludedEl) {
          $element.find('.transclude').replaceWith(transcludedEl);
          vm.hasTranscludeData = $element.find('.transclude').length > 0;
        });

        var store_services = burberryFilterService.getStoreServices();

        vm.storeServices = [];
        vm.showMoreBtn = false;

        vm.showServicesAvailable = function() {
          vm.isExpanded = !vm.isExpanded;
          vm.showMoreBtn = true;
        }

        vm.showMore = function($event) {
          vm.showMoreBtn = !vm.showMoreBtn;
          $event.stopPropagation();
        }

        if (vm.locationTags) {
          vm.locationTags.sort().forEach(function(tag) {
            if (store_services[tag]) {
              vm.storeServices.push(store_services[tag]);
            }
          });
          if (vm.storeServices.length > vm.maxServicesToShowWithoutShowMore) {
            vm.showMoreBtn = true;
          }
        }
      }
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('storeLocator')
    .directive('storeServicesCard', storeServicesCard);

  function storeServicesCard() {
    return {
      replace: true,
      scope: {
        locationTags: '=',
        windowWidth: '=',
        translatedMessages: '='
      },
      templateUrl: 'app/custom/clients/burberry/directives/storeServicesCard.directive.html',
      restrict: 'AE',
      bindToController: true,
      controllerAs: 'storeServicesC',
      controller: function (burberryFilterService) {
        var vm = this;
        var store_services = burberryFilterService.getStoreServices();

        vm.storeServices = [];
        vm.showMoreBtn = false;

        vm.showMore = function(btn, moreText) {
          var btnText = document.getElementById(btn);
          if (btnText.innerHTML.includes(moreText)) {
            document.querySelectorAll('.local-services .store-service-item.hidden').forEach(function(item) {
              item.classList.remove('hidden');
              item.classList.add('open');
            });
            btnText.innerHTML = vm.translatedMessages['mf.common.showLess'] || 'Show less';
          } else {
            document.querySelectorAll('.local-services .store-service-item.open').forEach(function(item) {
              item.classList.remove('open');
              item.classList.add('hidden');
            });
            btnText.innerHTML = vm.translatedMessages['mf.common.showMore'] || 'Show more';
          }
        }

        if (vm.locationTags) {
          vm.locationTags.sort().forEach(function(tag) {
            if (store_services[tag]) {
              vm.storeServices.push(store_services[tag]);
            }
          });
          if (vm.storeServices.length > 4) {
            vm.showMoreBtn = true;
          }
        }
      }
    };
  }
})();

(function () {
    'use strict';

    angular
        .module('storeLocator')
        .directive('snowplowTracking', snowplowTracking);
    function snowplowTracking() {
        return {
            link: function (scope, element, attrs) {
                element.on('click', function() {
                    if (window.snowberry && window.entities) {
                        var ev = {
                            schema: "iglu:com.burberry/cta_event/jsonschema/1-0-1",
                            data: {
                                "action": 'click',
                                "component": '@boss/' + attrs.snowplowComponent,
                                "context": attrs.snowplowContext,
                                "description": attrs.snowplowDescription,
                                "name": attrs.snowplowName
                            }
                        }
                        window.snowberry('trackSelfDescribingEvent', {
                            event: ev,
                            context: window.entities
                        });
                    }
                })
            }
        }
    }
})();

(function () {
  'use strict';

  angular
    .module('storeLocator')
    .directive('searchBurberry', searchBurberry);

  function searchBurberry() {
    return {
      templateUrl: 'app/custom/clients/burberry/directives/searchBurberry.directive.html',
      restrict: 'E',
      scope: {},
      controller: searchBurberryController,
      controllerAs: 'searchBurberryCtrl',
      bindToController: {
        locatorStates: '=',
        mapObj: '=',
        hideElementName: '@?',
        translatedMessages: '=',
        hideFilterButton: '='
      }
    };

    function searchBurberryController(_, mapHelper, $location, markersUtils, $analytics, storeLocatorDictionary, $scope, filtersService, $rootScope, MFeedMarkerService) {
      var $ctrl = this;

      $ctrl.places =[];
      $ctrl.showFilters = false;
      $ctrl.hasFilters = filtersService.hasFilters();
      $ctrl.availableFilters = filtersService.getFilters();
      $ctrl.availableFilterTypes = filtersService.getFilterTypes();
      $ctrl.addFilter = addFilter;
      $ctrl.addPreFilter = addPreFilter;
      $ctrl.clearPreFilter = clearPreFilter;
      $ctrl.applyFilters = applyFilters;
      $ctrl.deletePreFilterByIndex = deletePreFilterByIndex;
      $ctrl.isItemSelected = isItemSelected;
      $ctrl.closeModal = closeModal;
      $ctrl.isFirstApplyFilter = true;
      $ctrl.accordionIsOpen = [];
      $ctrl.preFilters = [];
      $ctrl.preFiltersCopy = [];
      $ctrl.quantityOfFilters = 0;
      $ctrl.locatorStates.searchInput = "";

      // when filters doesn't charge before this directive is ready, we wait for $rootScope.$on
      if($ctrl.availableFilters === null){
        var filterTypesSetListener = $rootScope.$on('filterTypesSet', function(event, data) {
          $ctrl.availableFilterTypes = data.filterTypes;
          createToggleAndSetAccordion();
          addPreFilters();
        });
  
        var filtersSetListener = $rootScope.$on('filtersSet', function(event, data) {
          $ctrl.availableFilters = data.filters;
          $ctrl.hasFilters = data.filters !== null;
        });
      }else{
        createToggleAndSetAccordion();
        addPreFilters();
      }

      function addPreFilters(){
        $ctrl.selectedFilters = filtersService.getSelectedFilters();
        // if we navigate to a local page for example and when we back, we keep same filters
        if($ctrl.selectedFilters.length > 0 && $ctrl.preFilters.length === 0){
          $ctrl.selectedFilters.split(',').forEach(function(elem) {
            var found = $ctrl.availableFilters.find(function(item) {
              return item.value === elem;
            });
            if(found){
              $ctrl.preFilters.unshift(found.label)
            }
          });
        }

        if($ctrl.preFilters.length > 0){
          $ctrl.quantityOfFilters = $ctrl.preFilters.length;
          $ctrl.isFirstApplyFilter = false;
        }
      }

      $scope.$watch('$viewContentLoaded', function () {
        setTimeout(function () {
          $('ul[role="listbox"]').attr('aria-label', 'Search Location');
          $('#searchField').focus();
        }, 500)
      });

      $scope.$watch(
        function () {
          return document.querySelector('#search_box ul.dropdown-menu') && document.querySelector('#search_box ul.dropdown-menu').childElementCount;
        },
        function (newValue, oldValue) {
          if (newValue !== oldValue && newValue === 0) {
            document.getElementById('global-locations-map-container').style.zIndex = '399';
          }
        }
      );

      $ctrl.userLatLngSearch = function () {
        $ctrl.locatorStates.reloadMap = true;
        $ctrl.locatorStates.showLoader = true;
        $ctrl.locatorStates.zoom = storeLocatorDictionary.zoomLevels.nearMe;
        $ctrl.locatorStates.searchInput = "";
        $ctrl.locatorStates.areaSearched = false;
        mapHelper.setGeoStates($ctrl.locatorStates);

        if (!_.isUndefined($ctrl.locatorStates.position)) {
          mapHelper.setCoordinates($ctrl.locatorStates.position, $ctrl.locatorStates, $ctrl.mapObj);
        } else {
          navigator.geolocation.getCurrentPosition(successFunction, mapHelper.geoLocationError($ctrl.locatorStates))
        }
      };

      var successFunction = function (position) {
        mapHelper.setCoordinates(position, $ctrl.locatorStates, $ctrl.mapObj.map);
        locatorStates.reloadMap = false;
      };

      $ctrl.performSearch = function (searchField) {
        document.getElementById('global-locations-map-container').style.zIndex = '399';

        $ctrl.locatorStates.showLoader = true;
        if (searchField.name) {
          $ctrl.locatorStates.matchingText = null;

          // Changes input field from "Search Results" to current location name
          window.setTimeout(function() {
            var locationName = $ctrl.locatorStates.current
            if (searchField.name === "") {searchField.name = locationName}
            $ctrl.locatorStates.searchInput = searchField.name
          }, 1000)

          $analytics.eventTrack("Searched: " + $ctrl.locatorStates.searchInput, { category: "Store Locator", label: "Store Locator" });

          $ctrl.locatorStates.zoom = searchField.type ? storeLocatorDictionary.zoomLevels[searchField.type] : storeLocatorDictionary.zoomLevels.fallback;
          $ctrl.locatorStates.areaSearched = false;

          var data = searchField.feature;
          $ctrl.locatorStates.current = $ctrl.locatorStates.searchInput;
          if (data && !_.isEmpty(data)) {
            var currentLocation = data;
            $ctrl.locatorStates.searchInputData = data;
            mapHelper.setSearchCoordinates(currentLocation.center[1], currentLocation.center[0], $ctrl.locatorStates, $ctrl.mapObj);
            MFeedMarkerService.closeAllPopups($ctrl.mapObj.map);
          } else {
            _.each($ctrl.locatorStates.locationMarkersArray, function (mfMarker) {
              $ctrl.mapObj.removeMarker(mfMarker);
            });
            $ctrl.locatorStates.locations = [];
          }
        }
      };

      $ctrl.autoCompleteLocations = function (viewValue) {
        var lat = $ctrl.locatorStates.position.coords ? $ctrl.locatorStates.position.coords.latitude : $ctrl.locatorStates.mapCenter.latitude;
        var lon = $ctrl.locatorStates.position.coords ? $ctrl.locatorStates.position.coords.longitude : $ctrl.locatorStates.mapCenter.longitude;

        if (typeof viewValue === 'string' && viewValue.trim() === '') {
          document.getElementById('global-locations-map-container').style.zIndex = '399';
          return [];
        }
        $ctrl.places = markersUtils.getAutoCompleteLocations(viewValue, lat, lon)
          .then(function (data) {
            return _.map(data.features, function (feature) {
              return { name: feature.place_name, type: feature.place_type[0], feature: feature };
            });
          }, function (error) {
            if(error.status == 404){
              $location.path('/404')
            }
            else if(error.status == 400){
              $location.path('/400')
            }
            else if(error.status == 500){
              $location.path('/500')
            }
            else {
              locatorStates.errors = 'An error occurred. Please try again.';
            }
            document.querySelectorAll('.mf-loader').forEach(function (value) { value.classList.add('ng-hide') })
          });
        $ctrl.places.then(function (thing) {
          $ctrl.places = thing;
          
          if (thing.length > 0) {
            document.getElementById('global-locations-map-container').style.zIndex = '400';
          } else {
            document.getElementById('global-locations-map-container').style.zIndex = '399';
          }
        });
        return $ctrl.places;
      };

      $ctrl.autoCompleteSelect = function (searchField) {
        $ctrl.performSearch(searchField);
      };

      $ctrl.updatePlace = function (place) {
        $ctrl.locatorStates.zoom = storeLocatorDictionary.zoomLevels[place.types[0]] ?
          storeLocatorDictionary.zoomLevels[place.types[0]] :
          storeLocatorDictionary.zoomLevels.fallback;
        mapHelper.setPlace(place, $ctrl.locatorStates, $ctrl.mapObj);
      };

      $ctrl.hitSearchBtn = function () {
        if($ctrl.locatorStates.searchInput){
          if($ctrl.places[0]){
            $ctrl.locatorStates.searchInput = $ctrl.places[0];
          }
          $ctrl.performSearch($ctrl.locatorStates.searchInput);
        }
      };

      $ctrl.completeLocationAndSearch = function (name) {
        $ctrl.autoCompleteLocations(name).then(function () {
          if($ctrl.places.length === 0){
            $ctrl.places[0]= {
              name: $ctrl.locatorStates.searchInput,
              type: $ctrl.places[0].type ? $ctrl.places[0].type : '',
              feature:{}
            }
          }
          $ctrl.performSearch($ctrl.places[0])
        })
      }

      $ctrl.clearInput = function () {
        $ctrl.locatorStates.searchInput = '';
        document.getElementById('global-locations-map-container').style.zIndex = '399';
      }

      function addFilter(filter) {
        $ctrl.locatorStates.message = 'Filtering locations...';
        filtersService.addFilter(filter);
        $ctrl.locatorStates.selectedFilters = filtersService.getSelectedFilters();
        $ctrl.performSearch(searchField); // Added call to performSearch function to kickoff search
        mapHelper.loadList($ctrl.locatorStates);
      }

      $ctrl.showFiltersForActiveTab = function () {
        return ($ctrl.locatorStates.activeTab && $ctrl.locatorStates.activeTab.hasFilters) || !$ctrl.locatorStates.activeTab;
      }

      $ctrl.activeIndex = null;

      function createToggleAndSetAccordion(){
        $ctrl.toggleAccordion = function(index) {
          if ($ctrl.activeIndex === index) {
            $ctrl.activeIndex = null;
          } else {
            $ctrl.activeIndex = index;
          }
          $ctrl.setAccordionIsOpen(index);
        };
  
        $ctrl.setAccordionIsOpen = function(index){
          var filtersContainer = document.querySelector('.search-container-burberry');
          filtersContainer.classList.remove('mobile-search-container');
  
          var availableFilterTypesQuantity = $ctrl.availableFilterTypes.length;
          if (!isNaN(index)) {
            for (var i = 0; i < availableFilterTypesQuantity; i++) {
              $ctrl.accordionIsOpen[i] = (i === index) ? !$ctrl.accordionIsOpen[i] : false;
            }
          } else {
            $ctrl.preFiltersCopy = angular.copy($ctrl.preFilters);
            $ctrl.showFilters = !$ctrl.showFilters;
            if ($ctrl.showFilters && $ctrl.accordionIsOpen.length === 0) {
              $ctrl.accordionIsOpen = Array(availableFilterTypesQuantity).fill(false);
            }
          }
        }
      }

      function addPreFilter(filter) {
        if (!$ctrl.preFilters.includes(filter)) {
          $ctrl.preFilters.unshift(filter);
        }
      }

      function clearPreFilter() {
        $ctrl.preFilters = [];
      }

      function deletePreFilterByIndex(index) {
        $ctrl.preFilters.splice(index, 1);
      }

      function applyFilters(){
        // wen need to know which filters we have to add (this get the elements differents between preFilters and preFiltersCopy)
        var filtersToApply = $ctrl.preFilters.concat($ctrl.preFiltersCopy).filter(function(elem, index, arr) {
          return arr.indexOf(elem) === index && arr.lastIndexOf(elem) === index;
        });
        filtersToApply.forEach(function(elem) {
          addFilter(elem);
        });
        $ctrl.showFilters = false;
        if($ctrl.preFilters.length === 0){
          $ctrl.isFirstApplyFilter = true;
          $ctrl.activeIndex = null;
          $ctrl.accordionIsOpen = [];
        }else{
          $ctrl.isFirstApplyFilter = false;
        }
        $ctrl.quantityOfFilters = $ctrl.preFilters.length;
      }

      function isItemSelected(item){
        return $ctrl.preFilters.includes(item)
      }

      function closeModal(){
        var filtersContainer = document.querySelector('.search-container-burberry');
        filtersContainer.classList.add('mobile-search-container');

        $ctrl.showFilters = !$ctrl.showFilters
        if($ctrl.quantityOfFilters === 0){
          $ctrl.isFirstApplyFilter = true;
          $ctrl.activeIndex = null;
          $ctrl.accordionIsOpen = [];
          $ctrl.preFilters = [];
        }else{
          $ctrl.preFilters = angular.copy($ctrl.preFiltersCopy);
        }
      }

      $scope.$on('$destroy', filterTypesSetListener);
      $scope.$on('$destroy', filtersSetListener);

    }
  }

})();


(function () {
  'use strict';

  angular
    .module('storeLocator')
    .directive('paymentOptionsCard', paymentOptionsCard);

  function paymentOptionsCard() {
    return {
      replace: true,
      scope: {
        locationPaymentOptions: '@',
        translatedMessages: '='
      },
      templateUrl: 'app/custom/clients/burberry/directives/paymentOptionsCard.directive.html',
      restrict: 'AE',
      bindToController: true,
      controllerAs: 'paymentOptionsC',
      controller: function () {
        var vm = this;
        var global_payment_options = {
          amex: {
            label: 'Amex',
            image: '../../../../assets/images/clients/burberry/amex.svg'
          },
          visa: {
            label: 'Visa',
            image: '../../../../assets/images/clients/burberry/visa.svg'
          },
          mastercard: {
            label: 'Mastercard',
            image: '../../../../assets/images/clients/burberry/mastercard.svg'
          },
          apple_pay: {
            label: 'Apple Pay',
            image: '../../../../assets/images/clients/burberry/apple_pay.svg'
          },
          google_pay: {
            label: 'Google Pay',
            image: '../../../../assets/images/clients/burberry/google_pay.svg'
          },
          diners: {
            label: 'Diners',
            image: '../../../../assets/images/clients/burberry/diners.svg'
          },
          discover: {
            label: 'Discover',
            image: '../../../../assets/images/clients/burberry/discover.svg'
          },
          alipay: {
            label: 'Alipay',
            image: '../../../../assets/images/clients/burberry/alipay.svg'
          },
          jcb: {
            label: 'JCB',
            image: '../../../../assets/images/clients/burberry/jcb.svg'
          },
          union_pay: {
            label: 'UnionPay',
            image: '../../../../assets/images/clients/burberry/union_pay.svg'
          },
          we_chat_pay: {
            label: 'WeChat Pay',
            image: '../../../../assets/images/clients/burberry/we_chat_pay.svg'
          }
        };

        vm.paymentOptions = [];
        if (vm.locationPaymentOptions) {
          vm.locationPaymentOptions.split(',').forEach(function(paymentOption) {
            var po = paymentOption.trim();
            if (global_payment_options[po]) {
              vm.paymentOptions.push({
                value: po,
                label: global_payment_options[po].label,
                image: global_payment_options[po].image
              });
            }
          });
        }
      }
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('storeLocator')
    .directive('nearbyCardBurberry', nearbyCardBurberry);

  function nearbyCardBurberry () {

    return {
      replace: true,
      scope: {locations: '=', includeLocality: "@"},
      templateUrl: 'app/custom/clients/burberry/directives/nearbyCardBurberry.directive.html',
      restrict: 'AE',
      bindToController: {title: '=', localPageBtn: '=', personNotLocation: '=', translatedMessages: '='},
      controllerAs: 'nearbyCardBurberryC',
      controller: function ($scope, localLandingData, urlBuilderFactory, storeLocatorCache, RegionService, CLIENT_ROUTE) {
        var vm = this;
        var near = $scope.locations[0];
        vm.getDirectionsUrl = getDirectionsUrl;
        vm.getCustomFieldValueByName = getCustomFieldValueByName;
        vm.client_route = CLIENT_ROUTE;
        vm.getLocalPageUrl = getLocalPageUrl;
        vm.regionService = RegionService;
        vm.hoursLocations = {};
        vm.includeLocality = $scope.includeLocality !== "false";

        localLandingData.getLocationsForGeoSearch(near.store_info.latitude, near.store_info.longitude, 20, 4).then(function (response) {
          if (response.length > 1) {
            vm.nearbyLocations = _.filter(response, function (loc) {
              return near.store_info.corporate_id !== loc.corporate_id;
            });
            vm.nearbyLocations.forEach(function(loc) {
              vm.hoursLocations[loc.corporate_id] = loc;
              vm.hoursLocations[loc.corporate_id].directionsUrl = getDirectionsUrl(loc['address_detail']);
              vm.hoursLocations[loc.corporate_id].store_info = {
                store_hours: loc.hours || ''
              }
            });
          } else {
            vm.nearbyLocations = [];
          }
        })

        function getDirectionsUrl(data) {
          return urlBuilderFactory.getDirectionsUrl(data);
        }

        function getCustomFieldValueByName(customFields, name) {
          if (customFields) {
            var field = _.find(customFields, {'name': name});
            if (field) {
              return field.value;
            }
          }
          return null;
        }

        function getLocalPageUrl(location) {
          var language = storeLocatorCache.get('language');
          var url = vm.personNotLocation ? '/ll/' + location.name + location.llp_url.slice(3, location.llp_url.length) : location.llp_url

          if (!_.isEmpty(language) && !_.isUndefined(language)) {
            if(CLIENT_ROUTE){
              return CLIENT_ROUTE + '/' + language + url;
            }
            return language + url;
          }
          return url;
        }
      }
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('storeLocator')
    .directive('listHoursCard', listHoursCard);

  function listHoursCard() {
    return {
      replace: true,
      scope: {
        location: '=',
        translatedMessages: '='
      },
      templateUrl: 'app/custom/clients/burberry/directives/listHoursCard.directive.html',
      restrict: 'AE',
      controller: ListHoursController,
      controllerAs: 'listHoursCardC',
      bindToController: true
    };
  }

  function ListHoursController(_, s, moment) {
    var hoursCardC = this;
    hoursCardC.closedNow = true;
    hoursCardC.open24 = false;
    hoursCardC.displayLabel = "";

    if(hoursCardC.location.status === "temp closed") {
      hoursCardC.displayLabel = hoursCardC.translatedMessages['mf.common.temporarilyClosed'] || 'Temporarily Closed';
    }

    if(hoursCardC.location.status === "coming soon"){
      hoursCardC.displayLabel = hoursCardC.translatedMessages['mf.common.comingSoon'] || 'Coming Soon';
    }

    if (hoursCardC.location.store_info.store_hours === '') {
      hoursCardC.displayLabel = hoursCardC.translatedMessages['mf.common.closed'] || 'Closed';
    }

    if (hoursCardC.displayLabel === "") {
      var sh = hoursCardC.location && hoursCardC.location.store_info ? s(hoursCardC.location.store_info.store_hours).trim(";").value() : null;
      // Replace anything that isn't number, ';', ',', or the letters c, l, o, s, e, d in their lower and capital forms
      sh = sh.replace(/[^0-9;,closedCLOSED]/g,'');
      sh = sh.trim();

      // Check if time returned is valid
      var checkHoursFormat = /^[0-9;,closedCLOSED]+$/;
      if (sh && checkHoursFormat.test(sh)) {
        hoursCardC.locHours = generateHours(sh, "Closed");
      }

      // Check for special hours
      var specialHours = (hoursCardC.location &&
        hoursCardC.location.store_info &&
        hoursCardC.location.store_info.special_hours) ?
        s(hoursCardC.location.store_info.special_hours).trim(";").value() : null;

      if (specialHours !== null) {
        var validSpHours = checkSpecialHours(specialHours);
        if (!_.isEmpty(validSpHours)) {
          hoursCardC.specialHours = generateSpecialHours(validSpHours);
        }
      }

      var storeCurrentDateTime = getStoreCurrentTime(hoursCardC.location.store_info.timezone);
      var convertedStoreHour = moment(getConvertedStoreHours(storeCurrentDateTime), "LT");
      hoursCardC.displayLabel = getStoreStatus(convertedStoreHour);
    }

    function getStoreStatus(now) {
      var currentDaySpecial = hoursCardC.specialHours ? hoursCardC.specialHours.find(function(day) { return day.day === now.day().toString() }) : null;
      var currentDayOfWeek = now.day() === 0 ? 7 : now.day();
      var currentDay = hoursCardC.locHours[currentDayOfWeek];

      if (isOpen(currentDay, now) && !currentDaySpecial) {
        return (hoursCardC.translatedMessages['mf.common.openToday'] || 'Open today') + " " + currentDay.listHoursMessage;
      }

      if (currentDaySpecial) {
        if (isOpen(currentDaySpecial, now)) {
          return (hoursCardC.translatedMessages['mf.common.openToday'] || 'Open today') + " " + currentDaySpecial.listHoursMessage;
        } else {
          var nextOpenSpecialDay = getNextDay(hoursCardC.specialHours, now);
          if (nextOpenSpecialDay !== (hoursCardC.translatedMessages['mf.common.closed'] || 'Closed')) {
            return nextOpenSpecialDay;
          }
        }
      }

      return getNextDay(Object.values(hoursCardC.locHours), now, hoursCardC.specialHours);
    }

    function isOpen(day, now) {
      var closeTime = moment(day.closeTime, 'HH:mm:ss');
      return now.isBefore(closeTime) || now.isSame(closeTime);
    }

    function getNextDay(dayList, now, specialHours) {
      for (let i = 1; i <= 7; i++) {
        var nextDayNumber = now.clone().add(i, 'days').isoWeekday().toString();
        var nextDay = dayList.find(function(day) { return day.day === nextDayNumber });
        var nextSpecialDay = specialHours ? specialHours.find(function(day) { return day.day === nextDayNumber }) : null;
        if (nextSpecialDay && !nextSpecialDay.closed) {
          var dayName = i === 1 ? "tomorrow" : moment().isoWeekday(nextSpecialDay.day).format("dddd");
          return (hoursCardC.translatedMessages['mf.common.open'] || 'Open') + " " + dayName + " " + nextSpecialDay.listHoursMessage;
        } else if (!nextSpecialDay && nextDay && nextDay.openDisplayTime) {
          var dayName = i === 1 ? "tomorrow" : moment().isoWeekday(nextDay.day).format("dddd");
          return (hoursCardC.translatedMessages['mf.common.open'] || 'Open') + " " + dayName + " " + nextDay.listHoursMessage;
        }
      }
      return hoursCardC.translatedMessages['mf.common.closed'] || 'Closed';
    }

    /**
     * function returns true if passed value is null, undefined and legth is zero, else false
     * @param {string} storeTimeZone
     */
    function checkObj(storeTimeZone) {
      return ( _.isNull(storeTimeZone) || _.isUndefined(storeTimeZone) || storeTimeZone.length === 0 )
    }

    /**
     * function to check if the store is open or closed and set
     * the corresponding 'closedNow' value on the directive object
     * @param {object} hourObj hour object which has all the details about the timings/days
     */
    function updateTodaysHours(hourObj) {
      if (hourObj.closed) {
        hoursCardC.closed24 = true;
        return;
      }
      // check for today's special hours. start
      var isTodaySpecial = isTodaySpecialHours();
      //check for today's special hours. end
      //counter to loop through the number of fragments
      var counter = 0;
      while (counter < hourObj.numberOfTimeFragments.length) {
        var openTimePeriodKey = 'openTimePeriod' + '_' + counter;
        var closeTimePeriodKey = 'closeTimePeriod' + '_' + counter;

        if (hourObj[openTimePeriodKey] && hourObj[closeTimePeriodKey]) {
          hoursCardC[openTimePeriodKey] = moment(hourObj[openTimePeriodKey], "LT").format("LT")
          hoursCardC[closeTimePeriodKey] = moment(hourObj[closeTimePeriodKey], "hh:mm LT").format("LT");
        }

        if (moment(hourObj[closeTimePeriodKey], "LT").isBefore(moment(hourObj[openTimePeriodKey], "LT")) || moment(hourObj[closeTimePeriodKey], "LT").format('HHmm') === '0000') {
          hourObj[closeTimePeriodKey] = moment(hourObj[closeTimePeriodKey], "LT").add(1, 'days');
        }

        var amIBetweenGroupKey = 'amIBetweenGroup' + '_' + counter;
        var now = moment();
        // store timezone code start
        var storeTimeZone = hoursCardC.location.store_info.timezone; // store timezone from api
        var storeCurrentDateTime = null;
        var convertedStoreHour = null;
        var isInvalidObj = checkObj(storeTimeZone);
        if (!isInvalidObj) {
          storeCurrentDateTime = getStoreCurrentTime(storeTimeZone);
          convertedStoreHour = moment(getConvertedStoreHours(storeCurrentDateTime), "LT");
        }
        // store timezone code end
        // instead of now object the comparison is made with convertedStoreHour object
        var startTime = moment(hourObj[openTimePeriodKey], "LT");
        var endTime = moment(hourObj[closeTimePeriodKey], "LT");
        if(!isInvalidObj){
          if (endTime.format('HHmm') < (startTime.format('HHmm'))) {
            if (convertedStoreHour.format('HHmm') < endTime.format('HHmm')) {
              startTime = startTime.subtract(1, 'days');
            } else {
              endTime = endTime.add(1, 'days');
            }
          }
          amIBetweenGroupKey = convertedStoreHour.isBetween(startTime, endTime);
        } else {
          if (endTime.format('HHmm') < (startTime.format('HHmm'))) {
            if (now.format('HHmm') < endTime.format('HHmm')) {
              startTime = startTime.subtract(1, 'days');
            } else {
              endTime = endTime.add(1, 'days');
            }
          }
          amIBetweenGroupKey = now.isBetween(startTime, endTime);
        }

        if (amIBetweenGroupKey) {
          hoursCardC.closeToday = endTime.format("LT");
          if (amIBetweenGroupKey || hourObj.open24) {
            hoursCardC.closedNow = false;
          } else {
            hoursCardC.closedNow = true;
          }
        } else if(isTodaySpecial && !amIBetweenGroupKey){
          hoursCardC.closeToday = endTime.format("LT");
          hoursCardC.closedNow = true;
        }
        counter++;
      }

      hoursCardC.openToday = hourObj.openDisplayTime;
      hoursCardC.open24 = hourObj.open24;
    }

    function isTodaySpecialHours(){
      var isTodaySpecial = false;
      var specialHours = (hoursCardC.location &&
        hoursCardC.location.store_info &&
        hoursCardC.location.store_info.special_hours) ?
        s(hoursCardC.location.store_info.special_hours).trim(";").value() : null;

      if (specialHours !== null) {
        // Check if any special hours are coming up.
        var validSpHours = checkSpecialHours(specialHours);
        if (!_.isEmpty(validSpHours)) {
          isTodaySpecial=true;
        }
      }
      return isTodaySpecial;
    }

    function parseDateStrings(dateStrs) {
      var intDateStrs = dateStrs.split(";");
      return _.map(intDateStrs, function(dateStr) {
        var info = dateStr.split(",");
        if (angular.isDefined(info[1]) && info[1].toUpperCase() === "CLOSED") {
          // return just the day. This way we can use it to determine if today == which hour obj.
          return {
            day: info[0]
          };
        }
        else {
          // Else add open and close times based on the strings.
          // Will moment parse these to more readable strings later.
          var dateObj = {
            day: info[0],
            openTime: info[1],
            closeTime: info[2],
          }

          // when we have more than 2 hours (open and close), we add more attributes dinamically
          for (var i = 3; i < info.length; i += 2) {
            var period = Math.ceil(i/2)-1;
            dateObj['openTime_'+period] = info[i];
            dateObj['closeTime_'+period] = info[i+1];
          }

          return dateObj;
        }
      });
    }


    function getPropertiesByPrefix(obj, prefix) {
      return Object.keys(obj)
        .filter(function(key) {
          return key.startsWith(prefix);
        })
        .map(function(key) {
          return obj[key];
        });
    }


    /**
     * function generates hours object for each day
     * @param {string} dateStrs open and close times for the week
     * @param {string} closeLabel close label for the location
     */
    function generateHours(dateStrs, closeLabel) {
      // Split up the dateStrs and generate objects for each one
      var parsedDateStrs = parseDateStrings(dateStrs);
      var locHours = {};
      _.range(1, 8).forEach(function(day) {
        // Generate base objects per day
        var newHoursObj = {
          day: day.toString(),
          dayName: moment().isoWeekday(day).format("dddd"),
          dayNameShort: moment().isoWeekday(day).format("dd"),
          dayNameShortNext: moment().isoWeekday(day).add(1, 'd').format("dd"),
          closedLabel: closeLabel
        };
        // filter method gets all the matching objects for a certain day of the week
        var parsedData = _.filter(parsedDateStrs, function(obj) {
          return obj['day'] === day.toString();
        });

        // all the open and close time for the store location in an array
        var openTime, closeTime;

        if (parsedData[0]) {
          openTime = getPropertiesByPrefix(parsedData[0], 'openTime');
          closeTime = getPropertiesByPrefix(parsedData[0], 'closeTime');
        } else {
          openTime = _.map(parsedData, 'openTime');
          closeTime = _.map(parsedData, 'closeTime');
        }
        if (openTime[0] && closeTime[0]) {
          parsedData.listHoursMessage = moment(openTime[0],"hmm").format("LT") + ' - ' + moment(closeTime[0],"hmm").format("LT");
        }
        // adding the values to the object we will need to display all the times
        // and proper messaging for the store hours

        _.forEach(openTime, function(value, key) {
          //moment js doesn't recognize 2400 hrs
          if (closeTime[key] === '2400') {
            closeTime[key] = '0000';
          }
          parsedData['openTime' + 'PeriodDisplayMessage' + '_' + key] = displayOpenAndClosedTime(openTime[key], closeTime[key]);
          parsedData['openTime' + 'Period' + '_' + key] = openTime[key] ? moment(openTime[key],"hmm").format("LT") : "";
          parsedData['closeTime' + 'Period' + '_' + key] = closeTime[key] ? moment(closeTime[key],"hmm").format("LT") : "";
          parsedData['openTime'] = openTime[key];
          parsedData['closeTime'] = closeTime[key];
          parsedData['numberOfTimeFragments'] = new Array(_.keys(openTime).length);
          if (key !== 0) {
            parsedData.listHoursMessage += ' & ' + parsedData['openTime' + 'Period' + '_' + key] + ' - ' + parsedData['closeTime' + 'Period' + '_' + key];
          }
        });

        //we need the numberOfTimeFragments to display the correct message when clients pass empty store hours for the day
        if (openTime.length === 0) {
          parsedData['numberOfTimeFragments'] = new Array(1);
        }

        _.assign(newHoursObj, parsedData);
        locHours[day] = createHoursObj(newHoursObj);
        // Check if Today. If so, apply highlighting and modify
        // some controller level variables in a separate function.
        if (day.toString() === moment().format("E")) {
          if(!hoursCardC.simplified) {
            locHours[day].highlightClass = "bold-700";
          }
          //initialize the open and close time empty arrays
          openTime = [];
          closeTime = [];
          var counter = 0;
          while (counter < locHours[day]['numberOfTimeFragments'].length) {
            var openTimePeriodKey = 'openTimePeriod' + '_' + counter;
            var closeTimePeriodKey = 'closeTimePeriod' + '_' + counter;
            if (locHours[day][openTimePeriodKey] && locHours[day][openTimePeriodKey].length > 0 && locHours[day][closeTimePeriodKey].length > 0) {
              openTime.push(locHours[day][openTimePeriodKey]);
              closeTime.push(locHours[day][closeTimePeriodKey]);
            }
            counter++;
          }

          // when the location does not have hours for the day we
          // assume that it is closed
          if (!(openTime.length > 0 && closeTime.length > 0)) {
            locHours[day].closed = true;
          }
          updateTodaysHours(locHours[day]);
        }
      });

      return locHours;
    }

    /**
     * function generates the display time message for the different
     * periods/times for which the store is open
     * @param {string} openTime open time for the store
     * @param {string} closeTime close time for the store
     */
    function displayOpenAndClosedTime(openTime, closeTime) {
      var displayTime = "";
      if (openTime && closeTime) {
        displayTime = moment(openTime, "hmm").format("LT") + " " + "-" + " " + moment(closeTime, "hmm").format("LT");
      }
      return displayTime;
    }

    /**
     * function is used to get the current time in the store timezone
     * @param {string} actualStoreTimeZone
     */
    function getStoreCurrentTime(actualStoreTimeZone){
      var currentStoreDateTime = null;
      var isInvalidObj = checkObj(actualStoreTimeZone);
      if (!isInvalidObj) {
        currentStoreDateTime = angular.isDefined((moment.tz.zone(actualStoreTimeZone))) ? moment.tz(actualStoreTimeZone).format('YYYY-MM-DD LT') : moment().format('YYYY-MM-DD LT');//
      }
      return currentStoreDateTime;
    }

    /**
     * function is used to get the time part from the converted store timezone
     * @param {moment} storeCurrentDateTime
     */
    function getConvertedStoreHours(storeCurrentDateTime){
      var convertedStoreHours = null;
      var currTimeArr = storeCurrentDateTime.split(" ");
      var isInvalidObj = checkObj(currTimeArr);
      if (!isInvalidObj){
        var isInvalidObj1 = checkObj(currTimeArr[1]);
        if(!isInvalidObj1 && currTimeArr.length > 1){
          if (currTimeArr[2]) {
            convertedStoreHours = currTimeArr[1].trim().concat(" ").concat(currTimeArr[2].trim());
          } else {
            convertedStoreHours = currTimeArr[1].trim().concat(" ");
          }
        }
      }
      return convertedStoreHours;
    }

    function generateSpecialHours(dateStrs) {
      // Split up the dateStrs and generate objects for each one
      var parsedDateStrs = parseDateStrings(dateStrs);
      var dates = _.uniq(_.map(parsedDateStrs, 'day'));
      var spHours = [];

      _.forEach(dates, function(date) {
        // Generate base objects per day
        var newHoursObj = {
          closedLabel: "Closed",
          dayNameShort: moment().isoWeekday(date).format("dd"),
          day: moment(date, "YYYY-MM-DD").format("E")
        };

        var parsedData = _.filter(parsedDateStrs, function(obj) {
          return obj['day'] === date.toString();
        });

        // all the open and close time for the store location in an array
        var openTime = _.map(parsedData, 'openTime');
        var closeTime = _.map(parsedData, 'closeTime');
        parsedData = {};
        _.forEach(openTime, function(value, key) {
          //moment js doesn't recognize 2400 hrs
          if (angular.isDefined(value)) {
            if (closeTime[key] === '2400') {
              closeTime[key] = '0000';
            }
            parsedData['openTime' + 'PeriodDisplayMessage' + '_' + key] = displayOpenAndClosedTime(openTime[key], closeTime[key]);
            parsedData['openTime' + 'Period' + '_' + key] = openTime[key] ? moment(openTime[key],"hmm").format("LT") : "";
            parsedData['closeTime' + 'Period' + '_' + key] = closeTime[key] ? moment(closeTime[key],"hmm").format("LT") : "";
            parsedData['openTime'] = openTime[0];
            parsedData['closeTime'] = closeTime[0];
            parsedData.listHoursMessage = parsedData['openTime' + 'Period' + '_' + key] + " - " + parsedData['closeTime' + 'Period' + '_' + key];
            parsedData['numberOfTimeFragments'] = new Array(_.keys(openTime).length);
          } else {
            //we need the numberOfTimeFragments to display the correct message for the store hours in the directive.html
            parsedData['numberOfTimeFragments'] = new Array(_.keys(openTime).length);
          }
        });

        _.assign(newHoursObj, parsedData);
        var completeHoursObj = createHoursObj(newHoursObj);
        if(completeHoursObj.dayNameShort === moment().format("YYYY-MM-DD")) {
          if(!hoursCardC.simplified) {
            completeHoursObj.highlightClass = "bold-700";
          }

          //initialize the open and close time empty arrays
          openTime = [];
          closeTime = [];
          var counter = 0;
          while (counter < completeHoursObj['numberOfTimeFragments'].length) {
            var openTimePeriodKey = 'openTimePeriod' + '_' + counter;
            var closeTimePeriodKey = 'closeTimePeriod' + '_' + counter;
            if (completeHoursObj[openTimePeriodKey] && completeHoursObj[openTimePeriodKey].length > 0 && completeHoursObj[closeTimePeriodKey].length > 0) {
              openTime.push(completeHoursObj[openTimePeriodKey]);
              closeTime.push(completeHoursObj[closeTimePeriodKey]);
            }
            counter++;
          }

          // Remove all highlighting on regular hours
          _.forEach(hoursCardC.locHours, function (hourObj) {
            hourObj.highlightClass = "";
          });

          updateTodaysHours(completeHoursObj);
        }
        spHours.push(completeHoursObj);
      });

      return spHours;
    }

    /* Things I removed:
     * location.status === 'coming soon' moving to directive.html
     */
    function createHoursObj(hourObj) {
      if (hoursCardC.location.status == "temp closed") {
        return _.assign(hourObj, {"closed": true, "closedLabel": "Temporarily Closed"})
      }
      if (!hourObj.hasOwnProperty("openTime")) {
        return _.assign(hourObj, {"closed": true});
      }
      hourObj.openTime = moment(hourObj.openTime, "HHmm");
      // If close is earlier than openM, then add 1 day to it
      hourObj.closeTime = moment(hourObj.closeTime, "HHmm");
      if (hourObj.closeTime.diff(hourObj.openTime) < 0) {
        hourObj.closeTime.add(1, 'd');
      }

      // Convenience vars so we only need to format or call moment on these once
      hourObj.openDisplayTime = hourObj.openTime.format("LT");
      hourObj.closeDisplayTime = hourObj.closeTime.format("LT");
      // Check if open 24/7 by comparing if diff of open and close time is 0
      hourObj.open24 = hourObj.openTime.diff(hourObj.closeTime) === 0;

      return hourObj;
    }

    // Takes a datestring and checks if any special days are within 7 days of today
    // Return a list of dates + times that are within 7 days of today
    function checkSpecialHours(dates) {
      //For each date with special hours
      var intNearbyDates = _.filter(dates.trim().split(";"), function(el){
        return angular.isDefined(el) && el!=="";
      });

      var nearbyDates = _.map(intNearbyDates, function(specialDay) {
        //Split on the entry
        var dayData = specialDay.split(",");
        //Check today - specialDay < 7, if matched, return this date!
        var specialDateMoment = moment(dayData[0], "YYYY-M-D");
        var today = moment();
        if (specialDateMoment.diff(today, "days") < 7 &&
          specialDateMoment.diff(today, "days") >= 0) {
          return specialDay;
        }
      });
      return _.compact(nearbyDates).join(";");
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('storeLocator')
    .directive('hoursCardBurberry', hoursCardBurberry);

  function hoursCardBurberry() {
    return {
      replace: true,
      scope: {
        location: '=',
        onlyToday: '=',
        customText: '@',
        hideEmptyHours: '=',
        simplified: '=',
        collapsibleOn: '@', // options are: mobile, desktop, all, or blank
        translatedMessages: '='
      },
      templateUrl: 'app/custom/clients/burberry/directives/hoursCardBurberry.directive.html',
      restrict: 'AE',
      controller: HoursController,
      controllerAs: 'hoursCardBurberryC',
      bindToController: true
    };
  }

  function HoursController(_, s, moment) {
    var hoursCardBurberryC = this;
    hoursCardBurberryC.closedNow = true;
    hoursCardBurberryC.open24 = false;
    hoursCardBurberryC.tempClosed = false;
    hoursCardBurberryC.openingHours = '';
    hoursCardBurberryC.toggleCollapsibleHours = toggleCollapsibleHours;

    // if temp closed, set hoursCardBurberryC.tempClosed
    if(hoursCardBurberryC.location.status == "temp closed") {
      hoursCardBurberryC.tempClosed = true;
    }

    // returns the hour fragment for the day depending on the passed key value
    hoursCardBurberryC.getOpenTimePeriodDisplayMessage = function(regularHours, index) {
      var key = '';
      if (angular.isDefined(index)) {
        key = 'openTimePeriodDisplayMessage_' + index;
      } else {
        key = 'openTimePeriodDisplayMessage';
      }
      return regularHours[key];
    };

    /**
     * function returns true if passed value is null, undefined and legth is zero, else false
     * @param {string} storeTimeZone
     */
    function checkObj(storeTimeZone) {
      return ( _.isNull(storeTimeZone) || _.isUndefined(storeTimeZone) || storeTimeZone.length === 0 )
    }

    /**
     * function to check if the store is open or closed and set
     * the corresponding 'closedNow' value on the directive object
     * @param {object} hourObj hour object which has all the details about the timings/days
    */
    function updateTodaysHours(hourObj) {
      if (hourObj.closed) {
        hoursCardBurberryC.closed24 = true;
        return;
      }
      // check for today's special hours. start
      var isTodaySpecial = isTodaySpecialHours();
      //check for today's special hours. end
      //counter to loop through the number of fragments
      var counter = 0;
      while (counter < hourObj.numberOfTimeFragments.length) {
        var openTimePeriodKey = 'openTimePeriod' + '_' + counter;
        var closeTimePeriodKey = 'closeTimePeriod' + '_' + counter;

        if (hourObj[openTimePeriodKey] && hourObj[closeTimePeriodKey]) {
          hoursCardBurberryC[openTimePeriodKey] = moment(hourObj[openTimePeriodKey], "LT").format("LT")
          hoursCardBurberryC[closeTimePeriodKey] = moment(hourObj[closeTimePeriodKey], "hh:mm LT").format("LT");
        }

        if (moment(hourObj[closeTimePeriodKey], "LT").isBefore(moment(hourObj[openTimePeriodKey], "LT")) || moment(hourObj[closeTimePeriodKey], "LT").format('HHmm') === '0000') {
          hourObj[closeTimePeriodKey] = moment(hourObj[closeTimePeriodKey], "LT").add(1, 'days');
        }

        var amIBetweenGroupKey = 'amIBetweenGroup' + '_' + counter;
        var now = moment();
        // store timezone code start
        var storeTimeZone = hoursCardBurberryC.location.store_info.timezone; // store timezone from api
        var storeCurrentDateTime = null;
        var convertedStoreHour = null;
        var isInvalidObj = checkObj(storeTimeZone);
        if (!isInvalidObj) {
          storeCurrentDateTime = getStoreCurrentTime(storeTimeZone);
          convertedStoreHour = moment(getConvertedStoreHours(storeCurrentDateTime), "LT");
        }
        // store timezone code end
        // instead of now object the comparison is made with convertedStoreHour object
        var startTime = moment(hourObj[openTimePeriodKey], "LT");
        var endTime = moment(hourObj[closeTimePeriodKey], "LT");
        if(!isInvalidObj){
          if (endTime.format('HHmm') < (startTime.format('HHmm'))) {
            if (convertedStoreHour.format('HHmm') < endTime.format('HHmm')) {
              startTime = startTime.subtract(1, 'days');
            } else {
              endTime = endTime.add(1, 'days');
            }
          }
          amIBetweenGroupKey = convertedStoreHour.isBetween(startTime, endTime);
        } else {
          if (endTime.format('HHmm') < (startTime.format('HHmm'))) {
            if (now.format('HHmm') < endTime.format('HHmm')) {
              startTime = startTime.subtract(1, 'days');
            } else {
              endTime = endTime.add(1, 'days');
            }
          }
          amIBetweenGroupKey = now.isBetween(startTime, endTime);
        }

        if (amIBetweenGroupKey) {
          hoursCardBurberryC.closeToday = endTime.format("LT");
          if (amIBetweenGroupKey || hourObj.open24) {
            hoursCardBurberryC.closedNow = false;
          } else {
            hoursCardBurberryC.closedNow = true;
          }
        } else if(isTodaySpecial && !amIBetweenGroupKey){
          hoursCardBurberryC.closeToday = endTime.format("LT");
          hoursCardBurberryC.closedNow = true;
        }
        counter++;
      }

      hoursCardBurberryC.openToday = hourObj.openDisplayTime;
      hoursCardBurberryC.open24 = hourObj.open24;
    }

    function isTodaySpecialHours(){
      var isTodaySpecial = false;
      var specialHours = (hoursCardBurberryC.location &&
        hoursCardBurberryC.location.store_info &&
        hoursCardBurberryC.location.store_info.special_hours) ?
        s(hoursCardBurberryC.location.store_info.special_hours).trim(";").value() : null;

      if (specialHours !== null) {
        // Check if any special hours are coming up.
        var validSpHours = checkSpecialHours(specialHours);
        if (!_.isEmpty(validSpHours)) {
          isTodaySpecial=true;
        }
      }
      return isTodaySpecial;
    }

    function parseDateStrings(dateStrs) {
      var intDateStrs = dateStrs.split(";");
      return _.map(intDateStrs, function(dateStr) {
        var info = dateStr.split(",");
        if (angular.isDefined(info[1]) && info[1].toUpperCase() === "CLOSED") {
          // return just the day. This way we can use it to determine if today == which hour obj.
          return {
            day: info[0]
          };
        }
        else {
          // Else add open and close times based on the strings.
          // Will moment parse these to more readable strings later.
          var dateObj = {
            day: info[0],
            openTime: info[1],
            closeTime: info[2],
          }

          // when we have more than 2 hours (open and close), we add more attributes dinamically
          for (var i = 3; i < info.length; i += 2) {
            var period = Math.ceil(i/2)-1;
            dateObj['openTime_'+period] = info[i];
            dateObj['closeTime_'+period] = info[i+1];
          }

          return dateObj;
        }
      });
    }

    function getPropertiesByPrefix(obj, prefix) {
      return Object.keys(obj)
        .filter(function(key) {
          return key.startsWith(prefix);
        })
        .map(function(key) {
          return obj[key];
        });
    }

    /**
     * function generates hours object for each day
     * @param {string} dateStrs open and close times for the week
     * @param {string} closeLabel close label for the location
    */
    function generateHours(dateStrs, closeLabel) {
      // Split up the dateStrs and generate objects for each one
      var parsedDateStrs = parseDateStrings(dateStrs);
      var locHours = {};
      _.range(1, 8).forEach(function(day) {
        // Generate base objects per day
        var newHoursObj = {
          day: day.toString(),
          dayName: moment().isoWeekday(day).format("dddd"),
          dayNameShort: moment().isoWeekday(day).format("dd"),
          dayNameShortNext: moment().isoWeekday(day).add(1, 'd').format("dd"),
          closedLabel: closeLabel
        };
        // filter method gets all the matching objects for a certain day of the week
        var parsedData = _.filter(parsedDateStrs, function(obj) {
          return obj['day'] === day.toString();
        });

        // all the open and close time for the store location in an array

        var openTime, closeTime;

        if (parsedData[0]) {
          openTime = getPropertiesByPrefix(parsedData[0], 'openTime');
          closeTime = getPropertiesByPrefix(parsedData[0], 'closeTime');
        } else {
          openTime = _.map(parsedData, 'openTime');
          closeTime = _.map(parsedData, 'closeTime');
        }

        // adding the values to the object we will need to display all the times
        // and proper messaging for the store hours
        parsedData = {};
        _.forEach(openTime, function(value, key) {
          //moment js doesn't recognize 2400 hrs
          if (closeTime[key] === '2400') {
            closeTime[key] = '0000';
          }
          parsedData['openTime' + 'PeriodDisplayMessage' + '_' + key] = displayOpenAndClosedTime(openTime[key], closeTime[key]);
          parsedData['openTime' + 'Period' + '_' + key] = openTime[key] ? moment(openTime[key],"hmm").format("LT") : "";
          parsedData['closeTime' + 'Period' + '_' + key] = closeTime[key] ? moment(closeTime[key],"hmm").format("LT") : "";
          parsedData['openTime'] = openTime[0];
          parsedData['closeTime'] = closeTime[0];
          parsedData['numberOfTimeFragments'] = new Array(_.keys(openTime).length);
        });

        //we need the numberOfTimeFragments to display the correct message when clients pass empty store hours for the day
        if (openTime.length === 0) {
          parsedData['numberOfTimeFragments'] = new Array(1);
        }

        _.assign(newHoursObj, parsedData);
        locHours[day] = createHoursObj(newHoursObj);
        // Check if Today. If so, apply highlighting and modify
        // some controller level variables in a separate function.
        if (day.toString() === moment().format("E")) {
          locHours[day].highlightClass = "current-day-medium";
          //initialize the open and close time empty arrays
          openTime = [];
          closeTime = [];
          var counter = 0;
          while (counter < locHours[day]['numberOfTimeFragments'].length) {
            var openTimePeriodKey = 'openTimePeriod' + '_' + counter;
            var closeTimePeriodKey = 'closeTimePeriod' + '_' + counter;
            if (locHours[day][openTimePeriodKey] && locHours[day][openTimePeriodKey].length > 0 && locHours[day][closeTimePeriodKey].length > 0) {
              openTime.push(locHours[day][openTimePeriodKey]);
              closeTime.push(locHours[day][closeTimePeriodKey]);
            }
            counter++;
          }

          // when the location does not have hours for the day we
          // assume that it is closed
          if (openTime.length > 0 && closeTime.length > 0) {
            locHours[day].openTimePeriodDisplayMessage = isTheLocationOpen(openTime, closeTime);
          } else {
            locHours[day].closed = true;
          }
          updateTodaysHours(locHours[day]);
        }
      });

      return locHours;
    }

    /**
     * function generates the display time message for the different
     * periods/times for which the store is open
     * @param {string} openTime open time for the store
     * @param {string} closeTime close time for the store
    */
    function displayOpenAndClosedTime(openTime, closeTime) {
      var displayTime = "";
      if (openTime && closeTime) {
        displayTime = moment(openTime, "hmm").format("LT") + " " + "-" + " " + moment(closeTime, "hmm").format("LT");
      }
      return displayTime;
    }

    /**
     * function is used to get the current time in the store timezone
     * @param {string} actualStoreTimeZone
     */
    function getStoreCurrentTime(actualStoreTimeZone){
      var currentStoreDateTime = null;
      var isInvalidObj = checkObj(actualStoreTimeZone);
      if (!isInvalidObj) {
        currentStoreDateTime = angular.isDefined((moment.tz.zone(actualStoreTimeZone))) ? moment.tz(actualStoreTimeZone).format('YYYY-MM-DD LT') : moment().format('YYYY-MM-DD LT');//
      }
      return currentStoreDateTime;
    }

    /**
     * function is used to get the time part from the converted store timezone
     * @param {moment} storeCurrentDateTime
     */
    function getConvertedStoreHours(storeCurrentDateTime){
      var convertedStoreHours = null;
      var currTimeArr = storeCurrentDateTime.split(" ");
      var isInvalidObj = checkObj(currTimeArr);
      if (!isInvalidObj){
        var isInvalidObj1 = checkObj(currTimeArr[1]);
        if(!isInvalidObj1 && currTimeArr.length > 1){
          if (currTimeArr[2]) {
            convertedStoreHours = currTimeArr[1].trim().concat(" ").concat(currTimeArr[2].trim());
          } else {
            convertedStoreHours = currTimeArr[1].trim().concat(" ");
          }
        }
      }
      return convertedStoreHours;
    }

    /**
     * function is used to generate the appropriate messaging for the
     * current day including store open/close times.
     * @param {array} openTime open time for the store for the current day
     * @param {array} closeTime close time for the store for the current day
    */
    function isTheLocationOpen(openTime, closeTime) {
      var amIBetweenFirstGroup = false;
      var amIBetweenSecondGroup = false;
      var amIBetweenThirdGroup = false;
      var storeOpenOrCloseMessage = '';
      var currentTime = moment();
      var displayMessage = '';
      var startTimeFirstGroup = openTime[0] ? moment(openTime[0].trim(), "LT") : "Closed Today";
      var endTimeFirstGroup = closeTime[0] ? moment(closeTime[0].trim(), "LT") : "Closed Today";

      var openTwentyFourHours = false;
      // store timezone code start
      var storeTimeZone = hoursCardBurberryC.location.store_info.timezone; // store timezone from api
      var storeCurrentDateTime = null;
      var convertedLocStoreHour = null;
      var isInvalidObj = checkObj(storeTimeZone);
      if (!isInvalidObj) {
        storeCurrentDateTime = getStoreCurrentTime(storeTimeZone);
        convertedLocStoreHour = moment(getConvertedStoreHours(storeCurrentDateTime), "LT");
      } else {
        convertedLocStoreHour = currentTime;
      }
      // store timezone code end

      if (openTime.length === 2) {
        var startTimeSecondGroup = moment(openTime[1], "LT");
        var endTimeSecondGroup = moment(closeTime[1], "LT");
      } else if (openTime.length === 3) {
        var startTimeThirdGroup = moment(openTime[2], "LT");
        var endTimeThirdGroup = moment(closeTime[2], "LT");
        startTimeSecondGroup = moment(openTime[1], "LT");
        endTimeSecondGroup = moment(closeTime[1], "LT");
      }
      //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
       // check if the close time is on the next date in the A.M.
        if (endTimeFirstGroup.format('HHmm') < (startTimeFirstGroup.format('HHmm')) || moment(closeTime[0], "LT").format('HHmm') === '0000') {
          //open 24 message if the store is open for 24hrs
          if (endTimeFirstGroup.format('HHmm') - (startTimeFirstGroup.format('HHmm')) === 0) {
            openTwentyFourHours = true;
          }
          // Check the user currentime is before shop close time then subtract 1 day from start date
          // as the shop has started in previous day
          // else add 1 day to end date as the shop will be closing on next day
          if (convertedLocStoreHour.format('HHmm') < (endTimeFirstGroup.format('HHmm'))) {
            startTimeFirstGroup = startTimeFirstGroup.subtract(1, 'days');
          } else {
            endTimeFirstGroup = endTimeFirstGroup.add(1, 'days');
          }
        }
      //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

      if (openTime.length === 2 && closeTime.length === 2) {
        // check if the close time is on the next date in the A.M.
        if (endTimeSecondGroup.isBefore(startTimeSecondGroup) || moment(closeTime[1], "LT").format('HHmm') === '0000') {
          endTimeSecondGroup = endTimeFirstGroup.add(1, 'days');
        }
        displayMessage = moment(openTime[0], "LT").format("LT") + ' - '  + moment(closeTime[0], "LT").format("LT") + ', ' +
                         moment(openTime[1], "LT").format("LT") + ' - ' + moment(closeTime[1], "LT").format("LT");
        // instead of currentTime object the comparison is made with convertedLocStoreHour object
        if (!isInvalidObj) {
          amIBetweenFirstGroup = convertedLocStoreHour.isBetween(startTimeFirstGroup, endTimeFirstGroup);
          amIBetweenSecondGroup = convertedLocStoreHour.isBetween(startTimeSecondGroup, endTimeSecondGroup);
        } else {
          // earlier implementation
          amIBetweenFirstGroup = currentTime.isBetween(startTimeFirstGroup, endTimeFirstGroup);
          amIBetweenSecondGroup = currentTime.isBetween(startTimeSecondGroup, endTimeSecondGroup);
        }

        if (amIBetweenFirstGroup) {
          storeOpenOrCloseMessage = moment(openTime[0], "LT").format("LT") + ' - ' + moment(closeTime[0], "LT").format("LT") + ', ' + displayMessage;
        } else if (amIBetweenSecondGroup) {
          storeOpenOrCloseMessage = moment(openTime[0], "LT").format("LT") + ' - ' + moment(closeTime[0], "LT").format("LT") + ', ' + displayMessage;
        } else {
          storeOpenOrCloseMessage = displayMessage;
        }
      } else if (openTime.length === 3 && closeTime.length === 3) {
        // if there are three fragments for store hours
        // check if the second fragment close time is on the next date in the A.M.
        if (endTimeSecondGroup.isBefore(startTimeSecondGroup) || moment(closeTime[1], "LT").format('HHmm') === '0000') {
          endTimeSecondGroup = endTimeFirstGroup.add(1, 'days');
        }
        // check if the third fragment close time is on the next date in the A.M.
        if (endTimeThirdGroup.isBefore(startTimeThirdGroup) || moment(closeTime[2], "LT").format('HHmm') === '0000') {
          endTimeThirdGroup = endTimeSecondGroup.add(1, 'days');
        }
        displayMessage = moment(openTime[0], "LT").format("LT") + ' - ' + moment(closeTime[0], "LT").format("LT") + ', ' +
                         moment(openTime[1], "LT").format("LT") + ' - ' + moment(closeTime[1], "LT").format("LT") + ', ' +
                         moment(openTime[2], "LT").format("LT") + ' - ' + moment(closeTime[2], "LT").format("LT");

        // time fragment flags
        // instead of currentTime object the comparison is made with convertedLocStoreHour object
        if (!isInvalidObj) {
          amIBetweenFirstGroup = convertedLocStoreHour.isBetween(startTimeFirstGroup, endTimeFirstGroup); // currentTime is replaced with convertedStoreHrs
          amIBetweenSecondGroup = convertedLocStoreHour.isBetween(startTimeSecondGroup, endTimeSecondGroup); // currentTime is replaced with convertedStoreHrs
          amIBetweenThirdGroup = convertedLocStoreHour.isBetween(startTimeThirdGroup, endTimeThirdGroup); // currentTime is replaced with convertedStoreHrs
        } else {
          // earlier implementation
          amIBetweenFirstGroup = currentTime.isBetween(startTimeFirstGroup, endTimeFirstGroup); // currentTime is replaced with convertedStoreHrs
          amIBetweenSecondGroup = currentTime.isBetween(startTimeSecondGroup, endTimeSecondGroup); // currentTime is replaced with convertedStoreHrs
          amIBetweenThirdGroup = currentTime.isBetween(startTimeThirdGroup, endTimeThirdGroup); // currentTime is replaced with convertedStoreHrs
        }
        if (amIBetweenFirstGroup) {
          storeOpenOrCloseMessage = moment(openTime[0], "LT").format("LT") + ' - ' + moment(closeTime[0], "LT").format("LT") + ', ' + displayMessage;
        } else if (amIBetweenSecondGroup) {
          storeOpenOrCloseMessage = moment(openTime[0], "LT").format("LT") + ' - ' + moment(closeTime[0], "LT").format("LT") + ', ' + displayMessage;

        } else if (amIBetweenThirdGroup) {
          storeOpenOrCloseMessage = moment(openTime[0], "LT").format("LT") + ' - ' + moment(closeTime[0], "LT").format("LT") + ', ' + displayMessage;
        } else {
          storeOpenOrCloseMessage = displayMessage;
        }
      } else {
        // below line is commented to implement the store timezone changes
        //amIBetweenFirstGroup = currentTime.isBetween(startTimeFirstGroup, endTimeFirstGroup);
        // instead of currentTime object the comparison is made with convertedLocStoreHour object
        //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

        if (!isInvalidObj) {
          /* if (endTimeFirstGroup.format('HHmm') < (startTimeFirstGroup.format('HHmm')) || moment(closeTime[0], "LT").format('HHmm') === '0000') {
            //open 24 message if the store is open for 24hrs
            if (endTimeFirstGroup.format('HHmm') - (startTimeFirstGroup.format('HHmm')) === 0) {
              openTwentyFourHours = true;
            }
            // Check the user currentime is before shop close time then subtract 1 day from start date
            // as the shop has started in previous day
            // else add 1 day to end date as the shop will be closing on next day
            if (convertedLocStoreHour.format('HHmm') < (endTimeFirstGroup.format('HHmm'))) {
              startTimeFirstGroup = startTimeFirstGroup.subtract(1, 'days');
            } else {
              endTimeFirstGroup = endTimeFirstGroup.add(1, 'days');
            }
          } */
            amIBetweenFirstGroup = convertedLocStoreHour.isBetween(startTimeFirstGroup, endTimeFirstGroup);
        } else { // in case if timezone is not populated in timezone variable then it should display as earlier
          amIBetweenFirstGroup = currentTime.isBetween(startTimeFirstGroup, endTimeFirstGroup);
        }
        if (openTwentyFourHours) {
          storeOpenOrCloseMessage = hoursCardBurberryC.translatedMessages['mf.localPage.hours.open24'] || 'Open 24 Hours';
        } else {
          if (amIBetweenFirstGroup) {
            storeOpenOrCloseMessage = moment(openTime[0], "LT").format("LT") + ' - ' + moment(closeTime[0], "LT").format("LT");
          } else {
            storeOpenOrCloseMessage = moment(openTime[0], "LT").format("LT") + ' - ' + moment(closeTime[0], "LT").format("LT");
          }
        }
      }
      //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

      return storeOpenOrCloseMessage;
    }

    function generateSpecialHours(dateStrs) {
      // Split up the dateStrs and generate objects for each one
      var parsedDateStrs = parseDateStrings(dateStrs);
      var dates = _.uniq(_.map(parsedDateStrs, 'day'));
      var spHours = [];

      _.forEach(dates, function(date) {
        // Generate base objects per day
        var newHoursObj = {
          closedLabel: hoursCardBurberryC.translatedMessages['mf.localPage.hours.closed'] || "Closed",
          dayNameShort: date,
          dayOfTheWeek: moment(date, "YYYY-MM-DD").format("E")
        };

        var parsedData = _.filter(parsedDateStrs, function(obj) {
          return obj['day'] === date.toString();
        });

        // all the open and close time for the store location in an array
        var openTime = _.map(parsedData, 'openTime');
        var closeTime = _.map(parsedData, 'closeTime');
        parsedData = {};
        _.forEach(openTime, function(value, key) {
          //moment js doesn't recognize 2400 hrs
          if (angular.isDefined(value)) {
            if (closeTime[key] === '2400') {
              closeTime[key] = '0000';
            }
            parsedData['openTime' + 'PeriodDisplayMessage' + '_' + key] = displayOpenAndClosedTime(openTime[key], closeTime[key]);
            parsedData['openTime' + 'Period' + '_' + key] = openTime[key] ? moment(openTime[key],"hmm").format("LT") : "";
            parsedData['closeTime' + 'Period' + '_' + key] = closeTime[key] ? moment(closeTime[key],"hmm").format("LT") : "";
            parsedData['openTime'] = openTime[0];
            parsedData['closeTime'] = closeTime[0];
            parsedData['numberOfTimeFragments'] = new Array(_.keys(openTime).length);
          } else {
            //we need the numberOfTimeFragments to display the correct message for the store hours in the directive.html
            parsedData['numberOfTimeFragments'] = new Array(_.keys(openTime).length);
          }
        });

        _.assign(newHoursObj, parsedData);
        var completeHoursObj = createHoursObj(newHoursObj);
        if(completeHoursObj.dayNameShort === moment().format("YYYY-MM-DD")) {
          completeHoursObj.highlightClass = "current-day-medium";

          //initialize the open and close time empty arrays
          openTime = [];
          closeTime = [];
          var counter = 0;
          while (counter < completeHoursObj['numberOfTimeFragments'].length) {
            var openTimePeriodKey = 'openTimePeriod' + '_' + counter;
            var closeTimePeriodKey = 'closeTimePeriod' + '_' + counter;
            if (completeHoursObj[openTimePeriodKey] && completeHoursObj[openTimePeriodKey].length > 0 && completeHoursObj[closeTimePeriodKey].length > 0) {
              openTime.push(completeHoursObj[openTimePeriodKey]);
              closeTime.push(completeHoursObj[closeTimePeriodKey]);
            }
            counter++;
          }

          // Remove all highlighting on regular hours
          _.forEach(hoursCardBurberryC.locHours, function (hourObj) {
            hourObj.highlightClass = "";
          });

          if (openTime.length > 0) {
            completeHoursObj.openTimePeriodDisplayMessage = isTheLocationOpen(openTime, closeTime);
          }
          updateTodaysHours(completeHoursObj);
        }
        spHours.push(completeHoursObj);
      });

      return spHours;
    }

    /* Things I removed:
     * location.status === 'coming soon' moving to directive.html
     */
    function createHoursObj(hourObj) {
      if (hoursCardBurberryC.location.status == "temp closed") {
        var tempClosed = hoursCardBurberryC.translatedMessages['mf.location.tempClosed.status'] || "Temporarily Closed";
        return _.assign(hourObj, {"closed": true, "closedLabel": tempClosed})
      }
      if (!hourObj.hasOwnProperty("openTime")) {
        return _.assign(hourObj, {"closed": true});
      }
      hourObj.openTime = moment(hourObj.openTime, "HHmm");
      // If close is earlier than openM, then add 1 day to it
      hourObj.closeTime = moment(hourObj.closeTime, "HHmm");
      if (hourObj.closeTime.diff(hourObj.openTime) < 0) {
        hourObj.closeTime.add(1, 'd');
      }

      // Convenience vars so we only need to format or call moment on these once
      hourObj.openDisplayTime = hourObj.openTime.format("LT");
      hourObj.closeDisplayTime = hourObj.closeTime.format("LT");
      // Check if open 24/7 by comparing if diff of open and close time is 0
      hourObj.open24 = hourObj.openTime.diff(hourObj.closeTime) === 0;

      // Augment openingHours on controller
      hoursCardBurberryC.openingHours = hoursCardBurberryC.openingHours +
        hourObj.dayNameShort +
        ' ' +
        hourObj.openDisplayTime +
        ' - ' +
        hourObj.closeDisplayTime +
        ' ';

      return hourObj;
    }

    // Takes a datestring and checks if any special days are within 7 days of today
    // Return a list of dates + times that are within 7 days of today
    function checkSpecialHours(dates) {
      //For each date with special hours
      var intNearbyDates = _.filter(dates.trim().split(";"), function(el){
        return angular.isDefined(el) && el!=="";
      });

      var nearbyDates = _.map(intNearbyDates, function(specialDay) {
        //Split on the entry
        var dayData = specialDay.split(",");
        //Check today - specialDay < 7, if matched, return this date!
        var specialDateMoment = moment(dayData[0], "YYYY-M-D");
        var today = moment();
        if (specialDateMoment.diff(today, "days") < 7 &&
            specialDateMoment.diff(today, "days") >= 0) {
          return specialDay;
        }
      });
      return _.compact(nearbyDates).join(";");
    }
    if(hoursCardBurberryC.location.status == "coming soon"){
      hoursCardBurberryC.comingSoon = hoursCardBurberryC.translatedMessages['mf.common.comingSoon'] || "Coming Soon";

    }
    else if (hoursCardBurberryC.location.status == "temp closed"){
      hoursCardBurberryC.comingSoon = hoursCardBurberryC.translatedMessages['mf.location.tempClosed.status'] || "Temporarily Closed";
    }

    // If there's custom text, set it.
    if (hoursCardBurberryC.customText) {
      var str = hoursCardBurberryC.customText;
      str = str.replace(/\[(.*?[^.])\]/g, function (s, key) {
        return hoursCardBurberryC[key];
      });
      hoursCardBurberryC.customTextShow = str;
    }

    var checkHoursFormat = /^[0-9;,closedCLOSED]+$/;

    var sh = hoursCardBurberryC.location && hoursCardBurberryC.location.store_info ? s(hoursCardBurberryC.location.store_info.store_hours).trim(";").value() : null;
    // Replace anything that isn't number, ';', ',', or the letters c, l, o, s, e, d in their lower and capital forms
    sh = sh.replace(/[^0-9;,closedCLOSED]/g,'');
    sh = sh.trim();

    // Check if there are store hours listed. If not, show all days as "Closed" unless config indicates they should be hidden
    if (hoursCardBurberryC.location.store_info.store_hours == '' && (!hoursCardBurberryC.hideEmptyHours || hoursCardBurberryC.hideEmptyHours != true)) {
      var closed = hoursCardBurberryC.translatedMessages['mf.localPage.hours.closed'] || "Closed";
      hoursCardBurberryC.locHours = generateHours(sh, closed);
    }

    // Check if store is coming soon, if so, init all days to coming soon
    if (hoursCardBurberryC.location.status == "coming soon") {
      var commingSoon = hoursCardBurberryC.translatedMessages['mf.common.comingSoon'] || "Coming Soon";
      hoursCardBurberryC.locHours = generateHours(sh, commingSoon);
    }

    // Check if time returned is valid
    if (sh && checkHoursFormat.test(sh)) {
      var closed = hoursCardBurberryC.translatedMessages['mf.localPage.hours.closed'] || "Closed";
      hoursCardBurberryC.locHours = generateHours(sh, closed);
    }

    // Check for special hours
    var specialHours = (hoursCardBurberryC.location &&
      hoursCardBurberryC.location.store_info &&
      hoursCardBurberryC.location.store_info.special_hours) ?
      s(hoursCardBurberryC.location.store_info.special_hours).trim(";").value() : null;
      //specialHours = '2018-12-24,0000,1800;2018-12-25,CLOSED;2018-12-31,0000,2200;2019-01-01,0600,0000;2019-05-15,CLOSED';

    if (specialHours !== null) {
      // Check if any special hours are coming up.
      var validSpHours = checkSpecialHours(specialHours);
      if (!_.isEmpty(validSpHours)) {
        // For each special day, format it for display like normal hours.
        hoursCardBurberryC.specialHours = generateSpecialHours(validSpHours);
      }
    }
    hoursCardBurberryC.hoursNote = _.find(hoursCardBurberryC.location.custom_fields, {'name': 'hours_note'});
    hoursCardBurberryC.hideClosedToday = _.find(hoursCardBurberryC.location.custom_fields, {'name': 'hide_closed_today'});
    if (hoursCardBurberryC.hideClosedToday && hoursCardBurberryC.closed24) {
      hoursCardBurberryC.locHours = undefined;
      hoursCardBurberryC.specialHours = undefined;
    }


    function toggleCollapsibleHours() {
      var collapsibleHours = document.getElementsByClassName('collapsible')[0];
      var collapseIcon = document.getElementsByClassName('collapse-icon')[0].getElementsByTagName('i')[0];
      if(collapsibleHours.classList.value.indexOf('show') === -1) {
        collapsibleHours.classList.add('show');
        collapseIcon.classList.remove('fa-chevron-down');
        collapseIcon.classList.add('fa-chevron-up');
      } else {
        collapsibleHours.classList.remove('show');
        collapseIcon.classList.add('fa-chevron-down');
        collapseIcon.classList.remove('fa-chevron-up');
      }
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('storeLocator')
    .directive('aboutCardBurberry', aboutCardBurberry);

  function aboutCardBurberry() {
    return {
      replace: true,
      scope: {
        aboutText: '@',
        windowWidth: '=',
        translatedMessages: '='
      },
      templateUrl: 'app/custom/clients/burberry/directives/aboutCardBurberry.directive.html',
      restrict: 'AE',
      bindToController: true,
      controllerAs: 'aboutCardBurberryC',
      controller: function ($sce) {
        var vm = this;

        var limit = vm.windowWidth < 768 ? 129 : 206;

        if (vm.aboutText) {
          var aboutTextSplit = [vm.aboutText.slice(0, limit), vm.aboutText.slice(limit)];
          if (aboutTextSplit.length === 1) {
            vm.showReadBtn = false;
            vm.aboutTextHtml = vm.aboutText;
          } else {
            vm.showReadBtn = true;
            vm.aboutTextHtml = $sce.trustAsHtml(aboutTextSplit.join('<span id="dots">...</span><span id="more">') + '</span>');
          }
        }

        vm.readMore = function() {
          var dots = document.getElementById("dots");
          var moreText = document.getElementById("more");
          var btnText = document.getElementById("read-btn");

          if (dots.style.display === "none") {
            dots.style.display = "inline";
            btnText.innerHTML = vm.translatedMessages['mf.localPage.aboutCard.readMore'] || 'Read more';
            moreText.style.display = "none";
          } else {
            dots.style.display = "none";
            btnText.innerHTML = vm.translatedMessages['mf.localPage.aboutCard.readLess'] || 'Read less';
            moreText.style.display = "inline";
          }
        }
      }
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('storeLocator')
    .directive('searchMulti', searchMulti);

  function searchMulti() {
    return {
      templateUrl: 'app/storeLocator/directives/multilingual/searchMulti.directive.html',
      restrict: 'E',
      scope: {
        isGoogleMapsApiLoaded: '='
      },
      controller: searchMultiController,
      controllerAs: 'searchMultiCtrl',
      bindToController: {
        locatorStates: '=',
        translatedMessages: '=',
        mapObj: '='
      }
    };

    function searchMultiController(_, mapHelper, $location, markersUtils, filtersService, $analytics, storeLocatorDictionary, CUSTOM_DICTIONARY) {
      var $ctrl = this;
      filtersService.setFilters();

      $ctrl.placeholder = $ctrl.translatedMessages['mf.storeLocator.searchInput.placeholder'] || CUSTOM_DICTIONARY && CUSTOM_DICTIONARY.placeholder;
      $ctrl.showFilters = false;
      $ctrl.availableFilters = filtersService.getFilters();
      $ctrl.availableFilterTypes = filtersService.getFilterTypes();
      $ctrl.addFilter = addFilter;
      $ctrl.isGoogleMapsEnabled = mapHelper.isGoogleMapsEnabled();
      $ctrl.places =[];
      $ctrl.nearMeButtonTooltip = $ctrl.translatedMessages['mf.storeLocator.nearMeButton.tooltip'] || "Find Locations Near You";
      $ctrl.searchInputTooltip = $ctrl.translatedMessages['mf.storeLocator.searchInput.tooltip'] || "search";
      $ctrl.searchButtonTooltip = $ctrl.translatedMessages['mf.storeLocator.searchButton.tooltip'] || "search button";
      $ctrl.searchButtonLabel = $ctrl.translatedMessages['mf.storeLocator.searchButton.label'] || "Search";
      $ctrl.filtersButtonTooltip = $ctrl.translatedMessages['mf.storeLocator.filtersButton.tooltip'] || "Toggle Filters Menu";
      $ctrl.filtersButtonLabel = $ctrl.translatedMessages['mf.storeLocator.filtersButton.label'] || "filter button";
      $ctrl.filtersButtonText = $ctrl.translatedMessages['mf.storeLocator.filtersButton.text'] || "Filter";

      var selectedFilters = []

      function addFilter(filter) {
        $ctrl.locatorStates.message = 'Filtering locations...';
        filtersService.addFilter(filter);
        $ctrl.locatorStates.selectedFilters = filtersService.getSelectedFilters();
        $ctrl.performSearch(searchField); // Added call to performSearch function to kickoff search
        mapHelper.loadList($ctrl.locatorStates);
      }

      $ctrl.showFiltersForActiveTab = function () {
        return ($ctrl.locatorStates.activeTab && $ctrl.locatorStates.activeTab.hasFilters) || !$ctrl.locatorStates.activeTab;
      }

      $ctrl.hasFilters = function () {
        return filtersService.hasFilters();
      }

      $ctrl.userLatLngSearch = function () {
        $ctrl.locatorStates.reloadMap = true;
        $ctrl.locatorStates.zoom = storeLocatorDictionary.zoomLevels.nearMe;
        $ctrl.locatorStates.searchInput = "";
        $ctrl.locatorStates.areaSearched = false;
        mapHelper.setGeoStates($ctrl.locatorStates);

        if (!_.isUndefined($ctrl.locatorStates.position)) {
          if ($ctrl.isGoogleMapsEnabled) {
            mapHelper.setCoordinatesAndPlace($ctrl.locatorStates.position, $ctrl.locatorStates, $ctrl.mapObj);
          }
          else {
            mapHelper.setCoordinates($ctrl.locatorStates.position, $ctrl.locatorStates, $ctrl.mapObj);
          }
        } else {
          navigator.geolocation.getCurrentPosition(successFunction, mapHelper.geoLocationError($ctrl.locatorStates))
        }
      };

      var successFunction = function (position) {
        if ($ctrl.isGoogleMapsEnabled) {
          mapHelper.setCoordinatesAndPlace(position, $ctrl.locatorStates, $ctrl.mapObj.map);
        }
        else {
          mapHelper.setCoordinates(position, $ctrl.locatorStates, $ctrl.mapObj.map);
        }
        locatorStates.reloadMap = false;
      };

      $ctrl.performSearch = function (searchField) {
        if (searchField.name) {
          $ctrl.locatorStates.matchingText = null;

          // Changes input field from "Search Results" to current location name
          window.setTimeout(function() {
            var locationName = $ctrl.locatorStates.current
            if (searchField.name === "") {searchField.name = locationName}
            $ctrl.locatorStates.searchInput = searchField.name
          }, 1000)

          $analytics.eventTrack("Searched: " + $ctrl.locatorStates.searchInput, { category: "Store Locator", label: "Store Locator" });

          $ctrl.locatorStates.zoom = searchField.type ? storeLocatorDictionary.zoomLevels[searchField.type] : storeLocatorDictionary.zoomLevels.fallback;
          $ctrl.locatorStates.areaSearched = false;

          var data = searchField.feature;
          $ctrl.locatorStates.current = $ctrl.locatorStates.searchInput;
          if (data && !_.isEmpty(data)) {
            var currentLocation = data;
            $ctrl.locatorStates.searchInputData = data;
            if ($ctrl.isGoogleMapsEnabled) {
              var lat = $ctrl.locatorStates.position.coords ? $ctrl.locatorStates.position.coords.latitude : $ctrl.locatorStates.mapCenter.latitude;
              var lon = $ctrl.locatorStates.position.coords ? $ctrl.locatorStates.position.coords.longitude : $ctrl.locatorStates.mapCenter.longitude;

              markersUtils.getLatLogFromAddress($ctrl.locatorStates.searchInput, lat, lon, $ctrl.mapObj.getBounds()).then(function (data) {
                $ctrl.updatePlace(data);
              })
            }
            else {
              mapHelper.setSearchCoordinates(currentLocation.center[1], currentLocation.center[0], $ctrl.locatorStates, $ctrl.mapObj);
            }
          } else {
            _.each($ctrl.locatorStates.locationMarkersArray, function (mfMarker) {
              $ctrl.mapObj.removeMarker(mfMarker);
            });
            $ctrl.locatorStates.locations = [];
          }
        }
      };

      $ctrl.autoCompleteLocations = function (viewValue) {
        var lat = $ctrl.locatorStates.position.coords ? $ctrl.locatorStates.position.coords.latitude : $ctrl.locatorStates.mapCenter.latitude;
        var lon = $ctrl.locatorStates.position.coords ? $ctrl.locatorStates.position.coords.longitude : $ctrl.locatorStates.mapCenter.longitude;

        if (typeof viewValue === 'string' && viewValue.trim() === '') {
          return [];
        }
        $ctrl.places = markersUtils.getAutoCompleteLocations(viewValue, lat, lon)
          .then(function (data) {
            return _.map(data.features, function (feature) {
              return { name: feature.place_name, type: feature.place_type[0], feature: feature };
            });
          }, function (error) {
            if(error.status == 404){
              $location.path('/404')
            }
            else if(error.status == 400){
              $location.path('/400')
            }
            else if(error.status == 500){
              $location.path('/500')
            }
            else {
              locatorStates.errors = 'An error occurred. Please try again.';
            }
            document.querySelectorAll('.mf-loader').forEach(function (value) { value.classList.add('ng-hide') })
          });
        $ctrl.places.then(function (thing) {
          $ctrl.places = thing;
        });
        return $ctrl.places;
      };

      $ctrl.autoCompleteSelect = function (searchField) {
        $ctrl.performSearch(searchField);
      };

      $ctrl.googlePlaceChanged = function (place) {
        // The autocomplete box triggers this callback even when the user hits the 'enter' key without selecting an option
        // from the autocomplete list. In that case, the autocomplete box returns a object without a 'geometry' property.
        // We'll attempt to geocode the search string if 'geometry' is undefined.
        if (place.geometry) {
          $ctrl.locatorStates.searchInputData = undefined;
          $ctrl.locatorStates.searchInput = place.formatted_address;
          $ctrl.updatePlace(place);
        }
        else {
          $ctrl.completeLocationAndSearch(place.name)
        }
      };

      $ctrl.updatePlace = function (place) {
        $ctrl.locatorStates.zoom = storeLocatorDictionary.zoomLevels[place.types[0]] ?
          storeLocatorDictionary.zoomLevels[place.types[0]] :
          storeLocatorDictionary.zoomLevels.fallback;
        mapHelper.setPlace(place, $ctrl.locatorStates, $ctrl.mapObj);
      };

      $ctrl.hitSearchBtn = function () {
        if($ctrl.locatorStates.searchInput){
          if($ctrl.isGoogleMapsEnabled){
            $ctrl.completeLocationAndSearch($ctrl.locatorStates.searchInput)
          }
          else if($ctrl.places[0]){
            $ctrl.locatorStates.searchInput = $ctrl.places[0];
          }
          $ctrl.performSearch($ctrl.locatorStates.searchInput);
        }
      };

      $ctrl.completeLocationAndSearch = function (name) {
        $ctrl.autoCompleteLocations(name).then(function () {
          if($ctrl.places.length === 0){
            $ctrl.places[0]= {
              name: $ctrl.locatorStates.searchInput,
              type: $ctrl.places[0].type ? $ctrl.places[0].type : '',
              feature:{}
            }
          }
          $ctrl.performSearch($ctrl.places[0])
        })
      }
    }
  }

})();


(function() {
  'use strict';

  angular
    .module('storeLocator')
    .directive('resultsMulti', resultsMulti);

  function resultsMulti () {
    return {
      templateUrl: 'app/storeLocator/directives/multilingual/resultsMulti.directive.html',
      restrict: 'E',
      scope: {},
      controller: resultsMultiController,
      controllerAs: 'resultsMultiCtrl',
      bindToController: {
        locatorStates: '=',
        mapObj: '=',
        translatedMessages: '='
      }
    };

    function resultsMultiController(storeLocatorDictionary, customFieldFactory, STORE_LOCATOR_FILTERS, storeLocatorCache, _, HAS_MULTILINGUAL, ORDER_RESULTS_LIST, RegionService) {
        var $ctrl = this;

        $ctrl.showMessage = true;
        $ctrl.orderResultsList = ORDER_RESULTS_LIST;
        $ctrl.groupedData = {};
        $ctrl.getLocations = getLocations;

        $ctrl.GetMessage = function()
        {
            var message = '';
            if ($ctrl.locatorStates.selectedFilters.length > 0) {
                if ($ctrl.locatorStates.locations.length > 0)
                {
                    message = $ctrl.translatedMessages['mf.storeLocator.results.hasResults.withFilters'].replaceAll('[', '{').replaceAll(']', '}') || storeLocatorDictionary.messages.resultsWithFilters;
                }
                else {
                  message = $ctrl.translatedMessages['mf.storeLocator.results.noResults.withFilters'].replaceAll('[', '{').replaceAll(']', '}') || storeLocatorDictionary.messages.noResultsWithFilters;
                }
                message = message.replace('{filters}', getTranslatedFilter());
            }
            else {
                if ($ctrl.locatorStates.locations.length > 0) {
                  if ($ctrl.locatorStates.matchingText) {
                    message = $ctrl.translatedMessages['mf.storeLocator.results.hasResults.matchingText'].replaceAll('[', '{').replaceAll(']', '}') || storeLocatorDictionary.messages.noResultsDidYouMean;
                    message = message.replace('{locationWanted}', $ctrl.locatorStates.matchingText);
                    message = message.replace('{locationResult}', customFieldFactory.getValueByName($ctrl.locatorStates.locations[0].entire_location.custom_fields,'llp_name') || $ctrl.locatorStates.locations[0].name);
                  } else {
                    message = $ctrl.translatedMessages['mf.storeLocator.hasResults'].replaceAll('[', '{').replaceAll(']', '}') || storeLocatorDictionary.messages.results;
                  }
                }
                else {
                    message = $ctrl.translatedMessages['mf.storeLocator.noResults'].replaceAll('[', '{').replaceAll(']', '}') || storeLocatorDictionary.messages.noResults;
                }
            }
            var currentLocationText = $ctrl.locatorStates.current === 'Current Location' ? $ctrl.translatedMessages['mf.storeLocator.results.currentLocation'] : $ctrl.locatorStates.current;
            $ctrl.locatorStates.current.name == undefined ? message = message.replace('{location}', currentLocationText) : message = message.replace('{location}', $ctrl.locatorStates.current.name);

            $ctrl.showMessage = message !== '';

            return message;
        }


      function getTranslatedFilter() {
        if (HAS_MULTILINGUAL) {
          var storeLocatorFilters = typeof STORE_LOCATOR_FILTERS === "object" ? STORE_LOCATOR_FILTERS : JSON.parse(STORE_LOCATOR_FILTERS);
          var filters = storeLocatorFilters[storeLocatorCache.get('language')]
          var selectedFilters = $ctrl.locatorStates.selectedFilters.split(',')
          var translated = []
          _.forEach(selectedFilters, function (selectedFilter) {
            var item = _.find(filters, { value: selectedFilter });
            translated.push(item.label)
          });
          return translated.join(', ')
        } else {
          return $ctrl.locatorStates.selectedFilters.replace(',', ', ')
        }
      }

      function getLocations(locations){
        if(ORDER_RESULTS_LIST){
          orderResultsList(locations);
        }
      }

      function orderResultsList(locations){

        var regionSet = "NONE";
        var regionQuantity = 0;
        for (var i = 0; i < locations.length; i++) {
          if(!!locations[i].region && locations[i].region !== regionSet){
            regionSet = locations[i].region;
            regionQuantity++;
          }
        }

        var orderedResultsList = getResultsListByAttribute(locations, regionQuantity === 1 ? 'locality' : 'region');

        $ctrl.groupedData = {};
          orderedResultsList.forEach(function (item) {
          if (!$ctrl.groupedData[item.resultTitle]) {
            $ctrl.groupedData[item.resultTitle] = [];
          }
          $ctrl.groupedData[item.resultTitle].push(item);
        });

      }

      function getResultsListByAttribute(locations, orderBy) {
        return locations.filter(function(location) {
            return !!location[orderBy];
        }).sort(function(a, b) {
          const elementA = a[orderBy].toUpperCase();
          const elementB = b[orderBy].toUpperCase();

          if (elementA < elementB) {
            return -1;
          }
          if (elementA > elementB) {
            return 1;
          }
      
          return 0;
        }).map(function(location) {
            if (orderBy === 'locality') {
                location.resultTitle = location[orderBy];
            } else {
                location.resultTitle = RegionService.lookupRegionFromCountry(location.country, location.region);
            }
            return location;
        });
      }

    }
  }

})();

(function () {
  'use strict';

  angular
    .module('storeLocator')
    .directive('socialCardMulti', socialCardMulti);

  function socialCardMulti() {

    return {
      replace: true,
      scope: {
        location: '='
      },
      templateUrl: 'app/localLanding/cards/multilingual/socialCardMulti.directive.html',
      restrict: 'AE',
      bindToController: { translatedMessages: '=' },
      controller: function ($scope, INSTAGRAM_HANDLE) {
          var socialCardMultiC = this;
          var hasTwitterProvider = _.filter($scope.location.store_info.social_providers, function (p) { return p._type == 'Twitter'; }).length > 0;
          //multilingual variables
          socialCardMultiC.onInstagramText = (socialCardMultiC.translatedMessages['mf.localPage.social.instagram.localTitle'] || 'on Instagram').replace('[name]',$scope.location.store_info.name);
          socialCardMultiC.onTwitterText = (socialCardMultiC.translatedMessages['mf.localPage.social.twitter.localTitle'] || 'on Twitter').replace('[name]',$scope.location.store_info.name);
          socialCardMultiC.titleByProvider = (socialCardMultiC.translatedMessages['mf.localPage.social.provider'] || '[name] on [provider]');

          socialCardMultiC.providers = _.filter($scope.location.store_info.social_providers, function (p) {
              return (p.master == true && p._type !== 'Instagram');
          });

          // add title in providers array
          socialCardMultiC.providers.forEach(
            function (item, index) {
              item.title = socialCardMultiC.titleByProvider.replace('[name]',$scope.location.store_info.name).replace('[provider]',item._type);
            }
          );

          // In case the providers array do not return Twitter, but the handle exists, we will push to the providers array
          if (!hasTwitterProvider && $scope.location.twitter_handle) {
            socialCardMultiC.providers.push({ _type: "Twitter"})
          }

          socialCardMultiC.instagramURL='https://www.instagram.com/' + INSTAGRAM_HANDLE;
          socialCardMultiC.instagramHandle=INSTAGRAM_HANDLE;
      },
      controllerAs: 'socialCardMultiC'
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('storeLocator')
    .directive('singleImageCardMulti', singleImageCardMulti);

  function singleImageCardMulti() {

    return {
      replace: true,
      scope: {
        location: '=',
        singleImageNumber: '=',
        singleImageTitle: '@',
        singleImageTarget: '@'
      },
      templateUrl: 'app/localLanding/cards/multilingual/singleImageCardMulti.directive.html',
      restrict: 'AE',
      bindToController: { translatedMessages: '=' },
      controller: function ($scope, customFieldFactory, storeLocatorCache) {
          var vm = this;
          var language = storeLocatorCache.get('storeFindersMessages').lang;
          vm.hasData = customFieldFactory.getTranslatedValueByName($scope.location.custom_fields,'single_image' + $scope.singleImageNumber, language);
          if (vm.hasData) {
              vm.src = customFieldFactory.getTranslatedValueByName($scope.location.custom_fields,'single_image' + $scope.singleImageNumber, language);
              vm.name = _.find($scope.location.custom_fields,{ 'name': 'single_image' + $scope.singleImageNumber }).name;
            
              //set naming for title and alt attributes
              var title = customFieldFactory.getTranslatedValueByName($scope.location.custom_fields,'single_image_title' + $scope.singleImageNumber, language);
              if (!_.isUndefined(title)) {
                  vm.title = title;
              }else{
                  vm.title = $scope.singleImageTitle || 'Promo image';
              }
              vm.findLink = customFieldFactory.getTranslatedValueByName($scope.location.custom_fields,'single_url' + $scope.singleImageNumber, language);
              if (!_.isUndefined(vm.findLink)) {
                  vm.link = vm.findLink;
              }
          }

          if(_.isUndefined($scope.singleImageTarget)) {
            vm.singleImageTarget = "_blank";
          }
      },
      controllerAs: 'singleImageCardMultiC'
    };
  }

  
})();

(function () {
  'use strict';

  angular
    .module('storeLocator')
    .directive('partnerReviewsCardMulti', partnerReviewsCardMulti);

  function partnerReviewsCardMulti(_, $filter, customFieldFactory, storeLocatorCache) {
    return {
      replace: true,
      scope: {
        'location': '=',
        'partnertype': '@',
        'translatedMessages': '='
        //@param partnertype can be network name (html/css styling currently only supports 'Yelp', 'Facebook', 'Foursquare, 'Google'. these are not case sensitive)
        //@param partnertype can also be or 'bestrating'/'best rating', 'mostreviews'/'most reviews'
        //@param supports custom fields review_partner_type (which works when html attribute is 'custom') and 'review_rating_minimum'
      },
      templateUrl: 'app/localLanding/cards/multilingual/partnerReviewsCardMulti.directive.html',
      restrict: 'AE',
      controllerAs: 'partnerReviewsCardMultiC',
      bindToController: true,
      controller: function () {
        var vm = this;
        var language = storeLocatorCache.get('storeFindersMessages').lang;

        function roundUpNearestHalf(value) {
          var remainder = value % 0.5;
          if (remainder > 0 && remainder >= 0.25)
            value = value - remainder + 0.5;
          else
            value = value - remainder;
          return value;
        }

        function getFoursquareColor(rating) {
          if (rating >= 9.0) {
            return '#00B551';
          }
          else if (rating >= 8.0) {
            return '#73CF42';
          }
          else if (rating >= 7.0) {
            return '#C5DE35';
          }
          else if (rating >= 6.0) {
            return '#FFC800';
          }
          else if (rating >= 5.0) {
            return '#FF9600';
          }
          else if (rating >= 4.0) {
            return '#FF6701';
          }
          else {
            return '#E6092C';
          }
        }

        function findBestRatedPartner(partners) {
          var max = 0,
            maxPartner,
            i;
          for (i = 0; i < partners.length; i++) {
            if ('rating' in partners[i] && partners[i].master) {
              if (partners[i]._type === 'Foursquare') {
                if (partners[i].rating / 2.0 > max) {
                  max = partners[i].rating / 2.0;
                  maxPartner = partners[i];
                }
              }
              else {
                if (partners[i].rating > max) {
                  max = partners[i].rating;
                  maxPartner = partners[i];
                }
              }
            }
          }
          return maxPartner;
        }

        function findMostReviewedPartner(partners) {
          var max = 0,
            maxPartner,
            i;
          for (i = 0; i < partners.length; i++) {
            if ('total_reviews' in partners[i] && partners[i].master) {
              if (partners[i].total_reviews > max) {
                max = partners[i].total_reviews;
                maxPartner = partners[i];
              }
            }
          }
          return maxPartner;
        }

        if (vm.partnertype === 'custom') {
          var customPartnerType = customFieldFactory.getTranslatedValueByName(vm.location.custom_fields, "review_partner_type", language);
          if (customPartnerType != null) {
            vm.partnertype = customPartnerType;
          }
          else {
            vm.partnertype = 'bestrating';
          }
        }
        if (vm.partnertype === 'bestrating' || vm.partnertype === 'best rating') {
          var partner = findBestRatedPartner(vm.location.store_info.providers);
        }
        else if (vm.partnertype === 'mostreviews' || vm.partnertype === 'most reviews') {
          var partner = findMostReviewedPartner(vm.location.store_info.providers);
        }
        else {
          var partner = _.find(vm.location.store_info.providers, function (item) {
            return item._type === vm.partnertype.charAt(0).toUpperCase() + vm.partnertype.substr(1).toLowerCase() && item.master;
          });
        }

        vm.pData = false;
        vm.title = vm.location.store_info.name ? vm.location.store_info.name : 'Find us';
        if (partner) {
          vm.partnerName = partner._type;
          vm.minRating = 0.75;
          var minRating = customFieldFactory.getTranslatedValueByName(vm.location.custom_fields, "review_rating_minimum", language);
          if (minRating != null) {
            vm.minRating = minRating;
          }
          vm.pData = {};
          vm.pData.itemReviewed = vm.location.store_info.name + ' ' + vm.location.store_info.address;
          vm.pData.url = partner.url;
          vm.pData.rating = parseFloat(partner.rating).toFixed(1);
          vm.pData.ratingFraction = vm.partnerName !== 'Foursquare' ? partner.rating / 5.0 : partner.rating / 10.0;
          vm.pData.reviewCount = partner.total_reviews;
          vm.pData.roundedRating = roundUpNearestHalf(vm.pData.rating, 0.5);
          vm.pData.roundedRatingAsPercentage = (vm.pData.roundedRating / 5.0) * 100 + '%';
          if (vm.partnerName === 'Foursquare') {
            vm.ratingColor = getFoursquareColor(vm.pData.rating);
          }
          if (vm.partnerName === 'Yelp') {
            vm.pData.yelpRoundedRatingString = vm.pData.roundedRating.toString().replace('.', '_');
            vm.pData.yelpStarUrl = 'https://s3-us-west-1.amazonaws.com/mfeed-store-locator.momentfeed.com/momentfeed/cards/partner_reviews/yelp_stars/regular_'
              + vm.pData.yelpRoundedRatingString + '@3x.png';
          }
          if (vm.partnerName === 'Google'){
            vm.pData.roundedRating = Math.round(vm.pData.rating);
          }
        }

        // multilingual variables
        vm.reviewCountByPartnerNameText = (vm.translatedMessages['mf.localPage.partnerReviews.reviewCountByPartnerName'] || 'View [reviewCount] [partnerName] Reviews').replace('[reviewCount]',vm.pData.reviewCount).replace('[partnerName]',vm.partnerName);
        vm.partnerNameText = (vm.translatedMessages['mf.localPage.partnerReviews.partnerName'] || 'View [partnerName] Reviews').replace('[partnerName]',vm.partnerName);
        vm.outOf5Text = vm.translatedMessages['mf.localPage.partnerReviews.outOfFive'] || 'out of 5';

      }
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('storeLocator')
    .directive('nearbyCardMulti', nearbyCardMulti);

  function nearbyCardMulti () {

    return {
      replace: true,
      scope: {locations: '=', includeLocality: "@"},
      templateUrl: 'app/localLanding/cards/multilingual/nearbyCardMulti.directive.html',
      restrict: 'AE',
      bindToController: {title: '=', localPageBtn: '=', personNotLocation: '=', translatedMessages: '='},
      controller: function ($scope, localLandingData, urlBuilderFactory, customFieldFactory, storeLocatorCache, RegionService) {
        var vm = this;
        var near = $scope.locations[0];
        vm.getDirectionsUrl = getDirectionsUrl;
        vm.getCustomFieldValueByName = getCustomFieldValueByName;
        vm.getLocalPageUrl = getLocalPageUrl;
        vm.regionService = RegionService;
        vm.includeLocality = $scope.includeLocality == "false" ? false : true;
        //multilingual variables
        vm.nearbyLocationText = vm.translatedMessages['mf.localPage.nearbylocations.text'] || 'Nearby Locations';
        vm.getDirectionsText = vm.translatedMessages['mf.cta.getDirectionsButton.text'] || 'Get Directions';
        vm.localPageText = vm.localPageBtn ? vm.localPageBtn : (vm.translatedMessages['mf.storeLocator.localPageButton.text'] || 'Local Page');

        localLandingData.getLocationsForGeoSearch(near.store_info.latitude, near.store_info.longitude, 20, 4).then(function (response) {
          if (response.length > 1) {
            $scope.locations = _.filter(response, function (loc) {
              return near.store_info.corporate_id != loc.corporate_id;
            });

          }else{
            $scope.locations = [];
          }
        })

        function getDirectionsUrl(data) {
          return urlBuilderFactory.getDirectionsUrl(data);
        }

        function getCustomFieldValueByName(customFields, name) {
          if (hasCustomFieldValue(customFields, name)) {
            var value = customFieldFactory.getValueByName(customFields, name);
          }
          return value;
        }

        function hasCustomFieldValue(customFields, name) {
          return customFieldFactory.getValueByName(customFields, name) ? true : false;
        }

        function getLocalPageUrl(location) {
          var language = storeLocatorCache.get('language');
          var url = vm.personNotLocation ? '/ll/' + location.name + location.llp_url.slice(3, location.llp_url.length) : location.llp_url

          if (!_.isEmpty(language) && !_.isUndefined(language)) {
            return language + url;
          }
          return url;
        }
      },
      controllerAs: 'nearbyCardMultiC'
    };
  }

  nearbyCardMultiController.$inject = ['$scope', 'localLandingData', 'urlBuilderFactory', 'customFieldFactory', 'LanguageService'];
  function nearbyCardMultiController($scope, localLandingData, urlBuilderFactory, customFieldFactory, LanguageService) {
    var vm = this;
    var near = $scope.locations[0];
    vm.getDirectionsUrl = getDirectionsUrl;
    vm.getCustomFieldValueByName = getCustomFieldValueByName;
    vm.getLocalPageUrl = getLocalPageUrl;
    vm.includeLocality = $scope.includeLocality == "false" ? false : true;
    vm.languageService = LanguageService;

    localLandingData.getLocationsForGeoSearch(near.store_info.latitude, near.store_info.longitude, 20, 4).then(function (response) {
      if (response.length > 1) {

        $scope.locations = _.filter(response, function (loc) {
          return near.corporate_id !== loc.corporate_id;
        });

      } else {
        $scope.locations = [];
      }
    })

    function getDirectionsUrl(data) {
      return urlBuilderFactory.getDirectionsUrl(data);
    }

    function getCustomFieldValueByName(customFields, name) {
      if (hasCustomFieldValue(customFields, name)) {
        var value = customFieldFactory.getValueByName(customFields, name);
      }
      return value;
    }

    function hasCustomFieldValue(customFields, name) {
      return customFieldFactory.getValueByName(customFields, name) ? true : false;
    }

    function getLocalPageUrl(location) {
      var url = vm.personNotLocation ? '/ll/' + location.name + location.llp_url.slice(3, location.llp_url.length) : location.llp_url
      return vm.languageService.updateLinkUrl(url);
    }
  }
})();


(function () {
  'use strict';

  angular
    .module('storeLocator')
    .directive('instagramCardMulti', instagramCardMulti);

  function instagramCardMulti() {

    return {
      replace: true,
      scope: {
        photos: '=',
        location: '='
      },
      templateUrl: 'app/localLanding/cards/multilingual/instagramCardMulti.directive.html',
      restrict: 'AE',
      bindToController: { translatedMessages: '=' },
      controller: function ($q, $scope, INSTAGRAM_HANDLE, localLandingData) {
        var vm = this;
        //multilingual variables
        vm.instragramGeneralTitleText = vm.translatedMessages['mf.localPage.social.instagram.generalTitle'] || 'Find us on Instagram';
        vm.onInstagramText = (vm.translatedMessages['mf.localPage.social.instagram.localTitle'] || 'on Instagram').replace('[name]','');

        $q.when(localLandingData.getPhotosForLocation($scope.location.id)).then(function (v) {
          if (v.total === 0) {
            return;
          }
          $scope.photos = vm.photos = _.filter(v.media, function(d){
            return d.media_type !== 'VIDEO'
          });
        });

        vm.igData = {};
        vm.llp_url = $scope.location.llp_url;
        vm.igData.url = 'https://www.instagram.com/' + INSTAGRAM_HANDLE;
        vm.title = $scope.location.store_info.name ? $scope.location.store_info.name : 'Find us';
      },
      controllerAs: 'instagramCardMultiC'
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('storeLocator')
    .directive('instagram9CardMulti', instagram9CardMulti);

  function instagram9CardMulti ($sce) {

    return {
      replace: true,
      scope: { photos: '=',location: '=', translatedMessages: '='},
      templateUrl: 'app/localLanding/cards/multilingual/instagram9CardMulti.directive.html',
      restrict: 'AE',
      bindToController: { translatedMessages: '=' },
      controller: function ($q,$scope,INSTAGRAM_HANDLE,localLandingData) {
        var vm = this;
        //multilingual variables
        vm.instragramGeneralTitleText = vm.translatedMessages['mf.localPage.social.instagram.generalTitle'] || 'Find us on Instagram';
        vm.onInstagramText = (vm.translatedMessages['mf.localPage.social.instagram.localTitle'] || 'on Instagram').replace('[name]','');
        
        $q.when(localLandingData.getPhotosForLocation($scope.location.id)).then(function (v) {
          if (v.total === 0) {
            return;
          }
          var fallback = "";
          var data = v.media || v;
          var foundValidPicture = _.filter(data, function(o) {
            return o.owner.hasOwnProperty('profile_picture_url');
          });
          if (!_.isEmpty(foundValidPicture)) {
            fallback = foundValidPicture[0]['owner']['profile_picture_url'];
          }

          data.map(function (o) {
            o.fallback_url = $sce.trustAsResourceUrl(fallback);
            if (o.thumbnail_url) {
              o.trust_url = $sce.trustAsResourceUrl(o.thumbnail_url);
            } else {
              o.trust_url = $sce.trustAsResourceUrl(o.media_url);
            }
          });
          $scope.photos = vm.photos = data;
        });

        vm.igData = {};
        vm.llp_url = $scope.location.llp_url;
        vm.igData.url = 'https://www.instagram.com/' + INSTAGRAM_HANDLE;
        vm.title = $scope.location.store_info.name ? $scope.location.store_info.name : 'Find us';

      },
      controllerAs: 'instagram9CardMultiC'
    };
  }
})();


(function () {
  'use strict';

  angular
    .module('storeLocator')
    .directive('hoursCollapseCardMulti', hoursCollapseCardMulti);

  function hoursCollapseCardMulti() {
    return {
      replace: true,
      scope: {
        location: '=',
        onlyToday: '=',
        translatedMessages: '='
      },
      templateUrl: 'app/localLanding/cards/multilingual/hoursCollapseCardMulti.directive.html',
      restrict: 'AE',
      controller: HoursController,
      controllerAs: 'hoursCardC',
      bindToController: true
    };
  }

  function HoursController(_, s, moment, customFieldFactory, storeLocatorCache) {
    var hoursCardC = this;
    // multilingual variables
    hoursCardC.openUntilText = hoursCardC.translatedMessages['mf.localPage.hours.openUntil'] || 'Open Until';
    hoursCardC.closedNowText = hoursCardC.translatedMessages['mf.localPage.hours.closedNow'] || 'Closed Now';
    hoursCardC.todaysHoursText = hoursCardC.translatedMessages['mf.localPage.hours.todaysHours'] || "Today's hours";
    hoursCardC.closedText = hoursCardC.translatedMessages['mf.localPage.hours.closed'] || 'Closed';
    hoursCardC.viewHoursText = 'View Hours';//hoursCardC.translatedMessages['mf.localPage.hours.closed'] || 'Closed';
    var language = storeLocatorCache.get('storeFindersMessages').lang;

    var days = _.range(1, 8),
      todayNum = moment().format("E"),
      sh = hoursCardC.location && hoursCardC.location.store_info ? s(hoursCardC.location.store_info.store_hours).trim(";").value() : null,
      formatTime = function (t) {
        return moment(t, "HHmm").format("LT");
      };

    hoursCardC.locHours = false;
    hoursCardC.closedNow = true;
    hoursCardC.openingHours = '';

    if (sh) {
      hoursCardC.locHours = {};
      //Initialize all days as closed
      days.forEach(function (d) {
        hoursCardC.locHours[d + ""] = {
          dayName: moment().isoWeekday(d).format("dddd"),
          dayNameShort: moment().isoWeekday(d).format("dd"),
          dayNameShortNext: moment().isoWeekday(d).add(1, 'd').format("dd"),
          closedLabel: hoursCardC.closedText
        }
      });

      sh.split(";").forEach(function (dh) {
        var info = dh.split(",").map(function (i) {
            return s(i).trim().value();
        });
        if (info.length) {
          var dayNum = info[0] + "",
            v = hoursCardC.locHours[dayNum];
          v.openTime = formatTime(info[1]);
          v.closeTime = formatTime(info[2]);
          v.openMoment = moment(info[1], "HHmm");
          v.openMoment24 = v.dayNameShort + ' ' + v.openMoment.format("H:mm");

          if(_.startsWith(info[2], '0')) {
            v.closeMoment = moment(info[2], "HHmm").add(1, 'd');
            v.closeMoment24 = v.dayNameShortNext + ' ' + v.closeMoment.format("H:mm");
          } else {
            v.closeMoment = moment(info[2], "HHmm");
            v.closeMoment24 = v.closeMoment.format("H:mm");
          }

          v.openingHours = v.openMoment24 + '-' + v.closeMoment24;
          hoursCardC.openingHours = hoursCardC.openingHours + v.dayNameShort + ' ' + v.openTime + ' - ' + v.closeTime + ' ';

          v.closedLabel = false;
          if(todayNum == dayNum){
            v.highlightClass = 'bold-700';
            var now = moment();
            hoursCardC.openToday = v.openTime;
            hoursCardC.closeToday = v.closeTime;
            if(now.isAfter(v.openMoment) && now.isBefore(v.closeMoment)){
              hoursCardC.closedNow = false;
            }
          }
        }
      });
    }

    hoursCardC.hoursNote = customFieldFactory.getTranslatedValueByName(hoursCardC.location.custom_fields, 'hours_note', language);

  }
})();

(function () {
  'use strict';

  angular
    .module('storeLocator')
    .directive('hoursCardMulti', hoursCardMulti);

  function hoursCardMulti() {
    return {
      replace: true,
      scope: {
        location: '=',
        onlyToday: '=',
        customText: '@',
        hideEmptyHours: '=',
        simplified: '=',
        collapsibleOn: '@', // options are: mobile, desktop, all, or blank,
        translatedMessages: '='
      },
      templateUrl: 'app/localLanding/cards/multilingual/hoursCardMulti.directive.html',
      restrict: 'AE',
      controller: HoursMultiController,
      controllerAs: 'hoursCardMultiC',
      bindToController: true
    };
  }

  function HoursMultiController(_, s, moment, customFieldFactory, storeLocatorCache) {
    var hoursCardC = this;
    hoursCardC.closedNow = true;
    hoursCardC.open24 = false;
    hoursCardC.tempClosed = false;
    hoursCardC.openingHours = '';
    hoursCardC.toggleCollapsibleHours = toggleCollapsibleHours;
    hoursCardC.titleText = hoursCardC.translatedMessages['mf.localPage.hours.title'] || 'Hours';
    hoursCardC.closedTodayText = hoursCardC.translatedMessages['mf.localPage.hours.closedToday'] || 'Closed Today';
    hoursCardC.closedNowText = hoursCardC.translatedMessages['mf.localPage.hours.closedNow'] || 'Closed Now';
    hoursCardC.todaysHoursText = hoursCardC.translatedMessages['mf.localPage.hours.todaysHours'] || "Today's hours";
    hoursCardC.openUntilText = hoursCardC.translatedMessages['mf.localPage.hours.openUntil'] || "Open Until";
    hoursCardC.open24Text = hoursCardC.translatedMessages['mf.localPage.hours.open24'] || "Open 24 Hours";
    hoursCardC.specialHoursText = hoursCardC.translatedMessages['mf.localPage.hours.special'] || "Special Hours";
    hoursCardC.closedText = hoursCardC.translatedMessages['mf.localPage.hours.closed'] || "Closed";
    hoursCardC.openNowUntilText = hoursCardC.translatedMessages['mf.localPage.hours.openNowUntil'] || "Open Now Until";
    var language = storeLocatorCache.get('storeFindersMessages').lang;
    
    // if temp closed, set hoursCardC.tempClosed
    if(hoursCardC.location.status == "temp closed") {
      hoursCardC.tempClosed = true;
    }

    // returns the hour fragment for the day depending on the passed key value
    hoursCardC.getOpenTimePeriodDisplayMessage = function(regularHours, index) {
      var key = '';
      if (angular.isDefined(index)) {
        key = 'openTimePeriodDisplayMessage_' + index;
      } else {
        key = 'openTimePeriodDisplayMessage';
      }
      return regularHours[key];
    };

    /**
     * function returns true if passed value is null, undefined and legth is zero, else false
     * @param {string} storeTimeZone 
     */
    function checkObj(storeTimeZone) {
      return ( _.isNull(storeTimeZone) || _.isUndefined(storeTimeZone) || storeTimeZone.length === 0 )
    }

    /**
     * function to check if the store is open or closed and set
     * the corresponding 'closedNow' value on the directive object
     * @param {object} hourObj hour object which has all the details about the timings/days
    */
    function updateTodaysHours(hourObj) {
      if (hourObj.closed) {
        hoursCardC.closed24 = true;
        return;
      }
      // check for today's special hours. start
      var isTodaySpecial = isTodaySpecialHours();
      //check for today's special hours. end
      //counter to loop through the number of fragments
      var counter = 0;
      while (counter < hourObj.numberOfTimeFragments.length) {
        var openTimePeriodKey = 'openTimePeriod' + '_' + counter;
        var closeTimePeriodKey = 'closeTimePeriod' + '_' + counter;

        if (hourObj[openTimePeriodKey] && hourObj[closeTimePeriodKey]) {
          hoursCardC[openTimePeriodKey] = moment(hourObj[openTimePeriodKey], "LT").format("LT")
          hoursCardC[closeTimePeriodKey] = moment(hourObj[closeTimePeriodKey], "hh:mm LT").format("LT");
        }

        if (moment(hourObj[closeTimePeriodKey], "LT").isBefore(moment(hourObj[openTimePeriodKey], "LT")) || moment(hourObj[closeTimePeriodKey], "LT").format('HHmm') === '0000') {
          hourObj[closeTimePeriodKey] = moment(hourObj[closeTimePeriodKey], "LT").add(1, 'days');
        }

        var amIBetweenGroupKey = 'amIBetweenGroup' + '_' + counter;
        var now = moment();
        // store timezone code start
        var storeTimeZone = hoursCardC.location.store_info.timezone; // store timezone from api
        var storeCurrentDateTime = null;
        var convertedStoreHour = null;
        var isInvalidObj = checkObj(storeTimeZone);
        if (!isInvalidObj) {
          storeCurrentDateTime = getStoreCurrentTime(storeTimeZone);
          convertedStoreHour = moment(getConvertedStoreHours(storeCurrentDateTime), "LT");
        }
        // store timezone code end
        // instead of now object the comparison is made with convertedStoreHour object
        var startTime = moment(hourObj[openTimePeriodKey], "LT");
        var endTime = moment(hourObj[closeTimePeriodKey], "LT");
        if(!isInvalidObj){
          if (endTime.format('HHmm') < (startTime.format('HHmm'))) {
            if (convertedStoreHour.format('HHmm') < endTime.format('HHmm')) {
              startTime = startTime.subtract(1, 'days');
            } else {
              endTime = endTime.add(1, 'days');
            }
          }
          amIBetweenGroupKey = convertedStoreHour.isBetween(startTime, endTime);
        } else {
          if (endTime.format('HHmm') < (startTime.format('HHmm'))) {
            if (now.format('HHmm') < endTime.format('HHmm')) {
              startTime = startTime.subtract(1, 'days');
            } else {
              endTime = endTime.add(1, 'days');
            }
          }
          amIBetweenGroupKey = now.isBetween(startTime, endTime);
        }

        if (amIBetweenGroupKey) {
          hoursCardC.closeToday = endTime.format("LT");
          if (amIBetweenGroupKey || hourObj.open24) {
            hoursCardC.closedNow = false;
          } else {
            hoursCardC.closedNow = true;
          }
        } else if(isTodaySpecial && !amIBetweenGroupKey){
          hoursCardC.closeToday = endTime.format("LT");
          hoursCardC.closedNow = true;
        }
        counter++;
      }

      hoursCardC.openToday = hourObj.openDisplayTime;
      hoursCardC.open24 = hourObj.open24;
    }

    function isTodaySpecialHours(){
      var isTodaySpecial = false;
      var specialHours = (hoursCardC.location &&
        hoursCardC.location.store_info &&
        hoursCardC.location.store_info.special_hours) ?
        s(hoursCardC.location.store_info.special_hours).trim(";").value() : null;
          
      if (specialHours !== null) {
        // Check if any special hours are coming up.
        var validSpHours = checkSpecialHours(specialHours);
        if (!_.isEmpty(validSpHours)) {
          isTodaySpecial=true;
        }
      } 
      return isTodaySpecial;
    }

    function parseDateStrings(dateStrs) {
      var intDateStrs = dateStrs.split(";");
      return _.map(intDateStrs, function(dateStr) {
        var info = dateStr.split(",");
        if (angular.isDefined(info[1]) && info[1].toUpperCase() === "CLOSED") {
          // return just the day. This way we can use it to determine if today == which hour obj.
          return {
            day: info[0]
          };
        }
        else {
          // Else add open and close times based on the strings.
          // Will moment parse these to more readable strings later.
          return {
            day: info[0],
            openTime: info[1],
            closeTime: info[2]
          };
        }
      });
    }

    /**
     * function generates hours object for each day
     * @param {string} dateStrs open and close times for the week
     * @param {string} closeLabel close label for the location
    */
    function generateHours(dateStrs, closeLabel) {
      // Split up the dateStrs and generate objects for each one
      var parsedDateStrs = parseDateStrings(dateStrs);
      var locHours = {};
      _.range(1, 8).forEach(function(day) {
        // Generate base objects per day
        var newHoursObj = {
          day: day.toString(),
          dayName: moment().isoWeekday(day).format("dddd"),
          dayNameShort: moment().isoWeekday(day).format("dd"),
          dayNameShortNext: moment().isoWeekday(day).add(1, 'd').format("dd"),
          closedLabel: closeLabel
        };
        // filter method gets all the matching objects for a certain day of the week
        var parsedData = _.filter(parsedDateStrs, function(obj) {
          return obj['day'] === day.toString();
        });

        // all the open and close time for the store location in an array
        var openTime = _.map(parsedData, 'openTime');
        var closeTime = _.map(parsedData, 'closeTime');
        // adding the values to the object we will need to display all the times
        // and proper messaging for the store hours
        parsedData = {};
        _.forEach(openTime, function(value, key) {
          //moment js doesn't recognize 2400 hrs
          if (closeTime[key] === '2400') {
            closeTime[key] = '0000';
          }
          parsedData['openTime' + 'PeriodDisplayMessage' + '_' + key] = displayOpenAndClosedTime(openTime[key], closeTime[key]);
          parsedData['openTime' + 'Period' + '_' + key] = openTime[key] ? moment(openTime[key],"hmm").format("LT") : "";
          parsedData['closeTime' + 'Period' + '_' + key] = closeTime[key] ? moment(closeTime[key],"hmm").format("LT") : "";
          parsedData['openTime'] = openTime[0];
          parsedData['closeTime'] = closeTime[0];
          parsedData['numberOfTimeFragments'] = new Array(_.keys(openTime).length);
        });

        //we need the numberOfTimeFragments to display the correct message when clients pass empty store hours for the day
        if (openTime.length === 0) {
          parsedData['numberOfTimeFragments'] = new Array(1);
        }

        _.assign(newHoursObj, parsedData);
        locHours[day] = createHoursObj(newHoursObj);
        // Check if Today. If so, apply highlighting and modify
        // some controller level variables in a separate function.
        if (day.toString() === moment().format("E")) {
          if(!hoursCardC.simplified) {
            locHours[day].highlightClass = "bold-700";
          }
          //initialize the open and close time empty arrays
          openTime = [];
          closeTime = [];
          var counter = 0;
          while (counter < locHours[day]['numberOfTimeFragments'].length) {
            var openTimePeriodKey = 'openTimePeriod' + '_' + counter;
            var closeTimePeriodKey = 'closeTimePeriod' + '_' + counter;
            if (locHours[day][openTimePeriodKey] && locHours[day][openTimePeriodKey].length > 0 && locHours[day][closeTimePeriodKey].length > 0) {
              openTime.push(locHours[day][openTimePeriodKey]);
              closeTime.push(locHours[day][closeTimePeriodKey]);
            }
            counter++;
          }

          // when the location does not have hours for the day we
          // assume that it is closed
          if (openTime.length > 0 && closeTime.length > 0) {
            locHours[day].openTimePeriodDisplayMessage = isTheLocationOpen(openTime, closeTime);
          } else {
            locHours[day].closed = true;
          }
          updateTodaysHours(locHours[day]);
        }
      });

      return locHours;
    }

    /**
     * function generates the display time message for the different
     * periods/times for which the store is open
     * @param {string} openTime open time for the store
     * @param {string} closeTime close time for the store
    */
    function displayOpenAndClosedTime(openTime, closeTime) {
      var displayTime = "";
      if (openTime && closeTime) {
        displayTime = moment(openTime, "hmm").format("LT") + " " + "-" + " " + moment(closeTime, "hmm").format("LT");
      }
      return displayTime;
    }

    /**
     * function is used to get the current time in the store timezone
     * @param {string} actualStoreTimeZone 
     */
    function getStoreCurrentTime(actualStoreTimeZone){
      var currentStoreDateTime = null;
      var isInvalidObj = checkObj(actualStoreTimeZone);
      if (!isInvalidObj) {
        currentStoreDateTime = angular.isDefined((moment.tz.zone(actualStoreTimeZone))) ? moment.tz(actualStoreTimeZone).format('YYYY-MM-DD LT') : moment().format('YYYY-MM-DD LT');//
      }
      return currentStoreDateTime;
    }

    /**
     * function is used to get the time part from the converted store timezone
     * @param {moment} storeCurrentDateTime 
     */
    function getConvertedStoreHours(storeCurrentDateTime){
      var convertedStoreHours = null;
      var currTimeArr = storeCurrentDateTime.split(" ");
      var isInvalidObj = checkObj(currTimeArr);
      if (!isInvalidObj){
        var isInvalidObj1 = checkObj(currTimeArr[1]);
        if(!isInvalidObj1 && currTimeArr.length > 1){
          if (currTimeArr[2]) {
            convertedStoreHours = currTimeArr[1].trim().concat(" ").concat(currTimeArr[2].trim());
          } else {
            convertedStoreHours = currTimeArr[1].trim().concat(" ");
          }
        }
      }
      return convertedStoreHours;
    }
    
    /**
     * function is used to generate the appropriate messaging for the
     * current day including store open/close times.
     * @param {array} openTime open time for the store for the current day
     * @param {array} closeTime close time for the store for the current day
    */
    function isTheLocationOpen(openTime, closeTime) {
      var amIBetweenFirstGroup = false;
      var amIBetweenSecondGroup = false;
      var amIBetweenThirdGroup = false;
      var storeOpenOrCloseMessage = '';
      var currentTime = moment();
      var displayMessage = '';
      var startTimeFirstGroup = openTime[0] ? moment(openTime[0].trim(), "LT") : "Closed Today";
      var endTimeFirstGroup = closeTime[0] ? moment(closeTime[0].trim(), "LT") : "Closed Today";

      var openTwentyFourHours = false;
      // store timezone code start
      var storeTimeZone = hoursCardC.location.store_info.timezone; // store timezone from api
      var storeCurrentDateTime = null;
      var convertedLocStoreHour = null;
      var isInvalidObj = checkObj(storeTimeZone);
      if (!isInvalidObj) {
        storeCurrentDateTime = getStoreCurrentTime(storeTimeZone);
        convertedLocStoreHour = moment(getConvertedStoreHours(storeCurrentDateTime), "LT");
      } else {
        convertedLocStoreHour = currentTime;
      }
      // store timezone code end
      
      if (openTime.length === 2) {
        var startTimeSecondGroup = moment(openTime[1], "LT");
        var endTimeSecondGroup = moment(closeTime[1], "LT");
      } else if (openTime.length === 3) {
        var startTimeThirdGroup = moment(openTime[2], "LT");
        var endTimeThirdGroup = moment(closeTime[2], "LT");
        startTimeSecondGroup = moment(openTime[1], "LT");
        endTimeSecondGroup = moment(closeTime[1], "LT");
      }
      //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
       // check if the close time is on the next date in the A.M.
        if (endTimeFirstGroup.format('HHmm') < (startTimeFirstGroup.format('HHmm')) || moment(closeTime[0], "LT").format('HHmm') === '0000') {
          //open 24 message if the store is open for 24hrs
          if (endTimeFirstGroup.format('HHmm') - (startTimeFirstGroup.format('HHmm')) === 0) {
            openTwentyFourHours = true;
          }
          // Check the user currentime is before shop close time then subtract 1 day from start date
          // as the shop has started in previous day
          // else add 1 day to end date as the shop will be closing on next day
          if (convertedLocStoreHour.format('HHmm') < (endTimeFirstGroup.format('HHmm'))) {
            startTimeFirstGroup = startTimeFirstGroup.subtract(1, 'days');
          } else {
            endTimeFirstGroup = endTimeFirstGroup.add(1, 'days');
          }
        }
      //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

      if (openTime.length === 2 && closeTime.length === 2) {
        // check if the close time is on the next date in the A.M.
        if (endTimeSecondGroup.isBefore(startTimeSecondGroup) || moment(closeTime[1], "LT").format('HHmm') === '0000') {
          endTimeSecondGroup = endTimeFirstGroup.add(1, 'days');
        }
        displayMessage = moment(openTime[0], "LT").format("LT") + ' - '  + moment(closeTime[0], "LT").format("LT") + ', ' +
                         moment(openTime[1], "LT").format("LT") + ' - ' + moment(closeTime[1], "LT").format("LT");
        // instead of currentTime object the comparison is made with convertedLocStoreHour object
        if (!isInvalidObj) {
          amIBetweenFirstGroup = convertedLocStoreHour.isBetween(startTimeFirstGroup, endTimeFirstGroup);
          amIBetweenSecondGroup = convertedLocStoreHour.isBetween(startTimeSecondGroup, endTimeSecondGroup);
        } else {
          // earlier implementation
          amIBetweenFirstGroup = currentTime.isBetween(startTimeFirstGroup, endTimeFirstGroup);
          amIBetweenSecondGroup = currentTime.isBetween(startTimeSecondGroup, endTimeSecondGroup);
        }

        if (amIBetweenFirstGroup) {
          storeOpenOrCloseMessage = hoursCardC.openNowUntilText + ' ' + moment(closeTime[0], "LT").format("LT") + ', ' + displayMessage;
        } else if (amIBetweenSecondGroup) {
          storeOpenOrCloseMessage = hoursCardC.openNowUntilText + ' ' + moment(closeTime[1], "LT").format("LT") + ', ' + displayMessage;
        } else {
          storeOpenOrCloseMessage = hoursCardC.closedNowText + ". " + hoursCardC.todaysHoursText + ': ' + displayMessage;
        }
      } else if (openTime.length === 3 && closeTime.length === 3) {
        // if there are three fragments for store hours
        // check if the second fragment close time is on the next date in the A.M.
        if (endTimeSecondGroup.isBefore(startTimeSecondGroup) || moment(closeTime[1], "LT").format('HHmm') === '0000') {
          endTimeSecondGroup = endTimeFirstGroup.add(1, 'days');
        }
        // check if the third fragment close time is on the next date in the A.M.
        if (endTimeThirdGroup.isBefore(startTimeThirdGroup) || moment(closeTime[2], "LT").format('HHmm') === '0000') {
          endTimeThirdGroup = endTimeSecondGroup.add(1, 'days');
        }
        displayMessage = moment(openTime[0], "LT").format("LT") + ' - ' + moment(closeTime[0], "LT").format("LT") + ', ' +
                         moment(openTime[1], "LT").format("LT") + ' - ' + moment(closeTime[1], "LT").format("LT") + ', ' +
                         moment(openTime[2], "LT").format("LT") + ' - ' + moment(closeTime[2], "LT").format("LT");

        // time fragment flags
        // instead of currentTime object the comparison is made with convertedLocStoreHour object
        if (!isInvalidObj) {
          amIBetweenFirstGroup = convertedLocStoreHour.isBetween(startTimeFirstGroup, endTimeFirstGroup); // currentTime is replaced with convertedStoreHrs
          amIBetweenSecondGroup = convertedLocStoreHour.isBetween(startTimeSecondGroup, endTimeSecondGroup); // currentTime is replaced with convertedStoreHrs
          amIBetweenThirdGroup = convertedLocStoreHour.isBetween(startTimeThirdGroup, endTimeThirdGroup); // currentTime is replaced with convertedStoreHrs
        } else {
          // earlier implementation
          amIBetweenFirstGroup = currentTime.isBetween(startTimeFirstGroup, endTimeFirstGroup); // currentTime is replaced with convertedStoreHrs
          amIBetweenSecondGroup = currentTime.isBetween(startTimeSecondGroup, endTimeSecondGroup); // currentTime is replaced with convertedStoreHrs
          amIBetweenThirdGroup = currentTime.isBetween(startTimeThirdGroup, endTimeThirdGroup); // currentTime is replaced with convertedStoreHrs
        }
        if (amIBetweenFirstGroup) {
          storeOpenOrCloseMessage = hoursCardC.openNowUntilText + ' ' + moment(closeTime[0], "LT").format("LT") + ', ' + displayMessage;
        } else if (amIBetweenSecondGroup) {
          storeOpenOrCloseMessage = hoursCardC.openNowUntilText + ' ' + moment(closeTime[1], "LT").format("LT") + ', ' + displayMessage;

        } else if (amIBetweenThirdGroup) {
          storeOpenOrCloseMessage = hoursCardC.openNowUntilText + ' ' + moment(closeTime[2], "LT").format("LT") + ', ' + displayMessage;
        } else {
          storeOpenOrCloseMessage = hoursCardC.closedNowText + '. ' + hoursCardC.todaysHoursText + ': ' + displayMessage;
        }
      } else {
        // below line is commented to implement the store timezone changes
        //amIBetweenFirstGroup = currentTime.isBetween(startTimeFirstGroup, endTimeFirstGroup);
        // instead of currentTime object the comparison is made with convertedLocStoreHour object
        //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

        if (!isInvalidObj) {
          /* if (endTimeFirstGroup.format('HHmm') < (startTimeFirstGroup.format('HHmm')) || moment(closeTime[0], "LT").format('HHmm') === '0000') {
            //open 24 message if the store is open for 24hrs
            if (endTimeFirstGroup.format('HHmm') - (startTimeFirstGroup.format('HHmm')) === 0) {
              openTwentyFourHours = true;
            }
            // Check the user currentime is before shop close time then subtract 1 day from start date
            // as the shop has started in previous day
            // else add 1 day to end date as the shop will be closing on next day
            if (convertedLocStoreHour.format('HHmm') < (endTimeFirstGroup.format('HHmm'))) {
              startTimeFirstGroup = startTimeFirstGroup.subtract(1, 'days');
            } else {
              endTimeFirstGroup = endTimeFirstGroup.add(1, 'days');
            }
          } */
            amIBetweenFirstGroup = convertedLocStoreHour.isBetween(startTimeFirstGroup, endTimeFirstGroup);
        } else { // in case if timezone is not populated in timezone variable then it should display as earlier
          amIBetweenFirstGroup = currentTime.isBetween(startTimeFirstGroup, endTimeFirstGroup);
        }
        if (openTwentyFourHours) {
          storeOpenOrCloseMessage = hoursCardC.open24Text;
        } else {
          if (amIBetweenFirstGroup) {
            storeOpenOrCloseMessage = hoursCardC.openNowUntilText + ' ' + moment(closeTime[0], "LT").format("LT");
          } else {
            storeOpenOrCloseMessage = hoursCardC.closedNowText + '. ' + hoursCardC.todaysHoursText + ': ' + moment(openTime[0], "LT").format("LT") + ' - ' + moment(closeTime[0], "LT").format("LT");
          }
        }
      }
      //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

      return storeOpenOrCloseMessage;
    }

    function generateSpecialHours(dateStrs) {
      // Split up the dateStrs and generate objects for each one
      var parsedDateStrs = parseDateStrings(dateStrs);
      var dates = _.uniq(_.map(parsedDateStrs, 'day'));
      var spHours = [];

      _.forEach(dates, function(date) {
        // Generate base objects per day
        var newHoursObj = {
          closedLabel: hoursCardC.translatedMessages['mf.localPage.hours.closed'] || "Closed",
          dayNameShort: date,
          dayOfTheWeek: moment(date, "YYYY-MM-DD").format("E")
        };

        var parsedData = _.filter(parsedDateStrs, function(obj) {
          return obj['day'] === date.toString();
        });
        
        // all the open and close time for the store location in an array
        var openTime = _.map(parsedData, 'openTime');
        var closeTime = _.map(parsedData, 'closeTime');
        parsedData = {};
        _.forEach(openTime, function(value, key) {
          //moment js doesn't recognize 2400 hrs
          if (angular.isDefined(value)) {
            if (closeTime[key] === '2400') {
              closeTime[key] = '0000';
            }
            parsedData['openTime' + 'PeriodDisplayMessage' + '_' + key] = displayOpenAndClosedTime(openTime[key], closeTime[key]);
            parsedData['openTime' + 'Period' + '_' + key] = openTime[key] ? moment(openTime[key],"hmm").format("LT") : "";
            parsedData['closeTime' + 'Period' + '_' + key] = closeTime[key] ? moment(closeTime[key],"hmm").format("LT") : "";
            parsedData['openTime'] = openTime[0];
            parsedData['closeTime'] = closeTime[0];
            parsedData['numberOfTimeFragments'] = new Array(_.keys(openTime).length);
          } else {
            //we need the numberOfTimeFragments to display the correct message for the store hours in the directive.html
            parsedData['numberOfTimeFragments'] = new Array(_.keys(openTime).length);
          }
        });

        _.assign(newHoursObj, parsedData);
        var completeHoursObj = createHoursObj(newHoursObj);
        if(completeHoursObj.dayNameShort === moment().format("YYYY-MM-DD")) {
          if(!hoursCardC.simplified) {
            completeHoursObj.highlightClass = "bold-700";
          }

          //initialize the open and close time empty arrays
          openTime = [];
          closeTime = [];
          var counter = 0;
          while (counter < completeHoursObj['numberOfTimeFragments'].length) {
            var openTimePeriodKey = 'openTimePeriod' + '_' + counter;
            var closeTimePeriodKey = 'closeTimePeriod' + '_' + counter;
            if (completeHoursObj[openTimePeriodKey] && completeHoursObj[openTimePeriodKey].length > 0 && completeHoursObj[closeTimePeriodKey].length > 0) {
              openTime.push(completeHoursObj[openTimePeriodKey]);
              closeTime.push(completeHoursObj[closeTimePeriodKey]);
            }
            counter++;
          }

          // Remove all highlighting on regular hours
          _.forEach(hoursCardC.locHours, function (hourObj) {
            hourObj.highlightClass = "";
          });

          if (openTime.length > 0) {
            completeHoursObj.openTimePeriodDisplayMessage = isTheLocationOpen(openTime, closeTime);
          }
          updateTodaysHours(completeHoursObj);
        }
        spHours.push(completeHoursObj);
      });

      return spHours;
    }

    /* Things I removed:
     * location.status === 'coming soon' moving to directive.html
     */
    function createHoursObj(hourObj) {
      if (hoursCardC.location.status == "temp closed") {
        return _.assign(hourObj, {"closed": true, "closedLabel": hoursCardC.translatedMessages['mf.location.tempClosed.status'] || "Temporarily Closed"})
      }
      if (!hourObj.hasOwnProperty("openTime")) {
        return _.assign(hourObj, {"closed": true});
      }
      hourObj.openTime = moment(hourObj.openTime, "HHmm");
      // If close is earlier than openM, then add 1 day to it
      hourObj.closeTime = moment(hourObj.closeTime, "HHmm");
      if (hourObj.closeTime.diff(hourObj.openTime) < 0) {
        hourObj.closeTime.add(1, 'd');
      }

      // Convenience vars so we only need to format or call moment on these once
      hourObj.openDisplayTime = hourObj.openTime.format("LT");
      hourObj.closeDisplayTime = hourObj.closeTime.format("LT");
      // Check if open 24/7 by comparing if diff of open and close time is 0
      hourObj.open24 = hourObj.openTime.diff(hourObj.closeTime) === 0;

      // Augment openingHours on controller
      hoursCardC.openingHours = hoursCardC.openingHours +
        hourObj.dayNameShort +
        ' ' +
        hourObj.openDisplayTime +
        ' - ' +
        hourObj.closeDisplayTime +
        ' ';

      return hourObj;
    }

    // Takes a datestring and checks if any special days are within 7 days of today
    // Return a list of dates + times that are within 7 days of today
    function checkSpecialHours(dates) {
      //For each date with special hours
      var intNearbyDates = _.filter(dates.trim().split(";"), function(el){
        return angular.isDefined(el) && el!=="";
      });

      var nearbyDates = _.map(intNearbyDates, function(specialDay) {
        //Split on the entry
        var dayData = specialDay.split(",");
        //Check today - specialDay < 7, if matched, return this date!
        var specialDateMoment = moment(dayData[0], "YYYY-M-D");
        var today = moment();
        if (specialDateMoment.diff(today, "days") < 7 &&
            specialDateMoment.diff(today, "days") >= 0) {
          return specialDay;
        }
      });
      return _.compact(nearbyDates).join(";");
    }
    if(hoursCardC.location.status == "coming soon"){
      hoursCardC.comingSoon = hoursCardC.translatedMessages['mf.location.comingSoon.status'] || "Coming Soon"
    }
    else if (hoursCardC.location.status == "temp closed"){
      hoursCardC.comingSoon = hoursCardC.translatedMessages['mf.location.tempClosed.status'] || "Temporarily Closed"
    }

    // If there's custom text, set it.
    if (hoursCardC.customText) {
      var str = hoursCardC.customText;
      str = str.replace(/\[(.*?[^.])\]/g, function (s, key) {
        return hoursCardC[key];
      });
      hoursCardC.customTextShow = str;
    }

    var checkHoursFormat = /^[0-9;,closedCLOSED]+$/;

    var sh = hoursCardC.location && hoursCardC.location.store_info ? s(hoursCardC.location.store_info.store_hours).trim(";").value() : null;
    // Replace anything that isn't number, ';', ',', or the letters c, l, o, s, e, d in their lower and capital forms
    sh = sh.replace(/[^0-9;,closedCLOSED]/g,'');
    sh = sh.trim();

    // Check if there are store hours listed. If not, show all days as "Closed" unless config indicates they should be hidden
    if (hoursCardC.location.store_info.store_hours == '' && (!hoursCardC.hideEmptyHours || hoursCardC.hideEmptyHours != true)) {
      hoursCardC.locHours = generateHours(sh, "Closed");
    }

    // Check if store is coming soon, if so, init all days to coming soon
    if (hoursCardC.location.status == "coming soon") {
      hoursCardC.locHours = generateHours(sh, "Coming Soon");
    }

    // Check if time returned is valid
    if (sh && checkHoursFormat.test(sh)) {
      hoursCardC.locHours = generateHours(sh, "Closed");
    }

    // Check for special hours
    var specialHours = (hoursCardC.location &&
      hoursCardC.location.store_info &&
      hoursCardC.location.store_info.special_hours) ?
      s(hoursCardC.location.store_info.special_hours).trim(";").value() : null;
      //specialHours = '2018-12-24,0000,1800;2018-12-25,CLOSED;2018-12-31,0000,2200;2019-01-01,0600,0000;2019-05-15,CLOSED';

    if (specialHours !== null) {
      // Check if any special hours are coming up.
      var validSpHours = checkSpecialHours(specialHours);
      if (!_.isEmpty(validSpHours)) {
        // For each special day, format it for display like normal hours.
        hoursCardC.specialHours = generateSpecialHours(validSpHours);
      }
    }
    hoursCardC.hoursNote = customFieldFactory.getTranslatedValueByName(hoursCardC.location.custom_fields, 'hours_note', language);

    function toggleCollapsibleHours() {
      var collapsibleHours = document.getElementsByClassName('collapsible')[0];
      var collapseIcon = document.getElementsByClassName('collapse-icon')[0].getElementsByTagName('i')[0];
      if(collapsibleHours.classList.value.indexOf('show') === -1) {
        collapsibleHours.classList.add('show');
        collapseIcon.classList.remove('fa-chevron-down');
        collapseIcon.classList.add('fa-chevron-up');
      } else {
        collapsibleHours.classList.remove('show');
        collapseIcon.classList.add('fa-chevron-down');
        collapseIcon.classList.remove('fa-chevron-up');
      }
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('storeLocator')
    .directive('hoursAdditionalCardMulti', hoursAdditionalCardMulti);

  function hoursAdditionalCardMulti() {
    return {
      replace: true,
      scope: {
        location: '=',
        titlePrimary: '=',
        titleAdditional: '@',
        isUsedForPrimaryRegularHours: '=',
        specialHoursDateFormat: '@',
        translatedMessages: '='
      },
      templateUrl: 'app/localLanding/cards/multilingual/hoursAdditionalCardMulti.directive.html',
      restrict: 'AE',
      controller: hoursAddCardMultiController,
      controllerAs: 'hoursAddCardMultiC',
      bindToController: true
    };
  }

  function hoursAddCardMultiController(_, s, moment, customFieldFactory, storeLocatorCache) {
    var hoursAddCardMultiC = this;

    hoursAddCardMultiC.closed24 = true;
    hoursAddCardMultiC.closed24Additional = true;
    hoursAddCardMultiC.closedNow = true;
    hoursAddCardMultiC.closedNowAdditional = true;
    hoursAddCardMultiC.open24 = false;
    hoursAddCardMultiC.openingHours = '';
    hoursAddCardMultiC.open24Additional = false;
    hoursAddCardMultiC.openingHoursAdditional = '';
    hoursAddCardMultiC.hasPrimary = false;
    hoursAddCardMultiC.hasPrimarySpecial = false;
    // multilingual variables
    hoursAddCardMultiC.openNowUntilText = hoursAddCardMultiC.translatedMessages['mf.localPage.hours.openNowUntil'] || 'Open Now Until';
    hoursAddCardMultiC.openUntilText = hoursAddCardMultiC.translatedMessages['mf.localPage.hours.openUntil'] || 'Open Until';
    hoursAddCardMultiC.closedNowText = hoursAddCardMultiC.translatedMessages['mf.localPage.hours.closedNow'] || 'Closed Now';
    hoursAddCardMultiC.todaysHoursText = hoursAddCardMultiC.translatedMessages['mf.localPage.hours.todaysHours'] || "Today's hours";
    hoursAddCardMultiC.open24Text = hoursAddCardMultiC.translatedMessages['mf.localPage.hours.open24'] || 'Open 24 Hours';
    hoursAddCardMultiC.closedTodayText = hoursAddCardMultiC.translatedMessages['mf.localPage.hours.closedToday'] || 'Closed Today';
    hoursAddCardMultiC.specialHoursText = hoursAddCardMultiC.translatedMessages['mf.localPage.hours.special'] || 'Special Hours';
    hoursAddCardMultiC.closedText = hoursAddCardMultiC.translatedMessages['mf.localPage.hours.closed'] || 'Closed';
    hoursAddCardMultiC.regularHoursText = hoursAddCardMultiC.translatedMessages['mf.localPage.hours.additional'] || 'Regular Hours';
    var language = storeLocatorCache.get('storeFindersMessages').lang;

    // returns the hour fragment for the day depending on the passed key value
    hoursAddCardMultiC.getOpenTimePeriodDisplayMessage = function(regularHours, index) {
      var key = '';
      if (angular.isDefined(index)) {
        key = 'openTimePeriodDisplayMessage_' + index;
      } else {
        key = 'openTimePeriodDisplayMessage';
      }
      return regularHours[key];
    };

    /**
     * function returns true if passed value is null, undefined and legth is zero, else false
     * @param {*} storeTimeZone 
     */
    function checkObj(storeTimeZone) {
      return ( _.isNull(storeTimeZone) || _.isUndefined(storeTimeZone) || storeTimeZone.length === 0 )
    }

    /**
     * function to check if the store is open or closed and set
     * the corresponding 'closedNow' value on the directive object
     * @param {object} hourObj hour object which has all the details about the timings/days
    */
    function updateTodaysHours(hourObj) {
      if (hourObj.closed) {
        hoursAddCardMultiC.closed24 = true;
        return;
      }

      hoursAddCardMultiC.closed24 = false;
       // check for today's special hours. start
       var isTodaySpecial = isTodaySpecialHours();
      //counter to loop through the number of fragments
      var counter = 0;
      if(hourObj && hourObj.numberOfTimeFragments) {
        while (counter < hourObj.numberOfTimeFragments.length) {
          var openTimePeriodKey = 'openTimePeriod' + '_' + counter;
          var closeTimePeriodKey = 'closeTimePeriod' + '_' + counter;
          if (hourObj[openTimePeriodKey] && hourObj[closeTimePeriodKey]) {
            hoursAddCardMultiC[openTimePeriodKey] = moment(hourObj[openTimePeriodKey], "LT").format("LT")
            hoursAddCardMultiC[closeTimePeriodKey] = moment(hourObj[closeTimePeriodKey], "LT").format("LT");
          }
          if (moment(hourObj[closeTimePeriodKey], "LT").isBefore(moment(hourObj[openTimePeriodKey], "LT")) || moment(hourObj[closeTimePeriodKey], "LT").format('HHmm') === '0000') {
            hourObj[closeTimePeriodKey] = moment(hourObj[closeTimePeriodKey], "LT").add(1, 'days');
          }
  
          var amIBetweenGroupKey = 'amIBetweenGroup' + '_' + counter;
          var now = moment();
          // store timezone code start
          var storeTimeZone = hoursAddCardMultiC.location.store_info.timezone; // store timezone from api
          var storeCurrDateTime = null;
          var convertedStoreTime = null;
          var isInvalidObj = checkObj(storeTimeZone);
          if (!isInvalidObj) {
            storeCurrDateTime = getStoreCurrentTime(storeTimeZone);
            convertedStoreTime = moment(getConvertedStoreHours(storeCurrDateTime), "LT");
          }
          // store timezone code end
          // instead of now object the comparison is made with convertedStoreTime object
          var startTime = moment(hourObj[openTimePeriodKey], "LT");
          var endTime = moment(hourObj[closeTimePeriodKey], "LT");
          if (now.isBefore(endTime)) {
            startTime = startTime.subtract(1, 'days');
          } else {
            endTime = endTime.add(1, 'days');
          }
          if(!isInvalidObj){
            amIBetweenGroupKey = convertedStoreTime.isBetween(startTime, endTime);
          } else {
            amIBetweenGroupKey = now.isBetween(startTime, endTime);
          }
  
          if (amIBetweenGroupKey) {
            hoursAddCardMultiC.closeToday = endTime.format("LT");
            if (amIBetweenGroupKey || hourObj.open24) {
              hoursAddCardMultiC.closedNow = false;
            } else {
              hoursAddCardMultiC.closedNow = true;
            }
          } else if(isTodaySpecial && !amIBetweenGroupKey){
            hoursAddCardMultiC.closeToday = endTime.format("LT");
            hoursAddCardMultiC.closedNow = true;
          }
  
          counter++;
        }
      }

      hoursAddCardMultiC.openToday = hourObj.openDisplayTime;
      hoursAddCardMultiC.open24 = hourObj.open24;
    }

    function isTodaySpecialHours(){
      var isTodaySpecial = false;
      var specialHours = (hoursAddCardMultiC.location &&
        hoursAddCardMultiC.location.store_info &&
        hoursAddCardMultiC.location.store_info.special_hours) ?
        s(hoursAddCardMultiC.location.store_info.special_hours).trim(";").value() : null;
          
      if (specialHours !== null) {
        // Check if any special hours are coming up.
        var validSpHours = checkSpecialHours(specialHours);
        if (!_.isEmpty(validSpHours)) {
          isTodaySpecial=true;
        }
      } 
      return isTodaySpecial;
    }

    function updateTodaysHoursAdditional(hourObj) {
      if (hourObj.closed) {
        hoursAddCardMultiC.closed24Additional = true;
        return;
      }

      hoursAddCardMultiC.closed24Additional = false;

      var now = moment();
      hoursAddCardMultiC.openTodayAdditional = hourObj.openDisplayTime;
      hoursAddCardMultiC.closeTodayAdditional = hourObj.closeDisplayTime;
      hoursAddCardMultiC.open24Additional = hourObj.open24;
      // store timezone code start
      var storeTimeZone = hoursAddCardMultiC.location.store_info.timezone; // store timezone from api
      var storeCurrentDateTime = null;
      var convertedStoreTodayHrs = null;
      var isInvalidObj = checkObj(storeTimeZone);
      if (!isInvalidObj) {
        storeCurrentDateTime = getStoreCurrentTime(storeTimeZone);
        convertedStoreTodayHrs = moment(getConvertedStoreHours(storeCurrentDateTime), "LT");
      }
      // store timezone code end
      // instead of now object the comparison is made with convertedStoreTodayHrs object
      if (!isInvalidObj) {
        if ((convertedStoreTodayHrs.isAfter(hourObj.openTime) && convertedStoreTodayHrs.isBefore(hourObj.closeTime)) || hourObj.open24) {
          hoursAddCardMultiC.closedNowAdditional = false;
        } else {
          hoursAddCardMultiC.closedNowAdditional = true;
        }
      } else {
        if ((now.isAfter(hourObj.openTime) && now.isBefore(hourObj.closeTime)) || hourObj.open24) {
          hoursAddCardMultiC.closedNowAdditional = false;
        } else {
          hoursAddCardMultiC.closedNowAdditional = true;
        }
      }
    }

    function parseDateStrings(dateStrs) {
      if(dateStrs) { var intDateStrs = dateStrs.split(";"); }
      return _.map(intDateStrs, function(dateStr) {
        var info = dateStr.split(",");
        if (angular.isDefined(info[1]) && info[1].toUpperCase() === "CLOSED") {
          // return just the day. This way we can use it to determine if today == which hour obj.
          return {
            day: info[0]
          };
        }
        else {
          // Else add open and close times based on the strings.
          // Will moment parse these to more readable strings later.
          return {
            day: info[0],
            openTime: info[1],
            closeTime: info[2]
          };
        }
      });
    }


    /**
     * function generates hours object for each day
     * @param {string} dateStrs open and close times for the week
     * @param {string} closeLabel close label for the location
     * @param {string} isPrimary flag to indicate if the hours are primary/additional
    */
    function generateHours(dateStrs, closeLabel, isPrimary) {
      // Split up the dateStrs and generate objects for each one
      var parsedDateStrs = parseDateStrings(dateStrs);
      var locHours = {};
      _.range(1, 8).forEach(function(day) {
        // Generate base objects per day
        var newHoursObj = {
          day: day.toString(),
          dayName: moment().isoWeekday(day).format("dddd"),
          dayNameShort: moment().isoWeekday(day).format("dd"),
          dayNameShortNext: moment().isoWeekday(day).add(1, 'd').format("dd"),
          closedLabel: closeLabel
        };

        // filter method gets all the matching objects for a certain day of the week
        var parsedData = _.filter(parsedDateStrs, function(obj) {
          return obj['day'] === day.toString();
        });

        // all the open and close time for the store location in an array
        var openTime = _.map(parsedData, 'openTime');
        var closeTime = _.map(parsedData, 'closeTime');
        parsedData = {};
        _.forEach(openTime, function(value, key) {
          //moment js doesn't recognize 2400 hrs
          if (closeTime[key] === '2400') {
            closeTime[key] = '0000';
          }
          parsedData['openTime' + 'PeriodDisplayMessage' + '_' + key] = displayOpenAndClosedTime(openTime[key], closeTime[key]);
          parsedData['openTime' + 'Period' + '_' + key] = openTime[key] ? moment(openTime[key],"hmm").format("LT") : "";
          parsedData['closeTime' + 'Period' + '_' + key] = closeTime[key] ? moment(closeTime[key],"hmm").format("LT") : "";
          parsedData['openTime'] = openTime[0];
          parsedData['closeTime'] = closeTime[0];
          parsedData['numberOfTimeFragments'] = new Array(_.keys(openTime).length);
        });

        //we need the numberOfTimeFragments to display the correct message for the store hours in the directive.html
        if (openTime.length === 0) {
          parsedData['numberOfTimeFragments'] = new Array(1);
        }
        _.assign(newHoursObj, parsedData);
        locHours[day] = createHoursObj(newHoursObj, isPrimary);

        // Check if Today. If so, apply highlighting and modify
        // some controller level variables in a separate function.
        if (day.toString() === moment().format("E")) {
          locHours[day].highlightClass = "bold-700";

          //initialize the open and close time empty arrays
          openTime = [];
          closeTime = [];
          var counter = 0;
          while (counter < locHours[day]['numberOfTimeFragments'].length) {
            var openTimePeriodKey = 'openTimePeriod' + '_' + counter;
            var closeTimePeriodKey = 'closeTimePeriod' + '_' + counter;
            if (locHours[day][openTimePeriodKey] && locHours[day][openTimePeriodKey].length > 0 && locHours[day][closeTimePeriodKey].length > 0) {
              openTime.push(locHours[day][openTimePeriodKey]);
              closeTime.push(locHours[day][closeTimePeriodKey]);
            }
            counter++;
          }

          // when the location does not have hours for the day we
          // assume that it is closed
          if (openTime.length > 0 && closeTime.length > 0) {
            // for current day we store the appropriate message for store close/open hours in the first display message element
            locHours[day].openTimePeriodDisplayMessage = isTheLocationOpen(openTime, closeTime);
          } else {
            locHours[day].closed = true;
          }

          // for current day we store the appropriate message for store close/open hours in the first display message element
          if (isPrimary) {
            updateTodaysHours(locHours[day]);
          }
          else {
            updateTodaysHoursAdditional(locHours[day]);
          }
        }
      });

      return locHours;
    }

    /**
     * function generates the display time message for the different
     * periods/times for which the store is open
     * @param {string} openTime open time for the store
     * @param {string} closeTime close time for the store
    */
    function displayOpenAndClosedTime(openTime, closeTime) {
      var displayTime = "";
      if (openTime && closeTime) {
        displayTime = moment(openTime, "hmm").format("LT") + " " + "-" + " " + moment(closeTime, "hmm").format("LT");
      }
      return displayTime;
    }

    /**
     * function is used to get the current time in the store timezone
     * @param {*} actualStoreTimeZone 
     */
    function getStoreCurrentTime(actualStoreTimeZone){
      var currentStoreDateTime = null;
      var isInvalidObj = checkObj(actualStoreTimeZone);
      if (!isInvalidObj) {
        currentStoreDateTime = angular.isDefined((moment.tz.zone(actualStoreTimeZone))) ? moment.tz(actualStoreTimeZone).format('YYYY-MM-DD LT') : moment().format('YYYY-MM-DD LT');//
      }
      return currentStoreDateTime;
    }

    /**
     * function is used to get the time part from the converted store timezone
     * @param {moment} storeCurrentDateTime 
     */
    function getConvertedStoreHours(storeCurrentDateTime){
      var convertedStoreHours = null;
      var currTimeArr = storeCurrentDateTime.split(" ");
      var isInvalidObj = checkObj(currTimeArr);
      if(!isInvalidObj){ 
        var isInvalidObj1 = checkObj(currTimeArr[1]);
        if(!isInvalidObj1 && currTimeArr.length > 1){
          if (currTimeArr[2]) {
            convertedStoreHours = currTimeArr[1].trim().concat(" ").concat(currTimeArr[2].trim());
          } else {
            convertedStoreHours = currTimeArr[1].trim().concat(" ");
          }
        }
      }
      return convertedStoreHours;
    }

    /**
     * function is used to generate the appropriate messaging for the
     * current day including store open/close times.
     * @param {array} openTime open time for the store for the current day
     * @param {array} closeTime close time for the store for the current day
    */
    function isTheLocationOpen(openTime, closeTime) {
      var amIBetweenFirstGroup = false;
      var amIBetweenSecondGroup = false;
      var amIBetweenThirdGroup = false;
      var storeOpenOrCloseMessage = '';
      var currentTime = moment();
      var displayMessage = '';
      var startTimeFirstGroup = openTime[0] ? moment(openTime[0].trim(), "LT") : hoursAddCardMultiC.closedTodayText;
      var endTimeFirstGroup = closeTime[0] ? moment(closeTime[0].trim(), "LT") : hoursAddCardMultiC.closedTodayText;
      var openTwentyFourHours = false;
      // store timezone code start
      var storeTimeZone = hoursAddCardMultiC.location.store_info.timezone; // store timezone from api
      var storeCurrDateTime = null;
      var convertedStoreHrs = null;
      var isInvalidObj = checkObj(storeTimeZone);
      if (!isInvalidObj) {
        storeCurrDateTime = getStoreCurrentTime(storeTimeZone);
        convertedStoreHrs = moment(getConvertedStoreHours(storeCurrDateTime), "LT");
      } else {
        convertedStoreHrs = currentTime;
      }
      // store timezone code end
      if (openTime.length === 2) {
        var startTimeSecondGroup = moment(openTime[1], "LT");
        var endTimeSecondGroup = moment(closeTime[1], "LT");
      } else if (openTime.length === 3) {
        var startTimeThirdGroup = moment(openTime[2], "LT");
        var endTimeThirdGroup = moment(closeTime[2], "LT");
        startTimeSecondGroup = moment(openTime[1], "LT");
        endTimeSecondGroup = moment(closeTime[1], "LT");
      }


      // check if the close time is on the next date in the A.M.
      if (endTimeFirstGroup.isBefore(startTimeFirstGroup) || moment(closeTime[0], "LT").format('HHmm') === '0000') {
        //open 24 message if the store is open for 24hrs
        if (endTimeFirstGroup.diff(startTimeFirstGroup) === 0) {
          openTwentyFourHours = true;
        }
        // Check the user currentime is before shop close time then subtract 1 day from start date
        // as the shop has started in previous day
        // else add 1 day to end date as the shop will be closing on next day
        if (convertedStoreHrs.isBefore(endTimeFirstGroup)) {
          startTimeFirstGroup = startTimeFirstGroup.subtract(1, 'days');
        } else {
          endTimeFirstGroup = endTimeFirstGroup.add(1, 'days');
        }
      }

      if (openTime.length === 2 && closeTime.length === 2) {
        // check if the close time is on the next date in the A.M.
        if (endTimeSecondGroup.isBefore(startTimeSecondGroup) || moment(closeTime[1], "LT").format('HHmm') === '0000') {
          endTimeSecondGroup = endTimeFirstGroup.add(1, 'days');
        }

        displayMessage = moment(openTime[0], "LT").format("LT") + ' - ' + moment(closeTime[0], "LT").format("LT") + ', ' +
                         moment(openTime[1], "LT").format("LT") + ' - ' + moment(closeTime[1], "LT").format("LT");
        // instead of currentTime object the comparison is made with convertedStoreHrs object
        if (!isInvalidObj) {
          amIBetweenFirstGroup = convertedStoreHrs.isBetween(startTimeFirstGroup, endTimeFirstGroup);
          amIBetweenSecondGroup = convertedStoreHrs.isBetween(startTimeSecondGroup, endTimeSecondGroup);
        } else {
          //earlier implementation
          amIBetweenFirstGroup = currentTime.isBetween(startTimeFirstGroup, endTimeFirstGroup);
          amIBetweenSecondGroup = currentTime.isBetween(startTimeSecondGroup, endTimeSecondGroup);
        }
        if (amIBetweenFirstGroup) {
          storeOpenOrCloseMessage = hoursAddCardMultiC.openNowUntilText +' '+ displayMessage;
        } else if (amIBetweenSecondGroup) {
          storeOpenOrCloseMessage = hoursAddCardMultiC.openNowUntilText +' '+ displayMessage;
        } else {
          storeOpenOrCloseMessage = hoursAddCardMultiC.closedNowText+'. '+hoursAddCardMultiC.todaysHoursText+': '+ displayMessage;
        }
      } else if (openTime.length === 3 && closeTime.length === 3) {
        // if there are three fragments for store hours
        // check if the close time is on the next date in the A.M.
        if (endTimeSecondGroup.isBefore(startTimeSecondGroup) || moment(closeTime[1], "LT").format('HHmm') === '0000') {
          endTimeSecondGroup = endTimeFirstGroup.add(1, 'days');
        }
        // check if the third fragment close time is on the next date in the A.M.
        if (endTimeThirdGroup.isBefore(startTimeThirdGroup) || moment(closeTime[2], "LT").format('HHmm') === '0000') {
          endTimeThirdGroup = endTimeSecondGroup.add(1, 'days');
        }

        displayMessage = moment(openTime[0], "LT").format("LT") + ' - ' + moment(closeTime[0], "LT").format("LT") + ', ' +
                         moment(openTime[1], "LT").format("LT") + ' - ' + moment(closeTime[1], "LT").format("LT") + ', ' +
                         moment(openTime[2], "LT").format("LT") + ' - ' + moment(closeTime[2], "LT").format("LT");
        // time fragment flags
        // instead of currentTime object the comparison is made with convertedStoreHrs object
        if (!isInvalidObj) {
          amIBetweenFirstGroup = convertedStoreHrs.isBetween(startTimeFirstGroup, endTimeFirstGroup);
          amIBetweenSecondGroup = convertedStoreHrs.isBetween(startTimeSecondGroup, endTimeSecondGroup);
          amIBetweenThirdGroup = convertedStoreHrs.isBetween(startTimeThirdGroup, endTimeThirdGroup);
        } else {
          //earlier implementation
          amIBetweenFirstGroup = currentTime.isBetween(startTimeFirstGroup, endTimeFirstGroup);
          amIBetweenSecondGroup = currentTime.isBetween(startTimeSecondGroup, endTimeSecondGroup);
          amIBetweenThirdGroup = currentTime.isBetween(startTimeThirdGroup, endTimeThirdGroup);
        }
        if (amIBetweenFirstGroup) {
          storeOpenOrCloseMessage = hoursAddCardMultiC.openNowUntilText + ' ' + moment(closeTime[0], "LT").format("LT") + ", " + displayMessage;
        } else if (amIBetweenSecondGroup) {
          storeOpenOrCloseMessage = hoursAddCardMultiC.openNowUntilText + ' ' + moment(closeTime[1], "LT").format("LT") + ', ' + displayMessage;

        } else if (amIBetweenThirdGroup) {
          storeOpenOrCloseMessage = hoursAddCardMultiC.openNowUntilText + ' ' + moment(closeTime[2], "LT").format("LT") + ', ' + displayMessage;
        } else {
          storeOpenOrCloseMessage = hoursAddCardMultiC.closedNowText + '. ' + hoursAddCardMultiC.todaysHoursText + ': ' + displayMessage;
        }
      } else {
        // instead of currentTime object the comparison is made with convertedStoreHrs object
        if (!isInvalidObj) {
          amIBetweenFirstGroup = convertedStoreHrs.isBetween(startTimeFirstGroup, endTimeFirstGroup);
        } else {
          // earlier implementation
          amIBetweenFirstGroup = currentTime.isBetween(startTimeFirstGroup, endTimeFirstGroup);
        }

        if (openTwentyFourHours) {
          storeOpenOrCloseMessage = hoursAddCardMultiC.open24Text;
        } else {
          if (amIBetweenFirstGroup) {
            storeOpenOrCloseMessage = hoursAddCardMultiC.openNowUntilText + ' ' + moment(closeTime[0], "LT").format("LT");
          } else {
            storeOpenOrCloseMessage = hoursAddCardMultiC.closedNowText + '. ' + hoursAddCardMultiC.todaysHoursText + ': ' + moment(openTime[0], "LT").format("LT") + ' - ' + moment(closeTime[0], "LT").format("LT");
          }
        }
      }

      return storeOpenOrCloseMessage;
    }

    function generateSpecialHours(dateStrs, isPrimary) {
      // Split up the dateStrs and generate objects for each one
      var parsedDateStrs = parseDateStrings(dateStrs);

      var spHours = [];
      parsedDateStrs.forEach(function(parsedData) {
        parsedData.dayNameShort = parsedData.day;
        parsedData.dayOfTheWeek = moment(parsedData.day, "YYYY-MM-DD").format("E");
        parsedData.closedLabel = "Closed";

        var completeHoursObj = createHoursObj(parsedData);

        if(completeHoursObj.day  === moment().format("YYYY-MM-DD")) {
          completeHoursObj.highlightClass = "bold-700";

          if (isPrimary) {
            //Clear Regular hours highlighting
            _.forEach(hoursAddCardMultiC.regularHours, function (hourObj) {
              if (hourObj.hasOwnProperty("regular")) {
                hourObj.regular.highlightClass = "";
              }
            });

            updateTodaysHours(completeHoursObj);
          }
          else {
            //Clear Additional hours highlighting
            _.forEach(hoursAddCardMultiC.regularHours, function (hourObj) {
              if (hourObj.hasOwnProperty("additional")) {
                hourObj.additional.highlightClass = "";
              }
            });

            updateTodaysHoursAdditional(completeHoursObj);
          }
        }

        if(hoursAddCardMultiC.specialHoursDateFormat) {
          completeHoursObj.dayNameShort = moment(completeHoursObj.dayNameShort, "YYYY-MM-DD").format("MM-DD-YYYY")
        }

        spHours.push(completeHoursObj);
      });

      return spHours;
    }

    /* removed:
     * location.status === 'coming soon' moving to directive.html
     */
    function createHoursObj(hourObj, isPrimary) {
      if (!hourObj.hasOwnProperty("openTime")) {
        return _.assign(hourObj, {"closed": true});
      }
      hourObj.openTime = moment(hourObj.openTime, "HHmm");
      // If close is earlier than openM, then add 1 day to it
      hourObj.closeTime = moment(hourObj.closeTime, "HHmm");
      if (hourObj.closeTime.diff(hourObj.openTime) < 0) {
        hourObj.closeTime.add(1, 'd');
      }

      // Convenience vars so we only need to format or call moment on these once
      hourObj.openDisplayTime = hourObj.openTime.format("LT");
      hourObj.closeDisplayTime = hourObj.closeTime.format("LT");

      // Check if open 24/7 by comparing if diff of open and close time is 0
      hourObj.open24 = (hourObj.openTime.diff(hourObj.closeTime) === 0 ||
                        Math.abs(hourObj.openTime.diff(hourObj.closeTime, 'hours')) === 24);

      // Augment openingHours on controller
      if (isPrimary) {
        hoursAddCardMultiC.openingHours = hoursAddCardMultiC.openingHours +
          hourObj.dayNameShort +
          ' ' +
          hourObj.openDisplayTime +
          ' - ' +
          hourObj.closeDisplayTime +
          ' ';
      }
      else {
        hoursAddCardMultiC.openingHoursAdditional = hoursAddCardMultiC.openingHoursAdditional +
          hourObj.dayNameShort +
          ' ' +
          hourObj.openDisplayTime +
          ' - ' +
          hourObj.closeDisplayTime +
          ' ';
      }
      return hourObj;
    }

    // Takes a datestring and checks if any special days are within 7 days of today
    // Return a list of dates + times that are within 7 days of today
    function checkSpecialHours(dates) {
      //For each date with special hours
      if(dates) { var intNearbyDates = dates.split(";"); }
      var nearbyDates = _.map(intNearbyDates, function(specialDay) {
        //Split on the entry
        var dayData = specialDay.split(",");
        //Check today - specialDay < 7, if matched, return this date!
        var specialDateMoment = moment(dayData[0], "YYYY-M-D");
        var today = moment();
        if (specialDateMoment.diff(today, "days") < 7 &&
          specialDateMoment.diff(today, "days") >= 0) {
          return specialDay;
        }
      });
      return _.compact(nearbyDates).join(";");
    }

    function combineSpecialHours(regularDates, additionalDates) {
      var combinedSpecialHours = {};

      _.forEach(regularDates, function(hourObj) {
        combinedSpecialHours[hourObj.dayNameShort] = {
          "regular" : hourObj
        }
      });

      _.forEach(additionalDates, function(hourObj) {
        if (combinedSpecialHours[hourObj.dayNameShort]) {
          combinedSpecialHours[hourObj.dayNameShort]["additional"] = hourObj;
        }
        else {
          combinedSpecialHours[hourObj.dayNameShort] = {
            "additional": hourObj
          }
        }
      })
      var orderedSpecialHours = {};
      Object.keys(combinedSpecialHours).sort().forEach(function(key) {
        orderedSpecialHours[key] = combinedSpecialHours[key];
      });

      return orderedSpecialHours;
    }

    function combineRegularHours(regularDates, additionalDates) {
      var combinedRegHours = {};

      _.forEach(regularDates, function(hourObj) {
        combinedRegHours[hourObj.day] = {
          "regular" : hourObj,
          "day" : hourObj.dayName
        }
      });

      _.forEach(additionalDates, function(hourObj) {
        if (combinedRegHours[hourObj.day]) {
          combinedRegHours[hourObj.day]["additional"] = hourObj;
        }
        else {
          combinedRegHours[hourObj.day] = {
            "additional": hourObj,
            "day" : hourObj.dayName
          }
        }
      })
      var orderedRegHours = {};
      Object.keys(combinedRegHours).sort().forEach(function(key) {
        orderedRegHours[combinedRegHours[key]["day"]] = combinedRegHours[key];
      });

      return orderedRegHours;
    }

    // Primary Regular Hours
    var checkHoursFormat = /^[0-9;,closedCLOSED]+$/;
    var sh = (hoursAddCardMultiC.location &&
              hoursAddCardMultiC.location.store_info) ?
      s(hoursAddCardMultiC.location.store_info.store_hours).trim(";").value() : null;
    sh = sh.replace(/[^0-9;,closedCLOSED]/g,'');
    sh = sh.trim();

    var regularHours = null;
    var primaryAdditionalHours = null;
    var regularSpecialHours = null;
    var additionalSpecialHours = null;

    // Primary Regular Hours

    // Check if there are store hours listed. If not, show all days as "Closed"
    if (hoursAddCardMultiC.location.store_info.store_hours == '') {
      regularHours = generateHours(sh, hoursAddCardMultiC.closedText, true);
      hoursAddCardMultiC.hasPrimary = true;
    }
    if (sh && checkHoursFormat.test(sh)) {
      regularHours = generateHours(sh, hoursAddCardMultiC.closedText, true);
      hoursAddCardMultiC.hasPrimary = true;
    }
    // Additional Regular Hours
    var findAdditionalHours = customFieldFactory.getTranslatedValueByName(hoursAddCardMultiC.location.custom_fields, 'hours_additional', language);
    if(findAdditionalHours) {
      var additionalHoursStr = findAdditionalHours ? s(findAdditionalHours).trim(";").value() : null;
      hoursAddCardMultiC.hasAdditional = additionalHoursStr ? true : false;
      if(hoursAddCardMultiC.hasAdditional) { primaryAdditionalHours = generateHours(additionalHoursStr, hoursAddCardMultiC.closedText, false); }
      
    }

    // Combine Regular Hours
    if (regularHours || primaryAdditionalHours) {
      hoursAddCardMultiC.regularHours = combineRegularHours(regularHours, primaryAdditionalHours);
    }
    // Primary Special Hours
    var primarySpecialHours = (hoursAddCardMultiC.location &&
      hoursAddCardMultiC.location.store_info &&
      hoursAddCardMultiC.location.store_info.special_hours) ?
      s(hoursAddCardMultiC.location.store_info.special_hours).trim(";").value() : null;
    if (primarySpecialHours !== null) {
      // Check if any special hours are coming up.
      var validSpecialHours = checkSpecialHours(primarySpecialHours);
      if (!_.isEmpty(validSpecialHours)) {
        // For each special day, format it for display like normal hours.
        regularSpecialHours = generateSpecialHours(validSpecialHours, true);
        hoursAddCardMultiC.hasPrimarySpecial = true;
      }
    }

    // Additional Special Hours
    var findAdditionalSpecialHours = customFieldFactory.getTranslatedValueByName(hoursAddCardMultiC.location.custom_fields, 'hours_additional_special', language);
    if(findAdditionalSpecialHours) {

      var additionalSpecialHoursStr = findAdditionalSpecialHours ? s(findAdditionalSpecialHours).trim(";").value() : null;
      var validAdditionalSpecialHours = checkSpecialHours(additionalSpecialHoursStr);
      hoursAddCardMultiC.hasAdditionalSpecial = validAdditionalSpecialHours ? true : false;
      if (!_.isEmpty(validAdditionalSpecialHours)) {
        // For each special day, format it for display like normal hours.
        additionalSpecialHours = generateSpecialHours(validAdditionalSpecialHours, false);
      }
    }

    // Combine Special Hours
    if (regularSpecialHours || additionalSpecialHours) {
      hoursAddCardMultiC.specialHours = combineSpecialHours(regularSpecialHours, additionalSpecialHours);
    }
    hoursAddCardMultiC.hoursNote = customFieldFactory.getTranslatedValueByName(hoursAddCardMultiC.location.custom_fields, 'hours_note', language);

    // If regular hours have special hours but additional hours do not

    hoursAddCardMultiC.getStandardAddtlHours = function(dayOfTheWeek) {
      return generateHours(additionalHoursStr, hoursAddCardMultiC.closedText, false)[dayOfTheWeek].openTimePeriodDisplayMessage_0 || hoursAddCardMultiC.closedText
    }


    hoursAddCardMultiC.getStandardRegHours = function(dayOfTheWeek) {
      var days = Object.entries(hoursAddCardMultiC.regularHours)
      var specialDay = days.filter(function(d) {
        return d[1].regular.day == dayOfTheWeek
      })

      return specialDay[0][1].regular.openTimePeriodDisplayMessage_0 || hoursAddCardMultiC.closedText
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('storeLocator')
    .directive('fbWidgetCardMulti', fbWidgetCardMulti);

  function fbWidgetCardMulti() {

    return {
      replace: true,
      scope: {
        location: '=',
        clientName: '=',
        brandUrl: '@'
      },
      templateUrl: 'app/localLanding/cards/multilingual/fbWidgetCardMulti.directive.html',
      restrict: 'AE',
      bindToController: { translatedMessages: '=' },
      controller: function ($filter, $timeout, $scope, $window) {

        var vm = this;
        //multilingual variables
        vm.faceBookGeneralTitleText = vm.translatedMessages['mf.localPage.social.facebook.generalTitle'] || 'Like us on Facebook';

        if ($scope.brandUrl) {
          vm.fbProviderUrl = $scope.brandUrl;
        } else {
          vm.fbProviders = _.filter($scope.location.store_info.providers, function (obj) {
            return obj._type === "Facebook" && obj.master;
          });
          if (vm.fbProviders.length > 0) {
            vm.fbProviderUrl = vm.fbProviders[0].url;
          }
        }
        angular.element($window).bind('resize', function () {
          vm.windowWidth = $window.innerWidth;
          $timeout(function () {
            changeFBPagePlugin(vm.fbProviderUrl)
          }, 500);
          $scope.$digest();
        });

        function changeFBPagePlugin(url) {
          //getting parent box width
          var container_width = Number($('.fb-widget-container').width()).toFixed(0);
          var container_height = Number($('.fb-widget-container').height()).toFixed(0);
          if (!isNaN(container_width) && !isNaN(container_height)) {
            $(".fb-page").attr("data-width", container_width).attr("data-height", container_height);
          }
          if (url) {
            $(".fb-page").attr("data-href", url);
          }
          if (typeof FB !== 'undefined') {
            FB.XFBML.parse();
          }
        }

        //initial card load requires call to FB.XFBML.parse to render per page
        $timeout(function () {
          changeFBPagePlugin(vm.fbProviderUrl)
        }, 1000);
      }
      ,
      controllerAs: 'fbWidgetCardMultiC'
    };
  }
})();

(function () {
    'use strict';

    angular
      .module('storeLocator')
      .directive('amenitiesCardMulti', amenitiesCardMulti);

    function amenitiesCardMulti() {
        return {
            replace: true,
            scope: {
                customFields: '=',
                defaultImage: '@',
                displayInOneLine: '@',
                title: '@',
                client: '@',
                customContent: '@',
                translatedMessages: '='
            },
            templateUrl: 'app/localLanding/cards/multilingual/amenitiesCardMulti.directive.html',
            restrict: 'AE',
            controller: amenitiesCardMultiController,
            controllerAs: 'amenitiesCardMultiC',
            bindToController: true
        };
    }

    function amenitiesCardMultiController(amenitiesService, $filter, $sce, storeLocatorCache) {
        var vm = this;
        vm.amenities = [];
        vm.amenitiesWithIcons = [];
        vm.amenitiesWithNoIcons = [];
        //multilingual variables
        vm.amenitiesText = vm.translatedMessages['mf.localPage.amenities.title'] || 'Amenities';
        var language = storeLocatorCache.get('storeFindersMessages').lang;

        if (typeof vm.title === 'undefined') {
            vm.title = vm.amenitiesText;
        }

        if (vm.customFields) {
            if(vm.customContent){
              var amenities = amenitiesService.getContents(vm.customFields, vm.customContent, language);
              vm.hasAmenities = amenities !== null && amenities.length > 0;
              vm.amenities = amenities;
              amenities.forEach(function (amenity) {
                  amenity.nameAmenity = $sce.trustAsHtml(amenity.data);
                  vm.amenitiesWithNoIcons.push(amenity);
              });
            }
            else{
              var amenities = amenitiesService.getAmenities(vm.customFields);
              vm.hasAmenities = amenities !== null && amenities.length > 0;
              vm.amenities = amenities;

              amenities.forEach(function (amenity) {
                if (amenity.tooltip === '') {
                  amenity.nameAmenity = $sce.trustAsHtml(amenity.data);
                  vm.amenitiesWithNoIcons.push(amenity);
                } else {
                  amenity.nameAmenity = $sce.trustAsHtml(amenity.tooltip);
                  vm.amenitiesWithIcons.push(amenity);
                }
              });
            }
        }
    }
})();

(function() {
  'use strict';

  angular
    .module('storeLocator')
    .directive('addressCardMulti', addressCardMulti);

  function addressCardMulti () {

    return {
      replace: true,
      transclude: true,
      scope: {
        location: '=',
        collapseAddress: '@',
        nameExtended: '@',
        customStoreName: '@',
        customButtonField: '@',
        customButtonText: '@',
        customButton2Field: '@',
        customButton2Text: '@',
        addressLink: '@',
        addressLinkTitle: '@',
        hideGetDirections: '=?', // Optional param for whether to show the "Get Directions" button.
        gtmOnClick: '=',
        deliveryModalExtendedDelivery: '=',
        altPhone: '@'
      },
      templateUrl: 'app/localLanding/cards/multilingual/addressCardMulti.directive.html',
      restrict: 'AE',
      controller: addressCardMultiController,
      controllerAs: 'addressCardMultiC',
      bindToController: { altPhoneTitle: '=', mainPhoneTitle: '=', translatedMessages: '=' }
      }
  }
      function addressCardMultiController($scope, customFieldFactory, storeLocatorCache) {
        var vm = this;
        vm.showGetDirections = true;
        vm.storeSEOName = $scope.location.store_info.name;
        //multilingual variables
        vm.tempClosedText = vm.translatedMessages['mf.location.tempClosed.displayText'] || 'This location is temporarily closed';
        vm.comingSoonText = vm.translatedMessages['mf.location.comingSoon.displayTex'] || 'This Location is Coming Soon';
        vm.getDirectionsText = vm.translatedMessages['mf.cta.getDirectionsButton.text'] || 'Get Directions';
        vm.viewTheMenuText = vm.translatedMessages['mf.cta.menuButton.tooltip'] || 'View the Menu';
        vm.callText = vm.translatedMessages['infowindow.call'] || 'Call';
        var language = storeLocatorCache.get('storeFindersMessages').lang;
        
        if ($scope.hideGetDirections) {
          vm.showGetDirections = false;
        }

        vm.statusFlag = '';

        if ($scope.location.status == "coming soon"){
          vm.statusFlag = vm.comingSoonText;
        }
        else if ($scope.location.status == "temp closed"){
          vm.statusFlag = vm.tempClosedText;
        }

        vm.directionsUrl = $scope.location.store_info.directionsUrl;

        if ($scope.customStoreName) {
            var findName = customFieldFactory.getTranslatedValueByName($scope.location.custom_fields, $scope.customStoreName, language);
            vm.storeName = findName ? findName : $scope.location.store_info.name;
        } else {
            vm.storeName = $scope.location.store_info.name;
        }

        if ($scope.nameExtended && $scope.nameExtended.includes('[')) {
          var arr = $scope.nameExtended.substr(1, $scope.nameExtended.length - 2).split(',');
          var nameExtendedConfig = [];
          arr.forEach(function(item) {
            item = customFieldFactory.getTranslatedValueByName($scope.location.custom_fields, item, language); 
            if(item) nameExtendedConfig.push(item);
          })
          nameExtendedConfig.length > 0 ? vm.nameExtendedConfig = nameExtendedConfig : vm.nameExtended = customFieldFactory.getTranslatedValueByName($scope.location.custom_fields, 'name_extended', language)
        } else if ($scope.nameExtended && !$scope.nameExtended.includes('[')) {
          vm.nameExtendedConfig = customFieldFactory.getTranslatedValueByName($scope.location.custom_fields, $scope.nameExtended, language);
        } else if(!$scope.nameExtended) {
          var name = customFieldFactory.getTranslatedValueByName($scope.location.custom_fields, 'name_extended', language);
          if(name) vm.nameExtended = name;
        }

        vm.menuLink = customFieldFactory.getTranslatedValueByName($scope.location.custom_fields, 'menulink', language)
        var orderLink = customFieldFactory.getTranslatedValueByName($scope.location.custom_fields, 'online_order_link', language);
        var onlineLink = customFieldFactory.getTranslatedValueByName($scope.location.custom_fields, 'order_online_link', language);
        if (orderLink) {
          vm.onlineOrderLink = orderLink;
        } else if (onlineLink) {
          vm.onlineOrderLink = onlineLink; 
        }
        vm.customButtonLink = customFieldFactory.getTranslatedValueByName($scope.location.custom_fields, $scope.customButtonField, language);
        var customButtonText = customFieldFactory.getTranslatedValueByName($scope.location.custom_fields, $scope.customButtonText, language);
        vm.customButtonText = customButtonText ? customButtonText : $scope.customButtonText;

        vm.customButton2Link = customFieldFactory.getTranslatedValueByName($scope.location.custom_fields, $scope.customButton2Field, language);
        var customButton2Text = customFieldFactory.getTranslatedValueByName($scope.location.custom_fields, $scope.customButton2Text, language);
        vm.customButton2Text = customButton2Text ? customButton2Text : $scope.customButton2Text;

        if($scope.collapseAddress){
        vm.addressExtended = $scope.location.store_info.address+" "+$scope.location.store_info.address_extended;
        }
        
        //Populating alternatie phone number
        if($scope.location.custom_fields) {
          var findAltPhone = customFieldFactory.getTranslatedValueByName($scope.location.custom_fields, $scope.altPhone, language);
          if(findAltPhone) {
            vm.altPhone = findAltPhone ? findAltPhone : findAltPhone ;
          }
        }
        
        if($scope.gtmOnClick == true) {
          window.onload = function() {
            var getDirectionsBtn = document.getElementsByClassName('get-directions')
            var deliveryModal = document.getElementsByClassName('delivery-modal')
            if(getDirectionsBtn[0]) {
              getDirectionsBtn[0].addEventListener('click', function() {
                getDirectionsLLP($scope.location.store_info.corporate_id)
              })
            }
            if(deliveryModal[0]) {
              deliveryModal[0].addEventListener('click', function() {
                deliveryModalLLP($scope.location.store_info.corporate_id)
              })
            }
          }
        }

      }
})();

(function() {
	'use strict';

	angular
		.module('storeLocator')
		.directive('aboutCardMulti', aboutCardMulti);

	function aboutCardMulti() {

		return {
			replace: true,
			scope: {
			    location: '=',
                title: '@',
				translatedMessages: '='
			},
			templateUrl: 'app/localLanding/cards/multilingual/aboutCardMulti.directive.html',
			restrict: 'AE',
			controller: aboutCardMultiController,
			controllerAs: 'aboutCardMultiCtrl',
			bindToController: true
		};
	}

	function aboutCardMultiController($sce) {
	    var aboutCardMultiCtrl = this;
		//multilingual variables
        aboutCardMultiCtrl.aboutText = aboutCardMultiCtrl.translatedMessages['mf.localPage.about.card'] || 'About';
		
	    if (typeof aboutCardMultiCtrl.title === 'undefined') {
	        aboutCardMultiCtrl.hasTitle = false;
	    } else {
	        aboutCardMultiCtrl.hasTitle = true;
	    }

	    if (!_.isUndefined(aboutCardMultiCtrl.location.description)) {
	        aboutCardMultiCtrl.description = $sce.trustAsHtml(aboutCardMultiCtrl.location.description);
	    }
	}

})();

(function () {
  'use strict';

  angular
    .module('storeLocator')
    .directive('featuredProductsCard', featuredProductsCard);

  function featuredProductsCard() {
    return {
      replace: true,
      scope: {
        location: '=',
        layout: '=',
        client: '='
      },
      templateUrl: 'app/localLanding/cards/aaa/featuredProductsCard.directive.html',
      restrict: 'AE',
      controller: featuredProductsCardController,
      controllerAs: 'cardCtrl',
      bindToController: true
    };
  }

  function featuredProductsCardController(customFieldFactory) {
    var vm = this;
    vm.getCustomFieldValueByName = getCustomFieldValueByName;
    vm.featuredProductsCustomFieldsArray = [];
    vm.openQuoteFormModal = openQuoteFormModal;
    vm.showCTALink = showCTALink;
    vm.showCTAModal = showCTAModal;
    vm.showModal = false;
    vm.recipientEmail = getCustomFieldValueByName(vm.location.custom_fields,'locator_quote_email');
    vm.getQuote = 'Get a Quote';

    var featuredProductsCustomFields = vm.location.custom_fields.filter(function (field) {
      return field.name.startsWith('locator_product_image_');
    });

    var featuredProductsCount = customFieldFactory.getFieldCountByRegex(featuredProductsCustomFields, new RegExp(/^locator_product_image_\d+_source$/));
    for (var i = 1; i <= featuredProductsCount; i++) {
      var featuredProduct = {};
      featuredProduct['source'] = getCustomFieldValueByName(featuredProductsCustomFields, 'locator_product_image_' + i + '_source')
      featuredProduct['title'] = getCustomFieldValueByName(featuredProductsCustomFields, 'locator_product_image_' + i + '_title')
      featuredProduct['text_custom_field_name'] = 'locator_product_image_' + i + '_text';
      featuredProduct['button_text'] = getCustomFieldValueByName(featuredProductsCustomFields, 'locator_product_image_' + i + '_button_text')
      featuredProduct['button_link'] = getCustomFieldValueByName(featuredProductsCustomFields, 'locator_product_image_' + i + '_button_link')
      vm.featuredProductsCustomFieldsArray.push(featuredProduct);
    }

    function getCustomFieldValueByName(cutomFields, name) {
      return customFieldFactory.getValueByName(cutomFields || vm.location.custom_fields, name);
    }

    function openQuoteFormModal() {
      if(vm.recipientEmail){
        vm.showModal = true;
      }
    }

    function showCTALink(featuredProduct) {
      var hasButtonLinkOrText = featuredProduct.button_link || featuredProduct.button_text;
      var isNotGetQuoteOrBranchLayout = featuredProduct.button_text !== vm.getQuote || vm.layout === 'branch';
      return (hasButtonLinkOrText && isNotGetQuoteOrBranchLayout) || vm.client === 'meemic'; 
    }

    function showCTAModal(featuredProduct) {
      var hasButtonLinkOrText = featuredProduct.button_link || featuredProduct.button_text;
      var isGetQuoteAndAgentBranch = featuredProduct.button_text === vm.getQuote && vm.layout !== 'branch';
      return hasButtonLinkOrText && isGetQuoteAndAgentBranch && vm.client !== 'meemic';
    }
  }
})();

(function () {
  "use strict";

  angular
    .module('storeLocator')
    .directive('agentInfoAaa', agentInfoAaaDirective);

    function agentInfoAaaDirective() {
      return {
        replace: true,
        scope: {
          location: '=',
          aaaType: '@', // meemic or acg
          quoteCtaTextCustomField: '@',
          showDescription: '=',
          showAddressExtended: '=',
          hideAddress: '=',
          descriptionCustomField: '@',
          showQuoteModal: '=',
          showContactUsModal: '=',
          directionIconClickableOnDesktop: '=',
          directionTextClickableOnDesktop: '=',
          subject: '@', // optional
        },
        templateUrl: 'app/localLanding/cards/aaa/agentInfoAaa.directive.html',
        restrict: 'AE',
        controller: agentInfoAaaController,
        controllerAs: 'agentInfoCtrl'
      };
    }
    function agentInfoAaaController(urlBuilderFactory, customFieldFactory, $scope, $window) {
      var vm = this;
      vm.getDirectionsUrl = getDirectionsUrl;
      vm.getCustomFieldValueByName = getCustomFieldValueByName;
      vm.openContactUsFormModal = openContactUsFormModal;
      vm.showContactUsFormModal = false;
      vm.openQuoteFormModal = openQuoteFormModal;
      vm.showQuoteFormModal = false;
      vm.recipientEmail = getCustomFieldValueByName($scope.location.custom_fields,'locator_quote_email');
      vm.quoteLink = getCustomFieldValueByName($scope.location.custom_fields,'locator_product_image_1_button_link');
      vm.storeName = getCustomFieldValueByName($scope.location.custom_fields, 'store_name') || $scope.location.store_info.name;

      vm.getImageRoute = getImageRoute;
      const meemicType = 'meemic';
      const acgType = 'acg';
      const agentType = $scope.aaaType === meemicType ? meemicType : acgType;

      function getDirectionsUrl(data, isClickable) {
        if ($window.innerWidth >= 768) {
          if(isClickable){
            return urlBuilderFactory.getDirectionsUrl(data);
          } else {
            return '';
          }
        } else {
          return urlBuilderFactory.getDirectionsUrl(data);
        }
      }

      function getCustomFieldValueByName(customFields, name) {
        return customFieldFactory.getValueByName(customFields || vm.location.custom_fields, name);
      }

      function openContactUsFormModal() {
        if ($scope.showContactUsModal && vm.recipientEmail) {
          vm.showContactUsFormModal = true;
        } else if ($scope.location.store_info.email) {
          var subject = $scope.subject || '';
          var mailtoLink = 'mailto:' + $scope.location.store_info.email + '?subject=' + encodeURIComponent(subject);
          $window.open(mailtoLink, '_blank');
        }
      }

      function openQuoteFormModal() {
        if ($scope.showQuoteModal && vm.recipientEmail) {
          vm.showQuoteFormModal = true;
        } else {
          if (vm.quoteLink) {
            if (!vm.quoteLink.startsWith('http://') && !vm.quoteLink.startsWith('https://')) {
                vm.quoteLink = 'http://' + vm.quoteLink;
            }
            $window.open(vm.quoteLink, '_blank');
          }
        }
      }

      function getImageRoute(iconName) {
        return 'assets/images/clients/americanautomobileassociation' + agentType + '/' + iconName;
      }

    }
    })();

(function () {
  'use strict';

  angular
    .module('storeLocator')
    .directive(
      'aboutAaa',
      function aboutAaaDirective(customFieldFactory) {
        return {
          replace: true,
          restrict: 'E',
          scope: {
            location: '=',
            customFieldDescriptionText: '@',
            customFieldDescriptionTitle: '@',
            customFieldDescriptionImage: '@',
          },
          controller: function ($scope, $sce) {
            if (angular.isArray($scope.location.custom_fields)) {
              $scope.title = customFieldFactory.getValueByName($scope.location.custom_fields,$scope.customFieldDescriptionTitle) || "About " + $scope.location.store_info.name;
              $scope.description = $sce.trustAsHtml(customFieldFactory.getValueByName(
                $scope.location.custom_fields, 
                $scope.customFieldDescriptionText
              ));
            }
          },
          templateUrl:
            'app/localLanding/cards/aaa/aboutAaa.directive.html',
        };
      }
    );
})();

(function () {
  'use strict';

  angular
    .module('storeLocator')
    .controller('templateController', templateController);

  function templateController(customFieldFactory, $sce, $window, $scope, HAM_NAV_DATA, HAM_NAV_TOGGLE, storeLocatorCache, LanguageService, DEFAULT_LANGUAGE, burberryFilterService, $rootScope, SUPPORTED_LANGUAGES, CTA_CONTACT_BURBERRY, LANGUAGE_MODAL, $modal, ENV) {
    var vm = this;
    vm.currentDate = new Date();
    vm.getCustomFieldValueByName = getCustomFieldValueByName;
    vm.hasCustomFieldValue = hasCustomFieldValue;
    vm.getCustomButtonCount = getCustomButtonCount;
    vm.getCustomImageCount = getCustomImageCount;
    vm.toggleFooter = toggleFooter;
    vm.toggleMobileMenu = toggleMobileMenu;
    vm.validateEmailInput = validateEmailInput;
    vm.openSignUpModal = openSignUpModal;
    vm.baseUrl = $window.location.href;
    vm.hamNavData = HAM_NAV_DATA;
    vm.hamNavToggle = HAM_NAV_TOGGLE;
    vm.backToTop = backToTop;
    vm.getStoreTypeFromTags = getStoreTypeFromTags;
    vm.getBasePath = getBasePath;
    vm.getAboutTextByLanguage = getAboutTextByLanguage;
    vm.openChangeLanguageModal = openChangeLanguageModal;
    vm.closeChangeLanguageModal = closeChangeLanguageModal;
    vm.getTextTranslationByKey = getTextTranslationByKey;
    vm.getCtaContactText = getCtaContactText;
    vm.getSitemapLevelsForLPBreadcrumb = getSitemapLevelsForLPBreadcrumb;

    var popUpModal = $modal(
      {
        templateUrl: 'app/custom/clients/burberry/directives/changeLanguage.modal.html',
        controller: 'templateController',
        placement: 'center',
        windowClass: 'center',
        show: false,
        scope: $scope
    });

    if (!$window.location.pathname.includes('site-map')) {
      setUpSnowberryTracker();
    }

    $scope.$on('$locationChangeSuccess', function () {
      scrollFunction();
      if (!$window.location.pathname.includes('site-map')) {
        setUpSnowberryTracker();
      }
    });

    function getCustomButtonCount(customFields) {
      return customFieldFactory.getButtonCount(customFields);
    }

    function getCustomImageCount(customFields) {
      return customFieldFactory.getImageCount(customFields);
    }

    function getCustomFieldValueByName(customFields, name) {
      var value = customFieldFactory.getValueByName(customFields, name);
      return $sce.trustAsHtml(value);
    }

    function hasCustomFieldValue(customFields, name) {
      return customFieldFactory.getValueByName(customFields, name) ? true : false;
    }

    function backToTop() {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    }

    var filtersSetListener = null;
    
    function getStoreTypeFromTags(tags) {
      filtersSetListener = $rootScope.$on('filtersSet', function(event, data) {
        return burberryFilterService.getLocationStoreType(tags, data.filters);
      });
    }

    function getBasePath() {
      return window.location.origin;
    }

    window.onscroll = function() {scrollFunction()};
    vm.lastScroll = 0;

    function scrollFunction() {
      var header = document.getElementById('header');
      if (document.documentElement.scrollTop < vm.lastScroll || vm.lastScroll === 0) {
        header.style.transform = 'translateY(0)';
      } else {
        header.style.transform = 'translateY(-100px)';
      }

      var scrollBtn = document.getElementById('scrollBtn');
      if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
        scrollBtn.style.display = "block";
      } else {
        scrollBtn.style.display = "none";
      }
      vm.lastScroll = document.documentElement.scrollTop === 0 ? 0 : document.documentElement.scrollTop;
    }

    function validateEmailInput() {
      var emailInput = document.getElementById('footer-email');
      var emailInputWrapper = document.querySelector('.email-input-wrapper');
      var emailInputLabel = document.getElementById('footer-email-label');
      var errorContainer = document.getElementById('footer-email-error');
      var submitButton = document.getElementById('email-submit');
      // Change to the correct validation regex
      if (emailInput.value === '') {
        // Change to the correct label according to the error
        errorContainer.innerText = 'Please complete this field';
        errorContainer.style.display = 'block';
        submitButton.style.display = 'flex';
        emailInputWrapper.style.setProperty('--background-color', '#EA1722FF');
      } else {
        emailInputLabel.style.transform = 'translate(0, 0) scale(1)';
        emailInputLabel.style.fontSize = '1.4rem';
        errorContainer.innerText = '';
        errorContainer.style.display = 'none';
        emailInputWrapper.style.setProperty('--background-color', '#000000');
      }
    }

    function openSignUpModal() {
      var emailInput = document.getElementById('footer-email');
      // Change to the correct validation regex
      if (emailInput.value === '') {
        emailInput.focus();
      } else {

      }
    }

    function toggleMobileMenu() {
      var mobileMenu = document.getElementById('mobile-menu');
      mobileMenu.style.display = mobileMenu.style.display === 'none' ? 'block' : 'none';
      document.body.style.overflow = mobileMenu.style.display === 'none' ? 'auto' : 'hidden';
    }

    function toggleFooter(menuItemId) {
      var menuItem = document.getElementById(menuItemId);
      if (menuItem.classList.contains('expanded')) {
        collapse(menuItem)
      } else {
        var otherExpandedElement = document.getElementsByClassName('expanded');
        if (otherExpandedElement.length === 1) {
          collapse(otherExpandedElement[0]);
        }
        expand(menuItem);
      }
    }

    function collapse(element) {
      var icon = document.querySelector('#' + element.id + ' svg');
      var elementList = document.querySelector('#' + element.id + '-list > ul');
      element.classList.remove('expanded');
      element.setAttribute('aria-expanded', 'false');
      elementList.style.height = '0';
      icon.style.transform = 'rotate(270deg)';
    }

    function expand(element) {
      var icon = document.querySelector('#' + element.id + ' svg');
      var elementList = document.querySelector('#' + element.id + '-list > ul');
      var listHeight = _.toArray(elementList.children).reduce(function(acc, listItem) {
        return acc + listItem.offsetHeight;
      }, 0);
      element.classList.add('expanded');
      element.setAttribute('aria-expanded', 'true');
      elementList.style.height = listHeight + 'px';
      icon.style.transform = 'rotate(450deg)';
    }

    function setUpSnowberryTracker() {
      var cookieConsent = decodeURIComponent(getCookie("OptanonConsent"));
      var canAppendTacking = cookieConsent && cookieConsent.indexOf('C0002:1') !== -1;
      if (canAppendTacking) {
        addSnowBerryNamespace();
        appendSnowberryTracker();
        appendTrackerEntities();
      } else {
        addWhenNewConsent();
      }
    }

    function addWhenNewConsent() {
      var iteration = 0;
      var interval = setInterval(function() {
        if (window.Optanon || iteration === 30) {
          if (window.Optanon) {
            window.Optanon.OnConsentChanged(function(e) {
              if (e.detail.indexOf('C0002') !== -1) {
                addSnowBerryNamespace();
                appendSnowberryTracker();
                appendTrackerEntities();
              }
            });
          }
          clearInterval(interval);
        } else {
          iteration++;
        }
      }, 300);
    }

    function addSnowBerryNamespace() {
      var script = document.createElement('script');
      script.type = 'text/javascript';
      script.async = 1;
      script.text = ';(function(p,l,o,w,i,n,g){if(!p[i]){p.GlobalSnowberryNamespace=p.GlobalSnowberryNamespace||[];p.GlobalSnowberryNamespace.push(i);p[i]=function(){(p[i].q=p[i].q||[]).push(arguments) };p[i].q=p[i].q||[];n=l.createElement(o);g=l.getElementsByTagName(o)[0];n.async=1;n.src=w;g.parentNode.insertBefore(n,g)}}(window, document, "script", "//dabs7b6g7t59l.cloudfront.net/v3.1.4/3c8ksv.js", "snowberry"));';
      document.body.prepend(script);
    }

    function appendSnowberryTracker() {
      var isProd = window.location.origin.indexOf('localhost') === -1 && window.location.origin.indexOf('llp.qa') === -1;
      var trackerUrl = isProd ? '//dc.apps.burberry.com' : '//com-burberry-prod1.mini.snplow.net';

      window.snowberry('newTracker', 'master', trackerUrl, {
        appId: 'com',
        platform: 'web',
        cookieDomain: '.burberry.com',
        cookieName: '_sp_',
        cookieSameSite: 'Lax',
        cookieSecure: true,
        encodeBase64: true,
        eventMethod: 'post',
        sessionCookieTimeout: 1800,
        bufferSize: 1,
        maxPostBytes: 40000,
        cookieLifetime: 31536000,
        stateStorageStrategy: 'cookieAndLocalStorage',
        maxLocalStorageQueueSize: 100,
        resetActivityTrackingOnPageView: true,
        connectionTimeout: 5000,
        contexts: {
          performanceTiming: true,
          webPage: true,
          gaCookies: true,
          optimizelyXSummary: true
        }
      });
    }

    function appendTrackerEntities() {
      var entities = [];
      var burberryIdCookie = getCookie('burberryId') ? getCookie('burberryId').split('_') : [];
      var engTitle = $window.location.pathname.split('/').length > 3 ? 'Store Page' : 'Store Locator Page';
      var page = {
        schema: "iglu:com.burberry/page_entity/jsonschema/1-0-4",
        data: {
          app: "Uberall",
          appVersion: "1",
          storeCountry: "United States",
          storeCountryCode: "US",
          currency: "USD",
          language: "en-US",
          engPath: $window.location.pathname,
          engTitle: engTitle,
          pageType: "STORE_LOCATOR"
        }
      }
      var user = {
        schema: "iglu:com.burberry/user_entity/jsonschema/1-0-4",
        data: {
          user: getCookiePartValue(burberryIdCookie, 0),
          user_ga: getGa(getCookie('_ga')),
          logged_in: !!getCustomer(burberryIdCookie),
          customer: getCustomer(burberryIdCookie),
          lps_id: getCookie('LPSID-6899673'),
          lpv_id: getCookie('LPVID'),
          fas_id: getCookie('fita.sid.burberry'),
          cs_id: getCookie('brbry-cross-session'),
          o_id: getQueryValue('o_id'),
          consent_groups: ",C0001,C0003,C0002,C0004,"
        }
      }
      entities.push(page,user);
      window.entities = entities;
      window.snowberry('setUserId', getCustomer(burberryIdCookie));
      window.snowberry('trackPageView', { context: entities });
    }

    function getCookie(name) {
      var value = "; " + document.cookie;
      var parts = value.split("; " + name + "=");
      if (parts.length === 2) return parts.pop().split(";").shift();
      return null;
    }

    function getCookiePartValue(cookie, part) {
      return cookie[part] && cookie[part] !== 'NULL' ? cookie[part] : null;
    }

    function getCustomer(burberryIdCookie) {
      return getCookiePartValue(burberryIdCookie, 1) || getQueryValue('mi_u') || getQueryValue('c_id') || null;
    }

    function getGa(gaCookie) {
      if (!gaCookie) {
        return null;
      }
      var parts = gaCookie.split('.');
      return parts[2] + '.' + parts[3];
    }

    function getQueryValue(query) {
      var searchParam = $window.location.search.split(query + '=');
      return searchParam.length === 2 ? searchParam[1] : null;
    }

    //Fix for svg href from header
    $scope.$on('$locationChangeStart', function (event, next, current) {
      if (current !== next) {
        $scope.currentLang = storeLocatorCache.get('language') || DEFAULT_LANGUAGE;
        vm.baseUrl = $sce.trustAsResourceUrl(next);
      }
    });

    $scope.changeLanguage=function(lang){
      LanguageService.changeLanguage(lang);
    }

    var language = storeLocatorCache.get('language') || DEFAULT_LANGUAGE;
    $scope.currentLang = language;

    function openChangeLanguageModal() {
      popUpModal.$promise.then(popUpModal.show());
      var modalBackdrop = document.querySelector('.modal-backdrop');
      modalBackdrop.classList.remove('fade-out');
    }

    function closeChangeLanguageModal() {
      var modalDialog = document.querySelector('#language-modal > .modal-dialog');
      var modalBackdrop = document.querySelector('.modal-backdrop');
      modalDialog.classList.add('fade-out');
      modalBackdrop.classList.add('fade-out');
      setTimeout(function () {
        popUpModal.hide();
      }, 400);
    }

    function getTextTranslationByKey (key) {
      return LANGUAGE_MODAL[$scope.currentLang].find(function (item) { return item.value === key}).label;
    }
    
    function getAboutTextByLanguage(customFields) {
      var aboutText = 'about_text';
      var currentLang = $scope.currentLang;
      if(currentLang !== DEFAULT_LANGUAGE && SUPPORTED_LANGUAGES.includes(currentLang)){
        aboutText += '_' + currentLang.replace(/-/g, '_');
      }
      var value = getCustomFieldValueByName(customFields, aboutText);
      if(value === null){
        return getCustomFieldValueByName(customFields, 'about_text');
      }
      return value;
    }

    function getCtaContactText(){
      return CTA_CONTACT_BURBERRY[$scope.currentLang].label;
    }

    function getSitemapLevelsForLPBreadcrumb(locationStoreInfo) {
      return locationStoreInfo.country.toLowerCase() === 'us' ? 'country,region,locality' : 'country,locality';
    }

    $scope.$on('$destroy', filtersSetListener);

    var url = window.location.href;
    var prodEnvironment = url.indexOf('localhost') === -1 && url.indexOf('llp.qa') === -1 && ENV === 'prod';

    var scriptJsFile = document.createElement('script');
    scriptJsFile.src = "https://cdn.cookielaw.org/scripttemplates/otSDKStub.js";
    scriptJsFile.type = "text/javascript";
    scriptJsFile.charset = "UTF-8";
    scriptJsFile.setAttribute("data-domain-script", prodEnvironment ? "018f58c1-e28a-7129-921f-6d675d75f9ca" : "018f58c1-e28a-7129-921f-6d675d75f9ca-test");

    var scriptFunctionCall = document.createElement('script');
    scriptFunctionCall.type = "text/javascript";
    scriptFunctionCall.text = "function OptanonWrapper() {}";

    var head = document.getElementsByTagName('head')[0];

    head.appendChild(scriptJsFile);
    head.appendChild(scriptFunctionCall);

  }

})();



(function() {
    'use strict';

    angular
        .module('storeLocator')
        .config(routerConfig)

    /** @ngInject */
    function routerConfig($stateProvider, CLIENT_ROUTE, STORE_LOCATOR_ROUTES, SITE_MAP_PAGE, LOCAL_LANDING_PAGE) {

        function getUrl(route) {
            return CLIENT_ROUTE == '' ? route : CLIENT_ROUTE + route;
        }

        $stateProvider
            .state('root.customLocalLandingUS', {
                url: getUrl(STORE_LOCATOR_ROUTES.customLocalLandingUS.url),
                templateUrl: LOCAL_LANDING_PAGE,
                controller: 'LocalLandingController',
                controllerAs: 'localLanding',
                params: STORE_LOCATOR_ROUTES.customLocalLandingUS.params
            })
            .state('root.customSiteMapRegionUS', {
                url: getUrl(STORE_LOCATOR_ROUTES.customSiteMapRegionUS.url),
                templateUrl: SITE_MAP_PAGE,
                controller: 'SiteMapController',
                controllerAs: 'siteMapC',
                title: 'Site Map',
                params: STORE_LOCATOR_ROUTES.customSiteMapRegionUS.params
            })
            .state('root.customSiteMapLocalityUS', {
                url: getUrl(STORE_LOCATOR_ROUTES.customSiteMapLocalityUS.url),
                templateUrl: SITE_MAP_PAGE,
                controller: 'SiteMapController',
                controllerAs: 'siteMapC',
                title: 'Site Map',
                params: STORE_LOCATOR_ROUTES.customSiteMapLocalityUS.params
        })
    }

})();

(function() {
  'use strict';
  angular.module('storeLocator')
    .constant('NO_ROUTING_PREFIX', true)
    .constant('ROOT_PAGE', "app/custom/clients/burberry/layout.html")
    .constant('LOCAL_LANDING_PAGE', "app/custom/clients/burberry/localLanding.html")
    .constant('STORE_LOCATOR', "app/custom/clients/burberry/storeLocator.html")
    .constant('STORE_LOCATOR_RESULTS_TEMPLATE', "app/custom/clients/burberry/templates/resultsLi.template.html")
    .constant('STORE_LOCATOR_MAP_POPUP_TEMPLATE', 'app/custom/clients/burberry/templates/mapPopup.template.html')
    .constant('LOCATION_LIST_TEMPLATE', 'app/custom/clients/burberry/templates/locationList.template.html')
    .constant('SITE_MAP_PAGE', "app/siteMap/siteMap.html")
    .constant('STORE_LOCATOR_SEARCH_COUNTRY', 'AE,AM,AT,AU,AZ,BE,BH,BR,CA,CH,CN,CZ,DE,DK,EG,ES,FI,FR,GE,HK,ID,IE,IN,IT,JP,KR,KW,KZ,LB,MO,MX,MY,NL,NO,NZ,PA,PH,PT,QA,RO,SA,SE,SG,TH,UK,US')
    .constant('STORE_LOCATOR_SEARCH_TYPE', 'postcode,region,place,country')
    .constant('STORE_LOCATOR_ZOOM_LEVELS', '{ "initial": "2",  "region": "6", "store": "9", "place": "11", "locality": "11", "country": "6" }')
    .constant('STORE_LOCATOR_LOCATIONS_NO', 50)
    .constant('STORE_LOCATOR_LATITUDE', 39.50)
    .constant('STORE_LOCATOR_LONGITUDE', -98.35)
    .constant('CLIENT_NAME', "Burberry")
    .constant("API_TOKEN", "DrB2gWYxFo6Zjtq5m9w5uEjMOgh6Rg")
    .constant('INSTAGRAM_BUSINESS_ACCOUNT_ID', null)
    .constant('INSTAGRAM_HANDLE', null)
    .constant("GOOGLE_ANALYTICS", 'G-3BE3TQ9R0F')
    .constant("GOOGLE_ANALYTICS_CLIENT", null)
    .constant("GOOGLE_TAG_MANAGER", null)
    .constant("NOINDEX_PROD_ENV", false)
    .constant("GOOGLE_AD_WORDS", null)
    .constant("FACEBOOK_PIXEL", null)
    .constant("TEALIUM_HEAD_INJECTIONS", null)
    .constant("TEALIUM_BODY_INJECTIONS", null)
    .constant("STORE_LOCATOR_PIN", "#000000")
    .constant("STORE_LOCATOR_PIN_ICON", "assets/images/clients/burberry/pin-icon-lp.png")
    .constant("STORE_LOCATOR_MAP_ZOOM_ON_SCROLL", true)
    .constant("STORE_LOCATOR_PIN_ICON_NO_NR", false)
    .constant("STORE_LOCATOR_TABS", '')
    .constant("SHOW_ICONS", false)
    .constant("STORE_LOCATOR_FILTERS", {
      "en":[
        {"active":false,"label":"Private store appointment","value":"private_store_appointment","type":"Services","llp":true},
        {"active":false,"label":"Alterations","value":"alterations","type":"Services","llp":true},
        {"active":false,"label":"Gift packaging","value":"gift_packaging","type":"Services","llp":true},
        {"active":false,"label":"Return in store","value":"return_in_store","type":"Services","llp":true},
        {"active":false,"label":"Aftercare appointment","value":"aftercare_appointment","type":"Services","llp":true},
        {"active":false,"label":"Personalise your product","value":"monogram_your_product","type":"Services","llp":true},
        {"active":false,"label":"Collect in store","value":"collect_in_store","type":"Services","llp":true},
        {"active":false,"label":"Airports","value":"airports","type":"Type of store","llp":true},
        {"active":false,"label":"Flagship","value":"flagships","type":"Type of store","llp":true},
        {"active":false,"label":"Pop up","value":"pop_up","type":"Type of store","llp":true},
        {"active":false,"label":"Accessories","value":"accessories","type":"Category","llp":true},
        {"active":false,"label":"Children","value":"children","type":"Category","llp":true},
        {"active":false,"label":"Men","value":"men","type":"Category","llp":true},
        {"active":false,"label":"Multi category","value":"multi_category","type":"Category","llp":true},
        {"active":false,"label":"Beauty","value":"beauty","type":"Category","llp":true},
        {"active":false,"label":"Fragrance","value":"fragrance","type":"Category","llp":true},
        {"active":false,"label":"Women","value":"women","type":"Category","llp":true},
        {"active":false,"label":"Shoes","value":"shoes","type":"Category","llp":true}
      ],
      "es":[
        {"active":false,"label":"Cita privada en tienda","value":"private_store_appointment","type":"Servicios","llp":true},
        {"active":false,"label":"Modificaciones","value":"alterations","type":"Servicios","llp":true},
        {"active":false,"label":"Envoltorios para regalo","value":"gift_packaging","type":"Servicios","llp":true},
        {"active":false,"label":"Devolución en tienda","value":"return_in_store","type":"Servicios","llp":true},
        {"active":false,"label":"Cita de cuidados posventa","value":"aftercare_appointment","type":"Servicios","llp":true},
        {"active":false,"label":"Personalización de productos","value":"monogram_your_product","type":"Servicios","llp":true},
        {"active":false,"label":"Recogida en tienda","value":"collect_in_store","type":"Servicios","llp":true},
        {"active":false,"label":"Aeropuertos","value":"airports","type":"Tipo de tienda","llp":true},
        {"active":false,"label":"Flagship","value":"flagships","type":"Tipo de tienda","llp":true},
        {"active":false,"label":"Pop-up","value":"pop_up","type":"Tipo de tienda","llp":true},
        {"active":false,"label":"Accesorios","value":"accessories","type":"Categoría","llp":true},
        {"active":false,"label":"Niños","value":"children","type":"Categoría","llp":true},
        {"active":false,"label":"Hombre","value":"men","type":"Categoría","llp":true},
        {"active":false,"label":"Multicategoría","value":"multi_category","type":"Categoría","llp":true},
        {"active":false,"label":"Belleza","value":"beauty","type":"Categoría","llp":true},
        {"active":false,"label":"Fragancias","value":"fragrance","type":"Categoría","llp":true},
        {"active":false,"label":"Mujer","value":"women","type":"Categoría","llp":true},
        {"active":false,"label":"Zapatos","value":"shoes","type":"Categoría","llp":true}
      ],
      "fr":[
        {"active":false,"label":"Rendez-vous privé en boutique","value":"private_store_appointment","type":"Services","llp":true},
        {"active":false,"label":"Retouches","value":"alterations","type":"Services","llp":true},
        {"active":false,"label":"Emballage cadeaux","value":"gift_packaging","type":"Services","llp":true},
        {"active":false,"label":"Retour en boutique","value":"return_in_store","type":"Services","llp":true},
        {"active":false,"label":"Rendez-vous après-vente","value":"aftercare_appointment","type":"Services","llp":true},
        {"active":false,"label":"Personnalisation","value":"monogram_your_product","type":"Services","llp":true},
        {"active":false,"label":"Retrait en boutique","value":"collect_in_store","type":"Services","llp":true},
        {"active":false,"label":"Aéroports","value":"airports","type":"Type de boutique","llp":true},
        {"active":false,"label":"Boutique phare","value":"flagships","type":"Type de boutique","llp":true},
        {"active":false,"label":"Pop-up","value":"pop_up","type":"Type de boutique","llp":true},
        {"active":false,"label":"Accessoires","value":"accessories","type":"Catégorie","llp":true},
        {"active":false,"label":"Enfant","value":"children","type":"Catégorie","llp":true},
        {"active":false,"label":"Homme","value":"men","type":"Catégorie","llp":true},
        {"active":false,"label":"Multicatégorie","value":"multi_category","type":"Catégorie","llp":true},
        {"active":false,"label":"Beauté","value":"beauty","type":"Catégorie","llp":true},
        {"active":false,"label":"Parfums","value":"fragrance","type":"Catégorie","llp":true},
        {"active":false,"label":"Femme","value":"women","type":"Catégorie","llp":true},
        {"active":false,"label":"Chaussures","value":"shoes","type":"Catégorie","llp":true}
      ],
      "it":[
        {"active":false,"label":"Appuntamento privato in boutique","value":"private_store_appointment","type":"Servizi","llp":true},
        {"active":false,"label":"Modifiche","value":"alterations","type":"Servizi","llp":true},
        {"active":false,"label":"Confezioni regalo","value":"gift_packaging","type":"Servizi","llp":true},
        {"active":false,"label":"Restituzione in boutique","value":"return_in_store","type":"Servizi","llp":true},
        {"active":false,"label":"Appuntamento per servizi post vendita","value":"aftercare_appointment","type":"Servizi","llp":true},
        {"active":false,"label":"Personalizzazione con iniziali","value":"monogram_your_product","type":"Servizi","llp":true},
        {"active":false,"label":"Ritiro in boutique","value":"collect_in_store","type":"Servizi","llp":true},
        {"active":false,"label":"Aeroporti","value":"airports","type":"Tipo di negozio","llp":true},
        {"active":false,"label":"Flagship store","value":"flagships","type":"Tipo di negozio","llp":true},
        {"active":false,"label":"Installazione temporanea","value":"pop_up","type":"Tipo di negozio","llp":true},
        {"active":false,"label":"Accessori","value":"accessories","type":"Categoria","llp":true},
        {"active":false,"label":"Bambini","value":"children","type":"Categoria","llp":true},
        {"active":false,"label":"Uomo","value":"men","type":"Categoria","llp":true},
        {"active":false,"label":"Multi-categoria","value":"multi_category","type":"Categoria","llp":true},
        {"active":false,"label":"Prodotti di bellezza","value":"beauty","type":"Categoria","llp":true},
        {"active":false,"label":"Fragranze","value":"fragrance","type":"Categoria","llp":true},
        {"active":false,"label":"Donna","value":"women","type":"Categoria","llp":true},
        {"active":false,"label":"Scarpe","value":"shoes","type":"Categoria","llp":true}
      ],
      "pt":[
        {"active":false,"label":"Agendamento em loja particular","value":"private_store_appointment","type":"Serviços","llp":true},
        {"active":false,"label":"Alterações","value":"alterations","type":"Serviços","llp":true},
        {"active":false,"label":"Embalagens para presentes","value":"gift_packaging","type":"Serviços","llp":true},
        {"active":false,"label":"Devolução na loja","value":"return_in_store","type":"Serviços","llp":true},
        {"active":false,"label":"Agendamento para serviços pós-vendas","value":"aftercare_appointment","type":"Serviços","llp":true},
        {"active":false,"label":"Personalize o seu produto com um monograma","value":"monogram_your_product","type":"Serviços","llp":true},
        {"active":false,"label":"Retirada na loja","value":"collect_in_store","type":"Serviços","llp":true},
        {"active":false,"label":"Aeroportos","value":"airports","type":"Tipo de loja","llp":true},
        {"active":false,"label":"Flagship","value":"flagships","type":"Tipo de loja","llp":true},
        {"active":false,"label":"Pop-ups","value":"pop_up","type":"Tipo de loja","llp":true},
        {"active":false,"label":"Acessórios","value":"accessories","type":"Categoria","llp":true},
        {"active":false,"label":"Infantil","value":"children","type":"Categoria","llp":true},
        {"active":false,"label":"Masculino","value":"men","type":"Categoria","llp":true},
        {"active":false,"label":"Multicategorias","value":"multi_category","type":"Categoria","llp":true},
        {"active":false,"label":"Linha de beleza","value":"beauty","type":"Categoria","llp":true},
        {"active":false,"label":"Fragrâncias","value":"fragrance","type":"Categoria","llp":true},
        {"active":false,"label":"Feminino","value":"women","type":"Categoria","llp":true},
        {"active":false,"label":"Sapatos","value":"shoes","type":"Categoria","llp":true}
      ],
      "ru":[
        {"active":false,"label":"Индивидуальные консультации","value":"private_store_appointment","type":"Услуги","llp":true},
        {"active":false,"label":"Подгонка одежды по фигуре","value":"alterations","type":"Услуги","llp":true},
        {"active":false,"label":"Праздничное оформление заказов","value":"gift_packaging","type":"Услуги","llp":true},
        {"active":false,"label":"Возврат товаров в магазин","value":"return_in_store","type":"Услуги","llp":true},
        {"active":false,"label":"Консультации по уходу за изделиями","value":"aftercare_appointment","type":"Услуги","llp":true},
        {"active":false,"label":"Нанесение монограммы","value":"monogram_your_product","type":"Услуги","llp":true},
        {"active":false,"label":"Получение товаров в магазине","value":"collect_in_store","type":"Услуги","llp":true},
        {"active":false,"label":"Аэропорты","value":"airports","type":"Тип магазина","llp":true},
        {"active":false,"label":"Флагманский магазин","value":"flagships","type":"Тип магазина","llp":true},
        {"active":false,"label":"Поп-ап","value":"pop_up","type":"Тип магазина","llp":true},
        {"active":false,"label":"Аксессуары","value":"accessories","type":"Категория","llp":true},
        {"active":false,"label":"Для детей","value":"children","type":"Категория","llp":true},
        {"active":false,"label":"Для мужчин","value":"men","type":"Категория","llp":true},
        {"active":false,"label":"Разные категории товаров","value":"multi_category","type":"Категория","llp":true},
        {"active":false,"label":"Парфюмерия и косметика","value":"beauty","type":"Категория","llp":true},
        {"active":false,"label":"Парфюмерия","value":"fragrance","type":"Категория","llp":true},
        {"active":false,"label":"Для женщин","value":"women","type":"Категория","llp":true},
        {"active":false,"label":"Обувь","value":"shoes","type":"Категория","llp":true}
      ],
      "ko":[
        {"active":false,"label":"프라이빗 매장 어포인트먼트","value":"private_store_appointment","type":"서비스","llp":true},
        {"active":false,"label":"수선","value":"alterations","type":"서비스","llp":true},
        {"active":false,"label":"선물 포장","value":"gift_packaging","type":"서비스","llp":true},
        {"active":false,"label":"매장으로 반품","value":"return_in_store","type":"서비스","llp":true},
        {"active":false,"label":"애프터케어 어포인트먼트","value":"aftercare_appointment","type":"서비스","llp":true},
        {"active":false,"label":"제품 모노그래밍","value":"monogram_your_product","type":"서비스","llp":true},
        {"active":false,"label":"매장 방문 수령","value":"collect_in_store","type":"서비스","llp":true},
        {"active":false,"label":"공항","value":"airports","type":"스토어 유형","llp":true},
        {"active":false,"label":"플래그십","value":"flagships","type":"스토어 유형","llp":true},
        {"active":false,"label":"팝업","value":"pop_up","type":"스토어 유형","llp":true},
        {"active":false,"label":"액세서리","value":"accessories","type":"카테고리","llp":true},
        {"active":false,"label":"아동","value":"children","type":"카테고리","llp":true},
        {"active":false,"label":"남성","value":"men","type":"카테고리","llp":true},
        {"active":false,"label":"멀티 카테고리","value":"multi_category","type":"카테고리","llp":true},
        {"active":false,"label":"뷰티","value":"beauty","type":"카테고리","llp":true},
        {"active":false,"label":"향수","value":"fragrance","type":"카테고리","llp":true},
        {"active":false,"label":"여성","value":"women","type":"카테고리","llp":true},
        {"active":false,"label":"신발","value":"shoes","type":"카테고리","llp":true}
      ],
      "ja":[
        {"active":false,"label":"店舗プライベートアポイントメント","value":"private_store_appointment","type":"サービス","llp":true},
        {"active":false,"label":"お直し","value":"alterations","type":"サービス","llp":true},
        {"active":false,"label":"ギフト包装","value":"gift_packaging","type":"サービス","llp":true},
        {"active":false,"label":"店舗で返品","value":"return_in_store","type":"サービス","llp":true},
        {"active":false,"label":"アフターケア アポイントメント","value":"aftercare_appointment","type":"サービス","llp":true},
        {"active":false,"label":"アイテムのモノグラミング","value":"monogram_your_product","type":"サービス","llp":true},
        {"active":false,"label":"店舗受け取りサービス","value":"collect_in_store","type":"サービス","llp":true},
        {"active":false,"label":"空港","value":"airports","type":"店舗タイプ","llp":true},
        {"active":false,"label":"本店","value":"flagships","type":"店舗タイプ","llp":true},
        {"active":false,"label":"ポップアップ","value":"pop_up","type":"店舗タイプ","llp":true},
        {"active":false,"label":"小物＆アクセサリー","value":"accessories","type":"カテゴリー","llp":true},
        {"active":false,"label":"チルドレンズ","value":"children","type":"カテゴリー","llp":true},
        {"active":false,"label":"メンズ","value":"men","type":"カテゴリー","llp":true},
        {"active":false,"label":"複数のカテゴリー","value":"multi_category","type":"カテゴリー","llp":true},
        {"active":false,"label":"ビューティ","value":"beauty","type":"カテゴリー","llp":true},
        {"active":false,"label":"フレグランス","value":"fragrance","type":"カテゴリー","llp":true},
        {"active":false,"label":"ウィメンズ","value":"women","type":"カテゴリー","llp":true},
        {"active":false,"label":"靴","value":"shoes","type":"カテゴリー","llp":true}
      ],
      "zh-tw":[
        {"active":false,"label":"私人店櫃預約","value":"private_store_appointment","type":"服务","llp":true},
        {"active":false,"label":"修改服務","value":"alterations","type":"服务","llp":true},
        {"active":false,"label":"禮品包裝服務","value":"gift_packaging","type":"服务","llp":true},
        {"active":false,"label":"店櫃退貨服務","value":"return_in_store","type":"服务","llp":true},
        {"active":false,"label":"售後保養預約","value":"aftercare_appointment","type":"服务","llp":true},
        {"active":false,"label":"私人印記","value":"monogram_your_product","type":"服务","llp":true},
        {"active":false,"label":"到店取貨","value":"collect_in_store","type":"服务","llp":true},
        {"active":false,"label":"机场","value":"airports","type":"商店类型","llp":true},
        {"active":false,"label":"旗艦店","value":"flagships","type":"商店类型","llp":true},
        {"active":false,"label":"限時展售空間","value":"pop_up","type":"商店类型","llp":true},
        {"active":false,"label":"配件","value":"accessories","type":"類別","llp":true},
        {"active":false,"label":"童款","value":"children","type":"類別","llp":true},
        {"active":false,"label":"男款","value":"men","type":"類別","llp":true},
        {"active":false,"label":"多類別","value":"multi_category","type":"類別","llp":true},
        {"active":false,"label":"美妝","value":"beauty","type":"類別","llp":true},
        {"active":false,"label":"香氛","value":"fragrance","type":"類別","llp":true},
        {"active":false,"label":"女款","value":"women","type":"類別","llp":true},
        {"active":false,"label":"鞋类","value":"shoes","type":"類別","llp":true}
      ],
      "zh-cn":[
        {"active":false,"label":"店内私人预约","value":"private_store_appointment","type":"服务","llp":true},
        {"active":false,"label":"改衣服务","value":"alterations","type":"服务","llp":true},
        {"active":false,"label":"礼品包装","value":"gift_packaging","type":"服务","llp":true},
        {"active":false,"label":"店内退货","value":"return_in_store","type":"服务","llp":true},
        {"active":false,"label":"售后保养预约","value":"aftercare_appointment","type":"服务","llp":true},
        {"active":false,"label":"私人印记","value":"monogram_your_product","type":"服务","llp":true},
        {"active":false,"label":"店内取货","value":"collect_in_store","type":"服务","llp":true},
        {"active":false,"label":"机场","value":"airports","type":"商店类型","llp":true},
        {"active":false,"label":"旗舰店","value":"flagships","type":"商店类型","llp":true},
        {"active":false,"label":"限时精品店","value":"pop_up","type":"商店类型","llp":true},
        {"active":false,"label":"配饰","value":"accessories","type":"类别","llp":true},
        {"active":false,"label":"儿童","value":"children","type":"类别","llp":true},
        {"active":false,"label":"男士","value":"men","type":"类别","llp":true},
        {"active":false,"label":"多类别","value":"multi_category","type":"类别","llp":true},
        {"active":false,"label":"美妆","value":"beauty","type":"类别","llp":true},
        {"active":false,"label":"香氛","value":"fragrance","type":"类别","llp":true},
        {"active":false,"label":"女士","value":"women","type":"类别","llp":true},
        {"active":false,"label":"鞋类","value":"shoes","type":"类别","llp":true}
      ],
      "de":[
        {"active":false,"label":"Persönliche Beratung im Store","value":"private_store_appointment","type":"Dienstleistungen","llp":true},
        {"active":false,"label":"Änderungen","value":"alterations","type":"Dienstleistungen","llp":true},
        {"active":false,"label":"Verpackungsservice","value":"gift_packaging","type":"Dienstleistungen","llp":true},
        {"active":false,"label":"Rückgaben im Store","value":"return_in_store","type":"Dienstleistungen","llp":true},
        {"active":false,"label":"Pflegeservice-Termine","value":"aftercare_appointment","type":"Dienstleistungen","llp":true},
        {"active":false,"label":"Produkt personalisieren","value":"monogram_your_product","type":"Dienstleistungen","llp":true},
        {"active":false,"label":"Collect-in-Store","value":"collect_in_store","type":"Dienstleistungen","llp":true},
        {"active":false,"label":"Flughäfen","value":"airports","type":"Geschäftstyp","llp":true},
        {"active":false,"label":"Flagship","value":"flagships","type":"Geschäftstyp","llp":true},
        {"active":false,"label":"Pop-ups","value":"pop_up","type":"Geschäftstyp","llp":true},
        {"active":false,"label":"Accessoires","value":"accessories","type":"Kategorie","llp":true},
        {"active":false,"label":"Kinder","value":"children","type":"Kategorie","llp":true},
        {"active":false,"label":"Herren","value":"men","type":"Kategorie","llp":true},
        {"active":false,"label":"Mehrere Kategorien","value":"multi_category","type":"Kategorie","llp":true},
        {"active":false,"label":"Beauty","value":"beauty","type":"Kategorie","llp":true},
        {"active":false,"label":"Düfte","value":"fragrance","type":"Kategorie","llp":true},
        {"active":false,"label":"Damen","value":"women","type":"Kategorie","llp":true},
        {"active":false,"label":"Schuhe","value":"shoes","type":"Kategorie","llp":true}
      ]
    })
    .constant("SHOW_LIST_DEFAULT", false)
    .constant("MAPBOX_STYLE", "mapbox/light-v11")
    .constant("CUSTOM_DICTIONARY", {
      placeholder: "Search for location"
    })
    .constant("MAPBOX_CLUSTER", true)
    .constant("STORE_LOCATOR_MAP_CONFIGS", '{' +
      '"clusterColors": "#ffffff",' +
      '"clusterSizes": 20,' +
      '"clusterRadius": 35,' +
      '"clusterTextSize": 12,' +
      '"clusterTextColor": "#0006cf",' +
      '"clusterBorderColor": "#0006cf",' +
      '"clusterBorderWidth": 1,' +
      '"clusterHoverColor": "#0006cf",' +
      '"clusterHoverTextColor": "#ffffff",' +
      '"pinImageSrc": "https://assets.burberry.com/is/image/Burberryltd/uberall-store-locator-pin-icon-map-default?fmt=png-alpha",' +
      '"pinImageHoverSrc": "https://assets.burberry.com/is/image/Burberryltd/uberall-store-locator-pin-icon-map-hover?fmt=png-alpha",' +
      '"pinStaticMapImageSrc": "https://assets.burberry.com/is/image/Burberryltd/uberall-store-locator-pin-icon-mapbox-default?fmt=png-alpha",' +
      '"pinImageSize": 0.15,' +
      '"noMapPopUpOnMobile": true,' +
      '"autoSearchOnDragAndZoom": true' +
      '}'
    )
    .constant("META",
      {
        "favicon": "assets/images/clients/burberry/favicon.png",
        "sitemap_country_description": {
          "AM": "Discover and journey through our stores across Armenia. Discover classic British fashion.",
          "AU": "Discover and journey through our stores across Australia. Discover classic British fashion.",
          "AT": "Discover and journey through our stores across Austria. Discover classic British fashion.",
          "AZ": "Discover and journey through our stores across Azerbaijan. Discover classic British fashion.",
          "BH": "Discover and journey through our stores across Bahrain. Discover classic British fashion.",
          "BE": "Discover and journey through our stores across Belgium. Discover classic British fashion.",
          "BR": "Discover and journey through our stores across Brazil. Discover classic British fashion.",
          "CA": "Discover and journey through our stores across Canada. Discover classic British fashion.",
          "CN": "Discover and journey through our stores across China Mainland. Discover classic British fashion.",
          "CZ": "Discover and journey through our stores across Czech Republic. Discover classic British fashion.",
          "DK": "Discover and journey through our stores across Denmark. Discover classic British fashion.",
          "EG": "Discover and journey through our stores across Egypt. Discover classic British fashion.",
          "FR": "Discover and journey through our stores across France. Discover classic British fashion.",
          "GE": "Discover and journey through our stores across Georgia. Discover classic British fashion.",
          "DE": "Discover and journey through our stores across Germany. Discover classic British fashion.",
          "HK": "Discover and journey through our stores across Hong Kong. Discover classic British fashion.",
          "IN": "Discover and journey through our stores across India. Discover classic British fashion.",
          "ID": "Discover and journey through our stores across Indonesia. Discover classic British fashion.",
          "IE": "Discover and journey through our stores across Ireland. Discover classic British fashion.",
          "IT": "Discover and journey through our stores across Italy. Discover classic British fashion.",
          "JP": "Discover and journey through our stores across Japan. Discover classic British fashion.",
          "KZ": "Discover and journey through our stores across Kazakhstan. Discover classic British fashion.",
          "KW": "Discover and journey through our stores across Kuwait. Discover classic British fashion.",
          "LB": "Discover and journey through our stores across Lebanon. Discover classic British fashion.",
          "MO": "Discover and journey through our stores across Macao. Discover classic British fashion.",
          "MY": "Discover and journey through our stores across Malaysia. Discover classic British fashion.",
          "MX": "Discover and journey through our stores across Mexico. Discover classic British fashion.",
          "NL": "Discover and journey through our stores across Netherlands. Discover classic British fashion.",
          "NZ": "Discover and journey through our stores across New Zealand. Discover classic British fashion.",
          "NO": "Discover and journey through our stores across Norway. Discover classic British fashion.",
          "PA": "Discover and journey through our stores across Panama. Discover classic British fashion.",
          "PH": "Discover and journey through our stores across Philippines. Discover classic British fashion.",
          "PT": "Discover and journey through our stores across Portugal. Discover classic British fashion.",
          "QA": "Discover and journey through our stores across Qatar. Discover classic British fashion.",
          "RO": "Discover and journey through our stores across Romania. Discover classic British fashion.",
          "SA": "Discover and journey through our stores across Saudi Arabia. Discover classic British fashion.",
          "SG": "Discover and journey through our stores across Singapore. Discover classic British fashion.",
          "ZA": "Discover and journey through our stores across South Africa. Discover classic British fashion.",
          "KR": "Discover and journey through our stores across South Korea. Discover classic British fashion.",
          "ES": "Discover and journey through our stores across Spain. Discover classic British fashion.",
          "SE": "Discover and journey through our stores across Sweden. Discover classic British fashion.",
          "CH": "Discover and journey through our stores across Switzerland. Discover classic British fashion.",
          "TW": "Discover and journey through our stores across Taiwan Area. Discover classic British fashion.",
          "TH": "Discover and journey through our stores across Thailand. Discover classic British fashion.",
          "TR": "Discover and journey through our stores across Turkey. Discover classic British fashion.",
          "AE": "Discover and journey through our stores across United Arab Emirates. Discover classic British fashion.",
          "UK": "Discover and journey through our stores across United Kingdom. Discover classic British fashion.",
          "US": "Discover and journey through our stores across United States. Discover classic British fashion.",
          "VN": "Discover and journey through our stores across Vietnam. Discover classic British fashion."
        },
        "sitemap_region_description": {
          "US": {
            "AZ": "Locate and explore our Arizona stores. Discover the essence of classic British fashion at its finest",
            "CA": "Discover our California stores. Uncover classic British fashion, where sophistication meets style",
            "CO": "Experience timeless classics with iconic, luxury British fashion at our Colorado stores. Discover here",
            "DC": "Explore luxury British fashion at our DC stores. Locate a store and delve into the latest collections",
            "FL": "Discover iconic British fashion at our Florida stores. Unveil new collections today. Locate a store near you",
            "GA": "Explore luxury British fashion at our Georgia stores and uncover the latest collections. Visit a store near you",
            "HI": "Explore the pinnacle of British luxury fashion at our Hawaii stores. Discover new collections in-store today",
            "IL": "Discover the epitome of British luxury fashion at our Illinois stores. Discover the latest collections in-store",
            "MA": "Experience British luxury fashion at our Massachusetts stores. Discover exquisite collections in-store",
            "MI": "Experience a world of luxury British fashion at our Michigan stores. Discover new collections at a store nearby",
            "MN": "Dive into luxury British fashion at our Minnesota stores. Explore new and iconic collections at a store near you",
            "NC": "Indulge in luxury British fashion at our NC stores. Locate a nearby store and explore iconic collections",
            "NJ": "Discover luxury British fashion at our New Jersey stores. Explore new collections at a store near you",
            "NV": "Discover luxury British fashion at our stores in Nevada and explore new collections. Visit a store near you",
            "NY": "Discover luxury British fashion at our New York stores. Explore new collections today at a store near you",
            "PA": "Discover the core of British luxury fashion at our Pennsylvania stores. Explore exclusive in-store collections",
            "TN": "Locate our stores in Tennessee and experience iconic British fashion. Discover exclusive collections in-store",
            "TX": "Indulge in luxury British fashion at our Texas stores. Find a store and explore our latest collections",
            "VA": "Discover luxury British fashion at our stores in Virginia. Explore signature collections at a store near you",
            "WA": "Experience luxury British fashion at our Washington stores. Explore iconic collections at a store near you"
          }
        },
        "sitemap_locality_description": {
          "US": {
            "AZ": {
              "scottsdale": "Discover our Scottsdale stores in Arizona. Uncover classic British fashion, where sophistication meets style",
            },
            "CA": {
              "beverly-hills": "Experience excellence at our exclusive Beverly Hills stores. Immerse yourself in our curated collection",
              "costa-mesa": "Explore exceptional British fashion at our Costa Mesa stores. Discover luxury clothing, accessories and service",
              "los-angeles": "Discover luxury British fashion at our Los Angeles locations. Find a store and uncover the latest collection",
              "palo-alto": "Explore luxury British fashion at our Palo Alto stores. Locate a store and discover the newest assortment",
              "san-diego": "Experience luxury British fashion at our San Diego stores. Find a store and explore the latest collection",
              "san-francisco": "Indulge in luxury British fashion at our San Diego locations. Locate a store and delve into the latest collection",
              "san-jose": "Locate our stores in San Jose and experience timeless elegance through classic British fashion. Find here",
              "santa-clara": "Find timeless elegance in classic British fashion at our Santa Clara stores. Discover new collections"
            },
            "CO": {
              "denver": "Indulge in luxury British fashion at our Denver stores. Find a store and explore the latest collection"
            },
            "DC": {
              "washington": "Locate our Stores in Washington and unveil Iconic British Fashion. Discover new collections today"
            },
            "FL": {
              "aventura": "Explore iconic British fashion at our Aventura stores. Unveil new collections today and locate a store near you",
              "bal-harbour": "Discover iconic British fashion at our Bal Harbour stores. Unveil new collections today and find a store near you",
              "miami": "Discover luxury British fashion at our stores in Miami. Explore new collections today at a store near you",
              "orlando": "Indulge in luxury British fashion at our Orlando stores. Discover new collections today at a store near you",
              "tampa": "Indulge in luxury British fashion at our Tampa stores. Discover new collections today at a store near you"
            },
            "GA": {
              "atlanta": "Discover luxury British fashion at our Atlanta stores and explore the latest collections. Visit a store near you today"
            },
            "HI": {
              "honolulu": "Embark on a journey of British luxury fashion at our Honolulu stores. Explore new collections in-store today"
            },
            "IL": {
              "chicago": "Explore British luxury fashion at our exclusive Chicago stores. Discover the latest collections in-store"
            },
            "MA": {
              "boston": "Discover luxury British fashion at our Boston stores. Experience a world of elegance and sophistication"
            },
            "MI": {
              "troy": "Immerse yourself in the world of luxury British fashion at our Troy stores. Discover new collections nearby"
            },
            "MN": {
              "bloomington": "Experience luxury British fashion at our Bloomington stores. Explore iconic collections at a store near you"
            },
            "NC": {
              "hackensack": "Indulge in luxury British fashion at our Hackensack stores. Locate a nearby store and explore iconic collections"
            },
            "NJ": {
              "paramus": "Discover luxury British fashion at our Paramus stores. Experience a world of elegance and sophistication",
              "short-hills": "Experience British luxury fashion at our stores in Short Hills. Discover exquisite collections in-store"
            },
            "NV": {
              "las-vegas": "Explore luxury British fashion at our Las Vegas stores and uncover new collections. Visit a store near you"
            },
            "NY": {
              "garden-city": "Explore iconic British fashion at our Garden City stores. Unveil new collections today and locate a store near you",
              "manhasset": "Locate our stores in Manhasset and experience timeless elegance through classic British fashion. Find here",
              "new-york": "Locate and explore our stores in New York City and discover the essence of luxury British fashion at its finest",
              "white-plains": "Discover the essence of luxury British fashion at its pinnacle by exploring our stores in White Plains."
            },
            "PA": {
              "king-of-prussia": "Explore luxury British fashion at our King of Prussia stores. Locate a nearby store and discover the classics",
              "pittsburgh": "Discover the epitome of British luxury fashion at our Pittsburgh stores. Discover the latest collections in-store"
            },
            "TN": {
              "nashville": "Locate our stores in Nashville and experience iconic British fashion. Discover exclusive in-store collections"
            },
            "TX": {
              "austin": "Discover luxury British fashion at our Austin stores, where sophistication meets style. Find a store near you.",
              "dallas": "Discover luxury British fashion at our Dallas stores, where sophistication meets style. Find a store near you.",
              "fort-worth": "Locate our stores in Fort Worth and experience timeless elegance through classic British fashion.",
              "houston": "Discover luxury British fashion at our Houston stores. Explore new collections at a store near you"
            },
            "VA": {
              "tysons": "Locate our Stores in Tysons and unveil Iconic British Fashion. Discover new collections today"
            },
            "WA": {
              "bellevue": "Experience British luxury fashion at our Bellevue stores. Discover classic yet innovative collections in-store"
            }
          },
          "AM":{
            "yerevan": "Explore luxury British fashion at our Yerevan stores. Locate a store and discover the newest assortment."
          },
          "AU":{
            "brisbane": "Explore luxury British fashion at our Brisbane stores. Locate a store and discover the newest assortment.",
            "melbourne": "Explore luxury British fashion at our Melbourne stores. Locate a store and discover the newest assortment.",
            "sydney": "Explore luxury British fashion at our Sydney stores. Locate a store and discover the newest assortment."
          },
          "AT":{
            "vienna": "Explore luxury British fashion at our Vienna stores. Locate a store and discover the newest assortment."
          },
          "AZ":{
            "baku": "Explore luxury British fashion at our Baku stores. Locate a store and discover the newest assortment."
          },
          "BH":{
            "manama": "Explore luxury British fashion at our Manama stores. Locate a store and discover the newest assortment."
          },
          "BE":{
            "brussels": "Explore luxury British fashion at our Brussels stores. Locate a store and discover the newest assortment."
          },
          "BR":{
            "brasilia": "Explore luxury British fashion at our Brasilia stores. Locate a store and discover the newest assortment.",
            "curitiba": "Explore luxury British fashion at our Curitiba stores. Locate a store and discover the newest assortment.",
            "guarulhos": "Explore luxury British fashion at our Guarulhos stores. Locate a store and discover the newest assortment.",
            "rio-de-janeiro": "Explore luxury British fashion at our Rio de Janeiro stores. Locate a store and discover the newest assortment.",
            "sao-paulo": "Explore luxury British fashion at our Sao Paulo stores. Locate a store and discover the newest assortment."
          },
          "CA":{
            "calgary": "Explore luxury British fashion at our Calgary stores. Locate a store and discover the newest assortment.",
            "mississauga": "Explore luxury British fashion at our Mississauga stores. Locate a store and discover the newest assortment.",
            "montreal": "Explore luxury British fashion at our Montreal stores. Locate a store and discover the newest assortment.",
            "richmond": "Explore luxury British fashion at our Richmond stores. Locate a store and discover the newest assortment.",
            "toronto": "Explore luxury British fashion at our Toronto stores. Locate a store and discover the newest assortment.",
            "vancouver": "Explore luxury British fashion at our Vancouver stores. Locate a store and discover the newest assortment."
          },
          "CN":{
            "beijing": "Explore luxury British fashion at our Beijing stores. Locate a store and discover the newest assortment.",
            "changchun": "Explore luxury British fashion at our Changchun stores. Locate a store and discover the newest assortment.",
            "changsha": "Explore luxury British fashion at our Changsha stores. Locate a store and discover the newest assortment.",
            "chongqing": "Explore luxury British fashion at our Chongqing stores. Locate a store and discover the newest assortment.",
            "dalian": "Explore luxury British fashion at our Dalian stores. Locate a store and discover the newest assortment.",
            "fuzhou": "Explore luxury British fashion at our Fuzhou stores. Locate a store and discover the newest assortment.",
            "guangzhou": "Explore luxury British fashion at our Guangzhou stores. Locate a store and discover the newest assortment.",
            "guiyang": "Explore luxury British fashion at our Guiyang stores. Locate a store and discover the newest assortment.",
            "hangzhou": "Explore luxury British fashion at our Hangzhou stores. Locate a store and discover the newest assortment.",
            "harbin": "Explore luxury British fashion at our Harbin stores. Locate a store and discover the newest assortment.",
            "hefei": "Explore luxury British fashion at our Hefei stores. Locate a store and discover the newest assortment.",
            "jinan": "Explore luxury British fashion at our Jinan stores. Locate a store and discover the newest assortment.",
            "kunming": "Explore luxury British fashion at our Kunming stores. Locate a store and discover the newest assortment.",
            "lanzhou": "Explore luxury British fashion at our Lanzhou stores. Locate a store and discover the newest assortment.",
            "nanchang": "Explore luxury British fashion at our Nanchang stores. Locate a store and discover the newest assortment.",
            "nanjing": "Explore luxury British fashion at our Nanjing stores. Locate a store and discover the newest assortment.",
            "nanning": "Explore luxury British fashion at our Nanning stores. Locate a store and discover the newest assortment.",
            "ningbo": "Explore luxury British fashion at our Ningbo stores. Locate a store and discover the newest assortment.",
            "qingdao": "Explore luxury British fashion at our Qingdao stores. Locate a store and discover the newest assortment.",
            "shenyang": "Explore luxury British fashion at our Shenyang stores. Locate a store and discover the newest assortment.",
            "shenzhen": "Explore luxury British fashion at our Shenzhen stores. Locate a store and discover the newest assortment.",
            "shijiazhuang": "Explore luxury British fashion at our Shijiazhuang stores. Locate a store and discover the newest assortment.",
            "suzhou": "Explore luxury British fashion at our Suzhou stores. Locate a store and discover the newest assortment.",
            "taiyuan": "Explore luxury British fashion at our Taiyuan stores. Locate a store and discover the newest assortment.",
            "urumqi": "Explore luxury British fashion at our Urumqi stores. Locate a store and discover the newest assortment.",
            "wuhan": "Explore luxury British fashion at our Wuhan stores. Locate a store and discover the newest assortment.",
            "wuxi": "Explore luxury British fashion at our Wuxi stores. Locate a store and discover the newest assortment.",
            "xiamen": "Explore luxury British fashion at our Xiamen stores. Locate a store and discover the newest assortment.",
            "xian": "Explore luxury British fashion at our Xian stores. Locate a store and discover the newest assortment.",
            "zhengzhou": "Explore luxury British fashion at our Zhengzhou stores. Locate a store and discover the newest assortment."
          },
          "CZ":{
            "prague": "Explore luxury British fashion at our Prague stores. Locate a store and discover the newest assortment."
          },
          "DK":{
            "copenhagen": "Explore luxury British fashion at our Copenhagen stores. Locate a store and discover the newest assortment."
          },
          "EG":{
            "new-cairo": "Explore luxury British fashion at our New Cairo stores. Locate a store and discover the newest assortment."
          },
          "FR":{
            "paris": "Explore luxury British fashion at our Paris stores. Locate a store and discover the newest assortment."
          },
          "GE":{
            "tbilisi": "Explore luxury British fashion at our Tbilisi stores. Locate a store and discover the newest assortment."
          },
          "DE":{
            "berlin": "Explore luxury British fashion at our Berlin stores. Locate a store and discover the newest assortment.",
            "dusseldorf": "Explore luxury British fashion at our Dusseldorf stores. Locate a store and discover the newest assortment.",
            "frankfurt": "Explore luxury British fashion at our Frankfurt stores. Locate a store and discover the newest assortment.",
            "hamburg": "Explore luxury British fashion at our Hamburg stores. Locate a store and discover the newest assortment.",
            "munich": "Explore luxury British fashion at our Munich stores. Locate a store and discover the newest assortment."
          },
          "HK":{
            "hong-kong-island": "Explore luxury British fashion at our Hong Kong Island stores. Locate a store and discover the newest assortment.",
            "kowloon": "Explore luxury British fashion at our Kowloon stores. Locate a store and discover the newest assortment."
          },
          "IN":{
            "bangalore": "Explore luxury British fashion at our Bangalore stores. Locate a store and discover the newest assortment.",
            "hyderabad": "Explore luxury British fashion at our Hyderabad stores. Locate a store and discover the newest assortment.",
            "kolkatta": "Explore luxury British fashion at our Kolkatta stores. Locate a store and discover the newest assortment.",
            "mumbai": "Explore luxury British fashion at our Mumbai stores. Locate a store and discover the newest assortment.",
            "new-delhi": "Explore luxury British fashion at our New Delhi stores. Locate a store and discover the newest assortment."
          },
          "ID":{
            "jakarta": "Explore luxury British fashion at our Jakarta stores. Locate a store and discover the newest assortment."
          },
          "IE":{
            "dublin": "Explore luxury British fashion at our Dublin stores. Locate a store and discover the newest assortment."
          },
          "IT":{
            "fiumicino": "Explore luxury British fashion at our Fiumicino stores. Locate a store and discover the newest assortment.",
            "florence": "Explore luxury British fashion at our Florence stores. Locate a store and discover the newest assortment.",
            "milan": "Explore luxury British fashion at our Milan stores. Locate a store and discover the newest assortment."
          },
          "JP":{
            "chiba": "Explore luxury British fashion at our Chiba stores. Locate a store and discover the newest assortment.",
            "fukuoka": "Explore luxury British fashion at our Fukuoka stores. Locate a store and discover the newest assortment.",
            "kobe": "Explore luxury British fashion at our Kobe stores. Locate a store and discover the newest assortment.",
            "kyoto": "Explore luxury British fashion at our Kyoto stores. Locate a store and discover the newest assortment.",
            "mito": "Explore luxury British fashion at our Mito stores. Locate a store and discover the newest assortment.",
            "nagoya": "Explore luxury British fashion at our Nagoya stores. Locate a store and discover the newest assortment.",
            "narita": "Explore luxury British fashion at our Narita stores. Locate a store and discover the newest assortment.",
            "osaka": "Explore luxury British fashion at our Osaka stores. Locate a store and discover the newest assortment.",
            "saitama": "Explore luxury British fashion at our Saitama stores. Locate a store and discover the newest assortment.",
            "sapporo": "Explore luxury British fashion at our Sapporo stores. Locate a store and discover the newest assortment.",
            "sendai": "Explore luxury British fashion at our Sendai stores. Locate a store and discover the newest assortment.",
            "tokyo": "Explore luxury British fashion at our Tokyo stores. Locate a store and discover the newest assortment.",
            "yokohama": "Explore luxury British fashion at our Yokohama stores. Locate a store and discover the newest assortment."
          },
          "KZ":{
            "almaty": "Explore luxury British fashion at our Almaty stores. Locate a store and discover the newest assortment.",
          },
          "KW":{
            "kuwait-city": "Explore luxury British fashion at our Kuwait City stores. Locate a store and discover the newest assortment."
          },
          "LB":{
            "antelias": "Explore luxury British fashion at our Antelias stores. Locate a store and discover the newest assortment.",
            "beirut": "Explore luxury British fashion at our Beirut stores. Locate a store and discover the newest assortment."
          },
          "MO":{
            "macao": "Explore luxury British fashion at our Macau stores. Locate a store and discover the newest assortment.",
          },
          "MY":{
            "kuala-lumpur": "Explore luxury British fashion at our Kuala Lumpur stores. Locate a store and discover the newest assortment."
          },
          "MX":{
            "huixquilucan": "Explore luxury British fashion at our Huixquilucan stores. Locate a store and discover the newest assortment.",
            "mexico-city": "Explore luxury British fashion at our Mexico City stores. Locate a store and discover the newest assortment.",
            "san-pedro-garza-garcia": "Explore luxury British fashion at our San Pedro Garza Garcia stores. Locate a store and discover the newest assortment.",
            "zapopan": "Explore luxury British fashion at our Zapopan stores. Locate a store and discover the newest assortment."
          },
          "NL":{
            "amsterdam": "Explore luxury British fashion at our Amsterdam stores. Locate a store and discover the newest assortment."
          },
          "NO":{
            "oslo": "Explore luxury British fashion at our Oslo stores. Locate a store and discover the newest assortment."
          },
          "NZ":{
            "auckland": "Explore luxury British fashion at our Auckland stores. Locate a store and discover the newest assortment."
          },
          "PA":{
            "panama-city": "Explore luxury British fashion at our Panama City stores. Locate a store and discover the newest assortment."
          },
          "PH":{
            "makati-city": "Explore luxury British fashion at our Makati City stores. Locate a store and discover the newest assortment.",
            "mandaluyong-city": "Explore luxury British fashion at our Mandaluyong City stores. Locate a store and discover the newest assortment."
          },
          "PT":{
            "lisbon": "Explore luxury British fashion at our Lisbon stores. Locate a store and discover the newest assortment.",
            "porto": "Explore luxury British fashion at our Porto stores. Locate a store and discover the newest assortment."
          },
          "QA":{
            "doha": "Explore luxury British fashion at our Doha stores. Locate a store and discover the newest assortment."
          },
          "RO":{
            "bucharest": "Explore luxury British fashion at our Bucharest stores. Locate a store and discover the newest assortment."
          },
          "SA":{
            "jeddah": "Explore luxury British fashion at our Jeddah stores. Locate a store and discover the newest assortment.",
            "riyadh": "Explore luxury British fashion at our Riyadh stores. Locate a store and discover the newest assortment."
          },
          "ZA":{
            "cape-town": "Explore luxury British fashion at our Cape Town stores. Locate a store and discover the newest assortment.",
            "johannesburg": "Explore luxury British fashion at our Johannesburg stores. Locate a store and discover the newest assortment."
          },
          "KR":{
            "bucheon": "Explore luxury British fashion at our Bucheon stores. Locate a store and discover the newest assortment.",
            "busan": "Explore luxury British fashion at our Busan stores. Locate a store and discover the newest assortment.",
            "changwon": "Explore luxury British fashion at our Changwon stores. Locate a store and discover the newest assortment.",
            "cheonan": "Explore luxury British fashion at our Cheonan stores. Locate a store and discover the newest assortment.",
            "daegu": "Explore luxury British fashion at our Daegu stores. Locate a store and discover the newest assortment.",
            "daejeon": "Explore luxury British fashion at our Daejeon stores. Locate a store and discover the newest assortment.",
            "goyang": "Explore luxury British fashion at our Goyang stores. Locate a store and discover the newest assortment.",
            "gwangju": "Explore luxury British fashion at our Gwangju stores. Locate a store and discover the newest assortment.",
            "incheon": "Explore luxury British fashion at our Incheon stores. Locate a store and discover the newest assortment.",
            "kyungki-do": "Explore luxury British fashion at our Kyungki-do stores. Locate a store and discover the newest assortment.",
            "seogwipo": "Explore luxury British fashion at our Seogwipo stores. Locate a store and discover the newest assortment.",
            "seoul": "Explore luxury British fashion at our Seoul stores. Locate a store and discover the newest assortment.",
            "sungnam": "Explore luxury British fashion at our Sungnam stores. Locate a store and discover the newest assortment.",
            "uijeoungbu": "Explore luxury British fashion at our Uijeoungbu stores. Locate a store and discover the newest assortment.",
            "ulsan": "Explore luxury British fashion at our Ulsan stores. Locate a store and discover the newest assortment.",
            "yongin": "Explore luxury British fashion at our Yongin stores. Locate a store and discover the newest assortment."
          },
          "ES":{
            "barcelona": "Explore luxury British fashion at our Barcelona stores. Locate a store and discover the newest assortment."
          },
          "SE":{
            "stockholm": "Explore luxury British fashion at our Stockholm stores. Locate a store and discover the newest assortment."
          },
          "CH":{
            "geneva": "Explore luxury British fashion at our Geneva stores. Locate a store and discover the newest assortment.",
            "zurich": "Explore luxury British fashion at our Zurich stores. Locate a store and discover the newest assortment."
          },
          "TW":{
            "hsinchu-city": "Explore luxury British fashion at our Hsinchu City stores. Locate a store and discover the newest assortment.",
            "kaohsiung-city": "Explore luxury British fashion at our Kaohsiung City stores. Locate a store and discover the newest assortment.",
            "taichung-city": "Explore luxury British fashion at our Taichung City stores. Locate a store and discover the newest assortment.",
            "tainan-city": "Explore luxury British fashion at our Tainan City stores. Locate a store and discover the newest assortment."
          },
          "TH":{
            "bangkok": "Explore luxury British fashion at our Bangkok stores. Locate a store and discover the newest assortment."
          },
          "TR":{
            "istanbul": "Explore luxury British fashion at our Istanbul stores. Locate a store and discover the newest assortment.",
            "izmir": "Explore luxury British fashion at our Izmir stores. Locate a store and discover the newest assortment."
          },
          "AE":{
            "abu-dhabi": "Explore luxury British fashion at our Abu Dhabi stores. Locate a store and discover the newest assortment.",
            "dubai": "Explore luxury British fashion at our Dubai stores. Locate a store and discover the newest assortment."
          },
          "UK":{
            "birmingham": "Explore luxury British fashion at our Birmingham stores. Locate a store and discover the newest assortment.",
            "edinburgh": "Explore luxury British fashion at our Edinburgh stores. Locate a store and discover the newest assortment.",
            "london": "Explore luxury British fashion at our London stores. Locate a store and discover the newest assortment.",
            "manchester": "Explore luxury British fashion at our Manchester stores. Locate a store and discover the newest assortment."
          },
          "VN":{
            "hanoi": "Explore luxury British fashion at our Hanoi stores. Locate a store and discover the newest assortment.",
            "ho-chi-minh-city": "Explore luxury British fashion at our Ho Chi Minh City stores. Locate a store and discover the newest assortment."
          }
        }
      }
    )
    .constant("ORDER_RESULTS_LIST", true)
    .constant("CTA_CONTACT_BURBERRY", {"en":{"label":"Contact Burberry"},"es":{"label":"Contactar con Burberry"},"fr":{"label":"Contacter Burberry"},"it":{"label":"Contatta Burberry"},"pt":{"label":"Entre em contato com a Burberry"},"ru":{"label":"Связаться с Burberry"},"ko":{"label":"버버리에 문의하기"},"ja":{"label":"お問い合わせ"},"zh-tw":{"label":"聯絡 Burberry"},"zh-cn":{"label":"联系我们"},"de":{"label":"Kontakt zu Burberry"}})
    .constant("HAS_MULTILINGUAL", true)
    .constant("LANGUAGE_COOKIE", 'language')
    .constant("DEFAULT_LANGUAGE", "en")
    .constant("SUPPORTED_LANGUAGES", ['en','es','fr','it','pt','ru','ko','ja','zh-tw','zh-cn','de'])
    .constant("LANGUAGE_MODAL", {
      'de': [
        { 'value': 'header', 'label': 'Sprache' },
        { 'value': 'content', 'label': 'Diesen Store können Sie in folgenden Sprachen besuchen:' },
        { 'value': 'select_label', 'label': 'Sprache wählen' },
        { 'value': 'language', 'label': 'Deutsch' },
        { 'value': 'button', 'label': 'Sprache aktualisieren' }
      ],
      'en': [
        { 'value': 'header', 'label': 'Language' },
        { 'value': 'content', 'label': 'You can browse this store in the following languages:' },
        { 'value': 'select_label', 'label': 'Choose a language' },
        { 'value': 'language', 'label': 'English' },
        { 'value': 'button', 'label': 'Update language' }
      ],
      'es': [
        { 'value': 'header', 'label': 'Idioma' },
        { 'value': 'content', 'label': 'Puedes navegar por esta tienda en los siguientes idiomas:' },
        { 'value': 'select_label', 'label': 'Elige un idioma' },
        { 'value': 'language', 'label': 'Español' },
        { 'value': 'button', 'label': 'Actualizar idioma' }
      ],
      'fr': [
        { 'value': 'header', 'label': 'Langue' },
        { 'value': 'content', 'label': 'Celle-ci est disponible dans les langues suivantes:' },
        { 'value': 'select_label', 'label': 'Choisir une langue' },
        { 'value': 'language', 'label': 'Français' },
        { 'value': 'button', 'label': 'Changer la langue' }
      ],
      'it': [
        { 'value': 'header', 'label': 'Lingua' },
        { 'value': 'content', 'label': 'Puoi visualizzare la boutique nelle seguenti lingue:' },
        { 'value': 'select_label', 'label': 'Seleziona lingua' },
        { 'value': 'language', 'label': 'Italiano' },
        { 'value': 'button', 'label': 'Aggiorna lingua' }
      ],
      'pt': [
        { 'value': 'header', 'label': 'Idioma' },
        { 'value': 'content', 'label': 'A página pode ser visualizada nos idiomas a seguir:' },
        { 'value': 'select_label', 'label': 'Alterar idioma' },
        { 'value': 'language', 'label': 'Português' },
        { 'value': 'button', 'label': 'Atualizar idioma' }
      ],
      'ru': [
        { 'value': 'header', 'label': 'Язык' },
        { 'value': 'content', 'label': 'Доступные языки для этого магазина:' },
        { 'value': 'select_label', 'label': 'Выбрать язык' },
        { 'value': 'language', 'label': 'Русский' },
        { 'value': 'button', 'label': 'Изменить язык' }
      ],
      'ko': [
        { 'value': 'header', 'label': '언어' },
        { 'value': 'content', 'label': '본 스토어에서는 다음 언어로 쇼핑을 즐기실 수 있습니다.' },
        { 'value': 'select_label', 'label': '언어 선택' },
        { 'value': 'language', 'label': '한국어' },
        { 'value': 'button', 'label': '언어 변경하기' }
      ],
      'ja': [
        { 'value': 'header', 'label': '言語' },
        { 'value': 'content', 'label': '当オンラインストアは以下の言語で閲覧できます：' },
        { 'value': 'select_label', 'label': '言語を選択' },
        { 'value': 'language', 'label': '日本語' },
        { 'value': 'button', 'label': '言語を更新' }
      ],
      'zh-cn': [
        { 'value': 'header', 'label': '语言' },
        { 'value': 'content', 'label': '敬请选择以下语言浏览此店铺：' },
        { 'value': 'select_label', 'label': '选择语言' },
        { 'value': 'language', 'label': '简体中文' },
        { 'value': 'button', 'label': '更改语言' }
      ],
      'zh-tw': [
        { 'value': 'header', 'label': '語言' },
        { 'value': 'content', 'label': '您可選擇下列語言瀏覽此店櫃：' },
        { 'value': 'select_label', 'label': '選擇語言' },
        { 'value': 'language', 'label': '繁體中文' },
        { 'value': 'button', 'label': '更新語言' }
      ]
    })
    .constant("LAYOUT_ASSETS_PATH", 'app/custom/clients/burberry/layout/')
    .constant("QUERY_BY_SLUG", true)
    .constant("STORE_LOCATOR_ROUTES", {
      home: { url: "/:language" },
      siteMap: { url: "/:language/site-map" },
      siteMapAll: { url: "/:language/site-map/all" },
      siteMapCountry: { url: "/:language/site-map/:country" },
      siteMapLocality: { url: "/:language/site-map/:country/:locality" },
      localLanding: { url: "/:language/:country/:locality/:address" },
      customLocalLandingUS: { url: "/:language/us/:region/:locality/:address", params: { country: 'us' } },
      customSiteMapRegionUS: { url: "/:language/site-map/us/:region", params: { country: 'us' }},
      customSiteMapLocalityUS: { url: "/:language/site-map/us/:region/:locality", params: { country: 'us' } },
    });
})();

(function () {
    'use strict';

    angular
      .module('storeLocator')
      .service('tabsService', tabsService);

    function tabsService(STORE_LOCATOR_TABS) {
        var tabs = null;

        setTabs();

        function setTabs() {
            tabs = STORE_LOCATOR_TABS ? JSON.parse(STORE_LOCATOR_TABS) : null;
        }

        this.showTabs = function () {
            return tabs && tabs.tabs && tabs.tabs.length > 0;
        };

        this.getTabs = function () {
            return tabs.tabs;
        };

        this.getActiveTab = function () {
            var activeTab = null;
            if (tabs && tabs.tabs) {
                activeTab = _.find(tabs.tabs, function (tab) {
                    return tab.active;
                });
            }
            return activeTab;
        };

        this.setActiveTab = function (tab) {
            if (tabs && tabs.tabs) {
                _.each(tabs.tabs, function (t) {
                    if (t.type === tab.type) {
                        t.active = true;
                    } else {
                        t.active = false;
                    }
                });
            }
        };

        this.isCollapsedForMobile = function () {
            return tabs.collapseForMobile;
        };

        this.getCollapsedText = function () {
            return tabs.collapsedText;
        };
    }
})();

(function () {
    'use strict';
    angular
      .module("storeLocator")
      .service('storeLocatorCache', storeLocatorCache);

    function storeLocatorCache() {
        var storeLocator = {};

        this.save = function save(key, value) {
            storeLocator[key] = value;
        }

        this.get = function get(key) {
            return storeLocator[key];
        }

        this.remove = function remove(key) {
            delete storeLocator[key];
        }

        this.clear = function clear() {
            storeLocator = {};
        }
    }
}());

(function () {
  'use strict';

  angular
    .module('storeLocator')
    .service('markersUtils', markersUtils);

  markersUtils.$inject = [
    'MAPBOX_KEY',
    'MAPBOX_BBOX',
    'APIMapboxService',
    'localLandingData',
    'STORE_LOCATOR_SEARCH_COUNTRY',
    'STORE_LOCATOR_SEARCH_TYPE',
    'mapHelper',
    'geocodeService'];
  function markersUtils(
    MAPBOX_KEY,
    MAPBOX_BBOX,
    APIMapboxService,
    localLandingData,
    STORE_LOCATOR_SEARCH_COUNTRY,
    STORE_LOCATOR_SEARCH_TYPE,
    mapHelper,
    geocodeService) {

    this.getAutoCompleteLocations = function (address, latitude, longitude) {
      var params = {
        "access_token": MAPBOX_KEY,
        "country": STORE_LOCATOR_SEARCH_COUNTRY,
        "types": STORE_LOCATOR_SEARCH_TYPE,
        "limit": 10
      };
      if (latitude && longitude) params.proximity = longitude + "," + latitude;
      if (MAPBOX_BBOX) params.bbox = MAPBOX_BBOX;

      return APIMapboxService.getFeatures(address, params);
    };

    this.getLatLogFromAddress = function (address, latitude, longitude, bounds) {
      if (mapHelper.isGoogleMapsEnabled()) {
        return geocodeService.geocodeGoogle(address, bounds);
      }
      else {
        return geocodeService.geocodeMapbox(address, latitude, longitude);
      }
    };

    this.getMapAreaLocations = function (center, bounds, filters, limit) {
      var geo_string = bounds.southWest.lat + "," + bounds.northEast.lng + "," + bounds.northEast.lat + "," + bounds.southWest.lng;
      var center_point_string = center;

      return localLandingData.getLocationsForSearch(center_point_string, geo_string, filters, limit);
    };

    this.getLocationsByName = function (name, limit, page) {
      return localLandingData.getLocationsByName(name, limit, page);
    };

    this.getLocationById = function (id) {
      return localLandingData.getLocationById(id);
    };

  }
})();

/**
 * Created by angie on 3/28/17.
 */
(function () {
  'use strict';

  angular
    .module('storeLocator')
    .factory('mapHelper', mapHelper);

  mapHelper.$inject = ['_', 'filtersService', 'storeLocatorDictionary', 'STORE_LOCATOR_MAP_TYPE', 'MFeedMap', 'geocodeService', 'STORE_LOCATOR_ZOOMOUT_ON_MOBILE_SEARCH'];
  function mapHelper(_, filtersService, storeLocatorDictionary, STORE_LOCATOR_MAP_TYPE, MFeedMap, geocodeService, STORE_LOCATOR_ZOOMOUT_ON_MOBILE_SEARCH) {

    return {
      geoLocationError: geoLocationError,
      setGeoStates: setGeoStates,
      setCoordinates: setCoordinates,
      setCoordinatesAndPlace: setCoordinatesAndPlace,
      setSearchCoordinates: setSearchCoordinates,
      loadList: loadList,
      setPlace: setPlace,
      isGoogleMapsEnabled: isGoogleMapsEnabled,
      displayMapPopUp: displayMapPopUp,
    };

    function geoLocationError(locatorStates) {
      locatorStates.message = 'Share your location or type a location in the search box';
      locatorStates.zoom = storeLocatorDictionary.zoomLevels.initial;
      locatorStates.geoEnabled = false;
      locatorStates.geoPermission = true;
      loadList(locatorStates);
    }

    function setGeoStates(locatorStates) {
      locatorStates.message = 'Fetching your location';
      locatorStates.geoEnabled = true;
      locatorStates.geoPermission = true;
      locatorStates.isRadius = true;
    }

    function setCoordinates(position, locatorStates, mfMap, callback) {
      if (position) {
        locatorStates.current = 'Current Location';
        locatorStates.position = position;
        locatorStates.currentLocationMarker = makeLocationMarker(position);

        var mfLatLng = new MFeedMap.LatLng(position.coords);
        mfMap.setView(mfLatLng, locatorStates.zoom)
        if(callback && (typeof(callback) === 'function')) {
          callback();
        }
      } else {
        locatorStates.message = 'No available coordinates. Please type a location in the search box';
      }
    }

    function setCoordinatesAndPlace(position, locatorStates, mfMap, callback) {
      if (position) {
        locatorStates.current = 'Current Location';
        locatorStates.position = position;
        locatorStates.currentLocationMarker = makeLocationMarker(position);

        geocodeService.reverseGeocodeGoogle(position.coords.latitude, position.coords.longitude).then(function (results) {
          if (results && results.length > 0) {
            var place = getPreferredPlaceMatch(results);
            setPlace(place, locatorStates, mfMap, storeLocatorDictionary.zoomLevels.nearMe);
            if (typeof callback === 'function') {
              callback();
            }
          } else {
            console.log('No results found');
          }
        });

      } else {
        locatorStates.message = 'No available coordinates. Please type a location in the search box';
      }
    }



    function setSearchCoordinates(latitude, longitude, locatorStates, mfMap) {
      locatorStates.message = storeLocatorDictionary.messages.loading;

      if (latitude && longitude) {
        var mfLatLng = new MFeedMap.LatLng({ latitude: latitude, longitude: longitude });
        var isMobile = window.innerWidth < 768;

        var zoomLevel = locatorStates.current && locatorStates.current.type
          ? parseInt(storeLocatorDictionary.zoomLevels[locatorStates.current.type]) - (isMobile && STORE_LOCATOR_ZOOMOUT_ON_MOBILE_SEARCH ? 1 : 0)
          : locatorStates.zoom;

        mfMap.setView(mfLatLng, zoomLevel);
        loadList(locatorStates);
      } else {
        locatorStates.message = 'No available coordinates. Please type a location in the search box';
      }
    }

    /**
     * Sets the map's view to the latitude/longitude and zoom level.
     * @param {google.maps.places.PlaceGeometry} place Zoom level
     * @param {Object} locatorStates Locator states object
     * @param {google.maps} mfMap object
     * @todo This function contains google-specific code. It should be moved to mfeed_map.service.js.
     */
    function setPlace(place, locatorStates, googleMapObj, zoom) {
      if (place.geometry) {
        locatorStates.message = storeLocatorDictionary.messages.loading;
        // Note: The fallback to locatorStates.current is necessary when navigating back to the locator via the breadcrumb on the sitemap or llp
        // since we create a fake place object that only contains the 'geometry' property when loading from the storeLocatorCache.
        locatorStates.current = place.formatted_address || place.name || locatorStates.current;
        // set viewport
        googleMapObj.map.fitBounds(place.geometry.viewport);

        // place.geometry.location is different when load first time and when we use search input
        if(typeof(place.geometry.location.lat) === 'function'){
          var mfLatLng = new MFeedMap.LatLng(place.geometry.location);
        }else{
          var mfLatLng = place.geometry.location;
        }

        googleMapObj.setView(mfLatLng, +zoom || locatorStates.zoom);
        loadList(locatorStates);
      }
    }

    function loadList(locatorStates) {
      locatorStates.reloadMap = true;
      locatorStates.locations = [];
      locatorStates.isLoading = true;
      locatorStates.selectedFilters = filtersService.getSelectedFilters();
    }

    function isGoogleMapsEnabled() {
      return STORE_LOCATOR_MAP_TYPE.toLowerCase() === 'google';
    }

    function makeLocationMarker(position) {
      return {
        "type": "Feature",
        "geometry": {
          "type": "Point",
          "coordinates": [position.coords.longitude, position.coords.latitude]
        },
        "properties": {
          "icon": {
            "className": "current-location-icon",
            "iconSize": null,
            "iconPath": "/assets/images/current_location_marker.png"
          }
        }
      };
    }

    /**
     * Gets the preferred place match from a reverse geocoding result set.
     * @param {google.maps.GeocoderResult[]} results List of GeocoderResult objects returned from Google geocoding service.
     * @returns {google.maps.GeocoderResult}
     */
    function getPreferredPlaceMatch(results) {

      // Look for zipcode first
      var preferred = _.find(results, function (obj) {
        return _.contains(obj.types, 'postal_code');
      });

      // Fallback to 'incorporated city or town political entity'
      if (!preferred) {
        preferred = _.find(results, function (obj) {
          return _.contains(obj.types, 'locality');
        });
      }

      // Fallback to 'county'. Note: This may need to be adjusted for non-US locations.
      if (!preferred) {
        preferred = _.find(results, function (obj) {
          return _.contains(obj.types, 'administrative_area_level_2');
        });
      }

      // Fallback to 'neighborhood'
      if (!preferred) {
        preferred = _.find(results, function (obj) {
          return _.contains(obj.types, 'neighborhood');
        });
      }

      // Fallback to 'state'
      if (!preferred) {
        preferred = _.find(results, function (obj) {
          return _.contains(obj.types, 'administrative_area_level_1');
        });
      }

      // Fallback to the first item in the collection
      if (!preferred) {
        preferred = results[0];
      }

      return preferred;
    }

    function displayMapPopUp(locatorStates) {
      if (locatorStates.locationMarkersArray.length > 0) {
        var marker = locatorStates.locationMarkersArray.find(function(m) {
          return m.number === 1;
        });
        if (isGoogleMapsEnabled() && marker) {
          google.maps.event.trigger(marker.marker, 'click');
        } else {
          var selection = document.querySelectorAll('[alt="mapbox pin-1"]');
          if (selection.length && selection[0]) {
            selection[0].click();
          }
        }
      }
    }

  }

})();

(function () {
  'use strict';

  angular
    .module('storeLocator')
    .service('mapService', mapService);

  function mapService(
    markersUtils,
    $document,
    $window,
    smoothScroll,
    STORE_LOCATOR_LATITUDE,
    STORE_LOCATOR_LONGITUDE,
    storeLocatorDictionary,
    STORE_LOCATOR_LOCATIONS_NO,
    storeLocatorCache,
    urlBuilderFactory,
    LanguageService,
    CLIENT_ROUTE,
    STORE_LOCATOR_DEFAULT_SEARCH_FILTERS,
    $q
  ) {

    this.setMapCtrl = function(ctrl) {
      this.mapCtrl = ctrl;
    };

    this.getMapCtrl = function() {
      return this.mapCtrl;
    };

    //radius function used in sortMarkersByDistance
    var radius = function (lat1, lon1, lat2, lon2) {
      var radlat1 = Math.PI * lat1 / 180;
      var radlat2 = Math.PI * lat2 / 180;
      var theta = lon1 - lon2;
      var radtheta = Math.PI * theta / 180;
      var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
      dist = Math.acos(dist);
      dist = dist * 180 / Math.PI;
      dist = dist * 60 * 1.1515;
      return dist
    };

    //sort the results by distance
    this.sortMarkersByDistance = function (data, mapLat, mapLng) {
      return _.sortBy(data, function (store) {
        return radius(
          store.store_info.latitude,
          store.store_info.longitude,
          mapLat,
          mapLng)
      });
    };

    //create the marker data
    this.createMarker = function (location, counter) {
      var extendedName = _.find(location.custom_fields, {'name': 'name_extended'});
      var lat = location.store_info.latitude;
      var lng = location.store_info.longitude;
      var customLatLong = _.find(location.custom_fields, {'name': 'locator_map_coordinates'});
      if (customLatLong) {
        var latLong = customLatLong.data.split(',');
        lat = latLong[0].trim();
        lng = latLong[1].trim();
      }
      //get search bound offset for marker pin accuracy
      var newStoreLng;
      var offset = storeLocatorCache.get('offset')
      var currBounds = storeLocatorCache.get('currentBounds')

      if(offset!== undefined && storeLocatorCache.get('change')) {
        if (currBounds>180) {
          newStoreLng = parseFloat(lng) + (offset * 360);
        }
        else if(currBounds<-180) {
          newStoreLng = -(offset * 360) + parseFloat(lng);
        }
      }
      else{
         newStoreLng = lng;
      }

      this.getDirectionsUrl = function() {
        return urlBuilderFactory.getDirectionsUrl(location.store_info);
      }

      //location object for resultsLi and mapPopup
      var ret = {
        id: location.id,
        number: this.getLocationTag(counter),
        latitude: lat,
        longitude: newStoreLng,
        distance: location.distance,
        name: location.store_info.name,
        extendedName: extendedName ? extendedName.data : '',
        address: location.store_info.address,
        region: location.store_info.region,
        description: location.description,
        address_extended: location.store_info.address_extended,
        postcode: location.store_info.postcode,
        locality: location.store_info.locality,
        phone: location.store_info.phone,
        website: location.store_info.website,
        hours: location.store_info.store_hours,
        additional_info: false,
        special_hours: location.store_info.special_hours,
        country: location.store_info.country,
        link: location.llp_url,
        local_landing_page: location.local_landing_page,
        icon: "/assets/images/poi_icon.png",
        directionsUrl: this.getDirectionsUrl(),
        llpUrlWithLanguage: CLIENT_ROUTE ? CLIENT_ROUTE + '/' + LanguageService.getCurrentLanguage() + location.llp_url : '/' + LanguageService.getCurrentLanguage() + location.llp_url,
        entire_location: location
      };
      ret["id"] = location.id;
      return ret;
    };

    //geo search of coord search
    this.searchMethod = function (locatorStates, bounds) {
      var center = STORE_LOCATOR_LATITUDE + ',' + STORE_LOCATOR_LONGITUDE;
      // set number of return locations as following order, if null move to next:
      // locatorStates.pageSize -> LOCATIONS NO -> 30
      var noOfLocations = locatorStates.pageSize ? locatorStates.pageSize :
        (STORE_LOCATOR_LOCATIONS_NO ? STORE_LOCATOR_LOCATIONS_NO : 30);

      // LLPS-433 Fix
      // This logic should probably be moved to filters.service.js though that service does not appear to currently
      // account for multiple tabs
      var useFilters = true;
      // if the locator page has tabs, only apply filters for the active tab.
      if (locatorStates.tabs) {
        useFilters = locatorStates.activeTab && locatorStates.activeTab.hasFilters;
      }
      var selectedFilters = useFilters ? locatorStates.selectedFilters : null;

      var geo_string;
      if (locatorStates.position.coords) {
        geo_string = locatorStates.position.coords.latitude + ',' + locatorStates.position.coords.longitude;
      }

      // if the user has allowed geo targeting
      if (locatorStates.geoEnabled) {
        storeLocatorCache.save('defaultSearch', false);
        storeLocatorCache.save('geoFlag', true);
        // if the user has moved the map around or used search input
        if (locatorStates.showSearchAreaBtn || locatorStates.searchInput || locatorStates.areaSearched) {
          geo_string = bounds.center.lat + ',' + bounds.center.lng;

          // I'm applying the same rule of line 166 when geo location is disabled
          // So we'll use the center coordinates from the search input when the user search for a specific location
          if (locatorStates.searchInput && locatorStates.searchInputData) {
            geo_string = locatorStates.searchInputData.center[1] + ',' + locatorStates.searchInputData.center[0];
          }
        }

        if (storeLocatorCache.get('clusterLocation')) {
          geo_string = storeLocatorCache.get('clusterLocation').geometry.coordinates[1] + ',' + storeLocatorCache.get('clusterLocation').geometry.coordinates[0];
        }

        // we dont need to refresh list when user has the same input as last time (when back from llp)
        // however, when user drag map and click search area button, the text field will be empty, which is same
        // as last value. so we dont want to use old data
        if (storeLocatorCache.get('input') !== null && !locatorStates.showSearchAreaBtn) {
          if (storeLocatorCache.get('input') === locatorStates.searchInput) {
            if (storeLocatorCache.get('currentLocationsList' && (storeLocatorCache.get('selectedFilters') === selectedFilters))) {
              return storeLocatorCache.get('currentLocationsList');
            }
          }
        }
        storeLocatorCache.save('input', locatorStates.searchInput);
        storeLocatorCache.save('selectedFilters', selectedFilters);

        return markersUtils.getMapAreaLocations(
          geo_string,
          bounds,
          selectedFilters,
          noOfLocations
        );

      } else {
        storeLocatorCache.save('defaultSearch', false);
        // else the user has not allowed geotargeting

        // if the user has moved the map around or used search input
        if (locatorStates.showSearchAreaBtn || locatorStates.searchInput || locatorStates.areaSearched) {
          geo_string = bounds.center.lat + ',' + bounds.center.lng;
          if (storeLocatorCache.get('input') !== null && !locatorStates.showSearchAreaBtn) {
            if (storeLocatorCache.get('input') === locatorStates.searchInput && storeLocatorCache.get('selectedFilters') === storeLocatorCache.selectedFilters) {
              if (storeLocatorCache.get('locationsList')) {
                return storeLocatorCache.get('locationsList');
              }
            }
          }
          if(locatorStates.searchInput && locatorStates.searchInputData){
            geo_string = locatorStates.searchInputData.center[1] + ',' + locatorStates.searchInputData.center[0];
          }

          if (storeLocatorCache.get('clusterLocation')) {
            geo_string = storeLocatorCache.get('clusterLocation').geometry.coordinates[1] + ',' + storeLocatorCache.get('clusterLocation').geometry.coordinates[0];
          }

          // 'input' and 'selectedFilters' together determine a cached locationsList
          storeLocatorCache.save('input', locatorStates.searchInput);
          storeLocatorCache.save('selectedFilters', locatorStates.selectedFilters);

          return markersUtils.getMapAreaLocations(
            geo_string,
            bounds,
            selectedFilters,
            noOfLocations
          );
        } else {
          storeLocatorCache.save('geoFlag', false);
          if (storeLocatorCache.get('locationsList') && (storeLocatorCache.get('selectedFilters') === selectedFilters)) {
            storeLocatorCache.save('defaultSearch', false);
            var deferred = $q.defer();
            deferred.resolve(storeLocatorCache.get('locationsList'));
            return deferred.promise;
          } else {
            // Functionality for adding a default tag to the selected filters to make an initial filtering of locations
            // if user has not shared geolocation or entered any search input or changed the map parameters, check if
            // STORE_LOCATOR_DEFAULT_SEARCH_FILTERS is a string and if so add it to the selected filters
            if (STORE_LOCATOR_DEFAULT_SEARCH_FILTERS && angular.isString(STORE_LOCATOR_DEFAULT_SEARCH_FILTERS)) {
              selectedFilters = selectedFilters !== '' ? selectedFilters + ',' + STORE_LOCATOR_DEFAULT_SEARCH_FILTERS : STORE_LOCATOR_DEFAULT_SEARCH_FILTERS;
            }
            // 'input' and 'selectedFilters' together determine a cached locationsList
            storeLocatorCache.save('input', locatorStates.searchInput);
            storeLocatorCache.save('selectedFilters', selectedFilters);
            storeLocatorCache.save('defaultSearch', true);
            return markersUtils.getMapAreaLocations(
              center,
              bounds,
              selectedFilters,
              noOfLocations
            );
          }
        }
      }
    };

    //scroll to results item from map
    this.scrollToItem = function (locationId) {
      var element = document.getElementById(locationId);
      //set active on li
      var activeRemove = $document.find('.location-li.active')[0];
      if (activeRemove) activeRemove.classList.remove('active');
      var itemToActivate = $document.find('#' + locationId)[0]

      if (itemToActivate) {
        itemToActivate.classList.add('active');
        //scroll to
        if ($window.location.href.indexOf('visionworks') > -1) {
          options = {
            duration: 700,
            easing: 'easeInQuad',
            offset: 575,
            containerId: 'js-results'
          };
          return smoothScroll(element, options);

        } else {
          var options = {
            duration: 700,
            easing: 'easeInQuad',
            offset: $('#js-results').offset().top,
            containerId: 'js-results'
          };
          return smoothScroll(element, options);
        }
      }
    };

    this.getLocationTag = function (number) {
      var pinUseLetters = storeLocatorDictionary.mapConfigs.pinUseLetters;

      if (Boolean(pinUseLetters)) {
        return this.convertNumberToLetter(number);
      } 

      return number;
    }

    // Example:
    // 1 => A | 26 =>  Z | 27 =>  AA | 28 => AB
    this.convertNumberToLetter = function (number) {
      var letter = '';
      var remainder;
      
      while (number > 0) {
          remainder = (number - 1) % 26;
          letter = String.fromCharCode(65 + remainder) + letter;
          number = (number - remainder)/26 | 0;
      }
      return letter || undefined;
    }

    this.requestLocationMarkerById = function (id) {
      return markersUtils.getLocationById(id).then(function (response) {
        return this.createMarker(response[0]);
      }.bind(this));
    }

  }
})();

(function () {
  'use strict';

  angular
    .module('storeLocator')
    .service('filtersService', filtersService);

  function filtersService(STORE_LOCATOR_FILTERS, HAS_MULTILINGUAL, storeLocatorCache, $window, $rootScope) {
    var filters = null,
      filterTypes = null,
      selectedFilters = [];

    this.hasFilters = function () {
      return filters !== null;
    };

    this.getFilterTypes = function () {
      return filterTypes;
    }
    this.getFilters = function () {
      return filters;
    };

    this.getSelectedFilters = function () {
      return selectedFilters.join(',');
    };

    this.addFilter = function (filter) {
      if (filter) {
        selectedFilters = [];
        _.forEach(filters, function (f) {
          if (f.label === filter) {
            f.active = !f.active;
          }
          if (f.active) {
            selectedFilters.push(f.value);
          }
        });
        // addTagsToUrl(selectedFilters)
      }
    };

    this.clearFilters = function () {
      selectedFilters = [];
      _.forEach(filters, function (f) {
        f.active = false;
      });
    };

    this.getFilterLabels = function () {
      var filterLookup = filters.reduce(function(acc, filter) {
        acc[filter.value] = filter.label;
        return acc;
      }, {});

      return selectedFilters.map(function(value) { 
        return filterLookup[value]; 
      }).join(', ');
    };

    this.setFilters = function () {
      if (HAS_MULTILINGUAL) {
        waitForLanguage()
      } else {
        if (STORE_LOCATOR_FILTERS && STORE_LOCATOR_FILTERS !== "") {
          var storeLocatorFilters = typeof STORE_LOCATOR_FILTERS === "object" ? STORE_LOCATOR_FILTERS : JSON.parse(STORE_LOCATOR_FILTERS);
          parseFilters(storeLocatorFilters)
        }
      }
    }

    this.setFilters();

    function waitForLanguage() {
      if (typeof storeLocatorCache.get('language') !== "undefined") {
        var storeLocatorFilters = typeof STORE_LOCATOR_FILTERS === "object" ? STORE_LOCATOR_FILTERS : JSON.parse(STORE_LOCATOR_FILTERS);
        parseFilters(storeLocatorFilters[storeLocatorCache.get('language')]);
      } else {
        setTimeout(waitForLanguage, 250);
      }
    }

    function parseFilters(storeLocatorfilters) {
      filters = storeLocatorfilters;
      filterTypes = _.uniq(_.pluck(filters, "type"));
      _.forEach(filters, function (f) {
        if (f.active) {
          selectedFilters.push(f.value);
        }
      });
      parseUrlTags(storeLocatorfilters)
    }

    function parseUrlTags(storeLocatorfilters) {
      var urlParams = new URLSearchParams($window.location.search);
      var filter = urlParams.get('filter');
      var tags = urlParams.get('tags');

      if (!tags) {
        tags = filter;
      } else if (filter) {
        tags += ',' + filter;
      }

      if (tags) {
        tags = tags.split(",");
        tags = selectedFilters.concat(tags);
        selectedFilters = tags.filter(function (value, index, self) {
          return self.indexOf(value) === index;
        });
        _.forEach(selectedFilters, function (filter) {
          setFilterAsActive(filter)
        });
      }
      $rootScope.$emit('filtersSet', { filters: storeLocatorfilters });
      $rootScope.$emit('filterTypesSet', { filterTypes: filterTypes });
    }

    function setFilterAsActive(filter) {
      _.forEach(filters, function (f) {
        if (f.value === filter) {
          f.active = true
        }
      });
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('storeLocator')
    .directive('tabs', tabs);

  function tabs() {
    return {
      templateUrl: 'app/storeLocator/directives/tabs.directive.html',
      restrict: 'E',
      scope: {},
      controller: tabsController,
      controllerAs: 'tabsCtrl',
      bindToController: {
          locatorStates: '=',
          mapObj: '='
      }
    };

    function tabsController(tabsService) {
        var $ctrl = this;

        $ctrl.collapseForMobile = tabsService.isCollapsedForMobile();
        $ctrl.collapse = $ctrl.collapseForMobile;
        $ctrl.collapsedText = tabsService.getCollapsedText();

        $ctrl.loadData =  function(tab) {
            $ctrl.locatorStates.activeTab = tab;
            tabsService.setActiveTab(tab);
            $ctrl.locatorStates.reloadMap = true;
        }
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('storeLocator')
    .directive('searchByName', searchByName);

  function searchByName(STORE_LOCATOR_SEARCH_BY_NAME_TEMPLATE, mapService) {
    return {
      templateUrl: STORE_LOCATOR_SEARCH_BY_NAME_TEMPLATE,
      restrict: 'E',
      controller: searchByNameController,
      controllerAs: 'searchByNameCtrl',
      bindToController: {
        locatorStates: '=',
        mapObj: '=',
        autocompleteMode: '@'
      },
      link: function(scope, element, attrs) {
        scope.mapCtrl = mapService.getMapCtrl();
      }
    };

    function searchByNameController(mapService, MFeedMarkerService, $location, markersUtils, CUSTOM_DICTIONARY, $scope, STORE_LOCATOR_LOCATIONS_NO) {
      var $ctrl = this;

      $ctrl.searchByNamePlaceholder = CUSTOM_DICTIONARY && CUSTOM_DICTIONARY.searchByNamePlaceholder;
      $ctrl.locations = [];
      var pageSize = $ctrl.locatorStates.pageSize ? $ctrl.locatorStates.pageSize :
        (STORE_LOCATOR_LOCATIONS_NO ? STORE_LOCATOR_LOCATIONS_NO : 30);

      $ctrl.autoCompleteLocations = function(viewValue) {
        $ctrl.locatorStates.isLoading = true;
        $ctrl.locatorStates.current = { name: viewValue };

        return markersUtils.getLocationsByName(viewValue, pageSize)
          .then(function (data) {
            $ctrl.locatorStates.isLoading = false;
            const response = data;

            if ($ctrl.autocompleteMode) {
              $ctrl.locations = response;
              return $ctrl.locations;
            } else {
              resetMarkers();
              const locations = createMarkers(response);

              if (locations.length > 0) {
                addMarkersToMap();
              }
              $ctrl.locatorStates.locations = locations;
            }
          }, function (error) {
            $ctrl.locations = [];
            $ctrl.locatorStates.errors = 'An error occurred. Please try again.';
            document.querySelectorAll('.mf-loader').forEach(function (value) { value.classList.add('ng-hide') })
          });
      };

      if ($location.search().loc_name) {
        $ctrl.locatorStates.searchByNameInput = $location.search().loc_name;
        $ctrl.autoCompleteLocations($location.search().loc_name);
      }

      $ctrl.autoCompleteSelect = function () {
        $location.path($ctrl.locatorStates.searchByNameInput.llp_url);
      };

      $ctrl.inputChanged = function() {
        if (!$ctrl.autocompleteMode) {
          handleEmptyInput($ctrl.locatorStates.searchByNameInput);
        }
      }

      function handleEmptyInput(value) {
        if (!value || (typeof value === 'string' && value.trim() === '')) {
          resetMarkers();
          $ctrl.locatorStates.current = { name: null };
          $ctrl.locatorStates.locations = [];
          $ctrl.mapObj.setView($ctrl.locatorStates.initial.center, $ctrl.locatorStates.initial.zoom);
        }
      }

      function resetMarkers() {
        $ctrl.locatorStates.locationMarkersArray.forEach(function (mfMarker) {
          $ctrl.mapObj.removeMarker(mfMarker);
        });
        $ctrl.locatorStates.locationMarkersArray = [];
      }

      function createMarkers(data) {
        let counter = 1;
        const locations = [];
        data.forEach(function (_location) {
          var location = mapService.createMarker(_location, counter);
          var mfMarker = MFeedMarkerService.createMFMarker($ctrl.mapObj, location, $ctrl.locatorStates, $scope);

          $ctrl.locatorStates.locationMarkersArray.push(mfMarker);
          locations.push(location);
          counter++;
        });
        return locations;
      }

      function addMarkersToMap() {
        $ctrl.mapObj.extendBounds($ctrl.locatorStates.locationMarkersArray.map(function(mfMarker) { return [mfMarker.marker._lngLat.lng, mfMarker.marker._lngLat.lat] }));
        $ctrl.locatorStates.locationMarkersArray.forEach(function (mfMarker) {
          mfMarker.addToMap();
        });
      }
    }
  }
})();


(function () {
  'use strict';

  angular
    .module('storeLocator')
    .directive('search', search);

  function search(STORE_LOCATOR_SEARCH_BAR_TEMPLATE) {
    return {
      templateUrl: STORE_LOCATOR_SEARCH_BAR_TEMPLATE,
      restrict: 'E',
      scope: {
        isGoogleMapsApiLoaded: '='
      },
      controller: searchController,
      controllerAs: 'searchCtrl',
      bindToController: {
        locatorStates: '=',
        mapObj: '=',
        useSquareCheckIcon: '=' // This is a flag to use square check icon instead of default check icon in filters
      }
    };

    function searchController(_, mapHelper, $location, markersUtils, filtersService, $analytics, storeLocatorDictionary, CUSTOM_DICTIONARY, $scope, MFeedMarkerService) {
      var $ctrl = this;
      
      $ctrl.placeholder = CUSTOM_DICTIONARY && CUSTOM_DICTIONARY.placeholder;
      $ctrl.showFilters = false;
      $ctrl.hasFilters = filtersService.hasFilters();
      $ctrl.availableFilters = filtersService.getFilters();
      $ctrl.availableFilterTypes = filtersService.getFilterTypes();
      $ctrl.addFilter = addFilter;
      $ctrl.isGoogleMapsEnabled = mapHelper.isGoogleMapsEnabled();
      $ctrl.places =[];
      $ctrl.useDefaultCheckIcon = $ctrl.useSquareCheckIcon ? false : true;

      $scope.$watch('$viewContentLoaded', function () {
        setTimeout(function () {
          $('ul[role="listbox"]').attr('aria-label', 'Search Location');
        }, 500)
      });

      function addFilter(filter) {
        $ctrl.locatorStates.message = 'Filtering locations...';
        filtersService.addFilter(filter);
        $ctrl.locatorStates.selectedFilters = filtersService.getSelectedFilters();
        $ctrl.performSearch(searchField); // Added call to performSearch function to kickoff search
        mapHelper.loadList($ctrl.locatorStates);
      }

      $ctrl.showFiltersForActiveTab = function () {
        return ($ctrl.locatorStates.activeTab && $ctrl.locatorStates.activeTab.hasFilters) || !$ctrl.locatorStates.activeTab;
      }

       function setLocatorStates(){
        $ctrl.locatorStates.reloadMap = true;
        $ctrl.locatorStates.showLoader = true;
        $ctrl.locatorStates.zoom = storeLocatorDictionary.zoomLevels.nearMe;
        $ctrl.locatorStates.searchInput = "";
        mapHelper.setGeoStates($ctrl.locatorStates);
       }

      $ctrl.userLatLngSearch = function () {
        setLocatorStates();
        if (!_.isUndefined($ctrl.locatorStates.position) && !_.isEmpty($ctrl.locatorStates.position)) {    
          if ($ctrl.isGoogleMapsEnabled) {
            mapHelper.setCoordinatesAndPlace($ctrl.locatorStates.position, $ctrl.locatorStates, $ctrl.mapObj);
          }
          else {
            mapHelper.setCoordinates($ctrl.locatorStates.position, $ctrl.locatorStates, $ctrl.mapObj);
          }
        } else {
          $ctrl.locatorStates.geoEnabled = false;
          navigator.geolocation.getCurrentPosition(successFunction, errorGeolocation);
        }
      };

      var errorGeolocation = function(error) {
        if (error.code === 1) {
          alert("Sorry, we are unable to determine your location at this time");
        }
        mapHelper.geoLocationError($ctrl.locatorStates);
      }

      var successFunction = function (position) {
        setLocatorStates(); 
        if ($ctrl.isGoogleMapsEnabled) { 
          mapHelper.setCoordinatesAndPlace(position, $ctrl.locatorStates, $ctrl.mapObj);
        }
        else {
          mapHelper.setCoordinates(position, $ctrl.locatorStates, $ctrl.mapObj);
        }
        $ctrl.locatorStates.current = $ctrl.locatorStates.current ? $ctrl.locatorStates.current : 'Current Location';
        $scope.safeApply();
      }
  
      $scope.safeApply = function(fn) {
        var phase = this.$root.$$phase;
        if(phase == '$apply' || phase == '$digest') {
          if(fn && (typeof(fn) === 'function')) {
            fn();
          }
        } else {
          this.$apply(fn);
        }
      };

      $ctrl.performSearch = function (searchField) {
        $ctrl.locatorStates.showLoader = true;
        if (searchField.name) {
          $ctrl.locatorStates.matchingText = null;

          // Changes input field from "Search Results" to current location name
          window.setTimeout(function() {
            var locationName = $ctrl.locatorStates.current
            if (searchField.name === "") {searchField.name = locationName}
            $ctrl.locatorStates.searchInput = searchField.name
          }, 1000)

          $analytics.eventTrack("Searched: " + $ctrl.locatorStates.searchInput, { category: "Store Locator", label: "Store Locator" });

          $ctrl.locatorStates.zoom = searchField.type ? storeLocatorDictionary.zoomLevels[searchField.type] : storeLocatorDictionary.zoomLevels.fallback;
          $ctrl.locatorStates.areaSearched = false;

          var data = searchField.feature;
          $ctrl.locatorStates.current = $ctrl.locatorStates.searchInput;
          if (data && !_.isEmpty(data)) {
            var currentLocation = data;
            $ctrl.locatorStates.searchInputData = data;
            if ($ctrl.isGoogleMapsEnabled) {
              var lat = $ctrl.locatorStates.position.coords ? $ctrl.locatorStates.position.coords.latitude : $ctrl.locatorStates.mapCenter.latitude;
              var lon = $ctrl.locatorStates.position.coords ? $ctrl.locatorStates.position.coords.longitude : $ctrl.locatorStates.mapCenter.longitude;

              markersUtils.getLatLogFromAddress($ctrl.locatorStates.searchInput, lat, lon, $ctrl.mapObj.getBounds()).then(function (data) {
                $ctrl.updatePlace(data);
              })
            }
            else {
              mapHelper.setSearchCoordinates(currentLocation.center[1], currentLocation.center[0], $ctrl.locatorStates, $ctrl.mapObj);
              MFeedMarkerService.closeAllPopups($ctrl.mapObj.map);
            }
          } else {
            _.each($ctrl.locatorStates.locationMarkersArray, function (mfMarker) {
              $ctrl.mapObj.removeMarker(mfMarker);
            });
            $ctrl.locatorStates.locations = [];
          }
        }
      };

      $ctrl.autoCompleteLocations = function (viewValue) {
        var lat = $ctrl.locatorStates.position.coords ? $ctrl.locatorStates.position.coords.latitude : $ctrl.locatorStates.mapCenter.latitude;
        var lon = $ctrl.locatorStates.position.coords ? $ctrl.locatorStates.position.coords.longitude : $ctrl.locatorStates.mapCenter.longitude;

        if (typeof viewValue === 'string' && viewValue.trim() === '') {
          return [];
        }
        $ctrl.places = markersUtils.getAutoCompleteLocations(viewValue, lat, lon)
          .then(function (data) {
            return _.map(data.features, function (feature) {
              return { name: feature.place_name, type: feature.place_type[0], feature: feature };
            });
          }, function (error) {
            if(error.status == 404){
              $location.path('/404')
            }
            else if(error.status == 400){
              $location.path('/400')
            }
            else if(error.status == 500){
              $location.path('/500')
            }
            else {
              locatorStates.errors = 'An error occurred. Please try again.';
            }
            document.querySelectorAll('.mf-loader').forEach(function (value) { value.classList.add('ng-hide') })
          });
        $ctrl.places.then(function (thing) {
          $ctrl.places = thing;
        });
        return $ctrl.places;
      };

      $ctrl.autoCompleteSelect = function (searchField) {
        $ctrl.performSearch(searchField);
      };

      $ctrl.googlePlaceChanged = function (place) {
        // The autocomplete box triggers this callback even when the user hits the 'enter' key without selecting an option
        // from the autocomplete list. In that case, the autocomplete box returns a object without a 'geometry' property.
        // We'll attempt to geocode the search string if 'geometry' is undefined.
        if (place.geometry) {
          $ctrl.locatorStates.searchInputData = undefined;
          $ctrl.locatorStates.searchInput = place.formatted_address;
          $ctrl.updatePlace(place);
        }
        else {
          $ctrl.completeLocationAndSearch(place.name)
        }
      };

      $ctrl.updatePlace = function (place) {
        $ctrl.locatorStates.zoom = storeLocatorDictionary.zoomLevels[place.types[0]] ?
          storeLocatorDictionary.zoomLevels[place.types[0]] :
          storeLocatorDictionary.zoomLevels.fallback;
        mapHelper.setPlace(place, $ctrl.locatorStates, $ctrl.mapObj);
      };

      $ctrl.hitSearchBtn = function () {
        if($ctrl.locatorStates.searchInput){
          if($ctrl.isGoogleMapsEnabled){
            $ctrl.completeLocationAndSearch($ctrl.locatorStates.searchInput)
          }
          else if($ctrl.places[0]){
            $ctrl.locatorStates.searchInput = $ctrl.places[0];
          }
          $ctrl.performSearch($ctrl.locatorStates.searchInput);
        }
      };

      $ctrl.completeLocationAndSearch = function (name) {
        $ctrl.autoCompleteLocations(name).then(function () {
          if($ctrl.places.length === 0){
            $ctrl.places[0]= {
              name: $ctrl.locatorStates.searchInput,
              type: $ctrl.places[0].type ? $ctrl.places[0].type : '',
              feature:{}
            }
          }
          $ctrl.performSearch($ctrl.places[0])
        })
      }
    }
  }
})();


(function() {
    'use strict';

    angular
        .module('storeLocator')
        .directive('resultsLi', resultsLi);

    function resultsLi(STORE_LOCATOR_RESULTS_TEMPLATE,CLIENT_ROUTE) {
        return {
            templateUrl: STORE_LOCATOR_RESULTS_TEMPLATE,
            restrict: 'E',
            replace: true,
            scope: {},
            controller: resultsLiController,
            controllerAs: 'resultsLiCtrl',
            bindToController: {
                locatorStates: '=',
                mapObj: '=',
                location: '=',
                translatedMessages: '=',
                lastIndexRemoveTabindex: '=', // used with $last in ng-repeat to get the last index
            }
        };

        function resultsLiController($document, customFieldFactory, urlBuilderFactory,pubSub,storeLocatorCache, RegionService, MAPBOX_CLUSTER, MFeedMarkerService, $scope, storeLocatorDictionary) {
            var $ctrl = this;
            $ctrl.client_route = CLIENT_ROUTE;
            $ctrl.regionService = RegionService;
            $ctrl.hasUserLocation = storeLocatorCache.get('geoFlag');
            $ctrl.hasSearchAddress = storeLocatorCache.get('input');

            var configs = storeLocatorDictionary.mapConfigs;

            // delete tabindex attribute in each li
            if($ctrl.lastIndexRemoveTabindex){
              var elements = document.getElementsByClassName('location-li');
              Array.prototype.forEach.call(elements, function(el) {
                setTimeout(function () {
                  var elem;
                  if (el.hasAttribute('tabindex')) {
                    elem = el;
                  } else {
                    elem = el.querySelector('.clearfix')
                  }
                  elem.removeAttribute('tabindex')
                }, 0);
              });
            }

            $ctrl.hasCustomFieldValue = function (name){
              return customFieldFactory.getValueByName($ctrl.location.entire_location.custom_fields, name) ? true : false;
            };
            $ctrl.getCustomFieldValue = function (customFieldName) {
                return customFieldFactory.getValueByName($ctrl.location.entire_location.custom_fields, customFieldName);
            };
            $ctrl.getTranslatedCustomFieldValue = function (customFieldName) {
              return customFieldFactory.getTranslatedValueByName($ctrl.location.entire_location.custom_fields, customFieldName, storeLocatorCache.get('storeFindersMessages').lang);
            };
            $ctrl.getFieldCountByRegex = function (regEx){
              return customFieldFactory.getFieldCountByRegex($ctrl.location.entire_location.custom_fields, regEx);
            };
            $ctrl.showLocationPopup = function(location_number) {
              var activeRemove = $document.find('.location-li.active')[0];
              if (activeRemove) activeRemove.classList.remove('active');

              if (MAPBOX_CLUSTER) {
                findLocationInCluster($ctrl.mapObj.map, $ctrl.location, $ctrl.mapObj.map.getZoom());

                function findLocationInCluster(map, location, zoomLevel) {
                  map.flyTo({
                    center: [location.longitude, location.latitude],
                    zoom: zoomLevel,
                    duration: 500
                  });

                  var locationFound = map.querySourceFeatures('location-clusters', { filter: ['!', ['has', 'point_count']] }).find(function(point) {
                    return point.properties.id === location.id;
                  });

                  setTimeout(function() {
                    if (!locationFound) {
                      var zoomLevel = $ctrl.mapObj.map.getZoom();
                      zoomLevel++;
                      findLocationInCluster(map, location, zoomLevel);
                    } else {
                      if ($document.find('#' + location.id) && $document.find('#' + location.id)[0]) {
                        $document.find('#' + location.id)[0].classList.add('active');
                      }
                      storeLocatorCache.save('clusterLocation', locationFound);
                      MFeedMarkerService.showClusterPopup(map, storeLocatorCache, location, $scope);
                    }
                  }, 300);
                }

              } else {
                var selectedMarker = _.find($ctrl.locatorStates.locationMarkersArray,
                  function (mfMarker) { return mfMarker.number == location_number });

                if (selectedMarker) {
                  // close other markers
                  $ctrl.locatorStates.locationMarkersArray.forEach(function (m) {
                    m.closePopup();
                  });

                  // zoom in on selected marker
                  selectedMarker.zoomTo();

                  // open selected marker popup
                  selectedMarker.openPopup();

                  storeLocatorCache.save('location', $ctrl.location);
                }
              }
            };
            $ctrl.highlightLocation = function (location_number, loc_id) {
              var activeRemove = $document.find('.location-li.active')[0];
              if (activeRemove) activeRemove.classList.remove('active');

              var active = $document.find('#' + loc_id)[0];
              if (active) active.classList.add('active');

              var selectedMarker = MFeedMarkerService.findMarker($ctrl.locatorStates, location_number);
              MFeedMarkerService.updateMarkerAndPublishEvent($ctrl.locatorStates, $ctrl.location, selectedMarker, configs);
            };
        }
    }
})();

(function() {
  'use strict';

  angular
    .module('storeLocator')
    .directive('results', results);

  results.$inject = ['$filter'];

  function results ($filter) {
    return {
      templateUrl: 'app/storeLocator/directives/results.directive.html',
      restrict: 'E',
      scope: {},
      controller: resultsController,
      controllerAs: 'resultsCtrl',
      bindToController: {
        locatorStates: '=',
        mapObj: '=',
        sortField: "="
      },
      link: function(scope, element, attrs, ctrl) {
        scope.$watch('resultsCtrl.locatorStates.locations', function(newVal, oldVal) {
          if (newVal !== oldVal && newVal && newVal.length > 0 && ctrl.sortField) {
            ctrl.locatorStates.locations = $filter('orderBy')(newVal, ctrl.sortField);
          }
        }, true);
      }
    };

    function resultsController(storeLocatorDictionary, customFieldFactory, ORDER_RESULTS_LIST, RegionService, filtersService) {
        var $ctrl = this;

        $ctrl.showMessage = true;
        $ctrl.orderResultsList = ORDER_RESULTS_LIST;
        $ctrl.groupedData = {};
        $ctrl.getLocations = getLocations;

        $ctrl.GetMessage = function()
        {
            var message = '';
            if ($ctrl.locatorStates.selectedFilters.length > 0) {
                if ($ctrl.locatorStates.locations.length > 0)
                {
                    message = storeLocatorDictionary.messages.resultsWithFilters;
                }
                else {
                    message = storeLocatorDictionary.messages.noResultsWithFilters;
                }
                var filterLabels = filtersService.getFilterLabels();
                message = message.replace('{filters}', filterLabels);
            }
            else {
                if ($ctrl.locatorStates.locations.length > 0) {
                  if ($ctrl.locatorStates.matchingText) {
                    message = storeLocatorDictionary.messages.noResultsDidYouMean;
                    message = message.replace('{locationWanted}', $ctrl.locatorStates.matchingText);
                    message = message.replace('{locationResult}', customFieldFactory.getValueByName($ctrl.locatorStates.locations[0].entire_location.custom_fields,'llp_name') || $ctrl.locatorStates.locations[0].name);
                  } else {
                    message = storeLocatorDictionary.messages.results;
                  }
                }
                else {
                    message = storeLocatorDictionary.messages.noResults;
                }
            }

            $ctrl.locatorStates.current.name == undefined ? message = message.replace('{location}', $ctrl.locatorStates.current) : message = message.replace('{location}', $ctrl.locatorStates.current.name)

            $ctrl.showMessage = message !== '';

            return message;
        }

        function getLocations(locations){
          if(ORDER_RESULTS_LIST){
            orderResultsList(locations);
          }
        }

        function orderResultsList(locations){

          var regionSet = "NONE";
          var regionQuantity = 0;
          for (var i = 0; i < locations.length; i++) {
            if(locations[i].region !== regionSet){
              regionSet = locations[i].region;
              regionQuantity++;
            }
          }

          if(regionQuantity === 1){
            orderResultsListByAttribute(locations, 'locality');
            for (var i = 0; i < locations.length; i++) {
              locations[i].resultTitle = locations[i].locality;
            }
          }else if (regionQuantity > 1){
            orderResultsListByAttribute(locations, 'region');
            for (var i = 0; i < locations.length; i++) {
              locations[i].resultTitle = RegionService.lookupRegionFromCountry(locations[i].country,locations[i].region);
            }
          }

          $ctrl.groupedData = {};
          locations.forEach(function (item) {
            if (!$ctrl.groupedData[item.resultTitle]) {
              $ctrl.groupedData[item.resultTitle] = [];
            }
            $ctrl.groupedData[item.resultTitle].push(item);
          });

        }

        function orderResultsListByAttribute(locations, orderBy) {
          locations.sort(function(a, b) {
            const elementA = a[orderBy].toUpperCase();
            const elementB = b[orderBy].toUpperCase();

            if (elementA < elementB) {
              return -1;
            }
            if (elementA > elementB) {
              return 1;
            }
        
            return 0;
          });
        }

    }
  }

})();

(function() {
  'use strict';

  angular
    .module('storeLocator')
    .directive('mapPopup', mapPopup);

  function mapPopup (STORE_LOCATOR_MAP_POPUP_TEMPLATE, CLIENT_ROUTE) {
    return {
      templateUrl: STORE_LOCATOR_MAP_POPUP_TEMPLATE,
      restrict: 'E',
      scope: {},
      controller: mapPopupController,
      controllerAs: 'mapPopupCtrl'
    };

    function mapPopupController($scope, customFieldFactory, storeLocatorCache, HAS_MULTILINGUAL, RegionService) {
        var $ctrl = this;
        $ctrl.client_route = CLIENT_ROUTE;
        $ctrl.location = $scope.$parent.location;
        $ctrl.regionService = RegionService;
        $ctrl.hasUserLocation = storeLocatorCache.get('geoFlag');
        $ctrl.hasSearchAddress = storeLocatorCache.get('input');
        
        if (HAS_MULTILINGUAL) {
          $ctrl.translatedMessages = storeLocatorCache.get('storeFindersMessages').messages;
          var language = storeLocatorCache.get('language');
          $ctrl.client_route = CLIENT_ROUTE+'/'+language;
        }

        $ctrl.getCustomFieldValue = function (customFieldName) {
            return customFieldFactory.getValueByName($ctrl.location.entire_location.custom_fields, customFieldName);
        }

      $ctrl.getTranslatedCustomFieldValue = function (customFieldName) {
        return customFieldFactory.getTranslatedValueByName($ctrl.location.entire_location.custom_fields, customFieldName, storeLocatorCache.get('storeFindersMessages').lang);
      }
    }
  }

})();

(function() {
    'use strict';

    angular
        .module('storeLocator')
        .directive('map', map);

    function map(mapService) {
        return {
            templateUrl: 'app/storeLocator/directives/map.directive.html',
            restrict: 'E',
            scope: {
                isGoogleMapsApiLoaded: '='
            },
            controller: mapController,
            controllerAs: 'mapCtrl',
            bindToController: {
                locatorStates: '=',
                mapObj: '=',
                translatedMessages: '=',
                navigateToDetailsPageOnClick: '=',
                highlightMarkerOnClick: '='
            },
            link: function(scope, element, attrs, ctrl) {
              mapService.setMapCtrl(ctrl);
            }
        };

        function mapController($scope,
            mapHelper,
            $location,
            mapService,
            STORE_LOCATOR_MAP_ZOOM_ON_SCROLL,
            MFeedMarkerService,
            geocodeService,
            storeLocatorCache,
            storeLocatorDictionary,
            filtersService,
            $q,
            MAPBOX_CLUSTER,
            DISPLAY_ALL_LOCATIONS_IN_MAP,
            localLandingData,
            DISPLAY_POPUP_ON_LOCATION_SHARED,
            RegionService,
            $rootScope
        ) {

            var $ctrl = this;
            $ctrl.isGoogleMapsEnabled = mapHelper.isGoogleMapsEnabled();
            $ctrl.initialLoadOver = false;
            $ctrl.deferred = $q.defer();
            $ctrl.promise = $ctrl.deferred.promise;
            $ctrl.searchAreaBtnTooltip = $ctrl.translatedMessages ? $ctrl.translatedMessages['mf.storeLocator.searchAreaButton.tooltip'] : 'Search this Area';
            $ctrl.searchAreaBtnText = $ctrl.translatedMessages ? $ctrl.translatedMessages['mf.storeLocator.searchAreaButton'] : 'Search this Area';
            $ctrl.isClusterActive =  MAPBOX_CLUSTER;
            $ctrl.displayAllLocationsInMap = DISPLAY_ALL_LOCATIONS_IN_MAP;

            //show map on inital load
            $ctrl.showMap = function(mfMap) {
              let canvas = document.getElementsByClassName("mapboxgl-canvas");
              if (canvas && canvas.length > 0) {
                canvas[0].setAttribute("role", "img");
                canvas[0].setAttribute("tabindex", "-1");
              }
                $ctrl.mapObj = mfMap; //save map in the controller object for future manipulation
                $ctrl.locatorStates.showLoader = true;

                var urlQueryParams = $location.search();
                if (urlQueryParams && urlQueryParams.loc_q) {
                  $ctrl.locatorStates.reloadMap = true;
                }

                if (!$ctrl.locatorStates.current !== 'Current Location') {
                    var coordinates = $ctrl.locatorStates.mapCenter;
                    $ctrl.mapObj.setView(
                        {
                            lng:  coordinates.longitude,
                            lat:  coordinates.latitude
                        },
                        $ctrl.locatorStates.zoom
                    );
                }

                if (!STORE_LOCATOR_MAP_ZOOM_ON_SCROLL) {
                    $ctrl.mapObj.setScrollWheelZoom(false);
                }

                $ctrl.mapObj.buildMap($scope, $ctrl.locatorStates, initMapFn, mapHelper.loadList);
            };

            //search this area function
            $ctrl.searchArea = function() {
                $ctrl.locatorStates.searchInput = '';
                $ctrl.locatorStates.current = 'Current Location';
                $ctrl.locatorStates.areaSearched = true;
                mapHelper.loadList($ctrl.locatorStates);
            };

            function initMapFn() {
                // if geolocation is available, set the location accordingly
                var urlQueryParams = $location.search();

                var mapBounds = storeLocatorCache.get('map_bounds');
                storeLocatorCache.save('selectedFilters', filtersService.getSelectedFilters());
                var loadFromCache = !angular.isUndefined(mapBounds);

                if (!angular.equals(urlQueryParams,{}) && urlQueryParams.loc_q) {
                  $ctrl.promise.then(function(data) {
                    loadBySearchParameter(urlQueryParams);
                  })
                }
                else if (loadFromCache) {
                  loadCachedValues(mapBounds);
                } 
                else if ($ctrl.locatorStates.searchType === 'location') {
                  $ctrl.locatorStates.message = 'Share your location or type a location in the search box';
                  getLocation().then(successFunction).catch(function(){
                    mapHelper.geoLocationError($ctrl.locatorStates);
                  });
                }
            }

          function getLocation() {
            var promise = new Promise(function(resolve, reject) {
              if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(
                  function(position){
                    resolve(position)
                  },
                  function (error){
                    reject(error);
                  }
                );
              } else {
                $ctrl.locatorStates.notifications = "Geolocation is not supported for this Browser/OS version yet.";
                reject();
              }
            });

            return promise;
          }

            function loadBySearchParameter(searchedValue) {
                $ctrl.locatorStates.searchInput = searchedValue.loc_q;
                if (searchedValue.pageSize){
                  $ctrl.locatorStates.pageSize = searchedValue.pageSize;
                }
                // geocode loc_q param and set the viewport using results before loading the map
                if ($ctrl.isGoogleMapsEnabled) {
                    geocodeService.geocodeGoogle($ctrl.locatorStates.searchInput)
                        .then(function (place) {
                            $ctrl.locatorStates.current = $ctrl.locatorStates.searchInput;
                            $ctrl.locatorStates.zoom = storeLocatorDictionary.zoomLevels[place.types[0]] ?
                            storeLocatorDictionary.zoomLevels[place.types[0]] :
                            storeLocatorDictionary.zoomLevels.fallback;
                           mapHelper.setPlace(place, $ctrl.locatorStates, $ctrl.mapObj);
                        });
                } else {
                    geocodeService.geocodeMapbox($ctrl.locatorStates.searchInput)
                        .then(function (result) {
                          $ctrl.locatorStates.matchingText = null;
                          if (result) {
                            if (!result.text.toLowerCase().includes($ctrl.locatorStates.searchInput.toLowerCase())) {
                              $ctrl.locatorStates.matchingText = $ctrl.locatorStates.searchInput;
                            }
                            $ctrl.locatorStates.zoom = result.place_type[0] ?
                              storeLocatorDictionary.zoomLevels[result.place_type[0]] :
                              storeLocatorDictionary.zoomLevels.fallback;
                            $ctrl.locatorStates.current = $ctrl.locatorStates.searchInput;
                            mapHelper.setSearchCoordinates(result.geometry.coordinates[1],
                              result.geometry.coordinates[0],
                              $ctrl.locatorStates,
                              $ctrl.mapObj);
                          }
                        });
                }
            }

            function loadCachedValues(bounds) {
                if ($ctrl.isGoogleMapsEnabled) {
                    var place = buildGeometry(bounds);
                    mapHelper.setPlace(place, $ctrl.locatorStates, $ctrl.mapObj);
                } else {
                    $ctrl.locatorStates.reloadMap = false;
                    $scope.safeApply()
                    mapHelper.setSearchCoordinates(bounds.center.lat,
                        bounds.center.lng,
                        $ctrl.locatorStates,
                        $ctrl.mapObj);
                    $scope.safeApply();

                }

                function buildGeometry(bounds) {
                    var ne = new google.maps.LatLng(bounds.northEast.lat, bounds.northEast.lng);
                    var sw = new google.maps.LatLng(bounds.southWest.lat, bounds.southWest.lng);

                    var mapGeometry = {
                        geometry: {
                            location: {
                                lat: bounds.center.lat,
                                lng: bounds.center.lng
                            },
                            viewport: new google.maps.LatLngBounds(sw, ne)
                        }
                    }

                    return mapGeometry;
                }
            }

            var successFunction = function(position) {
              var loadMapCallback = function() {
                    $ctrl.userLat = position.coords.latitude;
                    $ctrl.userLng = position.coords.longitude;
                    $ctrl.locatorStates.areaSearched = false;
                    $ctrl.initialLoadOver = true;
                    loadMap($ctrl.locatorStates, $ctrl.mapObj);
                }

                mapHelper.setGeoStates($ctrl.locatorStates);

                if ($ctrl.isGoogleMapsEnabled) {
                  mapHelper.setCoordinatesAndPlace(position, $ctrl.locatorStates, $ctrl.mapObj, loadMapCallback);
                } else {
                  mapHelper.setCoordinates(position, $ctrl.locatorStates, $ctrl.mapObj, loadMapCallback);
                }
            };

            //Necessary checks for the mapBox obj to return bounds within -180 & 180
            function mapBoxBoundsChecker (checkBounds){

              if(checkBounds.center.lng>180){
                var offset =0;

                while(checkBounds.center.lng>180) {
                  checkBounds.center.lng -= 360;
                  checkBounds.northEast.lng -= 360;
                  checkBounds.southWest.lng -= 360;
                  offset+=1;
                }

                //caching original Bounds offset to display pins correctly on map
                storeLocatorCache.save('offset', offset);
                storeLocatorCache.save('change', true);
              }
              else if(checkBounds.center.lng<-180){
                var offset =0;

                while(checkBounds.center.lng<-180){
                  checkBounds.center.lng += 360;
                  checkBounds.northEast.lng +=360;
                  checkBounds.southWest.lng +=360;
                  offset+=1;
                }

                //caching original Bounds offset to display pins correctly on map
                storeLocatorCache.save('offset', offset);
                storeLocatorCache.save('change', true);
              }
              else{
                storeLocatorCache.save('change', false);
              }
              return checkBounds;
            }


            function loadMap(locatorStates, mfMap) {
                var locations = [];

                locatorStates.isLoading = true;
                locatorStates.message = storeLocatorDictionary.messages.loading;
                locatorStates.locations = [];
                locatorStates.selectedFilters = filtersService.getSelectedFilters();

                if (locatorStates.currentLocationMarker &&
                    locatorStates.current === 'Current Location'
                    && !locatorStates.areaSearched) {
                    mfMap.setCurrentLocationMarker(locatorStates.currentLocationMarker);
                }

                var bounds = mfMap.getBounds();
                storeLocatorCache.save('currentBounds', bounds.center.lng);

                bounds = mapBoxBoundsChecker(bounds);

                storeLocatorCache.save('map_bounds', bounds);

                locatorStates.zoom = mfMap.getZoom();

                if($ctrl.locatorStates.searchInput){
                locatorStates.mapCenter.latitude = bounds.center.lat;
                locatorStates.mapCenter.longitude = bounds.center.lng;
                }
                storeLocatorCache.save('state', locatorStates);

                if (MAPBOX_CLUSTER && (!storeLocatorCache.get('geoLocationElements') ||
                  locatorStates.selectedFilters !== storeLocatorCache.get('selectedFilders'))) {

                  MFeedMarkerService.loadClusterPinImage(mfMap.map);
                  localLandingData.getGeoCoordinates(locatorStates.selectedFilters).then(function (responses) {
                    const features = responses.map(function (geoloc) {
                      return {
                        "type": "Feature",
                          "properties": {id: geoloc.id.toString()},
                        "geometry": {
                          "type": "Point",
                          "coordinates": [geoloc.longitude.toFixed(5), geoloc.latitude.toFixed(5)]
                        }
                      }
                    });
                    const geoLocationElements = {
                      "type": "FeatureCollection",
                      "features": features
                    }
                    storeLocatorCache.save('geoLocationElements', geoLocationElements);

                    if ($ctrl.displayAllLocationsInMap && !$ctrl.locatorStates.clusterLocation) {
                      MFeedMarkerService.addClustersClickHandler(mfMap.map, locatorStates, $scope, true, function (location) {
                        $ctrl.locatorStates.clusterLocation = storeLocatorCache.get('clusterLocation');
                      });
                    } else if (!$ctrl.locatorStates.clusterLocation) {
                      MFeedMarkerService.addClustersClickHandler(mfMap.map, locatorStates, $scope, false, function () {
                        $ctrl.locatorStates.clusterLocation = storeLocatorCache.get('clusterLocation');
                        loadMap($ctrl.locatorStates, $ctrl.mapObj);
                      });
                    }
                    locatorStates.geoLocationElements = geoLocationElements;
                    callGeoSearch();
                  });
                } else {
                  callGeoSearch();
                }

              // On initial load, the bounds may be undefined. Don't hit the llp endpoint
              // if we don't have the proper bounds parameter(s).
              function callGeoSearch() {
                if (bounds.center.lat && bounds.center.lng) {
                  mapService.searchMethod(locatorStates, bounds).then(function (data) {
                    $ctrl.deferred.resolve(data);
                    processSearchResult(data);
                  }, function (error) {
                    if(error.status === 404){
                      $location.path('/404')
                    }
                    else if(error.status === 400){
                      $location.path('/400')
                    }
                    else if(error.status === 500){
                      $location.path('/500')
                    }
                    else if(error.status === 503){
                      $location.path('/500')
                    }
                    else {
                      locatorStates.errors = 'An error occurred. Please try again.';
                    }
                    document.querySelectorAll('.mf-loader').forEach(function (value) { value.classList.add('ng-hide') })
                  });
                }
              }
                function processSearchResult(data) {
                  var counter = 1;
                  var response = data;
                  locatorStates.bounds = bounds;

                  function createMarkers() {
                    if (MAPBOX_CLUSTER) {
                      locatorStates.filteredGeoLocationElements = {
                        "type": "FeatureCollection",
                        "features": $ctrl.displayAllLocationsInMap ? locatorStates.geoLocationElements.features :
                          locatorStates.geoLocationElements.features.filter(function(el) {
                              var location = response.find(function(loc) {
                                return loc.id === el.properties.id;
                              })
                              return !!location;
                            })
                      };
                      $ctrl.mapObj.setClusters(locatorStates);

                      response.forEach(function (_location) {
                        var location = mapService.createMarker(_location, counter);
                        locations.push(location);
                        counter++;
                      });

                      locatorStates.locations = locations;
                    } else {
                      locatorStates.locationMarkersArray.forEach(function (mfMarker) {
                        mfMap.removeMarker(mfMarker);
                      });
                      locatorStates.locationMarkersArray = [];

                      response.forEach(function (_location) {
                        var location = mapService.createMarker(_location, counter);
                        var mfMarker = MFeedMarkerService.createMFMarker(mfMap, location, locatorStates, $scope);

                        locatorStates.locationMarkersArray.push(mfMarker);
                        locations.push(location);
                        counter++;
                      });

                      locatorStates.locations = locations;
                      locatorStates.locationMarkersArray.forEach(function (mfMarker) {
                        mfMarker.addToMap();
                      });
                    }
                  }

                  locatorStates.current = locatorStates
                    .current
                    ? locatorStates.current
                    : 'Current Location';
                  locatorStates.message = '';
                  locatorStates.isRadius = false;
                  locatorStates.reloadMap = false;
                  locatorStates.showSearchAreaBtn = false;
                  locatorStates.errors = "";

                  if (response.length > 0) {
                    createMarkers();
                    verifyCountryUnitIsLoaded()
                    if (DISPLAY_POPUP_ON_LOCATION_SHARED && locatorStates.geoEnabled && !locatorStates.areaSearched && !document.getElementById('loc_1')) {
                      mapHelper.displayMapPopUp(locatorStates);
                    }
                  } else {
                    createMarkers();
                    locatorStates.isLoading = false;
                  }
                  $scope.safeApply();
                  $rootScope.$broadcast('map.directive.processSearchResult', locations)
                }

                function verifyCountryUnitIsLoaded(){
                  if(!RegionService.getCurrentCountryUnit()){
                    RegionService.getCountryUnitFromBrowser().then(function(unit){
                      storeLocatorCache.save('countryUnit', unit);
                    }).finally(function(){
                      locatorStates.isLoading = false;
                      $scope.safeApply();
                    })
                  } else {
                    locatorStates.isLoading = false;
                    $scope.safeApply();
                  }
                }
            }

            // watch for the reloadMap field to change
            // wrap in debounce so that reloadMap = false doesn't prevent the previous
            // reloadMap = true from triggering the loadMap function.
            $scope.$watch(angular.bind(this,
                function() {
                    return this.locatorStates.reloadMap;
                }),
                _.debounce(
                  function() {
                    if ($ctrl.locatorStates.reloadMap){
                      loadMap($ctrl.locatorStates, $ctrl.mapObj);
                  }
                },500),
                true);


          $scope.safeApply = function(fn) {
            var phase = this.$root.$$phase;
            if(phase == '$apply' || phase == '$digest') {
              if(fn && (typeof(fn) === 'function')) {
                fn();
              }
            } else {
              this.$apply(fn);
            }
          };

          $scope.$on('$destroy', function() {
            storeLocatorCache.remove('geoLocationElements');
          });

        }
    }
})();

(function () {
  'use strict';

  angular
    .module('storeLocator')
    .directive('clientCss', clientCSS);

  function clientCSS(CLIENT_NAME,s) {
    return function (scope, elem, attr) {
      attr.$addClass(s(CLIENT_NAME).trim().slugify().value());
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('storeLocator')
    .directive('weatherCard', weatherCard);

  function weatherCard () {

    return {
      replace: true,
      scope: {location: '='},
      templateUrl: 'app/localLanding/cards/weatherCard.directive.html',
      restrict: 'AE',
      controllerAs: 'weatherCardC',
      controller: function ($scope, $http) {
        var vm = this;

        vm.location = $scope.location;

        var getWeather = function(){
          $http.jsonp('https://api.forecast.io/forecast/8f2758eb4e1241a07563e22b3c40b0b5/' + vm.location.store_info.latitude + ',' + vm.location.store_info.longitude +'?callback=JSON_CALLBACK')
            .success(function(data) {
              if (data) {
                vm.weather = {
                  temperature: Math.ceil(data.currently.temperature),
                  feelsLike: Math.ceil(data.currently.apparentTemperature),
                  summary: data.currently.summary,
                  icon: data.currently.icon,
                  precipPercent: data.currently.precipProbability * 100,
                  precipType: data.currently.precipType || 'precipitation'

                }
              }
            });
        };

        getWeather();

      }
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('storeLocator')
    .directive('videoEmbedCard', videoEmbedCard);

  function videoEmbedCard() {

    return {
      replace: true,
      scope: {
        customFields: '=',
        customFieldName: "@",
        customHeaderText: "@",
        disableAutoPlay: '@'
      },
      templateUrl: 'app/localLanding/cards/videoEmbedCard.directive.html',
      restrict: 'AE',
      controller: videoEmbedCardController,
      controllerAs: 'videoEmbedCardC',
      bindToController: true
    };
  }

  function videoEmbedCardController(_, $sce, $scope, $document) {
    var videoEmbedCardC = this;

    videoEmbedCardC.customHeaderText = videoEmbedCardC.customHeaderText ? videoEmbedCardC.customHeaderText : 'Featured Video';
    videoEmbedCardC.findLink = _.find(videoEmbedCardC.customFields, {'name': videoEmbedCardC.customFieldName});
    var findChannel = _.find(videoEmbedCardC.customFields, {'name': 'youtube_channel'});

    if (!_.isUndefined(findChannel)) {
      videoEmbedCardC.channel = findChannel.data;
    }

    if (!_.isUndefined(videoEmbedCardC.findLink)) {
      var element = angular.element($document[0].getElementById('video_url'));

      if (videoEmbedCardC.disableAutoPlay) {
        element.attr('sandbox', 'allow-same-origin allow-scripts allow-popups allow-forms');
      }

      //build the embed url
      videoEmbedCardC.link = $sce.trustAsResourceUrl(videoEmbedCardC.findLink.data);

      $scope.$watch('$viewContentLoaded', function () {
        setTimeout(function () {
          if (!_.isUndefined(videoEmbedCardC.findLink) && element[0]) setHeight(element)
        }, 500)
      });
    }

    function setHeight(element) {
      //set the height of the iframe
      element[0].height = element[0].clientWidth / 1.78125;
    }
  }
})();

(function () {
    'use strict';

    angular.module('storeLocator').directive('storeLocatorAmenitiesCard', storeLocatorAmenitiesCard);

    function storeLocatorAmenitiesCard() {
        return {
            replace: true,
            scope: {
                customFields: '=',
                title: '@',
                client: '@'
            },
            templateUrl: 'app/localLanding/cards/storeLocatorAmenitiesCard.directive.html',
            restrict: 'AE',
            controller: storeLocatorAmenitiesCardController,
            controllerAs: 'storeLocatorAmenitiesCardController',
            bindToController: true
        };
    }

    function storeLocatorAmenitiesCardController(amenitiesService) {
        var storeLocatorAmenitiesCardController = this;
        storeLocatorAmenitiesCardController.amenities = [];

        if (typeof storeLocatorAmenitiesCardController.title === 'undefined') {
            storeLocatorAmenitiesCardController.title = 'Amenities';
        }

        if (storeLocatorAmenitiesCardController.customFields) {
            storeLocatorAmenitiesCardController.amenities = amenitiesService.getAmenities(storeLocatorAmenitiesCardController.customFields);
        }

        storeLocatorAmenitiesCardController.showTooltip = function(amenity) {
            amenity.showTooltip = true;
        };

        storeLocatorAmenitiesCardController.hideTooltip = function (amenity) {
            amenity.showTooltip = false;
        };
    }
})();

(function () {
  'use strict';

  angular
    .module('storeLocator')
    .directive('starRatingCard', function () {
      return {
        restrict: 'A',
        template: '<ul class="rating">' +
          '<li ng-repeat="star in stars" ng-class="star">' +
          '\u2605' +
          '</li>' +
          '</ul>',
        scope: {
          ratingValue: '=',
          max: '='
        },
        link: function (scope, elem, attrs) {
          scope.stars = [];
          for (var i = 0; i < scope.max; i++) {
            scope.stars.push({
              filled: i < scope.ratingValue
            });
          }
        }
      }
    })
})();

(function () {
  'use strict';

  angular
    .module('storeLocator')
    .directive('socialCard', socialCard);

  function socialCard() {

    return {
      replace: true,
      scope: {
        location: '=',
        newUrlByProvider: '=', // example: [{type: 'Facebook', url: 'https://www.facebook.com/provider'}];
      },
      templateUrl: 'app/localLanding/cards/socialCard.directive.html',
      restrict: 'AE',
      controller: function ($scope, INSTAGRAM_HANDLE) {
          var socialCardC = this;
          var hasTwitterProvider = _.filter($scope.location.store_info.social_providers, function (p) { return p._type == 'Twitter'; }).length > 0;

          socialCardC.providers = _.filter($scope.location.store_info.social_providers, function (p) {
              return (p.master == true && p._type !== 'Instagram');
          });

          if($scope.newUrlByProvider && socialCardC.providers){
            $scope.newUrlByProvider.forEach(function(newProvider) {
                socialCardC.providers.forEach(function(provider) {
                    if (provider.type === newProvider.type) {
                        provider.url = newProvider.url;
                    }
                });
            });
          }

          // In case the providers array do not return Twitter, but the handle exists, we will push to the providers array
          if (!hasTwitterProvider && $scope.location.twitter_handle) {
            socialCardC.providers.push({ _type: "Twitter"})
          }

          socialCardC.instagramURL='https://www.instagram.com/' + INSTAGRAM_HANDLE;
          socialCardC.instagramHandle=INSTAGRAM_HANDLE;
      },
      controllerAs: 'socialCardC'
    };
  }
})();

(function () {
  'use strict';
  angular
    .module('storeLocator')
    .directive('sitemapErrorCard', sitemapErrorCard);

  function sitemapErrorCard() {
    return {
      replace: true,
      scope: {},
      controller: sitemapErrorCardController,
      controllerAs: 'sitemapErrorCtrl',
      templateUrl: 'app/localLanding/cards/sitemapErrorCard.directive.html',
      restrict: 'AE',
      bindToController: {}
    };

    function sitemapErrorCardController($location, $window) {
      setTimeout(function () {
        var path = $location.path();
        $window.location.href = path.split('/').slice(0, -1).join('/');
      }, 3500)
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('storeLocator')
    .directive('singleImageCard', singleImageCard);

  function singleImageCard() {

    return {
      replace: true,
      scope: {
        location: '=',
        singleImageNumber: '=',
        singleImageTitle: '@',
        singleImageTarget: '@'
      },
      templateUrl: 'app/localLanding/cards/singleImageCard.directive.html',
      restrict: 'AE',
      controller: function ($scope) {
          var vm = this;

          vm.hasData = _.find($scope.location.custom_fields, { 'name': 'single_image' + $scope.singleImageNumber });
          if (vm.hasData) {
              vm.src = _.find($scope.location.custom_fields,
                  { 'name': 'single_image' + $scope.singleImageNumber })
                  .data;
              vm.name = _.find($scope.location.custom_fields,
                  { 'name': 'single_image' + $scope.singleImageNumber })
                  .name;
            
              //set naming for title and alt attributes
              var title = _.find($scope.location.custom_fields, { 'name': 'single_image_title' + $scope.singleImageNumber });
              if (!_.isUndefined(title)) {
                  vm.title = title.data;
              }else{
                  vm.title = $scope.singleImageTitle || "Promo image";
              }

              vm.findLink = _.find($scope.location.custom_fields, { 'name': 'single_url' + $scope.singleImageNumber });
              if (!_.isUndefined(vm.findLink)) {
                  vm.link = vm.findLink.data;
              }
          }

          if(_.isUndefined($scope.singleImageTarget)) {
            vm.singleImageTarget = "_blank";
          }
      },
      controllerAs: 'singleImageCardC'
    };
  }

  
})();

(function () {
  'use strict';

  angular
    .module('storeLocator')
    .directive('promoCard', promoCard);

  function promoCard() {

    return {
      replace: true,
      scope: {
        location: '='
      },
      templateUrl: 'app/localLanding/cards/promoCard.directive.html',
      restrict: 'AE',
      controller: promoCardController,
      controllerAs: 'promoCardC'
    }
  }

  function promoCardController($scope, _) {
    var vm = this;
    vm.promoObject = {};
    vm.myInterval = 4000;
    vm.location = $scope.location;

    var customFields = vm.location.custom_fields;

    function compare(a, b) {
      var nameA = a.name;
      var nameB = b.name;
    
      var comparison = 0;
      if (nameA > nameB) {
        comparison = 1;
      } else if (nameA < nameB) {
        comparison = -1;
      }
      return comparison;
    }
    
    customFields.sort(compare);

    _.each(customFields, function (field) {
      if (isFieldTypeOf(field, 'promo_image')) { //hack for now
        addToPromoObject(field, 'image');
      } else if (isFieldTypeOf(field, 'promo_url')) {
        addToPromoObject(field, 'url');
      } else if (isFieldTypeOf(field, 'analytics_')) {
        addToPromoObject(field, 'analytics_');
      } else if (field.name == "PhoneNumber") {
        vm.phoneNumber = field.data;
      }
    });

    function isFieldTypeOf(field, type) {
      return field.name.indexOf(type) > -1;
    }

    function addToPromoObject(field, type) {
      var name = field.name.replace(type, '');
      if (!_.isUndefined(vm.promoObject[name])) {
        vm.promoObject[name][type] = field.data;
      } else {
        var object = {};
        object[type] = field.data;
        vm.promoObject[name] = object;
      }
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('storeLocator')
    .directive('partnerReviewsCard', partnerReviewsCard);

  function partnerReviewsCard(_, $filter, customFieldFactory, PARTNER_REVIEWS_CARD_TEMPLATE) {
    return {
      replace: true,
      scope: {
        'location': '=',
        'partnertype': '@',
        'fetchReviews': '='

        //@param partnertype can be network name (html/css styling currently only supports 'Yelp', 'Facebook', 'Foursquare, 'Google'. these are not case sensitive)
        //@param partnertype can also be or 'bestrating'/'best rating', 'mostreviews'/'most reviews'
        //@param supports custom fields review_partner_type (which works when html attribute is 'custom') and 'review_rating_minimum'
      },
      templateUrl: PARTNER_REVIEWS_CARD_TEMPLATE,
      restrict: 'AE',
      controllerAs: 'partnerReviewsCardC',
      bindToController: true,
      controller: function (localLandingData) {
        var vm = this;
        function roundUpNearestHalf(value) {
          var remainder = value % 0.5;
          if (remainder > 0 && remainder >= 0.25)
            value = value - remainder + 0.5;
          else
            value = value - remainder;
          return value;
        }

        function getFoursquareColor(rating) {
          if (rating >= 9.0) {
            return '#00B551';
          }
          else if (rating >= 8.0) {
            return '#73CF42';
          }
          else if (rating >= 7.0) {
            return '#C5DE35';
          }
          else if (rating >= 6.0) {
            return '#FFC800';
          }
          else if (rating >= 5.0) {
            return '#FF9600';
          }
          else if (rating >= 4.0) {
            return '#FF6701';
          }
          else {
            return '#E6092C';
          }
        }

        function findBestRatedPartner(partners) {
          var max = 0,
            maxPartner,
            i;
          for (i = 0; i < partners.length; i++) {
            if ('rating' in partners[i] && partners[i].master) {
              if (partners[i]._type === 'Foursquare') {
                if (partners[i].rating / 2.0 > max) {
                  max = partners[i].rating / 2.0;
                  maxPartner = partners[i];
                }
              }
              else {
                if (partners[i].rating > max) {
                  max = partners[i].rating;
                  maxPartner = partners[i];
                }
              }
            }
          }
          return maxPartner;
        }

        function findMostReviewedPartner(partners) {
          var max = 0,
            maxPartner,
            i;
          for (i = 0; i < partners.length; i++) {
            if ('total_reviews' in partners[i] && partners[i].master) {
              if (partners[i].total_reviews > max) {
                max = partners[i].total_reviews;
                maxPartner = partners[i];
              }
            }
          }
          return maxPartner;
        }

        function getRate(partner){
          localLandingData.getListingsForUberallId(vm.location.id).then(function(response){
            findRatingByProvider(partner, response)
          });
        }

        function findRatingByProvider(partner, rates) {
          if (!rates || !angular.isArray(rates)) {
            return;
          }

          var ratingObj = rates.find(function(item) {
            return item._type === vm.partnertype;
          });
          partner.rating = ratingObj.rating;
          partner.total_reviews = ratingObj.total_reviews;
          handleDataRate();
        }

        if (vm.partnertype === 'custom') {
          var customPartnerType = customFieldFactory.getValueByName(vm.location.custom_fields, "review_partner_type");
          if (customPartnerType != null) {
            vm.partnertype = customPartnerType;
          }
          else {
            vm.partnertype = 'bestrating';
          }
        }
        if (vm.partnertype === 'bestrating' || vm.partnertype === 'best rating') {
          var partner = findBestRatedPartner(vm.location.store_info.providers);
        }
        else if (vm.partnertype === 'mostreviews' || vm.partnertype === 'most reviews') {
          var partner = findMostReviewedPartner(vm.location.store_info.providers);
        }
        else {
          var partner = _.find(vm.location.store_info.providers, function (item) {
            return item._type === vm.partnertype.charAt(0).toUpperCase() + vm.partnertype.substr(1).toLowerCase() && item.master;
          });
          if(vm.fetchReviews && partner) {
            getRate(partner);
          }
        }

        vm.pData = false;
        vm.title = vm.location.store_info.name ? vm.location.store_info.name : 'Find us';
        if (partner && !vm.fetchReviews) {
          handleDataRate();
        }
        
        function handleDataRate(){
          vm.partnerName = partner._type;
          vm.minRating = 0.75;
          var minRating = customFieldFactory.getValueByName(vm.location.custom_fields, "review_rating_minimum");
          if (minRating != null) {
            vm.minRating = minRating;
          }
          vm.pData = {};
          vm.pData.itemReviewed = vm.location.store_info.name + ' ' + vm.location.store_info.address;
          vm.pData.url = partner.url;
          vm.pData.rating = parseFloat(partner.rating).toFixed(1);
          vm.pData.ratingFraction = vm.partnerName !== 'Foursquare' ? partner.rating / 5.0 : partner.rating / 10.0;
          vm.pData.reviewCount = partner.total_reviews;
          vm.pData.roundedRating = roundUpNearestHalf(vm.pData.rating, 0.5);
          vm.pData.roundedRatingAsPercentage = (vm.pData.roundedRating / 5.0) * 100 + '%';
          if (vm.partnerName === 'Foursquare') {
            vm.ratingColor = getFoursquareColor(vm.pData.rating);
          }
          if (vm.partnerName === 'Yelp') {
            vm.pData.yelpRoundedRatingString = vm.pData.roundedRating.toString().replace('.', '_');
            vm.pData.yelpStarUrl = 'https://s3-us-west-1.amazonaws.com/mfeed-store-locator.momentfeed.com/momentfeed/cards/partner_reviews/yelp_stars/regular_'
              + vm.pData.yelpRoundedRatingString + '@3x.png';
          }
          if (vm.partnerName === 'Google'){
            vm.pData.roundedRating = Math.round(vm.pData.rating);
          }
        }
      }
    };
  }
})();
(function() {
  'use strict';

  angular
    .module('storeLocator')
    .directive('nearbyCard', nearbyCard);

  function nearbyCard () {

    return {
      replace: true,
      scope: {locations: '=', includeLocality: "@"},
      templateUrl: 'app/localLanding/cards/nearbyCard.directive.html',
      restrict: 'AE',
      bindToController: {title: '=', localPageBtn: '='},
      controller: function ($scope, localLandingData, urlBuilderFactory, customFieldFactory, storeLocatorCache, RegionService) {
        var vm = this;
        var for_geo_search;
        var near = $scope.locations[0];
        vm.getDirectionsUrl = getDirectionsUrl;
        vm.getCustomFieldValueByName = getCustomFieldValueByName;
        vm.getLocalPageUrl = getLocalPageUrl;
        vm.regionService = RegionService;
        vm.includeLocality = $scope.includeLocality == "false" ? false : true;

        localLandingData.getLocationsForGeoSearch(near.store_info.latitude, near.store_info.longitude, 20, 4).then(function (response) {
          if (response.length > 1) {

            $scope.locations = _.filter(response, function (loc) {
              return near.corporate_id !== loc.corporate_id;
            });

          }else{
            $scope.locations = [];
          }
        })

        function getDirectionsUrl(data) {
          return urlBuilderFactory.getDirectionsUrl(data);
        }

        function getCustomFieldValueByName(customFields, name) {
          if (hasCustomFieldValue(customFields, name)) {
            var value = customFieldFactory.getValueByName(customFields, name);
          }
          return value;
        }

        function hasCustomFieldValue(customFields, name) {
          return customFieldFactory.getValueByName(customFields, name) ? true : false;
        }

        function getLocalPageUrl(location) {
          var language = storeLocatorCache.get('language');
          var url = location.llp_url;

          if (!_.isEmpty(language) && !_.isUndefined(language)) {
            return language + url;
          }
          return url;
        }
      },
      controllerAs: 'nearbyCardC'
    };
  }

  nearbyCardController.$inject = ['$scope', 'localLandingData', 'urlBuilderFactory', 'customFieldFactory', 'LanguageService'];
  function nearbyCardController($scope, localLandingData, urlBuilderFactory, customFieldFactory, LanguageService) {
    var vm = this;
    var near = $scope.locations[0];
    vm.getDirectionsUrl = getDirectionsUrl;
    vm.getCustomFieldValueByName = getCustomFieldValueByName;
    vm.getLocalPageUrl = getLocalPageUrl;
    vm.includeLocality = $scope.includeLocality == "false" ? false : true;
    vm.languageService = LanguageService;

    localLandingData.getLocationsForGeoSearch(near.store_info.latitude, near.store_info.longitude, 20, 4).then(function (response) {
      if (response.length > 1) {

        $scope.locations = _.filter(response, function (loc) {
          return near.id !== loc.id;
        });

      } else {
        $scope.locations = [];
      }
    })

    function getDirectionsUrl(data) {
      return urlBuilderFactory.getDirectionsUrl(data);
    }

    function getCustomFieldValueByName(customFields, name) {
      if (hasCustomFieldValue(customFields, name)) {
        var value = customFieldFactory.getValueByName(customFields, name);
      }
      return value;
    }

    function hasCustomFieldValue(customFields, name) {
      return customFieldFactory.getValueByName(customFields, name) ? true : false;
    }

    function getLocalPageUrl(location) {
      var url = vm.personNotLocation ? '/ll/' + location.name + location.llp_url.slice(3, location.llp_url.length) : location.llp_url
      return vm.languageService.updateLinkUrl(url);
    }
  }
})();

(function () {
  'use strict';
  angular
    .module('storeLocator')
    .directive('mfReviewsCard', mfReviewsCard);

  function mfReviewsCard() {
    return {
      replace: true,
      scope: {
        location: '=',
        disable: '@',
        pageSize: '@',
        title: '@'
      },
      controller: RatingController,
      controllerAs: 'RatingCtrl',
      templateUrl: 'app/localLanding/cards/mfReviewsCard.directive.html',
      restrict: 'AE',
      bindToController: {}
    };

    function RatingController(_, $scope, mfReviewFactory) {
      var $ctrl = this;

      $ctrl.enableForm = true;
      $ctrl.enableReviews = true;
      if ($scope.disable) {
        if ($scope.disable.indexOf('form') != -1) {
          $ctrl.enableForm = false;
        }
        if ($scope.disable.indexOf('reviews') != -1) {
          $ctrl.enableReviews = false;
        }
      }

      $ctrl.stars = _.range(0, 5);
      if ($ctrl.max == undefined) {
        $ctrl.max = 5;
      }
      $ctrl.toggle = function (index) {
        $ctrl.activeIndex = index;
      };

      $ctrl.loadText = "Load More Reviews";

      $ctrl.pageNumber = 1;
      mfReviewFactory.getMfReviewFromLocation($scope.location.id, $ctrl.pageNumber, $scope.pageSize, true)
        .then(function (res) {
          $ctrl.reviews = res.plain();
        });

      var params = {
        location_id: $scope.location.id,
        rating: null,
        text: "",
        title: "",
        last_name: "",
        first_name: "",
        email: ""
      };
      $scope.formData = params;
      $ctrl.title = $scope.title || 'Please Leave Us A Rating!';

      $ctrl.onSubmitClick = function () {
        if ($ctrl.activeIndex) {
          $scope.formData.rating = $ctrl.activeIndex + 1;
          $ctrl.isFormActive = true;
          if ($ctrl.isInfoValid()) {
            mfReviewFactory.postMfReviewOnLocation($scope.formData).then(function (res) {
              $ctrl.postMessage = res.status == 200 ? "Thank you for your review! 🎉" : "Service currently unavailable";
            })
          }
        }
      };

      $ctrl.isInfoValid = function () {
        for (var key in $scope.formData) {
          if ($scope.formData[key] == null || $scope.formData[key] == "") {
            return false;
          }
        }
        return true;
      };

      $ctrl.loadMore = function () {
        $ctrl.toggleExpand = true;
        $ctrl.pageNumber += 1;
        if ($ctrl.loadText != "No More Reviews") {
          mfReviewFactory.getMfReviewFromLocation($scope.location.id, $ctrl.pageNumber, $scope.pageSize, true)
            .then(function (res) {
              $ctrl.reviews = $ctrl.reviews.concat(res.plain());
              if (res.plain().length == 0) {
                $ctrl.loadText = "No More Reviews";
              }
            });
        }
      }
    }
  }

})();

(function() {
    'use strict';

    angular.module('storeLocator').directive('menuCard', menuCard);

    function menuCard() {
        return {
            replace: true,
            scope: {
                location: '=',
                name: '=',
                customHeader: '=',
                storeInfo: '=',
                locationId: '=',
                customStoreName: '@',
                link: '@',
                linkText: '@',
                languageCode: '@',
                initMenuItemsShown: '=',
                showMoreText: '@',
                showLessText: '@',
                showImage: '@',
                headingTag: '@'
            },
            templateUrl: 'app/localLanding/cards/menuCard.directive.html',
            restrict: 'AE',
            controller: menuCardController,
            controllerAs: 'menuCardController',
            bindToController: true
        };
    }

    function menuCardController(menuService, $scope) {
        var menuCardController = this;
        var defaultLanguageCode = "EN";

        var showMoreText = menuCardController.showMoreText || "Show More";
        var showLessText = menuCardController.showLessText || "Show Less";
        menuCardController.showMoreLessText = showMoreText;
        menuCardController.tabClick = tabClick;


        menuCardController.showMenu = false;
        if (menuCardController.customStoreName) {
          var findName = _.find(menuCardController.location.custom_fields, { "name": menuCardController.customStoreName });
          menuCardController.customStoreNameData = findName ? findName.data : menuCardController.location.store_info.name;
        } else {
          menuCardController.customStoreNameData = menuCardController.storeInfo.name;
        }

        if (!menuCardController.languageCode) {
            menuCardController.languageCode = defaultLanguageCode;
        }

        function mapCategoryOptions(categoryOptions) {
          var options = new Array();

          for (var marker = 0; marker < categoryOptions.length; marker++) {
            var option = {
              "@type":"MenuItem",
              "name": categoryOptions[marker].name,
              "description":categoryOptions[marker].description.text,
            }

            if (!!categoryOptions[marker].price) {
              option.offers = {
                "@type": "Offer",
                "price": parseFloat(categoryOptions[marker].price.amount).toFixed(2),
                "priceCurrency": categoryOptions[marker].price.currencyCode
              }
            }

            options.push(option)
          }
          return options
        }

      menuService.getMenu(menuCardController.languageCode, (menuCardController.location.id)).then(function (menu) {
        if(menu.length) {
          for(var x = 0; x < menu.length; x++) {
            for(var y = 0; y < menu[x].options.length; y++) {
              if (menu[x].options[y].price && menu[x].options[y].price.amount) {
                menu[x].options[y].price.amount = parseFloat(menu[x].options[y].price.amount).toFixed(2)
              }
            }
          }
          menuCardController.menu = menu;
          menuCardController.schema = {'@context':'http://schema.org', '@type':'Menu','url': menuCardController.storeInfo.website,'name':menuCardController.storeInfo.brand_name,'hasMenuSection': [] };

          for (var i = 0; i < menuCardController.menu.length; i++) {
            var menuCategory = {'@type':'MenuSection', 'name': menuCardController.menu[i].categoryName,'hasMenuItem': mapCategoryOptions(menuCardController.menu[i].options)}
            menuCardController.schema.hasMenuSection.push(menuCategory)
          }

          var head = document.getElementsByTagName('head')[0];
          var script = document.createElement('script');
          script.type = 'application/ld+json';
          script.text = JSON.stringify(menuCardController.schema)
          head.appendChild(script);


          if (menuCardController.menu !== null && menuCardController.menu.length > 0) {
            menuCardController.address = menuCardController.storeInfo.address +
              ", " +
              menuCardController.storeInfo.locality +
              ", " +
              menuCardController.storeInfo.region +
              " " +
              menuCardController.storeInfo.postcode;
            menuCardController.menu[0].active = true;

            setTimeout(function () {
              menuCardController.showMenu = true;
            }, 500);
          }
        } else {
          $scope.$emit('hide-menu-card');
        }
      });

        $scope.$watch('$viewContentLoaded', function () { // When the menu has loaded
          setTimeout(function () {
            var menu = Array.from(document.getElementsByClassName('menu-content'))[0]
            var nav = Array.from(menu.getElementsByClassName('nav-tabs'))[0]

            makeOptionsAccessible() // Add tab indicies to menu items to make them accessible via tabbing
            navigateMenu(nav) // Change focus and tab indicies on category tabs when navigating via arrow keys
          }, 1000)
        });

        function makeOptionsAccessible() {
          var menuOptions = Array.from(document.getElementsByClassName('menu-option'))
          menuOptions.forEach(function(el) {
            el.setAttribute('tabindex', '0');
          })
        }

        function navigateMenu(nav) {
          var tabs = Array.from(nav.children);
          tabs.forEach(function(tab, i) {
            if(i > 0) focusAndSetTabIndicies({negativeOne: tab}) // Set tabindex for category tabs to disable tabbing between

            tab.addEventListener('keydown', function(e){
              var currentTab = this;
              var navtabsLI = Array.from(currentTab.parentNode.children);

              if(e.keyCode == 39) { // When right arrow key is pressed,
                e.preventDefault();
                for(var i = 0; i < navtabsLI.length; i++) {
                  if(navtabsLI[i] == currentTab) {
                    var nextTab = navtabsLI[i + 1]
                    var previousTab = navtabsLI[i]
                    focusAndSetTabIndicies({negativeOne: previousTab, zero: nextTab, focus: nextTab}) // make tab before current inaccessible via tab, make next tab accessible via tab (so you can get back to it by reverse tabbing through the options) and focus on next tab
                  }
                }
              } else if (e.keyCode == 37) { // When left arrow key is pressed,
                e.preventDefault();
                for(var i = 0; i < navtabsLI.length; i++) {
                  if(navtabsLI[i] == currentTab) {
                    var previousTab = navtabsLI[i - 1]
                    focusAndSetTabIndicies({negativeOne: currentTab, zero: previousTab, focus: previousTab}) // make current tab inaccessible via tab, make tab before accessible via tab, put focus on previous tab
                  }
                }
              }
            })
          })
        }

        function focusAndSetTabIndicies(obj) {
          var a;
          for(var key in obj) {
            a = Array.from(obj[key].getElementsByTagName('a'))[0];
            if(key == 'negativeOne') a.setAttribute('tabindex', '-1');
            if(key == 'zero') a.setAttribute('tabindex', '0');
            if(key == 'focus') a.focus();
          }
        }

        function checkIfMenuIsLoaded(){
          var interval = setInterval(function() {
            var menuTabs = document.getElementById('tabset');
            if(menuTabs && menuCardController.menu && menuCardController.showMenu) {
              clearInterval(interval);
              reduceMenuCardLength();
            }
          },100)
        }

        checkIfMenuIsLoaded();

        function reduceMenuCardLength() {
            if(menuCardController.initMenuItemsShown) {
              var activeTab = getActiveTab();
              var activeSection = findActiveSection();
              setOverflowItems(activeTab, activeSection);
            }
        }

        function tabClick() {
          if(menuCardController.initMenuItemsShown) {
            setTimeout(function() {
              var activeSection = findActiveSection();
              var activeTab = getActiveTab();
              if(!activeSection.overflowItems) { setOverflowItems(activeTab, activeSection) }
              if(activeSection.expanded) {
                menuCardController.showMoreLessText = showLessText;
                expandActiveTab(activeTab, activeSection);
              } else {
                menuCardController.showMoreLessText = showMoreText;
              }
            },10)
          }
        }

        function getActiveTab() {
          var content = Array.from(document.getElementsByClassName('content'));
          return content.filter(function(menuSection) { return menuSection.parentElement.classList.contains('active') });
        }

        function findActiveSection() {
          var activeSection = menuCardController.menu.filter(function(item) {
            return item.active;
          })
          return activeSection[0];
        }

        function setOverflowItems(activeTab, activeSection) {
          if (activeTab.length > 0) {
            var overflowItems = Array.from(activeTab[0].getElementsByTagName('li')).slice(menuCardController.initMenuItemsShown, -1);
            Array.from(overflowItems).forEach(function(item){
              if(!item.classList.contains('overflow-item')) { item.classList.add('overflow-item')}
            })
            activeSection.overflowItems = true;
          }
        }

        function expandActiveTab(activeTab, activeSection) {
          activeSection.expanded = true;
          var overflowItems = Array.from(activeTab[0].getElementsByClassName('overflow-item'));
          overflowItems.forEach(function(item) {
            item.classList.add('show-item');
            item.style.maxHeight = item.scrollHeight + "px";
          })
        }

        function collapseActiveTab(activeTab, activeSection) {
          activeSection.expanded = false;
          var overflowItems = Array.from(activeTab[0].getElementsByClassName('overflow-item'));
          overflowItems.forEach(function(item) {
            item.classList.remove('show-item');
            item.style.maxHeight = null;
          })
        }

        menuCardController.numItemsToggle = function() {
          var activeSection = findActiveSection();
          var activeTab = getActiveTab();
          if(!activeSection.expanded) {
            activeSection.expanded = true;
            menuCardController.showMoreLessText = showLessText;
            expandActiveTab(activeTab, activeSection);
          } else {
            activeSection.expanded = false;
            menuCardController.showMoreLessText = showMoreText;
            collapseActiveTab(activeTab, activeSection);
          }
        }
    }
})();


(function () {
  'use strict';

  angular
    .module('storeLocator')
    .directive('mapCard', mapCard);

  function mapCard(
    MAPBOX_KEY,
    STORE_LOCATOR_PIN_ICON,
    STORE_LOCATOR_PIN,
    mapHelper, 
    GOOGLE_API_KEY, 
    $filter,
    $timeout,
    storeLocatorDictionary) {
    return {
      replace: true,
      scope: {
        location: '=',
        height: '@', /* set map height for desktop version, by default is 420px (if we don't define it) */
        mobileHeight: '@', /* set map height for mobile version, by default is 320px (if we don't define it) */
        windowWidth: '=',
        customCoordinates: '@',
        alt: '@'
      },
      templateUrl: 'app/localLanding/cards/mapCard.directive.html',
      restrict: 'AE',
      bindToController: true,
      controllerAs: 'mapCardC',
      controller: function ($scope) {
        var vm = this;
        var mapConfigs = storeLocatorDictionary.mapConfigs;
        if (vm.customCoordinates) {
          var coordinates = vm.customCoordinates.split(',');
          vm.customLatitude = coordinates[0].trim();
          vm.customLongitude = coordinates[1].trim();
        }
        vm.lat = vm.customLatitude || vm.location.store_info.latitude;
        vm.lng = vm.customLongitude || vm.location.store_info.longitude;
        vm.offsetStaticMapImageDesktop = mapConfigs.offsetStaticMapImageDesktop;
        vm.useStaticMapFullWidth = mapConfigs.useStaticMapFullWidth;
        vm.altText = vm.alt ? vm.alt : 'Map to '+ vm.location.store_info.name;
        // If the second parameter, "delay" (in $timeout) is not provided, the default behaviour is to execute the function after the DOM has completed rendering
        // we need it to re-render the map image and be sure it is showing in LP
        $timeout(function() {
          vm.height = vm.height ? vm.height : 420;
          vm.mobileHeight = vm.mobileHeight ? vm.mobileHeight : 320;
        });

        var currentWidth = 999999;
        function updateContainerWidth() {
          var divContainerWidth = document.getElementById('map-container').clientWidth;
          if (divContainerWidth !== currentWidth) {
              currentWidth = divContainerWidth;
              vm.mapContainerWidth = divContainerWidth >= 1280 ? 1280 : divContainerWidth;
          }
        }

        if (vm.useStaticMapFullWidth) {
          // Initial update
          updateContainerWidth();

          // Watch for window width changes
          $scope.$watch(function() {
              return vm.windowWidth;
          }, function(newVal, oldVal) {
              if (newVal !== oldVal) {
                  updateContainerWidth();
              }
          });
        }

        vm.getMapContainerWidth = function() {
          if (vm.mapContainerWidth) {
            return vm.mapContainerWidth;
          } else {
            return vm.windowWidth >= 768 ? 750 : 480;
          }
        }


        vm.getLongitudeWithOffset = function() {
          return vm.lng - vm.offsetStaticMapImageDesktop;
        }

        if (vm.location && vm.location.custom_fields) {
          var pinCF = vm.location && vm.location.custom_fields
            ? vm.location.custom_fields.filter(function(cf) { return cf.name === 'pin_image' })[0]
            : {};
          vm.pinImage = pinCF && pinCF.data ? pinCF.data : '';
        }
        setPinIcon();

        function setPinIcon() {
          vm.isGoogleMapsEnabled = mapHelper.isGoogleMapsEnabled();
          if (vm.isGoogleMapsEnabled) {
            vm.MAP_KEY = GOOGLE_API_KEY;
            if (mapConfigs.pinStaticMapImageSrc) {
              vm.mapPin = "icon:" + $filter('urlCleaner')(mapConfigs.pinStaticMapImageSrc) + "|"
            } else if (vm.pinImage || STORE_LOCATOR_PIN_ICON) {
              vm.mapPin = "icon:" + $filter('urlCleaner')(vm.pinImage || STORE_LOCATOR_PIN_ICON) + "|"
            } else {
              vm.mapPin = "color:" + $filter('removeHash')(STORE_LOCATOR_PIN) + "|"
            }
          } else {
            vm.MAP_KEY = MAPBOX_KEY;
            if (mapConfigs.pinStaticMapImageSrc) {
              vm.mapPin = "url-" + $filter('urlCleaner')(mapConfigs.pinStaticMapImageSrc)
            } else if (vm.pinImage || STORE_LOCATOR_PIN_ICON) {
              vm.mapPin = 'url-' + $filter('urlCleaner')(vm.pinImage || STORE_LOCATOR_PIN_ICON)
            } else {
              vm.mapPin = 'pin-l-1+' + $filter('removeHash')(STORE_LOCATOR_PIN)
            }
          }
        }
      }
    };
  }
})();

(function() {
  'use strict';
  angular
    .module('storeLocator')
    .directive('llpContentCard', llpContentCard);
  function llpContentCard() {
    return {
      replace: true,
      scope: {
        location: '='
      },
      templateUrl: 'app/localLanding/cards/llpContentCard.directive.html',
      restrict: 'AE',
      controller: function(moment, $filter, localLandingData) {
        var vm = this;
        vm.llpCardContent = [];
        localLandingData.getUberallLpContentCardPosts(vm.location.id).then(function (response) {
          vm.llpCardContent = response;
        });
        if(vm.llpCardContent.link_url) {
          vm.filteredLink = $filter('hasHttp')(vm.llpCardContent.link_url);
        } else {
          vm.filteredLink = '';
        }
        vm.published_date_tz = moment.utc(moment(vm.llpCardContent.published_on)).local().format('MMM DD, YYYY [at] h:mm A');
      },
      controllerAs: 'llpContentCardC',
      bindToController: true
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('storeLocator')
    .directive('instagram9Card', instagram9Card);

  function instagram9Card ($sce) {

    return {
      replace: true,
      scope: { photos: '=',location: '='},
      templateUrl: 'app/localLanding/cards/instagram9Card.directive.html',
      restrict: 'AE',
      controller: function ($q,$scope,INSTAGRAM_HANDLE,localLandingData) {
        var vm = this;
        $q.when(localLandingData.getPhotosForLocation($scope.location.id)).then(function (v) {
          if (v.total === 0) {
            return;
          }
          var fallback = "";
          var data = v.media || v;
          if (v.media) {
            data.reverse();
          }
          var foundValidPicture = _.filter(data, function(o) {
            return o.owner.hasOwnProperty('profile_picture_url');
          });
          if (!_.isEmpty(foundValidPicture)) {
            fallback = foundValidPicture[0]['owner']['profile_picture_url'];
          }

          data.map(function (o) {
            o.fallback_url = $sce.trustAsResourceUrl(fallback);
            if (o.thumbnail_url) {
              o.trust_url = $sce.trustAsResourceUrl(o.thumbnail_url);
            } else {
              o.trust_url = $sce.trustAsResourceUrl(o.media_url);
            }
          });
          $scope.photos = vm.photos = data;
        });

        vm.igData = {};
        vm.llp_url = $scope.location.llp_url;
        vm.igData.url = 'https://www.instagram.com/' + INSTAGRAM_HANDLE;
        vm.title = $scope.location.store_info && $scope.location.store_info.name ? $scope.location.store_info.name : 'Find us';

      },
      controllerAs: 'instagram9CardC'
    };
  }
})();


(function () {
  'use strict';

  angular
    .module('storeLocator')
    .directive('imageCard', imageCard);

  function imageCard() {
    return {
      replace: true,
      scope: {
        location: '=',
        customField: '@',
        source: '@',
        visibility: '@',
        target: '@?',
        role: '@?'
      },
      templateUrl: 'app/localLanding/cards/imageCard.directive.html',
      restrict: 'AE',
      controller: imageCardController,
      controllerAs: 'imageCardC',
      bindToController: true
    };
  }

  function imageCardController(_) {
    var vm = this;

    vm.image = _.find(vm.location.custom_fields, { 'name': vm.customField + '_source' });
    vm.imageSrc = vm.image ? vm.image.data : vm.source;

    if (vm.imageSrc) {
      var linkCustomField = _.find(vm.location.custom_fields, { 'name': vm.customField + '_link' });
      vm.imageLink = linkCustomField ? linkCustomField.data : null;
      var titleCustomField = _.find(vm.location.custom_fields, { 'name': vm.customField + '_alt_text' });
      vm.imageTitle = titleCustomField ? titleCustomField.data : null;
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('storeLocator')
    .directive('htmlCard', htmlCard);

  function htmlCard() {

    return {
      replace: true,
      transclude: true,
      scope: {
        location: '=',
        htmlContent: '@'
      },
      templateUrl: 'app/localLanding/cards/htmlCard.directive.html',
      restrict: 'AE',
      controller: htmlCardController,
      controllerAs: 'htmlCardC',
      bindToController: true
    };
  }

  function htmlCardController(_, $sce, customFieldFactory, $transclude, $element) {
    var htmlCardC = this;
    htmlCardC.content = _.find((htmlCardC.location.custom_fields || htmlCardC.location.customFields), {'name': htmlCardC.htmlContent});
    if(htmlCardC.content !== undefined){
      htmlCardC.content.data = customFieldFactory.resolveDynamicFieldsInText(htmlCardC.location.store_info, htmlCardC.location.custom_fields, htmlCardC.htmlContent)

      $transclude(function(transcludedEl, transScope) {
        if (transcludedEl.length > 0) {
          transcludedEl.html(htmlCardC.content.data);
          $element.find('.html-content').replaceWith(transcludedEl);
        }
      });
    }
    htmlCardC.trustAsHtml = function(string) {
      return $sce.trustAsHtml(string);
    };
  }
})();


(function () {
  'use strict';

  angular
    .module('storeLocator')
    .directive('hoursCollapseCard', hoursCollapseCard);

  function hoursCollapseCard() {
    return {
      replace: true,
      scope: {
        location: '=',
        onlyToday: '='
      },
      templateUrl: 'app/localLanding/cards/hoursCollapseCard.directive.html',
      restrict: 'AE',
      controller: HoursController,
      controllerAs: 'hoursCardC',
      bindToController: true
    };
  }

  function HoursController(_, s, moment) {
    var hoursCardC = this;

    var days = _.range(1, 8),
      todayNum = moment().format("E"),
      sh = hoursCardC.location && hoursCardC.location.store_info ? s(hoursCardC.location.store_info.store_hours).trim(";").value() : null,
      formatTime = function (t) {
        return moment(t, "HHmm").format("LT");
      };

    hoursCardC.locHours = false;
    hoursCardC.closedNow = true;
    hoursCardC.openingHours = '';

    if (sh) {
      hoursCardC.locHours = {};
      //Initialize all days as closed
      days.forEach(function (d) {
        hoursCardC.locHours[d + ""] = {
          dayName: moment().isoWeekday(d).format("dddd"),
          dayNameShort: moment().isoWeekday(d).format("dd"),
          dayNameShortNext: moment().isoWeekday(d).add(1, 'd').format("dd"),
          closedLabel: "Closed"
        }
      });

      sh.split(";").forEach(function (dh) {
        var info = dh.split(",").map(function (i) {
            return s(i).trim().value();
        });
        if (info.length) {
          var dayNum = info[0] + "",
            v = hoursCardC.locHours[dayNum];
          v.openTime = formatTime(info[1]);
          v.closeTime = formatTime(info[2]);
          v.openMoment = moment(info[1], "HHmm");
          v.openMoment24 = v.dayNameShort + ' ' + v.openMoment.format("H:mm");

          if(_.startsWith(info[2], '0')) {
            v.closeMoment = moment(info[2], "HHmm").add(1, 'd');
            v.closeMoment24 = v.dayNameShortNext + ' ' + v.closeMoment.format("H:mm");
          } else {
            v.closeMoment = moment(info[2], "HHmm");
            v.closeMoment24 = v.closeMoment.format("H:mm");
          }

          v.openingHours = v.openMoment24 + '-' + v.closeMoment24;
          hoursCardC.openingHours = hoursCardC.openingHours + v.dayNameShort + ' ' + v.openTime + ' - ' + v.closeTime + ' ';

          v.closedLabel = false;
          if(todayNum == dayNum){
            v.highlightClass = 'bold-700';
            var now = moment();
            hoursCardC.openToday = v.openTime;
            hoursCardC.closeToday = v.closeTime;
            if(now.isAfter(v.openMoment) && now.isBefore(v.closeMoment)){
              hoursCardC.closedNow = false;
            }
          }
        }
      });
    }

    hoursCardC.hoursNote = _.find(hoursCardC.location.custom_fields, {'name': 'hours_note'});

  }
})();

(function () {
  'use strict';

  angular
    .module('storeLocator')
    .directive('hoursCard', hoursCard);

  function hoursCard(HOURS_CARD_TEMPLATE) {
    return {
      replace: true,
      scope: {
        location: '=',
        onlyToday: '=',
        customText: '@',
        hideEmptyHours: '=',
        simplified: '=',
        fullTime: '=',
        collapsibleOn: '@', // options are: mobile, desktop, all, or blank
        showReorderedDaysOfWeek: '=?', // order days of week based on current day (shows current day in the top of the list)
        showNextBusinessDay: '=?',
        weeklyHoursCustomMessage: '@?'
      },
      templateUrl: HOURS_CARD_TEMPLATE,
      restrict: 'AE',
      controller: HoursController,
      controllerAs: 'hoursCardC',
      bindToController: true
    };
  }

  function HoursController(_, s, moment, customFieldFactory) {
    var hoursCardC = this;
    hoursCardC.closedNow = true;
    hoursCardC.open24 = false;
    hoursCardC.tempClosed = false;
    hoursCardC.openingHours = '';
    hoursCardC.toggleCollapsibleHours = toggleCollapsibleHours;
    hoursCardC.nextBusinessDay = {};
    hoursCardC.hasCustomFieldValue = hasCustomFieldValue;
    hoursCardC.getCustomFieldValueByName = getCustomFieldValueByName;

    function hasCustomFieldValue(customFields, name) {
        return customFieldFactory.getValueByName(customFields, name) ? true : false;
    }
    function getCustomFieldValueByName(customFields, name) {
      return customFieldFactory.getValueByName(customFields, name);
    }

    // if temp closed, set hoursCardC.tempClosed
    if(hoursCardC.location.status == "temp closed") {
      hoursCardC.tempClosed = true;
    }

    // returns the hour fragment for the day depending on the passed key value
    hoursCardC.getOpenTimePeriodDisplayMessage = function(regularHours, index) {
      var key = '';
      if (angular.isDefined(index)) {
        key = 'openTimePeriodDisplayMessage_' + index;
      } else {
        key = 'openTimePeriodDisplayMessage';
      }
      return regularHours[key];
    };

    hoursCardC.formatWeeklyHours = function (hoursArray) {
      function formatDays(startDay, endDay) {
        return startDay === endDay ? startDay : startDay + ' - ' + endDay;
      }

      var dayMessages = _.map(hoursArray, function (day) {
        var displayHoursMessage = hoursCardC.getOpenTimePeriodDisplayMessage(day, 0);
        var message;

        if (!displayHoursMessage || displayHoursMessage.toLowerCase() === 'closed') {
          message = 'Closed';
        }
        else if (hoursCardC.weeklyHoursCustomMessage) {
          message = hoursCardC.weeklyHoursCustomMessage;
        }
        else {
          message = displayHoursMessage;
        }

        return {
          dayName: day.dayName,
          message: message
        };
      });

      // Check if Sunday is closed and Saturday is closed
      var isSundayClosed = dayMessages.some(function (day) {
        return day.dayName === 'Sunday' && day.message === 'Closed';
      });
      var isSaturdayClosed = dayMessages.some(function (day) {
        return day.dayName === 'Saturday' && day.message === 'Closed';
      });

      // Filter out both Saturday and Sunday if both are closed
      if (isSundayClosed && isSaturdayClosed) {
        dayMessages = dayMessages.filter(function (day) {
          return day.dayName !== 'Saturday' && day.dayName !== 'Sunday';
        });
      } else if (isSundayClosed) {
        // Filter out only Sunday if it is closed
        dayMessages = dayMessages.filter(function (day) {
          return day.dayName !== 'Sunday';
        });
      }

      var formattedHours = [];
      var currentGroup = dayMessages.length > 0 ? [dayMessages[0]] : [];

      // Group days with the same message
      for (var i = 1; i < dayMessages.length; i++) {
        var prev = currentGroup[currentGroup.length - 1];
        var current = dayMessages[i];

        if (prev.message === current.message) {
          currentGroup.push(current);
        } else {
          formattedHours.push(formatDays(currentGroup[0].dayName, currentGroup[currentGroup.length - 1].dayName) + ': ' + prev.message);
          currentGroup = [current];
        }
      }

      // Add the last group
      if (currentGroup.length) {
        var last = currentGroup[currentGroup.length - 1];
        formattedHours.push(formatDays(currentGroup[0].dayName, last.dayName) + ': ' + last.message);
      }

      return formattedHours.join('\n');
    };

    hoursCardC.specialHoursFormat = function (weeklyHours, format) {
      // Assuming weeklyHours is a string or has been formatted to a string
      var formattedHours = weeklyHours;

      // Regex to find matches of the original time format
      var timeFormatRegex = /(\d{1,2}):00 (am|pm) - (\d{1,2}):00 (am|pm)/g;

      // Replace function to adjust the format based on the provided format parameter
      formattedHours = formattedHours.replace(timeFormatRegex, function (match, p1, p2, p3, p4) {
        // Convert "am/pm" to the desired format
        var startPeriod = p2 === 'am' ? format.split('-')[0].replace('h', p1).replace('a.m.', 'a.m.').replace('p.m.', 'a.m.') : format.split('-')[0].replace('h', p1).replace('a.m.', 'p.m.').replace('p.m.', 'p.m.');
        var endPeriod = p4 === 'am' ? format.split('-')[1].replace('h', p3).replace('a.m.', 'a.m.').replace('p.m.', 'a.m.') : format.split('-')[1].replace('h', p3).replace('a.m.', 'p.m.').replace('p.m.', 'p.m.');

        // Return the new format
        return startPeriod + '-' + endPeriod;
      });

      return formattedHours;
    }

    function getNextBusinessDay(locHours) {
      var today = new Date();
      var nextBusinessDay = new Date(today);

      var dayAbbreviations = {
        "Sunday": "Sun.",
        "Monday": "Mon.",
        "Tuesday": "Tues.",
        "Wednesday": "Wed.",
        "Thursday": "Thurs.",
        "Friday": "Fri.",
        "Saturday": "Sat."
      };

      var allDaysClosed = true;
      for (var i = 1; i <= 7; i++) {
        var dayInfo = locHours[i];
        if (dayInfo && !dayInfo.closed && dayInfo.openTimePeriod_0) {
          allDaysClosed = false;
          break;
        }
      }
    
      if (allDaysClosed) {
        hoursCardC.allDaysClosed = true;
      } else {
        do {
          nextBusinessDay.setDate(nextBusinessDay.getDate() + 1);
          var dayOfWeek = nextBusinessDay.getDay(); // 0 (Sunday) to 6 (Saturday)
          var dayKey = dayOfWeek === 0 ? 7 : dayOfWeek; // Convert Sunday (0) to 7 for locHours key
          var dayInfo = locHours[dayKey];
        } while (dayInfo.closed || !dayInfo.openTimePeriod_0);
      }

      return {
        dayName: dayAbbreviations[dayInfo.dayName],
        openingHours: dayInfo.openTimePeriod_0
      };
    }

    hoursCardC.hasStoreOpenedToday = function () {
      if (hoursCardC.closed24) {
        return true;
      }

      if (!hoursCardC.openToday) {
        return false;
      }

      var openTodayParts = hoursCardC.openToday.split(':');
      var openTodayDate = new Date();
      openTodayDate.setHours(parseInt(openTodayParts[0], 10));
      openTodayDate.setMinutes(parseInt(openTodayParts[1], 10));
      openTodayDate.setSeconds(0);
      openTodayDate.setMilliseconds(0);

      var now = new Date();
      return now >= openTodayDate;
    }

    /**
     * function returns true if passed value is null, undefined and legth is zero, else false
     * @param {string} storeTimeZone 
     */
    function checkObj(storeTimeZone) {
      return ( _.isNull(storeTimeZone) || _.isUndefined(storeTimeZone) || storeTimeZone.length === 0 )
    }

    /**
     * function to check if the store is open or closed and set
     * the corresponding 'closedNow' value on the directive object
     * @param {object} hourObj hour object which has all the details about the timings/days
    */
    function updateTodaysHours(hourObj) {
      if (hourObj.closed) {
        hoursCardC.closed24 = true;
        return;
      }
      // check for today's special hours. start
      var isTodaySpecial = isTodaySpecialHours();
      //check for today's special hours. end
      //counter to loop through the number of fragments
      var counter = 0;
      while (counter < hourObj.numberOfTimeFragments.length) {
        var openTimePeriodKey = 'openTimePeriod' + '_' + counter;
        var closeTimePeriodKey = 'closeTimePeriod' + '_' + counter;

        if (hourObj[openTimePeriodKey] && hourObj[closeTimePeriodKey]) {
          hoursCardC[openTimePeriodKey] = moment(hourObj[openTimePeriodKey], "LT").format("LT")
          hoursCardC[closeTimePeriodKey] = moment(hourObj[closeTimePeriodKey], "hh:mm LT").format("LT");
        }

        if (moment(hourObj[closeTimePeriodKey], "LT").isBefore(moment(hourObj[openTimePeriodKey], "LT")) || moment(hourObj[closeTimePeriodKey], "LT").format('HHmm') === '0000') {
          hourObj[closeTimePeriodKey] = moment(hourObj[closeTimePeriodKey], "LT").add(1, 'days');
        }

        var amIBetweenGroupKey = 'amIBetweenGroup' + '_' + counter;
        var now = moment();
        // store timezone code start
        var storeTimeZone = hoursCardC.location.store_info.timezone; // store timezone from api
        var storeCurrentDateTime = null;
        var convertedStoreHour = null;
        var isInvalidObj = checkObj(storeTimeZone);
        if (!isInvalidObj) {
          storeCurrentDateTime = getStoreCurrentTime(storeTimeZone);
          convertedStoreHour = moment(getConvertedStoreHours(storeCurrentDateTime), "LT");
        }
        // store timezone code end
        // instead of now object the comparison is made with convertedStoreHour object
        var startTime = moment(hourObj[openTimePeriodKey], "LT");
        var endTime = moment(hourObj[closeTimePeriodKey], "LT");
        if(!isInvalidObj){
          if (endTime.format('HHmm') < (startTime.format('HHmm'))) {
            if (convertedStoreHour.format('HHmm') < endTime.format('HHmm')) {
              startTime = startTime.subtract(1, 'days');
            } else {
              endTime = endTime.add(1, 'days');
            }
          }
          amIBetweenGroupKey = convertedStoreHour.isBetween(startTime, endTime);
        } else {
          if (endTime.format('HHmm') < (startTime.format('HHmm'))) {
            if (now.format('HHmm') < endTime.format('HHmm')) {
              startTime = startTime.subtract(1, 'days');
            } else {
              endTime = endTime.add(1, 'days');
            }
          }
          amIBetweenGroupKey = now.isBetween(startTime, endTime);
        }

        if (amIBetweenGroupKey) {
          hoursCardC.closeToday = endTime.format("LT");
          // This variable in intended to show the exact time rounded.
          // Then, "6.00 PM" would be "6 PM" and "11.00 AM" would be "11 AM"
          hoursCardC.closeTodayRounded = endTime.minutes() === 0 ? endTime.format("h a") : endTime.format("LT");
          if (amIBetweenGroupKey || hourObj.open24) {
            hoursCardC.closedNow = false;
          } else {
            hoursCardC.closedNow = true;
          }
        } else if(isTodaySpecial && !amIBetweenGroupKey){
          hoursCardC.closeToday = endTime.format("LT");
          hoursCardC.closeTodayRounded = endTime.minutes() === 0 ? endTime.format("h a") : endTime.format("LT");
          hoursCardC.closedNow = true;
        }
        counter++;
      }

      hoursCardC.openToday = hourObj.openDisplayTime;
      hoursCardC.openTodayRounded = hourObj.openTime.minutes() === 0 ? hourObj.openTime.format("h a") : hourObj.openTime.format("h:mm a");
      hoursCardC.open24 = hourObj.open24;
    }

    function isTodaySpecialHours(){
      var isTodaySpecial = false;
      var specialHours = (hoursCardC.location &&
        hoursCardC.location.store_info &&
        hoursCardC.location.store_info.special_hours) ?
        s(hoursCardC.location.store_info.special_hours).trim(";").value() : null;
          
      if (specialHours !== null) {
        // Check if any special hours are coming up.
        var validSpHours = checkSpecialHours(specialHours);
        if (!_.isEmpty(validSpHours)) {
          isTodaySpecial=true;
        }
      } 
      return isTodaySpecial;
    }

    function parseDateStrings(dateStrs) {
      var intDateStrs = dateStrs.split(";");
      return _.map(intDateStrs, function(dateStr) {
        var info = dateStr.split(",");
        if (angular.isDefined(info[1]) && info[1].toUpperCase() === "CLOSED") {
          // return just the day. This way we can use it to determine if today == which hour obj.
          return {
            day: info[0]
          };
        }
        else {
          // Else add open and close times based on the strings.
          // Will moment parse these to more readable strings later.
          return {
            day: info[0],
            openTime: info[1],
            closeTime: info[2]
          };
        }
      });
    }

    /**
     * function generates hours object for each day
     * @param {string} dateStrs open and close times for the week
     * @param {string} closeLabel close label for the location
    */
    function generateHours(dateStrs, closeLabel) {
      // Split up the dateStrs and generate objects for each one
      var parsedDateStrs = parseDateStrings(dateStrs);
      var locHours = {};
      _.range(1, 8).forEach(function(day) {
        // Generate base objects per day
        var newHoursObj = {
          day: day.toString(),
          dayName: moment().isoWeekday(day).format("dddd"),
          dayNameShort: moment().isoWeekday(day).format("dd"),
          dayNameShortNext: moment().isoWeekday(day).add(1, 'd').format("dd"),
          closedLabel: closeLabel
        };
        // filter method gets all the matching objects for a certain day of the week
        var parsedData = _.filter(parsedDateStrs, function(obj) {
          return obj['day'] === day.toString();
        });

        // all the open and close time for the store location in an array
        var openTime = _.map(parsedData, 'openTime');
        var closeTime = _.map(parsedData, 'closeTime');
        // adding the values to the object we will need to display all the times
        // and proper messaging for the store hours
        parsedData = {};
        _.forEach(openTime, function(value, key) {
          //moment js doesn't recognize 2400 hrs
          if (closeTime[key] === '2400') {
            closeTime[key] = '0000';
          }
          parsedData['openTime' + 'PeriodDisplayMessage' + '_' + key] = displayOpenAndClosedTime(openTime[key], closeTime[key]);
          parsedData['openTime' + 'Period' + '_' + key] = openTime[key] ? moment(openTime[key],"hmm").format("LT") : "";
          parsedData['closeTime' + 'Period' + '_' + key] = closeTime[key] ? moment(closeTime[key],"hmm").format("LT") : "";
          parsedData['openTime'] = openTime[0];
          parsedData['closeTime'] = closeTime[0];
          parsedData['numberOfTimeFragments'] = new Array(_.keys(openTime).length);
        });

        //we need the numberOfTimeFragments to display the correct message when clients pass empty store hours for the day
        if (openTime.length === 0) {
          parsedData['numberOfTimeFragments'] = new Array(1);
        }

        _.assign(newHoursObj, parsedData);
        locHours[day] = createHoursObj(newHoursObj);
        // Check if Today. If so, apply highlighting and modify
        // some controller level variables in a separate function.
        if (day.toString() === moment().format("E")) {
          if(!hoursCardC.simplified) {
            locHours[day].highlightClass = "bold-700";
          }
          //initialize the open and close time empty arrays
          openTime = [];
          closeTime = [];
          var counter = 0;
          while (counter < locHours[day]['numberOfTimeFragments'].length) {
            var openTimePeriodKey = 'openTimePeriod' + '_' + counter;
            var closeTimePeriodKey = 'closeTimePeriod' + '_' + counter;
            if (locHours[day][openTimePeriodKey] && locHours[day][openTimePeriodKey].length > 0 && locHours[day][closeTimePeriodKey].length > 0) {
              openTime.push(locHours[day][openTimePeriodKey]);
              closeTime.push(locHours[day][closeTimePeriodKey]);
            }
            counter++;
          }

          // when the location does not have hours for the day we
          // assume that it is closed
          if (openTime.length > 0 && closeTime.length > 0) {
            locHours[day].openTimePeriodDisplayMessage = isTheLocationOpen(openTime, closeTime);
          } else {
            locHours[day].closed = true;
          }
          updateTodaysHours(locHours[day]);
        }
      });

      if (hoursCardC.showReorderedDaysOfWeek) {
        return reorderDaysOfWeek(locHours);
      }
      if (hoursCardC.showNextBusinessDay) {
        hoursCardC.nextBusinessDay = getNextBusinessDay(locHours);
      }

      return locHours;
    }

    function reorderDaysOfWeek(locHours) {
      var currentDay = new Date().getDay();
      currentDay = currentDay === 0 ? 7 : currentDay; // Adjust Sunday to 7
      var orderedDays = {};
      for (var i = 1; i <= 7; i++) {
        orderedDays[i.toString()] = locHours[currentDay.toString()];
        currentDay = (currentDay % 7) + 1;
      }
      return orderedDays;
    }

    /**
     * function generates the display time message for the different
     * periods/times for which the store is open
     * @param {string} openTime open time for the store
     * @param {string} closeTime close time for the store
    */
    function displayOpenAndClosedTime(openTime, closeTime) {
      var displayTime = "";
      if (openTime && closeTime) {
        displayTime = moment(openTime, "hmm").format("LT") + " " + "-" + " " + moment(closeTime, "hmm").format("LT");
      }
      return displayTime;
    }

    /**
     * function is used to get the current time in the store timezone
     * @param {string} actualStoreTimeZone 
     */
    function getStoreCurrentTime(actualStoreTimeZone){
      var currentStoreDateTime = null;
      var isInvalidObj = checkObj(actualStoreTimeZone);
      if (!isInvalidObj) {
        currentStoreDateTime = angular.isDefined((moment.tz.zone(actualStoreTimeZone))) ? moment.tz(actualStoreTimeZone).format('YYYY-MM-DD LT') : moment().format('YYYY-MM-DD LT');//
      }
      return currentStoreDateTime;
    }

    /**
     * function is used to get the time part from the converted store timezone
     * @param {moment} storeCurrentDateTime 
     */
    function getConvertedStoreHours(storeCurrentDateTime){
      var convertedStoreHours = null;
      var currTimeArr = storeCurrentDateTime.split(" ");
      var isInvalidObj = checkObj(currTimeArr);
      if (!isInvalidObj){
        var isInvalidObj1 = checkObj(currTimeArr[1]);
        if(!isInvalidObj1 && currTimeArr.length > 1){
          if (currTimeArr[2]) {
            convertedStoreHours = currTimeArr[1].trim().concat(" ").concat(currTimeArr[2].trim());
          } else {
            convertedStoreHours = currTimeArr[1].trim().concat(" ");
          }
        }
      }
      return convertedStoreHours;
    }
    
    /**
     * function is used to generate the appropriate messaging for the
     * current day including store open/close times.
     * @param {array} openTime open time for the store for the current day
     * @param {array} closeTime close time for the store for the current day
    */
    function isTheLocationOpen(openTime, closeTime) {
      var amIBetweenFirstGroup = false;
      var amIBetweenSecondGroup = false;
      var amIBetweenThirdGroup = false;
      var storeOpenOrCloseMessage = '';
      var currentTime = moment();
      var displayMessage = '';
      var startTimeFirstGroup = openTime[0] ? moment(openTime[0].trim(), "LT") : "Closed Today";
      var endTimeFirstGroup = closeTime[0] ? moment(closeTime[0].trim(), "LT") : "Closed Today";

      var openTwentyFourHours = false;
      // store timezone code start
      var storeTimeZone = hoursCardC.location.store_info.timezone; // store timezone from api
      var storeCurrentDateTime = null;
      var convertedLocStoreHour = null;
      var isInvalidObj = checkObj(storeTimeZone);
      if (!isInvalidObj) {
        storeCurrentDateTime = getStoreCurrentTime(storeTimeZone);
        convertedLocStoreHour = moment(getConvertedStoreHours(storeCurrentDateTime), "LT");
      } else {
        convertedLocStoreHour = currentTime;
      }
      // store timezone code end
      
      if (openTime.length === 2) {
        var startTimeSecondGroup = moment(openTime[1], "LT");
        var endTimeSecondGroup = moment(closeTime[1], "LT");
      } else if (openTime.length === 3) {
        var startTimeThirdGroup = moment(openTime[2], "LT");
        var endTimeThirdGroup = moment(closeTime[2], "LT");
        startTimeSecondGroup = moment(openTime[1], "LT");
        endTimeSecondGroup = moment(closeTime[1], "LT");
      }
      //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
       // check if the close time is on the next date in the A.M.
        if (endTimeFirstGroup.format('HHmm') < (startTimeFirstGroup.format('HHmm')) || moment(closeTime[0], "LT").format('HHmm') === '0000') {
          //open 24 message if the store is open for 24hrs
          if (endTimeFirstGroup.format('HHmm') - (startTimeFirstGroup.format('HHmm')) === 0) {
            openTwentyFourHours = true;
          }
          // Check the user currentime is before shop close time then subtract 1 day from start date
          // as the shop has started in previous day
          // else add 1 day to end date as the shop will be closing on next day
          if (convertedLocStoreHour.format('HHmm') < (endTimeFirstGroup.format('HHmm'))) {
            startTimeFirstGroup = startTimeFirstGroup.subtract(1, 'days');
          } else {
            endTimeFirstGroup = endTimeFirstGroup.add(1, 'days');
          }
        }
      //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

      if (openTime.length === 2 && closeTime.length === 2) {
        // check if the close time is on the next date in the A.M.
        if (endTimeSecondGroup.isBefore(startTimeSecondGroup) || moment(closeTime[1], "LT").format('HHmm') === '0000') {
          endTimeSecondGroup = endTimeFirstGroup.add(1, 'days');
        }
        displayMessage = moment(openTime[0], "LT").format("LT") + ' - '  + moment(closeTime[0], "LT").format("LT") + ', ' +
                         moment(openTime[1], "LT").format("LT") + ' - ' + moment(closeTime[1], "LT").format("LT");
        // instead of currentTime object the comparison is made with convertedLocStoreHour object
        if (!isInvalidObj) {
          amIBetweenFirstGroup = convertedLocStoreHour.isBetween(startTimeFirstGroup, endTimeFirstGroup);
          amIBetweenSecondGroup = convertedLocStoreHour.isBetween(startTimeSecondGroup, endTimeSecondGroup);
        } else {
          // earlier implementation
          amIBetweenFirstGroup = currentTime.isBetween(startTimeFirstGroup, endTimeFirstGroup);
          amIBetweenSecondGroup = currentTime.isBetween(startTimeSecondGroup, endTimeSecondGroup);
        }

        if (amIBetweenFirstGroup) {
          storeOpenOrCloseMessage = 'Open Now Until ' + moment(closeTime[0], "LT").format("LT") + ', ' + displayMessage;
        } else if (amIBetweenSecondGroup) {
          storeOpenOrCloseMessage = 'Open Now Until ' + moment(closeTime[1], "LT").format("LT") + ', ' + displayMessage;
        } else {
          storeOpenOrCloseMessage = "Closed Now. Today's Hours: " + displayMessage;
        }
      } else if (openTime.length === 3 && closeTime.length === 3) {
        // if there are three fragments for store hours
        // check if the second fragment close time is on the next date in the A.M.
        if (endTimeSecondGroup.isBefore(startTimeSecondGroup) || moment(closeTime[1], "LT").format('HHmm') === '0000') {
          endTimeSecondGroup = endTimeFirstGroup.add(1, 'days');
        }
        // check if the third fragment close time is on the next date in the A.M.
        if (endTimeThirdGroup.isBefore(startTimeThirdGroup) || moment(closeTime[2], "LT").format('HHmm') === '0000') {
          endTimeThirdGroup = endTimeSecondGroup.add(1, 'days');
        }
        displayMessage = moment(openTime[0], "LT").format("LT") + ' - ' + moment(closeTime[0], "LT").format("LT") + ', ' +
                         moment(openTime[1], "LT").format("LT") + ' - ' + moment(closeTime[1], "LT").format("LT") + ', ' +
                         moment(openTime[2], "LT").format("LT") + ' - ' + moment(closeTime[2], "LT").format("LT");

        // time fragment flags
        // instead of currentTime object the comparison is made with convertedLocStoreHour object
        if (!isInvalidObj) {
          amIBetweenFirstGroup = convertedLocStoreHour.isBetween(startTimeFirstGroup, endTimeFirstGroup); // currentTime is replaced with convertedStoreHrs
          amIBetweenSecondGroup = convertedLocStoreHour.isBetween(startTimeSecondGroup, endTimeSecondGroup); // currentTime is replaced with convertedStoreHrs
          amIBetweenThirdGroup = convertedLocStoreHour.isBetween(startTimeThirdGroup, endTimeThirdGroup); // currentTime is replaced with convertedStoreHrs
        } else {
          // earlier implementation
          amIBetweenFirstGroup = currentTime.isBetween(startTimeFirstGroup, endTimeFirstGroup); // currentTime is replaced with convertedStoreHrs
          amIBetweenSecondGroup = currentTime.isBetween(startTimeSecondGroup, endTimeSecondGroup); // currentTime is replaced with convertedStoreHrs
          amIBetweenThirdGroup = currentTime.isBetween(startTimeThirdGroup, endTimeThirdGroup); // currentTime is replaced with convertedStoreHrs
        }
        if (amIBetweenFirstGroup) {
          storeOpenOrCloseMessage = 'Open Now Until ' + moment(closeTime[0], "LT").format("LT") + ', ' + displayMessage;
        } else if (amIBetweenSecondGroup) {
          storeOpenOrCloseMessage = 'Open Now Until ' + moment(closeTime[1], "LT").format("LT") + ', ' + displayMessage;

        } else if (amIBetweenThirdGroup) {
          storeOpenOrCloseMessage = 'Open Now Until ' + moment(closeTime[2], "LT").format("LT") + ', ' + displayMessage;
        } else {
          storeOpenOrCloseMessage = "Closed Now. Today's Hours: " + displayMessage;
        }
      } else {
        // below line is commented to implement the store timezone changes
        //amIBetweenFirstGroup = currentTime.isBetween(startTimeFirstGroup, endTimeFirstGroup);
        // instead of currentTime object the comparison is made with convertedLocStoreHour object
        //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

        if (!isInvalidObj) {
          /* if (endTimeFirstGroup.format('HHmm') < (startTimeFirstGroup.format('HHmm')) || moment(closeTime[0], "LT").format('HHmm') === '0000') {
            //open 24 message if the store is open for 24hrs
            if (endTimeFirstGroup.format('HHmm') - (startTimeFirstGroup.format('HHmm')) === 0) {
              openTwentyFourHours = true;
            }
            // Check the user currentime is before shop close time then subtract 1 day from start date
            // as the shop has started in previous day
            // else add 1 day to end date as the shop will be closing on next day
            if (convertedLocStoreHour.format('HHmm') < (endTimeFirstGroup.format('HHmm'))) {
              startTimeFirstGroup = startTimeFirstGroup.subtract(1, 'days');
            } else {
              endTimeFirstGroup = endTimeFirstGroup.add(1, 'days');
            }
          } */
            amIBetweenFirstGroup = convertedLocStoreHour.isBetween(startTimeFirstGroup, endTimeFirstGroup);
        } else { // in case if timezone is not populated in timezone variable then it should display as earlier
          amIBetweenFirstGroup = currentTime.isBetween(startTimeFirstGroup, endTimeFirstGroup);
        }
        if (openTwentyFourHours) {
          storeOpenOrCloseMessage = 'Open 24 Hours';
        } else {
          if (amIBetweenFirstGroup) {
            storeOpenOrCloseMessage = 'Open Now Until ' + moment(closeTime[0], "LT").format("LT");
          } else {
            storeOpenOrCloseMessage = "Closed Now. Today's Hours: " + moment(openTime[0], "LT").format("LT") + ' - ' + moment(closeTime[0], "LT").format("LT");
          }
        }
      }
      //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

      return storeOpenOrCloseMessage;
    }

    function generateSpecialHours(dateStrs) {
      // Split up the dateStrs and generate objects for each one
      var parsedDateStrs = parseDateStrings(dateStrs);
      var dates = _.uniq(_.map(parsedDateStrs, 'day'));
      var spHours = [];

      _.forEach(dates, function(date) {
        // Generate base objects per day
        var newHoursObj = {
          closedLabel: "Closed",
          dayNameShort: date,
          dayOfTheWeek: moment(date, "YYYY-MM-DD").format("E")
        };

        var parsedData = _.filter(parsedDateStrs, function(obj) {
          return obj['day'] === date.toString();
        });
        
        // all the open and close time for the store location in an array
        var openTime = _.map(parsedData, 'openTime');
        var closeTime = _.map(parsedData, 'closeTime');
        parsedData = {};
        _.forEach(openTime, function(value, key) {
          //moment js doesn't recognize 2400 hrs
          if (angular.isDefined(value)) {
            if (closeTime[key] === '2400') {
              closeTime[key] = '0000';
            }
            parsedData['openTime' + 'PeriodDisplayMessage' + '_' + key] = displayOpenAndClosedTime(openTime[key], closeTime[key]);
            parsedData['openTime' + 'Period' + '_' + key] = openTime[key] ? moment(openTime[key],"hmm").format("LT") : "";
            parsedData['closeTime' + 'Period' + '_' + key] = closeTime[key] ? moment(closeTime[key],"hmm").format("LT") : "";
            parsedData['openTime'] = openTime[0];
            parsedData['closeTime'] = closeTime[0];
            parsedData['numberOfTimeFragments'] = new Array(_.keys(openTime).length);
          } else {
            //we need the numberOfTimeFragments to display the correct message for the store hours in the directive.html
            parsedData['numberOfTimeFragments'] = new Array(_.keys(openTime).length);
          }
        });

        _.assign(newHoursObj, parsedData);
        var completeHoursObj = createHoursObj(newHoursObj);
        if(completeHoursObj.dayNameShort === moment().format("YYYY-MM-DD")) {
          if(!hoursCardC.simplified) {
            completeHoursObj.highlightClass = "bold-700";
          }

          //initialize the open and close time empty arrays
          openTime = [];
          closeTime = [];
          var counter = 0;
          while (counter < completeHoursObj['numberOfTimeFragments'].length) {
            var openTimePeriodKey = 'openTimePeriod' + '_' + counter;
            var closeTimePeriodKey = 'closeTimePeriod' + '_' + counter;
            if (completeHoursObj[openTimePeriodKey] && completeHoursObj[openTimePeriodKey].length > 0 && completeHoursObj[closeTimePeriodKey].length > 0) {
              openTime.push(completeHoursObj[openTimePeriodKey]);
              closeTime.push(completeHoursObj[closeTimePeriodKey]);
            }
            counter++;
          }

          // Remove all highlighting on regular hours
          _.forEach(hoursCardC.locHours, function (hourObj) {
            hourObj.highlightClass = "";
          });

          if (openTime.length > 0) {
            completeHoursObj.openTimePeriodDisplayMessage = isTheLocationOpen(openTime, closeTime);
          }
          updateTodaysHours(completeHoursObj);
        }
        spHours.push(completeHoursObj);
      });

      return spHours;
    }

    /* Things I removed:
     * location.status === 'coming soon' moving to directive.html
     */
    function createHoursObj(hourObj) {
      if (hoursCardC.location.status == "temp closed") {
        return _.assign(hourObj, {"closed": true, "closedLabel": "Temporarily Closed"})
      }
      if (!hourObj.hasOwnProperty("openTime")) {
        return _.assign(hourObj, {"closed": true});
      }
      hourObj.openTime = moment(hourObj.openTime, "HHmm");
      // If close is earlier than openM, then add 1 day to it
      hourObj.closeTime = moment(hourObj.closeTime, "HHmm");
      if (hourObj.closeTime.diff(hourObj.openTime) < 0) {
        hourObj.closeTime.add(1, 'd');
      }

      // Convenience vars so we only need to format or call moment on these once
      hourObj.openDisplayTime = hourObj.openTime.format("LT");
      hourObj.closeDisplayTime = hourObj.closeTime.format("LT");
      // Check if open 24/7 by comparing if diff of open and close time is 0
      hourObj.open24 = hourObj.openTime.diff(hourObj.closeTime) === 0;

      // Augment openingHours on controller
      hoursCardC.openingHours = hoursCardC.openingHours +
        hourObj.dayNameShort +
        ' ' +
        hourObj.openDisplayTime +
        ' - ' +
        hourObj.closeDisplayTime +
        ' ';

      return hourObj;
    }

    // Takes a datestring and checks if any special days are within 7 days of today
    // Return a list of dates + times that are within 7 days of today
    function checkSpecialHours(dates) {
      //For each date with special hours
      var intNearbyDates = _.filter(dates.trim().split(";"), function(el){
        return angular.isDefined(el) && el!=="";
      });

      var nearbyDates = _.map(intNearbyDates, function(specialDay) {
        //Split on the entry
        var dayData = specialDay.split(",");
        //Check today - specialDay < 7, if matched, return this date!
        var specialDateMoment = moment(dayData[0], "YYYY-M-D");
        var today = moment();
        if (specialDateMoment.diff(today, "days") < 7 &&
            specialDateMoment.diff(today, "days") >= 0) {
          return specialDay;
        }
      });
      return _.compact(nearbyDates).join(";");
    }
    if(hoursCardC.location.status == "coming soon"){
      hoursCardC.comingSoon = "Coming Soon"

    }
    else if (hoursCardC.location.status == "temp closed"){
      hoursCardC.comingSoon = "Temporarily Closed"
    }

    // If there's custom text, set it.
    if (hoursCardC.customText) {
      var str = hoursCardC.customText;
      str = str.replace(/\[(.*?[^.])\]/g, function (s, key) {
        return hoursCardC[key];
      });
      hoursCardC.customTextShow = str;
    }

    var checkHoursFormat = /^[0-9;,closedCLOSED]+$/;

    var sh = hoursCardC.location && hoursCardC.location.store_info ? s(hoursCardC.location.store_info.store_hours).trim(";").value() : null;
    // Replace anything that isn't number, ';', ',', or the letters c, l, o, s, e, d in their lower and capital forms
    sh = sh.replace(/[^0-9;,closedCLOSED]/g,'');
    sh = sh.trim();

    // Check if there are store hours listed. If not, show all days as "Closed" unless config indicates they should be hidden
    if (hoursCardC.location.store_info.store_hours == '' && (!hoursCardC.hideEmptyHours || hoursCardC.hideEmptyHours != true)) {
      hoursCardC.locHours = generateHours(sh, "Closed");
    }

    // Check if store is coming soon, if so, init all days to coming soon
    if (hoursCardC.location.status == "coming soon") {
      hoursCardC.locHours = generateHours(sh, "Coming Soon");
    }

    // Check if time returned is valid
    if (sh && checkHoursFormat.test(sh)) {
      hoursCardC.locHours = generateHours(sh, "Closed");
    }

    // Check for special hours
    var specialHours = (hoursCardC.location &&
      hoursCardC.location.store_info &&
      hoursCardC.location.store_info.special_hours) ?
      s(hoursCardC.location.store_info.special_hours).trim(";").value() : null;
      //specialHours = '2018-12-24,0000,1800;2018-12-25,CLOSED;2018-12-31,0000,2200;2019-01-01,0600,0000;2019-05-15,CLOSED';

    if (specialHours !== null) {
      // Check if any special hours are coming up.
      var validSpHours = checkSpecialHours(specialHours);
      if (!_.isEmpty(validSpHours)) {
        // For each special day, format it for display like normal hours.
        hoursCardC.specialHours = generateSpecialHours(validSpHours);
      }
    }
    hoursCardC.hoursNote = _.find(hoursCardC.location.custom_fields, {'name': 'hours_note'});
    hoursCardC.hideClosedToday = _.find(hoursCardC.location.custom_fields, {'name': 'hide_closed_today'});
    if (hoursCardC.hideClosedToday && hoursCardC.closed24) {
      hoursCardC.locHours = undefined;
      hoursCardC.specialHours = undefined;
    }


    function toggleCollapsibleHours() {
      var collapsibleHours = document.getElementsByClassName('collapsible')[0];
      var collapseIcon = document.getElementsByClassName('collapse-icon')[0].getElementsByTagName('i')[0];
      if(collapsibleHours.classList.value.indexOf('show') === -1) {
        collapsibleHours.classList.add('show');
        collapseIcon.classList.remove('fa-chevron-down');
        collapseIcon.classList.add('fa-chevron-up');
      } else {
        collapsibleHours.classList.remove('show');
        collapseIcon.classList.add('fa-chevron-down');
        collapseIcon.classList.remove('fa-chevron-up');
      }
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('storeLocator')
    .directive('hoursAdditionalCard', hoursAdditionalCard);

  function hoursAdditionalCard() {
    return {
      replace: true,
      scope: {
        location: '=',
        titlePrimary: '=',
        titleAdditional: '@',
        isUsedForPrimaryRegularHours: '=',
        specialHoursDateFormat: '@',
      },
      templateUrl: 'app/localLanding/cards/hoursAdditionalCard.directive.html',
      restrict: 'AE',
      controller: hoursAddCardController,
      controllerAs: 'hoursAddCardC',
      bindToController: true
    };
  }

  function hoursAddCardController(_, s, moment) {
    var hoursAddCardC = this;

    hoursAddCardC.closed24 = true;
    hoursAddCardC.closed24Additional = true;
    hoursAddCardC.closedNow = true;
    hoursAddCardC.closedNowAdditional = true;
    hoursAddCardC.open24 = false;
    hoursAddCardC.openingHours = '';
    hoursAddCardC.open24Additional = false;
    hoursAddCardC.openingHoursAdditional = '';
    hoursAddCardC.hasPrimary = false;
    hoursAddCardC.hasPrimarySpecial = false;

    // returns the hour fragment for the day depending on the passed key value
    hoursAddCardC.getOpenTimePeriodDisplayMessage = function(regularHours, index) {
      var key = '';
      if (angular.isDefined(index)) {
        key = 'openTimePeriodDisplayMessage_' + index;
      } else {
        key = 'openTimePeriodDisplayMessage';
      }
      return regularHours[key];
    };

    /**
     * function returns true if passed value is null, undefined and legth is zero, else false
     * @param {*} storeTimeZone 
     */
    function checkObj(storeTimeZone) {
      return ( _.isNull(storeTimeZone) || _.isUndefined(storeTimeZone) || storeTimeZone.length === 0 )
    }

    /**
     * function to check if the store is open or closed and set
     * the corresponding 'closedNow' value on the directive object
     * @param {object} hourObj hour object which has all the details about the timings/days
    */
    function updateTodaysHours(hourObj) {
      if (hourObj.closed) {
        hoursAddCardC.closed24 = true;
        return;
      }

      hoursAddCardC.closed24 = false;
       // check for today's special hours. start
       var isTodaySpecial = isTodaySpecialHours();
      //counter to loop through the number of fragments
      var counter = 0;
      if(hourObj && hourObj.numberOfTimeFragments) {
        while (counter < hourObj.numberOfTimeFragments.length) {
          var openTimePeriodKey = 'openTimePeriod' + '_' + counter;
          var closeTimePeriodKey = 'closeTimePeriod' + '_' + counter;
          if (hourObj[openTimePeriodKey] && hourObj[closeTimePeriodKey]) {
            hoursAddCardC[openTimePeriodKey] = moment(hourObj[openTimePeriodKey], "LT").format("LT")
            hoursAddCardC[closeTimePeriodKey] = moment(hourObj[closeTimePeriodKey], "LT").format("LT");
          }
          if (moment(hourObj[closeTimePeriodKey], "LT").isBefore(moment(hourObj[openTimePeriodKey], "LT")) || moment(hourObj[closeTimePeriodKey], "LT").format('HHmm') === '0000') {
            hourObj[closeTimePeriodKey] = moment(hourObj[closeTimePeriodKey], "LT").add(1, 'days');
          }
  
          var amIBetweenGroupKey = 'amIBetweenGroup' + '_' + counter;
          var now = moment();
          // store timezone code start
          var storeTimeZone = hoursAddCardC.location.store_info.timezone; // store timezone from api
          var storeCurrDateTime = null;
          var convertedStoreTime = null;
          var isInvalidObj = checkObj(storeTimeZone);
          if (!isInvalidObj) {
            storeCurrDateTime = getStoreCurrentTime(storeTimeZone);
            convertedStoreTime = moment(getConvertedStoreHours(storeCurrDateTime), "LT");
          }
          // store timezone code end
          // instead of now object the comparison is made with convertedStoreTime object
          var startTime = moment(hourObj[openTimePeriodKey], "LT");
          var endTime = moment(hourObj[closeTimePeriodKey], "LT");
          if (now.isBefore(endTime)) {
            startTime = startTime.subtract(1, 'days');
          } else {
            endTime = endTime.add(1, 'days');
          }
          if(!isInvalidObj){
            amIBetweenGroupKey = convertedStoreTime.isBetween(startTime, endTime);
          } else {
            amIBetweenGroupKey = now.isBetween(startTime, endTime);
          }
  
          if (amIBetweenGroupKey) {
            hoursAddCardC.closeToday = endTime.format("LT");
            if (amIBetweenGroupKey || hourObj.open24) {
              hoursAddCardC.closedNow = false;
            } else {
              hoursAddCardC.closedNow = true;
            }
          } else if(isTodaySpecial && !amIBetweenGroupKey){
            hoursAddCardC.closeToday = endTime.format("LT");
            hoursAddCardC.closedNow = true;
          }
  
          counter++;
        }
      }

      hoursAddCardC.openToday = hourObj.openDisplayTime;
      hoursAddCardC.open24 = hourObj.open24;
    }

    function isTodaySpecialHours(){
      var isTodaySpecial = false;
      var specialHours = (hoursAddCardC.location &&
        hoursAddCardC.location.store_info &&
        hoursAddCardC.location.store_info.special_hours) ?
        s(hoursAddCardC.location.store_info.special_hours).trim(";").value() : null;
          
      if (specialHours !== null) {
        // Check if any special hours are coming up.
        var validSpHours = checkSpecialHours(specialHours);
        if (!_.isEmpty(validSpHours)) {
          isTodaySpecial=true;
        }
      } 
      return isTodaySpecial;
    }

    function updateTodaysHoursAdditional(hourObj) {
      if (hourObj.closed) {
        hoursAddCardC.closed24Additional = true;
        return;
      }

      hoursAddCardC.closed24Additional = false;

      var now = moment();
      hoursAddCardC.openTodayAdditional = hourObj.openDisplayTime;
      hoursAddCardC.closeTodayAdditional = hourObj.closeDisplayTime;
      hoursAddCardC.open24Additional = hourObj.open24;
      // store timezone code start
      var storeTimeZone = hoursAddCardC.location.store_info.timezone; // store timezone from api
      var storeCurrentDateTime = null;
      var convertedStoreTodayHrs = null;
      var isInvalidObj = checkObj(storeTimeZone);
      if (!isInvalidObj) {
        storeCurrentDateTime = getStoreCurrentTime(storeTimeZone);
        convertedStoreTodayHrs = moment(getConvertedStoreHours(storeCurrentDateTime), "LT");
      }
      // store timezone code end
      // instead of now object the comparison is made with convertedStoreTodayHrs object
      if (!isInvalidObj) {
        if ((convertedStoreTodayHrs.isAfter(hourObj.openTime) && convertedStoreTodayHrs.isBefore(hourObj.closeTime)) || hourObj.open24) {
          hoursAddCardC.closedNowAdditional = false;
        } else {
          hoursAddCardC.closedNowAdditional = true;
        }
      } else {
        if ((now.isAfter(hourObj.openTime) && now.isBefore(hourObj.closeTime)) || hourObj.open24) {
          hoursAddCardC.closedNowAdditional = false;
        } else {
          hoursAddCardC.closedNowAdditional = true;
        }
      }
    }

    function parseDateStrings(dateStrs) {
      if(dateStrs) { var intDateStrs = dateStrs.split(";"); }
      return _.map(intDateStrs, function(dateStr) {
        var info = dateStr.split(",");
        if (angular.isDefined(info[1]) && info[1].toUpperCase() === "CLOSED") {
          // return just the day. This way we can use it to determine if today == which hour obj.
          return {
            day: info[0]
          };
        }
        else {
          // Else add open and close times based on the strings.
          // Will moment parse these to more readable strings later.
          return {
            day: info[0],
            openTime: info[1],
            closeTime: info[2]
          };
        }
      });
    }


    /**
     * function generates hours object for each day
     * @param {string} dateStrs open and close times for the week
     * @param {string} closeLabel close label for the location
     * @param {string} isPrimary flag to indicate if the hours are primary/additional
    */
    function generateHours(dateStrs, closeLabel, isPrimary) {
      // Split up the dateStrs and generate objects for each one
      var parsedDateStrs = parseDateStrings(dateStrs);
      var locHours = {};
      _.range(1, 8).forEach(function(day) {
        // Generate base objects per day
        var newHoursObj = {
          day: day.toString(),
          dayName: moment().isoWeekday(day).format("dddd"),
          dayNameShort: moment().isoWeekday(day).format("dd"),
          dayNameShortNext: moment().isoWeekday(day).add(1, 'd').format("dd"),
          closedLabel: closeLabel
        };

        // filter method gets all the matching objects for a certain day of the week
        var parsedData = _.filter(parsedDateStrs, function(obj) {
          return obj['day'] === day.toString();
        });

        // all the open and close time for the store location in an array
        var openTime = _.map(parsedData, 'openTime');
        var closeTime = _.map(parsedData, 'closeTime');
        parsedData = {};
        _.forEach(openTime, function(value, key) {
          //moment js doesn't recognize 2400 hrs
          if (closeTime[key] === '2400') {
            closeTime[key] = '0000';
          }
          parsedData['openTime' + 'PeriodDisplayMessage' + '_' + key] = displayOpenAndClosedTime(openTime[key], closeTime[key]);
          parsedData['openTime' + 'Period' + '_' + key] = openTime[key] ? moment(openTime[key],"hmm").format("LT") : "";
          parsedData['closeTime' + 'Period' + '_' + key] = closeTime[key] ? moment(closeTime[key],"hmm").format("LT") : "";
          parsedData['openTime'] = openTime[0];
          parsedData['closeTime'] = closeTime[0];
          parsedData['numberOfTimeFragments'] = new Array(_.keys(openTime).length);
        });

        //we need the numberOfTimeFragments to display the correct message for the store hours in the directive.html
        if (openTime.length === 0) {
          parsedData['numberOfTimeFragments'] = new Array(1);
        }
        _.assign(newHoursObj, parsedData);
        locHours[day] = createHoursObj(newHoursObj, isPrimary);

        // Check if Today. If so, apply highlighting and modify
        // some controller level variables in a separate function.
        if (day.toString() === moment().format("E")) {
          locHours[day].highlightClass = "bold-700";

          //initialize the open and close time empty arrays
          openTime = [];
          closeTime = [];
          var counter = 0;
          while (counter < locHours[day]['numberOfTimeFragments'].length) {
            var openTimePeriodKey = 'openTimePeriod' + '_' + counter;
            var closeTimePeriodKey = 'closeTimePeriod' + '_' + counter;
            if (locHours[day][openTimePeriodKey] && locHours[day][openTimePeriodKey].length > 0 && locHours[day][closeTimePeriodKey].length > 0) {
              openTime.push(locHours[day][openTimePeriodKey]);
              closeTime.push(locHours[day][closeTimePeriodKey]);
            }
            counter++;
          }

          // when the location does not have hours for the day we
          // assume that it is closed
          if (openTime.length > 0 && closeTime.length > 0) {
            // for current day we store the appropriate message for store close/open hours in the first display message element
            locHours[day].openTimePeriodDisplayMessage = isTheLocationOpen(openTime, closeTime);
          } else {
            locHours[day].closed = true;
          }

          // for current day we store the appropriate message for store close/open hours in the first display message element
          if (isPrimary) {
            updateTodaysHours(locHours[day]);
          }
          else {
            updateTodaysHoursAdditional(locHours[day]);
          }
        }
      });

      return locHours;
    }

    /**
     * function generates the display time message for the different
     * periods/times for which the store is open
     * @param {string} openTime open time for the store
     * @param {string} closeTime close time for the store
    */
    function displayOpenAndClosedTime(openTime, closeTime) {
      var displayTime = "";
      if (openTime && closeTime) {
        displayTime = moment(openTime, "hmm").format("LT") + " " + "-" + " " + moment(closeTime, "hmm").format("LT");
      }
      return displayTime;
    }

    /**
     * function is used to get the current time in the store timezone
     * @param {*} actualStoreTimeZone 
     */
    function getStoreCurrentTime(actualStoreTimeZone){
      var currentStoreDateTime = null;
      var isInvalidObj = checkObj(actualStoreTimeZone);
      if (!isInvalidObj) {
        currentStoreDateTime = angular.isDefined((moment.tz.zone(actualStoreTimeZone))) ? moment.tz(actualStoreTimeZone).format('YYYY-MM-DD LT') : moment().format('YYYY-MM-DD LT');//
      }
      return currentStoreDateTime;
    }

    /**
     * function is used to get the time part from the converted store timezone
     * @param {moment} storeCurrentDateTime 
     */
    function getConvertedStoreHours(storeCurrentDateTime){
      var convertedStoreHours = null;
      var currTimeArr = storeCurrentDateTime.split(" ");
      var isInvalidObj = checkObj(currTimeArr);
      if(!isInvalidObj){ 
        var isInvalidObj1 = checkObj(currTimeArr[1]);
        if(!isInvalidObj1 && currTimeArr.length > 1){
          if (currTimeArr[2]) {
            convertedStoreHours = currTimeArr[1].trim().concat(" ").concat(currTimeArr[2].trim());
          } else {
            convertedStoreHours = currTimeArr[1].trim().concat(" ");
          }
        }
      }
      return convertedStoreHours;
    }

    /**
     * function is used to generate the appropriate messaging for the
     * current day including store open/close times.
     * @param {array} openTime open time for the store for the current day
     * @param {array} closeTime close time for the store for the current day
    */
    function isTheLocationOpen(openTime, closeTime) {
      var amIBetweenFirstGroup = false;
      var amIBetweenSecondGroup = false;
      var amIBetweenThirdGroup = false;
      var storeOpenOrCloseMessage = '';
      var currentTime = moment();
      var displayMessage = '';
      var startTimeFirstGroup = openTime[0] ? moment(openTime[0].trim(), "LT") : "Closed Today";
      var endTimeFirstGroup = closeTime[0] ? moment(closeTime[0].trim(), "LT") : "Closed Today";
      var openTwentyFourHours = false;
      // store timezone code start
      var storeTimeZone = hoursAddCardC.location.store_info.timezone; // store timezone from api
      var storeCurrDateTime = null;
      var convertedStoreHrs = null;
      var isInvalidObj = checkObj(storeTimeZone);
      if (!isInvalidObj) {
        storeCurrDateTime = getStoreCurrentTime(storeTimeZone);
        convertedStoreHrs = moment(getConvertedStoreHours(storeCurrDateTime), "LT");
      } else {
        convertedStoreHrs = currentTime;
      }
      // store timezone code end
      if (openTime.length === 2) {
        var startTimeSecondGroup = moment(openTime[1], "LT");
        var endTimeSecondGroup = moment(closeTime[1], "LT");
      } else if (openTime.length === 3) {
        var startTimeThirdGroup = moment(openTime[2], "LT");
        var endTimeThirdGroup = moment(closeTime[2], "LT");
        startTimeSecondGroup = moment(openTime[1], "LT");
        endTimeSecondGroup = moment(closeTime[1], "LT");
      }


      // check if the close time is on the next date in the A.M.
      if (endTimeFirstGroup.isBefore(startTimeFirstGroup) || moment(closeTime[0], "LT").format('HHmm') === '0000') {
        //open 24 message if the store is open for 24hrs
        if (endTimeFirstGroup.diff(startTimeFirstGroup) === 0) {
          openTwentyFourHours = true;
        }
        // Check the user currentime is before shop close time then subtract 1 day from start date
        // as the shop has started in previous day
        // else add 1 day to end date as the shop will be closing on next day
        if (convertedStoreHrs.isBefore(endTimeFirstGroup)) {
          startTimeFirstGroup = startTimeFirstGroup.subtract(1, 'days');
        } else {
          endTimeFirstGroup = endTimeFirstGroup.add(1, 'days');
        }
      }

      if (openTime.length === 2 && closeTime.length === 2) {
        // check if the close time is on the next date in the A.M.
        if (endTimeSecondGroup.isBefore(startTimeSecondGroup) || moment(closeTime[1], "LT").format('HHmm') === '0000') {
          endTimeSecondGroup = endTimeFirstGroup.add(1, 'days');
        }

        displayMessage = moment(openTime[0], "LT").format("LT") + ' - ' + moment(closeTime[0], "LT").format("LT") + ', ' +
                         moment(openTime[1], "LT").format("LT") + ' - ' + moment(closeTime[1], "LT").format("LT");
        // instead of currentTime object the comparison is made with convertedStoreHrs object
        if (!isInvalidObj) {
          amIBetweenFirstGroup = convertedStoreHrs.isBetween(startTimeFirstGroup, endTimeFirstGroup);
          amIBetweenSecondGroup = convertedStoreHrs.isBetween(startTimeSecondGroup, endTimeSecondGroup);
        } else {
          //earlier implementation
          amIBetweenFirstGroup = currentTime.isBetween(startTimeFirstGroup, endTimeFirstGroup);
          amIBetweenSecondGroup = currentTime.isBetween(startTimeSecondGroup, endTimeSecondGroup);
        }
        if (amIBetweenFirstGroup) {
          storeOpenOrCloseMessage = 'Open Now Until ' + displayMessage;
        } else if (amIBetweenSecondGroup) {
          storeOpenOrCloseMessage = 'Open Now Until ' + displayMessage;

        } else {
          storeOpenOrCloseMessage = "Closed Now. Today's Hours: " + displayMessage;
        }
      } else if (openTime.length === 3 && closeTime.length === 3) {
        // if there are three fragments for store hours
        // check if the close time is on the next date in the A.M.
        if (endTimeSecondGroup.isBefore(startTimeSecondGroup) || moment(closeTime[1], "LT").format('HHmm') === '0000') {
          endTimeSecondGroup = endTimeFirstGroup.add(1, 'days');
        }
        // check if the third fragment close time is on the next date in the A.M.
        if (endTimeThirdGroup.isBefore(startTimeThirdGroup) || moment(closeTime[2], "LT").format('HHmm') === '0000') {
          endTimeThirdGroup = endTimeSecondGroup.add(1, 'days');
        }

        displayMessage = moment(openTime[0], "LT").format("LT") + ' - ' + moment(closeTime[0], "LT").format("LT") + ', ' +
                         moment(openTime[1], "LT").format("LT") + ' - ' + moment(closeTime[1], "LT").format("LT") + ', ' +
                         moment(openTime[2], "LT").format("LT") + ' - ' + moment(closeTime[2], "LT").format("LT");
        // time fragment flags
        // instead of currentTime object the comparison is made with convertedStoreHrs object
        if (!isInvalidObj) {
          amIBetweenFirstGroup = convertedStoreHrs.isBetween(startTimeFirstGroup, endTimeFirstGroup);
          amIBetweenSecondGroup = convertedStoreHrs.isBetween(startTimeSecondGroup, endTimeSecondGroup);
          amIBetweenThirdGroup = convertedStoreHrs.isBetween(startTimeThirdGroup, endTimeThirdGroup);
        } else {
          //earlier implementation
          amIBetweenFirstGroup = currentTime.isBetween(startTimeFirstGroup, endTimeFirstGroup);
          amIBetweenSecondGroup = currentTime.isBetween(startTimeSecondGroup, endTimeSecondGroup);
          amIBetweenThirdGroup = currentTime.isBetween(startTimeThirdGroup, endTimeThirdGroup);
        }
        if (amIBetweenFirstGroup) {
          storeOpenOrCloseMessage = "Open Now Until " + moment(closeTime[0], "LT").format("LT") + ", " +
                                     displayMessage;
        } else if (amIBetweenSecondGroup) {
          storeOpenOrCloseMessage = 'Open Now Until ' + moment(closeTime[1], "LT").format("LT") + ', ' +
                                     displayMessage;

        } else if (amIBetweenThirdGroup) {
          storeOpenOrCloseMessage = 'Open Now Until ' + moment(closeTime[2], "LT").format("LT") + ', ' +
                                     displayMessage;
        } else {
          storeOpenOrCloseMessage = "Closed Now. Today's Hours: " + displayMessage;
        }
      } else {
        // instead of currentTime object the comparison is made with convertedStoreHrs object
        if (!isInvalidObj) {
          amIBetweenFirstGroup = convertedStoreHrs.isBetween(startTimeFirstGroup, endTimeFirstGroup);
        } else {
          // earlier implementation
          amIBetweenFirstGroup = currentTime.isBetween(startTimeFirstGroup, endTimeFirstGroup);
        }

        if (openTwentyFourHours) {
          storeOpenOrCloseMessage = 'Open 24 Hours';
        } else {
          if (amIBetweenFirstGroup) {
            storeOpenOrCloseMessage = 'Open Now Until ' + moment(closeTime[0], "LT").format("LT");
          } else {
            storeOpenOrCloseMessage = "Closed Now. Today's Hours: " + moment(openTime[0], "LT").format("LT") + ' - ' + moment(closeTime[0], "LT").format("LT");
          }
        }
      }

      return storeOpenOrCloseMessage;
    }

    function generateSpecialHours(dateStrs, isPrimary) {
      // Split up the dateStrs and generate objects for each one
      var parsedDateStrs = parseDateStrings(dateStrs);

      var spHours = [];
      parsedDateStrs.forEach(function(parsedData) {
        parsedData.dayNameShort = parsedData.day;
        parsedData.dayOfTheWeek = moment(parsedData.day, "YYYY-MM-DD").format("E");
        parsedData.closedLabel = "Closed";

        var completeHoursObj = createHoursObj(parsedData);

        if(completeHoursObj.day  === moment().format("YYYY-MM-DD")) {
          completeHoursObj.highlightClass = "bold-700";

          if (isPrimary) {
            //Clear Regular hours highlighting
            _.forEach(hoursAddCardC.regularHours, function (hourObj) {
              if (hourObj.hasOwnProperty("regular")) {
                hourObj.regular.highlightClass = "";
              }
            });

            updateTodaysHours(completeHoursObj);
          }
          else {
            //Clear Additional hours highlighting
            _.forEach(hoursAddCardC.regularHours, function (hourObj) {
              if (hourObj.hasOwnProperty("additional")) {
                hourObj.additional.highlightClass = "";
              }
            });

            updateTodaysHoursAdditional(completeHoursObj);
          }
        }

        if(hoursAddCardC.specialHoursDateFormat) {
          completeHoursObj.dayNameShort = moment(completeHoursObj.dayNameShort, "YYYY-MM-DD").format("MM-DD-YYYY")
        }

        spHours.push(completeHoursObj);
      });

      return spHours;
    }

    /* removed:
     * location.status === 'coming soon' moving to directive.html
     */
    function createHoursObj(hourObj, isPrimary) {
      if (!hourObj.hasOwnProperty("openTime")) {
        return _.assign(hourObj, {"closed": true});
      }
      hourObj.openTime = moment(hourObj.openTime, "HHmm");
      // If close is earlier than openM, then add 1 day to it
      hourObj.closeTime = moment(hourObj.closeTime, "HHmm");
      if (hourObj.closeTime.diff(hourObj.openTime) < 0) {
        hourObj.closeTime.add(1, 'd');
      }

      // Convenience vars so we only need to format or call moment on these once
      hourObj.openDisplayTime = hourObj.openTime.format("LT");
      hourObj.closeDisplayTime = hourObj.closeTime.format("LT");

      // Check if open 24/7 by comparing if diff of open and close time is 0
      hourObj.open24 = (hourObj.openTime.diff(hourObj.closeTime) === 0 ||
                        Math.abs(hourObj.openTime.diff(hourObj.closeTime, 'hours')) === 24);

      // Augment openingHours on controller
      if (isPrimary) {
        hoursAddCardC.openingHours = hoursAddCardC.openingHours +
          hourObj.dayNameShort +
          ' ' +
          hourObj.openDisplayTime +
          ' - ' +
          hourObj.closeDisplayTime +
          ' ';
      }
      else {
        hoursAddCardC.openingHoursAdditional = hoursAddCardC.openingHoursAdditional +
          hourObj.dayNameShort +
          ' ' +
          hourObj.openDisplayTime +
          ' - ' +
          hourObj.closeDisplayTime +
          ' ';
      }
      return hourObj;
    }

    // Takes a datestring and checks if any special days are within 7 days of today
    // Return a list of dates + times that are within 7 days of today
    function checkSpecialHours(dates) {
      //For each date with special hours
      if(dates) { var intNearbyDates = dates.split(";"); }
      var nearbyDates = _.map(intNearbyDates, function(specialDay) {
        //Split on the entry
        var dayData = specialDay.split(",");
        //Check today - specialDay < 7, if matched, return this date!
        var specialDateMoment = moment(dayData[0], "YYYY-M-D");
        var today = moment();
        if (specialDateMoment.diff(today, "days") < 7 &&
          specialDateMoment.diff(today, "days") >= 0) {
          return specialDay;
        }
      });
      return _.compact(nearbyDates).join(";");
    }

    function combineSpecialHours(regularDates, additionalDates) {
      var combinedSpecialHours = {};

      _.forEach(regularDates, function(hourObj) {
        combinedSpecialHours[hourObj.dayNameShort] = {
          "regular" : hourObj
        }
      });

      _.forEach(additionalDates, function(hourObj) {
        if (combinedSpecialHours[hourObj.dayNameShort]) {
          combinedSpecialHours[hourObj.dayNameShort]["additional"] = hourObj;
        }
        else {
          combinedSpecialHours[hourObj.dayNameShort] = {
            "additional": hourObj
          }
        }
      })
      var orderedSpecialHours = {};
      Object.keys(combinedSpecialHours).sort().forEach(function(key) {
        orderedSpecialHours[key] = combinedSpecialHours[key];
      });

      return orderedSpecialHours;
    }

    function combineRegularHours(regularDates, additionalDates) {
      var combinedRegHours = {};

      _.forEach(regularDates, function(hourObj) {
        combinedRegHours[hourObj.day] = {
          "regular" : hourObj,
          "day" : hourObj.dayName
        }
      });

      _.forEach(additionalDates, function(hourObj) {
        if (combinedRegHours[hourObj.day]) {
          combinedRegHours[hourObj.day]["additional"] = hourObj;
        }
        else {
          combinedRegHours[hourObj.day] = {
            "additional": hourObj,
            "day" : hourObj.dayName
          }
        }
      })
      var orderedRegHours = {};
      Object.keys(combinedRegHours).sort().forEach(function(key) {
        orderedRegHours[combinedRegHours[key]["day"]] = combinedRegHours[key];
      });

      return orderedRegHours;
    }

    // Primary Regular Hours
    var checkHoursFormat = /^[0-9;,closedCLOSED]+$/;
    var sh = (hoursAddCardC.location &&
              hoursAddCardC.location.store_info) ?
      s(hoursAddCardC.location.store_info.store_hours).trim(";").value() : null;
    sh = sh.replace(/[^0-9;,closedCLOSED]/g,'');
    sh = sh.trim();

    var regularHours = null;
    var primaryAdditionalHours = null;
    var regularSpecialHours = null;
    var additionalSpecialHours = null;

    // Primary Regular Hours

    // Check if there are store hours listed. If not, show all days as "Closed"
    if (hoursAddCardC.location.store_info.store_hours == '') {
      regularHours = generateHours(sh, "Closed", true);
      hoursAddCardC.hasPrimary = true;
    }
    if (sh && checkHoursFormat.test(sh)) {
      regularHours = generateHours(sh, "Closed", true);
      hoursAddCardC.hasPrimary = true;
    }
    // Additional Regular Hours
    var findAdditionalHours = _.find(hoursAddCardC.location.custom_fields, {'name': 'hours_additional'});
    if(findAdditionalHours) {
      var additionalHoursStr = findAdditionalHours.data ? s(findAdditionalHours.data).trim(";").value() : null;
      hoursAddCardC.hasAdditional = additionalHoursStr ? true : false;
      if(hoursAddCardC.hasAdditional) { primaryAdditionalHours = generateHours(additionalHoursStr, "Closed", false); }
      
    }

    // Combine Regular Hours
    if (regularHours || primaryAdditionalHours) {
      hoursAddCardC.regularHours = combineRegularHours(regularHours, primaryAdditionalHours);
    }
    // Primary Special Hours
    var primarySpecialHours = (hoursAddCardC.location &&
      hoursAddCardC.location.store_info &&
      hoursAddCardC.location.store_info.special_hours) ?
      s(hoursAddCardC.location.store_info.special_hours).trim(";").value() : null;
    if (primarySpecialHours !== null) {
      // Check if any special hours are coming up.
      var validSpecialHours = checkSpecialHours(primarySpecialHours);
      if (!_.isEmpty(validSpecialHours)) {
        // For each special day, format it for display like normal hours.
        regularSpecialHours = generateSpecialHours(validSpecialHours, true);
        hoursAddCardC.hasPrimarySpecial = true;
      }
    }

    // Additional Special Hours
    var findAdditionalSpecialHours = _.find(hoursAddCardC.location.custom_fields, {'name': 'hours_additional_special'});
    if(findAdditionalSpecialHours) {

      var additionalSpecialHoursStr = findAdditionalSpecialHours.data ? s(findAdditionalSpecialHours.data).trim(";").value() : null;
      var validAdditionalSpecialHours = checkSpecialHours(additionalSpecialHoursStr);
      hoursAddCardC.hasAdditionalSpecial = validAdditionalSpecialHours ? true : false;
      if (!_.isEmpty(validAdditionalSpecialHours)) {
        // For each special day, format it for display like normal hours.
        additionalSpecialHours = generateSpecialHours(validAdditionalSpecialHours, false);
      }
    }

    // Combine Special Hours
    if (regularSpecialHours || additionalSpecialHours) {
      hoursAddCardC.specialHours = combineSpecialHours(regularSpecialHours, additionalSpecialHours);
    }
    hoursAddCardC.hoursNote = _.find(hoursAddCardC.location.custom_fields, {'name': 'hours_note'});

    // If regular hours have special hours but additional hours do not

    hoursAddCardC.getStandardAddtlHours = function(dayOfTheWeek) {
      return generateHours(additionalHoursStr, "Closed", false)[dayOfTheWeek].openTimePeriodDisplayMessage_0 || "Closed"
    }


    hoursAddCardC.getStandardRegHours = function(dayOfTheWeek) {
      var days = Object.entries(hoursAddCardC.regularHours)
      var specialDay = days.filter(function(d) {
        return d[1].regular.day == dayOfTheWeek
      })

      return specialDay[0][1].regular.openTimePeriodDisplayMessage_0 || "Closed"
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('storeLocator')
    .directive('fbWidgetCard', fbWidgetCard);

  function fbWidgetCard() {

    return {
      replace: true,
      scope: {
        location: '=',
        clientName: '=',
        brandUrl: '@'
      },
      templateUrl: 'app/localLanding/cards/fbWidgetCard.directive.html',
      restrict: 'AE',
      controller: function ($timeout, $scope, $window) {

        var vm = this;
       
        // This is a particular case for city national bank
        if($scope.brandUrl === 'bylocation'){
          var facebookUrl = $scope.location.store_info.providers.find( function (provider) {
            return provider._type.toLowerCase() === "facebook";
          })
          if(facebookUrl){
            vm.fbProviderUrl ='https://www.facebook.com/'+facebookUrl.venue_id;
          }
        }else{
          if ($scope.brandUrl) {
            vm.fbProviderUrl = $scope.brandUrl;
          } else {
            vm.fbProviders = _.filter($scope.location.store_info.providers, function (obj) {
              return obj._type === "Facebook" && obj.master;
            });
            if (vm.fbProviders.length > 0) {
              vm.fbProviderUrl = vm.fbProviders[0].url;
            }
          }
        }
        
        angular.element($window).bind('resize', function () {
          vm.windowWidth = $window.innerWidth;
          $timeout(function () {
            changeFBPagePlugin(vm.fbProviderUrl)
          }, 500);
          $scope.$digest();
        });

        function changeFBPagePlugin(url) {
          //getting parent box width
          var container_width = Number($('.fb-widget-container').width()).toFixed(0);
          var container_height = Number($('.fb-widget-container').height()).toFixed(0);
          if (!isNaN(container_width) && !isNaN(container_height)) {
            $(".fb-page").attr("data-width", container_width).attr("data-height", container_height);
          }
          if (url) {
            $(".fb-page").attr("data-href", url);
          }
          if (typeof FB !== 'undefined') {
            FB.XFBML.parse();
          }
        }

        //initial card load requires call to FB.XFBML.parse to render per page
        $timeout(function () {
          changeFBPagePlugin(vm.fbProviderUrl)
        }, 1000);
      }
      ,
      controllerAs: 'fbWidgetCardC'
    };
  }
})();

(function() {
    'use strict';

    angular.module('storeLocator').directive('fatBrandsMenuCard', fatBrandsMenuCard);

    function fatBrandsMenuCard() {
        return {
            replace: true,
            scope: {
                location: '=',
                name: '=',
                customHeader: '=',
                storeInfo: '=',
                locationId: '=',
                customStoreName: '@',
                link: '@',
                linkText: '@',
                languageCode: '@',
                initMenuItemsShown: '=',
                showMoreText: '@',
                showLessText: '@',
                showImage: '@'
            },
            templateUrl: 'app/localLanding/cards/fatBrandsMenuCard.directive.html',
            restrict: 'AE',
            controller: fatBrandsMenuCardController,
            controllerAs: 'fatBrandsMenuCardController',
            bindToController: true
        };
    }

    function fatBrandsMenuCardController(menuService, $scope) {
        var fatBrandsMenuCardController = this;
        var defaultLanguageCode = "EN";

        var showMoreText = fatBrandsMenuCardController.showMoreText || "Show More";
        var showLessText = fatBrandsMenuCardController.showLessText || "Show Less";

        fatBrandsMenuCardController.showMoreLessText = showMoreText;
        fatBrandsMenuCardController.showMenu = false;
        if (fatBrandsMenuCardController.customStoreName) {
          var findName = _.find(fatBrandsMenuCardController.location.custom_fields, { "name": fatBrandsMenuCardController.customStoreName });
          fatBrandsMenuCardController.customStoreNameData = findName ? findName.data : fatBrandsMenuCardController.location.store_info.name;
        } else {
          fatBrandsMenuCardController.customStoreNameData = fatBrandsMenuCardController.storeInfo.name;
        }

        if (!fatBrandsMenuCardController.languageCode) {
          fatBrandsMenuCardController.languageCode = defaultLanguageCode;
        }

        function mapCategoryOptions(categoryOptions) {
          var options = new Array();

          for (var marker = 0; marker < categoryOptions.length; marker++) {
            var option = {
              "@type":"MenuItem",
              "name": categoryOptions[marker].name,
              "description":categoryOptions[marker].description.text,
            }

            if (!!categoryOptions[marker].price) {
              option.offers = {
                "@type": "Offer",
                "price": parseFloat(categoryOptions[marker].price.amount).toFixed(2),
                "priceCurrency": categoryOptions[marker].price.currencyCode
              }
            }

            options.push(option)
          }
          return options
        }

      menuService.getMenu(fatBrandsMenuCardController.languageCode, (fatBrandsMenuCardController.location.id)).then(function (menu) {
        if(menu.length) {
          for(var x = 0; x < menu.length; x++) {
            for(var y = 0; y < menu[x].options.length; y++) {
              if (menu[x].options[y].price && menu[x].options[y].price.amount) {
                menu[x].options[y].price.amount = parseFloat(menu[x].options[y].price.amount).toFixed(2)
              }
            }
          }
          fatBrandsMenuCardController.menu = menu;
          fatBrandsMenuCardController.schema = {'@context':'http://schema.org', '@type':'Menu','url': fatBrandsMenuCardController.storeInfo.website,'name':fatBrandsMenuCardController.storeInfo.brand_name,'hasMenuSection': [] };

          for (var i = 0; i < fatBrandsMenuCardController.menu.length; i++) {
            var menuCategory = {'@type':'MenuSection', 'name': fatBrandsMenuCardController.menu[i].categoryName,'hasMenuItem': mapCategoryOptions(fatBrandsMenuCardController.menu[i].options)}
            fatBrandsMenuCardController.schema.hasMenuSection.push(menuCategory)
          }

          var head = document.getElementsByTagName('head')[0];
          var script = document.createElement('script');
          script.type = 'application/ld+json';
          script.text = JSON.stringify(fatBrandsMenuCardController.schema)
          head.appendChild(script);


          if (fatBrandsMenuCardController.menu !== null && fatBrandsMenuCardController.menu.length > 0) {
            fatBrandsMenuCardController.address = fatBrandsMenuCardController.storeInfo.address +
              ", " +
              fatBrandsMenuCardController.storeInfo.locality +
              ", " +
              fatBrandsMenuCardController.storeInfo.region +
              " " +
              fatBrandsMenuCardController.storeInfo.postcode;
            fatBrandsMenuCardController.menu[0].active = true;

            setTimeout(function () {
              fatBrandsMenuCardController.showMenu = true;
            }, 500);
          }
        } else {
          $scope.$emit('hide-menu-card');
        }
      });

        $scope.$watch('$viewContentLoaded', function () { // When the menu has loaded
          setTimeout(function () {
            var menu = Array.from(document.getElementsByClassName('menu-content'))[0]
            var nav = Array.from(menu.getElementsByClassName('nav-tabs'))[0]

            makeOptionsAccessible() // Add tab indicies to menu items to make them accessible via tabbing
            navigateMenu(nav) // Change focus and tab indicies on category tabs when navigating via arrow keys
          }, 500)
        });

        function makeOptionsAccessible() {
          var menuOptions = Array.from(document.getElementsByClassName('menu-option'))
          menuOptions.forEach(function(el) {
            el.setAttribute('tabindex', '0');
          })
        }

        function navigateMenu(nav) {
          var tabs = Array.from(nav.children);
          tabs.forEach(function(tab, i) {
            if(i > 0) focusAndSetTabIndicies({negativeOne: tab}) // Set tabindex for category tabs to disable tabbing between

            tab.addEventListener('keydown', function(e){
              var currentTab = this;
              var navtabsLI = Array.from(currentTab.parentNode.children);

              if(e.keyCode == 39) { // When right arrow key is pressed,
                e.preventDefault();
                for(var i = 0; i < navtabsLI.length; i++) {
                  if(navtabsLI[i] == currentTab) {
                    var nextTab = navtabsLI[i + 1]
                    var previousTab = navtabsLI[i]
                    focusAndSetTabIndicies({negativeOne: previousTab, zero: nextTab, focus: nextTab}) // make tab before current inaccessible via tab, make next tab accessible via tab (so you can get back to it by reverse tabbing through the options) and focus on next tab
                  }
                }
              } else if (e.keyCode == 37) { // When left arrow key is pressed,
                e.preventDefault();
                for(var i = 0; i < navtabsLI.length; i++) {
                  if(navtabsLI[i] == currentTab) {
                    var previousTab = navtabsLI[i - 1]
                    focusAndSetTabIndicies({negativeOne: currentTab, zero: previousTab, focus: previousTab}) // make current tab inaccessible via tab, make tab before accessible via tab, put focus on previous tab
                  }
                }
              }
            })
          })
        }

        function focusAndSetTabIndicies(obj) {
          var a;
          for(var key in obj) {
            a = Array.from(obj[key].getElementsByTagName('a'))[0];
            if(key == 'negativeOne') a.setAttribute('tabindex', '-1');
            if(key == 'zero') a.setAttribute('tabindex', '0');
            if(key == 'focus') a.focus();
          }
        }

        function checkIfMenuIsLoaded(){
          var interval = setInterval(function() {
            var menuTabs = document.getElementById('tabset');
            if(menuTabs && fatBrandsMenuCardController.menu && fatBrandsMenuCardController.showMenu) {
              clearInterval(interval);
              reduceMenuCardLength();
            }
          },100)
        }

        checkIfMenuIsLoaded();

        function reduceMenuCardLength() {
            if(fatBrandsMenuCardController.initMenuItemsShown) {
              var activeTab = getActiveTab();
              var activeSection = findActiveSection();
              setOverflowItems(activeTab, activeSection);
            }
        }

        function getActiveTab() {
          var content = Array.from(document.getElementsByClassName('content'));
          return content.filter(function(menuSection) { return menuSection.parentElement.classList.contains('active') });
        }

        function findActiveSection() {
          var activeSection = fatBrandsMenuCardController.menu.filter(function(item) {
            return item.active;
          })
          return activeSection[0];
        }

        function setOverflowItems(activeTab, activeSection) {
          if (activeTab.length > 0) {
            var overflowItems = Array.from(activeTab[0].getElementsByTagName('li')).slice(fatBrandsMenuCardController.initMenuItemsShown, -1);
            Array.from(overflowItems).forEach(function(item){
              if(!item.classList.contains('overflow-item')) { item.classList.add('overflow-item')}
            })
            activeSection.overflowItems = true;
          }
        }

        function expandActiveTab(activeTab, activeSection) {
          activeSection.expanded = true;
          var overflowItems = Array.from(activeTab[0].getElementsByClassName('overflow-item'));
          overflowItems.forEach(function(item) {
            item.classList.add('show-item');
            item.style.maxHeight = item.scrollHeight + "px";
          })
        }

        function collapseActiveTab(activeTab, activeSection) {
          activeSection.expanded = false;
          var overflowItems = Array.from(activeTab[0].getElementsByClassName('overflow-item'));
          overflowItems.forEach(function(item) {
            item.classList.remove('show-item');
            item.style.maxHeight = null;
          })
        }

        fatBrandsMenuCardController.numItemsToggle = function() {
          var activeSection = findActiveSection();
          var activeTab = getActiveTab();
          if(!activeSection.expanded) {
            activeSection.expanded = true;
            fatBrandsMenuCardController.showMoreLessText = showLessText;
            expandActiveTab(activeTab, activeSection);
          } else {
            activeSection.expanded = false;
            fatBrandsMenuCardController.showMoreLessText = showMoreText;
            collapseActiveTab(activeTab, activeSection);
          }
        }
    }
})();


(function () {
  'use strict';

  angular
    .module('storeLocator')
    .directive('fatBrandsHoursCard', fatBrandsHoursCard);

  function fatBrandsHoursCard() {
    return {
      replace: true,
      scope: {
        location: '=',
        onlyToday: '=',
        customText: '@',
        hideEmptyHours: '=',
        simplified: '=',
        collapsibleOn: '@' // options are: mobile, desktop, all, or blank
      },
      templateUrl: 'app/localLanding/cards/fatBrandsHoursCard.directive.html',
      restrict: 'AE',
      controller: FatBrandsHoursController,
      controllerAs: 'fatBrandsHoursCardC',
      bindToController: true
    };
  }

  function FatBrandsHoursController(_, s, moment) {
    var fatBrandsHoursCardC = this;
    fatBrandsHoursCardC.closedNow = true;
    fatBrandsHoursCardC.open24 = false;
    fatBrandsHoursCardC.tempClosed = false;
    fatBrandsHoursCardC.openingHours = '';
    fatBrandsHoursCardC.toggleCollapsibleHours = toggleCollapsibleHours;

    // if temp closed, set fatBrandsHoursCardC.tempClosed
    if(fatBrandsHoursCardC.location.status == "temp closed") {
      fatBrandsHoursCardC.tempClosed = true;
    }

    // returns the hour fragment for the day depending on the passed key value
    fatBrandsHoursCardC.getOpenTimePeriodDisplayMessage = function(regularHours, index) {
      var key = '';
      if (angular.isDefined(index)) {
        key = 'openTimePeriodDisplayMessage_' + index;
      } else {
        key = 'openTimePeriodDisplayMessage';
      }
      return regularHours[key];
    };

    /**
     * function returns true if passed value is null, undefined and legth is zero, else false
     * @param {string} storeTimeZone 
     */
    function checkObj(storeTimeZone) {
      return ( _.isNull(storeTimeZone) || _.isUndefined(storeTimeZone) || storeTimeZone.length === 0 )
    }

    /**
     * function to check if the store is open or closed and set
     * the corresponding 'closedNow' value on the directive object
     * @param {object} hourObj hour object which has all the details about the timings/days
    */
    function updateTodaysHours(hourObj) {
      if (hourObj.closed) {
        fatBrandsHoursCardC.closed24 = true;
        return;
      }
      // check for today's special hours. start
      var isTodaySpecial = isTodaySpecialHours();
      //check for today's special hours. end
      //counter to loop through the number of fragments
      var counter = 0;
      while (counter < hourObj.numberOfTimeFragments.length) {
        var openTimePeriodKey = 'openTimePeriod' + '_' + counter;
        var closeTimePeriodKey = 'closeTimePeriod' + '_' + counter;

        if (hourObj[openTimePeriodKey] && hourObj[closeTimePeriodKey]) {
          fatBrandsHoursCardC[openTimePeriodKey] = moment(hourObj[openTimePeriodKey], "hh:mm A").format("h:mm a")
          fatBrandsHoursCardC[closeTimePeriodKey] = moment(hourObj[closeTimePeriodKey], "hh:mm A").format("h:mm a");
        }

        if (moment(hourObj[closeTimePeriodKey], "hh:mm A").isBefore(moment(hourObj[openTimePeriodKey], "hh:mm A")) || moment(hourObj[closeTimePeriodKey], "HH:mm A").format('HHmm') === '0000') {
          hourObj[closeTimePeriodKey] = moment(hourObj[closeTimePeriodKey], "hh:mm A").add(1, 'days');
        }

        var amIBetweenGroupKey = 'amIBetweenGroup' + '_' + counter;
        var now = moment();
        // store timezone code start
        var storeTimeZone = fatBrandsHoursCardC.location.store_info.timezone; // store timezone from api
        var storeCurrentDateTime = null;
        var convertedStoreHour = null;
        var isInvalidObj = checkObj(storeTimeZone);
        if (!isInvalidObj) {
          storeCurrentDateTime = getStoreCurrentTime(storeTimeZone);
          convertedStoreHour = moment(getConvertedStoreHours(storeCurrentDateTime), "hh:mm A");
        }
        // store timezone code end
        // instead of now object the comparison is made with convertedStoreHour object
        var startTime = moment(hourObj[openTimePeriodKey], "hh:mm A");
        var endTime = moment(hourObj[closeTimePeriodKey], "hh:mm A");
        if(!isInvalidObj){
          if (endTime.format('HHmm') < (startTime.format('HHmm'))) {
            if (convertedStoreHour.format('HHmm') < endTime.format('HHmm')) {
              startTime = startTime.subtract(1, 'days');
            } else {
              endTime = endTime.add(1, 'days');
            }
          }
          amIBetweenGroupKey = convertedStoreHour.isBetween(startTime, endTime);
        } else {
          if (endTime.format('HHmm') < (startTime.format('HHmm'))) {
            if (now.format('HHmm') < endTime.format('HHmm')) {
              startTime = startTime.subtract(1, 'days');
            } else {
              endTime = endTime.add(1, 'days');
            }
          }
          amIBetweenGroupKey = now.isBetween(startTime, endTime);
        }

        if (amIBetweenGroupKey) {
          fatBrandsHoursCardC.closeToday = endTime.format("h:mm a");
          if (amIBetweenGroupKey || hourObj.open24) {
            fatBrandsHoursCardC.closedNow = false;
          } else {
            fatBrandsHoursCardC.closedNow = true;
          }
        } else if(isTodaySpecial && !amIBetweenGroupKey){
          fatBrandsHoursCardC.closeToday = endTime.format("h:mm a");
          fatBrandsHoursCardC.closedNow = true;
        }
        counter++;
      }

      fatBrandsHoursCardC.openToday = hourObj.openDisplayTime;
      fatBrandsHoursCardC.open24 = hourObj.open24;
    }

    function isTodaySpecialHours(){
      var isTodaySpecial = false;
      var specialHours = (fatBrandsHoursCardC.location &&
        fatBrandsHoursCardC.location.store_info &&
        fatBrandsHoursCardC.location.store_info.special_hours) ?
        s(fatBrandsHoursCardC.location.store_info.special_hours).trim(";").value() : null;
          
      if (specialHours !== null) {
        // Check if any special hours are coming up.
        var validSpHours = checkSpecialHours(specialHours);
        if (!_.isEmpty(validSpHours)) {
          isTodaySpecial=true;
        }
      } 
      return isTodaySpecial;
    }

    function parseDateStrings(dateStrs) {
      var intDateStrs = dateStrs.split(";");
      return _.map(intDateStrs, function(dateStr) {
        var info = dateStr.split(",");
        if (angular.isDefined(info[1]) && info[1].toUpperCase() === "CLOSED") {
          // return just the day. This way we can use it to determine if today == which hour obj.
          return {
            day: info[0]
          };
        }
        else {
          // Else add open and close times based on the strings.
          // Will moment parse these to more readable strings later.
          return {
            day: info[0],
            openTime: info[1],
            closeTime: info[2]
          };
        }
      });
    }

    /**
     * function generates hours object for each day
     * @param {string} dateStrs open and close times for the week
     * @param {string} closeLabel close label for the location
    */
    function generateHours(dateStrs, closeLabel) {
      // Split up the dateStrs and generate objects for each one
      var parsedDateStrs = parseDateStrings(dateStrs);
      var locHours = {};
      _.range(1, 8).forEach(function(day) {
        // Generate base objects per day
        var newHoursObj = {
          day: day.toString(),
          dayName: moment().isoWeekday(day).format("dddd"),
          dayNameShort: moment().isoWeekday(day).format("dd"),
          dayNameShortNext: moment().isoWeekday(day).add(1, 'd').format("dd"),
          closedLabel: closeLabel
        };
        // filter method gets all the matching objects for a certain day of the week
        var parsedData = _.filter(parsedDateStrs, function(obj) {
          return obj['day'] === day.toString();
        });

        // all the open and close time for the store location in an array
        var openTime = _.map(parsedData, 'openTime');
        var closeTime = _.map(parsedData, 'closeTime');
        // adding the values to the object we will need to display all the times
        // and proper messaging for the store hours
        parsedData = {};
        _.forEach(openTime, function(value, key) {
          //moment js doesn't recognize 2400 hrs
          if (closeTime[key] === '2400') {
            closeTime[key] = '0000';
          }
          parsedData['openTime' + 'PeriodDisplayMessage' + '_' + key] = displayOpenAndClosedTime(openTime[key], closeTime[key]);
          parsedData['openTime' + 'Period' + '_' + key] = openTime[key] ? moment(openTime[key],"hmm").format("hh:mm A") : "";
          parsedData['closeTime' + 'Period' + '_' + key] = closeTime[key] ? moment(closeTime[key],"hmm").format("hh:mm A") : "";
          parsedData['openTime'] = openTime[0];
          parsedData['closeTime'] = closeTime[0];
          parsedData['numberOfTimeFragments'] = new Array(_.keys(openTime).length);
        });

        //we need the numberOfTimeFragments to display the correct message when clients pass empty store hours for the day
        if (openTime.length === 0) {
          parsedData['numberOfTimeFragments'] = new Array(1);
        }

        _.assign(newHoursObj, parsedData);
        locHours[day] = createHoursObj(newHoursObj);
        // Check if Today. If so, apply highlighting and modify
        // some controller level variables in a separate function.
        if (day.toString() === moment().format("E")) {
          if(!fatBrandsHoursCardC.simplified) {
            locHours[day].highlightClass = "bold-700";
          }
          //initialize the open and close time empty arrays
          openTime = [];
          closeTime = [];
          var counter = 0;
          while (counter < locHours[day]['numberOfTimeFragments'].length) {
            var openTimePeriodKey = 'openTimePeriod' + '_' + counter;
            var closeTimePeriodKey = 'closeTimePeriod' + '_' + counter;
            if (locHours[day][openTimePeriodKey] && locHours[day][openTimePeriodKey].length > 0 && locHours[day][closeTimePeriodKey].length > 0) {
              openTime.push(locHours[day][openTimePeriodKey]);
              closeTime.push(locHours[day][closeTimePeriodKey]);
            }
            counter++;
          }

          // when the location does not have hours for the day we
          // assume that it is closed
          if (openTime.length > 0 && closeTime.length > 0) {
            locHours[day].openTimePeriodDisplayMessage = isTheLocationOpen(openTime, closeTime);
          } else {
            locHours[day].closed = true;
          }
          updateTodaysHours(locHours[day]);
        }
      });

      return locHours;
    }

    /**
     * function generates the display time message for the different
     * periods/times for which the store is open
     * @param {string} openTime open time for the store
     * @param {string} closeTime close time for the store
    */
    function displayOpenAndClosedTime(openTime, closeTime) {
      var displayTime = "";
      if (openTime && closeTime) {
        displayTime = moment(openTime, "hmm").format("h:mm a") + " " + "-" + " " + moment(closeTime, "hmm").format("h:mm a");
      }
      return displayTime;
    }

    /**
     * function is used to get the current time in the store timezone
     * @param {string} actualStoreTimeZone 
     */
    function getStoreCurrentTime(actualStoreTimeZone){
      var currentStoreDateTime = null;
      var isInvalidObj = checkObj(actualStoreTimeZone);
      if (!isInvalidObj) {
        currentStoreDateTime = angular.isDefined((moment.tz.zone(actualStoreTimeZone))) ? moment.tz(actualStoreTimeZone).format('YYYY-MM-DD hh:mm A') : moment().format('YYYY-MM-DD hh:mm A');//
      }
      return currentStoreDateTime;
    }

    /**
     * function is used to get the time part from the converted store timezone
     * @param {moment} storeCurrentDateTime 
     */
    function getConvertedStoreHours(storeCurrentDateTime){
      var convertedStoreHours = null;
      var currTimeArr = storeCurrentDateTime.split(" ");
      var isInvalidObj = checkObj(currTimeArr);
      if (!isInvalidObj){ 
        var isInvalidObj1 = checkObj(currTimeArr[1]);
        if(!isInvalidObj1 && currTimeArr.length > 1){
          convertedStoreHours = currTimeArr[1].trim().concat(" ").concat(currTimeArr[2].trim()) ;
        }
      }
      return convertedStoreHours;
    }
    
    /**
     * function is used to generate the appropriate messaging for the
     * current day including store open/close times.
     * @param {array} openTime open time for the store for the current day
     * @param {array} closeTime close time for the store for the current day
    */
    function isTheLocationOpen(openTime, closeTime) {
      var amIBetweenFirstGroup = false;
      var amIBetweenSecondGroup = false;
      var amIBetweenThirdGroup = false;
      var storeOpenOrCloseMessage = '';
      var currentTime = moment();
      var displayMessage = '';
      var startTimeFirstGroup = openTime[0] ? moment(openTime[0].trim(), "HH:mm A") : "Closed Today";
      var endTimeFirstGroup = closeTime[0] ? moment(closeTime[0].trim(), "HH:mm A") : "Closed Today";

      var openTwentyFourHours = false;
      // store timezone code start
      var storeTimeZone = fatBrandsHoursCardC.location.store_info.timezone; // store timezone from api
      var storeCurrentDateTime = null;
      var convertedLocStoreHour = null;
      var isInvalidObj = checkObj(storeTimeZone);
      if (!isInvalidObj) {
        storeCurrentDateTime = getStoreCurrentTime(storeTimeZone);
        convertedLocStoreHour = moment(getConvertedStoreHours(storeCurrentDateTime), "hh:mm A");
      } else {
        convertedLocStoreHour = currentTime;
      }
      // store timezone code end
      
      if (openTime.length === 2) {
        var startTimeSecondGroup = moment(openTime[1], "HH:mm A");
        var endTimeSecondGroup = moment(closeTime[1], "HH:mm A");
      } else if (openTime.length === 3) {
        var startTimeThirdGroup = moment(openTime[2], "HH:mm A");
        var endTimeThirdGroup = moment(closeTime[2], "HH:mm A");
        startTimeSecondGroup = moment(openTime[1], "HH:mm A");
        endTimeSecondGroup = moment(closeTime[1], "HH:mm A");
      }
      //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
       // check if the close time is on the next date in the A.M.
        if (endTimeFirstGroup.format('HHmm') < (startTimeFirstGroup.format('HHmm')) || moment(closeTime[0], "HH:mm A").format('HHmm') === '0000') {
          //open 24 message if the store is open for 24hrs
          if (endTimeFirstGroup.format('HHmm') - (startTimeFirstGroup.format('HHmm')) === 0) {
            openTwentyFourHours = true;
          }
          // Check the user currentime is before shop close time then subtract 1 day from start date
          // as the shop has started in previous day
          // else add 1 day to end date as the shop will be closing on next day
          if (convertedLocStoreHour.format('HHmm') < (endTimeFirstGroup.format('HHmm'))) {
            startTimeFirstGroup = startTimeFirstGroup.subtract(1, 'days');
          } else {
            endTimeFirstGroup = endTimeFirstGroup.add(1, 'days');
          }
        }
      //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

      if (openTime.length === 2 && closeTime.length === 2) {
        // check if the close time is on the next date in the A.M.
        if (endTimeSecondGroup.isBefore(startTimeSecondGroup) || moment(closeTime[1], "HH:mm A").format('HHmm') === '0000') {
          endTimeSecondGroup = endTimeFirstGroup.add(1, 'days');
        }
        displayMessage = moment(openTime[0], "hh:mm A").format("h:mm a") + ' - '  + moment(closeTime[0], "hh:mm A").format("h:mm a") + ', ' +
                         moment(openTime[1], "hh:mm A").format("h:mm a") + ' - ' + moment(closeTime[1], "hh:mm A").format("h:mm a");
        // instead of currentTime object the comparison is made with convertedLocStoreHour object
        if (!isInvalidObj) {
          amIBetweenFirstGroup = convertedLocStoreHour.isBetween(startTimeFirstGroup, endTimeFirstGroup);
          amIBetweenSecondGroup = convertedLocStoreHour.isBetween(startTimeSecondGroup, endTimeSecondGroup);
        } else {
          // earlier implementation
          amIBetweenFirstGroup = currentTime.isBetween(startTimeFirstGroup, endTimeFirstGroup);
          amIBetweenSecondGroup = currentTime.isBetween(startTimeSecondGroup, endTimeSecondGroup);
        }

        if (amIBetweenFirstGroup) {
          storeOpenOrCloseMessage = 'Open Now Until ' + moment(closeTime[0], "hh:mm A").format("h:mm a") + ', ' + displayMessage;
        } else if (amIBetweenSecondGroup) {
          storeOpenOrCloseMessage = 'Open Now Until ' + moment(closeTime[1], "hh:mm A").format("h:mm a") + ', ' + displayMessage;
        } else {
          storeOpenOrCloseMessage = "Closed Now. Today's Hours: " + displayMessage;
        }
      } else if (openTime.length === 3 && closeTime.length === 3) {
        // if there are three fragments for store hours
        // check if the second fragment close time is on the next date in the A.M.
        if (endTimeSecondGroup.isBefore(startTimeSecondGroup) || moment(closeTime[1], "HH:mm A").format('HHmm') === '0000') {
          endTimeSecondGroup = endTimeFirstGroup.add(1, 'days');
        }
        // check if the third fragment close time is on the next date in the A.M.
        if (endTimeThirdGroup.isBefore(startTimeThirdGroup) || moment(closeTime[2], "HH:mm A").format('HHmm') === '0000') {
          endTimeThirdGroup = endTimeSecondGroup.add(1, 'days');
        }
        displayMessage = moment(openTime[0], "hh:mm A").format("h:mm a") + ' - ' + moment(closeTime[0], "hh:mm A").format("h:mm a") + ', ' +
                         moment(openTime[1], "hh:mm A").format("h:mm a") + ' - ' + moment(closeTime[1], "hh:mm A").format("h:mm a") + ', ' +
                         moment(openTime[2], "hh:mm A").format("h:mm a") + ' - ' + moment(closeTime[2], "hh:mm A").format("h:mm a");

        // time fragment flags
        // instead of currentTime object the comparison is made with convertedLocStoreHour object
        if (!isInvalidObj) {
          amIBetweenFirstGroup = convertedLocStoreHour.isBetween(startTimeFirstGroup, endTimeFirstGroup); // currentTime is replaced with convertedStoreHrs
          amIBetweenSecondGroup = convertedLocStoreHour.isBetween(startTimeSecondGroup, endTimeSecondGroup); // currentTime is replaced with convertedStoreHrs
          amIBetweenThirdGroup = convertedLocStoreHour.isBetween(startTimeThirdGroup, endTimeThirdGroup); // currentTime is replaced with convertedStoreHrs
        } else {
          // earlier implementation
          amIBetweenFirstGroup = currentTime.isBetween(startTimeFirstGroup, endTimeFirstGroup); // currentTime is replaced with convertedStoreHrs
          amIBetweenSecondGroup = currentTime.isBetween(startTimeSecondGroup, endTimeSecondGroup); // currentTime is replaced with convertedStoreHrs
          amIBetweenThirdGroup = currentTime.isBetween(startTimeThirdGroup, endTimeThirdGroup); // currentTime is replaced with convertedStoreHrs
        }
        if (amIBetweenFirstGroup) {
          storeOpenOrCloseMessage = 'Open Now Until ' + moment(closeTime[0], "hh:mm A").format("h:mm a") + ', ' + displayMessage;
        } else if (amIBetweenSecondGroup) {
          storeOpenOrCloseMessage = 'Open Now Until ' + moment(closeTime[1], "hh:mm A").format("h:mm a") + ', ' + displayMessage;

        } else if (amIBetweenThirdGroup) {
          storeOpenOrCloseMessage = 'Open Now Until ' + moment(closeTime[2], "hh:mm A").format("h:mm a") + ', ' + displayMessage;
        } else {
          storeOpenOrCloseMessage = "Closed Now. Today's Hours: " + displayMessage;
        }
      } else {
        // below line is commented to implement the store timezone changes
        //amIBetweenFirstGroup = currentTime.isBetween(startTimeFirstGroup, endTimeFirstGroup);
        // instead of currentTime object the comparison is made with convertedLocStoreHour object
        //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

        if (!isInvalidObj) {
          /* if (endTimeFirstGroup.format('HHmm') < (startTimeFirstGroup.format('HHmm')) || moment(closeTime[0], "HH:mm A").format('HHmm') === '0000') {
            //open 24 message if the store is open for 24hrs
            if (endTimeFirstGroup.format('HHmm') - (startTimeFirstGroup.format('HHmm')) === 0) {
              openTwentyFourHours = true;
            }
            // Check the user currentime is before shop close time then subtract 1 day from start date
            // as the shop has started in previous day
            // else add 1 day to end date as the shop will be closing on next day
            if (convertedLocStoreHour.format('HHmm') < (endTimeFirstGroup.format('HHmm'))) {
              startTimeFirstGroup = startTimeFirstGroup.subtract(1, 'days');
            } else {
              endTimeFirstGroup = endTimeFirstGroup.add(1, 'days');
            }
          } */
            amIBetweenFirstGroup = convertedLocStoreHour.isBetween(startTimeFirstGroup, endTimeFirstGroup);
        } else { // in case if timezone is not populated in timezone variable then it should display as earlier
          amIBetweenFirstGroup = currentTime.isBetween(startTimeFirstGroup, endTimeFirstGroup);
        }
        if (openTwentyFourHours) {
          storeOpenOrCloseMessage = 'Open 24 Hours';
        } else {
          if (amIBetweenFirstGroup) {
            storeOpenOrCloseMessage = 'Open Now Until ' + moment(closeTime[0], "hh:mm A").format("h:mm a");
          } else {
            storeOpenOrCloseMessage = "Closed Now. Today's Hours: " + moment(openTime[0], "hh:mm A").format("h:mm a") + ' - ' + moment(closeTime[0], "hh:mm A").format("h:mm a");
          }
        }
      }
      //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

      return storeOpenOrCloseMessage;
    }

    function generateSpecialHours(dateStrs) {
      // Split up the dateStrs and generate objects for each one
      var parsedDateStrs = parseDateStrings(dateStrs);
      var dates = _.uniq(_.map(parsedDateStrs, 'day'));
      var spHours = [];

      _.forEach(dates, function(date) {
        // Generate base objects per day
        var newHoursObj = {
          closedLabel: "Closed",
          dayNameShort: date,
          dayOfTheWeek: moment(date, "YYYY-MM-DD").format("E")
        };

        var parsedData = _.filter(parsedDateStrs, function(obj) {
          return obj['day'] === date.toString();
        });
        
        // all the open and close time for the store location in an array
        var openTime = _.map(parsedData, 'openTime');
        var closeTime = _.map(parsedData, 'closeTime');
        parsedData = {};
        _.forEach(openTime, function(value, key) {
          //moment js doesn't recognize 2400 hrs
          if (angular.isDefined(value)) {
            if (closeTime[key] === '2400') {
              closeTime[key] = '0000';
            }
            parsedData['openTime' + 'PeriodDisplayMessage' + '_' + key] = displayOpenAndClosedTime(openTime[key], closeTime[key]);
            parsedData['openTime' + 'Period' + '_' + key] = openTime[key] ? moment(openTime[key],"hmm").format("hh:mm A") : "";
            parsedData['closeTime' + 'Period' + '_' + key] = closeTime[key] ? moment(closeTime[key],"hmm").format("hh:mm A") : "";
            parsedData['openTime'] = openTime[0];
            parsedData['closeTime'] = closeTime[0];
            parsedData['numberOfTimeFragments'] = new Array(_.keys(openTime).length);
          } else {
            //we need the numberOfTimeFragments to display the correct message for the store hours in the directive.html
            parsedData['numberOfTimeFragments'] = new Array(_.keys(openTime).length);
          }
        });

        _.assign(newHoursObj, parsedData);
        var completeHoursObj = createHoursObj(newHoursObj);
        if(completeHoursObj.dayNameShort === moment().format("YYYY-MM-DD")) {
          if(!fatBrandsHoursCardC.simplified) {
            completeHoursObj.highlightClass = "bold-700";
          }

          //initialize the open and close time empty arrays
          openTime = [];
          closeTime = [];
          var counter = 0;
          while (counter < completeHoursObj['numberOfTimeFragments'].length) {
            var openTimePeriodKey = 'openTimePeriod' + '_' + counter;
            var closeTimePeriodKey = 'closeTimePeriod' + '_' + counter;
            if (completeHoursObj[openTimePeriodKey] && completeHoursObj[openTimePeriodKey].length > 0 && completeHoursObj[closeTimePeriodKey].length > 0) {
              openTime.push(completeHoursObj[openTimePeriodKey]);
              closeTime.push(completeHoursObj[closeTimePeriodKey]);
            }
            counter++;
          }

          // Remove all highlighting on regular hours
          _.forEach(fatBrandsHoursCardC.locHours, function (hourObj) {
            hourObj.highlightClass = "";
          });

          if (openTime.length > 0) {
            completeHoursObj.openTimePeriodDisplayMessage = isTheLocationOpen(openTime, closeTime);
          }
          updateTodaysHours(completeHoursObj);
        }
        spHours.push(completeHoursObj);
      });

      return spHours;
    }

    /* Things I removed:
     * location.status === 'coming soon' moving to directive.html
     */
    function createHoursObj(hourObj) {
      if (fatBrandsHoursCardC.location.status == "temp closed") {
        return _.assign(hourObj, {"closed": true, "closedLabel": "Temporarily Closed"})
      }
      if (!hourObj.hasOwnProperty("openTime")) {
        return _.assign(hourObj, {"closed": true});
      }
      hourObj.openTime = moment(hourObj.openTime, "HHmm");
      // If close is earlier than openM, then add 1 day to it
      hourObj.closeTime = moment(hourObj.closeTime, "HHmm");
      if (hourObj.closeTime.diff(hourObj.openTime) < 0) {
        hourObj.closeTime.add(1, 'd');
      }

      // Convenience vars so we only need to format or call moment on these once
      hourObj.openDisplayTime = hourObj.openTime.format("h:mm a");
      hourObj.closeDisplayTime = hourObj.closeTime.format("h:mm a");
      // Check if open 24/7 by comparing if diff of open and close time is 0
      hourObj.open24 = hourObj.openTime.diff(hourObj.closeTime) === 0;

      // Augment openingHours on controller
      fatBrandsHoursCardC.openingHours = fatBrandsHoursCardC.openingHours +
        hourObj.dayNameShort +
        ' ' +
        hourObj.openDisplayTime +
        ' - ' +
        hourObj.closeDisplayTime +
        ' ';

      return hourObj;
    }

    // Takes a datestring and checks if any special days are within 7 days of today
    // Return a list of dates + times that are within 7 days of today
    function checkSpecialHours(dates) {
      //For each date with special hours
      var intNearbyDates = _.filter(dates.trim().split(";"), function(el){
        return angular.isDefined(el) && el!=="";
      });

      var nearbyDates = _.map(intNearbyDates, function(specialDay) {
        //Split on the entry
        var dayData = specialDay.split(",");
        //Check today - specialDay < 7, if matched, return this date!
        var specialDateMoment = moment(dayData[0], "YYYY-M-D");
        var today = moment();
        if (specialDateMoment.diff(today, "days") < 7 &&
            specialDateMoment.diff(today, "days") >= 0) {
          return specialDay;
        }
      });
      return _.compact(nearbyDates).join(";");
    }
    if(fatBrandsHoursCardC.location.status == "coming soon"){
      fatBrandsHoursCardC.comingSoon = "Coming Soon"

    }
    else if (fatBrandsHoursCardC.location.status == "temp closed"){
      fatBrandsHoursCardC.comingSoon = "Temporarily Closed"
    }

    // If there's custom text, set it.
    if (fatBrandsHoursCardC.customText) {
      var str = fatBrandsHoursCardC.customText;
      str = str.replace(/\[(.*?[^.])\]/g, function (s, key) {
        return fatBrandsHoursCardC[key];
      });
      fatBrandsHoursCardC.customTextShow = str;
    }

    var checkHoursFormat = /^[0-9;,closedCLOSED]+$/;

    var sh = fatBrandsHoursCardC.location && fatBrandsHoursCardC.location.store_info ? s(fatBrandsHoursCardC.location.store_info.store_hours).trim(";").value() : null;
    // Replace anything that isn't number, ';', ',', or the letters c, l, o, s, e, d in their lower and capital forms
    sh = sh.replace(/[^0-9;,closedCLOSED]/g,'');
    sh = sh.trim();

    // Check if there are store hours listed. If not, show all days as "Closed" unless config indicates they should be hidden
    if (fatBrandsHoursCardC.location.store_info.store_hours == '' && (!fatBrandsHoursCardC.hideEmptyHours || fatBrandsHoursCardC.hideEmptyHours != true)) {
      fatBrandsHoursCardC.locHours = generateHours(sh, "Closed");
    }

    // Check if store is coming soon, if so, init all days to coming soon
    if (fatBrandsHoursCardC.location.status == "coming soon") {
      fatBrandsHoursCardC.locHours = generateHours(sh, "Coming Soon");
    }

    // Check if time returned is valid
    if (sh && checkHoursFormat.test(sh)) {
      fatBrandsHoursCardC.locHours = generateHours(sh, "Closed");
    }

    // Check for special hours
    var specialHours = (fatBrandsHoursCardC.location &&
      fatBrandsHoursCardC.location.store_info &&
      fatBrandsHoursCardC.location.store_info.special_hours) ?
      s(fatBrandsHoursCardC.location.store_info.special_hours).trim(";").value() : null;
      //specialHours = '2018-12-24,0000,1800;2018-12-25,CLOSED;2018-12-31,0000,2200;2019-01-01,0600,0000;2019-05-15,CLOSED';

    if (specialHours !== null) {
      // Check if any special hours are coming up.
      var validSpHours = checkSpecialHours(specialHours);
      if (!_.isEmpty(validSpHours)) {
        // For each special day, format it for display like normal hours.
        fatBrandsHoursCardC.specialHours = generateSpecialHours(validSpHours);
      }
    }
    fatBrandsHoursCardC.hoursNote = _.find(fatBrandsHoursCardC.location.custom_fields, {'name': 'hours_note'});


    function toggleCollapsibleHours() {
      var collapsibleHours = document.getElementsByClassName('collapsible')[0];
      var collapseIcon = document.getElementsByClassName('collapse-icon')[0].getElementsByTagName('i')[0];
      if(collapsibleHours.classList.value.indexOf('show') === -1) {
        collapsibleHours.classList.add('show');
        collapseIcon.classList.remove('fa-chevron-down');
        collapseIcon.classList.add('fa-chevron-up');
      } else {
        collapsibleHours.classList.remove('show');
        collapseIcon.classList.add('fa-chevron-down');
        collapseIcon.classList.remove('fa-chevron-up');
      }
    }
  }

})();

angular
  .module('storeLocator')
  .directive('errorCard', errorCard);

function errorCard() {

  return {
    templateUrl: 'app/localLanding/cards/errorCard.directive.html',
    restrict: 'E',
    bindToController: {
      locationError: '=',
      customLocator: '@',
      translatedMessages: '='
    },
    controller: errorCardController,
    controllerAs: 'errorCardC'
  }
}

function errorCardController(localLandingData, $timeout, $window, $scope, LanguageService) {
  var vm = this;
  var errorStatusCode = $scope.localLanding.errorStatus;
  vm.errorHeading;
  vm.nearbyLocationsFlag = true;
  vm.auto_redirect = false;
  vm.location_p = localLandingData.getLocationForLocality().then(locationListComplete);
  vm.languageService = LanguageService;
  
  if (vm.translatedMessages) {
    vm.errorLine1 = vm.translatedMessages['mf.errorMsg.locationNotFound.line1'];
    vm.errorLine2 = vm.translatedMessages['mf.errorMsg.locationNotFound.line2'];
    vm.errorLine3 = vm.translatedMessages['mf.errorMsg.locationNotFound.line3'];
    vm.errorRedirect = vm.translatedMessages['mf.errorMsg.locationNotFound.redirect'];
    vm.backButton = vm.translatedMessages['mf.sitemapPage.backButton'];
  } else {
    vm.errorLine1 = 'We were unable to find that location, it might have moved or closed.';
    vm.errorLine2 = 'Here are some links to other nearby locations:';
    vm.errorLine3 = 'Try searching for the location';
    vm.errorRedirect = 'Re-directing to this location';
    vm.backButton = 'Back';
  }

  errorStatus(errorStatusCode);

  function errorStatus(errorCode) {
    if (errorCode == 400) {
      vm.errorHeading = "HTTP ERROR 400: (BAD REQUEST)";
      vm.nearbyLocationsFlag = false;
    } else if (errorCode == 404) {
      vm.errorHeading = "HTTP ERROR 404: (RESOURCE NOT FOUND)";
      vm.nearbyLocationsFlag = false;
    } else if (errorCode == 500) {
      vm.errorHeading = "HTTP ERROR 500: (INTERNAL SERVER ERROR)";
      vm.nearbyLocationsFlag = false;
    } else {
      vm.errorHeading = vm.translatedMessages ? vm.translatedMessages['mf.errorMsg.locationNotFound.title'] : "Location Not Found";
    }
  }

  function locationListComplete(response) {
    vm.location = response;

    if (vm.location.length == undefined) {
      vm.nearbyLocationsFlag = false;
    } else if (vm.location.length == 1) {
      vm.auto_redirect = true;
      $timeout(load, 3500);
    }
  }

  function load() {
    $window.location.href = vm.languageService.updateLinkUrl(vm.location[0].llp_url);
  }

}

(function () {
    'use strict';
    angular
      .module('storeLocator')
      .directive('deliveryModalCard', deliveryModalCard);

    function deliveryModalCard() {
      return {
        replace: true,
        scope: {
          location: '=',
          buttonClass: '@',
          extendedDelivery: '=',
          firstPartyLogoLink: '@'
        },
        controller: deliveryModalCardController,
        controllerAs: 'deliveryModalCardCtrl',
        templateUrl: 'app/localLanding/cards/deliveryModalCard.directive.html',
        restrict: 'AE',
        bindToController: {}
      };

      function deliveryModalCardController(_, $location, $scope, $modal, customFieldFactory, storeLocatorCache) {

        var $ctrl = this;
        $ctrl.buttonClass = $scope.buttonClass;
        $ctrl.validDelivery = false;
        $ctrl.extendedDelivery = $scope.extendedDelivery;
        $ctrl.location = $scope.location;
        $ctrl.orderOnline = getCustomFieldValueByName($scope.location.custom_fields, "order_online_link")
          || getCustomFieldValueByName($scope.location.custom_fields, "online_order_link");
        $ctrl.text = getCustomFieldValueByName($scope.location.custom_fields, "order_online_button_text") || 'Order Online';
        var customModalTitle = getCustomFieldValueByName($scope.location.custom_fields, "order_online_modal_title")
        $ctrl.modalTitle = customModalTitle || "Online Order Options"
        $ctrl.pageCategory = $location.path() === '/' ? 'Store Locator' : 'LLP';
        var orderOnlineLink2 = getCustomFieldValueByName($scope.location.custom_fields, "order_online_link2");
        var orderOnlineLink3 = getCustomFieldValueByName($scope.location.custom_fields, "order_online_link3");
        var orderOnlineLink4 = getCustomFieldValueByName($scope.location.custom_fields, "order_online_link4");
        var orderOnlineLink5 = getCustomFieldValueByName($scope.location.custom_fields, "order_online_link5");
        var orderOnlineLink6 = getCustomFieldValueByName($scope.location.custom_fields, "order_online_link6");
        $ctrl.link = $ctrl.orderOnline || orderOnlineLink2 || orderOnlineLink3 || orderOnlineLink4 || orderOnlineLink5 || orderOnlineLink6;
        var logoLinkBase = 'https://s3-us-west-1.amazonaws.com/mfeed-store-locator.momentfeed.com/momentfeed/cards/delivery_modal/';
        var focus;
        var modal;
        $ctrl.showModal = function () {
          deliveryModal.$promise
          .then(deliveryModal.show)
          
        };

        $ctrl.keypressShowModal = function(e) {
          focus = document.activeElement
          var key=e.keyCode || e.which;
          if (key==13){
            e.preventDefault()
            deliveryModal.$promise
            .then(deliveryModal.show)
            .then(setTimeout(function() { document.getElementsByClassName('modal-content')[0].focus() },200))
            .then( function() {
              var anchors = document.getElementsByTagName('a');
              var buttons = document.getElementsByTagName('button');
              var inputs = document.getElementsByTagName('input');
              var selects = document.getElementsByTagName('select');
              var tabs = document.querySelectorAll('[tabindex]')
              var close = document.getElementById('delivery-modal-close')
              
              Array.from(anchors).forEach(function(x) { x.setAttribute('tabindex', '-1') })
              Array.from(buttons).forEach(function(x) { x.setAttribute('tabindex', '-1') })
              Array.from(inputs).forEach(function(x) { x.setAttribute('tabindex', '-1') })
              Array.from(selects).forEach(function(x) { x.setAttribute('tabindex', '-1') })
              Array.from(tabs).forEach(function(x) { x.setAttribute('tabindex', '-1') })
              close.setAttribute('tabindex', "0")
              
              setTimeout(setTabIndiciesToNegOne, 0)
            })
            .then(modal = document.getElementsByClassName('modal'))
            .then(setTimeout(addEventListenersToModal, 0));
          };
        };

        $ctrl.closeModal = function(e) {
          var key=e.keyCode || e.which;
          if (key==13){
            e.preventDefault()
            deliveryModal.$promise
            .then(deliveryModal.hide)
            .then(resetTabIndices())
            .then(focus.focus());
          }
        };

        function setTabIndiciesToNegOne() {
          var popup = document.querySelectorAll('.leaflet-popup a')
          Array.from(popup).forEach(function(x) { x.setAttribute('tabindex', '-1') })
        }

        function addEventListenersToModal() {
          modal[0].addEventListener('click', function() {
            resetTabIndices();
            focus.focus();
          })
          document.addEventListener('keydown', function(e) {
            var key2=e.keyCode || e.which;
            if(key2==27) {
              resetTabIndices();
            }
          })
        }

        function resetTabIndices() {
          var anchors = document.getElementsByTagName('a');
          var buttons = document.getElementsByTagName('button');
          var inputs = document.getElementsByTagName('input');
          var selects = document.getElementsByTagName('select');
          var tabs = document.querySelectorAll('[tabindex]')

          Array.from(anchors).forEach(function(x) { x.setAttribute('tabindex', '0') })
          Array.from(buttons).forEach(function(x) { x.setAttribute('tabindex', '0') })
          Array.from(inputs).forEach(function(x) { x.setAttribute('tabindex', '0') })
          Array.from(selects).forEach(function(x) { x.setAttribute('tabindex', '0') })
          Array.from(tabs).forEach(function(x) { x.setAttribute('tabindex', '0') })
        }
        
        $ctrl.getCustomFieldValueByName = getCustomFieldValueByName;
        $ctrl.hasCustomFieldValue = hasCustomFieldValue;

        function getCustomFieldValueByName(customFields, name) {
          if (hasCustomFieldValue(customFields, name)) {
            var value = customFieldFactory.getValueByName(customFields, name);
          }
          return value;
        }

        function hasCustomFieldValue(customFields, name) {
          return customFieldFactory.getValueByName(customFields, name) ? true : false;
        }


        function extractHostname(url) {
          var hostname;
          //find & remove protocol (http, ftp, etc.) and get hostname
          if (url.indexOf("//") > -1) {
            hostname = url.split('/')[2];
          }
          else {
            hostname = url.split('/')[0];
          }

          //find & remove port number
          hostname = hostname.split(':')[0];
          //find & remove "?"
          hostname = hostname.split('?')[0];

          return hostname;
        }

        //Extract the Root Domain
        function extractRootDomain(url) {
          var domain = extractHostname(url),
            splitArr = domain.split('.'),
            arrLen = splitArr.length;

          //Checking for a subdomain
          if (arrLen > 2) {
            domain = splitArr[arrLen - 2] + '.' + splitArr[arrLen - 1];
            if (splitArr[arrLen - 2].length == 2 && splitArr[arrLen - 1].length == 2) {
              domain = splitArr[arrLen - 3] + '.' + domain;
            }
          }
          var result = domain.split('.');
          return result[0];
        }

        function extractClientDomain() {
          var baseUrl = storeLocatorCache.get('storeFindersOptions').widgetOriginUrl;
          var chunks = baseUrl.split('.');

          return chunks[chunks.length - 1];
        }

        function pushOrderOnlineData(link) {
          var orderOnlineLabel = extractRootDomain(link).toUpperCase();
          $ctrl.linkCount++;
          $scope.labels.push(orderOnlineLabel);
          $scope.links.push(link);
          if (orderOnlineLabel.toUpperCase().indexOf($ctrl.clientDomain) > -1) {
            $scope.logos.push($ctrl.clientLogoLink);
          } else {
            if (orderOnlineLabel === "OLO") {
              $scope.logos.push(logoLinkBase + $ctrl.location.store_info.name + ' olo.png');
            } else if ($scope.firstPartyLogoLink && orderOnlineLabel === 'HNGR' || orderOnlineLabel === 'YALLAMEDI') {
              $scope.logos.push($scope.firstPartyLogoLink);
            } else {
              $scope.logos.push(logoLinkBase + orderOnlineLabel.toLowerCase() + '.png');
            }
          }
        }

        $scope.labels = [];
        $scope.links = [];
        $scope.logos = [];
        $ctrl.linkCount = 0;

        $ctrl.clientDomain = extractClientDomain().toUpperCase();

        $ctrl.clientLogoElem = document.getElementsByClassName("main-logo")[0] || document.getElementsByClassName("logo")[0] || document.getElementById("logo");
        if ($ctrl.clientLogoElem) {
          var  clientLogoImg = $ctrl.clientLogoElem.getElementsByTagName("img")[0];
          if(clientLogoImg){
            $ctrl.clientLogoLink = clientLogoImg.src;
          }
        }

        if ($ctrl.orderOnline != null) {
          pushOrderOnlineData($ctrl.orderOnline);
        }

        if (orderOnlineLink2 != null) {
          pushOrderOnlineData(orderOnlineLink2);
        }

        if (orderOnlineLink3 != null) {
          pushOrderOnlineData(orderOnlineLink3);

        }

        if (orderOnlineLink4 != null) {
          pushOrderOnlineData(orderOnlineLink4);
        }

        if (orderOnlineLink5 != null) {
          pushOrderOnlineData(orderOnlineLink5);
        }

        if (orderOnlineLink6 != null) {
          pushOrderOnlineData(orderOnlineLink6);
        }

        if ($ctrl.linkCount > 0){
          $ctrl.validDelivery = true;
        }
        if ($ctrl.linkCount > 1) {
          $ctrl.extendedDelivery = true;
        } else if($ctrl.linkCount > 0 && $ctrl.extendedDelivery == true) {
          $ctrl.extendedDelivery = true;
        }
        var deliveryModal = $modal(
          {
            title: 'Delivery Options',
            templateUrl: 'app/localLanding/cards/delivery.modal.html',
            placement: "center",
            windowClass: "center",
            show: false,
            animation: "am-fade-and-scale",
            scope: $scope
          });
      }
    }

  }

)();

(function () {
  'use strict';

  angular
    .module('storeLocator')
    .directive('customFieldsButton', customFieldsButton);

  function customFieldsButton() {

    return {
      replace: true,
      scope: {
        customFields: '=',
        customFieldName: "@",
        buttonText: "@",
        buttonTarget: '@'
      },
      templateUrl: 'app/localLanding/cards/customFieldsButton.directive.html',
      restrict: 'AE',
      controller: customFieldsButtonController,
      controllerAs: 'customFieldsButtonC',
      bindToController: true
    };
  }

  function customFieldsButtonController(_) {
    var customFieldsButtonC = this;

    if(_.isUndefined(customFieldsButtonC.buttonTarget)) {
      customFieldsButtonC.buttonTarget = "_blank";
    }

    customFieldsButtonC.findLink = _.find(customFieldsButtonC.customFields, {'name': customFieldsButtonC.customFieldName});

    // new custom button: customFieldName_link
    customFieldsButtonC.btnLink = _.find(customFieldsButtonC.customFields, {'name': customFieldsButtonC.customFieldName + "_link"});
    // new custom button: customFieldName_text
    customFieldsButtonC.btnText = _.find(customFieldsButtonC.customFields, {'name': customFieldsButtonC.customFieldName + "_text"});
    // 
    customFieldsButtonC.btnTitle = _.find(customFieldsButtonC.customFields, {'name': customFieldsButtonC.customFieldName + "_title" });
 


    if(!_.isUndefined(customFieldsButtonC.findLink)) {
      customFieldsButtonC.link = customFieldsButtonC.findLink.data;
    } else if (customFieldsButtonC.btnLink && customFieldsButtonC.btnText) {
      customFieldsButtonC.link = customFieldsButtonC.btnLink.data;
      customFieldsButtonC.buttonText = customFieldsButtonC.btnText.data;
    }

    if(!_.isUndefined(customFieldsButtonC.btnTitle)) {
      customFieldsButtonC.title = customFieldsButtonC.btnTitle.data;

    } else {
      customFieldsButtonC.title = customFieldsButtonC.buttonText;
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('storeLocator')
    .directive('carouselMenu', carouselMenu);

  function carouselMenu() {

    return {
      replace: true,
      scope: {
        location: '='
      },
      templateUrl: 'app/localLanding/cards/carouselMenu.directive.html',
      restrict: 'AE',
      controller: carouselMenuController,
      controllerAs: 'carouselMenuC',
      bindToController: true
    };
  }

  function carouselMenuController($scope, _) {
    var vm = this;
    vm.menuData = _.find(vm.location.custom_fields, {'name': 'carousel_menu_data'});
    if (vm.menuData) {
      vm.slides = JSON.parse(JSON.parse("\"" + vm.menuData.data + "\""));
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('storeLocator')
    .directive('buttonCard', buttonCard);

  function buttonCard() {
    return {
      transclude: true,
      replace: true,
      scope: {
        location: '=',
        customField: '@',
        customText: '@',
        customLink: '@',
        customEvent: '@',
        visibility: '@',
        target: '@?',
        ariaLabel: '@?',
      },
      templateUrl: 'app/localLanding/cards/buttonCard.directive.html',
      restrict: 'AE',
      controller: buttonCardC,
      controllerAs: 'buttonCardC',
      bindToController: true
    };
  }

  function buttonCardC(_, $element, $transclude) {
    var buttonCard = this;

    $transclude(function(transcludedEl, transScope) {
      $element.find('.transclude').replaceWith(transcludedEl);
    });

    buttonCard.button = buttonCard.customLink || _.find(buttonCard.location.custom_fields, { 'name': buttonCard.customField + '_link' });

    if (buttonCard.button) {
      buttonCard.buttonLink = buttonCard.button && buttonCard.button.data ? buttonCard.button.data : buttonCard.button;
      buttonCard.buttonText = buttonCard.customText;
      if (!buttonCard.customText) {
        var textCustomField = _.find(buttonCard.location.custom_fields, { 'name': buttonCard.customField + '_text' });
        buttonCard.buttonText = textCustomField ? textCustomField.data : buttonCard.buttonText;
      }
    }
  }
})();

(function () {
    'use strict';

    angular.module('storeLocator').directive('amenitiesCard', amenitiesCard);

    function amenitiesCard() {
        return {
            replace: true,
            scope: {
                customFields: '=',
                defaultImage: '@',
                displayInOneLine: '@',
                title: '@',
                client: '@',
                customContent: '@'
            },
            templateUrl: 'app/localLanding/cards/amenitiesCard.directive.html',
            restrict: 'AE',
            controller: amenitiesCardController,
            controllerAs: 'amenitiesCardController',
            bindToController: true
        };
    }

    function amenitiesCardController(amenitiesService, $filter, $sce) {
        var amenitiesCardController = this;
        amenitiesCardController.amenities = [];
        amenitiesCardController.amenitiesWithIcons = [];
        amenitiesCardController.amenitiesWithNoIcons = [];

        if (typeof amenitiesCardController.title === 'undefined') {
            amenitiesCardController.title = 'Amenities';
        }

        if (amenitiesCardController.customFields) {
            if(amenitiesCardController.customContent){
              var amenities = amenitiesService.getContents(amenitiesCardController.customFields, amenitiesCardController.customContent);
              amenitiesCardController.hasAmenities = amenities !== null && amenities.length > 0;
              amenitiesCardController.amenities = amenities;

              amenities.forEach(function (amenity) {
                  amenity.nameAmenity = $sce.trustAsHtml(amenity.data);
                  amenitiesCardController.amenitiesWithNoIcons.push(amenity);
              });
            }
            else{
              var amenities = amenitiesService.getAmenities(amenitiesCardController.customFields);
              amenitiesCardController.hasAmenities = amenities !== null && amenities.length > 0;
              amenitiesCardController.amenities = amenities;

              amenities.forEach(function (amenity) {
                if (amenity.tooltip === '') {
                  amenity.nameAmenity = $sce.trustAsHtml(amenity.data);
                  amenitiesCardController.amenitiesWithNoIcons.push(amenity);
                } else {
                  amenity.nameAmenity = $sce.trustAsHtml(amenity.tooltip);
                  amenitiesCardController.amenitiesWithIcons.push(amenity);
                }
              });
            }
        }
    }
})();

(function() {
  'use strict';

  angular
    .module('storeLocator')
    .directive('addressCard', addressCard);

  function addressCard (ADDRESS_CARD_TEMPLATE) {

    return {
      replace: true,
      scope: {
        location: '=',
        collapseAddress: '@',
        nameExtended: '@',
        customStoreName: '@',
        customButtonField: '@',
        customButtonText: '@',
        customButton2Field: '@',
        customButton2Text: '@',
        addressLink: '@',
        addressLinkTitle: '@',
        hideGetDirections: '=?', // Optional param for whether to show the "Get Directions" button.
        gtmOnClick: '=',
        deliveryModalExtendedDelivery: '=',
        altPhone: '@',
        hideReviews: '=',
        showCallButton: '=?',
        addressLinkDesktop: '@',
        getDirectionsTarget: '@?',
        customButtonFieldTarget: '@',
        hideAddressExtended: '=?',
        hidePhone: '=?',
        type: '=?'
      },
      templateUrl: ADDRESS_CARD_TEMPLATE,
      restrict: 'AE',
      controller:addressCardController,
      controllerAs:'addressCardC',
      bindToController: {altPhoneTitle: '=', mainPhoneTitle: '=', phoneAlwaysClickable: '@'}
      }
  }
      function addressCardController($scope, customFieldFactory) {
        var vm = this;

        vm.showGetDirections = true;
        vm.showAddressExtended = true;
        vm.showPhone = true;
        vm.storeSEOName = $scope.location.store_info.name;
          
        if ($scope.hideGetDirections) {
          vm.showGetDirections = false;
        }

        if ($scope.hideAddressExtended) {
          vm.showAddressExtended = false;
        }

        if ($scope.hidePhone) {
          vm.showPhone = false;
        }

        vm.getDirectionsTarget = $scope.getDirectionsTarget ? $scope.getDirectionsTarget : '_blank';
        vm.customButtonFieldTarget = $scope.customButtonFieldTarget ? $scope.customButtonFieldTarget : '_blank';
        vm.statusFlag = '';

        if ($scope.location.status == "coming soon"){
          vm.statusFlag = "This Location is Coming Soon."
        }
        else if ($scope.location.status == "temp closed"){
          vm.statusFlag = "This Location is Temporarily Closed."
        }

        vm.directionsUrl = $scope.location.store_info.directionsUrl;

        if ($scope.customStoreName) {
            var findName = _.find($scope.location.custom_fields, { "name": $scope.customStoreName });
            vm.storeName = findName ? customFieldFactory.resolveDynamicFieldsInText($scope.location.store_info, $scope.location.custom_fields, findName.name) : $scope.location.store_info.name;
        } else {
            vm.storeName = $scope.location.store_info.name;
        }

        if ($scope.nameExtended && $scope.nameExtended.includes('[')) {
          var arr = $scope.nameExtended.substr(1, $scope.nameExtended.length - 2).split(',');
          var nameExtendedConfig = [];
          arr.forEach(function(item) {
            item = _.find($scope.location.custom_fields, { "name": item });
            if(item && item.data) nameExtendedConfig.push(item.data);
          })
          nameExtendedConfig.length > 0 ? vm.nameExtendedConfig = nameExtendedConfig : vm.nameExtended = (_.find($scope.location.custom_fields, { "name": "name_extended" })).data
        } else if ($scope.nameExtended && !$scope.nameExtended.includes('[')) {
          vm.nameExtendedConfig = (_.find($scope.location.custom_fields, { "name": $scope.nameExtended })).data
        } else if(!$scope.nameExtended) {
          var name = _.find($scope.location.custom_fields, { "name": "name_extended" })
          if(name) vm.nameExtended = name.data;
        }

        vm.menuLink = _.find($scope.location.custom_fields, {"name": "menulink"});
        if (_.find($scope.location.custom_fields, {"name": "online_order_link"})) {
          vm.onlineOrderLink = _.find($scope.location.custom_fields, {"name": "online_order_link"});
        } else if (_.find($scope.location.custom_fields, {"name": "order_online_link"})) {
          vm.onlineOrderLink = _.find($scope.location.custom_fields, {"name": "order_online_link"}); }
        vm.customButtonLink = _.find($scope.location.custom_fields, { "name": $scope.customButtonField });
        var customButtonText = _.find($scope.location.custom_fields, { "name": $scope.customButtonText })
        vm.customButtonText = customButtonText ? customButtonText.data : $scope.customButtonText;

        vm.customButton2Link = _.find($scope.location.custom_fields, { "name": $scope.customButton2Field });
        var customButton2Text = _.find($scope.location.custom_fields, { "name": $scope.customButton2Text })
        vm.customButton2Text = customButton2Text ? customButton2Text.data : $scope.customButton2Text;

        if($scope.collapseAddress){
        vm.addressExtended = $scope.location.store_info.address+" "+$scope.location.store_info.address_extended;
        }
        
        //Populating alternatie phone number
        if($scope.location.custom_fields) {
          var findAltPhone = _.find($scope.location.custom_fields, { "name": $scope.altPhone });
          if(findAltPhone) {
            vm.altPhone = findAltPhone ? findAltPhone.data : findAltPhone ;
          }
        }
        
        if($scope.gtmOnClick == true) {
          window.onload = function() {
            var getDirectionsBtn = document.getElementsByClassName('get-directions')
            var deliveryModal = document.getElementsByClassName('delivery-modal')
            if(getDirectionsBtn[0]) {
              getDirectionsBtn[0].addEventListener('click', function() {
                getDirectionsLLP($scope.location.store_info.corporate_id)
              })
            }
            if(deliveryModal[0]) {
              deliveryModal[0].addEventListener('click', function() {
                deliveryModalLLP($scope.location.store_info.corporate_id)
              })
            }
          }
        }

      }
})();

(function () {
    'use strict';

    angular
      .module('storeLocator')
      .directive('addressBreadcrumbCard', addressBreadcrumbCard);

    function addressBreadcrumbCard() {
        return {
            replace: true,
            scope: { 
              location: '=',
              charSeparator: '@?',
              sitemapLevels: '@?', // comma separated list of sitemap levels without spaces
              useUrlDash: '@?',
              useUrlLowercase: '@?',
              siteMapPrefix: '@?'
            },
            controller: addressBreadcrumbCardController,
            templateUrl: 'app/localLanding/cards/addressBreadcrumbCard.directive.html',
            controllerAs: 'addressBreadcrumbCardC',
            restrict: 'AE'
        };
    }

    function addressBreadcrumbCardController(LanguageService, $scope, urldashFilter) {
      var vm = this;
      vm.separator = "|";
      vm.sitemapLevels = ($scope.sitemapLevels || 'country,region,locality').split(',');
      vm.siteMapPrefix = angular.isUndefined($scope.siteMapPrefix) ? 'site-map' : $scope.siteMapPrefix;

      if ($scope.charSeparator) {
        vm.separator = $scope.charSeparator;
      }

      vm.hasSitemapLevel = function(level) {
        return vm.sitemapLevels.indexOf(level) !== -1;
      }

      vm.getSitemapLevelUrl = function(level) {
        let url = '';
        const index = vm.sitemapLevels.indexOf(level);

        for (let i = 0; i <= index; i++) {
          url += '/' + $scope.location[vm.sitemapLevels[i]];
        }

        if ($scope.useUrlDash) {
          url = urldashFilter(url, false, $scope.useUrlLowercase)
        }

        return LanguageService.updateLinkUrl(vm.siteMapPrefix + url);
      }
    }
})();

(function() {
	'use strict';

	angular
		.module('storeLocator')
		.directive('aboutCard', aboutCard);

	function aboutCard() {

		return {
			replace: true,
			scope: {
			    location: '=',
                   title: '@'
			},
			templateUrl: 'app/localLanding/cards/aboutCard.directive.html',
			restrict: 'AE',
			controller: aboutCardController,
			controllerAs: 'aboutCardCtrl',
			bindToController: true
		};
	}

	function aboutCardController($sce) {
	    var aboutCardCtrl = this;
	    if (typeof aboutCardCtrl.title === 'undefined') {
	        aboutCardCtrl.hasTitle = false;
	    } else {
	        aboutCardCtrl.hasTitle = true;
	    }

	    if (!_.isUndefined(aboutCardCtrl.location.description)) {
	        aboutCardCtrl.description = $sce.trustAsHtml(aboutCardCtrl.location.description);
	    }
	}

})();

(function() {
  'use strict';

  angular
    .module('storeLocator')
    .directive('starRating', starRating);

  function starRating () {
    return {
        restrict: 'A',
        template: '<ul class="rating">' +
            '<li ng-repeat="star in stars" ng-class="star">' +
            '\u2605' +
            '</li>' +
            '</ul>',
        scope: {
            ratingValue: '=',
            max: '='
        },
        link: function (scope) {
            scope.stars = [];
            for (var i = 0; i < scope.max; i++) {
                scope.stars.push({
                    filled: i < scope.ratingValue
                });
            }
        }
    }

  }
})();

/**
 * angular-bootstrap-scrolling-tabs
 * @version v1.2.0
 * @link https://github.com/mikejacobson/angular-bootstrap-scrolling-tabs
 * @author Mike Jacobson <michaeljjacobson1@gmail.com>
 * @license MIT License, http://www.opensource.org/licenses/MIT
 */
; (function ($, window) {
    'use strict';

    var scrollingTabsModule = angular.module('mj.scrollingTabs', []);

    var CONSTANTS = {
        CONTINUOUS_SCROLLING_TIMEOUT_INTERVAL: 50, // timeout interval for repeatedly moving the tabs container
        // by one increment while the mouse is held down--decrease to
        // make mousedown continous scrolling faster
        SCROLL_OFFSET_FRACTION: 6, // each click moves the container this fraction of the fixed container--decrease
        // to make the tabs scroll farther per click
        DATA_KEY_IS_MOUSEDOWN: 'ismousedown'
    };

    // smartresize from Paul Irish (debounced window resize)
    (function ($, sr) {
        var debounce = function (func, threshold, execAsap) {
            var timeout;

            return function debounced() {
                var obj = this, args = arguments;
                function delayed() {
                    if (!execAsap)
                        func.apply(obj, args);
                    timeout = null;
                }

                if (timeout)
                    clearTimeout(timeout);
                else if (execAsap)
                    func.apply(obj, args);

                timeout = setTimeout(delayed, threshold || 100);
            };
        };
        jQuery.fn[sr] = function (fn) { return fn ? this.bind('resize.scrtabs', debounce(fn)) : this.trigger(sr); };

    })(jQuery, 'smartresize');

    /* *************************************************************
     * scrolling-tabs element directive template
     * *************************************************************/
    // plunk: http://plnkr.co/edit/YhKiIhuAPkpAyacu6tuk
    var scrollingTabsTemplate = [
      '<div class="scrtabs-tab-container">',
      ' <div class="scrtabs-tab-scroll-arrow scrtabs-js-tab-scroll-arrow-left"><span class="glyphicon glyphicon-chevron-left"></span></div>',
      '   <div class="scrtabs-tabs-fixed-container">',
      '     <div class="scrtabs-tabs-movable-container">',
      '       <ul class="nav nav-tabs" role="tablist">',
      '         <li ng-class="{ \'active\': tab[propActive || \'active\'], ',
      '                         \'disabled\': tab[propDisabled || \'disabled\'] }" ',
      '             data-tab="{{tab}}" data-index="{{$index}}" ng-repeat="tab in tabsArr">',
      '           <a ng-href="{{\'#\' + tab[propPaneId || \'paneId\']}}" role="tab"',
      '                data-toggle="{{tab[propDisabled || \'disabled\'] ? \'\' : \'tab\'}}" ',
      '                ng-bind-html="sanitize(tab[propTitle || \'title\']);">',
      '           </a>',
      '         </li>',
      '       </ul>',
      '     </div>',
      ' </div>',
      ' <div class="scrtabs-tab-scroll-arrow scrtabs-js-tab-scroll-arrow-right"><span class="glyphicon glyphicon-chevron-right"></span></div>',
      '</div>'
    ].join('');


    /* *************************************************************
     * scrolling-tabs-wrapper element directive template
     * *************************************************************/
    // plunk: http://plnkr.co/edit/lWeQxxecKPudK7xlQxS3
    var scrollingTabsWrapperTemplate = [
      '<div class="scrtabs-tab-wrapper-container" ng-class="{ \'force-height\': !scrtc.hasTabContentOutsideMovableContainer }">',
      ' <div class="scrtabs-tab-scroll-arrow scrtabs-js-tab-scroll-arrow-left"><span class="glyphicon glyphicon-chevron-left"></span></div>',
      '   <div class="scrtabs-tabs-fixed-container">',
      '     <div class="scrtabs-tabs-movable-container" ng-transclude></div>',
      '   </div>',
      ' <div class="scrtabs-tab-scroll-arrow scrtabs-js-tab-scroll-arrow-right"><span class="glyphicon glyphicon-chevron-right"></span></div>',
      '</div>'
    ].join('');

    /* ***********************************************************************************
     * ElementsHandler - Class that each instance of ScrollingTabsControl will instantiate
     * **********************************************************************************/
    function ElementsHandler(scrollingTabsControl) {
        var ehd = this;

        ehd.stc = scrollingTabsControl;
    }

    // ElementsHandler prototype methods
    (function (p) {
        p.initElements = function (options) {
            var ehd = this,
                stc = ehd.stc,
                $tabsContainer = stc.$tabsContainer;

            ehd.setElementReferences();

            if (options.isWrappingAngularUITabset) {
                ehd.moveTabContentOutsideScrollContainer(options);
            }

            ehd.setEventListeners();
        };

        p.moveTabContentOutsideScrollContainer = function (options) {
            var ehd = this,
                stc = ehd.stc,
                $tabsContainer = stc.$tabsContainer,
                $movableContainer = $tabsContainer.find('.scrtabs-tabs-movable-container'),
                $tabContentInMovableContainer = $movableContainer.find('.tab-content'),
                uibTabsetController = $movableContainer.find('> div').eq(0).data('$uibTabsetController');

            $tabContentInMovableContainer.show().appendTo($tabsContainer);

            if (uibTabsetController) {
                $tabContentInMovableContainer.data('$uibTabsetController', uibTabsetController);
            }
        };

        p.refreshAllElementSizes = function () {
            var ehd = this,
                stc = ehd.stc,
                smv = stc.scrollMovement,
                scrollArrowsWereVisible = stc.scrollArrowsVisible,
                actionsTaken = {
                    didScrollToActiveTab: false
                },
                minPos;

            ehd.setElementWidths();
            ehd.setScrollArrowVisibility();

            if (stc.scrollArrowsVisible) {
                ehd.setFixedContainerWidthForJustVisibleScrollArrows();
            }

            // this could have been a window resize or the removal of a
            // dynamic tab, so make sure the movable container is positioned
            // correctly because, if it is far to the left and we increased the
            // window width, it's possible that the tabs will be too far left,
            // beyond the min pos.
            if (stc.scrollArrowsVisible || scrollArrowsWereVisible) {
                if (stc.scrollArrowsVisible) {
                    // make sure container not too far left
                    minPos = smv.getMinPos();
                    if (stc.movableContainerLeftPos < minPos) {
                        smv.incrementScrollRight(minPos);
                    } else {
                        smv.scrollToActiveTab({
                            isOnWindowResize: true
                        });

                        actionsTaken.didScrollToActiveTab = true;
                    }
                } else {
                    // scroll arrows went away after resize, so position movable container at 0
                    stc.movableContainerLeftPos = 0;
                    smv.slideMovableContainerToLeftPos();
                }
            }

            return actionsTaken;
        };

        p.setElementReferences = function () {
            var ehd = this,
                stc = ehd.stc,
                $tabsContainer = stc.$tabsContainer;

            stc.isNavPills = false;

            stc.$fixedContainer = $tabsContainer.find('.scrtabs-tabs-fixed-container');
            stc.$movableContainer = $tabsContainer.find('.scrtabs-tabs-movable-container');
            stc.$tabsUl = stc.$movableContainer.find('.nav-tabs');

            // check for pills
            if (!stc.$tabsUl.length) {
                stc.$tabsUl = stc.$movableContainer.find('.nav-pills');

                if (stc.$tabsUl.length) {
                    stc.isNavPills = true;
                }
            }

            stc.$tabsLiCollection = stc.$tabsUl.find('> li');
            stc.$leftScrollArrow = $tabsContainer.find('.scrtabs-js-tab-scroll-arrow-left');
            stc.$rightScrollArrow = $tabsContainer.find('.scrtabs-js-tab-scroll-arrow-right');
            stc.$scrollArrows = stc.$leftScrollArrow.add(stc.$rightScrollArrow);

            stc.$win = $(window);
        };

        p.setElementWidths = function () {
            var ehd = this,
                stc = ehd.stc;

            if (!stc.$win) {
                return;
            }

            stc.containerWidth = stc.$tabsContainer.outerWidth();
            stc.winWidth = stc.$win.width();

            stc.scrollArrowsCombinedWidth = stc.$leftScrollArrow.outerWidth() + stc.$rightScrollArrow.outerWidth();

            ehd.setFixedContainerWidth();
            ehd.setMovableContainerWidth();
        };

        p.setEventListeners = function () {
            var ehd = this,
                stc = ehd.stc,
                evh = stc.eventHandlers; // eventHandlers

            stc.$leftScrollArrow.off('.scrtabs').on({
                'mousedown.scrtabs touchstart.scrtabs': function (e) { evh.handleMousedownOnLeftScrollArrow.call(evh, e); },
                'mouseup.scrtabs touchend.scrtabs': function (e) { evh.handleMouseupOnLeftScrollArrow.call(evh, e); },
                'click.scrtabs': function (e) { evh.handleClickOnLeftScrollArrow.call(evh, e); }
            });

            stc.$rightScrollArrow.off('.scrtabs').on({
                'mousedown.scrtabs touchstart.scrtabs': function (e) { evh.handleMousedownOnRightScrollArrow.call(evh, e); },
                'mouseup.scrtabs touchend.scrtabs': function (e) { evh.handleMouseupOnRightScrollArrow.call(evh, e); },
                'click.scrtabs': function (e) { evh.handleClickOnRightScrollArrow.call(evh, e); }
            });

            stc.$win.smartresize(function (e) { evh.handleWindowResize.call(evh, e); });
        };

        p.setFixedContainerWidth = function () {
            var ehd = this,
                stc = ehd.stc,
                tabsContainerRect = stc.$tabsContainer.get(0).getBoundingClientRect();

            stc.fixedContainerWidth = tabsContainerRect.width || (tabsContainerRect.right - tabsContainerRect.left);
            stc.$fixedContainer.width(stc.fixedContainerWidth);
        };

        p.setFixedContainerWidthForJustHiddenScrollArrows = function () {
            var ehd = this,
                stc = ehd.stc;

            stc.$fixedContainer.width(stc.fixedContainerWidth);
        };

        p.setFixedContainerWidthForJustVisibleScrollArrows = function () {
            var ehd = this,
                stc = ehd.stc;

            stc.$fixedContainer.width(stc.fixedContainerWidth - stc.scrollArrowsCombinedWidth);
        };

        p.setMovableContainerWidth = function () {
            var ehd = this,
                stc = ehd.stc,
                $tabLi = stc.$tabsUl.find('li'),
                fixedContainerHeight = stc.$fixedContainer.height(),
                maxWidthExpansions = 10; // prevent infinite loop

            stc.movableContainerWidth = 0;

            if ($tabLi.length) {

                $tabLi.each(function __getLiWidth() {
                    var $li = $(this),
                        totalMargin = 0;

                    if (stc.isNavPills) { // pills have a margin-left, tabs have no margin
                        totalMargin = parseInt($li.css('margin-left'), 10) + parseInt($li.css('margin-right'), 10);
                    }

                    stc.movableContainerWidth += ($li.outerWidth() + totalMargin);
                });

                stc.movableContainerWidth += 1;

                // if the tabs don't span the width of the page, force the
                // movable container width to full page width so the bottom
                // border spans the page width instead of just spanning the
                // width of the tabs
                if (stc.movableContainerWidth < stc.fixedContainerWidth) {
                    stc.movableContainerWidth = stc.fixedContainerWidth;
                }
            }

            stc.$movableContainer.width(stc.movableContainerWidth);

            // when we have >35 pills, sometimes the movable container width ends
            // up being a pixel short, causing the last pill to wrap; so we do
            // this check for a wrapped pill--we check if the movable container
            // height has expanded beyond the fixed container height (indicating
            // a wrapped pill), and if it has, we increase the movable container
            // width 1 pixel at a time until there's no wrap. We also put a
            // limit on the number of checks/expansions to prevent an infinite
            // loop, in case we get into some weird situation where adding width
            // never fixes the wrap.
            while ((stc.$movableContainer.height() > fixedContainerHeight) && maxWidthExpansions--) {
                stc.$movableContainer.width(stc.movableContainerWidth += 1);
            }

        };

        p.setScrollArrowVisibility = function () {
            var ehd = this,
                stc = ehd.stc,
                shouldBeVisible = stc.movableContainerWidth > stc.fixedContainerWidth;

            if (shouldBeVisible && !stc.scrollArrowsVisible) {
                stc.$scrollArrows.show();
                stc.scrollArrowsVisible = true;
                ehd.setFixedContainerWidthForJustVisibleScrollArrows();
            } else if (!shouldBeVisible && stc.scrollArrowsVisible) {
                stc.$scrollArrows.hide();
                stc.scrollArrowsVisible = false;
                ehd.setFixedContainerWidthForJustHiddenScrollArrows();
            }
        };

    }(ElementsHandler.prototype));

    /* ***********************************************************************************
     * EventHandlers - Class that each instance of ScrollingTabsControl will instantiate
     * **********************************************************************************/
    function EventHandlers(scrollingTabsControl) {
        var evh = this;

        evh.stc = scrollingTabsControl;
    }

    // prototype methods
    (function (p) {
        p.handleClickOnLeftScrollArrow = function (e) {
            var evh = this,
                stc = evh.stc;

            stc.scrollMovement.incrementScrollLeft();
        };

        p.handleClickOnRightScrollArrow = function (e) {
            var evh = this,
                stc = evh.stc,
                scrollMovement = stc.scrollMovement;

            scrollMovement.incrementScrollRight(scrollMovement.getMinPos());
        };

        p.handleMousedownOnLeftScrollArrow = function (e) {
            var evh = this,
                stc = evh.stc;

            stc.scrollMovement.startScrollLeft();
        };

        p.handleMousedownOnRightScrollArrow = function (e) {
            var evh = this,
                stc = evh.stc;

            stc.scrollMovement.startScrollRight();
        };

        p.handleMouseupOnLeftScrollArrow = function (e) {
            var evh = this,
                stc = evh.stc;

            stc.scrollMovement.stopScrollLeft();
        };

        p.handleMouseupOnRightScrollArrow = function (e) {
            var evh = this,
                stc = evh.stc;

            stc.scrollMovement.stopScrollRight();
        };

        p.handleWindowResize = function (e) {
            var evh = this,
                stc = evh.stc,
                newWinWidth = stc.$win.width();

            if (newWinWidth === stc.winWidth) {
                return false; // false alarm
            }

            stc.winWidth = newWinWidth;
            stc.elementsHandler.refreshAllElementSizes();
        };

    }(EventHandlers.prototype));

    /* ***********************************************************************************
     * ScrollMovement - Class that each instance of ScrollingTabsControl will instantiate
     * **********************************************************************************/
    function ScrollMovement(scrollingTabsControl) {
        var smv = this;

        smv.stc = scrollingTabsControl;
    }

    // prototype methods
    (function (p) {

        p.continueScrollLeft = function () {
            var smv = this,
                stc = smv.stc;

            stc.$timeout(function () {
                if (stc.$leftScrollArrow.data(CONSTANTS.DATA_KEY_IS_MOUSEDOWN) && (stc.movableContainerLeftPos < 0)) {
                    if (!smv.incrementScrollLeft()) { // scroll limit not reached, so keep scrolling
                        smv.continueScrollLeft();
                    }
                }
            }, CONSTANTS.CONTINUOUS_SCROLLING_TIMEOUT_INTERVAL);
        };

        p.continueScrollRight = function (minPos) {
            var smv = this,
                stc = smv.stc;

            stc.$timeout(function () {
                if (stc.$rightScrollArrow.data(CONSTANTS.DATA_KEY_IS_MOUSEDOWN) && (stc.movableContainerLeftPos > minPos)) {
                    // slide tabs LEFT -> decrease movable container's left position
                    // min value is (movableContainerWidth - $tabHeader width)
                    if (!smv.incrementScrollRight(minPos)) {
                        smv.continueScrollRight(minPos);
                    }
                }
            }, CONSTANTS.CONTINUOUS_SCROLLING_TIMEOUT_INTERVAL);
        };

        p.decrementMovableContainerLeftPos = function (minPos) {
            var smv = this,
                stc = smv.stc;

            stc.movableContainerLeftPos -= (stc.fixedContainerWidth / CONSTANTS.SCROLL_OFFSET_FRACTION);
            if (stc.movableContainerLeftPos < minPos) {
                stc.movableContainerLeftPos = minPos;
            } else if (stc.scrollToTabEdge) {
                smv.setMovableContainerLeftPosToTabEdge('right');

                if (stc.movableContainerLeftPos < minPos) {
                    stc.movableContainerLeftPos = minPos;
                }
            }
        };

        p.getMinPos = function () {
            var smv = this,
                stc = smv.stc;

            return stc.scrollArrowsVisible ? (stc.fixedContainerWidth - stc.movableContainerWidth - stc.scrollArrowsCombinedWidth) : 0;
        };

        p.getMovableContainerCssLeftVal = function () {
            var smv = this,
                stc = smv.stc;

            return (stc.movableContainerLeftPos === 0) ? '0' : stc.movableContainerLeftPos + 'px';
        };

        p.incrementScrollLeft = function () {
            var smv = this,
                stc = smv.stc;

            stc.movableContainerLeftPos += (stc.fixedContainerWidth / CONSTANTS.SCROLL_OFFSET_FRACTION);

            if (stc.movableContainerLeftPos > 0) {
                stc.movableContainerLeftPos = 0;
            } else if (stc.scrollToTabEdge) {
                smv.setMovableContainerLeftPosToTabEdge('left');

                if (stc.movableContainerLeftPos > 0) {
                    stc.movableContainerLeftPos = 0;
                }
            }

            smv.slideMovableContainerToLeftPos();

            return (stc.movableContainerLeftPos === 0); // indicates scroll limit reached
        };

        p.incrementScrollRight = function (minPos) {
            var smv = this,
                stc = smv.stc;

            smv.decrementMovableContainerLeftPos(minPos);
            smv.slideMovableContainerToLeftPos();

            return (stc.movableContainerLeftPos === minPos);
        };

        p.scrollToActiveTab = function (options) {
            var smv = this,
                stc = smv.stc,
                offset = 0,
                $activeTab,
                activeTabWidth,
                activeTabLeftPos,
                activeTabRightPos,
                rightArrowLeftPos,
                leftArrowRightPos,
                visibleAreaLeftPos,
                visibleAreaRightPos,
                minPos;

            // if the active tab is not fully visible, scroll till it is
            if (!stc.scrollArrowsVisible) {
                return;
            }

            $activeTab = stc.$tabsUl.find('li.active');

            if (!$activeTab.length) {
                return;
            }

            activeTabLeftPos = $activeTab.offset().left;
            activeTabWidth = $activeTab.outerWidth();
            activeTabRightPos = activeTabLeftPos + activeTabWidth + parseInt(stc.scrollingTabsActiveOffset || 0, 10);

            rightArrowLeftPos = stc.$rightScrollArrow.offset().left;
            leftArrowRightPos = stc.$leftScrollArrow.outerWidth(); // its leftpos is 0
            visibleAreaLeftPos = leftArrowRightPos;
            visibleAreaRightPos = rightArrowLeftPos;

            if (activeTabLeftPos < visibleAreaLeftPos) {
                offset = activeTabLeftPos - visibleAreaLeftPos;
                stc.movableContainerLeftPos = stc.movableContainerLeftPos - offset;
            } else if (activeTabRightPos > visibleAreaRightPos) {
                offset = activeTabRightPos - visibleAreaRightPos;
                stc.movableContainerLeftPos = stc.movableContainerLeftPos - offset;
            }

            if (offset) {
                minPos = smv.getMinPos();

                if (stc.movableContainerLeftPos < minPos) {
                    stc.movableContainerLeftPos = minPos;
                } else if (stc.movableContainerLeftPos > 0) {
                    stc.movableContainerLeftPos = 0;
                }

                smv.slideMovableContainerToLeftPos();
            } else if (stc.scrollingTabsActiveOffset) {
                stc.handleArrowsClassNames('left');
            }
        };

        p.setMovableContainerLeftPosToTabEdge = function (scrollArrowClicked) {
            var smv = this,
                stc = smv.stc,
                offscreenWidth = -stc.movableContainerLeftPos,
                totalTabWidth = 0;

            // make sure LeftPos is set so that a tab edge will be against the
            // left scroll arrow so we won't have a partial, cut-off tab
            stc.$tabsLiCollection.each(function (index) {
                var tabWidth = $(this).width();

                totalTabWidth += tabWidth;

                if (totalTabWidth > offscreenWidth) {
                    stc.movableContainerLeftPos = (scrollArrowClicked === 'left') ? -(totalTabWidth - tabWidth) : -totalTabWidth;
                    return false; // exit .each() loop
                }

            });
        };

        p.slideMovableContainerToLeftPos = function () {
            var smv = this,
                stc = smv.stc,
                leftVal;

            stc.movableContainerLeftPos = stc.movableContainerLeftPos / 1;
            leftVal = smv.getMovableContainerCssLeftVal();

            stc.$movableContainer.stop().animate({ left: leftVal }, 'slow', function () {
                var newMinPos = smv.getMinPos();

                // if we slid past the min pos--which can happen if you resize the window
                // quickly--move back into position
                if (stc.movableContainerLeftPos < newMinPos) {
                    smv.decrementMovableContainerLeftPos(newMinPos);
                    stc.$movableContainer.stop().animate({ left: smv.getMovableContainerCssLeftVal() }, 'fast');
                }

                if (stc.scrollingTabsActiveOffset) {
                    var edge;
                    // taking 2px offset error
                    if (stc.movableContainerLeftPos <= 0 && stc.movableContainerLeftPos >= -2) {
                        // left edge
                        edge = 'left';
                    } else if ((stc.movableContainerLeftPos - newMinPos) >= 0 &&
                               (stc.movableContainerLeftPos - newMinPos) <= 2) {
                        edge = 'right';
                    }

                    stc.handleArrowsClassNames(edge);
                }
            });
        };

        p.startScrollLeft = function () {
            var smv = this,
                stc = smv.stc;

            stc.$leftScrollArrow.data(CONSTANTS.DATA_KEY_IS_MOUSEDOWN, true);
            smv.continueScrollLeft();
        };

        p.startScrollRight = function () {
            var smv = this,
                stc = smv.stc;

            stc.$rightScrollArrow.data(CONSTANTS.DATA_KEY_IS_MOUSEDOWN, true);
            smv.continueScrollRight(smv.getMinPos());
        };

        p.stopScrollLeft = function () {
            var smv = this,
                stc = smv.stc;

            stc.$leftScrollArrow.data(CONSTANTS.DATA_KEY_IS_MOUSEDOWN, false);
        };

        p.stopScrollRight = function () {
            var smv = this,
                stc = smv.stc;

            stc.$rightScrollArrow.data(CONSTANTS.DATA_KEY_IS_MOUSEDOWN, false);
        };

    }(ScrollMovement.prototype));

    /* **********************************************************************
     * ScrollingTabsControl - Class that each directive will instantiate
     * **********************************************************************/
    function ScrollingTabsControl($tabsContainer, $timeout, options) {
        var stc = this;

        options = options || {};

        stc.$tabsContainer = $tabsContainer;
        stc.$timeout = $timeout;

        stc.movableContainerLeftPos = 0;
        stc.scrollArrowsVisible = false;
        stc.scrollToTabEdge = false;

        stc.scrollMovement = new ScrollMovement(stc);
        stc.eventHandlers = new EventHandlers(stc);
        stc.elementsHandler = new ElementsHandler(stc);

        stc.scrollingTabsActiveOffset = options.scrollingTabsActiveOffset || 0;
    }

    // prototype methods
    (function (p) {
        p.handleTriggeredRefresh = function () {
            var stc = this,
                scrollMovement = stc.scrollMovement,
                actionsTaken = stc.elementsHandler.refreshAllElementSizes(true);

            if (!actionsTaken.didScrollToActiveTab) {
                stc.$timeout(function () {
                    scrollMovement.scrollToActiveTab({
                        isOnTabsRefresh: true
                    });
                }, stc.scrollingTabsActiveOffset ? 200 : 100);
            }
        };

        p.initTabs = function (options) {
            var stc = this,
                elementsHandler = stc.elementsHandler,
                scrollMovement = stc.scrollMovement;

            if (options.scrollToTabEdge) {
                stc.scrollToTabEdge = true;
            }

            stc.$timeout(function __initTabsAfterTimeout() {
                var actionsTaken;

                elementsHandler.initElements(options);
                actionsTaken = elementsHandler.refreshAllElementSizes();

                if (!actionsTaken.didScrollToActiveTab) {
                    scrollMovement.scrollToActiveTab({
                        isOnTabsRefresh: options.isWatchingTabs
                    });
                }
            }, 100);
        };

        /**
         * Handles control arrows classnames
         *
         * @param {string} edge ('left'|'right')
         * @return {undefined}
         */
        p.handleArrowsClassNames = function (edge) {
            var stc = this;
            var edgeClassName = 'scrtabs-tab-scroll-arrow--is-on-edge';
            var arrows = {
                left: stc.$leftScrollArrow,
                right: stc.$rightScrollArrow,
            };

            if (edge) {
                arrows[edge].addClass(edgeClassName);
                arrows[edge == 'left' ? 'right' : 'left'].removeClass(edgeClassName);
            } else {
                arrows.left.removeClass(edgeClassName);
                arrows.right.removeClass(edgeClassName);
            }
        };

    }(ScrollingTabsControl.prototype));

    scrollingTabsModule.directive('scrollingTabs', scrollingTabsDirective);

    scrollingTabsDirective.$inject = ['$timeout', '$sce'];
    function scrollingTabsDirective($timeout, $sce) {

        function sanitize(html) {
            return $sce.trustAsHtml(html);
        }


        // ------------ Directive Object ---------------------------
        return {
            restrict: 'E',
            template: scrollingTabsTemplate,
            transclude: false,
            replace: true,
            scope: {
                tabs: '@',
                watchTabs: '=',
                propPaneId: '@',
                propTitle: '@',
                propActive: '@',
                propDisabled: '@',
                localTabClick: '&tabClick',
                refreshOn: '='
            },
            link: function (scope, element, attrs) {
                var scrollingTabsControl = new ScrollingTabsControl(element, $timeout),
                    scrollToTabEdge = attrs.scrollToTabEdge && attrs.scrollToTabEdge.toLowerCase() === 'true';

                scope.tabsArr = scope.$eval(scope.tabs);
                scope.propPaneId = scope.propPaneId || 'paneId';
                scope.propTitle = scope.propTitle || 'title';
                scope.propActive = scope.propActive || 'active';
                scope.propDisabled = scope.propDisabled || 'disabled';
                scope.sanitize = sanitize;


                element.on('click.scrollingTabs', '.nav-tabs > li', function __handleClickOnTab(e) {
                    var clickedTabElData = $(this).data();

                    scope.localTabClick({
                        $event: e,
                        $index: clickedTabElData.index,
                        tab: clickedTabElData.tab
                    });

                });

                if (attrs.refreshOn) {
                    scope.$watch('refreshOn', function (newVal, oldVal) {
                        if (newVal && newVal !== oldVal) {
                            scrollingTabsControl.handleTriggeredRefresh();
                        }
                    });
                }

                if (!attrs.watchTabs) {

                    // we're not watching the tabs array for changes so just init
                    // the tabs without adding a watch
                    scrollingTabsControl.initTabs({
                        isWrapperDirective: false,
                        scrollToTabEdge: scrollToTabEdge,
                        scrollingTabsActiveOffset: attrs.scrollingTabsActiveOffset
                    });

                    return;
                }

                // we're watching the tabs array for changes...
                scope.$watch('watchTabs', function (latestTabsArray, prevTabsArray) {
                    var $activeTabLi,
                        activeIndex;

                    scope.tabsArr = scope.$eval(scope.tabs);

                    if (latestTabsArray && latestTabsArray.length && latestTabsArray[latestTabsArray.length - 1].active) { // new tab should be active

                        // the tab we just added should be active, so, after giving the
                        // elements time to render (thus the $timeout), force a click on it so
                        // bootstrap's built-in tab/pane activation can do its thing, otherwise
                        // the tab will show as active but its content pane won't be
                        $timeout(function () {

                            element.find('ul.nav-tabs > li:last').removeClass('active').find('a[role="tab"]').click();

                        }, 0);

                    } else { // --------- preserve the currently active tab

                        // we've replaced the nav-tabs so, to get the currently active tab
                        // we need to get it from the DOM because clicking a tab doesn't update
                        // the tabs array (Bootstrap's js just makes the clicked tab and its
                        // corresponding tab-content pane active); then we need to update
                        // the tabs array so it reflects the currently active tab before we
                        // call initTabs() because initTabs() generates the tab elements based
                        // on the array data.

                        // get the index of the currently active tab
                        $activeTabLi = element.find('.nav-tabs > li.active');

                        if ($activeTabLi.length) {

                            activeIndex = $activeTabLi.data('index');

                            scope.tabsArr.some(function __forEachTabsArrItem(t) {
                                if (t[scope.propActive]) {
                                    t[scope.propActive] = false;
                                    return true; // exit loop
                                }
                            });

                            scope.tabsArr[activeIndex][scope.propActive] = true;
                        }
                    }

                    scrollingTabsControl.initTabs({
                        isWrapperDirective: false,
                        isWatchingTabs: true,
                        scrollToTabEdge: scrollToTabEdge
                    });

                }, true);

            }

        };
    }

    scrollingTabsModule.directive('scrollingTabsWrapper', scrollingTabsWrapperDirective);

    scrollingTabsWrapperDirective.$inject = ['$timeout'];
    function scrollingTabsWrapperDirective($timeout) {
        // ------------ Directive Object ---------------------------
        return {
            restrict: 'A',
            template: scrollingTabsWrapperTemplate,
            transclude: true,
            replace: true,
            link: function (scope, element, attrs) {
                var scrollingTabsControl = new ScrollingTabsControl(element, $timeout, { scrollingTabsActiveOffset: attrs.scrollingTabsActiveOffset }),
                    isWrappingAngularUIBTabset = element.find('uib-tabset').length > 0,
                    isWrappingAngularUITabset = isWrappingAngularUIBTabset || element.find('tabset, .scrtabs-tabs-movable-container div > ul.nav').length > 0,
                    scrollToTabEdge = attrs.scrollToTabEdge && attrs.scrollToTabEdge.toLowerCase() === 'true',
                    scrtc = {
                        hasTabContentOutsideMovableContainer: true
                    };

                angular.extend(scope, { scrtc: scrtc });

                if (attrs.refreshOn) {
                    scope.$watch(attrs.refreshOn, function (newVal, oldVal) {
                        if (newVal && newVal !== oldVal) {
                            scrollingTabsControl.handleTriggeredRefresh();
                        }
                    });
                }

                if (!isWrappingAngularUITabset) {
                    scrtc.hasTabContentOutsideMovableContainer = false;
                }

                if (!isWrappingAngularUIBTabset && !attrs.watchTabs) {
                    // we don't need to watch the tabs for changes, so just
                    // init the tabs control and return
                    scrollingTabsControl.initTabs({
                        isWrapperDirective: true,
                        isWrappingAngularUITabset: isWrappingAngularUITabset,
                        scrollToTabEdge: scrollToTabEdge
                    });

                    return;
                }


                // ----- watch the tabs DOM for changes --------------
                // if we're watching angular uib-tabset after version 1.2.0, we
                // need to explicitly watch the tabs for DOM changes because
                // from 1.2.0, they added controllerAs and bindToController,
                // which messed up the direct connection between the tabs
                // model data and the transcluded DOM that allowed the tab-content
                // outside the movable container to update itself when the
                // active tab inside the movable container changed.
                // So if we're watching uib-tabset AND there is not a watch-tabs
                // attribute pointing to the tabs array, we set up this watch,
                // just watching for the active tab to change.
                // We also set up this watch if there's a watch-tabs="true"
                // attribute.
                if (isWrappingAngularUIBTabset ||
                    (attrs.watchTabs && attrs.watchTabs.toLowerCase() === 'true')) {

                    if (isWrappingAngularUITabset) {
                        scrtc.hasTabContentOutsideMovableContainer = false;
                    }

                    // we're watching the tabs html (rather than array) for changes,
                    // so init them then set up a watch that watches for changes
                    // to the number of tabs or to the active tab
                    initTabsAsWrapperWatchingTabs();

                    // give the DOM changes time to process, then set up our watch
                    $timeout(watchForTabDomChanges, 10);

                    // we can return out of here UNLESS we're wrapping uib-tabset AND
                    // also watching the tabs array for changes, in which case we need
                    // to continue on and set up the watch on the tabs array.
                    if (!isWrappingAngularUIBTabset || !attrs.watchTabs || attrs.watchTabs.toLowerCase() === 'true') {
                        return;
                    }
                }


                // ----- watch the tabs array for changes --------------
                // watch the tabs array for changes and refresh the tabs
                // control any time it changes (whether the change is a
                // new tab or just a change in which tab is selected)
                scope.$watch(attrs.watchTabs, function (latestTabsArray, prevTabsArray) {

                    if (!isWrappingAngularUITabset) { // wrapping regular bootstrap nav-tabs
                        // if we're wrapping regular bootstrap nav-tabs, we need to
                        // manually track the active tab because, if a tab is clicked,
                        // the tabs array doesn't update to reflect the new active tab;
                        // so if we make each dynamically added tab the new active tab,
                        // we need to deactivate whatever the currently active tab is,
                        // and we have no way of knowing that from the state of the tabs
                        // array--we need to check the tab elements on the page
                        // listen for tab clicks and update our tabs array accordingly because
                        // bootstrap doesn't do that
                        if (latestTabsArray && latestTabsArray.length && latestTabsArray[latestTabsArray.length - 1].active) {

                            // the tab we just added should be active, so, after giving the
                            // elements time to render (thus the $timeout), force a click on it so
                            // bootstrap's built-in tab/pane activation can do its thing, otherwise
                            // the tab will show as active but its content pane won't be
                            $timeout(function () {

                                element.find('ul.nav-tabs > li:last').removeClass('active').find('a[role="tab"]').click();

                            }, 0);

                        }

                    } else if (isWrappingAngularUIBTabset) {

                        if (latestTabsArray.length && latestTabsArray[latestTabsArray.length - 1].active) {
                            $timeout(function () {
                                element.find('.scrtabs-tabs-movable-container ul.nav-tabs > li:last').find('a[role="tab"],a.nav-link').click();
                            }, 0);
                        }

                    }

                    initTabsAsWrapperWatchingTabs();

                }, true);


                function initTabsAsWrapperWatchingTabs(options) {
                    scrollingTabsControl.initTabs({
                        isWrapperDirective: true,
                        isWrappingAngularUITabset: isWrappingAngularUITabset,
                        isWatchingTabs: true,
                        scrollToTabEdge: scrollToTabEdge,
                        isWatchingDom: options && options.isWatchingDom
                    });
                }

                function watchForTabDomChanges() {
                    var $navTabs = element.find('ul.nav-tabs'),
                        currActiveTabIdx,
                        showingActiveTabIdx;

                    if (!$navTabs.length) {
                        return;
                    }

                    // ---- watch for tabs being added or removed ----
                    scope.$watch(function () {
                        return $navTabs[0].childNodes.length;
                    }, function (newVal, oldVal) {
                        if (newVal !== oldVal) {
                            initTabsAsWrapperWatchingTabs({
                                isWatchingDom: true
                            });
                        }
                    });

                    // ---- watch for a change in the active tab ----
                    // we can't just use the built-in watch functionality
                    // to check for a change in the active tab because the
                    // function we pass to $watch sometimes executes before the
                    // active class changes to the newly-clicked tab, so our watch
                    // doesn't detect any change; to detect the change, we need
                    // to perform the check after a timeout, so we just hook
                    // into the $watch because we need to perform the check
                    // when a digest occurs, but we don't use the $watch's
                    // callback to make any changes, we just do it in our
                    // timeout function.
                    scope.$watch(function () {
                        // pass false as 3rd arg so digest is not initiated,
                        // otherwise we end up in infinite loop
                        $timeout(checkForActiveTabChange, 0, false);
                        return $navTabs.find('li.active').index();
                    }, angular.noop);


                    function checkForActiveTabChange() {
                        currActiveTabIdx = $navTabs.find('li.active').index();

                        if (currActiveTabIdx !== showingActiveTabIdx) {
                            showingActiveTabIdx = currActiveTabIdx;
                            initTabsAsWrapperWatchingTabs({
                                isWatchingDom: true
                            });
                        }

                        return false;
                    }
                }

            }
        };

    }


}(jQuery, window));

//DEADCODE
(function () {
  'use strict';
  angular
    .module("storeLocator")
    .filter('urldash', urldash);

  function urldash() {
    return function (input,reverse,lowercase) {
      if (input) {
         if(reverse) {
           var out = input.split('+_').join('/');
           out = out.split('*').join(',');
           out = out.split('_').join('.');
           out =  out.split('+~').join('&');
           out = out.split('-').join(' ');
           out = out.split('~').join('-');
           if (lowercase) {
              return out.toLowerCase();
           }
           return out;
         } else {
           if (lowercase) {
             return input.replace(/\s+/g, '-').toLowerCase();
           }
           return input.replace(/\s+/g, '-');
         }
      }
    }
  }
})();


(function() {
  'use strict';

  angular
    .module('storeLocator')
    .filter('urlCleaner', urlCleaner);

  /** @ngInject */
  function urlCleaner() {

    return function (value) {
      return (!value) ? '' : value.replace(/:/g, '%3A').replace(/\//g, '%2F').replace(/\?/g, '%3F').replace(/=/g, '%3D');
    };

  }
})();

(function() {
  'use strict';

  angular
    .module('storeLocator')
    .filter('telephone', telephone);

  /** @ngInject */
  function telephone() {
      return function (tel) {
        if (!tel) { return ''; }
        var value;
        if (tel.includes('+')) {
          value = tel.split(' ');
          if (value.length === 2) {
            value = value[1].replace(/\D/g,'');
          } else if (value.length > 2) {
            value = value.slice(value[1], value.length -1).join('');
          }
          if(value.length === 1 && tel.includes('+1')){
            value = value[0].replace(/\D/g,'');
            value = value.substr(1,value.length-1);
          }
          if(value.length === 1 && !tel.includes('+1')){
            value = value[0].replace(/\D/g,'');
          }
        } else {
          value = tel.toString().trim().replace(/\D/g,'');
        }
        if (value.match(/[^0-9]/)) {
          return tel;
        }
        var country, city, number;
        switch (value.length) {
          case 10: // +1PPP####### -> C (PPP) ###-####
            country = 1;
            city = value.slice(0, 3);
            number = value.slice(3);
            break;
          case 11: // +CCPP####### -> CC (PP) ###-####
            country = value.slice(0, 2);
            city = value.slice(2, 4);
            number = value.slice(4);
            break;
          // case 12: // +CCCPP####### -> CCC (PP) ###-####
          //   country = value.slice(0, 3);
          //   city = value.slice(3, 5);
          //   number = value.slice(5);
          //   break;
          default:
            return tel;
        }
        if (country == 1) {
          country = '';
        }
        number = number.slice(0, 3) + '-' + number.slice(3);
        return (country + ' (' + city + ') ' + number).trim();
      };
  }
})();

(function () {
    'use strict';

    angular
        .module('storeLocator')
        .filter('splitToTwoLines', splitToTwoLines);

    function splitToTwoLines($sce) {
        return function (input, char) {
            if (!input || !char) {
                return input;
            }
            var separatedText = input.split(char).join('<br>');
            return $sce.trustAsHtml(separatedText);
        };
    }
})();

(function () {
  "use strict";

  angular.module("storeLocator").filter("removeNumberFromAddress", removeNumberFromAddress);

  /** @ngInject */
  function removeNumberFromAddress() {
    return function (address) {
      var addressArray = address.split(' ');
      var hasNumber = /\d/;
      if (hasNumber.test(addressArray[0])) {
        addressArray = addressArray.slice(1, addressArray.length);
      }
      return addressArray.join(' ')
    };
  }
})();

(function () {
  "use strict";

  angular.module("storeLocator").filter("removeNumberAndCardinalPoints", removeNumberAndCardinalPoints);

  /** @ngInject */
  function removeNumberAndCardinalPoints() {
    return function (address) {
      var cardinalPointsArray = [
        "n",
        "s",
        "e",
        "w",
        "n.",
        "s.",
        "e.",
        "w.",
        "nw",
        "ne",
        "sw",
        "se",
        "nw.",
        "ne.",
        "sw.",
        "se.",
      ];
      var addressArray = address.split(' ');
      var hasNumber = /\d/;
      if (hasNumber.test(addressArray[0])) {
        addressArray = addressArray.slice(1, addressArray.length);
        if (cardinalPointsArray.includes(addressArray[0].toLowerCase())) {
          addressArray = addressArray.slice(1, addressArray.length);
        }
      }
      return addressArray.join(' ')
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('storeLocator')
    .filter('removeHash', removeHash);

  /** @ngInject */
  function removeHash() {

    return function (value) {
      return (!value) ? '' : value.replace(/#/g, '');
    };

  }
})();

(function() {
  'use strict';

  angular
    .module('storeLocator')
    .filter('removeAmPm', removeAmPm);

  function removeAmPm(_) {
    return function(time) {
      var hours = time.split(' ')[0];
      return hours;
    };
  }
})();

(function () {
  'use strict';
  angular
    .module("storeLocator")
    .filter('moment', moment);

  function moment(moment) {
    return function (input, momentFn, format) {
      var args = Array.prototype.slice.call(arguments, 2),
        momentObj = moment(input, format);
      return momentObj[momentFn].apply(momentObj, args);
    };
  }
})();


(function () {
  'use strict';

  angular
    .module('storeLocator')
    .filter('miToKm', miToKm);

  function miToKm(_) {
    return function (distance) {
      if (!_.isUndefined(distance)) return (distance / 0.62137).toFixed(1);
    };

  }
})();

(function() {
  'use strict';

  angular
    .module('storeLocator')
    .filter('labelizeLocation', labelizeLocation);

  /** @ngInject */
  function labelizeLocation() {
    return function (location) {
      return '{"url": "'+location.llp_url +'", "location_id": "'+location.momentfeed_venue_id +'"}';
    };

  }
})();

(function() {
  'use strict';

  angular
    .module('storeLocator')
    .filter('hasHttp', hasHttp);

  /** @ngInject */
  function hasHttp() {

    return function (value) {
      if(value && !value.match(/^http([s]?):\/\/.*/)){
        return '//' + value
      } else {
        return value
      }
    };

  }
})();

(function() {
  'use strict';

  angular
    .module('storeLocator')
    .filter('formatHours', formatHours);

  /** @ngInject */
  function formatHours() {

    return function(input) {
      var parts = input.split(' ');

      var timeParts = parts[0].split(':');
      var hours = parseInt(timeParts[0]);
      var minutes = parseInt(timeParts[1]);

      var formattedHours = (hours === 0) ? '12' : (hours < 10 ? hours.toString().replace(/^0+/, '') : hours);

      var period = parts[1].toUpperCase();

      var formattedTime = formattedHours + (minutes === 0 ? '' : ':' + String(minutes).padStart(2, '0')) + ' ' + period;
      return formattedTime;
    };

  }
})();

(function () {
  'use strict';

  angular
    .module('storeLocator')
    .filter('flattenLocations', flattenLocations);

  function flattenLocations() {
    return function (locations) {
      var flattened = [];
      angular.forEach(locations, function (stores) {
        angular.forEach(stores, function (store) {
          flattened.push(store);
        });
      });
      return flattened;
    };
  }
})();

//DEADCODE
(function() {
  'use strict';

  angular
    .module('storeLocator')
    .filter('commaSpace', commaSpace);

  function commaSpace(_) {
    return function (list) {
      if (!_.isUndefined(list) && list.length) return list.replace(/,/g, ', ');
    };

  }
})();

(function() {
  'use strict';

  angular
    .module('storeLocator')
    .directive('windowResize', windowResize);

  function windowResize ($window, _, $rootScope) {
    return function (scope) {

      var w = angular.element($window);

      if(!$rootScope.isMobile.ios()) {
        scope.$watch(function () {
          return {
            'h': $window.innerHeight,
            'w': $window.innerWidth
          };
        }, function (newValue) {

          scope.windowHeight = newValue.h;
          scope.windowWidth = newValue.w;

          scope.getMaxHeightWithOffsets = function () {
            var offset_pixels = 0;
            _.each(arguments, function(id){
              var tmp_el = angular.element(angular.element('#' + id));
              offset_pixels = offset_pixels + parseInt(tmp_el.outerHeight());
            });
            return {
              'max-height': (newValue.h - offset_pixels) + 'px'
            };
          };

          scope.getHeightwithOffsets = function () {
            var offset_pixels = 0;
            _.each(arguments, function(id){
              var tmp_el = angular.element(angular.element(id));
              offset_pixels = offset_pixels + parseInt(tmp_el.outerHeight());
            });
            return {
              'height': (newValue.h - offset_pixels) + 'px'
            };
          };

          scope.fillScreen = function () {
            var offset_pixels = 0;
            _.each(arguments, function(id){
              var tmp_el = angular.element(angular.element('#' + id));
              offset_pixels = offset_pixels + parseInt(tmp_el.outerHeight());
            });
            return {
              'min-height': (newValue.h - offset_pixels) + 'px'
            };
          };

          scope.getColumnHeight = function (id) {
            var set_height = 0;
            var offset_height = 0;

            //get height of left column
            var tmp_el = angular.element(angular.element('#' + id));
            var column_height = parseInt(tmp_el.outerHeight());

            //get height window minus nav
            var get_nav_height = angular.element(angular.element('#js-mf-navbar'));
            var nav_height = parseInt(get_nav_height.outerHeight());
            offset_height = newValue.h - nav_height;

            //set height
            if (offset_height >= column_height) {
              set_height = offset_height;
            } else {
              set_height = column_height;
            }

            return {
              'min-height': set_height + 'px'
            };
          };

        }, true);

      }

      w.bind('resize', function () {
        scope.$apply();
      });
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('storeLocator')
    .directive('mapbox', mapbox);

  mapbox.$inject = ['MAPBOX_KEY', '$window', 'MFeedMap', 'MAPBOX_STYLE'];
  function mapbox(MAPBOX_KEY, $window, MFeedMap, MAPBOX_STYLE) {
    return {
      restrict: 'EA',
      replace: true,
      scope: {
        callback: "="
      },
      template: '<div class="mf-map"></div>',
      link: function (scope, element) {
        mapboxgl.accessToken = MAPBOX_KEY;
        var mapbox = new mapboxgl.Map({
          container: element[0],
          style: 'mapbox://styles/' + MAPBOX_STYLE + '?optimize=true',
          minZoom: 1
        });

        // buttons: zoom-in, zoom-out and 'reset bearing to north'
        mapbox.addControl(new mapboxgl.NavigationControl());

        var map = new MFeedMap.MapboxMap(mapbox);

        setTimeout(function() {
          var mapboxExternalLinks = mapbox._controlPositions['bottom-right'].children[0].children[0].children;
          for(var i = 0; i < mapboxExternalLinks.length; i++) {
            mapboxExternalLinks[i].setAttribute('rel', 'noopener')
          }
        },500)

        scope.callback(map);
      }
    };
  }
})();

(function () {
    'use strict';
  
    angular
      .module('storeLocator')
      .directive('layoutLocalLanding', layoutLocalLanding);
  
    function layoutLocalLanding(LAYOUT_LOCAL_LANDING_PATH) {
      return {
        template: '<div ng-include="localLandingContent"></div>',
        link: function(scope, element, attrs) {
          scope.localLandingContent = LAYOUT_LOCAL_LANDING_PATH + attrs.type + '.html';
          attrs.$observe("type",function(v){
            scope.localLandingContent = LAYOUT_LOCAL_LANDING_PATH + v + '.html';
          });
        }
      };
    }
  })();
(function () {
  'use strict';

  angular
    .module('storeLocator')
    .directive('layoutHeader', layoutHeader);
  
  function layoutHeader(LAYOUT_ASSETS_PATH) {
    return {
      template: '<div ng-include="headerContent"></div>',
      link: function(scope, element, attrs) {
        scope.headerContent = LAYOUT_ASSETS_PATH + 'header/' + attrs.language + '.html';
        attrs.$observe("language",function(v){
          scope.headerContent = LAYOUT_ASSETS_PATH + 'header/' + v + '.html';
        });
        }
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('storeLocator')
    .directive('layoutFooter', layoutFooter);

  function layoutFooter(LAYOUT_ASSETS_PATH) {
    return {
      template: '<div ng-include="footerContent"></div>',
      link: function(scope, element, attrs) {
        scope.footerContent = LAYOUT_ASSETS_PATH + 'footer/' + attrs.language + '.html';
        attrs.$observe("language",function(v){
          scope.footerContent = LAYOUT_ASSETS_PATH + 'footer/' + v + '.html';
        });
      }
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('storeLocator')
    .directive('imageFallback', imageFallback);

  // Code taken from:
  // https://stackoverflow.com/questions/27549134/angularjs-ng-src-condition-if-not-found-via-url
  function imageFallback() {
    return {
      link: function (scope, element, attrs) {
        element.bind('error', function () {
          if (attrs.src !== attrs.imageFallback) {
            attrs.$set('src', attrs.imageFallback);
          }
        });
      }
    }
  }
})();

//set a fallback_url if the trust_url links to a missing image, 404s

(function () {
  'use strict';

  angular
    .module('storeLocator')
    .directive('googleMap', GoogleMap);

  GoogleMap.$inject = ['MFeedMap'];
  function GoogleMap(MFeedMap) {
    return {
      restrict: 'EA',
      replace: true,
      scope: {
        callback: "="
      },
      template: '<div class="mf-map"></div>',
      link: function (scope, element) {

        var mapCenter;
        var gmap = new google.maps.Map(element[0],
          {
            mapTypeControlOptions: {
              position: google.maps.ControlPosition.BOTTOM_CENTER
            },
            zoomControlOptions: {
              position: google.maps.ControlPosition.LEFT_TOP
            },
            streetViewControlOptions: {
              position: google.maps.ControlPosition.LEFT_TOP
            },
            styles: [{
              featureType: 'poi.business',
              stylers: [{ visibility: 'off' }]
            }]
          });

        // update the center of the map when it becomes idle after panning or zooming.
        google.maps.event.addListener(gmap, 'idle', function () {
          mapCenter = gmap.getCenter();
        });

        // re-center the map after the window has been resized.
        google.maps.event.addDomListener(window, 'resize', function () {
          gmap.setCenter(mapCenter);
        });

        var mapObj = new MFeedMap.GoogleMap(gmap);
        scope.callback(mapObj);
      }
    };
  }
})();

//I think this may be broken... 💀
(function () {
  'use strict';

  angular
    .module('storeLocator')
    .directive('googleAutocomplete', GoogleAutocomplete);

  GoogleAutocomplete.$inject = [
    'STORE_LOCATOR_SEARCH_COUNTRY',
    'STORE_LOCATOR_GOOGLE_SEARCH_TYPE',
    'CUSTOM_DICTIONARY'
  ];
  function GoogleAutocomplete(STORE_LOCATOR_SEARCH_COUNTRY,
    STORE_LOCATOR_GOOGLE_SEARCH_TYPE, CUSTOM_DICTIONARY) {
    return {
      restrict: 'EA',
      replace: true,
      scope: {
        placeChangedCallback: "=",
        messages: '='
      },
      template: '<input id="searchField" type="text" aria-label="{{label}}" placeholder={{placeholder}} ></div>',
      link: function (scope, element) {

        // Note: For more than 1 country, Google requires country codes as an array of ISO 3166-1 Alpha-2 country
        //       codes (case insensitive e.g. us, ca, br, au). It will restrict results to up to 5 country codes.
        var countries = STORE_LOCATOR_SEARCH_COUNTRY.split(',');
        var options = {
          types: [STORE_LOCATOR_GOOGLE_SEARCH_TYPE],
          componentRestrictions: { "country": countries }
        };
        
        scope.placeholder = scope.messages && scope.messages['mf.storeLocator.searchInput.placeholder'] || CUSTOM_DICTIONARY && CUSTOM_DICTIONARY.placeholder;
        scope.label = scope.messages && scope.messages['mf.storeLocator.searchInput.label'] || 'Search Location';
        
        var autocomplete = new google.maps.places.Autocomplete(element[0], options);

        google.maps.event.addListener(autocomplete, 'place_changed', function () {
          var place = autocomplete.getPlace();
          scope.$apply(function () {
            scope.placeChangedCallback(place);
          });
        });

      }
    };
  }
})();

angular.module('storeLocator').factory('focus', function($timeout, $window) {
    return function(id) {
        // timeout makes sure that it is invoked after any other event has been triggered.
        // e.g. click events that need to run before the focus or
        // inputs elements that are in a disabled state but are enabled when those events
        // are triggered.
        $timeout(function() {
            var element = $window.document.getElementById(id);
            if(element)
                element.focus();
        });
    };
});
angular.module('storeLocator').directive('eventFocus', function(focus) {
        return function(scope, elem, attr) {
            elem.on(attr.eventFocus, function() {
                focus(attr.eventFocusId);
            });

            // Removes bound events in the element itself
            // when the scope is destroyed
            scope.$on('$destroy', function() {
                elem.off(attr.eventFocus);
            });
        };
    });

(function () {
    'use strict';

    angular
        .module('storeLocator')
        .directive('deferRendering', deferRendering);

    function deferRendering($timeout, $rootScope) {
        return {
            restrict: 'A',
            scope: {
                delay: '@deferRendering'
            },
            link: function (scope, element) {
                function applyDeferRendering() {
                    element.css('display', 'none');
                    $timeout(function () {
                        element.css('display', 'block');
                    }, parseInt(scope.delay, 10) || 2000);
                }

                applyDeferRendering();

                var routeChangeListener = $rootScope.$on('$locationChangeSuccess', function () {
                    applyDeferRendering();
                });

                scope.$on('$destroy', function () {
                    routeChangeListener();
                });
            }
        };
    }
})();

(function () {
  'use strict';

  angular
    .module('storeLocator')
    .factory('storeLocatorDictionary', storeLocatorDictionary);

  function storeLocatorDictionary(STORE_LOCATOR_ZOOM_LEVELS, STORE_LOCATOR_MESSAGES, STORE_LOCATOR_MAP_CONFIGS, STORE_LOCATOR_PIN, SHOW_ICONS) {

      var d = {};
      var defaultValues = {
          zoomLevels: {
              initial: 3,
              initialMobile: 3,
              region: 5,
              district: 5,
              administrative_area_level_1: 5,
              locality: 9,
              place: 10,
              address: 7,
              postcode: 7,
              poi: 12,
              nearMe: 10,
              nearMeMobile: 9,
              neighborhood: 10,
              store: 7,
              fallback: 7,
              country: 3,
              autoMaxZoom: 7
          },
          messages: {
              loading: 'Gathering locations...',
              noResultsWithFilters: 'No {filters} in {location}',
              noResults: 'No Results for {location}',
              noResultsDidYouMean: 'No Results for {locationWanted}. Did you mean {locationResult}?',
              resultsWithFilters: '{filters} in {location}',
              results: 'Results for {location}',
              listView: 'LIST',
              mapView: 'MAP',
              storeLocatorTitle: 'Store Locator',
              storeLocatorDescription: null,
              customSearchTitle: null,
              siteMapLink: 'root.siteMap',
              siteMapLinkText: 'Locations'
          },
          mapConfigs: {
            showSearchButtonOnZoomChange: false,
            centerPointOnTheRight: false,
            pinUseLetters: false,
            pinShowText: true,
            pinColor: STORE_LOCATOR_PIN || 'black',
            pinBorderColor: '#ffffff1c',
            pinBorderWidth: 3,
            pinFontFamily: 'inherit',
            pinFontSize: 22,
            pinFontColor: 'white',
            pinFontWeight: '700',
            clusterRadius: 50,
            clusterColors: STORE_LOCATOR_PIN || 'black',
            clusterSizes: [20, 100, 30],
            clusterTextFont: 'Arial Unicode MS Bold',
            clusterTextSize: 12,
            clusterTextColor: "#000000",
            clusterBorderWidth: 1,
            pinImageSrc: './assets/images/default-pin-icon.png',
            pinImageHoverSrc: './assets/images/default-pin-icon.png',
            pinImageSize: 1,
            pinImageColor: STORE_LOCATOR_PIN || 'black',
            pinSelectedColor: '#000000',
            pinSelectedFontColor: '#ffffff',
            pinSelectedBorderColor: '#ffffff',
            pinSvgWidth: '40',
            pinSvgHeight: '45',
            pinSvgViewBox: '0 0 53 65',
            pinSvgPath: 'm46.16229,22.724c0,2.71981 -1.23537,6.16637 -3.08318,9.79967c-2.00316,3.79336 -4.26834,7.44242 -6.77882,10.92085c-2.47073,3.47761 -4.931,6.61277 -6.77882,8.87582c-0.56059,0.69547 -1.0692,1.29758 -1.49491,1.81665c-0.39454,0.46863 -0.97583,0.7391 -1.58828,0.7391c-0.61257,0 -1.19385,-0.27048 -1.58828,-0.7391c-0.42559,-0.51908 -0.93432,-1.12118 -1.49491,-1.81665c-1.84782,-2.26305 -4.31855,-5.3981 -6.77882,-8.87582c-2.51424,-3.47596 -4.77942,-7.12538 -6.77882,-10.92085c-1.84782,-3.63342 -3.08318,-7.07987 -3.08318,-9.79967c0,-10.89322 8.83078,-19.724 19.724,-19.724c10.89322,0 19.724,8.83078 19.724,19.724l0.00002,0z',
            noMapPopUpOnMobile: false,
            mapPopUpDesktopOffset: [0, 0],
            mapPopUpMobileOffset: [0, 150],
            disableMapInteractionOnPopupOpen: false,
            autoSearchOnDragAndZoom: false,
            pinStaticMapImageSrc: null,
            offsetStaticMapImageDesktop: 0, // if we want to move the whole map to the right a litle bit, 0.005 is a good offset (to set in index.constants)
            useStaticMapFullWidth: false,
          },
          showIcons: false
      };

      function init() {
          initZoomLevels();
          initMessages();
          initMapConfigs();
          d.showIcons = SHOW_ICONS ? SHOW_ICONS : defaultValues.showIcons;
      }

      function initZoomLevels()
      {
          var clientZoomLevels;
          if (STORE_LOCATOR_ZOOM_LEVELS && STORE_LOCATOR_ZOOM_LEVELS !== '') {
              clientZoomLevels = JSON.parse(STORE_LOCATOR_ZOOM_LEVELS);
          }

          if (clientZoomLevels) {
              d.zoomLevels = {
                  initial: clientZoomLevels.initial
                      ? clientZoomLevels.initial
                      : defaultValues.zoomLevels.initial,
                  initialMobile: clientZoomLevels.initialMobile
                      ? clientZoomLevels.initialMobile
                      : defaultValues.zoomLevels.initialMobile,    
                  region: clientZoomLevels.region ? clientZoomLevels.region : defaultValues.zoomLevels.region,
                  district: clientZoomLevels.district ? clientZoomLevels.district : defaultValues.zoomLevels.district,
                  administrative_area_level_1: clientZoomLevels.administrative_area_level_1 ? clientZoomLevels.administrative_area_level_1 : defaultValues.zoomLevels.administrative_area_level_1,
                  locality: clientZoomLevels.locality ? clientZoomLevels.locality : defaultValues.zoomLevels.locality,
                  place: clientZoomLevels.place ? clientZoomLevels.place : defaultValues.zoomLevels.place,
                  address: clientZoomLevels.address ? clientZoomLevels.address : defaultValues.zoomLevels.address,
                  postcode: clientZoomLevels.postcode
                      ? clientZoomLevels.postcode
                      : defaultValues.zoomLevels.postcode,
                  poi: clientZoomLevels.poi ? clientZoomLevels.poi : defaultValues.zoomLevels.poi,
                  nearMe: clientZoomLevels.nearMe ? clientZoomLevels.nearMe : defaultValues.zoomLevels.nearMe,
                  nearMeMobile: clientZoomLevels.nearMeMobile ? clientZoomLevels.nearMeMobile : defaultValues.zoomLevels.nearMeMobile,
                  neighborhood: clientZoomLevels.neighborhood ? clientZoomLevels.neighborhood : defaultValues.zoomLevels.neighborhood,
                  store: clientZoomLevels.store ? clientZoomLevels.store : defaultValues.zoomLevels.store,
                  fallback: clientZoomLevels.fallback
                      ? clientZoomLevels.fallback
                      : defaultValues.zoomLevels.fallback,
                  country: clientZoomLevels.country ? clientZoomLevels.country : defaultValues.zoomLevels.country,
                  autoMaxZoom: clientZoomLevels.autoMaxZoom ? clientZoomLevels.autoMaxZoom : defaultValues.zoomLevels.autoMaxZoom
              };
          } else {
              d.zoomLevels = defaultValues.zoomLevels;
          }
      }

      function initMessages() {
          var clientMessages;
          if (angular.isString(STORE_LOCATOR_MESSAGES)) {
              clientMessages = JSON.parse(STORE_LOCATOR_MESSAGES);
          }
          if (angular.isObject(STORE_LOCATOR_MESSAGES)) {
              clientMessages = STORE_LOCATOR_MESSAGES;
          }

          if (clientMessages) {
              d.messages = {
                  loading: angular.isDefined(clientMessages.loading)
                      ? clientMessages.loading
                      : defaultValues.messages.loading,
                  noResults: angular.isDefined(clientMessages.noResults)
                      ? clientMessages.noResults
                      : defaultValues.messages.noResults,
                  results: angular.isDefined(clientMessages.results)
                      ? clientMessages.results
                      : defaultValues.messages.results,
                  noResultsWithFilters: angular.isDefined(clientMessages.noResultsWithFilters)
                     ? clientMessages.noResultsWithFilters
                     : defaultValues.messages.noResultsWithFilters,
                  resultsWithFilters: angular.isDefined(clientMessages.resultsWithFilters)
                      ? clientMessages.resultsWithFilters
                      : defaultValues.messages.resultsWithFilters,
                  listView: angular.isDefined(clientMessages.listView)
                     ? clientMessages.listView
                     : defaultValues.messages.listView,
                  mapView: angular.isDefined(clientMessages.mapView)
                      ? clientMessages.mapView
                      : defaultValues.messages.mapView,
                  storeLocatorTitle: angular.isDefined(clientMessages.storeLocatorTitle)
                      ? clientMessages.storeLocatorTitle
                      : defaultValues.messages.storeLocatorTitle,
                  storeLocatorDescription: angular.isDefined(clientMessages.storeLocatorDescription)
                      ? clientMessages.storeLocatorDescription
                      : defaultValues.messages.storeLocatorDescription,
                  customSearchTitle: angular.isDefined(clientMessages.customSearchTitle)
                    ? clientMessages.customSearchTitle
                    : defaultValues.messages.customSearchTitle,
                  siteMapLink: angular.isDefined(clientMessages.siteMapLink)
                    ? clientMessages.siteMapLink
                    : defaultValues.messages.siteMapLink,
                  siteMapLinkText: angular.isDefined(clientMessages.siteMapLinkText)
                      ? clientMessages.siteMapLinkText
                      : defaultValues.messages.siteMapLinkText
              };
          } else {
              d.messages = defaultValues.messages;
          }
      }

      function initMapConfigs() {
        var mapConfigs;

        if (STORE_LOCATOR_MAP_CONFIGS && STORE_LOCATOR_MAP_CONFIGS !== '') {
            mapConfigs = JSON.parse(STORE_LOCATOR_MAP_CONFIGS);
        }

        if (mapConfigs) {
            d.mapConfigs = {
                showSearchButtonOnZoomChange: angular.isDefined(mapConfigs.showSearchButtonOnZoomChange)
                    ? mapConfigs.showSearchButtonOnZoomChange
                    : defaultValues.mapConfigs.showSearchButtonOnZoomChange,
                centerPointOnTheRight: angular.isDefined(mapConfigs.centerPointOnTheRight)
                    ? mapConfigs.centerPointOnTheRight
                    : defaultValues.mapConfigs.centerPointOnTheRight,
                pinUseLetters: angular.isDefined(mapConfigs.pinUseLetters)
                    ? mapConfigs.pinUseLetters
                    : defaultValues.mapConfigs.pinUseLetters,
                pinShowText: angular.isDefined(mapConfigs.pinShowText)
                    ? mapConfigs.pinShowText
                    : defaultValues.mapConfigs.pinShowText,
                pinColor: angular.isDefined(mapConfigs.pinColor)
                   ? mapConfigs.pinColor
                   : defaultValues.mapConfigs.pinColor,
                pinSelectedColor: angular.isDefined(mapConfigs.pinSelectedColor)
                    ? mapConfigs.pinSelectedColor
                    : defaultValues.mapConfigs.pinSelectedColor,
                pinBorderColor: angular.isDefined(mapConfigs.pinBorderColor)
                    ? mapConfigs.pinBorderColor
                    : defaultValues.mapConfigs.pinBorderColor,
                pinSelectedBorderColor: angular.isDefined(mapConfigs.pinSelectedBorderColor)
                    ? mapConfigs.pinSelectedBorderColor
                    : defaultValues.mapConfigs.pinSelectedBorderColor,
                pinBorderWidth: angular.isDefined(mapConfigs.pinBorderWidth)
                   ? mapConfigs.pinBorderWidth
                   : defaultValues.mapConfigs.pinBorderWidth,
                pinFontFamily: angular.isDefined(mapConfigs.pinFontFamily)
                    ? mapConfigs.pinFontFamily
                    : defaultValues.mapConfigs.pinFontFamily,
                pinFontSize: angular.isDefined(mapConfigs.pinFontSize)
                    ? mapConfigs.pinFontSize
                    : defaultValues.mapConfigs.pinFontSize,
                pinScaledSize: angular.isDefined(mapConfigs.pinScaledSize)
                    ? mapConfigs.pinScaledSize
                    : null,
                pinFontColor: angular.isDefined(mapConfigs.pinFontColor)
                    ? mapConfigs.pinFontColor
                    : defaultValues.mapConfigs.pinFontColor,
                pinSelectedFontColor: angular.isDefined(mapConfigs.pinSelectedFontColor)
                    ? mapConfigs.pinSelectedFontColor
                    : defaultValues.mapConfigs.pinSelectedFontColor,
                pinFontWeight: angular.isDefined(mapConfigs.pinFontWeight)
                    ? mapConfigs.pinFontWeight
                    : defaultValues.mapConfigs.pinFontWeight,
                clusterRadius: angular.isDefined(mapConfigs.clusterRadius)
                    ? mapConfigs.clusterRadius
                    : defaultValues.mapConfigs.clusterRadius,
                clusterColors: angular.isDefined(mapConfigs.clusterColors)
                    ? mapConfigs.clusterColors
                    : defaultValues.mapConfigs.clusterColors,
                clusterSizes: angular.isDefined(mapConfigs.clusterSizes)
                    ? mapConfigs.clusterSizes
                    : defaultValues.mapConfigs.clusterSizes,
                clusterTextFont: angular.isDefined(mapConfigs.clusterTextFont)
                    ? [ mapConfigs.clusterTextFont, defaultValues.mapConfigs.clusterTextFont ]
                    : [ defaultValues.mapConfigs.clusterTextFont ],
                clusterTextSize: angular.isDefined(mapConfigs.clusterTextSize)
                    ? mapConfigs.clusterTextSize
                    : defaultValues.mapConfigs.clusterTextSize,
                clusterTextColor: angular.isDefined(mapConfigs.clusterTextColor)
                  ? mapConfigs.clusterTextColor
                  : defaultValues.mapConfigs.clusterTextColor,
                clusterBorderColor: angular.isDefined(mapConfigs.clusterBorderColor)
                  ? mapConfigs.clusterBorderColor : angular.isDefined(mapConfigs.clusterColors) 
                  ? mapConfigs.clusterColors : defaultValues.mapConfigs.clusterColors, // if we don't have clusterBorderColor defined, we use clusterColor 
                clusterBorderWidth: angular.isDefined(mapConfigs.clusterBorderWidth)
                  ? mapConfigs.clusterBorderWidth
                  : defaultValues.mapConfigs.clusterBorderWidth,
                clusterHoverColor: angular.isDefined(mapConfigs.clusterHoverColor)
                  ? mapConfigs.clusterHoverColor : angular.isDefined(mapConfigs.clusterColors) 
                  ? mapConfigs.clusterColors : defaultValues.mapConfigs.clusterColors, // if we don't have clusterHoverColor defined, we use clusterColor
                clusterHoverTextColor: angular.isDefined(mapConfigs.clusterHoverTextColor)
                  ? mapConfigs.clusterHoverTextColor : angular.isDefined(mapConfigs.clusterTextColor) 
                  ? mapConfigs.clusterTextColor : defaultValues.mapConfigs.clusterTextColor, // if we don't have clusterHoverTextColor defined, we use clusterTextColor
                pinImageSrc: angular.isDefined(mapConfigs.pinImageSrc)
                    ? mapConfigs.pinImageSrc
                    : defaultValues.mapConfigs.pinImageSrc,
                pinImageHoverSrc: angular.isDefined(mapConfigs.pinImageHoverSrc)
                    ? mapConfigs.pinImageHoverSrc
                    : defaultValues.mapConfigs.pinImageHoverSrc,
                pinImageSize: angular.isDefined(mapConfigs.pinImageSize)
                    ? mapConfigs.pinImageSize
                    : defaultValues.mapConfigs.pinImageSize,
                pinImageColor: angular.isDefined(mapConfigs.pinImageColor)
                    ? mapConfigs.pinImageColor
                    : defaultValues.mapConfigs.pinImageColor,
                pinSvgWidth: angular.isDefined(mapConfigs.pinSvgWidth)
                    ? mapConfigs.pinSvgWidth
                    : defaultValues.mapConfigs.pinSvgWidth,
                pinSvgHeight: angular.isDefined(mapConfigs.pinSvgHeight)
                    ? mapConfigs.pinSvgHeight
                    : defaultValues.mapConfigs.pinSvgHeight,
                pinSvgViewBox: angular.isDefined(mapConfigs.pinSvgViewBox)
                    ? mapConfigs.pinSvgViewBox
                    : defaultValues.mapConfigs.pinSvgViewBox,
                pinSvgPath: angular.isDefined(mapConfigs.pinSvgPath)
                    ? mapConfigs.pinSvgPath
                    : defaultValues.mapConfigs.pinSvgPath,
                noMapPopUpOnMobile: angular.isDefined(mapConfigs.noMapPopUpOnMobile)
                    ? mapConfigs.noMapPopUpOnMobile
                    : defaultValues.mapConfigs.noMapPopUpOnMobile,
                mapPopUpDesktopOffset: angular.isDefined(mapConfigs.mapPopUpDesktopOffset)
                    ? mapConfigs.mapPopUpDesktopOffset
                    : defaultValues.mapConfigs.mapPopUpDesktopOffset,
                mapPopUpMobileOffset: angular.isDefined(mapConfigs.mapPopUpMobileOffset)
                    ? mapConfigs.mapPopUpMobileOffset
                    : defaultValues.mapConfigs.mapPopUpMobileOffset,
                disableMapInteractionOnPopupOpen: angular.isDefined(mapConfigs.disableMapInteractionOnPopupOpen)
                    ? mapConfigs.disableMapInteractionOnPopupOpen
                    : defaultValues.mapConfigs.disableMapInteractionOnPopupOpen,
                autoSearchOnDragAndZoom: angular.isDefined(mapConfigs.autoSearchOnDragAndZoom)
                    ? mapConfigs.autoSearchOnDragAndZoom
                    : defaultValues.mapConfigs.autoSearchOnDragAndZoom,
                pinStaticMapImageSrc: angular.isDefined(mapConfigs.pinStaticMapImageSrc)
                    ? mapConfigs.pinStaticMapImageSrc
                    : defaultValues.mapConfigs.pinStaticMapImageSrc,
                offsetStaticMapImageDesktop: angular.isDefined(mapConfigs.offsetStaticMapImageDesktop)
                    ? mapConfigs.offsetStaticMapImageDesktop
                    : defaultValues.mapConfigs.offsetStaticMapImageDesktop,
                useStaticMapFullWidth: angular.isDefined(mapConfigs.useStaticMapFullWidth)
                    ? mapConfigs.useStaticMapFullWidth
                    : defaultValues.mapConfigs.useStaticMapFullWidth,
            };
        } else {
            d.mapConfigs = defaultValues.mapConfigs;
        }
      }

      init();

      return d;
  }
})();

(function () {
  'use strict';

  angular
    .module('storeLocator')
    .controller('storeLocatorController', storeLocatorController);

  /** @ngInject */
  function storeLocatorController($analytics,
                                  $timeout,
                                  mapHelper,
                                  MetaDataService,
                                  pubSub,
                                  STORE_LOCATOR_LATITUDE,
                                  STORE_LOCATOR_LONGITUDE,
                                  STORE_LOCATOR_LOC_ID,
                                  STORE_LOCATOR_PIXEL,
                                  CUSTOM_DICTIONARY,
                                  customFieldFactory,
                                  storeLocatorDictionary,
                                  SHOW_LIST_DEFAULT,
                                  tabsService,
                                  $location,
                                  storeLocatorCache,
                                  $window,
                                  LanguageService,
                                  APIMfLpAdapterService) {

    var $ctrl = this;

    $ctrl.storeLocatorText = CUSTOM_DICTIONARY && CUSTOM_DICTIONARY.storeLocatorText;
    $ctrl.searchLabel = CUSTOM_DICTIONARY && CUSTOM_DICTIONARY.placeholder;
    $ctrl.pixelCode = STORE_LOCATOR_PIXEL;
    $ctrl.currentDate = new Date();

    var locatorState = storeLocatorCache.get('state');
    if (!angular.isUndefined(locatorState)) {
      $ctrl.locatorStates = locatorState;
    } else {
      $ctrl.locatorStates = {
        current: '',
        geoEnabled: false,
        isRadius: false,
        isLoading: true,
        locations: [],
        locationsArray: [],
        locationMarkers: [],
        locationMarkersArray: [],
        mapCenter: {latitude: STORE_LOCATOR_LATITUDE, longitude: STORE_LOCATOR_LONGITUDE},
        message: 'Share your location or type a location in the search box',
        reloadMap: false,
        selectedFilters: [],
        showSearchAreaBtn: false,
        areaSearched: false,
        position: {},
        zoom: $window.innerWidth <= 767 ? storeLocatorDictionary.zoomLevels.initialMobile : storeLocatorDictionary.zoomLevels.initial,
        tabs: tabsService.showTabs() ? tabsService.getTabs() : null,
        activeTab: tabsService.getActiveTab(),
        initial: {
          center: { lat: STORE_LOCATOR_LATITUDE, lng: STORE_LOCATOR_LONGITUDE },
          zoom: $window.innerWidth <= 767 ? storeLocatorDictionary.zoomLevels.initialMobile : storeLocatorDictionary.zoomLevels.initial,
        },
        searchType: 'location',
      };
    }

    $ctrl.mapObj = {};
    $ctrl.window = $window;
    $ctrl.languageService = LanguageService;

    const storeFindersOptions = storeLocatorCache.get('storeFindersOptions');
    if (storeFindersOptions) {
      const metadata = MetaDataService.getMetaData(storeFindersOptions, 'mainPage');
      pubSub.publish({
        msg: 'setMeta',
        metadata: metadata
      });
    }

    const storeFindersMessages = storeLocatorCache.get('storeFindersMessages');
    if(storeFindersMessages && storeFindersMessages.messages){
      $ctrl.translatedMessages = storeFindersMessages.messages;
      setUpConstants();
    }

    function setUpConstants() {
      $ctrl.heading = $ctrl.translatedMessages['mf.storeLocator.heading'] || "Store Locator";
      $ctrl.sitemapButton = $ctrl.translatedMessages['mf.storeLocator.sitemapButton'] || "Locations";
      $ctrl.searchTitle = $ctrl.translatedMessages['mf.storeLocator.searchTitle'] || "Find a Location by Zip Code or City, State";
      $ctrl.showMapButton = $ctrl.translatedMessages['mf.storeLocator.showMapButton'] || storeLocatorDictionary.messages.mapView;
      $ctrl.showListButton = $ctrl.translatedMessages['mf.storeLocator.showListButton'] || storeLocatorDictionary.messages.listView;
    }

    $ctrl.showTabs = tabsService.showTabs();

    // handles whether to show the list view by default, or the map view.
    // default is usually set to "false" - show the map view first.
    $ctrl.showList = SHOW_LIST_DEFAULT;
    $ctrl.showIcons = storeLocatorDictionary.showIcons;
    $ctrl.listViewText = storeLocatorDictionary.messages.listView;
    $ctrl.mapViewText = storeLocatorDictionary.messages.mapView;
    $ctrl.storeLocatorTitle = storeLocatorDictionary.messages.storeLocatorTitle;
    $ctrl.storeLocatorDescription = storeLocatorDictionary.messages.storeLocatorDescription;
    $ctrl.customSearchTitle = storeLocatorDictionary.messages.customSearchTitle;
    $ctrl.siteMapLink = storeLocatorDictionary.messages.siteMapLink;
    $ctrl.siteMapLinkText = storeLocatorDictionary.messages.siteMapLinkText;


    $ctrl.getSpecificLocationById = function getSpecificLocationById(STORE_LOCATOR_LOC_ID) {
      if (STORE_LOCATOR_LOC_ID && STORE_LOCATOR_LOC_ID !== '') {
        return APIMfLpAdapterService.llpJson({ uberall_id: STORE_LOCATOR_LOC_ID }).then(function (response) {
          return response;
        });
      } else {
        return null;
      }
    };

    // Dummy Location
    if (STORE_LOCATOR_LOC_ID) {
      $ctrl.getSpecificLocationById(STORE_LOCATOR_LOC_ID).then(function (storeLoc) {
        $ctrl.customLocation = storeLoc.length && storeLoc[0].id ? storeLoc[0] : null;
      });
    }

    $ctrl.getCustomFieldValueByName = function getCustomFieldValueByName(customFields, name) {
      return customFieldFactory.getValueByName(customFields, name);
    };
    $ctrl.getTranslatedCustomFieldValue = function (customFields, customFieldName) {
      return customFieldFactory.getTranslatedValueByName(customFields, customFieldName, storeLocatorCache.get('storeFindersMessages').lang);
    };
    $ctrl.hasCustomFieldValue = function hasCustomFieldValue(customFields, name) {
      return customFieldFactory.getValueByName(customFields, name) ? true : false;
    };

    // if the user doesn't allow or deny location data,
    // automatically fire location search without their
    // location data after 5 seconds. this also covers in
    // the case that the user is using firefox and
    // selects "not now" for access to their location data.
    $timeout(function () {
      var searchParam = $location.search();
      if (Object.keys(searchParam).length > 0 && !searchParam.loc_q) {
          return;
      }
      if (!$ctrl.locatorStates.geoPermission && Object.keys(searchParam).length === 0) {
        mapHelper.geoLocationError($ctrl.locatorStates);
        $ctrl.locatorStates.geoEnabled = null;
      }
    }, 3000);

    // GA track Page View event
    $analytics.eventTrack('Page View', {
      category: 'Store Locator', label: 'Store Locator', noninteraction: 'true'
    });
  }
})();

(function () {
  'use strict';

  angular
    .module('storeLocator')
    .factory('siteMapData', siteMapData);

  function siteMapData(APIMfLpAdapterService, NO_ROUTING_PREFIX) {

    return {
      getAllLocations: getAllLocations,
      getLocationsByContinent: getLocationsByContinent,
      getLocationsByCountry: getLocationsByCountry,
      getLocationsByRegion: getLocationsByRegion,
      getLocationsByLocality: getLocationsByLocality,
    };

    function getLocationsByLocality(country, region, locality) {
      return getLocations({
        country: country,
        region: region,
        locality: locality
      });
    }

    function getLocationsByRegion(country, region) {
      return getLocations({
        country: country,
        region: region
      });
    }

    function getLocationsByCountry(country) {
      return getLocations({
        country: country
      });
    }

    function getLocationsByContinent(continent) {
      return getLocations({
        continent: continent
      });
    }

    function getAllLocations() {
      return getLocations({});
    }

    function getLocations(params) {
      if (NO_ROUTING_PREFIX) {
        params['noRoutingPrefix'] = NO_ROUTING_PREFIX;
      }
      return APIMfLpAdapterService.siteMap(params);
    }
  }
})();

(function() {
  'use strict';

  /**
   * Common Feed Language
   */

  siteMapDictionary.$inject = [];

  function siteMapDictionary() {
    const dictionary = {};

    dictionary.locationsNotFound = 'No matching locations found';
    dictionary.countryLegends = {
      "AM": "Armenia",
      "AU": "Australia",
      "AT": "Austria",
      "AZ": "Azerbaijan",
      "BH": "Bahrain",
      "BE": "Belgium",
      "BR": "Brazil",
      "CA": "Canada",
      "CN": "China Mainland",
      "CZ": "Czech Republic",
      "DK": "Denmark",
      "EG": "Egypt",
      "FR": "France",
      "GE": "Georgia",
      "DE": "Germany",
      "HK": "Hong Kong",
      "IN": "India",
      "ID": "Indonesia",
      "IE": "Ireland",
      "IT": "Italy",
      "JP": "Japan",
      "KZ": "Kazakhstan",
      "KW": "Kuwait",
      "LB": "Lebanon",
      "MO": "Macao",
      "MY": "Malaysia",
      "MX": "Mexico",
      "NL": "Netherlands",
      "NZ": "New Zealand",
      "NO": "Norway",
      "PA": "Panama",
      "PH": "Philippines",
      "PT": "Portugal",
      "QA": "Qatar",
      "RO": "Romania",
      "SA": "Saudi Arabia",
      "SG": "Singapore",
      "ZA": "South Africa",
      "KR": "South Korea",
      "ES": "Spain",
      "SE": "Sweden",
      "CH": "Switzerland",
      "TW": "Taiwan Area",
      "TH": "Thailand",
      "TR": "Turkey",
      "AE": "United Arab Emirates",
      "UK": "United Kingdom",
      "US": "United States",
      "VN": "Vietnam"
    };

    return dictionary;
  }

  angular.module('storeLocator')
    .factory('siteMapDictionary', siteMapDictionary);
}());

(function () {
  'use strict';

  angular
    .module('storeLocator')
    .controller('SiteMapController', SiteMapController);

  /** @ngInject */
  function SiteMapController(_,
                             siteMapData,
                             $log,
                             CLIENT_NAME,
                             RegionService,
                             $analytics,
                             CLIENT_ROUTE,
                             MetaDataService,
                             pubSub,
                             $location,
                             SITEMAP_SHOW_TEMP_CLOSED_LOCATIONS,
                             siteMapDictionary,
                             $window,
                             $state,
                             LanguageService,
                             storeLocatorCache){
    var vm = this;
    vm.position= "global";
    vm.windowWidth = window.innerWidth;
    vm.locations = [];
    vm.showPage = false;
    vm.show_temp_closed_locations = SITEMAP_SHOW_TEMP_CLOSED_LOCATIONS;
    vm.client_name = CLIENT_NAME;
    vm.client_route = CLIENT_ROUTE;
    vm.showBreadcrumb = true;
    vm.region = CLIENT_NAME.toLowerCase().includes('burberry') && $state.params.region ? $state.params.region.toUpperCase() : $state.params.region;
    vm.country = CLIENT_NAME.toLowerCase().includes('burberry') && $state.params.country ? $state.params.country.toUpperCase() : $state.params.country;
    vm.continent = (angular.isDefined($state.params.continent)) ? $state.params.continent : RegionService.lookupContinent(vm.country ? vm.country.toUpperCase() : vm.country);
    vm.all = (angular.isDefined($state.params.all)) ? $state.params.all : false;
    vm.locality = $state.params.locality;
    vm.metaData = {};
    vm.othersList=[];
    vm.featuredList = [];
    vm.fullList = [];
    vm.selectedContinent = {name: ''};
    vm.languageService = LanguageService;
    vm.backButtonText = 'Back';
    vm.allButtonText = 'All';
    vm.locationsTitleText = 'Locations';

    const storeFindersMessages = storeLocatorCache.get('storeFindersMessages');
    if (storeFindersMessages && storeFindersMessages.messages) {
      setMessages(storeFindersMessages.messages);
    }

    function setMessages(translatedMessages) {
      vm.storeFindersMessages = translatedMessages;
      vm.backButtonText = vm.storeFindersMessages['mf.sitemapPage.backButton'];
      vm.allButtonText = vm.storeFindersMessages['mf.sitemapPage.all.title'];
      vm.locationsTitleText = vm.storeFindersMessages['mf.sitemapPage.title'];
    }

    init();

    function setMetadata() {
      const storeFindersOptions = storeLocatorCache.get('storeFindersOptions');
      if (storeFindersOptions) {
        const metadata = MetaDataService.getMetaData(storeFindersOptions, 'sitemap');
        vm.metaData.site_map_title = metadata.title;
        vm.metaData.site_map_description = metadata.desc;

        pubSub.publish({
          msg: 'setMeta',
          metadata: siteMapMetaCallback(metadata)
        });
      }
    }

    function siteMapMetaCallback(metadata) {
      var stateParamCountry = $state.params.country ? $state.params.country.toUpperCase() : $state.params.country;
      var stateParamRegion = $state.params.region ? $state.params.region.toUpperCase() : $state.params.region;
      var title, description;
      //Use the word 'marker' as a designator for the spot for the region/locality to be inserted.
      //This section can be expanded as we allow for more complex meta tags. e.g. regionMarker, localityMarker, cityMarker, etc.
      //ex: Visiting marker? Make your money count more with Dollar. Book at any of our three convenient marker
      //locations to begin your vacation. Start your adventure with Dollar and reserve your marker car rental today.

      if (vm.metaData["site_map_title"] != null && vm.metaData["site_map_description"] != null) {
        if (vm.position === 'country') {
          var currentCountry = stateParamCountry;
          if (stateParamCountry === 'US') {
            currentCountry = 'the United States';
          }
          if (CLIENT_NAME.toLowerCase().includes('burberry') && currentCountry !== 'the United States') {
            title = vm.metaData["site_map_title"].replace(/\[\[region\]\]/, replaceLegendByCountryName(currentCountry)).replace(/\*\|region\|\*/, replaceLegendByCountryName(currentCountry)).replace(/\[\[area\]\]/, '');
            description = vm.metaData["site_map_description"].replace(/\[\[region\]\]/g, replaceLegendByCountryName(currentCountry)).replace(/\*\|region\|\*/g, replaceLegendByCountryName(currentCountry)).replace(/\[\[area\]\]/g, '');
          } else {
            title = vm.metaData["site_map_title"].replace(/\[\[region\]\]/, currentCountry).replace(/\*\|region\|\*/, currentCountry).replace(/\[\[area\]\]/, '');
            description = vm.metaData["site_map_description"].replace(/\[\[region\]\]/g, currentCountry).replace(/\*\|region\|\*/g, currentCountry).replace(/\[\[area\]\]/g, '');
          }
        } else if (vm.position === 'all' || vm.position === 'global') {
          var placeholder = "Your Local Area";
          title = vm.metaData["site_map_title"].replace(/\[\[region\]\]/, placeholder).replace(/\*\|region\|\*/, placeholder).replace(/\[\[area\]\]/, '');
          description = vm.metaData["site_map_description"].replace(/\[\[region\]\]/g, placeholder).replace(/\*\|region\|\*/g, placeholder).replace(/\[\[area\]\]/g, '');
        } else if (vm.position === 'region') {
          var currentRegion = RegionService.lookupRegionFromCountry(stateParamCountry, stateParamRegion);
          title = vm.metaData["site_map_title"].replace(/\[\[region\]\]/, currentRegion).replace(/\*\|region\|\*/, currentRegion).replace(/\[\[area\]\]/, '');
          description = vm.metaData["site_map_description"].replace(/\[\[region\]\]/g, currentRegion).replace(/\*\|region\|\*/g, currentRegion).replace(/\[\[area\]\]/g, '');
        } else {
          var currentLocality = $state.params.locality ? Object.keys(vm.locList)[0] : RegionService.lookupRegionFromCountry(stateParamCountry, stateParamRegion);
          var currentArea = ', ' + RegionService.lookupRegionFromCountry(stateParamCountry, stateParamRegion);
          if (CLIENT_NAME.toLowerCase().includes('burberry') && stateParamCountry.toLowerCase() === 'us') {
            title = vm.metaData["site_map_title"].replace(/\[\[region\]\]/, replaceHyphenAndCapitalizeEachWord(currentLocality) + ', ' + stateParamRegion).replace(/\*\|region\|\*/, replaceHyphenAndCapitalizeEachWord(currentLocality) + ', ' + stateParamRegion)
          } else if(CLIENT_NAME.toLowerCase().includes('burberry') && stateParamCountry.toLowerCase() !== 'us') {
            title = vm.metaData["site_map_title"].replace(/\[\[region\]\]/, replaceHyphenAndCapitalizeEachWord(currentLocality) + ', ' + replaceLegendByCountryName(stateParamCountry)).replace(/\*\|region\|\*/, replaceHyphenAndCapitalizeEachWord(currentLocality) + ', ' + replaceLegendByCountryName(stateParamCountry))
          } else {
            title = vm.metaData["site_map_title"].replace(/\[\[region\]\]/g, currentLocality).replace(/\*\|region\|\*/g, currentLocality).replace(/\[\[area\]\]/g, currentArea);
          }
          description = vm.metaData["site_map_description"].replace(/\[\[region\]\]/g, currentLocality).replace(/\*\|region\|\*/g, currentLocality).replace(/\[\[area\]\]/g, currentArea);
        }

        if (CLIENT_NAME.toLowerCase().includes('burberry')) {
          description = MetaDataService.getBurberrySitemapDescription (
            description, vm.position, [stateParamCountry, stateParamRegion, $state.params.locality]
          );
        }

        metadata.title = title;
        metadata.desc = description;
        return metadata;
      } else {
        console.log("SiteMap meta tags have not been set!");
      }
    }

    function replaceHyphenAndCapitalizeEachWord(str) {
      return str.replace(/-/g, ' ').replace(/\b\w/g, function (match) {
        return match.toUpperCase();
      });
    }

    function replaceLegendByCountryName(str) {
      return siteMapDictionary.countryLegends[str.toUpperCase()]
    }

    $analytics.eventTrack('Page View', {
        category: 'Site Map', label: 'Site Map'
    });

    function init() {
        if ($state.params.locality) {
          vm.position = 'locality';
          siteMapData.getLocationsByLocality($state.params.country, $state.params.region, $state.params.locality).then(locationsComplete).catch(llerror);
        } else if ($state.params.region) {
          vm.position = 'region';
          if (vm.country === 'US') {
            vm.regionFullName = RegionService.lookup(vm.region);
          }
          siteMapData.getLocationsByRegion($state.params.country, $state.params.region).then(locationsComplete).then(groupFeaturedOthers).catch(llerror);
        } else if ($state.params.country) {
          vm.position = 'country';
          siteMapData.getLocationsByCountry($state.params.country).then(locationsComplete).catch(llerror);
        } else if (vm.continent) {
          vm.position = 'continent';
          siteMapData.getLocationsByContinent(vm.continent).then(locationsComplete).catch(llerror);
        } else {
          (vm.all) ? vm.position = 'all' : vm.position = 'global';
          vm.showBreadcrumb = false;
          siteMapData.getAllLocations().then(locationsComplete).catch(llerror);
        }
    }

    function groupFeaturedOthers(){
      vm.fullList.forEach(function(l){
        if (l.store_info.featured) vm.featuredList.push(l);
        else vm.othersList.push(l);
      });
      vm.featuredList = _(vm.featuredList)
        .groupBy(function(l){
          return l.store_info.locality;
        })
        .value();
      vm.othersList = _(vm.othersList)
        .groupBy(function(l){
          return l.store_info.locality;
        })
        .value();
    }

    function locationsComplete(response) {
      vm.locations = response.locations;
      if (response.message === siteMapDictionary.locationsNotFound) {
        $location.path('/404');
      }
      vm.showPage = true;

      if(vm.position==="country") {
        vm.locList = vm.getByRegionForCountry(vm.locations);
      } else if(vm.position==="region" || vm.position==="locality") {
        vm.locList = vm.getByLocalityForRegion(vm.locations);
      } else if(vm.position==="continent") {
        vm.locList = vm.getByCountryForContinent(vm.locations);
      } else if(vm.position === 'global') {
        vm.locList = _(vm.locations)
          .filter(function (l) {
            return vm.includeLocationsWithoutRegion(l);
          })
          .each(function (l) {
            l.regionTransformed = RegionService.lookupRegionFromCountry(l.store_info.country, l.store_info.region);
          })
          .sortBy(function (l) {
            return l.store_info.continent + " " + l.store_info.country + " " + l.regionTransformed;
          })
          .groupBy(function (l) {
            return l.store_info.continent;
          })
          .value();
      } else {
        vm.locList = _(vm.locations)
          .filter(function (l) {
            return (l.open_or_closed === "open" || l.open_or_closed === "coming soon" || l.open_or_closed === "temp closed") && l.store_info.region && l.local_landing_page;
          })
          .each(function(l){
            l.regionTransformed = RegionService.lookupRegionFromCountry(l.store_info.country, l.store_info.region);
          })
          .sortBy(function (l) {
            return l.regionTransformed + " " + l.store_info.locality;
          })
          .groupBy(function (l) {
            if (vm.locality)
            {
              return vm.locality;
            }
            return l.regionTransformed;
          })
          .value();
      }
      if (_.isEmpty(vm.locList)) {
        vm.locList = null;
      }

      setMetadata();
    }

    vm.noIndexHead = function() {
      $window.document.getElementsByName('robots')[0].content = 'noindex';
    };

    vm.includeLocationsWithoutRegion = function (l) {
      return l.store_info.region ? ( l.open_or_closed === "open"  ||  l.open_or_closed === "coming soon" || (vm.show_temp_closed_locations && l.open_or_closed === "temp closed")) && l.store_info.region && l.local_landing_page :
        ( l.open_or_closed === "open" ||  l.open_or_closed === "coming soon") && l.local_landing_page;
    }

    vm.getByCountryForContinent = function (locList) {
      return _(locList)
        .filter(function (l) {
          return vm.includeLocationsWithoutRegion(l);
        })
        .each(function (l) {
          l.regionTransformed = RegionService.lookupRegionFromCountry(l.store_info.country, l.store_info.region);
        })
        .sortBy(function (l) {
          return l.store_info.country + " " + l.regionTransformed + " " + l.store_info.locality;
        })
        .groupBy(function (l) {
          return l.store_info.country;
        })
        .value();
    };

    vm.getByRegionForCountry = function (locList) {
      return _(locList)
        .filter(function (l) {
          return vm.includeLocationsWithoutRegion(l);
        })
        .each(function (l) {
          var regionTransformed = RegionService.lookupRegionFromCountry(l.store_info.country, l.store_info.region);
          if(regionTransformed.length != 2) {
            var arr = regionTransformed.toLowerCase().split(' ')
            var i = 0
            var arrRev = []
            while(i < arr.length) {
              if(arr[i]) {
                arrRev.push(arr[i].charAt(0).toUpperCase() + arr[i].slice(1, arr[i].length))
              }
              i++
            }
            l.regionTransformed = arrRev.join(' ')
          } else {
            l.regionTransformed = regionTransformed
          }
        })
        .sortBy(function (l) {
          return l.regionTransformed + " " + l.store_info.locality;
        })
        .groupBy(function (l) {
          return l.regionTransformed;
        })
        .value();
    };

    vm.getByLocalityForRegion = function (locList) {
      return _(locList)
        .filter(function (l) {
          return vm.includeLocationsWithoutRegion(l);
        })
        .sortBy(function (l) {
          return l.store_info.locality + " " + l.store_info.address;
        })
        .each(function (l) {
          vm.fullList.push(l);
        })
        .groupBy(function (l) {
          return l.store_info.locality;
        })
        .value();
    };

    vm.normalizeLocality = function (locality) {
      if (CLIENT_NAME.toLowerCase().includes('burberry')) {
        return locality.replace(/-/g,' ');
      }
      return locality;
    }

    function llerror(error) {
      $log.debug(error);
      if(error.status === 404){
        $location.path('/404')
      }
      else if(error.status === 400){
        $location.path('/400')
      }
      else if(error.status === 500){
        $location.path('/500')
      }
    }
  }
})();

(function () {
  'use strict';

  angular
      .module('storeLocator')
      .directive('locationList', locationList);

  function locationList(LOCATION_LIST_TEMPLATE) {

    return {
      replace: true,
      scope: {
          client:'=',
          locations: '=',
          country: '=',
          region: '=',
          locality: '=',
          clientRoute: '=',
          position: '=',
          featured: '=',
          others: '=',
          getByCountry: '&',
          customHeading: '@',
          comingSoonText: '@',
          translatedMessages: '=',
          useUrlDash: '=',
          useUrlLowercase: '=',
          siteMapPrefix: '@?'
      },
      templateUrl: LOCATION_LIST_TEMPLATE,
      restrict: 'AE',
      controller: LocationListController,
      controllerAs: 'locationListC',
      bindToController: true
    };
  }

  LocationListController.$inject = ['urldashFilter', 'RegionService', 'LanguageService', '$timeout'];
  function LocationListController(urldashFilter, RegionService, LanguageService, $timeout){
    var vm = this;
    vm.languageService = LanguageService;
    vm.locationsTitleText = vm.translatedMessages ? vm.translatedMessages['mf.sitemapPage.title'] : vm.customHeading || "Locations"; 

    vm.urldashIt = function (text) {
      return urldashFilter(text);
    };
    vm.getCountry = function(code){
      return RegionService.lookupCountryNameFromCode(code)
    };
    vm.getRegion = function(countryCode, regionCode){
      // Temporary fix to accomodate data issues with Dollar/Thrifty's source of truth. To be removed when their data is clean.
      if(countryCode === "US") {
        return RegionService.lookup(regionCode);
      } else if (regionCode && regionCode.length != 2) {
        var arr = regionCode.toLowerCase().split(' ')
        var i = 0
        var arrRev = []
        while(i < arr.length) {
          if(arr[i]) {
            arrRev.push(arr[i].charAt(0).toUpperCase() + arr[i].slice(1, arr[i].length))
          }
          i++
        }
        regionCode = arrRev.join(' ')
        return regionCode
      }  else {
        return RegionService.lookupRegionFromCountry(countryCode, regionCode)
      }
    };

    vm.getListOfCountries = function (locations) {
      return {
        keys: Object.keys(vm.getByCountry({locList: locations})),
        values: Object.keys(vm.getByCountry({locList: locations})).map(function(key) {
          return vm.getByCountry({locList: locations})[key];
        })
      }
    };
    vm.checkCountryInContinent = function(countryCode){
      return RegionService.lookupContinent(countryCode);
    };
    vm.getLinkUrl = function(url){
      if (vm.useUrlDash) {
        url = urldashFilter(url, false, vm.useUrlLowercase);
      }
      url = angular.isUndefined(vm.siteMapPrefix) ? 'site-map/' + url : vm.siteMapPrefix + '/' + url;
      return LanguageService.updateLinkUrl(url);
    }
    
    $timeout(function() {
      vm.worldwideh1 = ['global', 'all'].indexOf(vm.position) >= 0
    },300);
  }
})();

(function () {
  'use strict';

  angular
    .module('storeLocator')
    .service('socialMediaService', socialMediaService);

    function socialMediaService() {
        var yelpType = 'Yelp',
            foursquareType = 'Foursquare',
            googleType = 'Google';

        this.storeHasYelp = function (data) {
            if (data && data.store_info && data.store_info.providers) {
                var yelp = _.findWhere(data.store_info.providers, { _type: yelpType });
                return !!yelp && yelp.venue_id !== "";
            }
            return false;
        }

        this.storeHasFoursquare = function (data) {
            if (data && data.store_info && data.store_info.providers) {
                var foursquare = _.findWhere(data.store_info.providers, { _type: foursquareType });
                return !!foursquare;
            }
            return false;
        }

        this.storeHasGoogle = function (data) {
            if (data && data.store_info && data.store_info.providers) {
                var google = _.findWhere(data.store_info.providers, { _type: googleType });
                return !!google && google.url !== "";
            }
            return false;
        }
        
        this.getProviderData = function (data, providerType) {
            if (data && data.store_info && data.store_info.providers) {
                return _.findWhere(data.store_info.providers, { _type: providerType });
            }
            return null;
        }
    }
    
})();

(function () {
  'use strict';

  angular
    .module('storeLocator')
    .service('menuService', menuService);

  function menuService($q, APIMfLpAdapterService, menuMapper) {
   this.getMenu = function (languageCode, locationId) {
      var deferred = $q.defer();
      getMenu(locationId).then(function (response) {
        if (response) {
          var menu = menuMapper.map(response, languageCode);
          deferred.resolve(menu);

        } else {
          deferred.reject();
        }
      });
      return deferred.promise;
    };

    function getMenu(locationId) {
      var params = {
        'ghosted': true
      };

      return APIMfLpAdapterService.location.menus(locationId, params);
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('storeLocator')
    .service('amenitiesService', amenitiesService);

  function amenitiesService() {
        this.storeHasAmenities = function (storeInfo) {
            var amenities = getAmenities(storeInfo);
            return amenities.length > 0;
        };

        this.storeHasCustomAmenities = function (storeInfo,contentTag) {
            var amenities = getContents(storeInfo,contentTag);
            return amenities.length > 0;
        };

        this.getAmenities = function (storeInfo) {
            var amenities = getAmenities(storeInfo);

            if (amenities) {
                amenities.forEach(function(amenity) {
                    var tooltips = storeInfo.filter(function(tooltip) {
                        return tooltip.name.indexOf(amenity.name + '_tooltip') === 0;
                    });
                    amenity.tooltip = '';
                    if (tooltips.length > 0) {
                        amenity.tooltip = tooltips[0].data;
                    }
                    amenity.showTooltip = false;
                });
            }

            return amenities;
        };

        this.getContents = function (storeInfo, contentTag, language) {
          var contents = getContents(storeInfo, contentTag, language);
          if (contents) {
            contents.forEach(function (item, i) {
                item.tooltip = contents[i].data;
            });
          }

          return contents;
        };

        function getAmenities(storeInfo) {
            var amenities = storeInfo.filter(function(amenity) {
                return isAmenity(amenity);
            });
            return amenities;
        }

        function isAmenity(data)
        {
            return data.name.indexOf('service_') === 0 && data.name.indexOf('_tooltip') === -1 && data.name.indexOf('service_custom') === -1 && data.data.toUpperCase() !== 'FALSE';
        }

        function getContents(storeInfo, contentTag, language) {
            var contents;
            var lengthServiceCustom = ('service_custom_' + contentTag).length;
            var contentsNoLanguage = storeInfo.filter(function(data) {
                return data.name.indexOf('service_custom_' + contentTag) === 0 && data.name.indexOf('_tooltip') === -1 && data.data.toUpperCase() !== 'FALSE' && data.name.length === lengthServiceCustom;
            });

            if(language){
                contents = storeInfo.filter(function(data) {
                    return data.name.indexOf('service_custom_' + contentTag + '_' + language) === 0 && data.name.indexOf('_tooltip') === -1 && data.data.toUpperCase() !== 'FALSE';
                });
                if(contents.length === 0) contents = contentsNoLanguage;
            }else{
                contents = contentsNoLanguage;
            }

            return contents;
        }
    }
})();

(function () {
  'use strict';

  angular
    .module('storeLocator')
    .factory('menuMapper', menuMapper);

  function menuMapper() {
      var DESCRIPTION_LIMIT = 150;

      return {
          map: map
      };


      function map(data) {
          return getAdapterMenu(data);
      }

    function getAdapterMenu(data) {
      var menu = [];
      _.each(data, function(element) {
        var menuSection = {
          categoryName: element.displayName,
          active: false,
          options: []
        }
        _.each(element.sections, function(section) {
          var sectionOptions = section.items.map(function(item) {
            return {
              optionId: item.id,
              name: item.displayName,
              description: formatDescription(item.description),
              price: item.price,
              photo: item.photoUrls.length ? item.photoUrls[0] && item.photoUrls[0].publicUrl : null,
            }
          });
          menuSection.options = menuSection.options.concat(sectionOptions);
        });
        menu.push(menuSection);
      });
      return menu;
    }

      function formatDescription(content) {
          var description = {
              truncated: false,
              text: content,
              truncatedText: ''
          };

          if (content && content.length > DESCRIPTION_LIMIT) {
              description = {
                  truncated: true,
                  text: content.substr(0, DESCRIPTION_LIMIT),
                  truncatedText: content.substr(DESCRIPTION_LIMIT)
              }
          }

          return description;
      }
  }
})();

(function () {
  'use strict';

  angular
    .module('storeLocator')
    .factory('localLandingData', localLandingData);

  function localLandingData(
    APIMfLpAdapterService,
    $state,
    urldashFilter,
    INSTAGRAM_BUSINESS_ACCOUNT_ID,
    TAGS_CONDITION_TYPE,
    storeLocatorCache,
    NO_ROUTING_PREFIX,
    QUERY_BY_SLUG,
    CLIENT_ROUTE,
    FIELD_MASK,
    localLandingDictionary,
    $window,
    $rootScope
  ) {

    // receives the pagination request and performs a search returning the results via another event
    $rootScope.$on('pagination.directive.click', function(evt,args) {
      getLocationsForSearch(
        args.params.center,
        args.params.coordinates,
        args.params.tags,
        args.params.pageSize,
        args.params.page
      ).then(function(response) {
        $rootScope.$broadcast('pagination.directive.click.response', {
          locations: response
        })
      });
    });

    return {
      getLocationForAddress: getLocationForAddress,
      getUberallLpContentCardPosts: getUberallLpContentCardPosts,
      getGeoCoordinates: getGeoCoordinates,
      getLocationForLocality: getLocationForLocality,
      getPhotosForLocation: getPhotosForLocation,
      getLocationsForSearch: getLocationsForSearch,
      getLocationsForGeoSearch: getLocationsForGeoSearch,
      getLocationsByName: getLocationsByName,
      getListingsForUberallId: getListingsForUberallId,
      getCustomItemsByLocationId: getCustomItemsByLocationId,
      getLocationById: getLocationById,
    };

    function getLocationForAddress() {
      var params = {
        pageSize: 30,
        language: storeLocatorCache.get('language')
      };

      var lang = storeLocatorCache.get('language');
      if (lang) {
        params.language = lang;
      }

      if (QUERY_BY_SLUG) {
        var slugParts = $state.current.url.split(/\/+/).filter(Boolean);
        if (lang) {
          slugParts.shift();
        }
        var slugValues = [];
        slugParts.forEach(function(part) {
          if (part.startsWith(':')) {
            slugValues.push($state.params[part.substring(1)]);
          } else if(CLIENT_ROUTE !== '/' + part) {
            slugValues.push(part);
          }
        });
        params['slug'] = slugValues.join('/');
      } else {
        params['name'] = urldashFilter($state.params.name, true);
        params['address'] = urldashFilter($state.params.address.normalize('NFC'), true);
        params['locality'] = urldashFilter($state.params.locality.normalize('NFC'),true);
        params['region'] = !urldashFilter($state.params.region.normalize('NFC')) ? undefined : urldashFilter($state.params.region.normalize('NFC')).replace(/-/g, ' ');
        params['country'] = urldashFilter($state.params.country);
      }
      if (NO_ROUTING_PREFIX) {
        params['noRoutingPrefix'] = NO_ROUTING_PREFIX;
      }
      if (FIELD_MASK) {
        params['fieldMask'] = FIELD_MASK;
      }

      return APIMfLpAdapterService.llpJson(params);
    }

    function getUberallLpContentCardPosts(locId) {
      return APIMfLpAdapterService.llpPosts({locationId: locId});
    }

    function getGeoCoordinates(tags) {
      var params = {};

      if (tags) {
        params.tags_type = TAGS_CONDITION_TYPE;
        params.tags = tags;
      }

      return APIMfLpAdapterService.llpGeo(params);
    }

    function getLocationForLocality() {
      var params = {
        locality: urldashFilter($state.params.locality,true),
        region: urldashFilter($state.params.region),
        pageSize: 30,
        language: storeLocatorCache.get('language'),
        country: urldashFilter($state.params.country)
      };
      if (NO_ROUTING_PREFIX) {
        params['noRoutingPrefix'] = NO_ROUTING_PREFIX;
      }

      return APIMfLpAdapterService.llpJson(params);
    }

    /**
     * Retrieves the locations for a search based on the provided parameters.
     *
     * @param {string} center - The center location as a string.
     * @param {string} coordinates_string - The coordinates as a string.
     * @param {string} tags - The tags to filter the locations by.
     * @param {number} limit - The maximum number of locations to retrieve.
     * @param {number} [page] - The page number for pagination. Optional
     * @returns {Promise} - A promise that resolves to an array of locations.
     * @throws {Error} - If the "page" is defined but not a number.
     */
    function getLocationsForSearch(center, coordinates_string, tags, limit, page) {

      if (page !== undefined && !angular.isNumber(page)) {
        throw new Error('page must be a number');
      }
      var currentPageNumber = page || 1;
      storeLocatorCache.save('currentPageNumber', currentPageNumber);

      var params = {
        center: center,
        coordinates: coordinates_string,
        page: currentPageNumber,
        pageSize: limit,
        language: storeLocatorCache.get('language')
      };

      if (NO_ROUTING_PREFIX) {
        params['noRoutingPrefix'] = NO_ROUTING_PREFIX;
      }

      if (tags) {
        params.tags_type = TAGS_CONDITION_TYPE;
        params.tags = tags;
      }

      if (FIELD_MASK) {
        params['fieldMask'] = FIELD_MASK;
      }

      var locationsList = APIMfLpAdapterService.llpJson(params);

      if (storeLocatorCache.get('geoFlag')) {
        storeLocatorCache.save('currentLocationsList', locationsList);
      } else {
        storeLocatorCache.save('locationsList', locationsList);
      }

      return locationsList;
    }

    function getLocationsForGeoSearch(lat,long,radius,limit) {
      var params = {
        geo: lat+","+long,
        radius: radius,
        page:1,
        pageSize:limit
      };
      if (NO_ROUTING_PREFIX) {
        params['noRoutingPrefix'] = NO_ROUTING_PREFIX;
      }

      return APIMfLpAdapterService.llpNearbyJson(params);
    }

    function getLocationsByName(name, limit, page) {
      if (page !== undefined && !angular.isNumber(page)) {
        throw new Error('page must be a number');
      }
      var currentPageNumber = page || 1;

      var params = {
        query: name,
        page: currentPageNumber,
        pageSize: limit,
      }

      if (NO_ROUTING_PREFIX) {
        params['noRoutingPrefix'] = NO_ROUTING_PREFIX;
      }

      return APIMfLpAdapterService.llpJson(params);
    }

    function getPhotosForLocation(locId) {
      var params = {
        page: 1,
        pageSize: 20,
        directory: 'instagram',
        businessAccountId: INSTAGRAM_BUSINESS_ACCOUNT_ID
      }
      return APIMfLpAdapterService.location.media(locId, params);
    }

    function getListingsForUberallId(locId) {
      return APIMfLpAdapterService.location.listings(locId);
    }

    function getCustomItemsByLocationId(locId) {
      return APIMfLpAdapterService.location.customItems(locId);
    }

    function getLocationById(locId) {
      var params = {
        uberall_id: locId
      };
      if (FIELD_MASK) {
        params['fieldMask'] = FIELD_MASK;
      }
      if (NO_ROUTING_PREFIX) {
        params['noRoutingPrefix'] = NO_ROUTING_PREFIX;
      }
      return APIMfLpAdapterService.llpJson(params);
    }

  }

})();

(function() {
  'use strict';

  angular
    .module('storeLocator')
    .factory('localLandingDictionary', localLandingDictionary);

  /** @ngInject */
  function localLandingDictionary() {
    var dictionary = {};

    //state values
    dictionary.LOCATION_NEW = {label: 'New Location', value: 'new', css_bg:'i-info', css:''};
    //list of cleints for which we will be redirecting them to the home page
    // or custom URL if the no results are found during location search.
    dictionary.CLIENT_LIST = {};
    dictionary.locationsNotFound = 'No matching locations found';
    return dictionary;
  }
})();

(function () {
  'use strict';

  angular
    .module('storeLocator')
    .controller('LocalLandingController', LocalLandingController);

  /** @ngInject */
  function LocalLandingController($stateParams, localLandingData, $log, _, $analytics, $state, $scope, $window, $timeout, MetaDataService, pubSub, storeLocatorCache, urldashFilter, urlBuilderFactory, localLandingDictionary, CLIENT_NAME, LanguageService, customFieldFactory, $sce) {
    var vm = this;
    vm.location = 'loading';
    vm.photos = ['photos'];
    vm.fbReviews = [];
    vm.activities = [];
    vm.nearbyLocations = [];
    vm.error = false;
    vm.errorStatus;
    vm.getPromoImageCount;
    vm.storeFindersMessages = null;

    $state.current.title = '';

    vm.address = $stateParams.address;
    vm.languageService = LanguageService;

    $state.current.title = '';

    // if we have the cache in side and this address is the address in the llp.json, then use cache
    // added normalize to addresses with accent marks failing on the equality check
    if (storeLocatorCache.get('location') && $stateParams.address !== '' && isSameAddress(storeLocatorCache.get('location'), urldashFilter($stateParams.address, true))) {
      locationListComplete([storeLocatorCache.get('location').entire_location]);
    } else {
      localLandingData.getLocationForAddress().then(locationListComplete).catch(llerror);
    }
    vm.windowWidth = window.innerWidth;

    const storeFindersMessages = storeLocatorCache.get('storeFindersMessages');
    if (storeFindersMessages && storeFindersMessages.messages) {
      vm.storeFindersMessages = storeFindersMessages.messages;
    }

    $window.onresize = function (event) {
      $timeout(function () {
        vm.windowWidth = window.innerWidth;
      });
    };

    function isSameAddress(location, urlAddress) {
      var formattedUrlAddress = urlAddress.normalize("NFD");
      var formattedLocationAddress = location.address.normalize("NFD");
      if (formattedUrlAddress === formattedLocationAddress) {
        return true;
      }
      if (location.entire_location.id) {
        return false;
      }
    }

    function locationListComplete(response) {
      // if the location are not found check if we have custome redirect URL's for the clients
      if (response.message === localLandingDictionary.locationsNotFound) {
        if (_.has(localLandingDictionary.CLIENT_LIST, CLIENT_NAME)) {
          $window.location.href = localLandingDictionary.CLIENT_LIST[CLIENT_NAME];
        }
      }
      // throw an error in case of null response
      if (response[0] == null) {
        vm.error = true;
        return;
      }

      localLandingData.getListingsForUberallId(response[0].id).then(function(locationProviders) {
        parseLocation(response[0], locationProviders);
      }).catch(function() {
          parseLocation(response[0]);
        });
    }

    function llerror(error) {
      $log.debug(error);
      vm.error = true;
      vm.errorStatus = error.status;
    }

    function checkHeroImage() {
      var image;
      var heroElement = document.querySelector("#hero");
      if (heroElement) {
        var heroElementSrc = heroElement.getAttribute("src");
        if (heroElementSrc) {
          image = heroElementSrc;
        } else {
          var imageInHeroElement = heroElement.querySelector("img");
          if (imageInHeroElement) {
            image = imageInHeroElement.getAttribute("src");
          }
        }
      }
      if (image) {
        setMetaImage(image);
      }
    }

    function checkMapImage() {
      var intervals = 12;
      var interval = $window.setInterval(function() {
        var mapImage = document.querySelector('.map-container img');
        if(mapImage) {
          $window.clearInterval(interval);
          setMetaImage(mapImage.src);
        } else if(intervals <= 0) {
          $window.clearInterval(interval);
          checkHeroImage();
        }
        intervals--;
      }, 300);
    }

    function setMetaImage(image) {
      pubSub.publish({
        msg: 'setMetaImage',
        metadataImage: image
      });
    }

    function checkIfPromoSectionIsLoaded(){
      var interval = setInterval(function() {
        var promoSection = document.getElementById('sectionPromos');
        if(promoSection) {
          clearInterval(interval);
          getPromoImageCount();
        }
      },100)
    }

    checkIfPromoSectionIsLoaded();

    function getPromoImageCount() {
        var promoImageSection = document.getElementById('sectionPromos');
        var promoImages = _.toArray(promoImageSection.getElementsByClassName('image-element'));
        var imageCount = promoImages.length;
        var missingImg = 0;
        promoImages.forEach(function(img) {
          var imgEl = _.toArray(img.getElementsByTagName('img'));
          if(!imgEl[0].src) {
            missingImg++;
          }
        })
        vm.getPromoImageCount = imageCount - missingImg;
        $scope.$apply();
    }

    function getTwitterHandle(handle) {
      var parsedHandle = handle ? handle.split('/') : '';
      return parsedHandle.length > 0 ? parsedHandle[parsedHandle.length - 1] : parsedHandle;
    }

    function parseLocation(location, mfProvidersData) {
      location.store_info.social_providers = location.store_info.providers;
      if (mfProvidersData && mfProvidersData.length > 0) {
        location.store_info.providers = mfProvidersData;
      }
      location.twitter_handle = getTwitterHandle(location.twitter_handle);
      vm.location = location;

      vm.location.store_info.directionsUrl = urlBuilderFactory.getDirectionsUrl(vm.location.store_info);
      $scope.$emit('localLanding.location', vm.location);
      storeLocatorCache.save('localLandingLocation', vm.location);

      const storeFindersOptions = storeLocatorCache.get('storeFindersOptions');
      if (storeFindersOptions) {
        const metadata = MetaDataService.getMetaData(storeFindersOptions, 'localPage', vm.location);
        metadata.twitter_handle = vm.location.twitter_handle && vm.location.twitter_handle.length > 0 ? '@' + vm.location.twitter_handle : '';
        checkMapImage();
        pubSub.publish({
          msg: 'setMeta',
          metadata: metadata
        });
      }

      vm.fbReviews = [vm.location];
      // GA track Page View event
      $analytics.eventTrack('Page View', {
        category: 'LLP',
        label: '{ "url": "' + vm.location.llp_url + '", "location_id": "' + vm.location.momentfeed_venue_id + '"}',
        noninteraction: 'true'
      });

      var address = vm.location.store_info.address + vm.location.store_info.address_extended;
      var locality = vm.location.store_info.locality;
      var region = vm.location.store_info.region;
      var postcode = vm.location.store_info.postcode;

      vm.alphanumeric = _.find(vm.location.custom_fields, function (o) {
        return o.name == "alphanumeric";
      });

      if (vm.alphanumeric) {
        vm.alphanumeric = vm.alphanumeric.data;
      }

      $state.current.title = ' at ' + address + ', ' + locality + ', ' + region + ' ' + postcode;
      vm.posts = vm.location.id;
      vm.brandPosts = "brandPosts";

      //Reduce Twitter API callback by referencing location data that we already have rather than calling the twitter endpoint
      //Twitter card differs from the other API reduction efforts in that there is no functionality to migrate INTO the card controller
      //just a smarter way to use data.
      var account = {
        "twitter_subscriptions": {
          "user": [vm.location.twitter_handle]
        }
      };
      vm.account = account;
      vm.nearbyLocations = [vm.location];
      vm.storeName = getCustomFieldValueByName(vm.location.custom_fields, 'store_name') || vm.location.store_info.name;
    }

    function getCustomFieldValueByName(customFields, name) {
      var value = customFieldFactory.getValueByName(customFields, name);
      return $sce.trustAsHtml(value);
    }
  }
})();

angular
  .module('storeLocator')
  .controller('500errorCard', errorPage);

function errorPage($scope) {

  $scope.back = function() {
    history.back();
  };

  return {
    templateUrl: 'app/errorPages/500.html',
    restrict: 'E',
    bindToController: {
      locationError: '='
    },
    controller: function(CLIENT_ROUTE) {
      var vm = this;

      vm.indexURI = CLIENT_ROUTE;
      vm.auto_redirect = false;

    },
    controllerAs: '500Ctrl'
  };

}

angular
  .module('storeLocator')
  .controller('404errorCard', errorPage);

function errorPage($scope) {

  $scope.back = function() {
    history.back();
  };

  return {
    templateUrl: 'app/errorPages/404.html',
    restrict: 'E',
    bindToController: {
      locationError: '='
    },
    controller: function(CLIENT_ROUTE) {
      var vm = this;

      vm.indexURI = CLIENT_ROUTE;
      vm.auto_redirect = false;

    },
    controllerAs: '404Ctrl'
  };

}

angular
  .module('storeLocator')
  .controller('400errorCard', errorPage);

function errorPage($scope) {

  $scope.back = function() {
    history.back();
  };

  return {
    templateUrl: 'app/errorPages/400.html',
    restrict: 'E',
    bindToController: {
      locationError: '='
    },
    controller: function(CLIENT_ROUTE) {
      var vm = this;

      vm.back = function() {
        history.back();
      };

      vm.indexURI = CLIENT_ROUTE;
      vm.auto_redirect = false;

    },
    controllerAs: '400Ctrl'
  };

}

(function () {
  'use strict';

  angular
    .module('storeLocator')
    .factory('urlBuilderFactory', urlBuilderFactory);

  function urlBuilderFactory(urldashFilter) {

    var DIRECTIONS_URL = 'https://www.google.com/maps/dir/?api=1&destination=';
    var INSTAGRAM_URL = 'https://www.instagram.com/';

    var factory = {
      getDirectionsUrl: getDirectionsUrl,
      getInstagramUrl: getInstagramUrl
    };

    //data passed in should be location.store_info object
    function getDirectionsUrlByAddress(data) {
      var fullAddress = data.address + " " + data.locality + " " + data.region + " " + data.postcode;
      var directionsUrl = DIRECTIONS_URL + urldashFilter(fullAddress);

      return directionsUrl;
    }

    function getDirectionsUrlByCoordinates(data) {
      if (data.latitude === null || data.longitude === null) {
        return null;
      }

      var coordinates = data.latitude + ", " + data.longitude;
      var directionsUrl = DIRECTIONS_URL + coordinates;
      return directionsUrl;
    }

    function getDirectionsUrlByPlaceId(data) {
      var googleProviderObj = _.find(data.providers, function(prov){return prov._type === "Google"}) || {};
      if (_.isEmpty(googleProviderObj)) {
        return null;
      }

      var gmbPlaceId = googleProviderObj.place_id;
      var gmbDestinationName = googleProviderObj.name;
      var directionsUrl = encodeURI("https://www.google.com/maps/dir/?api=1&destination_place_id=" + gmbPlaceId + "&destination=" + gmbDestinationName);
      return directionsUrl;
    }

    //returns a directions url when passing in location.store_info with priority given to
    // 1. gmb place_id 2. coordinates 3. address
    function getDirectionsUrl(data) {
      if (data !== null && angular.isDefined(data)) {
        var getByPlaceId = getDirectionsUrlByPlaceId(data);
        if (getByPlaceId !== null) {
          return getByPlaceId;
        }
        var getByCoordinates = getDirectionsUrlByCoordinates(data);
        if (getByCoordinates !== null) {
          return getByCoordinates;
        }
        return getDirectionsUrlByAddress(data);
      }
      return DIRECTIONS_URL;
    }

    function getInstagramUrl(handle) {
      var url = INSTAGRAM_URL + handle;
      return url;
    }

    return factory;
  }
})();

(function () {
  'use strict';
  angular
    .module("storeLocator")
    .factory('s', UnderscoreStringService);

  function UnderscoreStringService($window) {
    return $window.s; // assumes underscore has already been loaded on the page
  }
}());

(function () {
    'use strict';

    angular
        .module('storeLocator')
        .provider('sfAnalytics', sfAnalyticsProvider)
        .run(['sfAnalytics', function (sfAnalytics) {}]);

    function sfAnalyticsProvider() {
        this.$get = sfAnalytics;
        sfAnalytics.$inject = ['$window', 'ENV', 'SF_ANALYTICS_WEBSITE_QA', 'SF_ANALYTICS_WEBSITE_PROD', 'DISABLE_SCRIPTS_ON_QA'];
    }

    function sfAnalytics($window, ENV, SF_ANALYTICS_WEBSITE_QA, SF_ANALYTICS_WEBSITE_PROD, DISABLE_SCRIPTS_ON_QA) {
        var isProd = $window.location.origin.indexOf('localhost') === -1 && $window.location.origin.indexOf('llp.qa') === -1 && ENV === 'prod';

        var willRunProdAnalytics = isProd || !DISABLE_SCRIPTS_ON_QA;
        var sfAnalyticsWebsite = willRunProdAnalytics ? SF_ANALYTICS_WEBSITE_PROD : SF_ANALYTICS_WEBSITE_QA;
        var sfAnalyticsUrl = willRunProdAnalytics ? 'https://uberall.com' : 'https://dev.uberall.com';

        if (sfAnalyticsWebsite) {
            var script = document.createElement('script');
            script.id = 'umami-script';
            script.text = '!function(){"use strict";!function(t){var e=t.screen,n=e.width,r=e.height,a=t.navigator.language,i=t.location,o=t.localStorage,c=t.document,u=t.history,f=i.hostname,s=i.pathname,l=i.search,d=c.currentScript;if(d){var m="data-",v=d.getAttribute.bind(d),h="' + sfAnalyticsWebsite + '",p="' + sfAnalyticsUrl + '",g="false"!==v(m+"auto-track"),y=v(m+"do-not-track"),b=v(m+"domains")||"",S=b.split(",").map(function(t){return t.trim()}),k=(p?p.replace(/\\/$/,""):d.src.split("/").slice(0,-1).join("/"))+"/api/sfanalytics/trckvnt",w=n+"x"+r,N=/data-umami-event-([\\w-_]+)/,T=m+"umami-event",j=300,A=function(t,e,n){var r=t[e];return function(){for(var e=[],a=arguments.length;a--;)e[a]=arguments[a];return n.apply(null,e),r.apply(t,e)}},x=function(){return{website:h,hostname:f,screen:w,language:a,title:M,url:I,referrer:J}},E=function(){return o&&o.getItem("umami.disabled")||y&&(e=t.doNotTrack,n=t.navigator,r=t.external,a="msTrackingProtectionEnabled",i=e||n.doNotTrack||n.msDoNotTrack||r&&a in r&&r[a](),"1"==i||"yes"===i)||b&&!S.includes(f);var e,n,r,a,i},O=function(t,e,n){n&&(J=I,(I=function(t){try{return new URL(t).pathname}catch(e){return t}}(n.toString()))!==J&&setTimeout(D,j))},L=function(t,e){if(void 0===e&&(e="event"),!E()){var n={"Content-Type":"application/json"};return void 0!==K&&(n["x-umami-cache"]=K),fetch(k,{method:"POST",body:JSON.stringify({type:e,payload:t}),headers:n,keepalive:true}).then(function(t){return t.text()}).then(function(t){return K=t}).catch(function(){})}},D=function(t,e){return L("string"==typeof t?Object.assign({},x(),{name:t,data:"object"==typeof e?e:void 0}):"object"==typeof t?t:"function"==typeof t?t(x()):x())};t.umami||(t.umami={track:D,identify:function(t){return L(Object.assign({},x(),{data:t}),"identify")}});var K,P,_,q,C,I=""+s+l,J=c.referrer,M=c.title;if(g&&!E()){u.pushState=A(u,"pushState",O),u.replaceState=A(u,"replaceState",O),C=function(t){var e=t.getAttribute.bind(t),n=e(T);if(n){var r={};return t.getAttributeNames().forEach(function(t){var n=t.match(N);n&&(r[n[1]]=e(t))}),D(n,r)}return Promise.resolve()},c.addEventListener("click",function(t){var e=t.target,n="A"===e.tagName?e:function(t,e){for(var n=t,r=0;r<e;r++){if("A"===n.tagName)return n;if(!(n=n.parentElement))return null}return null}(e,10);if(n){var r=n.href,a="_blank"===n.target||t.ctrlKey||t.shiftKey||t.metaKey||t.button&&1===t.button;if(n.getAttribute(T)&&r)return a||t.preventDefault(),C(n).then(function(){a||(i.href=r)})}else C(e)},!0),_=new MutationObserver(function(t){var e=t[0];M=e&&e.target?e.target.text:void 0}),(q=c.querySelector("head > title"))&&_.observe(q,{subtree:!0,characterData:!0,childList:!0});var R=function(){"complete"!==c.readyState||P||(D(),P=!0)};c.addEventListener("readystatechange",R,!0),R()}}}(window)}();';
            document.head.appendChild(script);
            attachListener();

            function attachListener() {
                document.body.addEventListener('click', function(event) {
                    var element = event.target;
                    while (element && element !== event.currentTarget) {
                        if (element.dataset && element.dataset.sfAnalyticsEvent) {
                            var sfAnalyticsEvent = element.dataset.sfAnalyticsEvent;
                            if (sfAnalyticsEvent) {
                                $window.umami.track(sfAnalyticsEvent);
                                break;
                            }
                        }
                        element = element.parentElement;
                    }
                });
            }
        }
    }
})();
(function () {
  'use strict';
  angular
    .module("storeLocator")
    .factory('RegionService', RegionService);

  function RegionService(DEFAULT_UNIT, storeLocatorCache, GOOGLE_API_KEY, $http, GOOGLE_GEOCODE_URL, STORE_LOCATOR_SEARCH_COUNTRY, mapHelper) {
    const KM_TO_MILES  =  1.60934;

    var regions = {
      //US
      AL: "Alabama",
      AK: "Alaska",
      AS: "American Samoa",
      AZ: "Arizona",
      AR: "Arkansas",
      CA: "California",
      CO: "Colorado",
      CT: "Connecticut",
      DE: "Delaware",
      DC: "District Of Columbia",
      FM: "Federated States Of Micronesia",
      FL: "Florida",
      GA: "Georgia",
      GU: "Guam",
      HI: "Hawaii",
      ID: "Idaho",
      IL: "Illinois",
      IN: "Indiana",
      IA: "Iowa",
      KS: "Kansas",
      KY: "Kentucky",
      LA: "Louisiana",
      ME: "Maine",
      MH: "Marshall Islands",
      MD: "Maryland",
      MA: "Massachusetts",
      MI: "Michigan",
      MN: "Minnesota",
      MS: "Mississippi",
      MO: "Missouri",
      MT: "Montana",
      NE: "Nebraska",
      NV: "Nevada",
      NH: "New Hampshire",
      NJ: "New Jersey",
      NM: "New Mexico",
      NY: "New York",
      NC: "North Carolina",
      ND: "North Dakota",
      MP: "Northern Mariana Islands",
      OH: "Ohio",
      OK: "Oklahoma",
      OR: "Oregon",
      PW: "Palau",
      PA: "Pennsylvania",
      PR: "Puerto Rico",
      RI: "Rhode Island",
      SC: "South Carolina",
      SD: "South Dakota",
      TN: "Tennessee",
      TX: "Texas",
      UT: "Utah",
      VT: "Vermont",
      VI: "Virgin Islands",
      VA: "Virginia",
      WA: "Washington",
      WV: "West Virginia",
      WI: "Wisconsin",
      WY: "Wyoming",
    };

    var countries = {
      "AE": [
        {
          "province": "00",
          "province-name": "Abu Dhabi"
        },
        {
          "province": "01",
          "province-name": "Dubai"
        },
        {
          "province": "02",
          "province-name": "Sharjah"
        },
        {
          "province": "03",
          "province-name": "Umm al Khaimah"
        },
        {
          "province": "04",
          "province-name": "Ajman"
        },
        {
          "province": "05",
          "province-name": "Ras Al Khaimah "
        },
        {
          "province": "06",
          "province-name": "Fujairahß"
        }
      ],
      "AL": [],
      "AR": [
        {
          "province": "00",
          "province-name": "Capital Federal"
        },
        {
          "province": "01",
          "province-name": "Buenos Aires"
        },
        {
          "province": "02",
          "province-name": "Catamarca"
        },
        {
          "province": "03",
          "province-name": "Córdoba"
        },
        {
          "province": "04",
          "province-name": "Corrientes"
        },
        {
          "province": "05",
          "province-name": "Entre Rios"
        },
        {
          "province": "06",
          "province-name": "Jujuy"
        },
        {
          "province": "07",
          "province-name": "Mendoza"
        },
        {
          "province": "08",
          "province-name": "La Rioja"
        },
        {
          "province": "09",
          "province-name": "Salta"
        },
        {
          "province": "10",
          "province-name": "San Juan"
        },
        {
          "province": "11",
          "province-name": "San Luis"
        },
        {
          "province": "12",
          "province-name": "Santa Fé"
        },
        {
          "province": "13",
          "province-name": "Santiago del Estero"
        },
        {
          "province": "14",
          "province-name": "Tucumán"
        },
        {
          "province": "16",
          "province-name": "Chaco"
        },
        {
          "province": "17",
          "province-name": "Chubut"
        },
        {
          "province": "18",
          "province-name": "Formosa"
        },
        {
          "province": "19",
          "province-name": "Misiones"
        },
        {
          "province": "20",
          "province-name": "Neuquen"
        },
        {
          "province": "21",
          "province-name": "La Pampa"
        },
        {
          "province": "22",
          "province-name": "Rio Negro"
        },
        {
          "province": "23",
          "province-name": "Santa Cruz"
        },
        {
          "province": "24",
          "province-name": "Tierra de Fuego"
        }
      ],
      "AT": [
        {
          "province": "B",
          "province-name": "Burgenland"
        },
        {
          "province": "K",
          "province-name": "Carinthia"
        },
        {
          "province": "NÖ",
          "province-name": "Lower Austria"
        },
        {
          "province": "OÖ",
          "province-name": "Upper Austria"
        },
        {
          "province": "S",
          "province-name": "Salzburg"
        },
        {
          "province": "ST",
          "province-name": "Styria"
        },
        {
          "province": "T",
          "province-name": "Tyrol"
        },
        {
          "province": "V",
          "province-name": "Vorarlberg"
        },
        {
          "province": "W",
          "province-name": "Vienna"
        }
      ],
      "AU": [
        {
          "province": "ACT",
          "province-name": "Aust Capital Terr"
        },
        {
          "province": "AC", // to accomodate Dollar/Thrifty bad data
          "province-name": "Aust Capital Terr"
        },
        {
          "province": "NSW",
          "province-name": "New South Wales"
        },
        {
          "province": "NS", // to accomodate Dollar/Thrifty bad data
          "province-name": "New South Wales"
        },
        {
          "province": "NT",
          "province-name": "Northern Territory"
        },
        {
          "province": "QLD",
          "province-name": "Queensland"
        },
        {
          "province": "QL", // to accomodate Dollar/Thrifty bad data
          "province-name": "Queensland"
        },
        {
          "province": "SA",
          "province-name": "South Australia"
        },
        {
          "province": "TAS",
          "province-name": "Tasmania"
        },
        {
          "province": "TS", // to accomodate Dollar/Thrifty bad data
          "province-name": "Tasmania"
        },
        {
          "province": "VIC",
          "province-name": "Victoria"
        },
        {
          "province": "VI", // to accomodate Dollar/Thrifty bad data
          "province-name": "Victoria"
        },
        {
          "province": "WA",
          "province-name": "Western Australia"
        }
      ],
      "BE": [
        {
          "province": "01",
          "province-name": "Antwerp"
        },
        {
          "province": "02",
          "province-name": "Brabant (Flemish)"
        },
        {
          "province": "03",
          "province-name": "Hainaut"
        },
        {
          "province": "04",
          "province-name": "Liege"
        },
        {
          "province": "05",
          "province-name": "Limburg"
        },
        {
          "province": "06",
          "province-name": "Luxembourg"
        },
        {
          "province": "07",
          "province-name": "Namur"
        },
        {
          "province": "08",
          "province-name": "Oost-Vlaanderen"
        },
        {
          "province": "09",
          "province-name": "West-Vlaanderen"
        },
        {
          "province": "10",
          "province-name": "Brabant (Walloon)"
        },
        {
          "province": "11",
          "province-name": "Brussels (Capital)"
        }
      ],
      "BG": [
        {
          "province": "01",
          "province-name": "Burgas"
        },
        {
          "province": "02",
          "province-name": "Grad Sofiya"
        },
        {
          "province": "03",
          "province-name": "Khaskovo"
        },
        {
          "province": "04",
          "province-name": "Lovech"
        },
        {
          "province": "05",
          "province-name": "Montana"
        },
        {
          "province": "06",
          "province-name": "Plovdiv"
        },
        {
          "province": "07",
          "province-name": "Ruse"
        },
        {
          "province": "08",
          "province-name": "Sofiya"
        },
        {
          "province": "09",
          "province-name": "Varna"
        }
      ],
      "BN": [
        {
          "province": "BE",
          "province-name": "Belait"
        },
        {
          "province": "BM",
          "province-name": "Brunei-Muara"
        },
        {
          "province": "TE",
          "province-name": "Temburong"
        },
        {
          "province": "TU",
          "province-name": "Tutong"
        }
      ],
      "BR": [
        {
          "province": "AC",
          "province-name": "Acre"
        },
        {
          "province": "AL",
          "province-name": "Alagoas"
        },
        {
          "province": "AM",
          "province-name": "Amazon"
        },
        {
          "province": "AP",
          "province-name": "Amapá"
        },
        {
          "province": "BA",
          "province-name": "Bahia"
        },
        {
          "province": "CE",
          "province-name": "Ceará"
        },
        {
          "province": "DF",
          "province-name": "Brasília"
        },
        {
          "province": "ES",
          "province-name": "Espírito Santo"
        },
        {
          "province": "GO",
          "province-name": "Goiás"
        },
        {
          "province": "MA",
          "province-name": "Maranhão"
        },
        {
          "province": "MG",
          "province-name": "Minas Gerais"
        },
        {
          "province": "MS",
          "province-name": "Mato Grosso do Sul"
        },
        {
          "province": "MT",
          "province-name": "Mato Grosso"
        },
        {
          "province": "PA",
          "province-name": "Pará"
        },
        {
          "province": "PB",
          "province-name": "Paraíba"
        },
        {
          "province": "PE",
          "province-name": "Pernambuco"
        },
        {
          "province": "PI",
          "province-name": "Piauí"
        },
        {
          "province": "PR",
          "province-name": "Paraná"
        },
        {
          "province": "RJ",
          "province-name": "Rio de Janeiro"
        },
        {
          "province": "RN",
          "province-name": "Rio Grande do Norte"
        },
        {
          "province": "RO",
          "province-name": "Rondônia"
        },
        {
          "province": "RR",
          "province-name": "Roraima"
        },
        {
          "province": "RS",
          "province-name": "Rio Grande do Sul"
        },
        {
          "province": "SC",
          "province-name": "Santa Catarina"
        },
        {
          "province": "SE",
          "province-name": "Sergipe"
        },
        {
          "province": "SP",
          "province-name": "São Paulo"
        },
        {
          "province": "TO",
          "province-name": "Tocantins"
        }
      ],
      "BZ": [
        {
          "province": "BZ",
          "province-name": "Belize"
        },
        {
          "province": "CY",
          "province-name": "Cayo"
        },
        {
          "province": "CZ",
          "province-name": "Corozal"
        },
        {
          "province": "OW",
          "province-name": "Orange Walk"
        },
        {
          "province": "SC",
          "province-name": "Stann Creek"
        },
        {
          "province": "TO",
          "province-name": "Toledo"
        }
      ],
      "CA": [
        {
          "province": "AB",
          "province-name": "Alberta"
        },
        {
          "province": "AL", // to accomodate Dollar/Thrifty bad data
          "province-name": "Alberta"
        },
        {
          "province": "BC",
          "province-name": "British Columbia"
        },
        {
          "province": "MB",
          "province-name": "Manitoba"
        },
        {
          "province": "MN", // to accomodate Dollar/Thrifty bad data
          "province-name": "Manitoba"
        },
        {
          "province": "NB",
          "province-name": "New Brunswick"
        },
        {
          "province": "NE",
          "province-name": "ACS Legacy"
        },
        {
          "province": "NF",
          "province-name": "Newfoundland (old)"
        },
        {
          "province": "NL",
          "province-name": "Newfoundland & Labr."
        },
        {
          "province": "NS",
          "province-name": "Nova Scotia"
        },
        {
          "province": "NT",
          "province-name": "Northwest Terr."
        },
        {
          "province": "NU",
          "province-name": "Nunavut"
        },
        {
          "province": "ON",
          "province-name": "Ontario"
        },
        {
          "province": "OT", // to accomodate Dollar/Thrifty bad data
          "province-name": "Ontario"
        },
        {
          "province": "PE",
          "province-name": "Prince Edward Island"
        },
        {
          "province": "PQ",
          "province-name": "ACS Legacy"
        },
        {
          "province": "QC",
          "province-name": "Quebec"
        },
        {
          "province": "QU", // to accomodate Dollar/Thrifty bad data
          "province-name": "Quebec"
        },
        {
          "province": "SK",
          "province-name": "Saskatchewan"
        },
        {
          "province": "SA", // to accomodate Dollar/Thrifty bad data
          "province-name": "Saskatchewan"
        },
        {
          "province": "YT",
          "province-name": "Yukon Territory"
        }
      ],
      "CH": [
        {
          "province": "AG",
          "province-name": "Aargau"
        },
        {
          "province": "AI",
          "province-name": "Inner-Rhoden"
        },
        {
          "province": "AR",
          "province-name": "Ausser-Rhoden"
        },
        {
          "province": "BE",
          "province-name": "Bern"
        },
        {
          "province": "BL",
          "province-name": "Basel Land"
        },
        {
          "province": "BS",
          "province-name": "Basel Stadt"
        },
        {
          "province": "FR",
          "province-name": "Fribourg"
        },
        {
          "province": "GE",
          "province-name": "Geneva"
        },
        {
          "province": "GL",
          "province-name": "Glarus"
        },
        {
          "province": "GR",
          "province-name": "Graubuenden"
        },
        {
          "province": "JU",
          "province-name": "Jura"
        },
        {
          "province": "LU",
          "province-name": "Lucerne"
        },
        {
          "province": "NE",
          "province-name": "Neuchatel"
        },
        {
          "province": "NW",
          "province-name": "Nidwalden"
        },
        {
          "province": "OW",
          "province-name": "Obwalden"
        },
        {
          "province": "SG",
          "province-name": "St. Gallen"
        },
        {
          "province": "SH",
          "province-name": "Schaffhausen"
        },
        {
          "province": "SO",
          "province-name": "Solothurn"
        },
        {
          "province": "SZ",
          "province-name": "Schwyz"
        },
        {
          "province": "TG",
          "province-name": "Thurgau"
        },
        {
          "province": "TI",
          "province-name": "Ticino"
        },
        {
          "province": "UR",
          "province-name": "Uri"
        },
        {
          "province": "VD",
          "province-name": "Vaud"
        },
        {
          "province": "VS",
          "province-name": "Valais"
        },
        {
          "province": "ZG",
          "province-name": "Zug"
        },
        {
          "province": "ZH",
          "province-name": "Zurich"
        }
      ],
      "CL": [
        {
          "province": "01",
          "province-name": "I - Iquique"
        },
        {
          "province": "02",
          "province-name": "II - Antofagasta"
        },
        {
          "province": "03",
          "province-name": "III - Copiapo"
        },
        {
          "province": "04",
          "province-name": "IV - La Serena"
        },
        {
          "province": "05",
          "province-name": "V - Valparaiso"
        },
        {
          "province": "06",
          "province-name": "VI - Rancagua"
        },
        {
          "province": "07",
          "province-name": "VII - Talca"
        },
        {
          "province": "08",
          "province-name": "VIII - Concepción"
        },
        {
          "province": "09",
          "province-name": "IX - Temuco"
        },
        {
          "province": "10",
          "province-name": "X - Puerto Montt"
        },
        {
          "province": "11",
          "province-name": "XI - Coyhaique"
        },
        {
          "province": "12",
          "province-name": "XII - Punta Arenas"
        },
        {
          "province": "13",
          "province-name": "RM - Santiago"
        }
      ],
      "CN": [
        {
          "province": "010",
          "province-name": "Beijing"
        },
        {
          "province": "020",
          "province-name": "Shanghai"
        },
        {
          "province": "030",
          "province-name": "Tianjin"
        },
        {
          "province": "040",
          "province-name": "Nei Mongol"
        },
        {
          "province": "050",
          "province-name": "Shanxi"
        },
        {
          "province": "060",
          "province-name": "Hebei"
        },
        {
          "province": "070",
          "province-name": "Liaoning"
        },
        {
          "province": "080",
          "province-name": "Jilin"
        },
        {
          "province": "090",
          "province-name": "Heilongjiang"
        },
        {
          "province": "100",
          "province-name": "Jiangsu"
        },
        {
          "province": "110",
          "province-name": "Anhui"
        },
        {
          "province": "120",
          "province-name": "Shandong"
        },
        {
          "province": "130",
          "province-name": "Zhejiang"
        },
        {
          "province": "140",
          "province-name": "Jiangxi"
        },
        {
          "province": "150",
          "province-name": "Fujian"
        },
        {
          "province": "160",
          "province-name": "Hunan"
        },
        {
          "province": "170",
          "province-name": "Hubei"
        },
        {
          "province": "180",
          "province-name": "Henan"
        },
        {
          "province": "190",
          "province-name": "Guangdong"
        },
        {
          "province": "200",
          "province-name": "Hainan"
        },
        {
          "province": "210",
          "province-name": "Guangxi"
        },
        {
          "province": "220",
          "province-name": "Guizhou"
        },
        {
          "province": "230",
          "province-name": "Sichuan"
        },
        {
          "province": "240",
          "province-name": "Yunnan"
        },
        {
          "province": "250",
          "province-name": "Shaanxi"
        },
        {
          "province": "260",
          "province-name": "Gansu"
        },
        {
          "province": "270",
          "province-name": "Ningxia"
        },
        {
          "province": "280",
          "province-name": "Qinghai"
        },
        {
          "province": "290",
          "province-name": "Xinjiang"
        },
        {
          "province": "300",
          "province-name": "Xizang"
        },
        {
          "province": "310",
          "province-name": "Taiwan"
        }
      ],
      "CO": [
        {
          "province": "05",
          "province-name": "ANTIOQUIA"
        },
        {
          "province": "08",
          "province-name": "ATLANTICO"
        },
        {
          "province": "11",
          "province-name": "BOGOTA"
        },
        {
          "province": "13",
          "province-name": "BOLIVAR"
        },
        {
          "province": "15",
          "province-name": "BOYACA"
        },
        {
          "province": "17",
          "province-name": "CALDAS"
        },
        {
          "province": "18",
          "province-name": "CAQUETA"
        },
        {
          "province": "19",
          "province-name": "CAUCA"
        },
        {
          "province": "20",
          "province-name": "CESAR"
        },
        {
          "province": "23",
          "province-name": "CORDOBA"
        },
        {
          "province": "25",
          "province-name": "CUNDINAMARCA"
        },
        {
          "province": "27",
          "province-name": "CHOCO"
        },
        {
          "province": "41",
          "province-name": "HUILA"
        },
        {
          "province": "44",
          "province-name": "LA GUAJIRA"
        },
        {
          "province": "47",
          "province-name": "MAGDALENA"
        },
        {
          "province": "50",
          "province-name": "META"
        },
        {
          "province": "52",
          "province-name": "NARIÑO"
        },
        {
          "province": "54",
          "province-name": "NORTE SANTANDER"
        },
        {
          "province": "63",
          "province-name": "QUINDIO"
        },
        {
          "province": "66",
          "province-name": "RISARALDA"
        },
        {
          "province": "68",
          "province-name": "SANTANDER"
        },
        {
          "province": "70",
          "province-name": "SUCRE"
        },
        {
          "province": "73",
          "province-name": "TOLIMA"
        },
        {
          "province": "76",
          "province-name": "VALLE"
        },
        {
          "province": "81",
          "province-name": "ARAUCA"
        },
        {
          "province": "85",
          "province-name": "CASANARE"
        },
        {
          "province": "86",
          "province-name": "PUTUMAYO"
        },
        {
          "province": "88",
          "province-name": "SAN ANDRES"
        },
        {
          "province": "91",
          "province-name": "AMAZONAS"
        },
        {
          "province": "94",
          "province-name": "GUAINIA"
        },
        {
          "province": "95",
          "province-name": "GUAVIARE"
        },
        {
          "province": "97",
          "province-name": "VAUPES"
        },
        {
          "province": "99",
          "province-name": "VICHADA"
        }
      ],
      "CR": [
        {
          "province": "01",
          "province-name": "San Jose"
        },
        {
          "province": "02",
          "province-name": "Heredia"
        },
        {
          "province": "03",
          "province-name": "Alajuela"
        },
        {
          "province": "04",
          "province-name": "Cartago"
        },
        {
          "province": "05",
          "province-name": "Puntarenas"
        },
        {
          "province": "06",
          "province-name": "Guanacaste"
        },
        {
          "province": "07",
          "province-name": "Guanacaste"
        },
      ],
      "CZ": [
        {
          "province": "01",
          "province-name": "Jihocesky"
        },
        {
          "province": "31",
          "province-name": "Jihočeský"
        },
        {
          "province": "02",
          "province-name": "Jihomoravsky"
        },
        {
          "province": "64",
          "province-name": "Jihomoravský"
        },
        {
          "province": "03",
          "province-name": "Praha"
        },
        {
          "province": "04",
          "province-name": "Severocesky"
        },
        {
          "province": "05",
          "province-name": "Severomoravsky"
        },
        {
          "province": "06",
          "province-name": "Stredocesky"
        },
        {
          "province": "07",
          "province-name": "Vychodocesky"
        },
        {
          "province": "08",
          "province-name": "Zapadocesky"
        },
        {
          "province": "20",
          "province-name": "Středočeský"
        },
        {
          "province": "41",
          "province-name": "Karlovarský"
        },
        {
          "province": "52",
          "province-name": "Královéhradecký"
        },
        {
          "province": "51",
          "province-name": "Liberecký"
        },
        {
          "province": "80",
          "province-name": "Moravskoslezský"
        },
        {
          "province": "71",
          "province-name": "Olomoucký"
        },
        {
          "province": "53",
          "province-name": "Pardubický"
        },
        {
          "province": "32",
          "province-name": "Plzeňský"
        },
        {
          "province": "10",
          "province-name": "Praha"
        },
        {
          "province": "42",
          "province-name": "Ústecký"
        },
        {
          "province": "63",
          "province-name": "Kraj Vysočina"
        },
        {
          "province": "72",
          "province-name": "Zlínský"
        }
      ],
      "DE": [
        {
          "province": "01",
          "province-name": "Schleswig-Holstein"
        },
        {
          "province": "02",
          "province-name": "Hamburg"
        },
        {
          "province": "03",
          "province-name": "Lower Saxony"
        },
        {
          "province": "04",
          "province-name": "Bremen"
        },
        {
          "province": "05",
          "province-name": "Nrth Rhine Westfalia"
        },
        {
          "province": "06",
          "province-name": "Hesse"
        },
        {
          "province": "07",
          "province-name": "Rhineland Palatinate"
        },
        {
          "province": "08",
          "province-name": "Baden-Wurttemberg"
        },
        {
          "province": "09",
          "province-name": "Bavaria"
        },
        {
          "province": "10",
          "province-name": "Saarland"
        },
        {
          "province": "11",
          "province-name": "Berlin"
        },
        {
          "province": "12",
          "province-name": "Brandenburg"
        },
        {
          "province": "13",
          "province-name": "Mecklenburg-Vorpomm."
        },
        {
          "province": "14",
          "province-name": "Saxony"
        },
        {
          "province": "15",
          "province-name": "Saxony-Anhalt"
        },
        {
          "province": "16",
          "province-name": "Thuringia"
        }
      ],
      "DK": [
        {
          "province": "001",
          "province-name": "Copenhagen"
        },
        {
          "province": "002",
          "province-name": "Århus amt"
        },
        {
          "province": "003",
          "province-name": "Bornholm amt"
        },
        {
          "province": "004",
          "province-name": "Frederiksborg amt"
        },
        {
          "province": "005",
          "province-name": "Fyn amt"
        },
        {
          "province": "006",
          "province-name": "København amt"
        },
        {
          "province": "007",
          "province-name": "Nordjylland amt"
        },
        {
          "province": "008",
          "province-name": "Ribe amt"
        },
        {
          "province": "009",
          "province-name": "Ringkøbing amt"
        },
        {
          "province": "010",
          "province-name": "Roskilde amt"
        },
        {
          "province": "011",
          "province-name": "Sønderjylland amt"
        },
        {
          "province": "012",
          "province-name": "Storstrøm amt"
        },
        {
          "province": "013",
          "province-name": "Vejle amt"
        },
        {
          "province": "014",
          "province-name": "Vestsjælland amt"
        },
        {
          "province": "015",
          "province-name": "Viborg amt"
        },
        {
          "province": "016",
          "province-name": "Grønlands amt"
        }
      ],
      "DO": [],
      "ES": [
        {
          "province": "01",
          "province-name": "Alava"
        },
        {
          "province": "02",
          "province-name": "Albacete"
        },
        {
          "province": "03",
          "province-name": "Alicante"
        },
        {
          "province": "04",
          "province-name": "Almeria"
        },
        {
          "province": "05",
          "province-name": "Avila"
        },
        {
          "province": "06",
          "province-name": "Badajoz"
        },
        {
          "province": "07",
          "province-name": "Baleares"
        },
        {
          "province": "08",
          "province-name": "Barcelona"
        },
        {
          "province": "09",
          "province-name": "Burgos"
        },
        {
          "province": "10",
          "province-name": "Caceres"
        },
        {
          "province": "11",
          "province-name": "Cadiz"
        },
        {
          "province": "12",
          "province-name": "Castellon"
        },
        {
          "province": "13",
          "province-name": "Ciudad Real"
        },
        {
          "province": "14",
          "province-name": "Córdoba"
        },
        {
          "province": "15",
          "province-name": "La Coruña"
        },
        {
          "province": "16",
          "province-name": "Cuenca"
        },
        {
          "province": "17",
          "province-name": "Gerona"
        },
        {
          "province": "18",
          "province-name": "Granada"
        },
        {
          "province": "19",
          "province-name": "Guadalajara"
        },
        {
          "province": "20",
          "province-name": "Guipuzcoa"
        },
        {
          "province": "21",
          "province-name": "Huelva"
        },
        {
          "province": "22",
          "province-name": "Huesca"
        },
        {
          "province": "23",
          "province-name": "Jaen"
        },
        {
          "province": "24",
          "province-name": "Leon"
        },
        {
          "province": "25",
          "province-name": "Lerida"
        },
        {
          "province": "26",
          "province-name": "La Rioja"
        },
        {
          "province": "27",
          "province-name": "Lugo"
        },
        {
          "province": "28",
          "province-name": "Madrid"
        },
        {
          "province": "M", // to accomodate Dollar/Thrifty bad data
          "province-name": "Madrid"
        },
        {
          "province": "29",
          "province-name": "Malaga"
        },
        {
          "province": "30",
          "province-name": "Murcia"
        },
        {
          "province": "31",
          "province-name": "Navarra"
        },
        {
          "province": "32",
          "province-name": "Orense"
        },
        {
          "province": "33",
          "province-name": "Asturias"
        },
        {
          "province": "34",
          "province-name": "Palencia"
        },
        {
          "province": "35",
          "province-name": "Las Palmas"
        },
        {
          "province": "36",
          "province-name": "Pontevedra"
        },
        {
          "province": "37",
          "province-name": "Salamanca"
        },
        {
          "province": "38",
          "province-name": "Sta. Cruz Tenerife"
        },
        {
          "province": "39",
          "province-name": "Cantabria"
        },
        {
          "province": "40",
          "province-name": "Segovia"
        },
        {
          "province": "41",
          "province-name": "Sevilla"
        },
        {
          "province": "42",
          "province-name": "Soria"
        },
        {
          "province": "43",
          "province-name": "Tarragona"
        },
        {
          "province": "44",
          "province-name": "Teruel"
        },
        {
          "province": "45",
          "province-name": "Toledo"
        },
        {
          "province": "46",
          "province-name": "Valencia"
        },
        {
          "province": "47",
          "province-name": "Valladolid"
        },
        {
          "province": "48",
          "province-name": "Vizcaya"
        },
        {
          "province": "49",
          "province-name": "Zamora"
        },
        {
          "province": "50",
          "province-name": "Zaragoza"
        }
      ],
      "FI": [
        {
          "province": "001",
          "province-name": "Ahvenanmaa"
        },
        {
          "province": "002",
          "province-name": "Etelä-Suomi"
        },
        {
          "province": "003",
          "province-name": "Itä-Suomi"
        },
        {
          "province": "004",
          "province-name": "Lappi"
        },
        {
          "province": "FI", // to accomodate Dollar/Thrifty bad data
          "province-name": "Lappi"
        },
        {
          "province": "005",
          "province-name": "Länsi-Suomi"
        },
        {
          "province": "006",
          "province-name": "Oulu"
        }
      ],
      "FR": [
        {
          "province": "01",
          "province-name": "Ain"
        },
        {
          "province": "02",
          "province-name": "Aisne"
        },
        {
          "province": "03",
          "province-name": "Allier"
        },
        {
          "province": "04",
          "province-name": "Alpes (Hte-Provence)"
        },
        {
          "province": "05",
          "province-name": "Alpes (Hautes)"
        },
        {
          "province": "06",
          "province-name": "Alpes-Maritimes"
        },
        {
          "province": "07",
          "province-name": "Ardèche"
        },
        {
          "province": "08",
          "province-name": "Ardennes"
        },
        {
          "province": "09",
          "province-name": "Ariège"
        },
        {
          "province": "10",
          "province-name": "Aube"
        },
        {
          "province": "11",
          "province-name": "Aude"
        },
        {
          "province": "12",
          "province-name": "Aveyron"
        },
        {
          "province": "13",
          "province-name": "Bouches-du-Rhône"
        },
        {
          "province": "14",
          "province-name": "Calvados"
        },
        {
          "province": "15",
          "province-name": "Cantal"
        },
        {
          "province": "16",
          "province-name": "Charente"
        },
        {
          "province": "17",
          "province-name": "Charente-Maritime"
        },
        {
          "province": "18",
          "province-name": "Cher"
        },
        {
          "province": "19",
          "province-name": "Corrèze"
        },
        {
          "province": "21",
          "province-name": "Côte-d'Or"
        },
        {
          "province": "22",
          "province-name": "Côtes-d'Armor"
        },
        {
          "province": "23",
          "province-name": "Creuse"
        },
        {
          "province": "24",
          "province-name": "Dordogne"
        },
        {
          "province": "25",
          "province-name": "Doubs"
        },
        {
          "province": "26",
          "province-name": "Drôme"
        },
        {
          "province": "27",
          "province-name": "Eure"
        },
        {
          "province": "28",
          "province-name": "Eure-et-Loir"
        },
        {
          "province": "29",
          "province-name": "Finistère"
        },
        {
          "province": "2A",
          "province-name": "Corse-du-Sud"
        },
        {
          "province": "2B",
          "province-name": "Corse-du-Nord"
        },
        {
          "province": "30",
          "province-name": "Gard"
        },
        {
          "province": "31",
          "province-name": "Garonne (Haute)"
        },
        {
          "province": "32",
          "province-name": "Gers"
        },
        {
          "province": "33",
          "province-name": "Gironde"
        },
        {
          "province": "34",
          "province-name": "Hérault"
        },
        {
          "province": "35",
          "province-name": "Ille-et-Vilaine"
        },
        {
          "province": "36",
          "province-name": "Indre"
        },
        {
          "province": "37",
          "province-name": "Indre-et-Loire"
        },
        {
          "province": "38",
          "province-name": "Isère"
        },
        {
          "province": "39",
          "province-name": "Jura"
        },
        {
          "province": "40",
          "province-name": "Landes"
        },
        {
          "province": "41",
          "province-name": "Loir-et-Cher"
        },
        {
          "province": "42",
          "province-name": "Loire"
        },
        {
          "province": "43",
          "province-name": "Loire (Haute)"
        },
        {
          "province": "44",
          "province-name": "Loire-Atlantique"
        },
        {
          "province": "45",
          "province-name": "Loiret"
        },
        {
          "province": "46",
          "province-name": "Lot"
        },
        {
          "province": "47",
          "province-name": "Lot-et-Garonne"
        },
        {
          "province": "48",
          "province-name": "Lozère"
        },
        {
          "province": "49",
          "province-name": "Maine-et-Loire"
        },
        {
          "province": "50",
          "province-name": "Manche"
        },
        {
          "province": "51",
          "province-name": "Marne"
        },
        {
          "province": "52",
          "province-name": "Marne (Haute)"
        },
        {
          "province": "53",
          "province-name": "Mayenne"
        },
        {
          "province": "54",
          "province-name": "Meurthe-et-Moselle"
        },
        {
          "province": "55",
          "province-name": "Meuse"
        },
        {
          "province": "56",
          "province-name": "Morbihan"
        },
        {
          "province": "57",
          "province-name": "Moselle"
        },
        {
          "province": "58",
          "province-name": "Nièvre"
        },
        {
          "province": "59",
          "province-name": "Nord"
        },
        {
          "province": "60",
          "province-name": "Oise"
        },
        {
          "province": "61",
          "province-name": "Orne"
        },
        {
          "province": "62",
          "province-name": "Pas-de-Calais"
        },
        {
          "province": "63",
          "province-name": "Puy-de-Dôme"
        },
        {
          "province": "64",
          "province-name": "Pyrénées-Atlantiques"
        },
        {
          "province": "65",
          "province-name": "Pyrénées (Hautes)"
        },
        {
          "province": "66",
          "province-name": "Pyrénées-Orientales"
        },
        {
          "province": "67",
          "province-name": "Bas-Rhin"
        },
        {
          "province": "68",
          "province-name": "Haut-Rhin"
        },
        {
          "province": "69",
          "province-name": "Rhône"
        },
        {
          "province": "70",
          "province-name": "Saône (Haute)"
        },
        {
          "province": "71",
          "province-name": "Saône-et-Loire"
        },
        {
          "province": "72",
          "province-name": "Sarthe"
        },
        {
          "province": "73",
          "province-name": "Savoie"
        },
        {
          "province": "74",
          "province-name": "Savoie (Haute)"
        },
        {
          "province": "75",
          "province-name": "Paris"
        },
        {
          "province": "76",
          "province-name": "Seine-Maritime"
        },
        {
          "province": "77",
          "province-name": "Seine-et-Marne"
        },
        {
          "province": "78",
          "province-name": "Yvelines"
        },
        {
          "province": "79",
          "province-name": "Sèvres (Deux)"
        },
        {
          "province": "80",
          "province-name": "Somme"
        },
        {
          "province": "81",
          "province-name": "Tarn"
        },
        {
          "province": "82",
          "province-name": "Tarn-et-Garonne"
        },
        {
          "province": "83",
          "province-name": "Var"
        },
        {
          "province": "84",
          "province-name": "Vaucluse"
        },
        {
          "province": "85",
          "province-name": "Vendée"
        },
        {
          "province": "86",
          "province-name": "Vienne"
        },
        {
          "province": "87",
          "province-name": "Vienne (Haute)"
        },
        {
          "province": "88",
          "province-name": "Vosges"
        },
        {
          "province": "89",
          "province-name": "Yonne"
        },
        {
          "province": "90",
          "province-name": "Territ.-de-Belfort"
        },
        {
          "province": "91",
          "province-name": "Essonne"
        },
        {
          "province": "92",
          "province-name": "Hauts-de-Seine"
        },
        {
          "province": "93",
          "province-name": "Seine-Saint-Denis"
        },
        {
          "province": "94",
          "province-name": "Val-de-Marne"
        },
        {
          "province": "95",
          "province-name": "Val-d'Oise"
        },
        {
          "province": "97",
          "province-name": "D.O.M.-T.O.M."
        },
        {
          "province": "971",
          "province-name": "Guadeloupe"
        },
        {
          "province": "972",
          "province-name": "Martinique"
        },
        {
          "province": "973",
          "province-name": "Guyane"
        },
        {
          "province": "974",
          "province-name": "Réunion"
        },
        {
          "province": "975",
          "province-name": "Saint-Pierre-et-Miq."
        },
        {
          "province": "976",
          "province-name": "Wallis-et-Futuna"
        },
        {
          "province": "99",
          "province-name": "Hors-France"
        }
      ],
      "UK": [
        {
          "province": "AM",
          "province-name": "Armagh"
        },
        {
          "province": "AR",
          "province-name": "Ards"
        },
        {
          "province": "AT",
          "province-name": "Antrim"
        },
        {
          "province": "BA",
          "province-name": "Ballymena"
        },
        {
          "province": "BB",
          "province-name": "Blackburn"
        },
        {
          "province": "BE",
          "province-name": "Bedfordshire"
        },
        {
          "province": "BF",
          "province-name": "Bracknell Forest"
        },
        {
          "province": "BH",
          "province-name": "Brighton & Hove"
        },
        {
          "province": "BK",
          "province-name": "Berkshire"
        },
        {
          "province": "BL",
          "province-name": "Belfast"
        },
        {
          "province": "BM",
          "province-name": "Bournemouth"
        },
        {
          "province": "BN",
          "province-name": "Banbridge"
        },
        {
          "province": "BO",
          "province-name": "Borders"
        },
        {
          "province": "BP",
          "province-name": "Blackpool"
        },
        {
          "province": "BR",
          "province-name": "Bristol"
        },
        {
          "province": "BS",
          "province-name": "Bath&NthEstSomerset"
        },
        {
          "province": "BU",
          "province-name": "Buckinghamshire"
        },
        {
          "province": "BY",
          "province-name": "Ballymoney"
        },
        {
          "province": "CA",
          "province-name": "Cambridgeshire"
        },
        {
          "province": "CE",
          "province-name": "Central"
        },
        {
          "province": "CG",
          "province-name": "Craigavon"
        },
        {
          "province": "CH",
          "province-name": "Cheshire"
        },
        {
          "province": "CI",
          "province-name": "Coleraine"
        },
        {
          "province": "CK",
          "province-name": "Cookstown"
        },
        {
          "province": "CL",
          "province-name": "Clwyd"
        },
        {
          "province": "CO",
          "province-name": "Cornwall"
        },
        {
          "province": "CR",
          "province-name": "Carrickfergus"
        },
        {
          "province": "CS",
          "province-name": "Castlereagh"
        },
        {
          "province": "CU",
          "province-name": "Cumbria"
        },
        {
          "province": "CV",
          "province-name": "Cleveland"
        },
        {
          "province": "DB",
          "province-name": "Derbyshire"
        },
        {
          "province": "DF",
          "province-name": "Dumfries a. Galloway"
        },
        {
          "province": "DG",
          "province-name": "Dungannon"
        },
        {
          "province": "DL",
          "province-name": "Darlington"
        },
        {
          "province": "DN",
          "province-name": "Down"
        },
        {
          "province": "DO",
          "province-name": "Dorset"
        },
        {
          "province": "DU",
          "province-name": "Durham"
        },
        {
          "province": "DV",
          "province-name": "Devon"
        },
        {
          "province": "DY",
          "province-name": "Dyfed"
        },
        {
          "province": "ER",
          "province-name": "East Riding"
        },
        {
          "province": "ES",
          "province-name": "Essex"
        },
        {
          "province": "FI",
          "province-name": "Fife"
        },
        {
          "province": "FM",
          "province-name": "Fermanagh"
        },
        {
          "province": "GL",
          "province-name": "Gloucestershire"
        },
        {
          "province": "GM",
          "province-name": "Greater Manchester"
        },
        {
          "province": "GR",
          "province-name": "Grampian"
        },
        {
          "province": "GS",
          "province-name": "Sth. Gloucestershire"
        },
        {
          "province": "GW",
          "province-name": "Gwent"
        },
        {
          "province": "GY",
          "province-name": "Gwynedd"
        },
        {
          "province": "HA",
          "province-name": "Hampshire"
        },
        {
          "province": "HI",
          "province-name": "Highland"
        },
        {
          "province": "HL",
          "province-name": "Halton"
        },
        {
          "province": "HR",
          "province-name": "Hartlepool"
        },
        {
          "province": "HT",
          "province-name": "Hertfordshire"
        },
        {
          "province": "HW",
          "province-name": "Hereford and Worcs."
        },
        {
          "province": "IW",
          "province-name": "Isle of Wight"
        },
        {
          "province": "KE",
          "province-name": "Kent"
        },
        {
          "province": "KH",
          "province-name": "Kingston-upon-Hull"
        },
        {
          "province": "LA",
          "province-name": "Lancashire"
        },
        {
          "province": "LC",
          "province-name": "Leicester City"
        },
        {
          "province": "LD",
          "province-name": "Londonderry"
        },
        {
          "province": "LE",
          "province-name": "Leicestershire"
        },
        {
          "province": "LI",
          "province-name": "Lincolnshire"
        },
        {
          "province": "LM",
          "province-name": "Limavady"
        },
        {
          "province": "LO",
          "province-name": "Greater London"
        },
        {
          "province": "LR",
          "province-name": "Larne"
        },
        {
          "province": "LS",
          "province-name": "Lisburn"
        },
        {
          "province": "LT",
          "province-name": "Lothian"
        },
        {
          "province": "LU",
          "province-name": "Luton"
        },
        {
          "province": "MA",
          "province-name": "Magherafelt"
        },
        {
          "province": "MG",
          "province-name": "Mid Glamorgan"
        },
        {
          "province": "MI",
          "province-name": "Middlesbrough"
        },
        {
          "province": "MK",
          "province-name": "Milton Keynes"
        },
        {
          "province": "MO",
          "province-name": "Moyle"
        },
        {
          "province": "MY",
          "province-name": "Merseyside"
        },
        {
          "province": "NA",
          "province-name": "Newtownabbey"
        },
        {
          "province": "NB",
          "province-name": "Newbury"
        },
        {
          "province": "NC",
          "province-name": "Nottingham City"
        },
        {
          "province": "ND",
          "province-name": "North Down"
        },
        {
          "province": "NE",
          "province-name": "NthEast Lincolnshire"
        },
        {
          "province": "NH",
          "province-name": "Northamptonshire"
        },
        {
          "province": "NK",
          "province-name": "Norfolk"
        },
        {
          "province": "NL",
          "province-name": "North Lincolnshire"
        },
        {
          "province": "NM",
          "province-name": "Newry and Mourne"
        },
        {
          "province": "NS",
          "province-name": "North Somerset"
        },
        {
          "province": "NT",
          "province-name": "Nottinghamshire"
        },
        {
          "province": "NU",
          "province-name": "Northumberland"
        },
        {
          "province": "OM",
          "province-name": "Omagh"
        },
        {
          "province": "OR",
          "province-name": "Orkney"
        },
        {
          "province": "OX",
          "province-name": "Oxfordshire"
        },
        {
          "province": "PB",
          "province-name": "Peterborough"
        },
        {
          "province": "PL",
          "province-name": "Poole"
        },
        {
          "province": "PM",
          "province-name": "Portsmouth"
        },
        {
          "province": "PO",
          "province-name": "Powys"
        },
        {
          "province": "PY",
          "province-name": "Plymouth"
        },
        {
          "province": "RD",
          "province-name": "Redcar and Cleveland"
        },
        {
          "province": "RE",
          "province-name": "Reading"
        },
        {
          "province": "RM",
          "province-name": "Rochester up. Medway"
        },
        {
          "province": "RU",
          "province-name": "Rutland"
        },
        {
          "province": "SC",
          "province-name": "Strathclyde"
        },
        {
          "province": "SD",
          "province-name": "Southend"
        },
        {
          "province": "SE",
          "province-name": "East Sussex"
        },
        {
          "province": "SG",
          "province-name": "South Glamorgan"
        },
        {
          "province": "SH",
          "province-name": "Shropshire"
        },
        {
          "province": "SK",
          "province-name": "Suffolk"
        },
        {
          "province": "SL",
          "province-name": "Shetland"
        },
        {
          "province": "SN",
          "province-name": "Stockton-on-Tees"
        },
        {
          "province": "SO",
          "province-name": "Somerset"
        },
        {
          "province": "SP",
          "province-name": "Southampton"
        },
        {
          "province": "SR",
          "province-name": "Strabane"
        },
        {
          "province": "ST",
          "province-name": "Staffordshire"
        },
        {
          "province": "SU",
          "province-name": "Slough"
        },
        {
          "province": "SW",
          "province-name": "West Sussex"
        },
        {
          "province": "SY",
          "province-name": "Surrey"
        },
        {
          "province": "TA",
          "province-name": "Tayside"
        },
        {
          "province": "TD",
          "province-name": "Thamesdown"
        },
        {
          "province": "TH",
          "province-name": "Thurrock"
        },
        {
          "province": "TO",
          "province-name": "Torbay"
        },
        {
          "province": "TW",
          "province-name": "Tyne and Wear"
        },
        {
          "province": "WA",
          "province-name": "Warwickshire"
        },
        {
          "province": "WD",
          "province-name": "Windsor & Maidenhead"
        },
        {
          "province": "WG",
          "province-name": "West Glamorgan"
        },
        {
          "province": "WI",
          "province-name": "Wiltshire"
        },
        {
          "province": "WL",
          "province-name": "Western Isles"
        },
        {
          "province": "WM",
          "province-name": "West Midlands"
        },
        {
          "province": "WO",
          "province-name": "Wokingham"
        },
        {
          "province": "WR",
          "province-name": "Wrekin"
        },
        {
          "province": "WT",
          "province-name": "Warrington"
        },
        {
          "province": "YK",
          "province-name": "York"
        },
        {
          "province": "YN",
          "province-name": "North Yorkshire"
        },
        {
          "province": "YS",
          "province-name": "South Yorkshire"
        },
        {
          "province": "YW",
          "province-name": "West Yorkshire"
        }
      ],
      "GR": [
        {
          "province": "01",
          "province-name": "Aitolia kai Akarnan."
        },
        {
          "province": "02",
          "province-name": "Akhaia"
        },
        {
          "province": "03",
          "province-name": "Argolis"
        },
        {
          "province": "04",
          "province-name": "Arkadhia"
        },
        {
          "province": "05",
          "province-name": "Arta"
        },
        {
          "province": "06",
          "province-name": "Attiki"
        },
        {
          "province": "07",
          "province-name": "Dhodhekanisos"
        },
        {
          "province": "08",
          "province-name": "Dhrama"
        },
        {
          "province": "09",
          "province-name": "Evritania"
        },
        {
          "province": "10",
          "province-name": "Evros"
        },
        {
          "province": "11",
          "province-name": "Evvoia"
        },
        {
          "province": "12",
          "province-name": "Florina"
        },
        {
          "province": "13",
          "province-name": "Fokis"
        },
        {
          "province": "14",
          "province-name": "Fthiotis"
        },
        {
          "province": "15",
          "province-name": "Grevena"
        },
        {
          "province": "16",
          "province-name": "Ilia"
        },
        {
          "province": "17",
          "province-name": "Imathia"
        },
        {
          "province": "18",
          "province-name": "Ioannina"
        },
        {
          "province": "19",
          "province-name": "Iraklion"
        },
        {
          "province": "20",
          "province-name": "Kardhitsa"
        },
        {
          "province": "21",
          "province-name": "Kastoria"
        },
        {
          "province": "22",
          "province-name": "Kavala"
        },
        {
          "province": "23",
          "province-name": "Kefallinia"
        },
        {
          "province": "24",
          "province-name": "Kerkira"
        },
        {
          "province": "25",
          "province-name": "Khalkidhiki"
        },
        {
          "province": "26",
          "province-name": "Khania"
        },
        {
          "province": "27",
          "province-name": "Khios"
        },
        {
          "province": "28",
          "province-name": "Kikladhes"
        },
        {
          "province": "29",
          "province-name": "Kilkis"
        },
        {
          "province": "30",
          "province-name": "Korinthia"
        },
        {
          "province": "31",
          "province-name": "Kozani"
        },
        {
          "province": "32",
          "province-name": "Lakonia"
        },
        {
          "province": "33",
          "province-name": "Larisa"
        },
        {
          "province": "34",
          "province-name": "Lasithi"
        },
        {
          "province": "35",
          "province-name": "Lesvos"
        },
        {
          "province": "36",
          "province-name": "Levkas"
        },
        {
          "province": "37",
          "province-name": "Magnisia"
        },
        {
          "province": "38",
          "province-name": "Messinia"
        },
        {
          "province": "39",
          "province-name": "Pella"
        },
        {
          "province": "40",
          "province-name": "Pieria"
        },
        {
          "province": "41",
          "province-name": "Piraievs"
        },
        {
          "province": "42",
          "province-name": "Preveza"
        },
        {
          "province": "43",
          "province-name": "Rethimni"
        },
        {
          "province": "44",
          "province-name": "Rodhopi"
        },
        {
          "province": "45",
          "province-name": "Samos"
        },
        {
          "province": "46",
          "province-name": "Serrai"
        },
        {
          "province": "47",
          "province-name": "Thesprotia"
        },
        {
          "province": "48",
          "province-name": "Thessaloniki"
        },
        {
          "province": "49",
          "province-name": "Trikala"
        },
        {
          "province": "50",
          "province-name": "Voiotia"
        },
        {
          "province": "51",
          "province-name": "Xanthi"
        },
        {
          "province": "52",
          "province-name": "Zakinthos"
        }
      ],
      "HK": [
        {
          "province": "HK",
          "province-name": "Hong Kong Island"
        },
        {
          "province": "KLN",
          "province-name": "Kowloon"
        },
        {
          "province": "NT",
          "province-name": "New Territories"
        }
      ],
      "HN": [
        {
          "province": "AT",
          "province-name": "Atlántida"
        },
        {
          "province": "CH",
          "province-name": "Choluteca"
        },
        {
          "province": "CL",
          "province-name": "Colón"
        },
        {
          "province": "CM",
          "province-name": "Comayagua"
        },
        {
          "province": "CP",
          "province-name": "Copán"
        },
        {
          "province": "CR",
          "province-name": "Cortés"
        },
        {
          "province": "EP",
          "province-name": "El Paraíso"
        },
        {
          "province": "FM",
          "province-name": "Francisco Morazán"
        },
        {
          "province": "GD",
          "province-name": "Gracias a Dios"
        },
        {
          "province": "IB",
          "province-name": "Islas de la Bahía"
        },
        {
          "province": "IN",
          "province-name": "Intibucá"
        },
        {
          "province": "LE",
          "province-name": "Lempira"
        },
        {
          "province": "LP",
          "province-name": "La Paz"
        },
        {
          "province": "OC",
          "province-name": "Ocotepeque"
        },
        {
          "province": "OL",
          "province-name": "Olancho"
        },
        {
          "province": "SB",
          "province-name": "Santa Bárbara"
        },
        {
          "province": "VA",
          "province-name": "Valle"
        },
        {
          "province": "YO",
          "province-name": "Yoro"
        }
      ],
      "HR": [
        {
          "province": "01",
          "province-name": "Bjelovar-Bilogora"
        },
        {
          "province": "02",
          "province-name": "Stadt Zagreb"
        },
        {
          "province": "03",
          "province-name": "Dubrovnik-Neretva"
        },
        {
          "province": "04",
          "province-name": "Istra"
        },
        {
          "province": "05",
          "province-name": "Karlovac"
        },
        {
          "province": "06",
          "province-name": "Koprivnica-Krizevci"
        },
        {
          "province": "07",
          "province-name": "Lika-Senj"
        },
        {
          "province": "08",
          "province-name": "Medimurje"
        },
        {
          "province": "09",
          "province-name": "Osijek-Baranja"
        },
        {
          "province": "10",
          "province-name": "Pozega-Slavonija"
        },
        {
          "province": "11",
          "province-name": "Primorje-Gorski Kot."
        },
        {
          "province": "12",
          "province-name": "Sibenik"
        },
        {
          "province": "13",
          "province-name": "Sisak-Moslavina"
        },
        {
          "province": "14",
          "province-name": "Slavonski"
        },
        {
          "province": "15",
          "province-name": "Brod-Posavina"
        },
        {
          "province": "16",
          "province-name": "Split-Dalmatia"
        },
        {
          "province": "17",
          "province-name": "Varazdin"
        },
        {
          "province": "18",
          "province-name": "Virovitica-Podravina"
        },
        {
          "province": "19",
          "province-name": "Vukovar-Srijem"
        },
        {
          "province": "20",
          "province-name": "Zadar-Knin"
        },
        {
          "province": "21",
          "province-name": "Zagreb"
        }
      ],
      "HU": [
        {
          "province": "01",
          "province-name": "Bacs-Kiskun"
        },
        {
          "province": "02",
          "province-name": "Baranya"
        },
        {
          "province": "03",
          "province-name": "Bekes"
        },
        {
          "province": "04",
          "province-name": "Bekescsaba"
        },
        {
          "province": "05",
          "province-name": "Borsod-Abauj-Zemplen"
        },
        {
          "province": "06",
          "province-name": "Budapest"
        },
        {
          "province": "07",
          "province-name": "Csongrad"
        },
        {
          "province": "08",
          "province-name": "Debrecen"
        },
        {
          "province": "09",
          "province-name": "Dunaujvaros"
        },
        {
          "province": "10",
          "province-name": "Eger"
        },
        {
          "province": "11",
          "province-name": "Fejer"
        },
        {
          "province": "12",
          "province-name": "Gyor"
        },
        {
          "province": "13",
          "province-name": "Gyor-Moson-Sopron"
        },
        {
          "province": "14",
          "province-name": "Hajdu-Bihar"
        },
        {
          "province": "15",
          "province-name": "Heves"
        },
        {
          "province": "16",
          "province-name": "Hodmezovasarhely"
        },
        {
          "province": "17",
          "province-name": "Jasz-Nagykun-Szolnok"
        },
        {
          "province": "18",
          "province-name": "Kaposvar"
        },
        {
          "province": "19",
          "province-name": "Kecskemet"
        },
        {
          "province": "20",
          "province-name": "Komarom-Esztergom"
        },
        {
          "province": "21",
          "province-name": "Miskolc"
        },
        {
          "province": "22",
          "province-name": "Nagykanizsa"
        },
        {
          "province": "23",
          "province-name": "Nograd"
        },
        {
          "province": "24",
          "province-name": "Nyiregyhaza"
        },
        {
          "province": "25",
          "province-name": "Pecs"
        },
        {
          "province": "26",
          "province-name": "Pest"
        },
        {
          "province": "27",
          "province-name": "Somogy"
        },
        {
          "province": "28",
          "province-name": "Sopron"
        },
        {
          "province": "29",
          "province-name": "Szabolcs-Szat.-Bereg"
        },
        {
          "province": "30",
          "province-name": "Szeged"
        },
        {
          "province": "31",
          "province-name": "Szekesfehervar"
        },
        {
          "province": "32",
          "province-name": "Szolnok"
        },
        {
          "province": "33",
          "province-name": "Szombathely"
        },
        {
          "province": "34",
          "province-name": "Tatabanya"
        },
        {
          "province": "35",
          "province-name": "Tolna"
        },
        {
          "province": "36",
          "province-name": "Vas"
        },
        {
          "province": "37",
          "province-name": "Veszprem"
        },
        {
          "province": "38",
          "province-name": "Zala"
        },
        {
          "province": "39",
          "province-name": "Zalaegerszeg"
        }
      ],
      "ID": [
        {
          "province": "01",
          "province-name": "DKI Jakarta Jakarta"
        },
        {
          "province": "02",
          "province-name": "Jawa Barat West Java"
        },
        {
          "province": "03",
          "province-name": "Jawa Tengah Central"
        },
        {
          "province": "04",
          "province-name": "Jawa Timur East Java"
        },
        {
          "province": "05",
          "province-name": "DI Yogyakarta Yogyak"
        },
        {
          "province": "06",
          "province-name": "DI Aceh Aceh"
        },
        {
          "province": "07",
          "province-name": "Sumatera Utara North"
        },
        {
          "province": "08",
          "province-name": "Sumatera Barat West"
        },
        {
          "province": "09",
          "province-name": "Riau Riau"
        },
        {
          "province": "10",
          "province-name": "Jambi Jambi"
        },
        {
          "province": "11",
          "province-name": "Sumatera Selatan Sou"
        },
        {
          "province": "12",
          "province-name": "Bengkulu Bengkulu"
        },
        {
          "province": "13",
          "province-name": "Lampung Lampung"
        },
        {
          "province": "14",
          "province-name": "Kalimantan Selatan S"
        },
        {
          "province": "15",
          "province-name": "Kalimantan Barat Wes"
        },
        {
          "province": "16",
          "province-name": "Kalimantan Tengah Ce"
        },
        {
          "province": "17",
          "province-name": "Kalimantan Timur Eas"
        },
        {
          "province": "18",
          "province-name": "Sulawesi Selatan Sou"
        },
        {
          "province": "19",
          "province-name": "Sulawesi Tenggara So"
        },
        {
          "province": "20",
          "province-name": "Sulawesi Tengah Cent"
        },
        {
          "province": "21",
          "province-name": "Sulawesi Utara North"
        },
        {
          "province": "22",
          "province-name": "Bali Bali"
        },
        {
          "province": "23",
          "province-name": "Nusa Tenggara Barat"
        },
        {
          "province": "24",
          "province-name": "Nusa Tenggara Timur"
        },
        {
          "province": "25",
          "province-name": "Maluku Maluku"
        },
        {
          "province": "26",
          "province-name": "Irian Jaya Irian Jay"
        },
        {
          "province": "27",
          "province-name": "Timor Timur East Tim"
        }
      ],
      "IE": [
        {
          "province": "CK",
          "province-name": "Cork"
        },
        {
          "province": "CL",
          "province-name": "Clare"
        },
        {
          "province": "CV",
          "province-name": "Cavan"
        },
        {
          "province": "CW",
          "province-name": "Carlow"
        },
        {
          "province": "DB",
          "province-name": "Dublin"
        },
        {
          "province": "DG",
          "province-name": "Donegal"
        },
        {
          "province": "GW",
          "province-name": "Galway"
        },
        {
          "province": "KD",
          "province-name": "Kildare"
        },
        {
          "province": "KK",
          "province-name": "Kilkenny"
        },
        {
          "province": "KY",
          "province-name": "Kerry"
        },
        {
          "province": "LF",
          "province-name": "Longford"
        },
        {
          "province": "LI",
          "province-name": "Limerick"
        },
        {
          "province": "LM",
          "province-name": "Leitrim"
        },
        {
          "province": "LS",
          "province-name": "Laois"
        },
        {
          "province": "LT",
          "province-name": "Louth"
        },
        {
          "province": "MH",
          "province-name": "Monaghan"
        },
        {
          "province": "MT",
          "province-name": "Meath"
        },
        {
          "province": "MY",
          "province-name": "Mayo"
        },
        {
          "province": "OF",
          "province-name": "Offaly"
        },
        {
          "province": "RC",
          "province-name": "Rosscommon"
        },
        {
          "province": "SG",
          "province-name": "Sligo"
        },
        {
          "province": "TP",
          "province-name": "Tipperary"
        },
        {
          "province": "WF",
          "province-name": "Waterford"
        },
        {
          "province": "WK",
          "province-name": "Wicklow"
        },
        {
          "province": "WM",
          "province-name": "Westmeath"
        },
        {
          "province": "WX",
          "province-name": "Wexford"
        }
      ],
      "IL": [
        {
          "province": "01",
          "province-name": "Central"
        },
        {
          "province": "M",
          "province-name": "Central"
        },
        {
          "province": "02",
          "province-name": "Haifa"
        },
        {
          "province": "HA",
          "province-name": "Haifa"
        },
        {
          "province": "03",
          "province-name": "Jerusalem"
        },
        {
          "province": "JM",
          "province-name": "Jerusalem"
        },
        {
          "province": "04",
          "province-name": "Northern"
        },
        {
          "province": "Z",
          "province-name": "Northern"
        },
        {
          "province": "05",
          "province-name": "Southern"
        },
        {
          "province": "D",
          "province-name": "Southern"
        },
        {
          "province": "06",
          "province-name": "Tel Aviv"
        },
        {
          "province": "TA",
          "province-name": "Tel Aviv"
        }
      ],
      "IN": [
        {
          "province": "01",
          "province-name": "Andra Pradesh"
        },
        {
          "province": "02",
          "province-name": "Arunachal Pradesh"
        },
        {
          "province": "03",
          "province-name": "Assam"
        },
        {
          "province": "04",
          "province-name": "Bihar"
        },
        {
          "province": "05",
          "province-name": "Goa"
        },
        {
          "province": "06",
          "province-name": "Gujarat"
        },
        {
          "province": "07",
          "province-name": "Haryana"
        },
        {
          "province": "08",
          "province-name": "Himachal Pradesh"
        },
        {
          "province": "09",
          "province-name": "Jammu und Kashmir"
        },
        {
          "province": "10",
          "province-name": "Karnataka"
        },
        {
          "province": "11",
          "province-name": "Kerala"
        },
        {
          "province": "12",
          "province-name": "Madhya Pradesh"
        },
        {
          "province": "13",
          "province-name": "Maharashtra"
        },
        {
          "province": "14",
          "province-name": "Manipur"
        },
        {
          "province": "15",
          "province-name": "Megalaya"
        },
        {
          "province": "16",
          "province-name": "Mizoram"
        },
        {
          "province": "17",
          "province-name": "Nagaland"
        },
        {
          "province": "18",
          "province-name": "Orissa"
        },
        {
          "province": "19",
          "province-name": "Punjab"
        },
        {
          "province": "20",
          "province-name": "Rajasthan"
        },
        {
          "province": "21",
          "province-name": "Sikkim"
        },
        {
          "province": "22",
          "province-name": "Tamil Nadu"
        },
        {
          "province": "23",
          "province-name": "Tripura"
        },
        {
          "province": "24",
          "province-name": "Uttar Pradesh"
        },
        {
          "province": "25",
          "province-name": "West Bengal"
        },
        {
          "province": "26",
          "province-name": "Andaman und Nico.In."
        },
        {
          "province": "27",
          "province-name": "Chandigarh"
        },
        {
          "province": "28",
          "province-name": "Dadra und Nagar Hav."
        },
        {
          "province": "29",
          "province-name": "Daman und Diu"
        },
        {
          "province": "30",
          "province-name": "Delhi"
        },
        {
          "province": "31",
          "province-name": "Lakshadweep"
        },
        {
          "province": "32",
          "province-name": "Pondicherry"
        },
        {
          "province": "33",
          "province-name": "Pondicherry"
        },
        {
          "province": "34",
          "province-name": ""
        },
        {
          "province": "35",
          "province-name": ""
        }
      ],
      "IT": [
        {
          "province": "AG",
          "province-name": "Agriento"
        },
        {
          "province": "AL",
          "province-name": "Alessandria"
        },
        {
          "province": "AN",
          "province-name": "Ancona"
        },
        {
          "province": "AO",
          "province-name": "Aosta"
        },
        {
          "province": "AP",
          "province-name": "Ascoli Piceno"
        },
        {
          "province": "AQ",
          "province-name": "L'Aquila"
        },
        {
          "province": "AR",
          "province-name": "Arezzo"
        },
        {
          "province": "AT",
          "province-name": "Asti"
        },
        {
          "province": "AV",
          "province-name": "Avellino"
        },
        {
          "province": "BA",
          "province-name": "Bari"
        },
        {
          "province": "BG",
          "province-name": "Bergamo"
        },
        {
          "province": "BI",
          "province-name": "Biella"
        },
        {
          "province": "BL",
          "province-name": "Belluno"
        },
        {
          "province": "BN",
          "province-name": "Benevento"
        },
        {
          "province": "BO",
          "province-name": "Bologna"
        },
        {
          "province": "BR",
          "province-name": "Brindisi"
        },
        {
          "province": "BS",
          "province-name": "Brescia"
        },
        {
          "province": "BZ",
          "province-name": "Bolzano"
        },
        {
          "province": "CA",
          "province-name": "Cagliari"
        },
        {
          "province": "CB",
          "province-name": "Campobasso"
        },
        {
          "province": "CE",
          "province-name": "Caserta"
        },
        {
          "province": "CH",
          "province-name": "Chieti"
        },
        {
          "province": "CL",
          "province-name": "Caltanisetta"
        },
        {
          "province": "CN",
          "province-name": "Cuneo"
        },
        {
          "province": "CO",
          "province-name": "Como"
        },
        {
          "province": "CR",
          "province-name": "Cremona"
        },
        {
          "province": "CS",
          "province-name": "Cosenza"
        },
        {
          "province": "CT",
          "province-name": "Catania"
        },
        {
          "province": "CZ",
          "province-name": "Catanzaro"
        },
        {
          "province": "EN",
          "province-name": "Enna"
        },
        {
          "province": "FE",
          "province-name": "Ferrara"
        },
        {
          "province": "FG",
          "province-name": "Foggia"
        },
        {
          "province": "FI",
          "province-name": "Florence"
        },
        {
          "province": "FO",
          "province-name": "Forlì"
        },
        {
          "province": "FR",
          "province-name": "Frosinone"
        },
        {
          "province": "GE",
          "province-name": "Genova"
        },
        {
          "province": "GO",
          "province-name": "Gorizia"
        },
        {
          "province": "GR",
          "province-name": "Grosseto"
        },
        {
          "province": "IM",
          "province-name": "Imperia"
        },
        {
          "province": "IS",
          "province-name": "Isernia"
        },
        {
          "province": "KR",
          "province-name": "Crotone"
        },
        {
          "province": "LC",
          "province-name": "Lecco"
        },
        {
          "province": "LE",
          "province-name": "Lecce"
        },
        {
          "province": "LI",
          "province-name": "Livorno"
        },
        {
          "province": "LO",
          "province-name": "Lodi"
        },
        {
          "province": "LT",
          "province-name": "Latina"
        },
        {
          "province": "LU",
          "province-name": "Lucca"
        },
        {
          "province": "MC",
          "province-name": "Macerata"
        },
        {
          "province": "ME",
          "province-name": "Messina"
        },
        {
          "province": "MI",
          "province-name": "Milan"
        },
        {
          "province": "MN",
          "province-name": "Mantova"
        },
        {
          "province": "MO",
          "province-name": "Modena"
        },
        {
          "province": "MS",
          "province-name": "Massa Carrara"
        },
        {
          "province": "MT",
          "province-name": "Matera"
        },
        {
          "province": "NA",
          "province-name": "Naples"
        },
        {
          "province": "NO",
          "province-name": "Novara"
        },
        {
          "province": "NU",
          "province-name": "Nuoro"
        },
        {
          "province": "OR",
          "province-name": "Oristano"
        },
        {
          "province": "PA",
          "province-name": "Palermo"
        },
        {
          "province": "PC",
          "province-name": "Piacenza"
        },
        {
          "province": "PD",
          "province-name": "Padova"
        },
        {
          "province": "PE",
          "province-name": "Pescara"
        },
        {
          "province": "PG",
          "province-name": "Perugia"
        },
        {
          "province": "PI",
          "province-name": "Pisa"
        },
        {
          "province": "PN",
          "province-name": "Pordenone"
        },
        {
          "province": "PO",
          "province-name": "Prato"
        },
        {
          "province": "PR",
          "province-name": "Parma"
        },
        {
          "province": "PS",
          "province-name": "Pesaro"
        },
        {
          "province": "PT",
          "province-name": "Pistoia"
        },
        {
          "province": "PU",
          "province-name": "Pesaro-Urbino"
        },
        {
          "province": "PV",
          "province-name": "Pavia"
        },
        {
          "province": "PZ",
          "province-name": "Potenza"
        },
        {
          "province": "RA",
          "province-name": "Ravenna"
        },
        {
          "province": "RC",
          "province-name": "Reggio Calabria"
        },
        {
          "province": "RE",
          "province-name": "Reggio Emilia"
        },
        {
          "province": "RG",
          "province-name": "Ragusa"
        },
        {
          "province": "RI",
          "province-name": "Rieti"
        },
        {
          "province": "RM",
          "province-name": "Rome"
        },
        {
          "province": "RN",
          "province-name": "Rimini"
        },
        {
          "province": "RO",
          "province-name": "Rovigo"
        },
        {
          "province": "RV",
          "province-name": "Rovigo"
        },
        {
          "province": "SA",
          "province-name": "Salerno"
        },
        {
          "province": "SI",
          "province-name": "Siena"
        },
        {
          "province": "SO",
          "province-name": "Sondrio"
        },
        {
          "province": "SP",
          "province-name": "La Spezia"
        },
        {
          "province": "SR",
          "province-name": "Siracusa"
        },
        {
          "province": "SS",
          "province-name": "Sassari"
        },
        {
          "province": "SV",
          "province-name": "Savona"
        },
        {
          "province": "TA",
          "province-name": "Taranto"
        },
        {
          "province": "TE",
          "province-name": "Teramo"
        },
        {
          "province": "TN",
          "province-name": "Trento"
        },
        {
          "province": "TO",
          "province-name": "Turin"
        },
        {
          "province": "TP",
          "province-name": "Trapani"
        },
        {
          "province": "TR",
          "province-name": "Terni"
        },
        {
          "province": "TS",
          "province-name": "Trieste"
        },
        {
          "province": "TV",
          "province-name": "Treviso"
        },
        {
          "province": "UD",
          "province-name": "Udine"
        },
        {
          "province": "VA",
          "province-name": "Varese"
        },
        {
          "province": "VC",
          "province-name": "Vercelli"
        },
        {
          "province": "VE",
          "province-name": "Venice"
        },
        {
          "province": "VI",
          "province-name": "Vicenza"
        },
        {
          "province": "VR",
          "province-name": "Verona"
        },
        {
          "province": "VT",
          "province-name": "Viterbo"
        },
        {
          "province": "VV",
          "province-name": "Vibo Valentia"
        }
      ],
      "JP": [
        {
          "province": "01",
          "province-name": "Hokkaido"
        },
        {
          "province": "02",
          "province-name": "Aomori"
        },
        {
          "province": "03",
          "province-name": "Iwate"
        },
        {
          "province": "04",
          "province-name": "Miyagi"
        },
        {
          "province": "05",
          "province-name": "Akita"
        },
        {
          "province": "06",
          "province-name": "Yamagata"
        },
        {
          "province": "07",
          "province-name": "Fukushima"
        },
        {
          "province": "08",
          "province-name": "Ibaraki"
        },
        {
          "province": "09",
          "province-name": "Tochigi"
        },
        {
          "province": "10",
          "province-name": "Gunma"
        },
        {
          "province": "11",
          "province-name": "Saitama"
        },
        {
          "province": "12",
          "province-name": "Chiba"
        },
        {
          "province": "13",
          "province-name": "Tokyo"
        },
        {
          "province": "14",
          "province-name": "Kanagawa"
        },
        {
          "province": "15",
          "province-name": "Niigata"
        },
        {
          "province": "16",
          "province-name": "Toyama"
        },
        {
          "province": "17",
          "province-name": "Ishikawa"
        },
        {
          "province": "18",
          "province-name": "Fukui"
        },
        {
          "province": "19",
          "province-name": "Yamanashi"
        },
        {
          "province": "20",
          "province-name": "Nagano"
        },
        {
          "province": "21",
          "province-name": "Gifu"
        },
        {
          "province": "22",
          "province-name": "Shizuoka"
        },
        {
          "province": "23",
          "province-name": "Aichi"
        },
        {
          "province": "24",
          "province-name": "Mie"
        },
        {
          "province": "25",
          "province-name": "Shiga"
        },
        {
          "province": "26",
          "province-name": "Kyoto"
        },
        {
          "province": "27",
          "province-name": "Osaka"
        },
        {
          "province": "28",
          "province-name": "Hyogo"
        },
        {
          "province": "29",
          "province-name": "Nara"
        },
        {
          "province": "30",
          "province-name": "Wakayama"
        },
        {
          "province": "31",
          "province-name": "Tottori"
        },
        {
          "province": "32",
          "province-name": "Shimane"
        },
        {
          "province": "33",
          "province-name": "Okayama"
        },
        {
          "province": "34",
          "province-name": "Hiroshima"
        },
        {
          "province": "35",
          "province-name": "Yamaguchi"
        },
        {
          "province": "36",
          "province-name": "Tokushima"
        },
        {
          "province": "37",
          "province-name": "Kagawa"
        },
        {
          "province": "38",
          "province-name": "Ehime"
        },
        {
          "province": "39",
          "province-name": "Kochi"
        },
        {
          "province": "40",
          "province-name": "Fukuoka"
        },
        {
          "province": "41",
          "province-name": "Saga"
        },
        {
          "province": "42",
          "province-name": "Nagasaki"
        },
        {
          "province": "43",
          "province-name": "Kumamoto"
        },
        {
          "province": "44",
          "province-name": "Oita"
        },
        {
          "province": "45",
          "province-name": "Miyazaki"
        },
        {
          "province": "46",
          "province-name": "Kagoshima"
        },
        {
          "province": "47",
          "province-name": "Okinawa"
        }
      ],
      "KN": [],
      "KR": [
        {
          "province": "01",
          "province-name": "Cheju-do"
        },
        {
          "province": "02",
          "province-name": "Cholla-bukto"
        },
        {
          "province": "03",
          "province-name": "Cholla-namdo"
        },
        {
          "province": "04",
          "province-name": "Ch´ungch´ong-bukto"
        },
        {
          "province": "05",
          "province-name": "Ch´ungch´ong-namdo"
        },
        {
          "province": "06",
          "province-name": "Inch´on-jikhalsi"
        },
        {
          "province": "07",
          "province-name": "Kangwon-do"
        },
        {
          "province": "08",
          "province-name": "Kwangju-jikhalsi"
        },
        {
          "province": "09",
          "province-name": "Kyonggi-do"
        },
        {
          "province": "10",
          "province-name": "Kyongsang-bukto"
        },
        {
          "province": "11",
          "province-name": "Kyongsang-namdo"
        },
        {
          "province": "12",
          "province-name": "Pusan-jikhalsi"
        },
        {
          "province": "13",
          "province-name": "Soul-t´ukpyolsi"
        },
        {
          "province": "14",
          "province-name": "Taegu-jikhalsi"
        },
        {
          "province": "15",
          "province-name": "Taejon-jikhalsi"
        }
      ],
      "KZ": [
        {
          "province": "00",
          "province-name": "Almatynskaia"
        },
        {
          "province": "01",
          "province-name": "Kostanaiskaia"
        },
        {
          "province": "02",
          "province-name": "Severo-Kazakhstansk"
        },
        {
          "province": "03",
          "province-name": "Pavlodarskaia"
        },
        {
          "province": "04",
          "province-name": "Akmolinskaia"
        },
        {
          "province": "05",
          "province-name": "Aktubinskaia"
        },
        {
          "province": "06",
          "province-name": "Atyrauskaia"
        },
        {
          "province": "07",
          "province-name": "Zapadno-Kazakhst"
        },
        {
          "province": "08",
          "province-name": "Mangystayskaia"
        },
        {
          "province": "09",
          "province-name": "Karagandinskaia"
        },
        {
          "province": "10",
          "province-name": "Vostochno-Kazakhstan"
        },
        {
          "province": "11",
          "province-name": "Gambilskaia"
        },
        {
          "province": "12",
          "province-name": "Kyzilordinskaia"
        }
      ],
      "KW": [
        {
          "province": "AH",
          "province-name": "Al Aḩmadī"
        },
        {
          "province": "FA",
          "province-name": "Al Farwānīyah"
        },
        {
          "province": "JA",
          "province-name": "Al Jahrā’"
        },
        {
          "province": "KU",
          "province-name": "Al ‘Āşimah"
        },
        {
          "province": "HA",
          "province-name": "Ḩawallī"
        },
        {
          "province": "MU",
          "province-name": "Mubārak al Kabīr"
        }
      ],
      "LT": [],
      "LU": [
        {
          "province": "CA",
          "province-name": "Capellen"
        },
        {
          "province": "CL",
          "province-name": "Clervaux"
        },
        {
          "province": "DI",
          "province-name": "Diekirch"
        },
        {
          "province": "EC",
          "province-name": "Echternach"
        },
        {
          "province": "ES",
          "province-name": "Esch-sur-Alzette"
        },
        {
          "province": "GR",
          "province-name": "Grevenmacher"
        },
        {
          "province": "LU",
          "province-name": "Luxembourg"
        },
        {
          "province": "ME",
          "province-name": "Mersch"
        },
        {
          "province": "RD",
          "province-name": "Redange"
        },
        {
          "province": "RM",
          "province-name": "Remich"
        },
        {
          "province": "VD",
          "province-name": "Vianden"
        },
        {
          "province": "WI",
          "province-name": "Wiltz"
        }
      ],
      "MA": [
        {
          "province": "AGD",
          "province-name": "Agadir"
        },
        {
          "province": "AOU",
          "province-name": "Aousserd "
        },
        {
          "province": "ASZ",
          "province-name": "Assa-Zag "
        },
        {
          "province": "AZI",
          "province-name": "Azilal"
        },
        {
          "province": "BEM",
          "province-name": "Béni Mellal"
        },
        {
          "province": "BES",
          "province-name": "Benslimane"
        },
        {
          "province": "BER",
          "province-name": "Berkane"
        },
        {
          "province": "BRR",
          "province-name": "Berrechid"
        },
        {
          "province": "BOD",
          "province-name": "Boujdour "
        },
        {
          "province": "BOM",
          "province-name": "Boulemane"
        },
        {
          "province": "CAS",
          "province-name": "Casablanca "
        },
        {
          "province": "CHE",
          "province-name": "Chefchaouen"
        },
        {
          "province": "CHI",
          "province-name": "Chichaoua"
        },
        {
          "province": "CHT",
          "province-name": "Chtouka-Ait Baha"
        },
        {
          "province": "DRI",
          "province-name": "Driouch"
        },
        {
          "province": "ERR",
          "province-name": "Errachidia"
        },
        {
          "province": "ESM",
          "province-name": "Es-Semara "
        },
        {
          "province": "ESI",
          "province-name": "Essaouira"
        },
        {
          "province": "FAH",
          "province-name": "Fahs-Anjra"
        },
        {
          "province": "FES",
          "province-name": "Fès"
        },
        {
          "province": "FIG",
          "province-name": "Figuig"
        },
        {
          "province": "FQH",
          "province-name": "Fquih Ben Salah"
        },
        {
          "province": "GUE",
          "province-name": "Guelmim"
        },
        {
          "province": "GUF",
          "province-name": "Guercif"
        },
        {
          "province": "HAJ",
          "province-name": "El Hajeb"
        },
        {
          "province": "HAO",
          "province-name": "Al Haouz"
        },
        {
          "province": "HOC",
          "province-name": "Al Hoceïma"
        },
        {
          "province": "IFR",
          "province-name": "Ifrane"
        },
        {
          "province": "INE",
          "province-name": "Inezgane-Ait Melloul"
        },
        {
          "province": "JDI",
          "province-name": "El Jadida"
        },
        {
          "province": "JRA",
          "province-name": "Jerada"
        },
        {
          "province": "KES",
          "province-name": "El Kelâa des Sraghna"
        },
        {
          "province": "KEN",
          "province-name": "Kénitra"
        },
        {
          "province": "KHE",
          "province-name": "Khemisset"
        },
        {
          "province": "KHN",
          "province-name": "Khenifra"
        },
        {
          "province": "KHO",
          "province-name": "Khouribga"
        },
        {
          "province": "LAA",
          "province-name": "Laâyoune "
        },
        {
          "province": "LAR",
          "province-name": "Larache"
        },
        {
          "province": "MAR",
          "province-name": "Marrakech"
        },
        {
          "province": "MDF",
          "province-name": "M’diq-Fnideq"
        },
        {
          "province": "MED",
          "province-name": "Médiouna"
        },
        {
          "province": "MEK",
          "province-name": "Meknès"
        },
        {
          "province": "MID",
          "province-name": "Midelt"
        },
        {
          "province": "MOH",
          "province-name": "Mohammadia"
        },
        {
          "province": "MOU",
          "province-name": "Moulay Yacoub"
        },
        {
          "province": "NAD",
          "province-name": "Nador"
        },
        {
          "province": "NOU",
          "province-name": "Nouaceur"
        },
        {
          "province": "OUA",
          "province-name": "Ouarzazate"
        },
        {
          "province": "OUD",
          "province-name": "Oued Ed-Dahab "
        },
        {
          "province": "OUZ",
          "province-name": "Ouezzane"
        },
        {
          "province": "OUJ",
          "province-name": "Oujda-Angad"
        },
        {
          "province": "RAB",
          "province-name": "Rabat"
        },
        {
          "province": "REH",
          "province-name": "Rehamna"
        },
        {
          "province": "SAF",
          "province-name": "Safi"
        },
        {
          "province": "SAL",
          "province-name": "Salé"
        },
        {
          "province": "SEF",
          "province-name": "Sefrou"
        },
        {
          "province": "SET",
          "province-name": "Settat"
        },
        {
          "province": "SIB",
          "province-name": "Sidi Bennour"
        },
        {
          "province": "SIF",
          "province-name": "Sidi Ifni"
        },
        {
          "province": "SIK",
          "province-name": "Sidi Kacem"
        },
        {
          "province": "SIL",
          "province-name": "Sidi Slimane"
        },
        {
          "province": "SKH",
          "province-name": "Skhirate-Témara"
        },
        {
          "province": "TNT",
          "province-name": "Tan-Tan "
        },
        {
          "province": "TNG",
          "province-name": "Tanger-Assilah"
        },
        {
          "province": "TAO",
          "province-name": "Taounate"
        },
        {
          "province": "TAI",
          "province-name": "Taourirt"
        },
        {
          "province": "TAF",
          "province-name": "Tarfaya "
        },
        {
          "province": "TAR",
          "province-name": "Taroudant"
        },
        {
          "province": "TAT",
          "province-name": "Tata"
        },
        {
          "province": "TAZ",
          "province-name": "Taza"
        },
        {
          "province": "TET",
          "province-name": "Tétouan"
        },
        {
          "province": "TIN",
          "province-name": "Tinghir"
        },
        {
          "province": "TIZ",
          "province-name": "Tiznit"
        },
        {
          "province": "YUS",
          "province-name": "Youssoufia"
        },
        {
          "province": "ZAG",
          "province-name": "Zagora"
        },
      ],
      "MT": [],
      "MX": [
        {
          "province": "AGS",
          "province-name": "Aguascalientes"
        },
        {
          "province": "AGU",
          "province-name": "Aguascalientes"
        },
        {
          "province": "BCN",
          "province-name": "Baja California (N)"
        },
        {
          "province": "BCS",
          "province-name": "Baja California Sur"
        },
        {
          "province": "CAM",
          "province-name": "Campeche"
        },
        {
          "province": "CHH",
          "province-name": "Chihuahua"
        },
        {
          "province": "CHI",
          "province-name": "Chihuahua"
        },
        {
          "province": "CHP",
          "province-name": "Chiapas"
        },
        {
          "province": "CHS",
          "province-name": "Chiapas"
        },
        {
          "province": "CMP",
          "province-name": "Campeche"
        },
        {
          "province": "COA",
          "province-name": "Coahuila"
        },
        {
          "province": "COL",
          "province-name": "Colima"
        },
        {
          "province": "DF",
          "province-name": "Distrito Federal"
        },
        {
          "province": "DGO",
          "province-name": "Durango"
        },
        {
          "province": "DIF",
          "province-name": "Distrito Federal"
        },
        {
          "province": "DUR",
          "province-name": "Durango"
        },
        {
          "province": "GRO",
          "province-name": "Guerrero"
        },
        {
          "province": "GTO",
          "province-name": "Guanajuato"
        },
        {
          "province": "GUA",
          "province-name": "Guanajuato"
        },
        {
          "province": "HGO",
          "province-name": "Hidalgo"
        },
        {
          "province": "HID",
          "province-name": "Hidalgo"
        },
        {
          "province": "JAL",
          "province-name": "Jalisco"
        },
        {
          "province": "MCH",
          "province-name": "Michoacán"
        },
        {
          "province": "MEX",
          "province-name": "Estado de México"
        },
        {
          "province": "MIC",
          "province-name": "Michoacán"
        },
        {
          "province": "MOR",
          "province-name": "Morelos"
        },
        {
          "province": "NAY",
          "province-name": "Nayarit"
        },
        {
          "province": "NL",
          "province-name": "Nuevo Léon"
        },
        {
          "province": "NLE",
          "province-name": "Nuevo Léon"
        },
        {
          "province": "OAX",
          "province-name": "Oaxaca"
        },
        {
          "province": "PUE",
          "province-name": "Puebla"
        },
        {
          "province": "QR",
          "province-name": "Quintana Roo"
        },
        {
          "province": "QRO",
          "province-name": "Querétaro"
        },
        {
          "province": "QUE",
          "province-name": "Querétaro"
        },
        {
          "province": "ROO",
          "province-name": "Quintana Roo"
        },
        {
          "province": "SIN",
          "province-name": "Sinaloa"
        },
        {
          "province": "SLP",
          "province-name": "San Luis Potosí"
        },
        {
          "province": "SON",
          "province-name": "Sonora"
        },
        {
          "province": "TAB",
          "province-name": "Tabasco"
        },
        {
          "province": "TAM",
          "province-name": "Tamaulipas"
        },
        {
          "province": "TLA",
          "province-name": "Tlaxcala"
        },
        {
          "province": "TLX",
          "province-name": "Tlaxcala"
        },
        {
          "province": "TMS",
          "province-name": "Tamaulipas"
        },
        {
          "province": "VER",
          "province-name": "Veracruz"
        },
        {
          "province": "YUC",
          "province-name": "Yucatán"
        },
        {
          "province": "ZAC",
          "province-name": "Zacatecas"
        }
      ],
      "MY": [
        {
          "province": "JOH",
          "province-name": "Johor"
        },
        {
          "province": "KED",
          "province-name": "Kedah"
        },
        {
          "province": "KEL",
          "province-name": "Kelantan"
        },
        {
          "province": "KUL",
          "province-name": "Kuala Lumpur"
        },
        {
          "province": "LAB",
          "province-name": "Labuan"
        },
        {
          "province": "MEL",
          "province-name": "Melaka"
        },
        {
          "province": "PAH",
          "province-name": "Pahang"
        },
        {
          "province": "PEL",
          "province-name": "Perlis"
        },
        {
          "province": "PER",
          "province-name": "Perak"
        },
        {
          "province": "PIN",
          "province-name": "Pulau Pinang"
        },
        {
          "province": "SAB",
          "province-name": "Sabah"
        },
        {
          "province": "SAR",
          "province-name": "Sarawak"
        },
        {
          "province": "SEL",
          "province-name": "Selangor"
        },
        {
          "province": "SER",
          "province-name": "Negeri Sembilan"
        },
        {
          "province": "TRE",
          "province-name": "Trengganu"
        }
      ],
      "NA": [
        {
          "province": "ER",
          "province-name": "Erongo"
        },
        {
          "province": "HA",
          "province-name": "Hardap"
        },
        {
          "province": "KA",
          "province-name": "Karas"
        },
        {
          "province": "KE",
          "province-name": "Kavango East"
        },
        {
          "province": "KW",
          "province-name": "Kavango West"
        },
        {
          "province": "KH",
          "province-name": "Khomas"
        },
        {
          "province": "KU",
          "province-name": "Kunene"
        },
        {
          "province": "OW",
          "province-name": "Ohangwena"
        },
        {
          "province": "OH",
          "province-name": "Omaheke"
        },
        {
          "province": "OS",
          "province-name": "Omusati"
        },
        {
          "province": "ON",
          "province-name": "Oshana"
        },
        {
          "province": "OT",
          "province-name": "Oshikoto"
        },
        {
          "province": "OD",
          "province-name": "Otjozondjupa"
        },
        {
          "province": "CA",
          "province-name": "Zambezi"
        }
      ],
      "NI": [],
      "NL": [
        {
          "province": "01",
          "province-name": "Drenthe"
        },
        {
          "province": "02",
          "province-name": "Flevoland"
        },
        {
          "province": "03",
          "province-name": "Friesland"
        },
        {
          "province": "04",
          "province-name": "Gelderland"
        },
        {
          "province": "05",
          "province-name": "Groningen"
        },
        {
          "province": "06",
          "province-name": "Limburg"
        },
        {
          "province": "07",
          "province-name": "Noord-Brabant"
        },
        {
          "province": "08",
          "province-name": "Noord-Holland"
        },
        {
          "province": "09",
          "province-name": "Overijssel"
        },
        {
          "province": "10",
          "province-name": "Utrecht"
        },
        {
          "province": "11",
          "province-name": "Zeeland"
        },
        {
          "province": "12",
          "province-name": "Zuid-Holland"
        }
      ],
      "NO": [
        {
          "province": "01",
          "province-name": "Østfold Fylke"
        },
        {
          "province": "02",
          "province-name": "Akershus Fylke"
        },
        {
          "province": "03",
          "province-name": "Oslo"
        },
        {
          "province": "04",
          "province-name": "Hedmark Fylke"
        },
        {
          "province": "05",
          "province-name": "Oppland Fylke"
        },
        {
          "province": "06",
          "province-name": "Buskerud Fylke"
        },
        {
          "province": "07",
          "province-name": "Vestfold Fylke"
        },
        {
          "province": "08",
          "province-name": "Telemark Fylke"
        },
        {
          "province": "09",
          "province-name": "Aust-Agder Fylke"
        },
        {
          "province": "10",
          "province-name": "Vest-Agder Fylke"
        },
        {
          "province": "11",
          "province-name": "Rogaland Fylke"
        },
        {
          "province": "12",
          "province-name": "Hordaland Fylke"
        },
        {
          "province": "14",
          "province-name": "Sogn og Fjordane F."
        },
        {
          "province": "15",
          "province-name": "Møre og Romsdal F."
        },
        {
          "province": "16",
          "province-name": "Sør-Trøndelag Fylke"
        },
        {
          "province": "17",
          "province-name": "Nord-Trøndelag Fylke"
        },
        {
          "province": "18",
          "province-name": "Nordland Fylke"
        },
        {
          "province": "19",
          "province-name": "Troms Fylke"
        },
        {
          "province": "20",
          "province-name": "Finnmark Fylke"
        }
      ],
      "NZ": [
        {
          "province": "AKL",
          "province-name": "Auckland"
        },
        {
          "province": "BOP",
          "province-name": "Bay of Plenty"
        },
        {
          "province": "CAN",
          "province-name": "Canterbury"
        },
        {
          "province": "HAB",
          "province-name": "Hawke´s Bay"
        },
        {
          "province": "MAN",
          "province-name": "Manawatu-Wanganui"
        },
        {
          "province": "NTL",
          "province-name": "Northland"
        },
        {
          "province": "OTA",
          "province-name": "Otago"
        },
        {
          "province": "STL",
          "province-name": "Southland"
        },
        {
          "province": "TAR",
          "province-name": "Taranaki"
        },
        {
          "province": "WAI",
          "province-name": "Waikato"
        },
        {
          "province": "WEC",
          "province-name": "West Coast"
        },
        {
          "province": "WLG",
          "province-name": "Wellington"
        }
      ],
      "OM": [
        {
          "province": "DA",
          "province-name": "Ad Dākhilīyah"
        },
        {
          "province": "BS",
          "province-name": "Shamāl al Bāţinah"
        },
        {
          "province": "BJ",
          "province-name": "Janūb al Bāţinah"
        },
        {
          "province": "WU",
          "province-name": "Al Wusţá"
        },
        {
          "province": "SS",
          "province-name": "Shamāl ash Sharqīyah"
        },
        {
          "province": "SJ",
          "province-name": "Janūb ash Sharqīyah"
        },
        {
          "province": "ZA",
          "province-name": "Az̧ Z̧āhirah"
        },
        {
          "province": "BU",
          "province-name": "Al Buraymī"
        },
        {
          "province": "MA",
          "province-name": "Masqaţ"
        },
        {
          "province": "MU",
          "province-name": "Musandam"
        },
        {
          "province": "ZU",
          "province-name": "Z̧ufār"
        }
      ],
      "PA": [],
      "PE": [
        {
          "province": "01",
          "province-name": "Tumbes"
        },
        {
          "province": "02",
          "province-name": "Piura"
        },
        {
          "province": "03",
          "province-name": "Lambayeque"
        },
        {
          "province": "04",
          "province-name": "La Libertad"
        },
        {
          "province": "05",
          "province-name": "Ancash"
        },
        {
          "province": "06",
          "province-name": "Lima y Callao"
        },
        {
          "province": "07",
          "province-name": "Ica"
        },
        {
          "province": "08",
          "province-name": "Arequipa"
        },
        {
          "province": "09",
          "province-name": "Moquegua"
        },
        {
          "province": "10",
          "province-name": "Tacna"
        },
        {
          "province": "11",
          "province-name": "Amazon"
        },
        {
          "province": "12",
          "province-name": "Cajamarca"
        },
        {
          "province": "13",
          "province-name": "San Martín"
        },
        {
          "province": "14",
          "province-name": "Huánuco"
        },
        {
          "province": "15",
          "province-name": "Pasco"
        },
        {
          "province": "16",
          "province-name": "Junín"
        },
        {
          "province": "17",
          "province-name": "Huancavelica"
        },
        {
          "province": "18",
          "province-name": "Ayacucho"
        },
        {
          "province": "19",
          "province-name": "Apurimac"
        },
        {
          "province": "20",
          "province-name": "Cuzco"
        },
        {
          "province": "21",
          "province-name": "Puno"
        },
        {
          "province": "22",
          "province-name": "Loreto"
        },
        {
          "province": "23",
          "province-name": "Ucayali"
        },
        {
          "province": "24",
          "province-name": "Madre de Díos"
        }
      ],
      "PH": [
        {
          "province": "01",
          "province-name": "Ilocos"
        },
        {
          "province": "02",
          "province-name": "Cagayan Valley"
        },
        {
          "province": "03",
          "province-name": "Central Luzon"
        },
        {
          "province": "04",
          "province-name": "South Luzon"
        },
        {
          "province": "05",
          "province-name": "Bicol"
        },
        {
          "province": "06",
          "province-name": "West Visayas"
        },
        {
          "province": "07",
          "province-name": "Central Visayas"
        },
        {
          "province": "08",
          "province-name": "Eastern Visayas"
        },
        {
          "province": "09",
          "province-name": "Western Mindanao"
        },
        {
          "province": "10",
          "province-name": "Northern Mindanao"
        },
        {
          "province": "11",
          "province-name": "Central Mindanao"
        },
        {
          "province": "12",
          "province-name": "South Mindanao"
        }
      ],
      "PL": [
        {
          "province": "01",
          "province-name": "Biala Podlaska"
        },
        {
          "province": "02",
          "province-name": "Bialystok"
        },
        {
          "province": "03",
          "province-name": "Bielsko Biala"
        },
        {
          "province": "04",
          "province-name": "Bydgoszcz"
        },
        {
          "province": "05",
          "province-name": "Chelm"
        },
        {
          "province": "06",
          "province-name": "Ciechanow"
        },
        {
          "province": "07",
          "province-name": "Czestochowa"
        },
        {
          "province": "08",
          "province-name": "Elblag"
        },
        {
          "province": "09",
          "province-name": "Gdansk"
        },
        {
          "province": "10",
          "province-name": "Gorzow"
        },
        {
          "province": "11",
          "province-name": "Jelenia Gora"
        },
        {
          "province": "12",
          "province-name": "Kalisz"
        },
        {
          "province": "13",
          "province-name": "Katowice"
        },
        {
          "province": "14",
          "province-name": "Kielce"
        },
        {
          "province": "15",
          "province-name": "Konin"
        },
        {
          "province": "16",
          "province-name": "Koszalin"
        },
        {
          "province": "17",
          "province-name": "Krakow"
        },
        {
          "province": "18",
          "province-name": "Krosno"
        },
        {
          "province": "19",
          "province-name": "Legnica"
        },
        {
          "province": "20",
          "province-name": "Leszno"
        },
        {
          "province": "21",
          "province-name": "Lodz"
        },
        {
          "province": "22",
          "province-name": "Lomza"
        },
        {
          "province": "23",
          "province-name": "Lublin"
        },
        {
          "province": "24",
          "province-name": "Nowy Sacz"
        },
        {
          "province": "25",
          "province-name": "Olsztyn"
        },
        {
          "province": "26",
          "province-name": "Opole"
        },
        {
          "province": "27",
          "province-name": "Ostroleka"
        },
        {
          "province": "28",
          "province-name": "Pila"
        },
        {
          "province": "29",
          "province-name": "Piotrkow"
        },
        {
          "province": "30",
          "province-name": "Plock"
        },
        {
          "province": "31",
          "province-name": "Poznan"
        },
        {
          "province": "32",
          "province-name": "Przemysl"
        },
        {
          "province": "33",
          "province-name": "Radom"
        },
        {
          "province": "34",
          "province-name": "Rzeszow"
        },
        {
          "province": "35",
          "province-name": "Siedlce"
        },
        {
          "province": "36",
          "province-name": "Sieradz"
        },
        {
          "province": "37",
          "province-name": "Skierniewice"
        },
        {
          "province": "38",
          "province-name": "Slupsk"
        },
        {
          "province": "39",
          "province-name": "Suwalki"
        },
        {
          "province": "40",
          "province-name": "Szczecin"
        },
        {
          "province": "41",
          "province-name": "Tarnobrzeg"
        },
        {
          "province": "42",
          "province-name": "Tarnow"
        },
        {
          "province": "43",
          "province-name": "Torun"
        },
        {
          "province": "44",
          "province-name": "Walbrzych"
        },
        {
          "province": "45",
          "province-name": "Warszawa"
        },
        {
          "province": "46",
          "province-name": "Wloclawek"
        },
        {
          "province": "47",
          "province-name": "Wroclaw"
        },
        {
          "province": "48",
          "province-name": "Zamosc"
        },
        {
          "province": "49",
          "province-name": "Zielona Gora"
        }
      ],
      "PR": [
        {
          "province": "0",
          "province-name": "Isla Verde",
        },
        {
          "province": "1",
          "province-name": "Rafael Hernandez",
        },
        {
          "province": "2",
          "province-name": "San Juan",
        },
      ],
      "PT": [
        {
          "province": "10",
          "province-name": "Minho-Lima"
        },
        {
          "province": "11",
          "province-name": "Cávado"
        },
        {
          "province": "12",
          "province-name": "Ave"
        },
        {
          "province": "13",
          "province-name": "Grande Porto"
        },
        {
          "province": "14",
          "province-name": "Tâmega"
        },
        {
          "province": "15",
          "province-name": "Entre Douro e Vouga"
        },
        {
          "province": "16",
          "province-name": "Douro"
        },
        {
          "province": "17",
          "province-name": "Alto Trás-os-Montes"
        },
        {
          "province": "20",
          "province-name": "Baixo Vouga"
        },
        {
          "province": "21",
          "province-name": "Baixo Mondego"
        },
        {
          "province": "22",
          "province-name": "Pinhal Litoral"
        },
        {
          "province": "23",
          "province-name": "Pinhal Interior N."
        },
        {
          "province": "24",
          "province-name": "Pinhal Interior Sul"
        },
        {
          "province": "25",
          "province-name": "Dão-Lafoes"
        },
        {
          "province": "26",
          "province-name": "Serra da Estrela"
        },
        {
          "province": "27",
          "province-name": "Beira Interior Norte"
        },
        {
          "province": "28",
          "province-name": "Beira Interior Sul"
        },
        {
          "province": "29",
          "province-name": "Cova da Beira"
        },
        {
          "province": "30",
          "province-name": "Oeste"
        },
        {
          "province": "31",
          "province-name": "Grande Lisboa"
        },
        {
          "province": "32",
          "province-name": "Península de Setúbal"
        },
        {
          "province": "33",
          "province-name": "Médio Tejo"
        },
        {
          "province": "34",
          "province-name": "Lezíria do Tejo"
        },
        {
          "province": "40",
          "province-name": "Alentejo Litoral"
        },
        {
          "province": "41",
          "province-name": "Alto Alentejo"
        },
        {
          "province": "42",
          "province-name": "Alentejo Central"
        },
        {
          "province": "43",
          "province-name": "Baixo Alentejo"
        },
        {
          "province": "50",
          "province-name": "Algarve"
        },
        {
          "province": "60",
          "province-name": "Reg. Aut. dos Açores"
        },
        {
          "province": "70",
          "province-name": "Reg. Aut. da Madeira"
        }
      ],
      "RE": [],
      "RO": [
        {
          "province": "01",
          "province-name": "Alba"
        },
        {
          "province": "02",
          "province-name": "Arad"
        },
        {
          "province": "03",
          "province-name": "Arges"
        },
        {
          "province": "04",
          "province-name": "Bacau"
        },
        {
          "province": "05",
          "province-name": "Bihor"
        },
        {
          "province": "06",
          "province-name": "Bistrita-Nasaud"
        },
        {
          "province": "07",
          "province-name": "Botosani"
        },
        {
          "province": "08",
          "province-name": "Braila"
        },
        {
          "province": "09",
          "province-name": "Brasov"
        },
        {
          "province": "10",
          "province-name": "Bucuresti"
        },
        {
          "province": "11",
          "province-name": "Buzau"
        },
        {
          "province": "12",
          "province-name": "Calarasi"
        },
        {
          "province": "13",
          "province-name": "Caras-Severin"
        },
        {
          "province": "14",
          "province-name": "Cluj"
        },
        {
          "province": "15",
          "province-name": "Constanta"
        },
        {
          "province": "16",
          "province-name": "Covasna"
        },
        {
          "province": "17",
          "province-name": "Dimbovita"
        },
        {
          "province": "18",
          "province-name": "Dolj"
        },
        {
          "province": "19",
          "province-name": "Galati"
        },
        {
          "province": "20",
          "province-name": "Gorj"
        },
        {
          "province": "21",
          "province-name": "Giurgiu"
        },
        {
          "province": "22",
          "province-name": "Harghita"
        },
        {
          "province": "23",
          "province-name": "Hunedoara"
        },
        {
          "province": "24",
          "province-name": "Ialomita"
        },
        {
          "province": "25",
          "province-name": "Iasi"
        },
        {
          "province": "26",
          "province-name": "Maramures"
        },
        {
          "province": "27",
          "province-name": "Mehedinti"
        },
        {
          "province": "28",
          "province-name": "Mures"
        },
        {
          "province": "29",
          "province-name": "Neamt"
        },
        {
          "province": "30",
          "province-name": "Olt"
        },
        {
          "province": "31",
          "province-name": "Prahova"
        },
        {
          "province": "32",
          "province-name": "Salaj"
        },
        {
          "province": "33",
          "province-name": "Satu Mare"
        },
        {
          "province": "34",
          "province-name": "Sibiu"
        },
        {
          "province": "35",
          "province-name": "Suceava"
        },
        {
          "province": "36",
          "province-name": "Teleorman"
        },
        {
          "province": "37",
          "province-name": "Timis"
        },
        {
          "province": "38",
          "province-name": "Tulcea"
        },
        {
          "province": "39",
          "province-name": "Vaslui"
        },
        {
          "province": "40",
          "province-name": "Vilcea"
        },
        {
          "province": "41",
          "province-name": "Vrancea"
        }
      ],
      "RS": [
        {
          "province": "KM",
          "province-name": "Kosovo-Metohija"
        },
        {
          "province": "VO",
          "province-name": "Vojvodina"
        }
      ],
      "RU": [
        {
          "province": "01",
          "province-name": "Adigeja Republic"
        },
        {
          "province": "02",
          "province-name": "Highlands-Altay Rep."
        },
        {
          "province": "03",
          "province-name": "Republ.of Bashkortos"
        },
        {
          "province": "04",
          "province-name": "Buryat Republic"
        },
        {
          "province": "05",
          "province-name": "Dagestan Republic"
        },
        {
          "province": "06",
          "province-name": "Ingushetija Republic"
        },
        {
          "province": "07",
          "province-name": "Kabardino-Balkar.Rep"
        },
        {
          "province": "08",
          "province-name": "Kalmyk Republic"
        },
        {
          "province": "09",
          "province-name": "Karach.-Cherkessk Re"
        },
        {
          "province": "10",
          "province-name": "Karelian Republic"
        },
        {
          "province": "11",
          "province-name": "Komi Republic"
        },
        {
          "province": "12",
          "province-name": "Marijskaya Republic"
        },
        {
          "province": "13",
          "province-name": "Mordovian Republic"
        },
        {
          "province": "14",
          "province-name": "Yakutiya-Saha Rrepub"
        },
        {
          "province": "15",
          "province-name": "North-Osetiya Republ"
        },
        {
          "province": "16",
          "province-name": "Tatarstan Republic"
        },
        {
          "province": "17",
          "province-name": "Tuva Republic"
        },
        {
          "province": "18",
          "province-name": "The Udmurt Republic"
        },
        {
          "province": "19",
          "province-name": "Chakassky Republic"
        },
        {
          "province": "20",
          "province-name": "Chechenskaya Republ."
        },
        {
          "province": "21",
          "province-name": "Chuvash Republic"
        },
        {
          "province": "22",
          "province-name": "Altay Territory"
        },
        {
          "province": "23",
          "province-name": "Krasnodar Territory"
        },
        {
          "province": "24",
          "province-name": "Krasnoyarsk Territor"
        },
        {
          "province": "25",
          "province-name": "Primorye Territory"
        },
        {
          "province": "26",
          "province-name": "Stavropol Territory"
        },
        {
          "province": "27",
          "province-name": "Khabarovsk Territory"
        },
        {
          "province": "28",
          "province-name": "The Amur Area"
        },
        {
          "province": "29",
          "province-name": "The Arkhangelsk Area"
        },
        {
          "province": "30",
          "province-name": "The Astrakhan Area"
        },
        {
          "province": "31",
          "province-name": "The Belgorod Area"
        },
        {
          "province": "32",
          "province-name": "The Bryansk Area"
        },
        {
          "province": "33",
          "province-name": "The Vladimir Area"
        },
        {
          "province": "34",
          "province-name": "The Volgograd Area"
        },
        {
          "province": "35",
          "province-name": "The Vologda Area"
        },
        {
          "province": "36",
          "province-name": "The Voronezh Area"
        },
        {
          "province": "37",
          "province-name": "The Ivanovo Area"
        },
        {
          "province": "38",
          "province-name": "The Irkutsk Area"
        },
        {
          "province": "39",
          "province-name": "The Kaliningrad Area"
        },
        {
          "province": "40",
          "province-name": "The Kaluga Area"
        },
        {
          "province": "41",
          "province-name": "The Kamchatka Area"
        },
        {
          "province": "42",
          "province-name": "The Kemerovo Area"
        },
        {
          "province": "43",
          "province-name": "The Kirov Area"
        },
        {
          "province": "44",
          "province-name": "The Kostroma Area"
        },
        {
          "province": "45",
          "province-name": "The Kurgan Area"
        },
        {
          "province": "46",
          "province-name": "The Kursk Area"
        },
        {
          "province": "47",
          "province-name": "The Leningrad Area"
        },
        {
          "province": "48",
          "province-name": "The Lipetsk Area"
        },
        {
          "province": "49",
          "province-name": "The Magadan Area"
        },
        {
          "province": "50",
          "province-name": "The Moscow Area"
        },
        {
          "province": "51",
          "province-name": "The Murmansk Area"
        },
        {
          "province": "52",
          "province-name": "The Nizhniy Novgorod"
        },
        {
          "province": "53",
          "province-name": "The Novgorod Area"
        },
        {
          "province": "54",
          "province-name": "The Novosibirsk Area"
        },
        {
          "province": "55",
          "province-name": "The Omsk Area"
        },
        {
          "province": "56",
          "province-name": "The Orenburg Area"
        },
        {
          "province": "57",
          "province-name": "The Oryol Area"
        },
        {
          "province": "58",
          "province-name": "The Penza Area"
        },
        {
          "province": "59",
          "province-name": "The Perm Area"
        },
        {
          "province": "60",
          "province-name": "The Pskov Area"
        },
        {
          "province": "61",
          "province-name": "The Rostov Area"
        },
        {
          "province": "62",
          "province-name": "The Ryazan Area"
        },
        {
          "province": "63",
          "province-name": "The Samara Area"
        },
        {
          "province": "64",
          "province-name": "The Saratov Area"
        },
        {
          "province": "65",
          "province-name": "The Sakhalin Area"
        },
        {
          "province": "66",
          "province-name": "The Sverdlovsk Area"
        },
        {
          "province": "67",
          "province-name": "The Smolensk Area"
        },
        {
          "province": "68",
          "province-name": "The Tambov Area"
        },
        {
          "province": "69",
          "province-name": "The Tver Area"
        },
        {
          "province": "70",
          "province-name": "The Tomsk Area"
        },
        {
          "province": "71",
          "province-name": "The Tula Area"
        },
        {
          "province": "72",
          "province-name": "The Tyumen Area"
        },
        {
          "province": "73",
          "province-name": "The Ulyanovsk Area"
        },
        {
          "province": "74",
          "province-name": "The Chelyabinsk Area"
        },
        {
          "province": "75",
          "province-name": "The Chita Area"
        },
        {
          "province": "76",
          "province-name": "The Yaroslavl Area"
        },
        {
          "province": "77",
          "province-name": "c.Moscow"
        },
        {
          "province": "78",
          "province-name": "c.St-Peterburg"
        },
        {
          "province": "79",
          "province-name": "The Jewish Auton.are"
        },
        {
          "province": "80",
          "province-name": "Aginsk Buryat Aut.di"
        },
        {
          "province": "81",
          "province-name": "Komy Permjats.Aut.di"
        },
        {
          "province": "82",
          "province-name": "Korjacs Auton.distri"
        },
        {
          "province": "83",
          "province-name": "Nenekchky Auton.dist"
        },
        {
          "province": "84",
          "province-name": "The Taymir Auton.dis"
        },
        {
          "province": "85",
          "province-name": "Ust-Ordinsky Buryat"
        },
        {
          "province": "86",
          "province-name": "Chanti-Mansyjsky Aut"
        },
        {
          "province": "87",
          "province-name": "Chukotka Auton. dist"
        },
        {
          "province": "88",
          "province-name": "Evensky Auton.distri"
        },
        {
          "province": "89",
          "province-name": "Jamalo-Nenekchky Aut"
        }
      ],
      "SE": [
        {
          "province": "001",
          "province-name": "Blekinge Län"
        },
        {
          "province": "002",
          "province-name": "Dalarnas Län"
        },
        {
          "province": "003",
          "province-name": "Gotlands Län"
        },
        {
          "province": "004",
          "province-name": "Gävleborgs Län"
        },
        {
          "province": "005",
          "province-name": "Hallands Län"
        },
        {
          "province": "006",
          "province-name": "Jämtlands Län"
        },
        {
          "province": "007",
          "province-name": "Jönköpings Län"
        },
        {
          "province": "008",
          "province-name": "Kalmar Län"
        },
        {
          "province": "009",
          "province-name": "Kronobergs Län"
        },
        {
          "province": "010",
          "province-name": "Norrbottens Län"
        },
        {
          "province": "011",
          "province-name": "Skåne Län"
        },
        {
          "province": "012",
          "province-name": "Stockholms Län"
        },
        {
          "province": "013",
          "province-name": "Södermanlands Län"
        },
        {
          "province": "014",
          "province-name": "Uppsala Län"
        },
        {
          "province": "015",
          "province-name": "Värmlands Län"
        },
        {
          "province": "016",
          "province-name": "Västerbottens Län"
        },
        {
          "province": "017",
          "province-name": "Västernorrlands Län"
        },
        {
          "province": "018",
          "province-name": "Västmanlands Län"
        },
        {
          "province": "019",
          "province-name": "Västra Götalands Län"
        },
        {
          "province": "020",
          "province-name": "Örebro Län"
        },
        {
          "province": "021",
          "province-name": "Östergötlands Län"
        }
      ],
      "SG": [
        {
          "province": "SG",
          "province-name": "Singapore"
        }
      ],
      "SI": [
        {
          "province": "01",
          "province-name": "Ajdovscina"
        },
        {
          "province": "02",
          "province-name": "Brezice"
        },
        {
          "province": "03",
          "province-name": "Celje"
        },
        {
          "province": "04",
          "province-name": "Cerknica"
        },
        {
          "province": "05",
          "province-name": "Crnomelj"
        },
        {
          "province": "06",
          "province-name": "Dravograd"
        },
        {
          "province": "07",
          "province-name": "Gornja Radgona"
        },
        {
          "province": "08",
          "province-name": "Grosuplje"
        },
        {
          "province": "09",
          "province-name": "Hrastnik Lasko"
        },
        {
          "province": "10",
          "province-name": "Idrija"
        },
        {
          "province": "11",
          "province-name": "Ilirska Bistrica"
        },
        {
          "province": "12",
          "province-name": "Izola"
        },
        {
          "province": "13",
          "province-name": "Jesenice"
        },
        {
          "province": "14",
          "province-name": "Kamnik"
        },
        {
          "province": "15",
          "province-name": "Kocevje"
        },
        {
          "province": "16",
          "province-name": "Koper"
        },
        {
          "province": "17",
          "province-name": "Kranj"
        },
        {
          "province": "18",
          "province-name": "Krsko"
        },
        {
          "province": "19",
          "province-name": "Lenart"
        },
        {
          "province": "20",
          "province-name": "Lendava"
        },
        {
          "province": "21",
          "province-name": "Litija"
        },
        {
          "province": "22",
          "province-name": "Ljubljana-Bezigrad"
        },
        {
          "province": "23",
          "province-name": "Ljubljana-Center"
        },
        {
          "province": "24",
          "province-name": "Ljubljana-Moste-Polj"
        },
        {
          "province": "25",
          "province-name": "Ljubljana-Siska"
        },
        {
          "province": "26",
          "province-name": "Ljubljana-Vic-Rudnik"
        },
        {
          "province": "27",
          "province-name": "Ljutomer"
        },
        {
          "province": "28",
          "province-name": "Logatec"
        },
        {
          "province": "29",
          "province-name": "Maribor"
        },
        {
          "province": "30",
          "province-name": "Metlika"
        },
        {
          "province": "31",
          "province-name": "Mozirje"
        },
        {
          "province": "32",
          "province-name": "Murska Sobota"
        },
        {
          "province": "33",
          "province-name": "Nova Gorica"
        },
        {
          "province": "34",
          "province-name": "Novo Mesto"
        },
        {
          "province": "35",
          "province-name": "Ormoz"
        },
        {
          "province": "36",
          "province-name": "Pesnica"
        },
        {
          "province": "37",
          "province-name": "Piran"
        },
        {
          "province": "38",
          "province-name": "Postojna"
        },
        {
          "province": "39",
          "province-name": "Ptuj"
        },
        {
          "province": "40",
          "province-name": "Radlje Ob Dravi"
        },
        {
          "province": "41",
          "province-name": "Radovljica"
        },
        {
          "province": "42",
          "province-name": "Ravne Na Koroskem"
        },
        {
          "province": "43",
          "province-name": "Ribnica"
        },
        {
          "province": "44",
          "province-name": "Ruse"
        },
        {
          "province": "45",
          "province-name": "Sentjur Pri Celju"
        },
        {
          "province": "46",
          "province-name": "Sevnica"
        },
        {
          "province": "47",
          "province-name": "Sezana"
        },
        {
          "province": "48",
          "province-name": "Skofja Loka"
        },
        {
          "province": "49",
          "province-name": "Slovenj Gradec"
        },
        {
          "province": "50",
          "province-name": "Slovenska Bistrica"
        },
        {
          "province": "51",
          "province-name": "Slovenske Konjice"
        },
        {
          "province": "52",
          "province-name": "Smarje Pri Jelsah"
        },
        {
          "province": "53",
          "province-name": "Tolmin"
        },
        {
          "province": "54",
          "province-name": "Trbovlje"
        },
        {
          "province": "55",
          "province-name": "Trebnje"
        },
        {
          "province": "56",
          "province-name": "Trzic"
        },
        {
          "province": "57",
          "province-name": "Velenje"
        },
        {
          "province": "58",
          "province-name": "Vrhnika"
        },
        {
          "province": "59",
          "province-name": "Zagorje Ob Savi"
        },
        {
          "province": "60",
          "province-name": "Zalec"
        }
      ],
      "SK": [
        {
          "province": "01",
          "province-name": "Bratislava"
        },
        {
          "province": "02",
          "province-name": "Zapadoslovensky"
        },
        {
          "province": "03",
          "province-name": "Stredoslovensky"
        },
        {
          "province": "04",
          "province-name": "Vychodoslovensky"
        }
      ],
      "TH": [
        {
          "province": "01",
          "province-name": "Amnat Charoen"
        },
        {
          "province": "02",
          "province-name": "Ang Thong"
        },
        {
          "province": "03",
          "province-name": "Buriram"
        },
        {
          "province": "04",
          "province-name": "Chachoengsao"
        },
        {
          "province": "05",
          "province-name": "Chai Nat"
        },
        {
          "province": "06",
          "province-name": "Chaiyaphum"
        },
        {
          "province": "07",
          "province-name": "Chanthaburi"
        },
        {
          "province": "08",
          "province-name": "Chiang Mai"
        },
        {
          "province": "09",
          "province-name": "Chiang Rai"
        },
        {
          "province": "10",
          "province-name": "Chon Buri"
        },
        {
          "province": "11",
          "province-name": "Chumphon"
        },
        {
          "province": "12",
          "province-name": "Kalasin"
        },
        {
          "province": "13",
          "province-name": "Kamphaeng Phet"
        },
        {
          "province": "14",
          "province-name": "Kanchanaburi"
        },
        {
          "province": "15",
          "province-name": "Khon Kaen"
        },
        {
          "province": "16",
          "province-name": "Krabi"
        },
        {
          "province": "17",
          "province-name": "Krung Thep"
        },
        {
          "province": "18",
          "province-name": "Mahanakhon"
        },
        {
          "province": "19",
          "province-name": "Lampang"
        },
        {
          "province": "20",
          "province-name": "Lamphun"
        },
        {
          "province": "21",
          "province-name": "Loei"
        },
        {
          "province": "22",
          "province-name": "Lop Buri"
        },
        {
          "province": "23",
          "province-name": "Mae Hong Son"
        },
        {
          "province": "24",
          "province-name": "Maha Sarakham"
        },
        {
          "province": "25",
          "province-name": "Mukdahan"
        },
        {
          "province": "26",
          "province-name": "Nakhon Nayok"
        },
        {
          "province": "27",
          "province-name": "Nakhon Pathom"
        },
        {
          "province": "28",
          "province-name": "Nakhon Phanom"
        },
        {
          "province": "29",
          "province-name": "Nakhon Ratchasima"
        },
        {
          "province": "30",
          "province-name": "Nakhon Sawan"
        },
        {
          "province": "31",
          "province-name": "Nakhon Si Thammarat"
        },
        {
          "province": "32",
          "province-name": "Nan"
        },
        {
          "province": "33",
          "province-name": "Narathiwat"
        },
        {
          "province": "34",
          "province-name": "Nong Bua Lamphu"
        },
        {
          "province": "35",
          "province-name": "Nong Khai"
        },
        {
          "province": "36",
          "province-name": "Nonthaburi"
        },
        {
          "province": "37",
          "province-name": "Pathum Thani"
        },
        {
          "province": "38",
          "province-name": "Pattani"
        },
        {
          "province": "39",
          "province-name": "Phangnga"
        },
        {
          "province": "40",
          "province-name": "Phatthalung"
        },
        {
          "province": "41",
          "province-name": "Phayao"
        },
        {
          "province": "42",
          "province-name": "Phetchabun"
        },
        {
          "province": "43",
          "province-name": "Phetchaburi"
        },
        {
          "province": "44",
          "province-name": "Phichit"
        },
        {
          "province": "45",
          "province-name": "Phitsanulok"
        },
        {
          "province": "46",
          "province-name": "Phra Nakhon Si Ayut."
        },
        {
          "province": "47",
          "province-name": "Phrae"
        },
        {
          "province": "48",
          "province-name": "Phuket"
        },
        {
          "province": "49",
          "province-name": "Prachin Buri"
        }
      ],
      "TR": [
        {
          "province": "01",
          "province-name": "Adana"
        },
        {
          "province": "02",
          "province-name": "Adiyaman"
        },
        {
          "province": "03",
          "province-name": "Afyon"
        },
        {
          "province": "04",
          "province-name": "Agri"
        },
        {
          "province": "05",
          "province-name": "Amasya"
        },
        {
          "province": "06",
          "province-name": "Ankara"
        },
        {
          "province": "07",
          "province-name": "Antalya"
        },
        {
          "province": "08",
          "province-name": "Artvin"
        },
        {
          "province": "09",
          "province-name": "Aydin"
        },
        {
          "province": "10",
          "province-name": "Balikesir"
        },
        {
          "province": "11",
          "province-name": "Bilecik"
        },
        {
          "province": "12",
          "province-name": "Bingöl"
        },
        {
          "province": "13",
          "province-name": "Bitlis"
        },
        {
          "province": "14",
          "province-name": "Bolu"
        },
        {
          "province": "15",
          "province-name": "Burdur"
        },
        {
          "province": "16",
          "province-name": "Bursa"
        },
        {
          "province": "17",
          "province-name": "Canakkale"
        },
        {
          "province": "18",
          "province-name": "Cankiri"
        },
        {
          "province": "19",
          "province-name": "Corum"
        },
        {
          "province": "20",
          "province-name": "Denizli"
        },
        {
          "province": "21",
          "province-name": "Diyarbakir"
        },
        {
          "province": "22",
          "province-name": "Edirne"
        },
        {
          "province": "23",
          "province-name": "Elazig"
        },
        {
          "province": "24",
          "province-name": "Erzincan"
        },
        {
          "province": "25",
          "province-name": "Erzurum"
        },
        {
          "province": "26",
          "province-name": "Eskisehir"
        },
        {
          "province": "27",
          "province-name": "Gaziantep"
        },
        {
          "province": "28",
          "province-name": "Giresun"
        },
        {
          "province": "29",
          "province-name": "Gümüshane"
        },
        {
          "province": "30",
          "province-name": "Hakkari"
        },
        {
          "province": "31",
          "province-name": "Hatay"
        },
        {
          "province": "32",
          "province-name": "Isparta"
        },
        {
          "province": "33",
          "province-name": "Icel"
        },
        {
          "province": "34",
          "province-name": "Istanbul"
        },
        {
          "province": "35",
          "province-name": "Izmir"
        },
        {
          "province": "36",
          "province-name": "Kars"
        },
        {
          "province": "37",
          "province-name": "Kastamonu"
        },
        {
          "province": "38",
          "province-name": "Kayseri"
        },
        {
          "province": "39",
          "province-name": "Kirklareli"
        },
        {
          "province": "40",
          "province-name": "Kirshehir"
        },
        {
          "province": "41",
          "province-name": "Kocaeli"
        },
        {
          "province": "42",
          "province-name": "Konya"
        },
        {
          "province": "43",
          "province-name": "Kütahya"
        },
        {
          "province": "44",
          "province-name": "Malatya"
        },
        {
          "province": "45",
          "province-name": "Manisa"
        },
        {
          "province": "46",
          "province-name": "K.Marash"
        },
        {
          "province": "47",
          "province-name": "Mardin"
        },
        {
          "province": "48",
          "province-name": "Mugla"
        },
        {
          "province": "49",
          "province-name": "Mush"
        },
        {
          "province": "50",
          "province-name": "Nevshehir"
        },
        {
          "province": "51",
          "province-name": "Nigde"
        },
        {
          "province": "52",
          "province-name": "Ordu"
        },
        {
          "province": "53",
          "province-name": "Rize"
        },
        {
          "province": "54",
          "province-name": "Sakarya"
        },
        {
          "province": "55",
          "province-name": "Samsun"
        },
        {
          "province": "56",
          "province-name": "Siirt"
        },
        {
          "province": "57",
          "province-name": "Sinop"
        },
        {
          "province": "58",
          "province-name": "Sivas"
        },
        {
          "province": "59",
          "province-name": "Tekirdag"
        },
        {
          "province": "60",
          "province-name": "Tokat"
        },
        {
          "province": "61",
          "province-name": "Trabzon"
        },
        {
          "province": "62",
          "province-name": "Tunceli"
        },
        {
          "province": "63",
          "province-name": "Shanliurfa"
        },
        {
          "province": "64",
          "province-name": "Ushak"
        },
        {
          "province": "65",
          "province-name": "Van"
        },
        {
          "province": "66",
          "province-name": "Yozgat"
        },
        {
          "province": "67",
          "province-name": "Zonguldak"
        },
        {
          "province": "68",
          "province-name": "Aksaray"
        },
        {
          "province": "69",
          "province-name": "Bayburt"
        },
        {
          "province": "70",
          "province-name": "Karaman"
        },
        {
          "province": "71",
          "province-name": "Kirikkale"
        },
        {
          "province": "72",
          "province-name": "Batman"
        },
        {
          "province": "73",
          "province-name": "Shirnak"
        },
        {
          "province": "74",
          "province-name": "Bartin"
        },
        {
          "province": "75",
          "province-name": "Ardahan"
        },
        {
          "province": "76",
          "province-name": "Igdir"
        },
        {
          "province": "77",
          "province-name": "Yalova"
        }
      ],
      "TW": [
        {
          "province": "FJN",
          "province-name": "Fu-chien"
        },
        {
          "province": "KSH",
          "province-name": "Kao-hsiung"
        },
        {
          "province": "TPE",
          "province-name": "T´ai-pei"
        },
        {
          "province": "TWN",
          "province-name": "Taiwan"
        }
      ],
      "UA": [
        {
          "province": "CHG",
          "province-name": "Chernigivs'ka"
        },
        {
          "province": "CHR",
          "province-name": "Cherkas'ka"
        },
        {
          "province": "CHV",
          "province-name": "Chernovits'ka"
        },
        {
          "province": "DNP",
          "province-name": "Dnipropetrovs'ka"
        },
        {
          "province": "DON",
          "province-name": "Donets'ka"
        },
        {
          "province": "HAR",
          "province-name": "Harkivs'ka"
        },
        {
          "province": "HML",
          "province-name": "Hmel'nits'ka"
        },
        {
          "province": "HRS",
          "province-name": "Hersons'ka"
        },
        {
          "province": "IVF",
          "province-name": "Ivano-Frankivs'ka"
        },
        {
          "province": "KIE",
          "province-name": "Kievs'ka"
        },
        {
          "province": "KIR",
          "province-name": "Kirovograds'ka"
        },
        {
          "province": "KRM",
          "province-name": "Respublika Krim"
        },
        {
          "province": "LUG",
          "province-name": "Lugans'ka"
        },
        {
          "province": "L'V",
          "province-name": "L'vivsbka"
        },
        {
          "province": "M_K",
          "province-name": "m.Kiev"
        },
        {
          "province": "M_S",
          "province-name": "m.Sevastopil'"
        },
        {
          "province": "MIK",
          "province-name": "Mikolaivs'ka"
        },
        {
          "province": "ODS",
          "province-name": "Odes'ka"
        },
        {
          "province": "POL",
          "province-name": "Poltavs'ka"
        },
        {
          "province": "RIV",
          "province-name": "Rivnens'ka"
        },
        {
          "province": "SUM",
          "province-name": "Sums'ka"
        },
        {
          "province": "TER",
          "province-name": "Ternopil's'ka"
        },
        {
          "province": "VIN",
          "province-name": "Vinnits'ka"
        },
        {
          "province": "VOL",
          "province-name": "Volins'ka"
        },
        {
          "province": "ZAK",
          "province-name": "Zakarpats'ka"
        },
        {
          "province": "ZAP",
          "province-name": "Zaporiz'ka"
        },
        {
          "province": "ZHI",
          "province-name": "Zhitomirs'ka"
        }
      ],
      "US": [
        {
          "province": "AA",
          "province-name": "Armed Forces America"
        },
        {
          "province": "AE",
          "province-name": "Armed Forces Europe"
        },
        {
          "province": "AK",
          "province-name": "Alaska"
        },
        {
          "province": "AL",
          "province-name": "Alabama"
        },
        {
          "province": "AP",
          "province-name": "Armed Forces Pacific"
        },
        {
          "province": "AR",
          "province-name": "Arkansas"
        },
        {
          "province": "AS",
          "province-name": "American Samoa"
        },
        {
          "province": "AZ",
          "province-name": "Arizona"
        },
        {
          "province": "CA",
          "province-name": "California"
        },
        {
          "province": "CO",
          "province-name": "Colorado"
        },
        {
          "province": "CT",
          "province-name": "Connecticut"
        },
        {
          "province": "DC",
          "province-name": "District of Columbia"
        },
        {
          "province": "DE",
          "province-name": "Delaware"
        },
        {
          "province": "FL",
          "province-name": "Florida"
        },
        {
          "province": "GA",
          "province-name": "Georgia"
        },
        {
          "province": "GU",
          "province-name": "Guam"
        },
        {
          "province": "HI",
          "province-name": "Hawaii"
        },
        {
          "province": "IA",
          "province-name": "Iowa"
        },
        {
          "province": "ID",
          "province-name": "Idaho"
        },
        {
          "province": "IL",
          "province-name": "Illinois"
        },
        {
          "province": "IN",
          "province-name": "Indiana"
        },
        {
          "province": "KS",
          "province-name": "Kansas"
        },
        {
          "province": "KY",
          "province-name": "Kentucky"
        },
        {
          "province": "LA",
          "province-name": "Louisiana"
        },
        {
          "province": "MA",
          "province-name": "Massachusetts"
        },
        {
          "province": "MD",
          "province-name": "Maryland"
        },
        {
          "province": "ME",
          "province-name": "Maine"
        },
        {
          "province": "MI",
          "province-name": "Michigan"
        },
        {
          "province": "MN",
          "province-name": "Minnesota"
        },
        {
          "province": "MO",
          "province-name": "Missouri"
        },
        {
          "province": "MP",
          "province-name": "Northern Mariana Isl"
        },
        {
          "province": "MS",
          "province-name": "Mississippi"
        },
        {
          "province": "MT",
          "province-name": "Montana"
        },
        {
          "province": "NC",
          "province-name": "North Carolina"
        },
        {
          "province": "ND",
          "province-name": "North Dakota"
        },
        {
          "province": "NE",
          "province-name": "Nebraska"
        },
        {
          "province": "NH",
          "province-name": "New Hampshire"
        },
        {
          "province": "NJ",
          "province-name": "New Jersey"
        },
        {
          "province": "NM",
          "province-name": "New Mexico"
        },
        {
          "province": "NP",
          "province-name": "No Plate"
        },
        {
          "province": "NV",
          "province-name": "Nevada"
        },
        {
          "province": "NY",
          "province-name": "New York"
        },
        {
          "province": "OH",
          "province-name": "Ohio"
        },
        {
          "province": "OK",
          "province-name": "Oklahoma"
        },
        {
          "province": "OR",
          "province-name": "Oregon"
        },
        {
          "province": "PA",
          "province-name": "Pennsylvania"
        },
        {
          "province": "PP",
          "province-name": "Paper Plate"
        },
        {
          "province": "PR",
          "province-name": "Puerto Rico"
        },
        {
          "province": "RI",
          "province-name": "Rhode Island"
        },
        {
          "province": "SC",
          "province-name": "South Carolina"
        },
        {
          "province": "SD",
          "province-name": "South Dakota"
        },
        {
          "province": "TN",
          "province-name": "Tennessee"
        },
        {
          "province": "TX",
          "province-name": "Texas"
        },
        {
          "province": "UT",
          "province-name": "Utah"
        },
        {
          "province": "VA",
          "province-name": "Virginia"
        },
        {
          "province": "VI",
          "province-name": "Virgin Islands"
        },
        {
          "province": "VT",
          "province-name": "Vermont"
        },
        {
          "province": "WA",
          "province-name": "Washington"
        },
        {
          "province": "WI",
          "province-name": "Wisconsin"
        },
        {
          "province": "WV",
          "province-name": "West Virginia"
        },
        {
          "province": "WY",
          "province-name": "Wyoming"
        }
      ],
      "UY": [],
      "VE": [
        {
          "province": "AMA",
          "province-name": "Amazon"
        },
        {
          "province": "ANZ",
          "province-name": "Anzoategui"
        },
        {
          "province": "APU",
          "province-name": "Apure"
        },
        {
          "province": "ARA",
          "province-name": "Aragua"
        },
        {
          "province": "BAR",
          "province-name": "Barinas"
        },
        {
          "province": "BOL",
          "province-name": "Bolivar"
        },
        {
          "province": "CAR",
          "province-name": "Carabobo"
        },
        {
          "province": "COJ",
          "province-name": "Cojedes"
        },
        {
          "province": "DA",
          "province-name": "Delta Amacuro"
        },
        {
          "province": "DF",
          "province-name": "Distrito Federal"
        },
        {
          "province": "FAL",
          "province-name": "Falcon"
        },
        {
          "province": "GUA",
          "province-name": "Guarico"
        },
        {
          "province": "LAR",
          "province-name": "Lara"
        },
        {
          "province": "MER",
          "province-name": "Merida"
        },
        {
          "province": "MIR",
          "province-name": "Miranda"
        },
        {
          "province": "MON",
          "province-name": "Monagas"
        },
        {
          "province": "NE",
          "province-name": "Nueva Esparta"
        },
        {
          "province": "POR",
          "province-name": "Portuguesa"
        },
        {
          "province": "SUC",
          "province-name": "Sucre"
        },
        {
          "province": "TAC",
          "province-name": "Tachira"
        },
        {
          "province": "TRU",
          "province-name": "Trujillo"
        },
        {
          "province": "VAR",
          "province-name": "Vargas"
        },
        {
          "province": "YAR",
          "province-name": "Yaracuy"
        },
        {
          "province": "ZUL",
          "province-name": "Zulia"
        }
      ],
      "VI": [],
      "VG": [],
      "ZA": [
        {
          "province": "EC",
          "province-name": "Eastern Cape"
        },
        {
          "province": "FS",
          "province-name": "Freestate"
        },
        {
          "province": "GP",
          "province-name": "Gauteng"
        },
        {
          "province": "KZN",
          "province-name": "Kwazulu/Natal"
        },
        {
          "province": "MP",
          "province-name": "Mpumalanga"
        },
        {
          "province": "NC",
          "province-name": "Northern Cape"
        },
        {
          "province": "NP",
          "province-name": "Northern Province"
        },
        {
          "province": "NW",
          "province-name": "North-West"
        },
        {
          "province": "WC",
          "province-name": "Western Cape"
        }
      ]
    };

    var codeToCountry = {
      'AF': 'Afghanistan',
      'AX': 'Åland Islands',
      'AL': 'Albania',
      'DZ': 'Algeria',
      'AS': 'American Samoa',
      'AD': 'Andorra',
      'AO': 'Angola',
      'AI': 'Anguilla',
      'AQ': 'Antarctica',
      'AG': 'Antigua and Barbuda',
      'AR': 'Argentina',
      'AM': 'Armenia',
      'AW': 'Aruba',
      'AU': 'Australia',
      'AT': 'Austria',
      'AZ': 'Azerbaijan',
      'BS': 'Bahamas',
      'BH': 'Bahrain',
      'BD': 'Bangladesh',
      'BB': 'Barbados',
      'BY': 'Belarus',
      'BE': 'Belgium',
      'BZ': 'Belize',
      'BJ': 'Benin',
      'BM': 'Bermuda',
      'BT': 'Bhutan',
      'BO': 'Bolivia, Plurinational State of',
      'BQ': 'Bonaire, Sint Eustatius and Saba',
      'BA': 'Bosnia and Herzegovina',
      'BW': 'Botswana',
      'BV': 'Bouvet Island',
      'BR': 'Brazil',
      'IO': 'British Indian Ocean Territory',
      'BN': 'Brunei Darussalam',
      'BG': 'Bulgaria',
      'BF': 'Burkina Faso',
      'BI': 'Burundi',
      'KH': 'Cambodia',
      'CM': 'Cameroon',
      'CA': 'Canada',
      'CV': 'Cape Verde',
      'KY': 'Cayman Islands',
      'CF': 'Central African Republic',
      'TD': 'Chad',
      'CL': 'Chile',
      'CN': 'China',
      'CX': 'Christmas Island',
      'CC': 'Cocos (keeling) Islands',
      'CO': 'Colombia',
      'KM': 'Comoros',
      'CG': 'Congo',
      'CD': 'Congo, The Democratic Republic of The',
      'CK': 'Cook Islands',
      'CR': 'Costa Rica',
      'CI': 'Côte D\'Ivoire',
      'HR': 'Croatia',
      'CU': 'Cuba',
      'CW': 'Curaçao',
      'CY': 'Cyprus',
      'CZ': 'Czech Republic',
      'DK': 'Denmark',
      'DJ': 'Djibouti',
      'DM': 'Dominica',
      'DO': 'Dominican Republic',
      'EC': 'Ecuador',
      'EG': 'Egypt',
      'SV': 'El Salvador',
      'GQ': 'Equatorial Guinea',
      'ER': 'Eritrea',
      'EE': 'Estonia',
      'ET': 'Ethiopia',
      'FK': 'Falkland Islands (malvinas)',
      'FO': 'Faroe Islands',
      'FJ': 'Fiji',
      'FI': 'Finland',
      'FR': 'France',
      'GF': 'French Guiana',
      'PF': 'French Polynesia',
      'TF': 'French Southern Territories',
      'GA': 'Gabon',
      'GM': 'Gambia',
      'GE': 'Georgia',
      'DE': 'Germany',
      'GH': 'Ghana',
      'GI': 'Gibraltar',
      'GR': 'Greece',
      'GL': 'Greenland',
      'GD': 'Grenada',
      'GP': 'Guadeloupe',
      'GU': 'Guam',
      'GT': 'Guatemala',
      'GG': 'Guernsey',
      'GN': 'Guinea',
      'GW': 'Guinea-bissau',
      'GY': 'Guyana',
      'HT': 'Haiti',
      'HM': 'Heard Island and Mcdonald Islands',
      'VA': 'Holy See (vatican City State)',
      'HN': 'Honduras',
      'HK': 'Hong Kong',
      'HU': 'Hungary',
      'IS': 'Iceland',
      'IN': 'India',
      'ID': 'Indonesia',
      'IR': 'Iran, Islamic Republic of',
      'IQ': 'Iraq',
      'IE': 'Ireland',
      'IM': 'Isle of Man',
      'IL': 'Israel',
      'IT': 'Italy',
      'JM': 'Jamaica',
      'JP': 'Japan',
      'JE': 'Jersey',
      'JO': 'Jordan',
      'KZ': 'Kazakhstan',
      'KE': 'Kenya',
      'KI': 'Kiribati',
      'KP': 'Korea, Democratic People\'s Republic of',
      'KR': 'Korea, Republic of',
      'KW': 'Kuwait',
      'KG': 'Kyrgyzstan',
      'LA': 'Lao People\'s Democratic Republic',
      'LV': 'Latvia',
      'LB': 'Lebanon',
      'LS': 'Lesotho',
      'LR': 'Liberia',
      'LY': 'Libya',
      'LI': 'Liechtenstein',
      'LT': 'Lithuania',
      'LU': 'Luxembourg',
      'MO': 'Macao',
      'MK': 'Macedonia, The Former Yugoslav Republic of',
      'MG': 'Madagascar',
      'MW': 'Malawi',
      'MY': 'Malaysia',
      'MV': 'Maldives',
      'ML': 'Mali',
      'MT': 'Malta',
      'MH': 'Marshall Islands',
      'MQ': 'Martinique',
      'MR': 'Mauritania',
      'MU': 'Mauritius',
      'YT': 'Mayotte',
      'MX': 'Mexico',
      'FM': 'Micronesia, Federated States of',
      'MD': 'Moldova, Republic of',
      'MC': 'Monaco',
      'MN': 'Mongolia',
      'ME': 'Montenegro',
      'MS': 'Montserrat',
      'MA': 'Morocco',
      'MZ': 'Mozambique',
      'MM': 'Myanmar',
      'NA': 'Namibia',
      'NR': 'Nauru',
      'NP': 'Nepal',
      'NL': 'Netherlands',
      'NC': 'New Caledonia',
      'NZ': 'New Zealand',
      'NI': 'Nicaragua',
      'NE': 'Niger',
      'NG': 'Nigeria',
      'NU': 'Niue',
      'NF': 'Norfolk Island',
      'MP': 'Northern Mariana Islands',
      'NO': 'Norway',
      'OM': 'Oman',
      'PK': 'Pakistan',
      'PW': 'Palau',
      'PS': 'Palestine, State of',
      'PA': 'Panama',
      'PG': 'Papua New Guinea',
      'PY': 'Paraguay',
      'PE': 'Peru',
      'PH': 'Philippines',
      'PN': 'Pitcairn',
      'PL': 'Poland',
      'PT': 'Portugal',
      'PR': 'Puerto Rico',
      'QA': 'Qatar',
      'RE': 'Réunion',
      'RO': 'Romania',
      'RU': 'Russian Federation',
      'RW': 'Rwanda',
      'BL': 'Saint Barthélemy',
      'SH': 'Saint Helena, Ascension and Tristan Da Cunha',
      'KN': 'Saint Kitts and Nevis',
      'LC': 'Saint Lucia',
      'MF': 'Saint Martin (French Part)',
      'PM': 'Saint Pierre and Miquelon',
      'VC': 'Saint Vincent and The Grenadines',
      'WS': 'Samoa',
      'SM': 'San Marino',
      'ST': 'Sao Tome and Principe',
      'SA': 'Saudi Arabia',
      'SN': 'Senegal',
      'RS': 'Serbia',
      'SC': 'Seychelles',
      'SL': 'Sierra Leone',
      'SG': 'Singapore',
      'SX': 'Sint Maarten (Dutch Part)',
      'SK': 'Slovakia',
      'SI': 'Slovenia',
      'SB': 'Solomon Islands',
      'SO': 'Somalia',
      'ZA': 'South Africa',
      'GS': 'South Georgia and The South Sandwich Islands',
      'SS': 'South Sudan',
      'ES': 'Spain',
      'LK': 'Sri Lanka',
      'SD': 'Sudan',
      'SR': 'Suriname',
      'SJ': 'Svalbard and Jan Mayen',
      'SZ': 'Swaziland',
      'SE': 'Sweden',
      'CH': 'Switzerland',
      'SY': 'Syrian Arab Republic',
      'TW': 'Taiwan, Province of China',
      'TJ': 'Tajikistan',
      'TZ': 'Tanzania, United Republic of',
      'TH': 'Thailand',
      'TL': 'Timor-leste',
      'TG': 'Togo',
      'TK': 'Tokelau',
      'TO': 'Tonga',
      'TT': 'Trinidad and Tobago',
      'TN': 'Tunisia',
      'TR': 'Turkey',
      'TM': 'Turkmenistan',
      'TC': 'Turks and Caicos Islands',
      'TV': 'Tuvalu',
      'UG': 'Uganda',
      'UA': 'Ukraine',
      'AE': 'United Arab Emirates',
      'UK': 'United Kingdom',
      'US': 'United States',
      'UM': 'United States Minor Outlying Islands',
      'UY': 'Uruguay',
      'UZ': 'Uzbekistan',
      'VU': 'Vanuatu',
      'VE': 'Venezuela, Bolivarian Republic of',
      'VN': 'Viet Nam',
      'VG': 'Virgin Islands, British',
      'VI': 'Virgin Islands, U.s.',
      'WF': 'Wallis and Futuna',
      'EH': 'Western Sahara',
      'YE': 'Yemen',
      'ZM': 'Zambia',
      'ZW': 'Zimbabwe'
    };

    var countryCodeToContinent = {
      'AD': 'Europe',
      'AE': 'Asia',
      'AF': 'Asia',
      'AG': 'North America',
      'AI': 'North America',
      'AL': 'Europe',
      'AM': 'Asia',
      'AN': 'North America',
      'AO': 'Africa',
      'AP': 'Asia',
      'AQ': 'Antartica',
      'AR': 'South America',
      'AS': 'Oceania',
      'AT': 'Europe',
      'AU': 'Oceania',
      'AW': 'North America',
      'AX': 'Europe',
      'AZ': 'Asia',
      'BA': 'Europe',
      'BB': 'North America',
      'BD': 'Asia',
      'BE': 'Europe',
      'BF': 'Africa',
      'BG': 'Europe',
      'BH': 'Asia',
      'BI': 'Africa',
      'BJ': 'Africa',
      'BL': 'North America',
      'BM': 'North America',
      'BN': 'Asia',
      'BO': 'South America',
      'BQ': 'South America',
      'BR': 'South America',
      'BS': 'North America',
      'BT': 'Asia',
      'BV': 'Antartica',
      'BW': 'Africa',
      'BY': 'Europe',
      'BZ': 'North America',
      'CA': 'North America',
      'CC': 'Asia',
      'CD': 'Africa',
      'CF': 'Africa',
      'CG': 'Africa',
      'CH': 'Europe',
      'CI': 'Africa',
      'CK': 'Oceania',
      'CL': 'South America',
      'CM': 'Africa',
      'CN': 'Asia',
      'CO': 'South America',
      'CR': 'North America',
      'CU': 'North America',
      'CV': 'Africa',
      'CX': 'Asia',
      'CY': 'Europe',
      'CZ': 'Europe',
      'DE': 'Europe',
      'DJ': 'Africa',
      'DK': 'Europe',
      'DM': 'North America',
      'DO': 'North America',
      'DZ': 'Africa',
      'EC': 'South America',
      'EE': 'Europe',
      'EG': 'Africa',
      'EH': 'Africa',
      'ER': 'Africa',
      'ES': 'Europe',
      'ET': 'Africa',
      'EU': 'Europe',
      'FI': 'Europe',
      'FJ': 'Oceania',
      'FK': 'South America',
      'FM': 'Oceania',
      'FO': 'Europe',
      'FR': 'Europe',
      'FX': 'Europe',
      'GA': 'Africa',
      'UK': 'Europe',
      'GD': 'North America',
      'GE': 'Asia',
      'GF': 'South America',
      'GG': 'Europe',
      'GH': 'Africa',
      'GI': 'Europe',
      'GL': 'North America',
      'GM': 'Africa',
      'GN': 'Africa',
      'GP': 'North America',
      'GQ': 'Africa',
      'GR': 'Europe',
      'GS': 'Antartica',
      'GT': 'North America',
      'GU': 'Oceania',
      'GW': 'Africa',
      'GY': 'South America',
      'HK': 'Asia',
      'HM': 'Antartica',
      'HN': 'North America',
      'HR': 'Europe',
      'HT': 'North America',
      'HU': 'Europe',
      'ID': 'Asia',
      'IE': 'Europe',
      'IL': 'Asia',
      'IM': 'Europe',
      'IN': 'Asia',
      'IO': 'Asia',
      'IQ': 'Asia',
      'IR': 'Asia',
      'IS': 'Europe',
      'IT': 'Europe',
      'JE': 'Europe',
      'JM': 'North America',
      'JO': 'Asia',
      'JP': 'Asia',
      'KE': 'Africa',
      'KG': 'Asia',
      'KH': 'Asia',
      'KI': 'Oceania',
      'KM': 'Africa',
      'KN': 'North America',
      'KP': 'Asia',
      'KR': 'Asia',
      'KW': 'Asia',
      'KY': 'North America',
      'KZ': 'Asia',
      'LA': 'Asia',
      'LB': 'Asia',
      'LC': 'North America',
      'LI': 'Europe',
      'LK': 'Asia',
      'LR': 'Africa',
      'LS': 'Africa',
      'LT': 'Europe',
      'LU': 'Europe',
      'LV': 'Europe',
      'LY': 'Africa',
      'MA': 'Africa',
      'MC': 'Europe',
      'MD': 'Europe',
      'ME': 'Europe',
      'MF': 'North America',
      'MG': 'Africa',
      'MH': 'Oceania',
      'MK': 'Europe',
      'ML': 'Africa',
      'MM': 'Asia',
      'MN': 'Asia',
      'MO': 'Asia',
      'MP': 'Oceania',
      'MQ': 'North America',
      'MR': 'Africa',
      'MS': 'North America',
      'MT': 'Europe',
      'MU': 'Africa',
      'MV': 'Asia',
      'MW': 'Africa',
      'MX': 'North America',
      'MY': 'Asia',
      'MZ': 'Africa',
      'NA': 'Africa',
      'NC': 'Oceania',
      'NE': 'Africa',
      'NF': 'Oceania',
      'NG': 'Africa',
      'NI': 'North America',
      'NL': 'Europe',
      'NO': 'Europe',
      'NP': 'Asia',
      'NR': 'Oceania',
      'NU': 'Oceania',
      'NZ': 'Oceania',
      'OM': 'Asia',
      'PA': 'North America',
      'PE': 'South America',
      'PF': 'Oceania',
      'PG': 'Oceania',
      'PH': 'Asia',
      'PK': 'Asia',
      'PL': 'Europe',
      'PM': 'North America',
      'PN': 'Oceania',
      'PR': 'North America',
      'PS': 'Asia',
      'PT': 'Europe',
      'PW': 'Oceania',
      'PY': 'South America',
      'QA': 'Asia',
      'RE': 'Africa',
      'RO': 'Europe',
      'RS': 'Europe',
      'RU': 'Europe',
      'RW': 'Africa',
      'SA': 'Asia',
      'SB': 'Oceania',
      'SC': 'Africa',
      'SD': 'Africa',
      'SE': 'Europe',
      'SG': 'Asia',
      'SH': 'Africa',
      'SI': 'Europe',
      'SJ': 'Europe',
      'SK': 'Europe',
      'SL': 'Africa',
      'SM': 'Europe',
      'SN': 'Africa',
      'SO': 'Africa',
      'SR': 'South America',
      'ST': 'Africa',
      'SV': 'North America',
      'SY': 'Asia',
      'SZ': 'Africa',
      'TC': 'North America',
      'TD': 'Africa',
      'TF': 'Antartica',
      'TG': 'Africa',
      'TH': 'Asia',
      'TJ': 'Asia',
      'TK': 'Oceania',
      'TL': 'Asia',
      'TM': 'Asia',
      'TN': 'Africa',
      'TO': 'Oceania',
      'TR': 'Europe',
      'TT': 'North America',
      'TV': 'Oceania',
      'TW': 'Asia',
      'TZ': 'Africa',
      'UA': 'Europe',
      'UG': 'Africa',
      'UM': 'Oceania',
      'US': 'North America',
      'UY': 'South America',
      'UZ': 'Asia',
      'VA': 'Europe',
      'VC': 'North America',
      'VE': 'South America',
      'VG': 'North America',
      'VI': 'North America',
      'VN': 'Asia',
      'VU': 'Oceania',
      'WF': 'Oceania',
      'WS': 'Oceania',
      'YE': 'Asia',
      'YT': 'Africa',
      'ZA': 'Africa',
      'ZM': 'Africa',
      'ZW': 'Africa'
    };

    var regionService = {
      lookup: function (abbr) {
        return regions[abbr.toUpperCase()] || abbr;
      },
      lookupRegionFromCountry: function (country, province) {
        if (countries[country]) {
          var result = countries[country].filter(function (data) {
            return data.province === province
          });
          return result.length === 0 ? province : result[0]['province-name'];
        }
        else {
          return country;
        }
      },
      lookupCountryNameFromCode: function (countryCode) {
        return codeToCountry[countryCode];
      },
      lookupContinent: function (countryCode) {
        return countryCodeToContinent[countryCode];
      },
      getUnitByCountry: function (countryCode) {
        var countriesWithMiles = ['LR', 'MM', 'UK', 'US'];
        if (countriesWithMiles.includes(countryCode)) {
          return 'mi'
        } else {
          return 'km'
        }
      },
      getCountryUnitFromBrowser: function (){
        return regionService.getCountryCodeFromBrowser().then(function(GeolocationPosition){
          return regionService.getCountryFromGoogleMap(GeolocationPosition.coords.latitude,  GeolocationPosition.coords.longitude).then(function(code){
            return regionService.getUnitByCountry(code);
          })
        }).catch(function(){
          return DEFAULT_UNIT
        })
      },
      getCurrentCountryUnit: function () {
        return storeLocatorCache.get('countryUnit') || DEFAULT_UNIT;
      },
      getCountryCodeFromBrowser: function() {
        if (navigator.geolocation) {
          return new Promise(function(resolve, reject) {
            return navigator.geolocation.getCurrentPosition(resolve, reject, { timeout: 5000 })
          });
        } else {
          throw "Geolocation services are not supported by your browser."
        }
      },
      getCountryFromGoogleMap: function (lat, lng) {
        if (mapHelper.isGoogleMapsEnabled()) {
          return $http.get(GOOGLE_GEOCODE_URL, {
              params: {
                latlng: lat + ',' + lng,
                sensor: false,
                key: GOOGLE_API_KEY
              }
            })
            .then(function (response) {
              if (response.data.status == 'OK') {
                var address_components = response.data.results[0].address_components;
                var countryCode = undefined
                address_components.forEach(function (element) {
                  if (element.types.includes('country')) {
                    countryCode = element.short_name;
                  }
                });
                return countryCode;
              } else {
                throw "Error: " + response.data.error_message
              }
            });
        } else {
          return Promise.resolve(STORE_LOCATOR_SEARCH_COUNTRY.split(',')[0]);
        }
      },
      getDistanceString: function (distance){
        var countryUnit = regionService.getCurrentCountryUnit();
        if (countryUnit == 'km') {
          distance = distance * KM_TO_MILES
        }
        return (Number(distance)).toFixed(1) + ' ' + countryUnit + '.'
      },
      getRegionName: function (keyRegion){
        if(regions[keyRegion]){
          return regions[keyRegion]
        }
      },
      getRegionCode: function (regionName) {
        if (regions[regionName]) {
          return regionName;
        }
        for (var key in regions) {
          if (regions[key] === regionName) {
            return key;
          }
        }
      },
    }

    return regionService;
  }
}());

(function() {
  'use strict';

  angular
    .module('storeLocator')
    .factory('pubSub', pubSub);

  function pubSub() {

    var listeners = [];

    function subscribe(callback) {
      listeners.push(callback);
    }

    function unsubscribe(callback) {
      var index = listeners.indexOf(callback);
      if (index > -1) {
        listeners.splice(index, 1);
      }
    }

    function publish(message) {
      for (var i = 0; i < listeners.length; i++) {
        listeners[i](message);
      }
    }

    return {
      subscribe: subscribe,
      unsubscribe: unsubscribe,
      publish: publish
    }
  };
})();

(function () {
  'use strict';
  angular
    .module("storeLocator")
    .factory('moment', MomentService);

  function MomentService($window) {
    return $window.moment; // assumes underscore has already been loaded on the page
  }
}());

(function () {
    'use strict';

    angular
        .module('storeLocator')
        .factory('MFeedMarkerService', MFeedMarkerService);

    MFeedMarkerService.$inject = [
        'STORE_LOCATOR_PIN',
        'STORE_LOCATOR_PIN_ICON',
        '$compile',
        'mapService',
        'storeLocatorDictionary',
        'mapHelper',
        'customFieldFactory',
        'MFeedMap',
        'pubSub',
        'storeLocatorCache',
        'CLIENT_NAME',
        'CLIENT_ROUTE',
        'STORE_LOCATOR_MAP_CONFIGS',
        'HAS_MULTILINGUAL',
        'LanguageService'
    ];
    function MFeedMarkerService(
        STORE_LOCATOR_PIN,
        STORE_LOCATOR_PIN_ICON,
        $compile,
        mapService,
        storeLocatorDictionary,
        mapHelper,
        customFieldFactory,
        MFeedMap,
        pubSub,
        storeLocatorCache,
        CLIENT_NAME,
        CLIENT_ROUTE,
        STORE_LOCATOR_MAP_CONFIGS,
        HAS_MULTILINGUAL,
        LanguageService) {
        var service = {
            createMFMarker: createMFMarker,
            loadClusterPinImage: loadClusterPinImage,
            addClustersClickHandler: addClustersClickHandler,
            showClusterPopup: showClusterPopup,
            findMarker: findMarker,
            updateMarkerAndPublishEvent: updateMarkerAndPublishEvent,
            closeAllPopups: closeAllPopups
        };

        return service;

        function createMFMarker(mfMap, location, locatorStates, scope) {
            if (mapHelper.isGoogleMapsEnabled()) {
                return createGoogleMarker(mfMap.map, location, locatorStates, scope);
            }
            else {
                return createMapboxMarker(mfMap.map, location, locatorStates, scope);
            }
        }

        function createGoogleMarker(map, location, locatorStates, scope) {
            var findBorder = customFieldFactory.getValueByName(location.entire_location.custom_fields, 'custom_pin_border');
            var borderColor = findBorder ? findBorder : STORE_LOCATOR_PIN;
            var pinImageSrc = getPinImageSrc(location, locatorStates);
            var configs = storeLocatorDictionary.mapConfigs;
            var svg = '<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 144.9 200" xml:space="preserve"> \
                         <path stroke="' + borderColor + '" stroke-width="6" fill="' + STORE_LOCATOR_PIN + '" d="M72.5,12.3c-33.3,0-60.3,27-60.3,60.3c0,52.8,60.3,115.8,60.3,115.8s60.3-63,60.3-115.8 \
                           C132.9,39.3,105.8,12.3,72.5,12.3z M72.5,109.3c-20.3,0-36.7-16.4-36.7-36.7C35.8,52.4,52.3,36,72.5,36s36.7,16.4,36.7,36.7 \
                           C109.2,92.9,92.8,109.3,72.5,109.3z"/> \
                         <path fill="white" d="M 68.186839,108.94311 C 53.694467,106.92303 42.094081,97.362316 37.69889,83.815789 \
                           c -2.309623,-7.118544 -2.278746,-15.590568 0.08246,-22.624471 3.404628,-10.14221 11.48484,-18.671795 \
                           21.285937,-22.469732 13.409339,-5.196135 27.9895,-2.412608 38.39836,7.330706 5.234626,4.899923 \
                           8.821926,11.0678 10.626646,18.2711 0.89523,3.573195 1.1417,10.344745 0.51539,14.159987 -2.45518,14.955889 \
                           -13.99847,26.912781 -28.916878,29.952951 -3.044223,0.62038 -8.85315,0.87627 -11.503963,0.50678 z" /> \
                       </svg>';

            var markerObj = {};
            if (pinImageSrc) {
                markerObj = {
                    id: location.id,
                    icon: {
                        url: pinImageSrc,
                        scaledSize: configs.pinScaledSize ? new google.maps.Size(configs.pinScaledSize, configs.pinScaledSize) : null
                    }
                }
            } else {
                markerObj = {
                    label: {
                        text: location.number.toString(),
                        color: "black",
                        fontSize: "12px",
                        fontWeight:"bold"
                    },
                    id: location.id,
                    icon: {
                        labelOrigin: new google.maps.Point(24,18),
                        scaledSize: new google.maps.Size(48, 48),
                        url: 'data:image/svg+xml;base64,' + btoa(svg)
                    }
                }
            }

            var marker = new google.maps.Marker(markerObj);
            var position = new google.maps.LatLng(location.latitude, location.longitude);
            marker.setPosition(position);

            var linkFunction = $compile(angular.element('<map-popup></map-popup>'));
            var mapPopupScope = scope.$new();


            mapPopupScope.location = location;

            var infoWindow = new google.maps.InfoWindow({
                content: linkFunction(mapPopupScope)[0]
            });

            marker.addListener('click', function () {
                // close other markers
                var locationId;
                locatorStates.locationMarkersArray.forEach(function (m) {
                    if (m.locationId == location.id) {
                        locationId = m.locationId;
                    }
                    m.closePopup();
                });

                mapService.scrollToItem(locationId);
                infoWindow.open(map, marker);
                storeLocatorCache.save('location', location);
            });

            return new MFeedMap.GoogleMarker(marker, map, location.number, infoWindow, storeLocatorDictionary.zoomLevels, location.id);
        }

        function createMapboxMarker(map, location, locatorStates, scope) {
            var pinImageSrc = getPinImageSrc(location, locatorStates);
            var configs = storeLocatorDictionary.mapConfigs;
            var pinElement = document.createElement('div');
            var srOnlyElement = document.createElement('span');
            srOnlyElement.innerText = location.number + ' pin on the map';
            srOnlyElement.setAttribute('class', 'sr-only');

            if (pinImageSrc) {
                var pinForLocation = $("img[aria-label='mapbox pin-" + location.number + "']");
                if(!pinForLocation || (pinForLocation && pinForLocation.length == 0)){
                    var imageEl = document.createElement("IMG");
                    imageEl.setAttribute("src", pinImageSrc);
                    imageEl.setAttribute("role", "img");
                    imageEl.style.maxWidth = '50px';
                    imageEl.style.filter = 'drop-shadow(1px 1px 1px #707070)';
                    imageEl.setAttribute("aria-label", "mapbox pin-" + location.number);
                    pinElement.appendChild(imageEl);
                }
            } else {
              var svgElement = null;
              var pinSvg = '<svg viewBox="' + configs.pinSvgViewBox + '" width="' + configs.pinSvgWidth + 'px" height="' + configs.pinSvgHeight + 'px" xmlns="http://www.w3.org/2000/svg"> \
              <title>pinSvg '+ location.number +'</title> \
              <defs> \
                  <filter id="blur '+ location.number +'" x="0" y="0"> \
                      <feGaussianBlur in="SourceGraphic" stdDeviation="2"/> \
                  </filter> \
                  <linearGradient y2="1" x2="1" y1="1" x1="1" id="shadow '+ location.number +'"> \
                      <stop offset="0" stop-color="#eeeeee"/> \
                      <stop offset="1" stop-color="#363636"/> \
                  </linearGradient> \
              </defs> \
              <ellipse fill="url(#shadow)" filter="url(#blur)" fill-opacity="0.38" ry="9.90476" \
                  rx="21.5" cy="53.34227" cx="26.9" stroke-width="1.5"/> \
              <path stroke="' + configs.pinBorderColor + '" fill="' + configs.pinColor + '" \
                  stroke-width="' + configs.pinBorderWidth +'" stroke-miterlimit="4" \
                  d="' + configs.pinSvgPath + '" \
              /> \
              <text fill="' + configs.pinFontColor + '" font-family="' + configs.pinFontFamily + '" \
                  font-size="' + configs.pinFontSize + '" font-weight="' + configs.pinFontWeight + '" \
                  x="49%" y="37%" dominant-baseline="middle" text-anchor="middle"ml:space="preserve">'
               + (Boolean(configs.pinShowText) ? location.number : '') + '</text>';
               pinElement.innerHTML = pinSvg;
               svgElement = pinElement.firstElementChild;
               svgElement.setAttribute("role", "img");
               svgElement.setAttribute("aria-label", "mapbox pin-" + location.number);
            }

            pinElement.setAttribute("role", "img");
            pinElement.setAttribute("alt", "mapbox pin-" + location.number);
            pinElement.setAttribute("aria-label", "marker");
            pinElement.setAttribute("tabindex", "-1");
            if (CLIENT_NAME === 'Visionworks') {
                pinElement.appendChild(srOnlyElement);
            }
            pinElement.addEventListener('click', function () {
                onMarkerClick(scope.mapCtrl.navigateToDetailsPageOnClick, scope.mapCtrl.highlightMarkerOnClick);
            });

            // Marker
            var mapboxMarker = new mapboxgl.Marker({
              element: pinElement,
              id: location.id,
              title: location.name,
              number: location.number.toString(),
              getMessageScope: function () {
                return scope;
              },
              location: location
            }).setLngLat([location.longitude, location.latitude]);

            // Popup
            var popUp = getPopup(location, scope);
            mapboxMarker.setPopup(popUp).addTo(map);

            // scroll in the results lists when the user clicks on specific map pin
            // mimics behavior from resultsLiDirective
            function onMarkerClick(navigateToDetailsPageOnClick, highlightMarkerOnClick) {
                if (navigateToDetailsPageOnClick) {
                    var language = storeLocatorCache.get('language');
                    if (typeof language !== "undefined") {
                        window.location.href = LanguageService.updateLinkUrl(CLIENT_ROUTE !== '' ? CLIENT_ROUTE + '/' + language + location.link : location.link);
                    } else {
                        window.location.href = LanguageService.updateLinkUrl(CLIENT_ROUTE !== '' ? CLIENT_ROUTE + location.link : location.link);
                    }
                }

                var selectedMarker = findMarker(locatorStates, location.number);
                if (selectedMarker) {
                    if (highlightMarkerOnClick) {
                        updateMarkerAndPublishEvent(locatorStates, location, selectedMarker, configs);
                    } else {
                        var currentZoom = map.getZoom();
                        map.flyTo({
                            center: selectedMarker.marker.getLngLat(),
                            offset: getOffset(),
                            zoom: currentZoom < storeLocatorDictionary.zoomLevels.store
                            ? storeLocatorDictionary.zoomLevels.store
                            : currentZoom
                        })
                        closeAllPopups();
                        storeLocatorCache.save('location', location);
                    }

                    var locationId = findLocationId(location.id);
                    if (locationId) {
                        mapService.scrollToItem(locationId);
                    }
                }
            }

            function closeAllPopups() {
                locatorStates.locationMarkersArray.forEach(function (m) {
                    m.closePopup();
                });
            }

            function findLocationId(id) {
                var locationId;
                locatorStates.locationMarkersArray.forEach(function (m) {
                    if (m.locationId === id) {
                        locationId = m.locationId;
                    }
                });
                return locationId;
            }

            return new MFeedMap.MapboxMarker(
              mapboxMarker,
              map,
              location.number,
              storeLocatorDictionary.zoomLevels,
              location.id
            );
        }

        function loadClusterPinImage(map) {
            var configs = storeLocatorDictionary.mapConfigs;
            var pinImageSrc = configs.pinImageSrc;
            var pinImageHoverSrc = configs.pinImageHoverSrc;
            var language = storeLocatorCache.get('language');

            var currentUrl = window.location.href;
            var baseUrl = window.location.origin;
            if (currentUrl.indexOf('localhost') === -1) {
                var urlSegments = currentUrl.split('/');
                urlSegments.pop();
                baseUrl = urlSegments.join('/');
            }

            if (configs.pinImageSrc.startsWith('assets') === 0) { 
                if (language) {
                    pinImageSrc = baseUrl + '/' + pinImageSrc;
                }else{
                    pinImageSrc = window.location.href.indexOf('localhost') === -1 ?
                    window.location.origin + window.location.pathname + pinImageSrc :
                    window.location.origin + '/' + pinImageSrc;
                }
            }

            if (configs.pinImageHoverSrc.startsWith('assets') === 0) {
                if (typeof language !== "undefined" && HAS_MULTILINGUAL) {
                    pinImageHoverSrc = baseUrl + '/' + pinImageHoverSrc;
                }else{
                    pinImageHoverSrc = window.location.href.indexOf('localhost') === -1 ?
                    window.location.origin + window.location.pathname + pinImageHoverSrc :
                    window.location.origin + '/' + pinImageHoverSrc;
                }
            }

            if(!map.getLayer('unclustered-point')) {
                map.loadImage(pinImageSrc, function(err, img) {
                    if (!err && !map.hasImage('custom-pin')) {
                        map.addImage('custom-pin', img, { sdf: pinImageSrc === './assets/images/default-pin-icon.png' });
                    }
                });
                map.loadImage(pinImageHoverSrc, function(err, hoverImg) {
                    if (!err && !map.hasImage('custom-pin-hover')) {
                        map.addImage('custom-pin-hover', hoverImg, { sdf: pinImageHoverSrc === './assets/images/default-pin-icon.png' });
                    }
                });
            }
        }

        function addClustersClickHandler(map, locatorStates, scope, findLocationOutsideResults, searchAreaFn) {
            ['click', 'dblclick'].forEach(function(action) {
                map.off(action).on(action, function(e) {
                  e.preventDefault();
                    if (e.originalEvent instanceof MouseEvent && !(e.originalEvent instanceof PointerEvent) && !e.originalEvent.isTrusted) {
                        e.point.x = e.originalEvent.clientX;
                        e.point.y = e.originalEvent.clientY;
                    }

                    var features = map.queryRenderedFeatures(e.point);

                    if (features.length === 0 && !storeLocatorCache.get('clusterLocation')) return;
                    var feature = features[0] || storeLocatorCache.get('clusterLocation');
                    var currentZoom = map.getZoom();

                    if (feature.properties.cluster) {
                      var clusterId = features[0].properties.cluster_id;
                      map.getSource('location-clusters').getClusterExpansionZoom(clusterId,
                        function(err, zoom) {
                          if (err) return;
                          map.easeTo({
                            center: features[0].geometry.coordinates,
                            zoom: zoom
                          });
                        }
                      );
                    } else {
                        var foundLocation = _.find(locatorStates.locations, function (location) {
                            return location.id === (storeLocatorCache.get('clusterLocation') ? storeLocatorCache.get('clusterLocation').properties.id : feature.properties.id);
                        });

                        if (foundLocation) {
                          closeAllPopups();
                          var popUp = getPopup(foundLocation, scope, map);
                          popUp.setLngLat([foundLocation.longitude, foundLocation.latitude]).addTo(map);
                          handleUnclusteredClick(foundLocation, currentZoom, map);
                        } else if (findLocationOutsideResults) {
                            mapService.requestLocationMarkerById(feature.properties.id).then(function (loc) {
                                closeAllPopups();
                                var popUp = getPopup(loc, scope, map);
                                popUp.setLngLat([loc.longitude, loc.latitude]).addTo(map);
                                handleUnclusteredClick(loc, currentZoom, map);
                                searchAreaFn();
                            });
                        } else if (feature.geometry.type === 'Point') {
                            storeLocatorCache.save('clusterLocation', feature);
                            searchAreaFn();
                        }
                    }
                });
            });
        }

        function handleUnclusteredClick(foundLocation, currentZoom, map) {
          var storeLocatorMapConfigsParsed = JSON.parse(STORE_LOCATOR_MAP_CONFIGS);
          var viewportWidth = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
          if (typeof storeLocatorMapConfigsParsed !== "undefined" && viewportWidth < 768 && storeLocatorMapConfigsParsed.noMapPopUpOnMobile) {
            var language = storeLocatorCache.get('language');
            if (typeof language !== "undefined") {
                window.location.href = LanguageService.updateLinkUrl(CLIENT_ROUTE !== '' ? CLIENT_ROUTE + '/' +language + foundLocation.link : foundLocation.link);
            } else {
                window.location.href = LanguageService.updateLinkUrl(CLIENT_ROUTE !== '' ? CLIENT_ROUTE + foundLocation.link : foundLocation.link);
            }
          }

          var center = [foundLocation.longitude, foundLocation.latitude];
          setTimeout(function() {
            mapService.scrollToItem(foundLocation.id);
            storeLocatorCache.save('location', foundLocation);
          }, 0);
          storeLocatorCache.remove('clusterLocation');
          setTimeout(function() {
            map.flyTo({
              center: center,
              offset: navigator.userAgent.match(/Android/i) || navigator.userAgent.match(/Android/i) ? [0, 0] : getOffset(),
              zoom: currentZoom < storeLocatorDictionary.zoomLevels.store
                ? storeLocatorDictionary.zoomLevels.store
                : currentZoom
            });
          }, 200);
        }

        function showClusterPopup(map, locatorStates, location, scope, searchAreaFn) {
            const clusterLocation = storeLocatorCache.get('clusterLocation');
            if (clusterLocation) {
                var foundLocation = location || _.find(locatorStates.locations, function (location) {
                    return location.id === clusterLocation.properties.id;
                });

                if (foundLocation) {
                  closeAllPopups();
                  var popUp = getPopup(foundLocation, scope);
                  popUp.setLngLat([foundLocation.longitude, foundLocation.latitude]).addTo(map);
                  handleUnclusteredClick(foundLocation, map.getZoom(), map);
                }
            } else if (locatorStates.clusterLocation && locatorStates.current && locatorStates.current.feature) {
              setTimeout(function() {
                map.flyTo({
                  center: locatorStates.current.feature.geometry.coordinates,
                  offset: navigator.userAgent.match(/Android/i) || navigator.userAgent.match(/Android/i) ? [0, 0] : getOffset(),
                  zoom: map.getZoom()
                });
              }, 200);
              addClustersClickHandler(map, locatorStates, scope, searchAreaFn);
            }
        }

        function getPinImageSrc(location) {
          var pinImageSrc = '';
          var pinCF = location && location.entire_location && location.entire_location.custom_fields
            ? findPinImage(location)
            : {};
          pinImageSrc = pinCF && pinCF.data ? pinCF.data : STORE_LOCATOR_PIN_ICON;
          return pinImageSrc;
        }

        function findPinImage(location) {
          var pinImage = location.entire_location.custom_fields.filter(function (cf) {
              return cf.name === 'pin_image'
            })[0];
            return pinImage;
          }

        function getPopup(location, scope, map) {
            var linkFunction = $compile(angular.element('<map-popup></map-popup>'));
            var mapPopupScope = scope.$new();
            mapPopupScope.location = location;

            var popUp = new mapboxgl.Popup({
                offset: [0, -27]
            })
            .setDOMContent(linkFunction(mapPopupScope)[0])
            .setMaxWidth("300px");

            if (storeLocatorDictionary.mapConfigs.disableMapInteractionOnPopupOpen) {
                popUp.on('open', function() {
                    toggleMapInteractions('disable', map);
                })

                popUp.on('close', function() {
                    toggleMapInteractions('enable', map);
                })
            }

            return popUp;
        }

        function closeAllPopups(map) {
            const popUp = document.getElementsByClassName('mapboxgl-popup');
            if ( popUp.length ) {
                popUp[0].remove();
                if (storeLocatorDictionary.mapConfigs.disableMapInteractionOnPopupOpen && map) {
                    toggleMapInteractions('enable', map);
                }
            }
        }

        function toggleMapInteractions(status, map) {
            var interactions = [
                'scrollZoom',
                'boxZoom',
                'dragRotate',
                'dragPan',
                'keyboard',
                'doubleClickZoom',
                'touchZoomRotate'
            ];

            interactions.forEach(function(interaction) {
                map[interaction][status]();
            });
            const el = document.querySelector('.mapboxgl-ctrl-top-right');
            if (el) {
                el.style.display = status === 'disable' ? 'none' : 'block';
            }
            document.getElementById('searchAreaBtn').style.display = status === 'disable' ? 'none' : 'inline-block';
        }

        function getOffset() {
            var viewportWidth = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
            var mapPopUpDesktopOffset = storeLocatorDictionary.mapConfigs.mapPopUpDesktopOffset;
            var mapPopUpMobileOffset = storeLocatorDictionary.mapConfigs.mapPopUpMobileOffset;
            var noMapPopUpOnMobile = storeLocatorDictionary.mapConfigs.noMapPopUpOnMobile;
            var offset = mapPopUpDesktopOffset;
            if (Boolean(storeLocatorDictionary.mapConfigs.centerPointOnTheRight)) {
                if (viewportWidth > 1260) {
                    offset = [400, 0];
                } else if (viewportWidth > 767 && viewportWidth < 1260) {
                    offset = [200, 0];
                } else {
                    offset = [0, 150];
                }
            } else {
                if (viewportWidth < 960) {
                  offset = Boolean(noMapPopUpOnMobile) ? mapPopUpDesktopOffset : mapPopUpMobileOffset;
                }
            }
            return offset;
        }

        function findMarker(locatorStates, number) {
            return _.find(locatorStates.locationMarkersArray,
                function (mfMarker) { return mfMarker.number === number; }
            );
        }

        function updateMarkerColor(markerObj, fillColor, strokeColor, textColor) {
            if (markerObj) {
                var markerElement = markerObj.marker.getElement();
                var svgPath = markerElement.querySelector('.mapboxgl-marker svg path');
                var svgText = markerElement.querySelector('.mapboxgl-marker svg text');
                svgPath.setAttribute('fill', fillColor);
                svgPath.setAttribute('stroke', strokeColor);
                svgText.setAttribute('fill', textColor);
            }
        }

        function updateMarkerAndPublishEvent(locatorStates, location, selectedMarker, mapConfigs) {
            var previousActiveLocation = storeLocatorCache.get('location');
            if (previousActiveLocation) {
                var previousActiveMarker = findMarker(locatorStates, previousActiveLocation.number);
                updateMarkerColor(previousActiveMarker, mapConfigs.pinColor, mapConfigs.pinBorderColor, mapConfigs.pinFontColor);
            }

            if (selectedMarker) {
                updateMarkerColor(selectedMarker, mapConfigs.pinSelectedColor, mapConfigs.pinSelectedBorderColor, mapConfigs.pinSelectedFontColor);
                storeLocatorCache.save('location', location);
            }
        }
    }

})();

/**
 * @file This service is intended to serve as an abstraction layer for the Mapbox and Google Map APIs.
 *       Google Maps and Mapbox API specific code should go here.
 */
(function () {
    'use strict';

    angular
        .module('storeLocator')
        .factory('MFeedMap', MFeedMap);

    MFeedMap.$inject = ['storeLocatorDictionary'];
    function MFeedMap(storeLocatorDictionary) {

        var mfeed = {};

        /**
         * Represents a lat/lng pair.
         * @constructor
         * @param {google.maps.LatLng|mapboxgl.LngLat} latLng The API-specific LatLng object.
         */
        mfeed.LatLng = function (latLng) {
            this.lat;
            this.lng;
            if (latLng.latitude && latLng.longitude) {
                this.lat = latLng.latitude;
                this.lng = latLng.longitude;
            }
            else if (latLng instanceof mapboxgl.LngLat) {
                this.lat = latLng.lat;
                this.lng = latLng.lng;
            }
            else if (latLng instanceof google.maps.LatLng) {
                this.lat = latLng.lat();
                this.lng = latLng.lng();
            } 
        }

        /**
         * Represents a lat/lng bounds.
         * @constructor
         * @param {google.maps.LatLngBounds|mapboxgl.LngLatBounds} bounds The API-specific LatLngBounds object.
         */
        mfeed.LatLngBounds = function (bounds) {
            this.southWest = {};
            this.northEast = {};
            this.center = {};
            if (bounds instanceof mapboxgl.LngLatBounds) {
                this.southWest = new mfeed.LatLng(bounds.getSouthWest());
                this.northEast = new mfeed.LatLng(bounds.getNorthEast());
                this.center = new mfeed.LatLng(bounds.getCenter());
            }
            else if (bounds instanceof google.maps.LatLngBounds) {
                this.southWest = new mfeed.LatLng(bounds.getSouthWest());
                this.northEast = new mfeed.LatLng(bounds.getNorthEast());
                this.center = new mfeed.LatLng(bounds.getCenter());
            }
        }



        /****************************************************
        MFeed Map "Interface"
        *****************************************************/

        mfeed.Map = {
            buildMap: function () { },
            getBounds: function () { },
            removeMarker: function () { },
            setScrollWheelZoom: function () { },
            addTo: function () { },
            setView: function () { },
            setCurrentLocationMarker: function () { },
            setClusters: function () { },
            extendBounds: function () { }
        };

        /****************************************************
        Mapbox Map Implementation
        *****************************************************/

        /**
         * Represents the core Map object.
         * @constructor
         * @param {L.Map} map The Mapbox API Map object.
         */
        mfeed.MapboxMap = function (map) {
            this.map = map;
        };

        mfeed.MapboxMap.prototype = Object.create(mfeed.Map);

        /**
         * Enables or disables scrollwheel zooming.
         * @param {Boolean} value Value indicating whether to enable or disable scrollwheel zooming.
         */
        mfeed.MapboxMap.prototype.setScrollWheelZoom = function (value) {
            if (!value) {
                this.map.scrollZoom.disable();
            }
            else {
                this.map.scrollZoom.enable({ around: 'center' });
            }
        }
        
        /**
         * Intializes and configures clusters.
         * @param {Object} locatorStates LocatorStates object that handles store locator-related state data.
         */
        mfeed.MapboxMap.prototype.setClusters = function (locatorStates) {
          var circleColor = angular.isArray(storeLocatorDictionary.mapConfigs.clusterColors) ?
            ['step', ['get', 'point_count']].concat(storeLocatorDictionary.mapConfigs.clusterColors) : storeLocatorDictionary.mapConfigs.clusterColors;

          var circleRadius = angular.isArray(storeLocatorDictionary.mapConfigs.clusterSizes) ?
            ['step', ['get', 'point_count']].concat(storeLocatorDictionary.mapConfigs.clusterSizes) : storeLocatorDictionary.mapConfigs.clusterSizes;
         
          var circleBorderColor = angular.isArray(storeLocatorDictionary.mapConfigs.clusterBorderColor) ?
            ['step', ['get', 'point_count']].concat(storeLocatorDictionary.mapConfigs.clusterBorderColor) : storeLocatorDictionary.mapConfigs.clusterBorderColor; 

          var circleBorderWidth = angular.isArray(storeLocatorDictionary.mapConfigs.clusterBorderWidth) ?
            ['step', ['get', 'point_count']].concat(storeLocatorDictionary.mapConfigs.clusterBorderWidth) : storeLocatorDictionary.mapConfigs.clusterBorderWidth; 

          if (!this.map.getSource('location-clusters')) {
            this.map.addSource('location-clusters', {
              type: 'geojson',
              data: locatorStates.filteredGeoLocationElements,
              cluster: true,
              clusterRadius: storeLocatorDictionary.mapConfigs.clusterRadius,
              tolerance: 0
            });

            this.map.addLayer({
              id: 'clusters',
              type: 'circle',
              source: 'location-clusters',
              filter: ['has', 'point_count'],
              paint: {
                'circle-stroke-color': circleBorderColor,
                'circle-stroke-width': circleBorderWidth,
                'circle-color': circleColor,
                'circle-radius': circleRadius
              }
            });

            if(!this.map.getLayer('unclustered-point')) {
              var pinImageConfig = {
                id: 'unclustered-point',
                type: 'symbol',
                source: 'location-clusters',
                filter: ['!', ['has', 'point_count']],
                layout: {
                  'icon-image': 'custom-pin',
                  'icon-size': storeLocatorDictionary.mapConfigs.pinImageSize,
                  'icon-allow-overlap': true
                }
              };

              if (storeLocatorDictionary.mapConfigs.pinImageSrc.includes('default')) {
                pinImageConfig.paint = {
                  'icon-color': storeLocatorDictionary.mapConfigs.pinImageColor
                }
              }

              this.map.addLayer(pinImageConfig);
            }

            this.map.addLayer({
              id: 'cluster-count',
              type: 'symbol',
              source: 'location-clusters',
              filter: ['has', 'point_count'],
              layout: {
                'text-field': '{point_count_abbreviated}',
                'text-font': storeLocatorDictionary.mapConfigs.clusterTextFont,
                'text-size': storeLocatorDictionary.mapConfigs.clusterTextSize
              },
              paint: {
                "text-color": storeLocatorDictionary.mapConfigs.clusterTextColor
              }
            });
          } else {
            this.map.getSource('location-clusters').setData(locatorStates.filteredGeoLocationElements);
          }
        }

       /**
         * Runs the initial setup processes for the map object.
         * @param {$rootScope.Scope} scope Value indicating whether to enable or disable scrollwheel zooming.
         * @param {Object} locatorStates LocatorStates object that handles store locator-related state data.
         * @callback initMapCallback Callback that runs once the map has loaded.
         */
        mfeed.MapboxMap.prototype.buildMap = function (scope, locatorStates, initMapCallback, reloadLocationsCallback) {
            var circleColor = angular.isArray(storeLocatorDictionary.mapConfigs.clusterColors) ?
                            ['step', ['get', 'point_count']].concat(storeLocatorDictionary.mapConfigs.clusterColors) : storeLocatorDictionary.mapConfigs.clusterColors;
            this.map.on('load', function () {

                // set lat/lng
                this.setCenter([locatorStates.mapCenter.longitude, locatorStates.mapCenter.latitude]);
                
                if (locatorStates.zoom) {
                    this.setZoom(locatorStates.zoom);
                }

                this.resize();

                initMapCallback();

                if (Boolean(storeLocatorDictionary.mapConfigs.autoSearchOnDragAndZoom)) {
                    this.on('dragend', function () {
                        scope.safeApply(function () {
                            locatorStates.showLoader = false;
                            locatorStates.searchInput = '';
                            locatorStates.current = 'Current Location';
                            locatorStates.areaSearched = true;
                            reloadLocationsCallback(locatorStates);
                        })
                    });
                    this.on('zoomend', function (e) {
                        if(e.originalEvent){
                            if(e.originalEvent.type === 'wheel' || e.originalEvent.type === 'click' || e.originalEvent.type === 'keydown'){
                                scope.safeApply(function () {
                                    locatorStates.showLoader = false;
                                    locatorStates.current = 'Current Location';
                                    locatorStates.areaSearched = true;
                                    reloadLocationsCallback(locatorStates);
                                })
                            }
                        }
                    });
                } else {
                    // show 'Search this Area' button after drag
                    this.on('dragend', function () {
                        scope.safeApply(function () {
                            locatorStates.showSearchAreaBtn = true;
                        })
                    });
                    // show 'Search this Area' button after zoom changes
                    if (Boolean(storeLocatorDictionary.mapConfigs.showSearchButtonOnZoomChange)) {
                        this.on('zoomend', function (e) {
                            scope.safeApply(function () {
                                locatorStates.showSearchAreaBtn = true;
                            })
                        });
                    }
                }

                var lastHoveredClusterId = null;
                var lastPointIdClicked = null;
                var isClusterColorDifferentToClusterHoverColor = storeLocatorDictionary.mapConfigs.clusterColors !== storeLocatorDictionary.mapConfigs.clusterHoverColor;
                var isPinImageDifferentToPinImageHover = storeLocatorDictionary.mapConfigs.pinImageSrc !== storeLocatorDictionary.mapConfigs.pinImageHoverSrc;

                this.on('mouseenter', 'clusters', function() {
                    this.getCanvas().style.cursor = 'pointer';
                });
                this.on('mouseleave', 'clusters', function() {
                    this.getCanvas().style.cursor = '';
                    if(isClusterColorDifferentToClusterHoverColor) {
                        // keep original color for the rest cluster and text after leave
                        this.setPaintProperty('clusters', 'circle-color', circleColor);
                        if (lastHoveredClusterId !== null) {
                            this.setPaintProperty('cluster-count', 'text-color', storeLocatorDictionary.mapConfigs.clusterTextColor);
                        }
                    }
                });
                this.on('mouseenter', 'unclustered-point', function() {
                    this.getCanvas().style.cursor = 'pointer';
                });
                this.on('mouseleave', 'unclustered-point', function(e) {
                    this.getCanvas().style.cursor = '';
                    if(isPinImageDifferentToPinImageHover) {
                        // keep original pin-image for all unclustered-point after leave
                        this.setLayoutProperty('unclustered-point', 'icon-image', 'custom-pin');
                        if(lastPointIdClicked !== null){
                            this.setLayoutProperty('unclustered-point', 'icon-image', ['match', ['get', 'id'], lastPointIdClicked, 'custom-pin-hover', 'custom-pin']);
                        }
                    }
                });
                
                if(isClusterColorDifferentToClusterHoverColor) {
                    this.on('mousemove', 'clusters', function (e) {
                        var features = this.queryRenderedFeatures(e.point, {
                            layers: ['clusters']
                        });
                        if (features.length > 0) {
                            this.getCanvas().style.cursor = 'pointer';
                            var clusterId = features[0].properties.cluster_id;
                            this.setPaintProperty('clusters', 'circle-color', [
                                'case',
                                ['==', ['get', 'cluster_id'], clusterId],
                                storeLocatorDictionary.mapConfigs.clusterHoverColor, // change to hover color
                                circleColor // keep original color for the rest of clusters
                            ]);
                            this.setPaintProperty('cluster-count', 'text-color', [
                                'case',
                                ['==', ['get', 'cluster_id'], clusterId],
                                storeLocatorDictionary.mapConfigs.clusterHoverTextColor, // change text color when is hovered
                                storeLocatorDictionary.mapConfigs.clusterTextColor // keep original color for the rest of clusters
                            ]);
                            lastHoveredClusterId = clusterId;
                        }
                    });
                }

                if(isPinImageDifferentToPinImageHover) {
                    handlePointEvent('mousemove', this);
                    handlePointEvent('click', this);
                }

                function handlePointEvent(eventType, map) {
                    map.on(eventType, 'unclustered-point', function (e) {
                        var features = map.queryRenderedFeatures(e.point, {
                            layers: ['unclustered-point']
                        });
                        if (features.length > 0) {
                            var pointId = features[0].properties.id;
                            // change icon-image just for the current point
                            if (lastPointIdClicked !== pointId) {
                                if (lastPointIdClicked) {
                                    map.setLayoutProperty('unclustered-point', 'icon-image', ['match', ['get', 'id'], pointId, 'custom-pin-hover', lastPointIdClicked, 'custom-pin-hover', 'custom-pin']);
                                } else {
                                    map.setLayoutProperty('unclustered-point', 'icon-image', ['match', ['get', 'id'], pointId, 'custom-pin-hover', 'custom-pin']);
                                }
                                if (eventType === 'click') {
                                    lastPointIdClicked = pointId;
                                }
                            }
                        }
                    });
                }

            });

            scope.safeApply = function(fn) {
                var phase = this.$root.$$phase;
                if(phase == '$apply' || phase == '$digest') {
                  if(fn && (typeof(fn) === 'function')) {
                    fn();
                  }
                } else {
                  this.$apply(fn);
                }
            };
        }

        /**
         * Returns the current bounds for the map.
         * @returns {mfeed.LatLngBounds}
         */
        mfeed.MapboxMap.prototype.getBounds = function () {
            return new mfeed.LatLngBounds(this.map.getBounds());
        }

        /**
         * Fits the map to the bounds calculated according to the pins needed to be rendered.
         * @returns {mfeed.LatLngBounds}
         */
        mfeed.MapboxMap.prototype.extendBounds = function (lngLatList) {
          var bounds = new mapboxgl.LngLatBounds();
          lngLatList.forEach(function(lngLat) {
            bounds.extend(lngLat);
          });
          this.map.fitBounds(bounds, { padding: 50, maxZoom: storeLocatorDictionary.zoomLevels.autoMaxZoom });
        }

        /**
        * Returns the current zoom level for the map.
        * @returns number
        */
        mfeed.MapboxMap.prototype.getZoom = function () {
            return this.map.getZoom();
        }

        /**
         * Removes the marker from its associated map.
         * @param {mfeed.MapboxMarker} mfMarker MFeed marker object to be removed from the map.
         */
        mfeed.MapboxMap.prototype.removeMarker = function (mfMarker) {
            mfMarker.marker.remove();
        }

        /**
         * Sets the map's view to the latitude/longitude and zoom level.
         * @param {mfeed.LatLng} mfLatLng Latitude/longitude to center the map around.
         * @param {Number} zoom Zoom level 
         */
        mfeed.MapboxMap.prototype.setView = function (mfLatLng, zoom) {
            var viewportWidth = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
            var offset = [0, 0]; // default

            if (Boolean(storeLocatorDictionary.mapConfigs.centerPointOnTheRight)) {
                if (viewportWidth > 1260) {
                    offset = [-210, 0];
                } else if (viewportWidth > 767 && viewportWidth < 1260) {
                    offset = [-140, 0];
                } 
            }

            this.map.jumpTo({ center: [mfLatLng.lng, mfLatLng.lat], zoom: zoom || null })
            this.map.panBy(offset);
        }

        /**
         * Sets the current location marker.
         * @param {GeoJSON} currentLocation GeoJSON-formatted object representing the user's current location.
         */
        mfeed.MapboxMap.prototype.setCurrentLocationMarker = function (currentLocation) {
            var viewportWidth = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
            var geo = currentLocation.geometry;
            var offset = [0, 0]; // default
            var zoom = viewportWidth <= 767 && storeLocatorDictionary.zoomLevels.nearMeMobile ?
                storeLocatorDictionary.zoomLevels.nearMeMobile : storeLocatorDictionary.zoomLevels.nearMe;

            if (Boolean(storeLocatorDictionary.mapConfigs.centerPointOnTheRight)) {
                if (viewportWidth > 1260) {
                    offset = [-200, 0];
                } else if (viewportWidth > 767 && viewportWidth < 1260) {
                    offset = [-140, 0];
                } 
            }

            this.map.jumpTo({ center: [geo.coordinates[0], geo.coordinates[1]], zoom: zoom });
            this.map.panBy(offset);
        }

        /****************************************************
        Google Maps Implementation
        *****************************************************/

        /**
         * Represents the core Map object.
         * @constructor
         * @param {google.maps.Map} map The Google Maps API Map object.
         */
        mfeed.GoogleMap = function (map) {
            this.map = map;
        };

        mfeed.GoogleMap.prototype = Object.create(mfeed.Map);

        /**
         * Enables or disables scrollwheel zooming.
         * @param {Boolean} value Value indicating whether to enable or disable scrollwheel zooming.
         */
        mfeed.GoogleMap.prototype.setScrollWheelZoom = function (value) {
            this.map.set('scrollWheel', value);
        }

        /**
         * Runs the initial setup processes for the map object.
         * @param {$rootScope.Scope} scope Value indicating whether to enable or disable scrollwheel zooming.
         * @param {Object} locatorStates LocatorStates object that handles store locator-related state data.
         * @callback initMapCallback Callback that runs once the map has loaded.
         */
        mfeed.GoogleMap.prototype.buildMap = function (scope, locatorStates, initMap, reloadLocationsCallback) {
            initMap();

            // set basic lat/lng
            this.map.setCenter(new google.maps.LatLng(
                locatorStates.mapCenter.latitude,
                locatorStates.mapCenter.longitude));

            if (locatorStates.zoom) {
                this.map.setZoom(+locatorStates.zoom);
            }

            if (Boolean(storeLocatorDictionary.mapConfigs.autoSearchOnDragAndZoom)) {
                // show 'Search this Area' button after drag
                google.maps.event.addListener(this.map, 'dragend', function () {
                    scope.$apply(function() {
                        locatorStates.showLoader = false;
                        locatorStates.searchInput = '';
                        locatorStates.current = 'Current Location';
                        locatorStates.areaSearched = true;
                        reloadLocationsCallback(locatorStates);
                    });
                });
                google.maps.event.addListener(this.map, 'zoom_changed', function () {
                    scope.$apply(function() {
                        locatorStates.showLoader = false;
                        locatorStates.current = 'Current Location';
                        locatorStates.areaSearched = true;
                        reloadLocationsCallback(locatorStates);
                    });
                });
            } else {
                // show 'Search this Area' button after drag
                google.maps.event.addListener(this.map, 'dragend', function () {
                    scope.$apply(function() {
                        locatorStates.showSearchAreaBtn = true;
                    });
                });
            }
        }

        /**
         * Returns the current bounds for the map.
         * @returns {mfeed.LatLngBounds}
         */
        mfeed.GoogleMap.prototype.getBounds = function () {
            return new mfeed.LatLngBounds(this.map.getBounds());
        }

        /**
        * Returns the current zoom level for the map.
        * @returns number
        */
        mfeed.GoogleMap.prototype.getZoom = function () {
            return this.map.getZoom();
        }

        /**
         * Removes the marker from its associated map.
         * @param {mfeed.GoogleMarker} mfMarker MFeed marker object to be removed from the map.
         */
        mfeed.GoogleMap.prototype.removeMarker = function (mfMarker) {
            if (mfMarker) {
                mfMarker.marker.setMap(null);
            }
        }

        /**
         * Sets the map's view to the latitude/longitude and zoom level.
         * @param {mfeed.LatLng} mfLatLng Latitude/longitude to center the map around.
         * @param {Number} zoom Zoom level 
         */
        mfeed.GoogleMap.prototype.setView = function (mfLatLng, zoom) {
            this.map.setCenter(new google.maps.LatLng(mfLatLng.lat, mfLatLng.lng));
            if (zoom) {
                this.map.setZoom(+zoom);
            }
        }

        /**
         * Sets the current location marker.
         * @param {GeoJSON} currentLocation GeoJSON-formatted object representing the user's current location.
         */
        mfeed.GoogleMap.prototype.setCurrentLocationMarker = function (currentLocation) {
            this.map.data.addGeoJson(currentLocation);

            // set's the custom icon for the user's current location once setCurrentLocationMarker has been invoked
            this.map.data.setStyle(function (feature) {
                return {
                    icon: feature.getProperty('icon').iconPath,
                    clickable: false
                };
            });
        }




        /****************************************************
        MFeed Marker "Interface"
        *****************************************************/

        mfeed.Marker = {
            closePopup: function () { },
            openPopup: function () { },
            addToMap: function () { },
            zoomTo: function () { },
            getLatLng: function () { }
        };

        /****************************************************
        Mapbox Marker Implementation
        *****************************************************/

        /**
         * Represents the core Marker object.
         * @constructor
         * @param {L.Marker} map The Mapbox API Marker object.
         */
        mfeed.MapboxMarker = function (marker, map, number, zoomLevels, locationId) {
            this.marker = marker;
            this.map = map;
            this.number = number;
            this.zoomLevels = zoomLevels;
            this.locationId = locationId;
        };

        mfeed.MapboxMarker.prototype = Object.create(mfeed.Marker);

        /**
         * Closes the popup bound to the marker.
         */
        mfeed.MapboxMarker.prototype.closePopup = function () {
            if (this.marker.getPopup().isOpen()) {
                this.marker.togglePopup();
            }
        }

        /**
         * Opens the popup associated with the marker and pans the map to it.
         */
        mfeed.MapboxMarker.prototype.openPopup = function () {
            if (!this.marker.getPopup().isOpen()) {
                this.marker.togglePopup();
            }
        }

        /**
         * Adds the marker to its associated map.
         */
        mfeed.MapboxMarker.prototype.addToMap = function () {
            this.marker.addTo(this.map);
        }

        /**
         * Zooms (and pans) the map to the marker.
         */
        mfeed.MapboxMarker.prototype.zoomTo = function () {
            var viewportWidth = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
            var offset = [0, 0]; // default offset

            if (Boolean(storeLocatorDictionary.mapConfigs.centerPointOnTheRight)) {
                if (viewportWidth > 1260) {
                    offset = [400, 0];
                } else if (viewportWidth > 767 && viewportWidth < 1260) {
                    offset = [200, 0];
                } 
            }

            var currentZoom = this.map.getZoom();
            this.map.flyTo({
              center: this.marker.getLngLat(),
              offset: offset,
              zoom: currentZoom < this.zoomLevels.store
                ? this.zoomLevels.store
                : currentZoom
            })
        }

        /**
         * Returns the Lat/Lng of the marker.
         * @returns {mfeed.LatLng} Lat/Lng pair
         */
        mfeed.MapboxMarker.prototype.getLatLng = function () {
            return new mfeed.LatLng(this.marker.getLatLng());
        }

        /****************************************************
        Google Marker Implementation
        *****************************************************/

        /**
         * Represents the core Marker object.
         * @constructor
         * @param {google.maps.Marker} map The Google Maps API Marker object.
         */
        mfeed.GoogleMarker = function (marker, map, number, infoWindow, zoomLevels, locationId) {
            this.marker = marker;
            this.map = map;
            this.number = number;
            this.zoomLevels = zoomLevels;
            this.infoWindow = infoWindow;
            this.locationId = locationId;
        };

        mfeed.GoogleMarker.prototype = Object.create(mfeed.Marker);

        /**
         * Closes the popup bound to the marker.
         */
        mfeed.GoogleMarker.prototype.closePopup = function () {
            this.infoWindow.close();
        }

        /**
         * Opens the popup associated with the marker and pans the map to it.
         */
        mfeed.GoogleMarker.prototype.openPopup = function () {
            this.infoWindow.open(this.map, this.marker);
        }

        /**
         * Adds the marker to its associated map.
         */
        mfeed.GoogleMarker.prototype.addToMap = function () {
            this.marker.setMap(this.map);
        }

        /**
         * Zooms (and pans) the map to the marker.
         */
        mfeed.GoogleMarker.prototype.zoomTo = function () {
            //TODO: Investigate ways to make panning smoother like Mapbox's setZoomAround method
            this.map.panTo(this.marker.getPosition());

            var currentZoom = this.map.getZoom();
            var zoom = currentZoom < this.zoomLevels.store
                ? this.zoomLevels.store
                : currentZoom
            this.map.setZoom(zoom);
        }

        /**
         * Returns the Lat/Lng of the marker.
         * @returns {mfeed.LatLng} Lat/Lng pair
         */
        mfeed.GoogleMarker.prototype.getLatLng = function () {
            return new mfeed.LatLng(this.marker.getPosition());
        }

        return mfeed;
    }

})();

(function() {
  'use strict';

  angular
    .module('storeLocator')
    .factory('mfReviewFactory', mfReviewFactory);

  function mfReviewFactory(APIMfLpAdapterService) {
    return {
      getMfReviewFromLocation: getMfReviewFromLocation,
      postMfReviewOnLocation: postMfReviewOnLocation
    };
    function getMfReviewFromLocation(id, page, pageSize, published) {
      var params = {
        page: page,
        pageSize: pageSize,
        published: published
      };

      return APIMfLpAdapterService.reviews.get(id, params);
    }
    function postMfReviewOnLocation(params) {
      params.authorName = params.first_name + " " + params.last_name;
      params.locationId = params.location_id;

      return APIMfLpAdapterService.reviews.post(params);
    }
  }

})();

(function () {
  'use strict';
  angular
    .module("storeLocator")
    .factory('_', LodashService);

  function LodashService($window) {
    //Add some mixins
    $window._.mixin({
      //Removes the null fields from an object
      compactObject: function (o) {
        var clone = _.clone(o);
        _.each(clone, function (v, k) {
          if (!v) {
            delete clone[k];
          }
        });
        return clone;
      }
    });
    return $window._; // assumes underscore has already been loaded on the page
  }
}());

(function () {
  'use strict';

  angular
    .module('storeLocator')
    .provider("googleMapsLoader", googleMapsLoaderProvider)
    .run(function ($rootScope, googleMapsLoader) {
      googleMapsLoader.then(function () {
        $rootScope.isGoogleMapsApiLoaded = true;
      });
    });

  googleMapsLoaderProvider.$inject = [];
  function googleMapsLoaderProvider() {
    this.$get = googleMapsLoader;

    googleMapsLoader.$inject = ['$q', 'GOOGLE_API_KEY', '$window', 'mapHelper'];
    function googleMapsLoader($q, GOOGLE_API_KEY, $window, mapHelper) {
      var deferred = $q.defer();

      if (!mapHelper.isGoogleMapsEnabled()) {
        deferred.reject();
      }

      var onError = function () {
        deferred.reject();
      }

      if ($window.google && $window.google.maps) {
        deferred.resolve();
      } else if(mapHelper.isGoogleMapsEnabled()) {
        $window.onGoogleScriptLoad = function () {
          if ($window.google && $window.google.maps) {
            deferred.resolve();
          }
          else {
            deferred.reject();
          }
        };

        var script = document.createElement("script");
        script.type = "text/javascript";
        script.async = true;
        script.src = "https://maps.google.com/maps/api/js?v=3.31&libraries=places&callback=onGoogleScriptLoad&key=" + GOOGLE_API_KEY;

        script.onerror = onError;
        document.body.appendChild(script);
      }

      return deferred.promise;
    }
  }

})();

(function () {
    'use strict';

    angular
        .module('storeLocator')
        .service('geocodeService', geocodeService);

    geocodeService.$inject = [
        'MAPBOX_KEY',
        'STORE_LOCATOR_SEARCH_COUNTRY',
        'STORE_LOCATOR_SEARCH_TYPE',
        'MAPBOX_BBOX',
        'APIMapboxService',
        '$q'];

    function geocodeService(MAPBOX_KEY,
        STORE_LOCATOR_SEARCH_COUNTRY,
        STORE_LOCATOR_SEARCH_TYPE,
        MAPBOX_BBOX,
        APIMapboxService,
        $q) {

        var googleGeocoder;

        var service = {
            geocodeGoogle: geocodeGoogle,
            reverseGeocodeGoogle: reverseGeocodeGoogle,
            geocodeMapbox: geocodeMapbox
        };
        return service;

        /**
         * Converts an address to a place.
         * This is a Google-specific function that should be moved to mfeed_map.service.js.
         * @param {string} address The address to be geocoded.
         * @param {MFeed.LatLngBounds} bounds Lat/Lng bounds for biasing the results towards the current viewport.
         * @returns {Promise<google.maps.GeocoderResult>} A promise containing the GeocoderResult object.
         */
        function geocodeGoogle(address, bounds) {
            if (!googleGeocoder) {
                googleGeocoder = new google.maps.Geocoder();
            }

            var deferred = $q.defer();

            var requestParams = { 'address': address };

            if (bounds) {
                requestParams.bounds = new google.maps.LatLngBounds(
                    {
                        lat: bounds.southWest.lat,
                        lng: bounds.southWest.lng
                    },
                    {
                        lat: bounds.northEast.lat,
                        lng: bounds.northEast.lng
                    });
            }

            googleGeocoder.geocode(requestParams, function (results, status) {
                if (status == 'OK') {
                    deferred.resolve(results[0]);
                }
                else {
                    deferred.reject();
                }
            });

            return deferred.promise;
        }

        /**
         * Converts a latitude/longitude pair into a list of possible locations at varying levels of specificity (street, zip, locality, county, state, country, etc).
         * This is a Google-specific function that should be moved to mfeed_map.service.js.
         * @param {number} latitude
         * @param {number} longitude
         * @returns {Promise<google.maps.GeocoderResult[]>} A promise containing an array of GeocoderResult objects.
         */
        function reverseGeocodeGoogle(latitude, longitude) {
            if (!googleGeocoder) {
                googleGeocoder = new google.maps.Geocoder();
            }

            var deferred = $q.defer();

            var requestParams = {
                "location":
                {
                    "lat": latitude,
                    "lng": longitude
                }
            };

            googleGeocoder.geocode(requestParams, function (results, status) {
                if (status === 'OK') {
                    deferred.resolve(results);
                } else {
                    deferred.reject();
                }
            });

            return deferred.promise;
        }

        /**
         * Converts an address to a location specified in the Carmen GeoJSON format used by Mapbox.
         * This is a Mapbox-specific function that should be moved to mfeed_map.service.js.
         * @param {string} address The address to be geocoded.
         * @param {number} latitude Latitude for biasing the results.
         * @param {number} longitude Longitude for biasing the results.
         * @returns {Promise<GeoJSON>} A promise containing a Carmen GeoJSON object.
         */
        function geocodeMapbox(address, latitude, longitude) {
            var params = {
                "access_token": MAPBOX_KEY,
                "country": STORE_LOCATOR_SEARCH_COUNTRY,
                "types": STORE_LOCATOR_SEARCH_TYPE
            };
            if (latitude && longitude) params.proximity = longitude + "," + latitude;
            if (MAPBOX_BBOX) params.bbox = MAPBOX_BBOX;

            return APIMapboxService.getFeatures(address, params)
                .then(function (response) {
                    return response.features[0];
                });
        }

    }
})();

(function () {
  'use strict';

  angular
    .module('storeLocator')
    .directive('elemReady', function ($parse) {
      return {
        restrict: 'A',
        link: function ($scope, elem, attrs) {
          setTimeout(function () {
            var started;

            elem.load(function () {
              if (!started) $scope.$apply(function () {
                var func = $parse(attrs.elemReady);
                func($scope);
                started = true;
              })
            });

            elem.ready(function () {
              if (!started) $scope.$apply(function () {
                var func = $parse(attrs.elemReady);
                func($scope);
                started = true;
              })
            })
          })

        }
      }
    })
})();

(function () {
  'use strict';

  angular
    .module('storeLocator')
    .factory('customFieldFactory', customFieldFactory);

  function customFieldFactory() {
    var factory = {
      getValueByName: getValueByName,
      getTranslatedValueByName: getTranslatedValueByName,
      getFieldCountByName: getFieldCountByName,
      getFieldCountByRegex: getFieldCountByRegex,
      getButtonCount: getButtonCount,
      getImageCount: getImageCount,
      getLocatorImageCount: getLocatorImageCount,
      resolveDynamicFieldsInText: resolveDynamicFieldsInText,
    };

    function getValueByName(customFields, customFieldName) {
      if (customFields) {
        var field = _.find(customFields, {'name': customFieldName});
        if (field) {
          return field.data;
        }
      }

      return null;
    }
    
    function getTranslatedValueByName(customFields, customFieldName, language) {
      if (customFields) {
        var field = _.find(customFields, {'name': customFieldName + '_' + language});
        if (field) {
          return field.data;
        }else{
          return getValueByName(customFields, customFieldName);
        }
      }

      return null;
    }

    function getFieldCountByName(customFields, customFieldName){
      if (customFields){
        var fields = _.filter(customFields, function(field){
          return field.name.toLowerCase().indexOf(customFieldName.toLowerCase()) === 0;
        });
        return fields.length;
      }
      return 0;
    }


    function getFieldCountByRegex(customFields, regex) {
      if (customFields) {
        var fields = _.filter(customFields, function (field) {
          return field.name.match(regex);
        });
        return fields.length;
      }
      return 0;
    }

    function getButtonCount(customFields) {
      return getFieldCountByRegex(customFields,new RegExp(/^button\d+_text$/));
    }

    function getImageCount(customFields) {
      return getFieldCountByRegex(customFields, new RegExp(/^single_image\d+$/));
    }

    function getLocatorImageCount(customFields) {
      return getFieldCountByRegex(customFields, new RegExp(/^locator_single_image_\d+_link$/));
    }

    //Resolve dynamic fields with this pattern: *|dynamicfield|*
    function resolveDynamicFieldsInText(locationData, customFields, customFieldName) {
      var content = _.find(customFields, {'name': customFieldName});
      var dynamicFieldsInText = content.data.match(/\*\|([^|]+)\|\*/g);
      var formattedText = content.data.split(/\*\|([^|]+)\|\*/g);
      if (dynamicFieldsInText) {
        dynamicFieldsInText.forEach(function(f) {
          var field = f.substring(2, f.length - 2);
          var customField = _.find(customFields, {'name': field});
          if (customField) {
            formattedText[formattedText.indexOf(field)] = customField.data;
          } else {
            formattedText[formattedText.indexOf(field)] = locationData[field];
          }
        })
      }
      return formattedText.join("");
    }

    return factory;
  }
})();

(function () {
  "use strict";

  angular.module("storeLocator").factory("UtilsService", function () {
    var service = {
      getCurrentYear: function () {
        return new Date().getFullYear();
      },
    };

    return service;
  });
})();

(function () {
  'use strict';

  angular
      .module('storeLocator')
      .factory('StoreFinderService', StoreFinderService);

  function StoreFinderService(APIStoreFinderService, storeLocatorCache) {

    return {
      getMessagesAndMeta: function (language) {
        return APIStoreFinderService.getSettings(language).then(function (response) {
          storeLocatorCache.save('storeFindersMessages', { lang: language, messages: response.messages });
          storeLocatorCache.save('storeFindersOptions', response.options );
        });
      },
    };
  }
})();

(function () {
  'use strict';

  angular
      .module('storeLocator')
      .factory('MetaDataService', MetaDataService);

  function MetaDataService(META, customFieldFactory) {
    var metaDataPageKeys = [
      'title',
      'desc',
      'keywords',
      'image'
    ];

    var metaDataGlobalKeys = [
      'favicon',
      'googleSiteVerification',
      'bingSiteVerification',
      'widgetOriginUrl'
    ];

    var replaceDynamicFields = function(dynamicFields, str, location) {
      var replacedString = str;
      dynamicFields.forEach(function(field) {
        var fieldName = field.substring(2, field.length - 2);
        var value = fieldName.indexOf('custom_') !== -1 ? customFieldFactory.getValueByName(location.custom_fields, fieldName.split('custom_').join('')) : location.store_info[fieldName];
        replacedString = replacedString.split(field).join(value);
      });
      return replacedString;
    };

    var getMetaDataValue = function(key, meta, location) {
      var value = meta[key] || META[key];
      var exp = new RegExp('\\*\\|[^*|\\s+]*\\|\\*', 'g');
      var dynamicFields = value ? value.match(exp) : null;
      return dynamicFields && location ? replaceDynamicFields(dynamicFields, value, location) : value || '';
    };

    return {
      getMetaData: function(sfOptions, pageType, location) {
        var result = { pageType: pageType };

        metaDataPageKeys.forEach(function(key) {
          var sfOptionsKey = pageType + key.charAt(0).toUpperCase().concat(key.slice(1));
          result[key] = getMetaDataValue(sfOptionsKey, sfOptions, location);
        });

        metaDataGlobalKeys.forEach(function(key) {
          result[key] = getMetaDataValue(key, sfOptions, location);
        });

        return result;
      },
      getBurberrySitemapDescription: function(mainMetaDescription, sitemapLevel, levelValues) {
        switch (sitemapLevel) {
          case 'global':
          case 'all':
            return mainMetaDescription;
          case 'country':
            return getCustomDescription('country');
          case 'region':
            return getCustomDescription('region');
          case 'locality':
            return getCustomDescription('locality')
          default:
            break;
        }

        function getCustomDescription(sitemapLevel) {
          var currentValues = levelValues.filter(function(val){
            return val !== undefined
          })
          var sitemapLevelDescription = META['sitemap_' + sitemapLevel + '_description'];
          for (var i = 0; i < currentValues.length; i++) {
            sitemapLevelDescription = sitemapLevelDescription[currentValues[i]];
          }
          return sitemapLevelDescription;
        }
      }
    };
  }


})();

(function () {
  'use strict';

  angular
      .module('storeLocator')
      .factory('LanguageService', LanguageService);

  function LanguageService(
    $state,
    $window,
    HAS_MULTILINGUAL,
    SUPPORTED_LANGUAGES,
    DEFAULT_LANGUAGE,
    LANGUAGE_COOKIE,
    storeLocatorCache,
    moment,
    _,
    CLIENT_ROUTE,
    CLIENT_NAME) {

    function addNewValidSubdirectory(validSubdirectories){
      CLIENT_ROUTE.split('/').forEach(
        function(element){
          if(element !== '' && element !== undefined){
            validSubdirectories.push(element);
          }
        }
      )
    }

    function createHreflangLink(lang, href) {
      var link = document.createElement('link');
      link.rel = 'alternate';
      link.hreflang = lang;
      link.href = href;
      document.head.appendChild(link);
    }

    function removeHreflangLinks() {
      var hreflangElements = document.querySelectorAll('link[rel="alternate"][hreflang]');
      hreflangElements.forEach(function (element) {
        element.remove();
      });
    }

    var languageService = {
      setLanguage: function () {
        var languageFromCache = storeLocatorCache.get('language');
        var urlLanguage = languageFromCache || $window.location.pathname.split('/')[1];
        var languageCookie = null;

        if (LANGUAGE_COOKIE) {
          var completeCookie = "; " + document.cookie;
          var parts = completeCookie.split("; " + LANGUAGE_COOKIE + "=");
          languageCookie = (parts.length === 2) ? parts.pop().split(";").shift() : null;
        }

        if (HAS_MULTILINGUAL) {
          if(CLIENT_ROUTE !== ''){
            urlLanguage = languageFromCache || $window.location.pathname.split('/')[2];
          }
          // This will removed once the multilingual epic be completed
          var excludedRoutes = ['404', '400', '500'];
          if (!excludedRoutes.includes(urlLanguage)) {
            if (urlLanguage !== '') {
              if (SUPPORTED_LANGUAGES.includes(urlLanguage)) {
                storeLocatorCache.save('language', urlLanguage);
                moment.locale(urlLanguage);
              } else {
                // The language is not supported, redirects to the default language
                $window.location.href = languageService.getUrl(urlLanguage, true);
              }
            } else {
              // It does not have the language in the URL,
              // if it has Language Cookie it redirects to this language URL
              // otherwise it redirects to the default language
              $window.location.href = languageCookie ? languageService.getUrl(languageCookie) : languageService.getUrlWithDefaultLanguage();
            }
          }
          languageService.setPageHreflang(urlLanguage);
          return Promise.resolve(urlLanguage);
        } else {
          moment.locale(DEFAULT_LANGUAGE, {
            meridiem: function(hour, minute, isLower) {
              return hour < 12 ? 'am' : 'pm';
            }
          });
          return Promise.resolve(DEFAULT_LANGUAGE);
        }
      },
      getUrl: function (urlLanguage, isDefault, path ) {
        var position = 2
        var validSubdirectories = ['ll', 'site-map'];
        if (CLIENT_ROUTE !== '') {
          addNewValidSubdirectory(validSubdirectories);
        }
        if (validSubdirectories.includes(urlLanguage)) {
          position = 1
        }

        path = !_.isUndefined(path) ? path: $window.location.pathname.split('/').slice(position).join('/');
        var language = isDefault ? DEFAULT_LANGUAGE : urlLanguage

        return ('/' + language + '/' + path).replace(/\/$/, "");
      },
      getUrlWithDefaultLanguage: function () {
        var position = 2
        var validSubdirectories = ['ll', 'site-map'];
        if (CLIENT_ROUTE !== '') {
          addNewValidSubdirectory(validSubdirectories);
          position = 1
        }
        var path = $window.location.pathname.split('/').slice(position).join('/');
        if(storeLocatorCache.get('language') !== undefined){
          return ('/' + path + storeLocatorCache.get('language')).replace(/\/$/, "");
        }
        return ('/' + path + DEFAULT_LANGUAGE).replace(/\/$/, "");
      },
      updateLinkUrl: function (path) {
        if (CLIENT_NAME.toLowerCase().includes('burberry')) {
          path = path.replace(/^\/+/, '').replace(/ /g,'-').toLowerCase();
        } else {
          path = path.replace(/^\/+/, '');
        }
        if (CLIENT_ROUTE !== '') {
          var route = CLIENT_ROUTE.substring(1) + '/'; 
          if (HAS_MULTILINGUAL) {
              route += storeLocatorCache.get('language') + '/';
          }
          return route + path;
        }

        if (HAS_MULTILINGUAL) {
          return languageService.getUrl(storeLocatorCache.get('language'), false, path);
        }

        return path;
      },
      changeLanguage: function (lang) {
        storeLocatorCache.remove('locationsList');
        storeLocatorCache.remove('location');
        storeLocatorCache.save('language', lang);
        $state.go($state.current, { language: lang }, { reload: true });
      },
      getCurrentLanguage: function () {
        return storeLocatorCache.get('language');
      },
      setPageHreflang: function (urlLanguage) {
        removeHreflangLinks();
        var langRegex = new RegExp('/' + urlLanguage + '(?=/)|/' + urlLanguage + '$', 'g');
        createHreflangLink('x-default', $window.location.href.replace(langRegex, '/' + DEFAULT_LANGUAGE));
        SUPPORTED_LANGUAGES.forEach(function (lang) {
          createHreflangLink(lang, $window.location.href.replace(langRegex, '/' + lang));
        });
      }
    };
    return languageService;
  }


})();

(function () {
  'use strict';

  angular
    .module('storeLocator')
    .factory('RestangularConfigService', RestangularConfigService);
    function RestangularConfigService(Restangular) {
      return Restangular.withConfig(function (RestangularConfigurer) {
        RestangularConfigurer.setFullResponse(true);
        RestangularConfigurer.setDefaultHttpFields({ timeout: 10000 });
      });
    }
})();

(function() {
  'use strict';

  angular
    .module('storeLocator')
    .factory('APIMfLpAdapterService', APIMfLpAdapterService);

  function APIMfLpAdapterService(API_TOKEN, RestangularConfigService) {
    const restangularInstance = RestangularConfigService.withConfig(function (RestangularConfigurer) {
      RestangularConfigurer.setDefaultHeaders({ Authorization: API_TOKEN });
    });

    const baseMfLpAdapter = restangularInstance.all('mf-lp-adapter');

    const responseHandler = function(response) {
      return response.data;
    }

    return {
      llpJson: function (params) {
        return baseMfLpAdapter.one('llp.json').get(params).then(responseHandler);
      },
      llpGeo: function (params) {
        return baseMfLpAdapter.one('llp', 'geo').get(params).then(responseHandler);
      },
      llpNearbyJson: function (params) {
        return baseMfLpAdapter.one('llp', 'nearby.json').get(params).then(responseHandler);
      },
      llpPosts: function (params) {
        return baseMfLpAdapter.one('content', 'lpPosts').get(params).then(responseHandler);
      },
      siteMap: function(params) {
        return baseMfLpAdapter.one('v2').one('llp', 'sitemap').get(params).then(responseHandler);
      },
      location: {
        media: function (id, params) {
          return baseMfLpAdapter.one('location', id).one('media').get(params).then(responseHandler);
        },
        menus: function(id, params) {
          return baseMfLpAdapter.one('location', id).one('menus').get(params).then(responseHandler);
        },
        listings: function(id) {
          return baseMfLpAdapter.one('locations', id).one('listings').get().then(responseHandler);
        },
        customItems: function(id) {
          return baseMfLpAdapter.one('location', id).one('customItems').get().then(responseHandler);
        }
      },
      reviews: {
        get: function(id, params) {
          return baseMfLpAdapter.one('momentfeed').one('location', id).get(params).then(responseHandler);
        },
        post: function(params) {
          return baseMfLpAdapter.one('momentfeed').post('', params);
        }
      }
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('storeLocator')
    .factory('APIStoreFinderService', APIStoreFinderService);

  function APIStoreFinderService(RestangularConfigService, API_TOKEN) {
    const baseStoreFinders = RestangularConfigService.all('storefinders');

    return {
      getSettings: function(language) {
        return baseStoreFinders
          .one(API_TOKEN)
          .one('settings', language)
          .get({ includeMfExtraKeys: true })
          .then(function(response) {
            return response.data.response;
          });
      }
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('storeLocator')
    .factory('APIMapboxService', APIMapboxService);

  function APIMapboxService(Restangular, MAPBOX_GEOCODE_URL, s) {
    const responseHandler = function (response, isSearchBoxApi) {
      if (!isSearchBoxApi) {
        return response;
      }

      return {
        features: response.features.map(function (feature) {
          return {
            text: feature.properties.name,
            place_name: feature.properties.name + ', ' + feature.properties.place_formatted,
            place_type: [feature.properties.feature_type],
            geometry: feature.geometry,
            center: feature.geometry.coordinates
          };
        })
      };
    };

    return {
      getFeatures: function (address, params) {
        const url = s(MAPBOX_GEOCODE_URL).sprintf(encodeURIComponent(address)).value();
        const isSearchBoxApi = url.includes('/search/searchbox');

        if (isSearchBoxApi) {
          params.auto_complete = true;
        }

        return Restangular
          .oneUrl('mapbox', url)
          .get(params)
          .then(function (response) {
            return responseHandler(response, isSearchBoxApi);
          });
      }
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('storeLocator')
    .controller('RootController', RootController);

  /** @ngInject */

  function RootController($window, s, $rootScope, $location, pubSub, BUNDLE_PATH, NOINDEX_PAGES, NOINDEX_QA_ENV, NOINDEX_PROD_ENV) {
    var url = window.location.href;
    var prodEnvironment = url.indexOf('localhost') === -1 && url.indexOf('llp.qa') === -1;

    pubSub.subscribe(function(response) {
      if (response.msg === 'setMeta') {
        setMeta(response.metadata);
      } if (response.msg === 'setMetaImage') {
        setMetaImageAsync(response.metadataImage);
      }
    });

    function setMeta(metadata) {
      $rootScope.title = function() {
        return s(metadata.title)
          .replace('undefined', '')
          .replace('null', '')
          .trim().clean().value();
      };

      $rootScope.image = function() {
        return metadata.image;
      };

      $rootScope.description = function(){
        return s(metadata.desc)
                .replace('undefined', '')
                .replace('null', '')
                .trim().clean().value();
      };

      $rootScope.keywords = function(){
        return s(metadata.keywords)
                .replace('undefined', '')
                .replace('null', '')
                .trim().clean().value();
      };

      $rootScope.canonical_url = function () {
        var baseUrl = metadata.widgetOriginUrl;
        return (prodEnvironment ? baseUrl : $window.origin) + $location.$$path;
      };

      $rootScope.metaFavicon = function() {
        var faviconPath = metadata.favicon;
        if (BUNDLE_PATH.length > 0 && faviconPath.split('/')[0] === 'assets') {
          var absURL = $location.$$absUrl.split('/');
          faviconPath = absURL[0] + '//' + absURL[2] + BUNDLE_PATH + '/' + faviconPath;
        }
        return faviconPath;
      };

      $rootScope.twitter_handle = function () {
        return metadata.twitter_handle;
      };

      $rootScope.googleSiteVerification = function () {
        return metadata.googleSiteVerification;
      };

      $rootScope.bingSiteVerification = function () {
        return metadata.bingSiteVerification;
      };

      $rootScope.index = function () {
        try {
          var currentUrl = window.location.href;
          if (!prodEnvironment) {
            return NOINDEX_QA_ENV ? 'noindex' : 'index';
          }
          if (NOINDEX_PROD_ENV && currentUrl.includes('llp.prod.momentfeed.com')) {
            return 'noindex';
          }
          if (NOINDEX_PAGES && NOINDEX_PAGES.includes('site-map') && metadata && metadata.pageType === 'sitemap') {
            return 'noindex';
          }
          if (NOINDEX_PAGES && NOINDEX_PAGES.includes('store-locator') && metadata && metadata.pageType === 'mainPage') {
            return 'noindex';
          }
          if (NOINDEX_PAGES && NOINDEX_PAGES.includes('local-page') && metadata && metadata.pageType === 'localPage') {
            return 'noindex';
          }
          return 'INDEX, FOLLOW';
        } catch (error) {
          return 'INDEX, FOLLOW';
        }
      };
    }

    function setMetaImageAsync(metadataImage) {
      var metaImageEl = document.createElement('meta');
      var metaImageSecureEl = document.createElement('meta');
      metaImageEl.setAttribute('property', 'og:image');
      metaImageSecureEl.setAttribute('property', 'og:image:secure');
      metaImageEl.setAttribute('content', metadataImage);
      metaImageSecureEl.setAttribute('content', metadataImage);
      document.head.appendChild(metaImageEl);
      document.head.appendChild(metaImageSecureEl);
    }

    $rootScope.isMobile = {
      android: function() { return navigator.userAgent.match(/Android/i); },
      ios: function() { return navigator.userAgent.match(/iPhone|iPad|iPod/i); }
    };
  }
})();

!function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var c="function"==typeof require&&require;if(!u&&c)return c(o,!0);if(i)return i(o,!0);var a=new Error("Cannot find module '"+o+"'");throw a.code="MODULE_NOT_FOUND",a}var f=n[o]={exports:{}};t[o][0].call(f.exports,function(n){var r=t[o][1][n];return s(r||n)},f,f.exports,e,t,n,r)}return n[o].exports}for(var i="function"==typeof require&&require,o=0;o<r.length;o++)s(r[o]);return s}({1:[function(t,n,r){(function(n){"use strict";function define(t,n,e){t[n]||Object[r](t,n,{writable:!0,configurable:!0,value:e})}if(t(327),t(328),t(2),n._babelPolyfill)throw new Error("only one instance of babel-polyfill is allowed");n._babelPolyfill=!0;var r="defineProperty";define(String.prototype,"padLeft","".padStart),define(String.prototype,"padRight","".padEnd),"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function(t){[][t]&&define(Array,t,Function.call.bind([][t]))})}).call(this,"undefined"!=typeof global?global:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{2:2,327:327,328:328}],2:[function(t,n,r){t(130),n.exports=t(23).RegExp.escape},{130:130,23:23}],3:[function(t,n,r){n.exports=function(t){if("function"!=typeof t)throw TypeError(t+" is not a function!");return t}},{}],4:[function(t,n,r){var e=t(18);n.exports=function(t,n){if("number"!=typeof t&&"Number"!=e(t))throw TypeError(n);return+t}},{18:18}],5:[function(t,n,r){var e=t(128)("unscopables"),i=Array.prototype;void 0==i[e]&&t(42)(i,e,{}),n.exports=function(t){i[e][t]=!0}},{128:128,42:42}],6:[function(t,n,r){n.exports=function(t,n,r,e){if(!(t instanceof n)||void 0!==e&&e in t)throw TypeError(r+": incorrect invocation!");return t}},{}],7:[function(t,n,r){var e=t(51);n.exports=function(t){if(!e(t))throw TypeError(t+" is not an object!");return t}},{51:51}],8:[function(t,n,r){"use strict";var e=t(119),i=t(114),o=t(118);n.exports=[].copyWithin||function copyWithin(t,n){var r=e(this),u=o(r.length),c=i(t,u),a=i(n,u),f=arguments.length>2?arguments[2]:void 0,s=Math.min((void 0===f?u:i(f,u))-a,u-c),l=1;for(a<c&&c<a+s&&(l=-1,a+=s-1,c+=s-1);s-- >0;)a in r?r[c]=r[a]:delete r[c],c+=l,a+=l;return r}},{114:114,118:118,119:119}],9:[function(t,n,r){"use strict";var e=t(119),i=t(114),o=t(118);n.exports=function fill(t){for(var n=e(this),r=o(n.length),u=arguments.length,c=i(u>1?arguments[1]:void 0,r),a=u>2?arguments[2]:void 0,f=void 0===a?r:i(a,r);f>c;)n[c++]=t;return n}},{114:114,118:118,119:119}],10:[function(t,n,r){var e=t(39);n.exports=function(t,n){var r=[];return e(t,!1,r.push,r,n),r}},{39:39}],11:[function(t,n,r){var e=t(117),i=t(118),o=t(114);n.exports=function(t){return function(n,r,u){var c,a=e(n),f=i(a.length),s=o(u,f);if(t&&r!=r){for(;f>s;)if((c=a[s++])!=c)return!0}else for(;f>s;s++)if((t||s in a)&&a[s]===r)return t||s||0;return!t&&-1}}},{114:114,117:117,118:118}],12:[function(t,n,r){var e=t(25),i=t(47),o=t(119),u=t(118),c=t(15);n.exports=function(t,n){var r=1==t,a=2==t,f=3==t,s=4==t,l=6==t,h=5==t||l,v=n||c;return function(n,c,p){for(var d,y,g=o(n),m=i(g),b=e(c,p,3),x=u(m.length),S=0,w=r?v(n,x):a?v(n,0):void 0;x>S;S++)if((h||S in m)&&(d=m[S],y=b(d,S,g),t))if(r)w[S]=y;else if(y)switch(t){case 3:return!0;case 5:return d;case 6:return S;case 2:w.push(d)}else if(s)return!1;return l?-1:f||s?s:w}}},{118:118,119:119,15:15,25:25,47:47}],13:[function(t,n,r){var e=t(3),i=t(119),o=t(47),u=t(118);n.exports=function(t,n,r,c,a){e(n);var f=i(t),s=o(f),l=u(f.length),h=a?l-1:0,v=a?-1:1;if(r<2)for(;;){if(h in s){c=s[h],h+=v;break}if(h+=v,a?h<0:l<=h)throw TypeError("Reduce of empty array with no initial value")}for(;a?h>=0:l>h;h+=v)h in s&&(c=n(c,s[h],h,f));return c}},{118:118,119:119,3:3,47:47}],14:[function(t,n,r){var e=t(51),i=t(49),o=t(128)("species");n.exports=function(t){var n;return i(t)&&(n=t.constructor,"function"!=typeof n||n!==Array&&!i(n.prototype)||(n=void 0),e(n)&&null===(n=n[o])&&(n=void 0)),void 0===n?Array:n}},{128:128,49:49,51:51}],15:[function(t,n,r){var e=t(14);n.exports=function(t,n){return new(e(t))(n)}},{14:14}],16:[function(t,n,r){"use strict";var e=t(3),i=t(51),o=t(46),u=[].slice,c={},a=function(t,n,r){if(!(n in c)){for(var e=[],i=0;i<n;i++)e[i]="a["+i+"]";c[n]=Function("F,a","return new F("+e.join(",")+")")}return c[n](t,r)};n.exports=Function.bind||function bind(t){var n=e(this),r=u.call(arguments,1),c=function(){var e=r.concat(u.call(arguments));return this instanceof c?a(n,e.length,e):o(n,e,t)};return i(n.prototype)&&(c.prototype=n.prototype),c}},{3:3,46:46,51:51}],17:[function(t,n,r){var e=t(18),i=t(128)("toStringTag"),o="Arguments"==e(function(){return arguments}()),u=function(t,n){try{return t[n]}catch(t){}};n.exports=function(t){var n,r,c;return void 0===t?"Undefined":null===t?"Null":"string"==typeof(r=u(n=Object(t),i))?r:o?e(n):"Object"==(c=e(n))&&"function"==typeof n.callee?"Arguments":c}},{128:128,18:18}],18:[function(t,n,r){var e={}.toString;n.exports=function(t){return e.call(t).slice(8,-1)}},{}],19:[function(t,n,r){"use strict";var e=t(72).f,i=t(71),o=t(93),u=t(25),c=t(6),a=t(39),f=t(55),s=t(57),l=t(100),h=t(29),v=t(66).fastKey,p=t(125),d=h?"_s":"size",y=function(t,n){var r,e=v(n);if("F"!==e)return t._i[e];for(r=t._f;r;r=r.n)if(r.k==n)return r};n.exports={getConstructor:function(t,n,r,f){var s=t(function(t,e){c(t,s,n,"_i"),t._t=n,t._i=i(null),t._f=void 0,t._l=void 0,t[d]=0,void 0!=e&&a(e,r,t[f],t)});return o(s.prototype,{clear:function clear(){for(var t=p(this,n),r=t._i,e=t._f;e;e=e.n)e.r=!0,e.p&&(e.p=e.p.n=void 0),delete r[e.i];t._f=t._l=void 0,t[d]=0},delete:function(t){var r=p(this,n),e=y(r,t);if(e){var i=e.n,o=e.p;delete r._i[e.i],e.r=!0,o&&(o.n=i),i&&(i.p=o),r._f==e&&(r._f=i),r._l==e&&(r._l=o),r[d]--}return!!e},forEach:function forEach(t){p(this,n);for(var r,e=u(t,arguments.length>1?arguments[1]:void 0,3);r=r?r.n:this._f;)for(e(r.v,r.k,this);r&&r.r;)r=r.p},has:function has(t){return!!y(p(this,n),t)}}),h&&e(s.prototype,"size",{get:function(){return p(this,n)[d]}}),s},def:function(t,n,r){var e,i,o=y(t,n);return o?o.v=r:(t._l=o={i:i=v(n,!0),k:n,v:r,p:e=t._l,n:void 0,r:!1},t._f||(t._f=o),e&&(e.n=o),t[d]++,"F"!==i&&(t._i[i]=o)),t},getEntry:y,setStrong:function(t,n,r){f(t,n,function(t,r){this._t=p(t,n),this._k=r,this._l=void 0},function(){for(var t=this,n=t._k,r=t._l;r&&r.r;)r=r.p;return t._t&&(t._l=r=r?r.n:t._t._f)?"keys"==n?s(0,r.k):"values"==n?s(0,r.v):s(0,[r.k,r.v]):(t._t=void 0,s(1))},r?"entries":"values",!r,!0),l(n)}}},{100:100,125:125,25:25,29:29,39:39,55:55,57:57,6:6,66:66,71:71,72:72,93:93}],20:[function(t,n,r){var e=t(17),i=t(10);n.exports=function(t){return function toJSON(){if(e(this)!=t)throw TypeError(t+"#toJSON isn't generic");return i(this)}}},{10:10,17:17}],21:[function(t,n,r){"use strict";var e=t(93),i=t(66).getWeak,o=t(7),u=t(51),c=t(6),a=t(39),f=t(12),s=t(41),l=t(125),h=f(5),v=f(6),p=0,d=function(t){return t._l||(t._l=new y)},y=function(){this.a=[]},g=function(t,n){return h(t.a,function(t){return t[0]===n})};y.prototype={get:function(t){var n=g(this,t);if(n)return n[1]},has:function(t){return!!g(this,t)},set:function(t,n){var r=g(this,t);r?r[1]=n:this.a.push([t,n])},delete:function(t){var n=v(this.a,function(n){return n[0]===t});return~n&&this.a.splice(n,1),!!~n}},n.exports={getConstructor:function(t,n,r,o){var f=t(function(t,e){c(t,f,n,"_i"),t._t=n,t._i=p++,t._l=void 0,void 0!=e&&a(e,r,t[o],t)});return e(f.prototype,{delete:function(t){if(!u(t))return!1;var r=i(t);return!0===r?d(l(this,n)).delete(t):r&&s(r,this._i)&&delete r[this._i]},has:function has(t){if(!u(t))return!1;var r=i(t);return!0===r?d(l(this,n)).has(t):r&&s(r,this._i)}}),f},def:function(t,n,r){var e=i(o(n),!0);return!0===e?d(t).set(n,r):e[t._i]=r,t},ufstore:d}},{12:12,125:125,39:39,41:41,51:51,6:6,66:66,7:7,93:93}],22:[function(t,n,r){"use strict";var e=t(40),i=t(33),o=t(94),u=t(93),c=t(66),a=t(39),f=t(6),s=t(51),l=t(35),h=t(56),v=t(101),p=t(45);n.exports=function(t,n,r,d,y,g){var m=e[t],b=m,x=y?"set":"add",S=b&&b.prototype,w={},_=function(t){var n=S[t];o(S,t,"delete"==t?function(t){return!(g&&!s(t))&&n.call(this,0===t?0:t)}:"has"==t?function has(t){return!(g&&!s(t))&&n.call(this,0===t?0:t)}:"get"==t?function get(t){return g&&!s(t)?void 0:n.call(this,0===t?0:t)}:"add"==t?function add(t){return n.call(this,0===t?0:t),this}:function set(t,r){return n.call(this,0===t?0:t,r),this})};if("function"==typeof b&&(g||S.forEach&&!l(function(){(new b).entries().next()}))){var E=new b,O=E[x](g?{}:-0,1)!=E,P=l(function(){E.has(1)}),M=h(function(t){new b(t)}),F=!g&&l(function(){for(var t=new b,n=5;n--;)t[x](n,n);return!t.has(-0)});M||(b=n(function(n,r){f(n,b,t);var e=p(new m,n,b);return void 0!=r&&a(r,y,e[x],e),e}),b.prototype=S,S.constructor=b),(P||F)&&(_("delete"),_("has"),y&&_("get")),(F||O)&&_(x),g&&S.clear&&delete S.clear}else b=d.getConstructor(n,t,y,x),u(b.prototype,r),c.NEED=!0;return v(b,t),w[t]=b,i(i.G+i.W+i.F*(b!=m),w),g||d.setStrong(b,t,y),b}},{101:101,33:33,35:35,39:39,40:40,45:45,51:51,56:56,6:6,66:66,93:93,94:94}],23:[function(t,n,r){var e=n.exports={version:"2.5.0"};"number"==typeof __e&&(__e=e)},{}],24:[function(t,n,r){"use strict";var e=t(72),i=t(92);n.exports=function(t,n,r){n in t?e.f(t,n,i(0,r)):t[n]=r}},{72:72,92:92}],25:[function(t,n,r){var e=t(3);n.exports=function(t,n,r){if(e(t),void 0===n)return t;switch(r){case 1:return function(r){return t.call(n,r)};case 2:return function(r,e){return t.call(n,r,e)};case 3:return function(r,e,i){return t.call(n,r,e,i)}}return function(){return t.apply(n,arguments)}}},{3:3}],26:[function(t,n,r){"use strict";var e=t(35),i=Date.prototype.getTime,o=Date.prototype.toISOString,u=function(t){return t>9?t:"0"+t};n.exports=e(function(){return"0385-07-25T07:06:39.999Z"!=o.call(new Date(-5e13-1))})||!e(function(){o.call(new Date(NaN))})?function toISOString(){if(!isFinite(i.call(this)))throw RangeError("Invalid time value");var t=this,n=t.getUTCFullYear(),r=t.getUTCMilliseconds(),e=n<0?"-":n>9999?"+":"";return e+("00000"+Math.abs(n)).slice(e?-6:-4)+"-"+u(t.getUTCMonth()+1)+"-"+u(t.getUTCDate())+"T"+u(t.getUTCHours())+":"+u(t.getUTCMinutes())+":"+u(t.getUTCSeconds())+"."+(r>99?r:"0"+u(r))+"Z"}:o},{35:35}],27:[function(t,n,r){"use strict";var e=t(7),i=t(120);n.exports=function(t){if("string"!==t&&"number"!==t&&"default"!==t)throw TypeError("Incorrect hint");return i(e(this),"number"!=t)}},{120:120,7:7}],28:[function(t,n,r){n.exports=function(t){if(void 0==t)throw TypeError("Can't call method on  "+t);return t}},{}],29:[function(t,n,r){n.exports=!t(35)(function(){return 7!=Object.defineProperty({},"a",{get:function(){return 7}}).a})},{35:35}],30:[function(t,n,r){var e=t(51),i=t(40).document,o=e(i)&&e(i.createElement);n.exports=function(t){return o?i.createElement(t):{}}},{40:40,51:51}],31:[function(t,n,r){n.exports="constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(",")},{}],32:[function(t,n,r){var e=t(81),i=t(78),o=t(82);n.exports=function(t){var n=e(t),r=i.f;if(r)for(var u,c=r(t),a=o.f,f=0;c.length>f;)a.call(t,u=c[f++])&&n.push(u);return n}},{78:78,81:81,82:82}],33:[function(t,n,r){var e=t(40),i=t(23),o=t(42),u=t(94),c=t(25),a=function(t,n,r){var f,s,l,h,v=t&a.F,p=t&a.G,d=t&a.S,y=t&a.P,g=t&a.B,m=p?e:d?e[n]||(e[n]={}):(e[n]||{}).prototype,b=p?i:i[n]||(i[n]={}),x=b.prototype||(b.prototype={});p&&(r=n);for(f in r)s=!v&&m&&void 0!==m[f],l=(s?m:r)[f],h=g&&s?c(l,e):y&&"function"==typeof l?c(Function.call,l):l,m&&u(m,f,l,t&a.U),b[f]!=l&&o(b,f,h),y&&x[f]!=l&&(x[f]=l)};e.core=i,a.F=1,a.G=2,a.S=4,a.P=8,a.B=16,a.W=32,a.U=64,a.R=128,n.exports=a},{23:23,25:25,40:40,42:42,94:94}],34:[function(t,n,r){var e=t(128)("match");n.exports=function(t){var n=/./;try{"/./"[t](n)}catch(r){try{return n[e]=!1,!"/./"[t](n)}catch(t){}}return!0}},{128:128}],35:[function(t,n,r){n.exports=function(t){try{return!!t()}catch(t){return!0}}},{}],36:[function(t,n,r){"use strict";var e=t(42),i=t(94),o=t(35),u=t(28),c=t(128);n.exports=function(t,n,r){var a=c(t),f=r(u,a,""[t]),s=f[0],l=f[1];o(function(){var n={};return n[a]=function(){return 7},7!=""[t](n)})&&(i(String.prototype,t,s),e(RegExp.prototype,a,2==n?function(t,n){return l.call(t,this,n)}:function(t){return l.call(t,this)}))}},{128:128,28:28,35:35,42:42,94:94}],37:[function(t,n,r){"use strict";var e=t(7);n.exports=function(){var t=e(this),n="";return t.global&&(n+="g"),t.ignoreCase&&(n+="i"),t.multiline&&(n+="m"),t.unicode&&(n+="u"),t.sticky&&(n+="y"),n}},{7:7}],38:[function(t,n,r){"use strict";function flattenIntoArray(t,n,r,a,f,s,l,h){for(var v,p,d=f,y=0,g=!!l&&u(l,h,3);y<a;){if(y in r){if(v=g?g(r[y],y,n):r[y],p=!1,i(v)&&(p=v[c],p=void 0!==p?!!p:e(v)),p&&s>0)d=flattenIntoArray(t,n,v,o(v.length),d,s-1)-1;else{if(d>=9007199254740991)throw TypeError();t[d]=v}d++}y++}return d}var e=t(49),i=t(51),o=t(118),u=t(25),c=t(128)("isConcatSpreadable");n.exports=flattenIntoArray},{118:118,128:128,25:25,49:49,51:51}],39:[function(t,n,r){var e=t(25),i=t(53),o=t(48),u=t(7),c=t(118),a=t(129),f={},s={},r=n.exports=function(t,n,r,l,h){var v,p,d,y,g=h?function(){return t}:a(t),m=e(r,l,n?2:1),b=0;if("function"!=typeof g)throw TypeError(t+" is not iterable!");if(o(g)){for(v=c(t.length);v>b;b++)if((y=n?m(u(p=t[b])[0],p[1]):m(t[b]))===f||y===s)return y}else for(d=g.call(t);!(p=d.next()).done;)if((y=i(d,m,p.value,n))===f||y===s)return y};r.BREAK=f,r.RETURN=s},{118:118,129:129,25:25,48:48,53:53,7:7}],40:[function(t,n,r){var e=n.exports="undefined"!=typeof window&&window.Math==Math?window:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")();"number"==typeof __g&&(__g=e)},{}],41:[function(t,n,r){var e={}.hasOwnProperty;n.exports=function(t,n){return e.call(t,n)}},{}],42:[function(t,n,r){var e=t(72),i=t(92);n.exports=t(29)?function(t,n,r){return e.f(t,n,i(1,r))}:function(t,n,r){return t[n]=r,t}},{29:29,72:72,92:92}],43:[function(t,n,r){var e=t(40).document;n.exports=e&&e.documentElement},{40:40}],44:[function(t,n,r){n.exports=!t(29)&&!t(35)(function(){return 7!=Object.defineProperty(t(30)("div"),"a",{get:function(){return 7}}).a})},{29:29,30:30,35:35}],45:[function(t,n,r){var e=t(51),i=t(99).set;n.exports=function(t,n,r){var o,u=n.constructor;return u!==r&&"function"==typeof u&&(o=u.prototype)!==r.prototype&&e(o)&&i&&i(t,o),t}},{51:51,99:99}],46:[function(t,n,r){n.exports=function(t,n,r){var e=void 0===r;switch(n.length){case 0:return e?t():t.call(r);case 1:return e?t(n[0]):t.call(r,n[0]);case 2:return e?t(n[0],n[1]):t.call(r,n[0],n[1]);case 3:return e?t(n[0],n[1],n[2]):t.call(r,n[0],n[1],n[2]);case 4:return e?t(n[0],n[1],n[2],n[3]):t.call(r,n[0],n[1],n[2],n[3])}return t.apply(r,n)}},{}],47:[function(t,n,r){var e=t(18);n.exports=Object("z").propertyIsEnumerable(0)?Object:function(t){return"String"==e(t)?t.split(""):Object(t)}},{18:18}],48:[function(t,n,r){var e=t(58),i=t(128)("iterator"),o=Array.prototype;n.exports=function(t){return void 0!==t&&(e.Array===t||o[i]===t)}},{128:128,58:58}],49:[function(t,n,r){var e=t(18);n.exports=Array.isArray||function isArray(t){return"Array"==e(t)}},{18:18}],50:[function(t,n,r){var e=t(51),i=Math.floor;n.exports=function isInteger(t){return!e(t)&&isFinite(t)&&i(t)===t}},{51:51}],51:[function(t,n,r){n.exports=function(t){return"object"==typeof t?null!==t:"function"==typeof t}},{}],52:[function(t,n,r){var e=t(51),i=t(18),o=t(128)("match");n.exports=function(t){var n;return e(t)&&(void 0!==(n=t[o])?!!n:"RegExp"==i(t))}},{128:128,18:18,51:51}],53:[function(t,n,r){var e=t(7);n.exports=function(t,n,r,i){try{return i?n(e(r)[0],r[1]):n(r)}catch(n){var o=t.return;throw void 0!==o&&e(o.call(t)),n}}},{7:7}],54:[function(t,n,r){"use strict";var e=t(71),i=t(92),o=t(101),u={};t(42)(u,t(128)("iterator"),function(){return this}),n.exports=function(t,n,r){t.prototype=e(u,{next:i(1,r)}),o(t,n+" Iterator")}},{101:101,128:128,42:42,71:71,92:92}],55:[function(t,n,r){"use strict";var e=t(60),i=t(33),o=t(94),u=t(42),c=t(41),a=t(58),f=t(54),s=t(101),l=t(79),h=t(128)("iterator"),v=!([].keys&&"next"in[].keys()),p=function(){return this};n.exports=function(t,n,r,d,y,g,m){f(r,n,d);var b,x,S,w=function(t){if(!v&&t in P)return P[t];switch(t){case"keys":return function keys(){return new r(this,t)};case"values":return function values(){return new r(this,t)}}return function entries(){return new r(this,t)}},_=n+" Iterator",E="values"==y,O=!1,P=t.prototype,M=P[h]||P["@@iterator"]||y&&P[y],F=M||w(y),I=y?E?w("entries"):F:void 0,A="Array"==n?P.entries||M:M;if(A&&(S=l(A.call(new t)))!==Object.prototype&&S.next&&(s(S,_,!0),e||c(S,h)||u(S,h,p)),E&&M&&"values"!==M.name&&(O=!0,F=function values(){return M.call(this)}),e&&!m||!v&&!O&&P[h]||u(P,h,F),a[n]=F,a[_]=p,y)if(b={values:E?F:w("values"),keys:g?F:w("keys"),entries:I},m)for(x in b)x in P||o(P,x,b[x]);else i(i.P+i.F*(v||O),n,b);return b}},{101:101,128:128,33:33,41:41,42:42,54:54,58:58,60:60,79:79,94:94}],56:[function(t,n,r){var e=t(128)("iterator"),i=!1;try{var o=[7][e]();o.return=function(){i=!0},Array.from(o,function(){throw 2})}catch(t){}n.exports=function(t,n){if(!n&&!i)return!1;var r=!1;try{var o=[7],u=o[e]();u.next=function(){return{done:r=!0}},o[e]=function(){return u},t(o)}catch(t){}return r}},{128:128}],57:[function(t,n,r){n.exports=function(t,n){return{value:n,done:!!t}}},{}],58:[function(t,n,r){n.exports={}},{}],59:[function(t,n,r){var e=t(81),i=t(117);n.exports=function(t,n){for(var r,o=i(t),u=e(o),c=u.length,a=0;c>a;)if(o[r=u[a++]]===n)return r}},{117:117,81:81}],60:[function(t,n,r){n.exports=!1},{}],61:[function(t,n,r){var e=Math.expm1;n.exports=!e||e(10)>22025.465794806718||e(10)<22025.465794806718||-2e-17!=e(-2e-17)?function expm1(t){return 0==(t=+t)?t:t>-1e-6&&t<1e-6?t+t*t/2:Math.exp(t)-1}:e},{}],62:[function(t,n,r){var e=t(65),i=Math.pow,o=i(2,-52),u=i(2,-23),c=i(2,127)*(2-u),a=i(2,-126),f=function(t){return t+1/o-1/o};n.exports=Math.fround||function fround(t){var n,r,i=Math.abs(t),s=e(t);return i<a?s*f(i/a/u)*a*u:(n=(1+u/o)*i,r=n-(n-i),r>c||r!=r?s*(1/0):s*r)}},{65:65}],63:[function(t,n,r){n.exports=Math.log1p||function log1p(t){return(t=+t)>-1e-8&&t<1e-8?t-t*t/2:Math.log(1+t)}},{}],64:[function(t,n,r){n.exports=Math.scale||function scale(t,n,r,e,i){return 0===arguments.length||t!=t||n!=n||r!=r||e!=e||i!=i?NaN:t===1/0||t===-1/0?t:(t-n)*(i-e)/(r-n)+e}},{}],65:[function(t,n,r){n.exports=Math.sign||function sign(t){return 0==(t=+t)||t!=t?t:t<0?-1:1}},{}],66:[function(t,n,r){var e=t(124)("meta"),i=t(51),o=t(41),u=t(72).f,c=0,a=Object.isExtensible||function(){return!0},f=!t(35)(function(){return a(Object.preventExtensions({}))}),s=function(t){u(t,e,{value:{i:"O"+ ++c,w:{}}})},l=function(t,n){if(!i(t))return"symbol"==typeof t?t:("string"==typeof t?"S":"P")+t;if(!o(t,e)){if(!a(t))return"F";if(!n)return"E";s(t)}return t[e].i},h=function(t,n){if(!o(t,e)){if(!a(t))return!0;if(!n)return!1;s(t)}return t[e].w},v=function(t){return f&&p.NEED&&a(t)&&!o(t,e)&&s(t),t},p=n.exports={KEY:e,NEED:!1,fastKey:l,getWeak:h,onFreeze:v}},{124:124,35:35,41:41,51:51,72:72}],67:[function(t,n,r){var e=t(160),i=t(33),o=t(103)("metadata"),u=o.store||(o.store=new(t(266))),c=function(t,n,r){var i=u.get(t);if(!i){if(!r)return;u.set(t,i=new e)}var o=i.get(n);if(!o){if(!r)return;i.set(n,o=new e)}return o},a=function(t,n,r){var e=c(n,r,!1);return void 0!==e&&e.has(t)},f=function(t,n,r){var e=c(n,r,!1);return void 0===e?void 0:e.get(t)},s=function(t,n,r,e){c(r,e,!0).set(t,n)},l=function(t,n){var r=c(t,n,!1),e=[];return r&&r.forEach(function(t,n){e.push(n)}),e},h=function(t){return void 0===t||"symbol"==typeof t?t:String(t)},v=function(t){i(i.S,"Reflect",t)};n.exports={store:u,map:c,has:a,get:f,set:s,keys:l,key:h,exp:v}},{103:103,160:160,266:266,33:33}],68:[function(t,n,r){var e=t(40),i=t(113).set,o=e.MutationObserver||e.WebKitMutationObserver,u=e.process,c=e.Promise,a="process"==t(18)(u);n.exports=function(){var t,n,r,f=function(){var e,i;for(a&&(e=u.domain)&&e.exit();t;){i=t.fn,t=t.next;try{i()}catch(e){throw t?r():n=void 0,e}}n=void 0,e&&e.enter()};if(a)r=function(){u.nextTick(f)};else if(o){var s=!0,l=document.createTextNode("");new o(f).observe(l,{characterData:!0}),r=function(){l.data=s=!s}}else if(c&&c.resolve){var h=c.resolve();r=function(){h.then(f)}}else r=function(){i.call(e,f)};return function(e){var i={fn:e,next:void 0};n&&(n.next=i),t||(t=i,r()),n=i}}},{113:113,18:18,40:40}],69:[function(t,n,r){"use strict";function PromiseCapability(t){var n,r;this.promise=new t(function(t,e){if(void 0!==n||void 0!==r)throw TypeError("Bad Promise constructor");n=t,r=e}),this.resolve=e(n),this.reject=e(r)}var e=t(3);n.exports.f=function(t){return new PromiseCapability(t)}},{3:3}],70:[function(t,n,r){"use strict";var e=t(81),i=t(78),o=t(82),u=t(119),c=t(47),a=Object.assign;n.exports=!a||t(35)(function(){var t={},n={},r=Symbol(),e="abcdefghijklmnopqrst";return t[r]=7,e.split("").forEach(function(t){n[t]=t}),7!=a({},t)[r]||Object.keys(a({},n)).join("")!=e})?function assign(t,n){for(var r=u(t),a=arguments.length,f=1,s=i.f,l=o.f;a>f;)for(var h,v=c(arguments[f++]),p=s?e(v).concat(s(v)):e(v),d=p.length,y=0;d>y;)l.call(v,h=p[y++])&&(r[h]=v[h]);return r}:a},{119:119,35:35,47:47,78:78,81:81,82:82}],71:[function(t,n,r){var e=t(7),i=t(73),o=t(31),u=t(102)("IE_PROTO"),c=function(){},a=function(){var n,r=t(30)("iframe"),e=o.length;for(r.style.display="none",t(43).appendChild(r),r.src="javascript:",n=r.contentWindow.document,n.open(),n.write("<script>document.F=Object<\/script>"),n.close(),a=n.F;e--;)delete a.prototype[o[e]];return a()};n.exports=Object.create||function create(t,n){var r;return null!==t?(c.prototype=e(t),r=new c,c.prototype=null,r[u]=t):r=a(),void 0===n?r:i(r,n)}},{102:102,30:30,31:31,43:43,7:7,73:73}],72:[function(t,n,r){var e=t(7),i=t(44),o=t(120),u=Object.defineProperty;r.f=t(29)?Object.defineProperty:function defineProperty(t,n,r){if(e(t),n=o(n,!0),e(r),i)try{return u(t,n,r)}catch(t){}if("get"in r||"set"in r)throw TypeError("Accessors not supported!");return"value"in r&&(t[n]=r.value),t}},{120:120,29:29,44:44,7:7}],73:[function(t,n,r){var e=t(72),i=t(7),o=t(81);n.exports=t(29)?Object.defineProperties:function defineProperties(t,n){i(t);for(var r,u=o(n),c=u.length,a=0;c>a;)e.f(t,r=u[a++],n[r]);return t}},{29:29,7:7,72:72,81:81}],74:[function(t,n,r){"use strict";n.exports=t(60)||!t(35)(function(){var n=Math.random();__defineSetter__.call(null,n,function(){}),delete t(40)[n]})},{35:35,40:40,60:60}],75:[function(t,n,r){var e=t(82),i=t(92),o=t(117),u=t(120),c=t(41),a=t(44),f=Object.getOwnPropertyDescriptor;r.f=t(29)?f:function getOwnPropertyDescriptor(t,n){if(t=o(t),n=u(n,!0),a)try{return f(t,n)}catch(t){}if(c(t,n))return i(!e.f.call(t,n),t[n])}},{117:117,120:120,29:29,41:41,44:44,82:82,92:92}],76:[function(t,n,r){var e=t(117),i=t(77).f,o={}.toString,u="object"==typeof window&&window&&Object.getOwnPropertyNames?Object.getOwnPropertyNames(window):[],c=function(t){try{return i(t)}catch(t){return u.slice()}};n.exports.f=function getOwnPropertyNames(t){return u&&"[object Window]"==o.call(t)?c(t):i(e(t))}},{117:117,77:77}],77:[function(t,n,r){var e=t(80),i=t(31).concat("length","prototype");r.f=Object.getOwnPropertyNames||function getOwnPropertyNames(t){return e(t,i)}},{31:31,80:80}],78:[function(t,n,r){r.f=Object.getOwnPropertySymbols},{}],79:[function(t,n,r){var e=t(41),i=t(119),o=t(102)("IE_PROTO"),u=Object.prototype;n.exports=Object.getPrototypeOf||function(t){return t=i(t),e(t,o)?t[o]:"function"==typeof t.constructor&&t instanceof t.constructor?t.constructor.prototype:t instanceof Object?u:null}},{102:102,119:119,41:41}],80:[function(t,n,r){var e=t(41),i=t(117),o=t(11)(!1),u=t(102)("IE_PROTO");n.exports=function(t,n){var r,c=i(t),a=0,f=[];for(r in c)r!=u&&e(c,r)&&f.push(r);for(;n.length>a;)e(c,r=n[a++])&&(~o(f,r)||f.push(r));return f}},{102:102,11:11,117:117,41:41}],81:[function(t,n,r){var e=t(80),i=t(31);n.exports=Object.keys||function keys(t){return e(t,i)}},{31:31,80:80}],82:[function(t,n,r){r.f={}.propertyIsEnumerable},{}],83:[function(t,n,r){var e=t(33),i=t(23),o=t(35);n.exports=function(t,n){var r=(i.Object||{})[t]||Object[t],u={};u[t]=n(r),e(e.S+e.F*o(function(){r(1)}),"Object",u)}},{23:23,33:33,35:35}],84:[function(t,n,r){var e=t(81),i=t(117),o=t(82).f;n.exports=function(t){return function(n){for(var r,u=i(n),c=e(u),a=c.length,f=0,s=[];a>f;)o.call(u,r=c[f++])&&s.push(t?[r,u[r]]:u[r]);return s}}},{117:117,81:81,82:82}],85:[function(t,n,r){var e=t(77),i=t(78),o=t(7),u=t(40).Reflect;n.exports=u&&u.ownKeys||function ownKeys(t){var n=e.f(o(t)),r=i.f;return r?n.concat(r(t)):n}},{40:40,7:7,77:77,78:78}],86:[function(t,n,r){var e=t(40).parseFloat,i=t(111).trim;n.exports=1/e(t(112)+"-0")!=-1/0?function parseFloat(t){var n=i(String(t),3),r=e(n);return 0===r&&"-"==n.charAt(0)?-0:r}:e},{111:111,112:112,40:40}],87:[function(t,n,r){var e=t(40).parseInt,i=t(111).trim,o=t(112),u=/^[-+]?0[xX]/;n.exports=8!==e(o+"08")||22!==e(o+"0x16")?function parseInt(t,n){var r=i(String(t),3);return e(r,n>>>0||(u.test(r)?16:10))}:e},{111:111,112:112,40:40}],88:[function(t,n,r){"use strict";var e=t(89),i=t(46),o=t(3);n.exports=function(){for(var t=o(this),n=arguments.length,r=Array(n),u=0,c=e._,a=!1;n>u;)(r[u]=arguments[u++])===c&&(a=!0);return function(){var e,o=this,u=arguments.length,f=0,s=0;if(!a&&!u)return i(t,r,o);if(e=r.slice(),a)for(;n>f;f++)e[f]===c&&(e[f]=arguments[s++]);for(;u>s;)e.push(arguments[s++]);return i(t,e,o)}}},{3:3,46:46,89:89}],89:[function(t,n,r){n.exports=t(40)},{40:40}],90:[function(t,n,r){n.exports=function(t){try{return{e:!1,v:t()}}catch(t){return{e:!0,v:t}}}},{}],91:[function(t,n,r){var e=t(69);n.exports=function(t,n){var r=e.f(t);return(0,r.resolve)(n),r.promise}},{69:69}],92:[function(t,n,r){n.exports=function(t,n){return{enumerable:!(1&t),configurable:!(2&t),writable:!(4&t),value:n}}},{}],93:[function(t,n,r){var e=t(94);n.exports=function(t,n,r){for(var i in n)e(t,i,n[i],r);return t}},{94:94}],94:[function(t,n,r){var e=t(40),i=t(42),o=t(41),u=t(124)("src"),c=Function.toString,a=(""+c).split("toString");t(23).inspectSource=function(t){return c.call(t)},(n.exports=function(t,n,r,c){var f="function"==typeof r;f&&(o(r,"name")||i(r,"name",n)),t[n]!==r&&(f&&(o(r,u)||i(r,u,t[n]?""+t[n]:a.join(String(n)))),t===e?t[n]=r:c?t[n]?t[n]=r:i(t,n,r):(delete t[n],i(t,n,r)))})(Function.prototype,"toString",function toString(){return"function"==typeof this&&this[u]||c.call(this)})},{124:124,23:23,40:40,41:41,42:42}],95:[function(t,n,r){n.exports=function(t,n){var r=n===Object(n)?function(t){return n[t]}:n;return function(n){return String(n).replace(t,r)}}},{}],96:[function(t,n,r){n.exports=Object.is||function is(t,n){return t===n?0!==t||1/t==1/n:t!=t&&n!=n}},{}],97:[function(t,n,r){"use strict";var e=t(33),i=t(3),o=t(25),u=t(39);n.exports=function(t){e(e.S,t,{from:function from(t){var n,r,e,c,a=arguments[1];return i(this),n=void 0!==a,n&&i(a),void 0==t?new this:(r=[],n?(e=0,c=o(a,arguments[2],2),u(t,!1,function(t){r.push(c(t,e++))})):u(t,!1,r.push,r),new this(r))}})}},{25:25,3:3,33:33,39:39}],98:[function(t,n,r){"use strict";var e=t(33);n.exports=function(t){e(e.S,t,{of:function of(){for(var t=arguments.length,n=Array(t);t--;)n[t]=arguments[t];return new this(n)}})}},{33:33}],99:[function(t,n,r){var e=t(51),i=t(7),o=function(t,n){if(i(t),!e(n)&&null!==n)throw TypeError(n+": can't set as prototype!")};n.exports={set:Object.setPrototypeOf||("__proto__"in{}?function(n,r,e){try{e=t(25)(Function.call,t(75).f(Object.prototype,"__proto__").set,2),e(n,[]),r=!(n instanceof Array)}catch(t){r=!0}return function setPrototypeOf(t,n){return o(t,n),r?t.__proto__=n:e(t,n),t}}({},!1):void 0),check:o}},{25:25,51:51,7:7,75:75}],100:[function(t,n,r){"use strict";var e=t(40),i=t(72),o=t(29),u=t(128)("species");n.exports=function(t){var n=e[t];o&&n&&!n[u]&&i.f(n,u,{configurable:!0,get:function(){return this}})}},{128:128,29:29,40:40,72:72}],101:[function(t,n,r){var e=t(72).f,i=t(41),o=t(128)("toStringTag");n.exports=function(t,n,r){t&&!i(t=r?t:t.prototype,o)&&e(t,o,{configurable:!0,value:n})}},{128:128,41:41,72:72}],102:[function(t,n,r){var e=t(103)("keys"),i=t(124);n.exports=function(t){return e[t]||(e[t]=i(t))}},{103:103,124:124}],103:[function(t,n,r){var e=t(40),i=e["__core-js_shared__"]||(e["__core-js_shared__"]={});n.exports=function(t){return i[t]||(i[t]={})}},{40:40}],104:[function(t,n,r){var e=t(7),i=t(3),o=t(128)("species");n.exports=function(t,n){var r,u=e(t).constructor;return void 0===u||void 0==(r=e(u)[o])?n:i(r)}},{128:128,3:3,7:7}],105:[function(t,n,r){"use strict";var e=t(35);n.exports=function(t,n){return!!t&&e(function(){n?t.call(null,function(){},1):t.call(null)})}},{35:35}],106:[function(t,n,r){var e=t(116),i=t(28);n.exports=function(t){return function(n,r){var o,u,c=String(i(n)),a=e(r),f=c.length;return a<0||a>=f?t?"":void 0:(o=c.charCodeAt(a),o<55296||o>56319||a+1===f||(u=c.charCodeAt(a+1))<56320||u>57343?t?c.charAt(a):o:t?c.slice(a,a+2):u-56320+(o-55296<<10)+65536)}}},{116:116,28:28}],107:[function(t,n,r){var e=t(52),i=t(28);n.exports=function(t,n,r){if(e(n))throw TypeError("String#"+r+" doesn't accept regex!");return String(i(t))}},{28:28,52:52}],108:[function(t,n,r){var e=t(33),i=t(35),o=t(28),u=/"/g,c=function(t,n,r,e){var i=String(o(t)),c="<"+n;return""!==r&&(c+=" "+r+'="'+String(e).replace(u,"&quot;")+'"'),c+">"+i+"</"+n+">"};n.exports=function(t,n){var r={};r[t]=n(c),e(e.P+e.F*i(function(){var n=""[t]('"');return n!==n.toLowerCase()||n.split('"').length>3}),"String",r)}},{28:28,33:33,35:35}],109:[function(t,n,r){var e=t(118),i=t(110),o=t(28);n.exports=function(t,n,r,u){var c=String(o(t)),a=c.length,f=void 0===r?" ":String(r),s=e(n);if(s<=a||""==f)return c;var l=s-a,h=i.call(f,Math.ceil(l/f.length));return h.length>l&&(h=h.slice(0,l)),u?h+c:c+h}},{110:110,118:118,28:28}],110:[function(t,n,r){"use strict";var e=t(116),i=t(28);n.exports=function repeat(t){var n=String(i(this)),r="",o=e(t);if(o<0||o==1/0)throw RangeError("Count can't be negative");for(;o>0;(o>>>=1)&&(n+=n))1&o&&(r+=n);return r}},{116:116,28:28}],111:[function(t,n,r){var e=t(33),i=t(28),o=t(35),u=t(112),c="["+u+"]",a="​",f=RegExp("^"+c+c+"*"),s=RegExp(c+c+"*$"),l=function(t,n,r){var i={},c=o(function(){return!!u[t]()||a[t]()!=a}),f=i[t]=c?n(h):u[t];r&&(i[r]=f),e(e.P+e.F*c,"String",i)},h=l.trim=function(t,n){return t=String(i(t)),1&n&&(t=t.replace(f,"")),2&n&&(t=t.replace(s,"")),t};n.exports=l},{112:112,28:28,33:33,35:35}],112:[function(t,n,r){n.exports="\t\n\v\f\r   ᠎             　\u2028\u2029\ufeff"},{}],113:[function(t,n,r){var e,i,o,u=t(25),c=t(46),a=t(43),f=t(30),s=t(40),l=s.process,h=s.setImmediate,v=s.clearImmediate,p=s.MessageChannel,d=s.Dispatch,y=0,g={},m=function(){var t=+this;if(g.hasOwnProperty(t)){var n=g[t];delete g[t],n()}},b=function(t){m.call(t.data)};h&&v||(h=function setImmediate(t){for(var n=[],r=1;arguments.length>r;)n.push(arguments[r++]);return g[++y]=function(){c("function"==typeof t?t:Function(t),n)},e(y),y},v=function clearImmediate(t){delete g[t]},"process"==t(18)(l)?e=function(t){l.nextTick(u(m,t,1))}:d&&d.now?e=function(t){d.now(u(m,t,1))}:p?(i=new p,o=i.port2,i.port1.onmessage=b,e=u(o.postMessage,o,1)):s.addEventListener&&"function"==typeof postMessage&&!s.importScripts?(e=function(t){s.postMessage(t+"","*")},s.addEventListener("message",b,!1)):e="onreadystatechange"in f("script")?function(t){a.appendChild(f("script")).onreadystatechange=function(){a.removeChild(this),m.call(t)}}:function(t){setTimeout(u(m,t,1),0)}),n.exports={set:h,clear:v}},{18:18,25:25,30:30,40:40,43:43,46:46}],114:[function(t,n,r){var e=t(116),i=Math.max,o=Math.min;n.exports=function(t,n){return t=e(t),t<0?i(t+n,0):o(t,n)}},{116:116}],115:[function(t,n,r){var e=t(116),i=t(118);n.exports=function(t){if(void 0===t)return 0;var n=e(t),r=i(n);if(n!==r)throw RangeError("Wrong length!");return r}},{116:116,118:118}],116:[function(t,n,r){var e=Math.ceil,i=Math.floor;n.exports=function(t){return isNaN(t=+t)?0:(t>0?i:e)(t)}},{}],117:[function(t,n,r){var e=t(47),i=t(28);n.exports=function(t){return e(i(t))}},{28:28,47:47}],118:[function(t,n,r){var e=t(116),i=Math.min;n.exports=function(t){return t>0?i(e(t),9007199254740991):0}},{116:116}],
119:[function(t,n,r){var e=t(28);n.exports=function(t){return Object(e(t))}},{28:28}],120:[function(t,n,r){var e=t(51);n.exports=function(t,n){if(!e(t))return t;var r,i;if(n&&"function"==typeof(r=t.toString)&&!e(i=r.call(t)))return i;if("function"==typeof(r=t.valueOf)&&!e(i=r.call(t)))return i;if(!n&&"function"==typeof(r=t.toString)&&!e(i=r.call(t)))return i;throw TypeError("Can't convert object to primitive value")}},{51:51}],121:[function(t,n,r){"use strict";if(t(29)){var e=t(60),i=t(40),o=t(35),u=t(33),c=t(123),a=t(122),f=t(25),s=t(6),l=t(92),h=t(42),v=t(93),p=t(116),d=t(118),y=t(115),g=t(114),m=t(120),b=t(41),x=t(17),S=t(51),w=t(119),_=t(48),E=t(71),O=t(79),P=t(77).f,M=t(129),F=t(124),I=t(128),A=t(12),k=t(11),N=t(104),j=t(141),T=t(58),R=t(56),L=t(100),G=t(9),D=t(8),C=t(72),W=t(75),U=C.f,B=W.f,V=i.RangeError,z=i.TypeError,q=i.Uint8Array,K=Array.prototype,Y=a.ArrayBuffer,J=a.DataView,H=A(0),X=A(2),$=A(3),Z=A(4),Q=A(5),tt=A(6),nt=k(!0),rt=k(!1),et=j.values,it=j.keys,ot=j.entries,ut=K.lastIndexOf,ct=K.reduce,at=K.reduceRight,ft=K.join,st=K.sort,lt=K.slice,ht=K.toString,vt=K.toLocaleString,pt=I("iterator"),dt=I("toStringTag"),yt=F("typed_constructor"),gt=F("def_constructor"),mt=c.CONSTR,bt=c.TYPED,xt=c.VIEW,St=A(1,function(t,n){return Pt(N(t,t[gt]),n)}),wt=o(function(){return 1===new q(new Uint16Array([1]).buffer)[0]}),_t=!!q&&!!q.prototype.set&&o(function(){new q(1).set({})}),Et=function(t,n){var r=p(t);if(r<0||r%n)throw V("Wrong offset!");return r},Ot=function(t){if(S(t)&&bt in t)return t;throw z(t+" is not a typed array!")},Pt=function(t,n){if(!(S(t)&&yt in t))throw z("It is not a typed array constructor!");return new t(n)},Mt=function(t,n){return Ft(N(t,t[gt]),n)},Ft=function(t,n){for(var r=0,e=n.length,i=Pt(t,e);e>r;)i[r]=n[r++];return i},It=function(t,n,r){U(t,n,{get:function(){return this._d[r]}})},At=function from(t){var n,r,e,i,o,u,c=w(t),a=arguments.length,s=a>1?arguments[1]:void 0,l=void 0!==s,h=M(c);if(void 0!=h&&!_(h)){for(u=h.call(c),e=[],n=0;!(o=u.next()).done;n++)e.push(o.value);c=e}for(l&&a>2&&(s=f(s,arguments[2],2)),n=0,r=d(c.length),i=Pt(this,r);r>n;n++)i[n]=l?s(c[n],n):c[n];return i},kt=function of(){for(var t=0,n=arguments.length,r=Pt(this,n);n>t;)r[t]=arguments[t++];return r},Nt=!!q&&o(function(){vt.call(new q(1))}),jt=function toLocaleString(){return vt.apply(Nt?lt.call(Ot(this)):Ot(this),arguments)},Tt={copyWithin:function copyWithin(t,n){return D.call(Ot(this),t,n,arguments.length>2?arguments[2]:void 0)},every:function every(t){return Z(Ot(this),t,arguments.length>1?arguments[1]:void 0)},fill:function fill(t){return G.apply(Ot(this),arguments)},filter:function filter(t){return Mt(this,X(Ot(this),t,arguments.length>1?arguments[1]:void 0))},find:function find(t){return Q(Ot(this),t,arguments.length>1?arguments[1]:void 0)},findIndex:function findIndex(t){return tt(Ot(this),t,arguments.length>1?arguments[1]:void 0)},forEach:function forEach(t){H(Ot(this),t,arguments.length>1?arguments[1]:void 0)},indexOf:function indexOf(t){return rt(Ot(this),t,arguments.length>1?arguments[1]:void 0)},includes:function includes(t){return nt(Ot(this),t,arguments.length>1?arguments[1]:void 0)},join:function join(t){return ft.apply(Ot(this),arguments)},lastIndexOf:function lastIndexOf(t){return ut.apply(Ot(this),arguments)},map:function map(t){return St(Ot(this),t,arguments.length>1?arguments[1]:void 0)},reduce:function reduce(t){return ct.apply(Ot(this),arguments)},reduceRight:function reduceRight(t){return at.apply(Ot(this),arguments)},reverse:function reverse(){for(var t,n=this,r=Ot(n).length,e=Math.floor(r/2),i=0;i<e;)t=n[i],n[i++]=n[--r],n[r]=t;return n},some:function some(t){return $(Ot(this),t,arguments.length>1?arguments[1]:void 0)},sort:function sort(t){return st.call(Ot(this),t)},subarray:function subarray(t,n){var r=Ot(this),e=r.length,i=g(t,e);return new(N(r,r[gt]))(r.buffer,r.byteOffset+i*r.BYTES_PER_ELEMENT,d((void 0===n?e:g(n,e))-i))}},Rt=function slice(t,n){return Mt(this,lt.call(Ot(this),t,n))},Lt=function set(t){Ot(this);var n=Et(arguments[1],1),r=this.length,e=w(t),i=d(e.length),o=0;if(i+n>r)throw V("Wrong length!");for(;o<i;)this[n+o]=e[o++]},Gt={entries:function entries(){return ot.call(Ot(this))},keys:function keys(){return it.call(Ot(this))},values:function values(){return et.call(Ot(this))}},Dt=function(t,n){return S(t)&&t[bt]&&"symbol"!=typeof n&&n in t&&String(+n)==String(n)},Ct=function getOwnPropertyDescriptor(t,n){return Dt(t,n=m(n,!0))?l(2,t[n]):B(t,n)},Wt=function defineProperty(t,n,r){return!(Dt(t,n=m(n,!0))&&S(r)&&b(r,"value"))||b(r,"get")||b(r,"set")||r.configurable||b(r,"writable")&&!r.writable||b(r,"enumerable")&&!r.enumerable?U(t,n,r):(t[n]=r.value,t)};mt||(W.f=Ct,C.f=Wt),u(u.S+u.F*!mt,"Object",{getOwnPropertyDescriptor:Ct,defineProperty:Wt}),o(function(){ht.call({})})&&(ht=vt=function toString(){return ft.call(this)});var Ut=v({},Tt);v(Ut,Gt),h(Ut,pt,Gt.values),v(Ut,{slice:Rt,set:Lt,constructor:function(){},toString:ht,toLocaleString:jt}),It(Ut,"buffer","b"),It(Ut,"byteOffset","o"),It(Ut,"byteLength","l"),It(Ut,"length","e"),U(Ut,dt,{get:function(){return this[bt]}}),n.exports=function(t,n,r,a){a=!!a;var f=t+(a?"Clamped":"")+"Array",l="get"+t,v="set"+t,p=i[f],g=p||{},m=p&&O(p),b=!p||!c.ABV,w={},_=p&&p.prototype,M=function(t,r){var e=t._d;return e.v[l](r*n+e.o,wt)},F=function(t,r,e){var i=t._d;a&&(e=(e=Math.round(e))<0?0:e>255?255:255&e),i.v[v](r*n+i.o,e,wt)},I=function(t,n){U(t,n,{get:function(){return M(this,n)},set:function(t){return F(this,n,t)},enumerable:!0})};b?(p=r(function(t,r,e,i){s(t,p,f,"_d");var o,u,c,a,l=0,v=0;if(S(r)){if(!(r instanceof Y||"ArrayBuffer"==(a=x(r))||"SharedArrayBuffer"==a))return bt in r?Ft(p,r):At.call(p,r);o=r,v=Et(e,n);var g=r.byteLength;if(void 0===i){if(g%n)throw V("Wrong length!");if((u=g-v)<0)throw V("Wrong length!")}else if((u=d(i)*n)+v>g)throw V("Wrong length!");c=u/n}else c=y(r),u=c*n,o=new Y(u);for(h(t,"_d",{b:o,o:v,l:u,e:c,v:new J(o)});l<c;)I(t,l++)}),_=p.prototype=E(Ut),h(_,"constructor",p)):o(function(){p(1)})&&o(function(){new p(-1)})&&R(function(t){new p,new p(null),new p(1.5),new p(t)},!0)||(p=r(function(t,r,e,i){s(t,p,f);var o;return S(r)?r instanceof Y||"ArrayBuffer"==(o=x(r))||"SharedArrayBuffer"==o?void 0!==i?new g(r,Et(e,n),i):void 0!==e?new g(r,Et(e,n)):new g(r):bt in r?Ft(p,r):At.call(p,r):new g(y(r))}),H(m!==Function.prototype?P(g).concat(P(m)):P(g),function(t){t in p||h(p,t,g[t])}),p.prototype=_,e||(_.constructor=p));var A=_[pt],k=!!A&&("values"==A.name||void 0==A.name),N=Gt.values;h(p,yt,!0),h(_,bt,f),h(_,xt,!0),h(_,gt,p),(a?new p(1)[dt]==f:dt in _)||U(_,dt,{get:function(){return f}}),w[f]=p,u(u.G+u.W+u.F*(p!=g),w),u(u.S,f,{BYTES_PER_ELEMENT:n}),u(u.S+u.F*o(function(){g.of.call(p,1)}),f,{from:At,of:kt}),"BYTES_PER_ELEMENT"in _||h(_,"BYTES_PER_ELEMENT",n),u(u.P,f,Tt),L(f),u(u.P+u.F*_t,f,{set:Lt}),u(u.P+u.F*!k,f,Gt),e||_.toString==ht||(_.toString=ht),u(u.P+u.F*o(function(){new p(1).slice()}),f,{slice:Rt}),u(u.P+u.F*(o(function(){return[1,2].toLocaleString()!=new p([1,2]).toLocaleString()})||!o(function(){_.toLocaleString.call([1,2])})),f,{toLocaleString:jt}),T[f]=k?A:N,e||k||h(_,pt,N)}}else n.exports=function(){}},{100:100,104:104,11:11,114:114,115:115,116:116,118:118,119:119,12:12,120:120,122:122,123:123,124:124,128:128,129:129,141:141,17:17,25:25,29:29,33:33,35:35,40:40,41:41,42:42,48:48,51:51,56:56,58:58,6:6,60:60,71:71,72:72,75:75,77:77,79:79,8:8,9:9,92:92,93:93}],122:[function(t,n,r){"use strict";function packIEEE754(t,n,r){var e,i,o,u=Array(r),c=8*r-n-1,a=(1<<c)-1,f=a>>1,s=23===n?M(2,-24)-M(2,-77):0,l=0,h=t<0||0===t&&1/t<0?1:0;for(t=P(t),t!=t||t===E?(i=t!=t?1:0,e=a):(e=F(I(t)/A),t*(o=M(2,-e))<1&&(e--,o*=2),t+=e+f>=1?s/o:s*M(2,1-f),t*o>=2&&(e++,o/=2),e+f>=a?(i=0,e=a):e+f>=1?(i=(t*o-1)*M(2,n),e+=f):(i=t*M(2,f-1)*M(2,n),e=0));n>=8;u[l++]=255&i,i/=256,n-=8);for(e=e<<n|i,c+=n;c>0;u[l++]=255&e,e/=256,c-=8);return u[--l]|=128*h,u}function unpackIEEE754(t,n,r){var e,i=8*r-n-1,o=(1<<i)-1,u=o>>1,c=i-7,a=r-1,f=t[a--],s=127&f;for(f>>=7;c>0;s=256*s+t[a],a--,c-=8);for(e=s&(1<<-c)-1,s>>=-c,c+=n;c>0;e=256*e+t[a],a--,c-=8);if(0===s)s=1-u;else{if(s===o)return e?NaN:f?-E:E;e+=M(2,n),s-=u}return(f?-1:1)*e*M(2,s-n)}function unpackI32(t){return t[3]<<24|t[2]<<16|t[1]<<8|t[0]}function packI8(t){return[255&t]}function packI16(t){return[255&t,t>>8&255]}function packI32(t){return[255&t,t>>8&255,t>>16&255,t>>24&255]}function packF64(t){return packIEEE754(t,52,8)}function packF32(t){return packIEEE754(t,23,4)}function addGetter(t,n,r){d(t[m],n,{get:function(){return this[r]}})}function get(t,n,r,e){var i=+r,o=v(i);if(o+n>t[N])throw _(b);var u=t[k]._b,c=o+t[j],a=u.slice(c,c+n);return e?a:a.reverse()}function set(t,n,r,e,i,o){var u=+r,c=v(u);if(c+n>t[N])throw _(b);for(var a=t[k]._b,f=c+t[j],s=e(+i),l=0;l<n;l++)a[f+l]=s[o?l:n-l-1]}var e=t(40),i=t(29),o=t(60),u=t(123),c=t(42),a=t(93),f=t(35),s=t(6),l=t(116),h=t(118),v=t(115),p=t(77).f,d=t(72).f,y=t(9),g=t(101),m="prototype",b="Wrong index!",x=e.ArrayBuffer,S=e.DataView,w=e.Math,_=e.RangeError,E=e.Infinity,O=x,P=w.abs,M=w.pow,F=w.floor,I=w.log,A=w.LN2,k=i?"_b":"buffer",N=i?"_l":"byteLength",j=i?"_o":"byteOffset";if(u.ABV){if(!f(function(){x(1)})||!f(function(){new x(-1)})||f(function(){return new x,new x(1.5),new x(NaN),"ArrayBuffer"!=x.name})){x=function ArrayBuffer(t){return s(this,x),new O(v(t))};for(var T,R=x[m]=O[m],L=p(O),G=0;L.length>G;)(T=L[G++])in x||c(x,T,O[T]);o||(R.constructor=x)}var D=new S(new x(2)),C=S[m].setInt8;D.setInt8(0,2147483648),D.setInt8(1,2147483649),!D.getInt8(0)&&D.getInt8(1)||a(S[m],{setInt8:function setInt8(t,n){C.call(this,t,n<<24>>24)},setUint8:function setUint8(t,n){C.call(this,t,n<<24>>24)}},!0)}else x=function ArrayBuffer(t){s(this,x,"ArrayBuffer");var n=v(t);this._b=y.call(Array(n),0),this[N]=n},S=function DataView(t,n,r){s(this,S,"DataView"),s(t,x,"DataView");var e=t[N],i=l(n);if(i<0||i>e)throw _("Wrong offset!");if(r=void 0===r?e-i:h(r),i+r>e)throw _("Wrong length!");this[k]=t,this[j]=i,this[N]=r},i&&(addGetter(x,"byteLength","_l"),addGetter(S,"buffer","_b"),addGetter(S,"byteLength","_l"),addGetter(S,"byteOffset","_o")),a(S[m],{getInt8:function getInt8(t){return get(this,1,t)[0]<<24>>24},getUint8:function getUint8(t){return get(this,1,t)[0]},getInt16:function getInt16(t){var n=get(this,2,t,arguments[1]);return(n[1]<<8|n[0])<<16>>16},getUint16:function getUint16(t){var n=get(this,2,t,arguments[1]);return n[1]<<8|n[0]},getInt32:function getInt32(t){return unpackI32(get(this,4,t,arguments[1]))},getUint32:function getUint32(t){return unpackI32(get(this,4,t,arguments[1]))>>>0},getFloat32:function getFloat32(t){return unpackIEEE754(get(this,4,t,arguments[1]),23,4)},getFloat64:function getFloat64(t){return unpackIEEE754(get(this,8,t,arguments[1]),52,8)},setInt8:function setInt8(t,n){set(this,1,t,packI8,n)},setUint8:function setUint8(t,n){set(this,1,t,packI8,n)},setInt16:function setInt16(t,n){set(this,2,t,packI16,n,arguments[2])},setUint16:function setUint16(t,n){set(this,2,t,packI16,n,arguments[2])},setInt32:function setInt32(t,n){set(this,4,t,packI32,n,arguments[2])},setUint32:function setUint32(t,n){set(this,4,t,packI32,n,arguments[2])},setFloat32:function setFloat32(t,n){set(this,4,t,packF32,n,arguments[2])},setFloat64:function setFloat64(t,n){set(this,8,t,packF64,n,arguments[2])}});g(x,"ArrayBuffer"),g(S,"DataView"),c(S[m],u.VIEW,!0),r.ArrayBuffer=x,r.DataView=S},{101:101,115:115,116:116,118:118,123:123,29:29,35:35,40:40,42:42,6:6,60:60,72:72,77:77,9:9,93:93}],123:[function(t,n,r){for(var e,i=t(40),o=t(42),u=t(124),c=u("typed_array"),a=u("view"),f=!(!i.ArrayBuffer||!i.DataView),s=f,l=0,h="Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array".split(",");l<9;)(e=i[h[l++]])?(o(e.prototype,c,!0),o(e.prototype,a,!0)):s=!1;n.exports={ABV:f,CONSTR:s,TYPED:c,VIEW:a}},{124:124,40:40,42:42}],124:[function(t,n,r){var e=0,i=Math.random();n.exports=function(t){return"Symbol(".concat(void 0===t?"":t,")_",(++e+i).toString(36))}},{}],125:[function(t,n,r){var e=t(51);n.exports=function(t,n){if(!e(t)||t._t!==n)throw TypeError("Incompatible receiver, "+n+" required!");return t}},{51:51}],126:[function(t,n,r){var e=t(40),i=t(23),o=t(60),u=t(127),c=t(72).f;n.exports=function(t){var n=i.Symbol||(i.Symbol=o?{}:e.Symbol||{});"_"==t.charAt(0)||t in n||c(n,t,{value:u.f(t)})}},{127:127,23:23,40:40,60:60,72:72}],127:[function(t,n,r){r.f=t(128)},{128:128}],128:[function(t,n,r){var e=t(103)("wks"),i=t(124),o=t(40).Symbol,u="function"==typeof o;(n.exports=function(t){return e[t]||(e[t]=u&&o[t]||(u?o:i)("Symbol."+t))}).store=e},{103:103,124:124,40:40}],129:[function(t,n,r){var e=t(17),i=t(128)("iterator"),o=t(58);n.exports=t(23).getIteratorMethod=function(t){if(void 0!=t)return t[i]||t["@@iterator"]||o[e(t)]}},{128:128,17:17,23:23,58:58}],130:[function(t,n,r){var e=t(33),i=t(95)(/[\\^$*+?.()|[\]{}]/g,"\\$&");e(e.S,"RegExp",{escape:function escape(t){return i(t)}})},{33:33,95:95}],131:[function(t,n,r){var e=t(33);e(e.P,"Array",{copyWithin:t(8)}),t(5)("copyWithin")},{33:33,5:5,8:8}],132:[function(t,n,r){"use strict";var e=t(33),i=t(12)(4);e(e.P+e.F*!t(105)([].every,!0),"Array",{every:function every(t){return i(this,t,arguments[1])}})},{105:105,12:12,33:33}],133:[function(t,n,r){var e=t(33);e(e.P,"Array",{fill:t(9)}),t(5)("fill")},{33:33,5:5,9:9}],134:[function(t,n,r){"use strict";var e=t(33),i=t(12)(2);e(e.P+e.F*!t(105)([].filter,!0),"Array",{filter:function filter(t){return i(this,t,arguments[1])}})},{105:105,12:12,33:33}],135:[function(t,n,r){"use strict";var e=t(33),i=t(12)(6),o="findIndex",u=!0;o in[]&&Array(1)[o](function(){u=!1}),e(e.P+e.F*u,"Array",{findIndex:function findIndex(t){return i(this,t,arguments.length>1?arguments[1]:void 0)}}),t(5)(o)},{12:12,33:33,5:5}],136:[function(t,n,r){"use strict";var e=t(33),i=t(12)(5),o=!0;"find"in[]&&Array(1).find(function(){o=!1}),e(e.P+e.F*o,"Array",{find:function find(t){return i(this,t,arguments.length>1?arguments[1]:void 0)}}),t(5)("find")},{12:12,33:33,5:5}],137:[function(t,n,r){"use strict";var e=t(33),i=t(12)(0),o=t(105)([].forEach,!0);e(e.P+e.F*!o,"Array",{forEach:function forEach(t){return i(this,t,arguments[1])}})},{105:105,12:12,33:33}],138:[function(t,n,r){"use strict";var e=t(25),i=t(33),o=t(119),u=t(53),c=t(48),a=t(118),f=t(24),s=t(129);i(i.S+i.F*!t(56)(function(t){Array.from(t)}),"Array",{from:function from(t){var n,r,i,l,h=o(t),v="function"==typeof this?this:Array,p=arguments.length,d=p>1?arguments[1]:void 0,y=void 0!==d,g=0,m=s(h);if(y&&(d=e(d,p>2?arguments[2]:void 0,2)),void 0==m||v==Array&&c(m))for(n=a(h.length),r=new v(n);n>g;g++)f(r,g,y?d(h[g],g):h[g]);else for(l=m.call(h),r=new v;!(i=l.next()).done;g++)f(r,g,y?u(l,d,[i.value,g],!0):i.value);return r.length=g,r}})},{118:118,119:119,129:129,24:24,25:25,33:33,48:48,53:53,56:56}],139:[function(t,n,r){"use strict";var e=t(33),i=t(11)(!1),o=[].indexOf,u=!!o&&1/[1].indexOf(1,-0)<0;e(e.P+e.F*(u||!t(105)(o)),"Array",{indexOf:function indexOf(t){return u?o.apply(this,arguments)||0:i(this,t,arguments[1])}})},{105:105,11:11,33:33}],140:[function(t,n,r){var e=t(33);e(e.S,"Array",{isArray:t(49)})},{33:33,49:49}],141:[function(t,n,r){"use strict";var e=t(5),i=t(57),o=t(58),u=t(117);n.exports=t(55)(Array,"Array",function(t,n){this._t=u(t),this._i=0,this._k=n},function(){var t=this._t,n=this._k,r=this._i++;return!t||r>=t.length?(this._t=void 0,i(1)):"keys"==n?i(0,r):"values"==n?i(0,t[r]):i(0,[r,t[r]])},"values"),o.Arguments=o.Array,e("keys"),e("values"),e("entries")},{117:117,5:5,55:55,57:57,58:58}],142:[function(t,n,r){"use strict";var e=t(33),i=t(117),o=[].join;e(e.P+e.F*(t(47)!=Object||!t(105)(o)),"Array",{join:function join(t){return o.call(i(this),void 0===t?",":t)}})},{105:105,117:117,33:33,47:47}],143:[function(t,n,r){"use strict";var e=t(33),i=t(117),o=t(116),u=t(118),c=[].lastIndexOf,a=!!c&&1/[1].lastIndexOf(1,-0)<0;e(e.P+e.F*(a||!t(105)(c)),"Array",{lastIndexOf:function lastIndexOf(t){if(a)return c.apply(this,arguments)||0;var n=i(this),r=u(n.length),e=r-1;for(arguments.length>1&&(e=Math.min(e,o(arguments[1]))),e<0&&(e=r+e);e>=0;e--)if(e in n&&n[e]===t)return e||0;return-1}})},{105:105,116:116,117:117,118:118,33:33}],144:[function(t,n,r){"use strict";var e=t(33),i=t(12)(1);e(e.P+e.F*!t(105)([].map,!0),"Array",{map:function map(t){return i(this,t,arguments[1])}})},{105:105,12:12,33:33}],145:[function(t,n,r){"use strict";var e=t(33),i=t(24);e(e.S+e.F*t(35)(function(){function F(){}return!(Array.of.call(F)instanceof F)}),"Array",{of:function of(){for(var t=0,n=arguments.length,r=new("function"==typeof this?this:Array)(n);n>t;)i(r,t,arguments[t++]);return r.length=n,r}})},{24:24,33:33,35:35}],146:[function(t,n,r){"use strict";var e=t(33),i=t(13);e(e.P+e.F*!t(105)([].reduceRight,!0),"Array",{reduceRight:function reduceRight(t){return i(this,t,arguments.length,arguments[1],!0)}})},{105:105,13:13,33:33}],147:[function(t,n,r){"use strict";var e=t(33),i=t(13);e(e.P+e.F*!t(105)([].reduce,!0),"Array",{reduce:function reduce(t){return i(this,t,arguments.length,arguments[1],!1)}})},{105:105,13:13,33:33}],148:[function(t,n,r){"use strict";var e=t(33),i=t(43),o=t(18),u=t(114),c=t(118),a=[].slice;e(e.P+e.F*t(35)(function(){i&&a.call(i)}),"Array",{slice:function slice(t,n){var r=c(this.length),e=o(this);if(n=void 0===n?r:n,"Array"==e)return a.call(this,t,n);for(var i=u(t,r),f=u(n,r),s=c(f-i),l=Array(s),h=0;h<s;h++)l[h]="String"==e?this.charAt(i+h):this[i+h];return l}})},{114:114,118:118,18:18,33:33,35:35,43:43}],149:[function(t,n,r){"use strict";var e=t(33),i=t(12)(3);e(e.P+e.F*!t(105)([].some,!0),"Array",{some:function some(t){return i(this,t,arguments[1])}})},{105:105,12:12,33:33}],150:[function(t,n,r){"use strict";var e=t(33),i=t(3),o=t(119),u=t(35),c=[].sort,a=[1,2,3];e(e.P+e.F*(u(function(){a.sort(void 0)})||!u(function(){a.sort(null)})||!t(105)(c)),"Array",{sort:function sort(t){return void 0===t?c.call(o(this)):c.call(o(this),i(t))}})},{105:105,119:119,3:3,33:33,35:35}],151:[function(t,n,r){t(100)("Array")},{100:100}],152:[function(t,n,r){var e=t(33);e(e.S,"Date",{now:function(){return(new Date).getTime()}})},{33:33}],153:[function(t,n,r){var e=t(33),i=t(26);e(e.P+e.F*(Date.prototype.toISOString!==i),"Date",{toISOString:i})},{26:26,33:33}],154:[function(t,n,r){"use strict";var e=t(33),i=t(119),o=t(120);e(e.P+e.F*t(35)(function(){return null!==new Date(NaN).toJSON()||1!==Date.prototype.toJSON.call({toISOString:function(){return 1}})}),"Date",{toJSON:function toJSON(t){var n=i(this),r=o(n);return"number"!=typeof r||isFinite(r)?n.toISOString():null}})},{119:119,120:120,33:33,35:35}],155:[function(t,n,r){var e=t(128)("toPrimitive"),i=Date.prototype;e in i||t(42)(i,e,t(27))},{128:128,27:27,42:42}],156:[function(t,n,r){var e=Date.prototype,i=e.toString,o=e.getTime;new Date(NaN)+""!="Invalid Date"&&t(94)(e,"toString",function toString(){var t=o.call(this);return t===t?i.call(this):"Invalid Date"})},{94:94}],157:[function(t,n,r){var e=t(33);e(e.P,"Function",{bind:t(16)})},{16:16,33:33}],158:[function(t,n,r){"use strict";var e=t(51),i=t(79),o=t(128)("hasInstance"),u=Function.prototype;o in u||t(72).f(u,o,{value:function(t){if("function"!=typeof this||!e(t))return!1;if(!e(this.prototype))return t instanceof this;for(;t=i(t);)if(this.prototype===t)return!0;return!1}})},{128:128,51:51,72:72,79:79}],159:[function(t,n,r){var e=t(72).f,i=Function.prototype,o=/^\s*function ([^ (]*)/;"name"in i||t(29)&&e(i,"name",{configurable:!0,get:function(){try{return(""+this).match(o)[1]}catch(t){return""}}})},{29:29,72:72}],160:[function(t,n,r){"use strict";var e=t(19),i=t(125);n.exports=t(22)("Map",function(t){return function Map(){return t(this,arguments.length>0?arguments[0]:void 0)}},{get:function get(t){var n=e.getEntry(i(this,"Map"),t);return n&&n.v},set:function set(t,n){return e.def(i(this,"Map"),0===t?0:t,n)}},e,!0)},{125:125,19:19,22:22}],161:[function(t,n,r){var e=t(33),i=t(63),o=Math.sqrt,u=Math.acosh;e(e.S+e.F*!(u&&710==Math.floor(u(Number.MAX_VALUE))&&u(1/0)==1/0),"Math",{acosh:function acosh(t){return(t=+t)<1?NaN:t>94906265.62425156?Math.log(t)+Math.LN2:i(t-1+o(t-1)*o(t+1))}})},{33:33,63:63}],162:[function(t,n,r){function asinh(t){return isFinite(t=+t)&&0!=t?t<0?-asinh(-t):Math.log(t+Math.sqrt(t*t+1)):t}var e=t(33),i=Math.asinh;e(e.S+e.F*!(i&&1/i(0)>0),"Math",{asinh:asinh})},{33:33}],163:[function(t,n,r){var e=t(33),i=Math.atanh;e(e.S+e.F*!(i&&1/i(-0)<0),"Math",{atanh:function atanh(t){return 0==(t=+t)?t:Math.log((1+t)/(1-t))/2}})},{33:33}],164:[function(t,n,r){var e=t(33),i=t(65);e(e.S,"Math",{cbrt:function cbrt(t){return i(t=+t)*Math.pow(Math.abs(t),1/3)}})},{33:33,65:65}],165:[function(t,n,r){var e=t(33);e(e.S,"Math",{clz32:function clz32(t){return(t>>>=0)?31-Math.floor(Math.log(t+.5)*Math.LOG2E):32}})},{33:33}],166:[function(t,n,r){var e=t(33),i=Math.exp;e(e.S,"Math",{cosh:function cosh(t){return(i(t=+t)+i(-t))/2}})},{33:33}],167:[function(t,n,r){var e=t(33),i=t(61);e(e.S+e.F*(i!=Math.expm1),"Math",{expm1:i})},{33:33,61:61}],168:[function(t,n,r){var e=t(33);e(e.S,"Math",{fround:t(62)})},{33:33,62:62}],169:[function(t,n,r){var e=t(33),i=Math.abs;e(e.S,"Math",{hypot:function hypot(t,n){for(var r,e,o=0,u=0,c=arguments.length,a=0;u<c;)r=i(arguments[u++]),a<r?(e=a/r,o=o*e*e+1,a=r):r>0?(e=r/a,o+=e*e):o+=r;return a===1/0?1/0:a*Math.sqrt(o)}})},{33:33}],170:[function(t,n,r){var e=t(33),i=Math.imul;e(e.S+e.F*t(35)(function(){return-5!=i(4294967295,5)||2!=i.length}),"Math",{imul:function imul(t,n){var r=+t,e=+n,i=65535&r,o=65535&e;return 0|i*o+((65535&r>>>16)*o+i*(65535&e>>>16)<<16>>>0)}})},{33:33,35:35}],171:[function(t,n,r){var e=t(33);e(e.S,"Math",{log10:function log10(t){return Math.log(t)*Math.LOG10E}})},{33:33}],172:[function(t,n,r){var e=t(33);e(e.S,"Math",{log1p:t(63)})},{33:33,63:63}],173:[function(t,n,r){var e=t(33);e(e.S,"Math",{log2:function log2(t){return Math.log(t)/Math.LN2}})},{33:33}],174:[function(t,n,r){var e=t(33);e(e.S,"Math",{sign:t(65)})},{33:33,65:65}],175:[function(t,n,r){var e=t(33),i=t(61),o=Math.exp;e(e.S+e.F*t(35)(function(){return-2e-17!=!Math.sinh(-2e-17)}),"Math",{sinh:function sinh(t){return Math.abs(t=+t)<1?(i(t)-i(-t))/2:(o(t-1)-o(-t-1))*(Math.E/2)}})},{33:33,35:35,61:61}],176:[function(t,n,r){var e=t(33),i=t(61),o=Math.exp;e(e.S,"Math",{tanh:function tanh(t){var n=i(t=+t),r=i(-t);return n==1/0?1:r==1/0?-1:(n-r)/(o(t)+o(-t))}})},{33:33,61:61}],177:[function(t,n,r){var e=t(33);e(e.S,"Math",{trunc:function trunc(t){return(t>0?Math.floor:Math.ceil)(t)}})},{33:33}],178:[function(t,n,r){"use strict";var e=t(40),i=t(41),o=t(18),u=t(45),c=t(120),a=t(35),f=t(77).f,s=t(75).f,l=t(72).f,h=t(111).trim,v=e.Number,p=v,d=v.prototype,y="Number"==o(t(71)(d)),g="trim"in String.prototype,m=function(t){var n=c(t,!1);if("string"==typeof n&&n.length>2){n=g?n.trim():h(n,3);var r,e,i,o=n.charCodeAt(0);if(43===o||45===o){if(88===(r=n.charCodeAt(2))||120===r)return NaN}else if(48===o){switch(n.charCodeAt(1)){case 66:case 98:e=2,i=49;break;case 79:case 111:e=8,i=55;break;default:return+n}for(var u,a=n.slice(2),f=0,s=a.length;f<s;f++)if((u=a.charCodeAt(f))<48||u>i)return NaN;return parseInt(a,e)}}return+n};if(!v(" 0o1")||!v("0b1")||v("+0x1")){v=function Number(t){var n=arguments.length<1?0:t,r=this;return r instanceof v&&(y?a(function(){d.valueOf.call(r)}):"Number"!=o(r))?u(new p(m(n)),r,v):m(n)};for(var b,x=t(29)?f(p):"MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger".split(","),S=0;x.length>S;S++)i(p,b=x[S])&&!i(v,b)&&l(v,b,s(p,b));v.prototype=d,d.constructor=v,t(94)(e,"Number",v)}},{111:111,120:120,18:18,29:29,35:35,40:40,41:41,45:45,71:71,72:72,75:75,77:77,94:94}],179:[function(t,n,r){var e=t(33);e(e.S,"Number",{EPSILON:Math.pow(2,-52)})},{33:33}],180:[function(t,n,r){var e=t(33),i=t(40).isFinite;e(e.S,"Number",{isFinite:function isFinite(t){return"number"==typeof t&&i(t)}})},{33:33,40:40}],181:[function(t,n,r){var e=t(33);e(e.S,"Number",{isInteger:t(50)})},{33:33,50:50}],182:[function(t,n,r){var e=t(33);e(e.S,"Number",{isNaN:function isNaN(t){return t!=t}})},{33:33}],183:[function(t,n,r){var e=t(33),i=t(50),o=Math.abs;e(e.S,"Number",{isSafeInteger:function isSafeInteger(t){return i(t)&&o(t)<=9007199254740991}})},{33:33,50:50}],184:[function(t,n,r){var e=t(33);e(e.S,"Number",{MAX_SAFE_INTEGER:9007199254740991})},{33:33}],185:[function(t,n,r){var e=t(33);e(e.S,"Number",{MIN_SAFE_INTEGER:-9007199254740991})},{33:33}],186:[function(t,n,r){var e=t(33),i=t(86);e(e.S+e.F*(Number.parseFloat!=i),"Number",{parseFloat:i})},{33:33,86:86}],187:[function(t,n,r){var e=t(33),i=t(87);e(e.S+e.F*(Number.parseInt!=i),"Number",{parseInt:i})},{33:33,87:87}],188:[function(t,n,r){"use strict";var e=t(33),i=t(116),o=t(4),u=t(110),c=1..toFixed,a=Math.floor,f=[0,0,0,0,0,0],s="Number.toFixed: incorrect invocation!",l=function(t,n){for(var r=-1,e=n;++r<6;)e+=t*f[r],f[r]=e%1e7,e=a(e/1e7)},h=function(t){for(var n=6,r=0;--n>=0;)r+=f[n],f[n]=a(r/t),r=r%t*1e7},v=function(){for(var t=6,n="";--t>=0;)if(""!==n||0===t||0!==f[t]){var r=String(f[t]);n=""===n?r:n+u.call("0",7-r.length)+r}return n},p=function(t,n,r){return 0===n?r:n%2==1?p(t,n-1,r*t):p(t*t,n/2,r)},d=function(t){for(var n=0,r=t;r>=4096;)n+=12,r/=4096;for(;r>=2;)n+=1,r/=2;return n};e(e.P+e.F*(!!c&&("0.000"!==8e-5.toFixed(3)||"1"!==.9.toFixed(0)||"1.25"!==1.255.toFixed(2)||"1000000000000000128"!==(0xde0b6b3a7640080).toFixed(0))||!t(35)(function(){c.call({})})),"Number",{toFixed:function toFixed(t){var n,r,e,c,a=o(this,s),f=i(t),y="",g="0";if(f<0||f>20)throw RangeError(s);if(a!=a)return"NaN";if(a<=-1e21||a>=1e21)return String(a);if(a<0&&(y="-",a=-a),a>1e-21)if(n=d(a*p(2,69,1))-69,r=n<0?a*p(2,-n,1):a/p(2,n,1),r*=4503599627370496,(n=52-n)>0){for(l(0,r),e=f;e>=7;)l(1e7,0),e-=7;for(l(p(10,e,1),0),e=n-1;e>=23;)h(1<<23),e-=23;h(1<<e),l(1,1),h(2),g=v()}else l(0,r),l(1<<-n,0),g=v()+u.call("0",f);return f>0?(c=g.length,g=y+(c<=f?"0."+u.call("0",f-c)+g:g.slice(0,c-f)+"."+g.slice(c-f))):g=y+g,g}})},{110:110,116:116,33:33,35:35,4:4}],189:[function(t,n,r){"use strict";var e=t(33),i=t(35),o=t(4),u=1..toPrecision;e(e.P+e.F*(i(function(){return"1"!==u.call(1,void 0)})||!i(function(){u.call({})})),"Number",{toPrecision:function toPrecision(t){var n=o(this,"Number#toPrecision: incorrect invocation!");return void 0===t?u.call(n):u.call(n,t)}})},{33:33,35:35,4:4}],190:[function(t,n,r){var e=t(33);e(e.S+e.F,"Object",{assign:t(70)})},{33:33,70:70}],191:[function(t,n,r){var e=t(33);e(e.S,"Object",{create:t(71)})},{33:33,71:71}],192:[function(t,n,r){var e=t(33);e(e.S+e.F*!t(29),"Object",{defineProperties:t(73)})},{29:29,33:33,73:73}],193:[function(t,n,r){var e=t(33);e(e.S+e.F*!t(29),"Object",{defineProperty:t(72).f})},{29:29,33:33,72:72}],194:[function(t,n,r){var e=t(51),i=t(66).onFreeze;t(83)("freeze",function(t){return function freeze(n){return t&&e(n)?t(i(n)):n}})},{51:51,66:66,83:83}],195:[function(t,n,r){var e=t(117),i=t(75).f;t(83)("getOwnPropertyDescriptor",function(){return function getOwnPropertyDescriptor(t,n){return i(e(t),n)}})},{117:117,75:75,83:83}],196:[function(t,n,r){t(83)("getOwnPropertyNames",function(){return t(76).f})},{76:76,83:83}],197:[function(t,n,r){var e=t(119),i=t(79);t(83)("getPrototypeOf",function(){return function getPrototypeOf(t){return i(e(t))}})},{119:119,79:79,83:83}],198:[function(t,n,r){var e=t(51);t(83)("isExtensible",function(t){return function isExtensible(n){return!!e(n)&&(!t||t(n))}})},{51:51,83:83}],199:[function(t,n,r){var e=t(51);t(83)("isFrozen",function(t){return function isFrozen(n){return!e(n)||!!t&&t(n)}})},{51:51,83:83}],200:[function(t,n,r){var e=t(51);t(83)("isSealed",function(t){return function isSealed(n){return!e(n)||!!t&&t(n)}})},{51:51,83:83}],201:[function(t,n,r){var e=t(33);e(e.S,"Object",{is:t(96)})},{33:33,96:96}],202:[function(t,n,r){var e=t(119),i=t(81);t(83)("keys",function(){return function keys(t){return i(e(t))}})},{119:119,81:81,83:83}],203:[function(t,n,r){var e=t(51),i=t(66).onFreeze;t(83)("preventExtensions",function(t){return function preventExtensions(n){return t&&e(n)?t(i(n)):n}})},{51:51,66:66,83:83}],204:[function(t,n,r){var e=t(51),i=t(66).onFreeze;t(83)("seal",function(t){return function seal(n){return t&&e(n)?t(i(n)):n}})},{51:51,66:66,83:83}],205:[function(t,n,r){var e=t(33);e(e.S,"Object",{setPrototypeOf:t(99).set})},{33:33,99:99}],206:[function(t,n,r){"use strict";var e=t(17),i={};i[t(128)("toStringTag")]="z",i+""!="[object z]"&&t(94)(Object.prototype,"toString",function toString(){return"[object "+e(this)+"]"},!0)},{128:128,17:17,94:94}],207:[function(t,n,r){var e=t(33),i=t(86);e(e.G+e.F*(parseFloat!=i),{parseFloat:i})},{33:33,86:86}],208:[function(t,n,r){var e=t(33),i=t(87);e(e.G+e.F*(parseInt!=i),{parseInt:i})},{33:33,87:87}],209:[function(t,n,r){"use strict";var e,i,o,u,c=t(60),a=t(40),f=t(25),s=t(17),l=t(33),h=t(51),v=t(3),p=t(6),d=t(39),y=t(104),g=t(113).set,m=t(68)(),b=t(69),x=t(90),S=t(91),w=a.TypeError,_=a.process,E=a.Promise,O="process"==s(_),P=function(){},M=i=b.f,F=!!function(){try{var n=E.resolve(1),r=(n.constructor={})[t(128)("species")]=function(t){t(P,P)};return(O||"function"==typeof PromiseRejectionEvent)&&n.then(P)instanceof r}catch(t){}}(),I=c?function(t,n){return t===n||t===E&&n===u}:function(t,n){return t===n},A=function(t){var n;return!(!h(t)||"function"!=typeof(n=t.then))&&n},k=function(t,n){if(!t._n){t._n=!0;var r=t._c;m(function(){for(var e=t._v,i=1==t._s,o=0;r.length>o;)!function(n){var r,o,u=i?n.ok:n.fail,c=n.resolve,a=n.reject,f=n.domain;try{u?(i||(2==t._h&&T(t),t._h=1),!0===u?r=e:(f&&f.enter(),r=u(e),f&&f.exit()),r===n.promise?a(w("Promise-chain cycle")):(o=A(r))?o.call(r,c,a):c(r)):a(e)}catch(t){a(t)}}(r[o++]);t._c=[],t._n=!1,n&&!t._h&&N(t)})}},N=function(t){g.call(a,function(){var n,r,e,i=t._v,o=j(t);if(o&&(n=x(function(){O?_.emit("unhandledRejection",i,t):(r=a.onunhandledrejection)?r({promise:t,reason:i}):(e=a.console)&&e.error&&e.error("Unhandled promise rejection",i)}),t._h=O||j(t)?2:1),t._a=void 0,o&&n.e)throw n.v})},j=function(t){if(1==t._h)return!1;for(var n,r=t._a||t._c,e=0;r.length>e;)if(n=r[e++],n.fail||!j(n.promise))return!1;return!0},T=function(t){g.call(a,function(){var n;O?_.emit("rejectionHandled",t):(n=a.onrejectionhandled)&&n({promise:t,reason:t._v})})},R=function(t){var n=this;n._d||(n._d=!0,n=n._w||n,n._v=t,n._s=2,n._a||(n._a=n._c.slice()),k(n,!0))},L=function(t){var n,r=this;if(!r._d){r._d=!0,r=r._w||r;try{if(r===t)throw w("Promise can't be resolved itself");(n=A(t))?m(function(){var e={_w:r,_d:!1};try{n.call(t,f(L,e,1),f(R,e,1))}catch(t){R.call(e,t)}}):(r._v=t,r._s=1,k(r,!1))}catch(t){R.call({_w:r,_d:!1},t)}}};F||(E=function Promise(t){p(this,E,"Promise","_h"),v(t),e.call(this);try{t(f(L,this,1),f(R,this,1))}catch(t){R.call(this,t)}},e=function Promise(t){this._c=[],this._a=void 0,this._s=0,this._d=!1,this._v=void 0,this._h=0,this._n=!1},e.prototype=t(93)(E.prototype,{then:function then(t,n){var r=M(y(this,E));return r.ok="function"!=typeof t||t,r.fail="function"==typeof n&&n,r.domain=O?_.domain:void 0,this._c.push(r),this._a&&this._a.push(r),this._s&&k(this,!1),r.promise},catch:function(t){return this.then(void 0,t)}}),o=function(){var t=new e;this.promise=t,this.resolve=f(L,t,1),this.reject=f(R,t,1)},b.f=M=function(t){return I(E,t)?new o(t):i(t)}),l(l.G+l.W+l.F*!F,{Promise:E}),t(101)(E,"Promise"),t(100)("Promise"),u=t(23).Promise,l(l.S+l.F*!F,"Promise",{reject:function reject(t){var n=M(this);return(0,n.reject)(t),n.promise}}),l(l.S+l.F*(c||!F),"Promise",{resolve:function resolve(t){return t instanceof E&&I(t.constructor,this)?t:S(this,t)}}),l(l.S+l.F*!(F&&t(56)(function(t){E.all(t).catch(P)})),"Promise",{all:function all(t){var n=this,r=M(n),e=r.resolve,i=r.reject,o=x(function(){var r=[],o=0,u=1;d(t,!1,function(t){var c=o++,a=!1;r.push(void 0),u++,n.resolve(t).then(function(t){a||(a=!0,r[c]=t,--u||e(r))},i)}),--u||e(r)});return o.e&&i(o.v),r.promise},race:function race(t){var n=this,r=M(n),e=r.reject,i=x(function(){d(t,!1,function(t){n.resolve(t).then(r.resolve,e)})});return i.e&&e(i.v),r.promise}})},{100:100,101:101,104:104,113:113,128:128,17:17,23:23,25:25,
3:3,33:33,39:39,40:40,51:51,56:56,6:6,60:60,68:68,69:69,90:90,91:91,93:93}],210:[function(t,n,r){var e=t(33),i=t(3),o=t(7),u=(t(40).Reflect||{}).apply,c=Function.apply;e(e.S+e.F*!t(35)(function(){u(function(){})}),"Reflect",{apply:function apply(t,n,r){var e=i(t),a=o(r);return u?u(e,n,a):c.call(e,n,a)}})},{3:3,33:33,35:35,40:40,7:7}],211:[function(t,n,r){var e=t(33),i=t(71),o=t(3),u=t(7),c=t(51),a=t(35),f=t(16),s=(t(40).Reflect||{}).construct,l=a(function(){function F(){}return!(s(function(){},[],F)instanceof F)}),h=!a(function(){s(function(){})});e(e.S+e.F*(l||h),"Reflect",{construct:function construct(t,n){o(t),u(n);var r=arguments.length<3?t:o(arguments[2]);if(h&&!l)return s(t,n,r);if(t==r){switch(n.length){case 0:return new t;case 1:return new t(n[0]);case 2:return new t(n[0],n[1]);case 3:return new t(n[0],n[1],n[2]);case 4:return new t(n[0],n[1],n[2],n[3])}var e=[null];return e.push.apply(e,n),new(f.apply(t,e))}var a=r.prototype,v=i(c(a)?a:Object.prototype),p=Function.apply.call(t,v,n);return c(p)?p:v}})},{16:16,3:3,33:33,35:35,40:40,51:51,7:7,71:71}],212:[function(t,n,r){var e=t(72),i=t(33),o=t(7),u=t(120);i(i.S+i.F*t(35)(function(){Reflect.defineProperty(e.f({},1,{value:1}),1,{value:2})}),"Reflect",{defineProperty:function defineProperty(t,n,r){o(t),n=u(n,!0),o(r);try{return e.f(t,n,r),!0}catch(t){return!1}}})},{120:120,33:33,35:35,7:7,72:72}],213:[function(t,n,r){var e=t(33),i=t(75).f,o=t(7);e(e.S,"Reflect",{deleteProperty:function deleteProperty(t,n){var r=i(o(t),n);return!(r&&!r.configurable)&&delete t[n]}})},{33:33,7:7,75:75}],214:[function(t,n,r){"use strict";var e=t(33),i=t(7),o=function(t){this._t=i(t),this._i=0;var n,r=this._k=[];for(n in t)r.push(n)};t(54)(o,"Object",function(){var t,n=this,r=n._k;do{if(n._i>=r.length)return{value:void 0,done:!0}}while(!((t=r[n._i++])in n._t));return{value:t,done:!1}}),e(e.S,"Reflect",{enumerate:function enumerate(t){return new o(t)}})},{33:33,54:54,7:7}],215:[function(t,n,r){var e=t(75),i=t(33),o=t(7);i(i.S,"Reflect",{getOwnPropertyDescriptor:function getOwnPropertyDescriptor(t,n){return e.f(o(t),n)}})},{33:33,7:7,75:75}],216:[function(t,n,r){var e=t(33),i=t(79),o=t(7);e(e.S,"Reflect",{getPrototypeOf:function getPrototypeOf(t){return i(o(t))}})},{33:33,7:7,79:79}],217:[function(t,n,r){function get(t,n){var r,u,f=arguments.length<3?t:arguments[2];return a(t)===f?t[n]:(r=e.f(t,n))?o(r,"value")?r.value:void 0!==r.get?r.get.call(f):void 0:c(u=i(t))?get(u,n,f):void 0}var e=t(75),i=t(79),o=t(41),u=t(33),c=t(51),a=t(7);u(u.S,"Reflect",{get:get})},{33:33,41:41,51:51,7:7,75:75,79:79}],218:[function(t,n,r){var e=t(33);e(e.S,"Reflect",{has:function has(t,n){return n in t}})},{33:33}],219:[function(t,n,r){var e=t(33),i=t(7),o=Object.isExtensible;e(e.S,"Reflect",{isExtensible:function isExtensible(t){return i(t),!o||o(t)}})},{33:33,7:7}],220:[function(t,n,r){var e=t(33);e(e.S,"Reflect",{ownKeys:t(85)})},{33:33,85:85}],221:[function(t,n,r){var e=t(33),i=t(7),o=Object.preventExtensions;e(e.S,"Reflect",{preventExtensions:function preventExtensions(t){i(t);try{return o&&o(t),!0}catch(t){return!1}}})},{33:33,7:7}],222:[function(t,n,r){var e=t(33),i=t(99);i&&e(e.S,"Reflect",{setPrototypeOf:function setPrototypeOf(t,n){i.check(t,n);try{return i.set(t,n),!0}catch(t){return!1}}})},{33:33,99:99}],223:[function(t,n,r){function set(t,n,r){var c,l,h=arguments.length<4?t:arguments[3],v=i.f(f(t),n);if(!v){if(s(l=o(t)))return set(l,n,r,h);v=a(0)}return u(v,"value")?!(!1===v.writable||!s(h))&&(c=i.f(h,n)||a(0),c.value=r,e.f(h,n,c),!0):void 0!==v.set&&(v.set.call(h,r),!0)}var e=t(72),i=t(75),o=t(79),u=t(41),c=t(33),a=t(92),f=t(7),s=t(51);c(c.S,"Reflect",{set:set})},{33:33,41:41,51:51,7:7,72:72,75:75,79:79,92:92}],224:[function(t,n,r){var e=t(40),i=t(45),o=t(72).f,u=t(77).f,c=t(52),a=t(37),f=e.RegExp,s=f,l=f.prototype,h=/a/g,v=/a/g,p=new f(h)!==h;if(t(29)&&(!p||t(35)(function(){return v[t(128)("match")]=!1,f(h)!=h||f(v)==v||"/a/i"!=f(h,"i")}))){f=function RegExp(t,n){var r=this instanceof f,e=c(t),o=void 0===n;return!r&&e&&t.constructor===f&&o?t:i(p?new s(e&&!o?t.source:t,n):s((e=t instanceof f)?t.source:t,e&&o?a.call(t):n),r?this:l,f)};for(var d=u(s),y=0;d.length>y;)!function(t){t in f||o(f,t,{configurable:!0,get:function(){return s[t]},set:function(n){s[t]=n}})}(d[y++]);l.constructor=f,f.prototype=l,t(94)(e,"RegExp",f)}t(100)("RegExp")},{100:100,128:128,29:29,35:35,37:37,40:40,45:45,52:52,72:72,77:77,94:94}],225:[function(t,n,r){t(29)&&"g"!=/./g.flags&&t(72).f(RegExp.prototype,"flags",{configurable:!0,get:t(37)})},{29:29,37:37,72:72}],226:[function(t,n,r){t(36)("match",1,function(t,n,r){return[function match(r){"use strict";var e=t(this),i=void 0==r?void 0:r[n];return void 0!==i?i.call(r,e):new RegExp(r)[n](String(e))},r]})},{36:36}],227:[function(t,n,r){t(36)("replace",2,function(t,n,r){return[function replace(e,i){"use strict";var o=t(this),u=void 0==e?void 0:e[n];return void 0!==u?u.call(e,o,i):r.call(String(o),e,i)},r]})},{36:36}],228:[function(t,n,r){t(36)("search",1,function(t,n,r){return[function search(r){"use strict";var e=t(this),i=void 0==r?void 0:r[n];return void 0!==i?i.call(r,e):new RegExp(r)[n](String(e))},r]})},{36:36}],229:[function(t,n,r){t(36)("split",2,function(n,r,e){"use strict";var i=t(52),o=e,u=[].push,c="length";if("c"=="abbc".split(/(b)*/)[1]||4!="test".split(/(?:)/,-1)[c]||2!="ab".split(/(?:ab)*/)[c]||4!=".".split(/(.?)(.?)/)[c]||".".split(/()()/)[c]>1||"".split(/.?/)[c]){var a=void 0===/()??/.exec("")[1];e=function(t,n){var r=String(this);if(void 0===t&&0===n)return[];if(!i(t))return o.call(r,t,n);var e,f,s,l,h,v=[],p=(t.ignoreCase?"i":"")+(t.multiline?"m":"")+(t.unicode?"u":"")+(t.sticky?"y":""),d=0,y=void 0===n?4294967295:n>>>0,g=new RegExp(t.source,p+"g");for(a||(e=new RegExp("^"+g.source+"$(?!\\s)",p));(f=g.exec(r))&&!((s=f.index+f[0][c])>d&&(v.push(r.slice(d,f.index)),!a&&f[c]>1&&f[0].replace(e,function(){for(h=1;h<arguments[c]-2;h++)void 0===arguments[h]&&(f[h]=void 0)}),f[c]>1&&f.index<r[c]&&u.apply(v,f.slice(1)),l=f[0][c],d=s,v[c]>=y));)g.lastIndex===f.index&&g.lastIndex++;return d===r[c]?!l&&g.test("")||v.push(""):v.push(r.slice(d)),v[c]>y?v.slice(0,y):v}}else"0".split(void 0,0)[c]&&(e=function(t,n){return void 0===t&&0===n?[]:o.call(this,t,n)});return[function split(t,i){var o=n(this),u=void 0==t?void 0:t[r];return void 0!==u?u.call(t,o,i):e.call(String(o),t,i)},e]})},{36:36,52:52}],230:[function(t,n,r){"use strict";t(225);var e=t(7),i=t(37),o=t(29),u=/./.toString,c=function(n){t(94)(RegExp.prototype,"toString",n,!0)};t(35)(function(){return"/a/b"!=u.call({source:"a",flags:"b"})})?c(function toString(){var t=e(this);return"/".concat(t.source,"/","flags"in t?t.flags:!o&&t instanceof RegExp?i.call(t):void 0)}):"toString"!=u.name&&c(function toString(){return u.call(this)})},{225:225,29:29,35:35,37:37,7:7,94:94}],231:[function(t,n,r){"use strict";var e=t(19),i=t(125);n.exports=t(22)("Set",function(t){return function Set(){return t(this,arguments.length>0?arguments[0]:void 0)}},{add:function add(t){return e.def(i(this,"Set"),t=0===t?0:t,t)}},e)},{125:125,19:19,22:22}],232:[function(t,n,r){"use strict";t(108)("anchor",function(t){return function anchor(n){return t(this,"a","name",n)}})},{108:108}],233:[function(t,n,r){"use strict";t(108)("big",function(t){return function big(){return t(this,"big","","")}})},{108:108}],234:[function(t,n,r){"use strict";t(108)("blink",function(t){return function blink(){return t(this,"blink","","")}})},{108:108}],235:[function(t,n,r){"use strict";t(108)("bold",function(t){return function bold(){return t(this,"b","","")}})},{108:108}],236:[function(t,n,r){"use strict";var e=t(33),i=t(106)(!1);e(e.P,"String",{codePointAt:function codePointAt(t){return i(this,t)}})},{106:106,33:33}],237:[function(t,n,r){"use strict";var e=t(33),i=t(118),o=t(107),u="".endsWith;e(e.P+e.F*t(34)("endsWith"),"String",{endsWith:function endsWith(t){var n=o(this,t,"endsWith"),r=arguments.length>1?arguments[1]:void 0,e=i(n.length),c=void 0===r?e:Math.min(i(r),e),a=String(t);return u?u.call(n,a,c):n.slice(c-a.length,c)===a}})},{107:107,118:118,33:33,34:34}],238:[function(t,n,r){"use strict";t(108)("fixed",function(t){return function fixed(){return t(this,"tt","","")}})},{108:108}],239:[function(t,n,r){"use strict";t(108)("fontcolor",function(t){return function fontcolor(n){return t(this,"font","color",n)}})},{108:108}],240:[function(t,n,r){"use strict";t(108)("fontsize",function(t){return function fontsize(n){return t(this,"font","size",n)}})},{108:108}],241:[function(t,n,r){var e=t(33),i=t(114),o=String.fromCharCode,u=String.fromCodePoint;e(e.S+e.F*(!!u&&1!=u.length),"String",{fromCodePoint:function fromCodePoint(t){for(var n,r=[],e=arguments.length,u=0;e>u;){if(n=+arguments[u++],i(n,1114111)!==n)throw RangeError(n+" is not a valid code point");r.push(n<65536?o(n):o(55296+((n-=65536)>>10),n%1024+56320))}return r.join("")}})},{114:114,33:33}],242:[function(t,n,r){"use strict";var e=t(33),i=t(107);e(e.P+e.F*t(34)("includes"),"String",{includes:function includes(t){return!!~i(this,t,"includes").indexOf(t,arguments.length>1?arguments[1]:void 0)}})},{107:107,33:33,34:34}],243:[function(t,n,r){"use strict";t(108)("italics",function(t){return function italics(){return t(this,"i","","")}})},{108:108}],244:[function(t,n,r){"use strict";var e=t(106)(!0);t(55)(String,"String",function(t){this._t=String(t),this._i=0},function(){var t,n=this._t,r=this._i;return r>=n.length?{value:void 0,done:!0}:(t=e(n,r),this._i+=t.length,{value:t,done:!1})})},{106:106,55:55}],245:[function(t,n,r){"use strict";t(108)("link",function(t){return function link(n){return t(this,"a","href",n)}})},{108:108}],246:[function(t,n,r){var e=t(33),i=t(117),o=t(118);e(e.S,"String",{raw:function raw(t){for(var n=i(t.raw),r=o(n.length),e=arguments.length,u=[],c=0;r>c;)u.push(String(n[c++])),c<e&&u.push(String(arguments[c]));return u.join("")}})},{117:117,118:118,33:33}],247:[function(t,n,r){var e=t(33);e(e.P,"String",{repeat:t(110)})},{110:110,33:33}],248:[function(t,n,r){"use strict";t(108)("small",function(t){return function small(){return t(this,"small","","")}})},{108:108}],249:[function(t,n,r){"use strict";var e=t(33),i=t(118),o=t(107),u="".startsWith;e(e.P+e.F*t(34)("startsWith"),"String",{startsWith:function startsWith(t){var n=o(this,t,"startsWith"),r=i(Math.min(arguments.length>1?arguments[1]:void 0,n.length)),e=String(t);return u?u.call(n,e,r):n.slice(r,r+e.length)===e}})},{107:107,118:118,33:33,34:34}],250:[function(t,n,r){"use strict";t(108)("strike",function(t){return function strike(){return t(this,"strike","","")}})},{108:108}],251:[function(t,n,r){"use strict";t(108)("sub",function(t){return function sub(){return t(this,"sub","","")}})},{108:108}],252:[function(t,n,r){"use strict";t(108)("sup",function(t){return function sup(){return t(this,"sup","","")}})},{108:108}],253:[function(t,n,r){"use strict";t(111)("trim",function(t){return function trim(){return t(this,3)}})},{111:111}],254:[function(t,n,r){"use strict";var e=t(40),i=t(41),o=t(29),u=t(33),c=t(94),a=t(66).KEY,f=t(35),s=t(103),l=t(101),h=t(124),v=t(128),p=t(127),d=t(126),y=t(59),g=t(32),m=t(49),b=t(7),x=t(117),S=t(120),w=t(92),_=t(71),E=t(76),O=t(75),P=t(72),M=t(81),F=O.f,I=P.f,A=E.f,k=e.Symbol,N=e.JSON,j=N&&N.stringify,T=v("_hidden"),R=v("toPrimitive"),L={}.propertyIsEnumerable,G=s("symbol-registry"),D=s("symbols"),C=s("op-symbols"),W=Object.prototype,U="function"==typeof k,B=e.QObject,V=!B||!B.prototype||!B.prototype.findChild,z=o&&f(function(){return 7!=_(I({},"a",{get:function(){return I(this,"a",{value:7}).a}})).a})?function(t,n,r){var e=F(W,n);e&&delete W[n],I(t,n,r),e&&t!==W&&I(W,n,e)}:I,q=function(t){var n=D[t]=_(k.prototype);return n._k=t,n},K=U&&"symbol"==typeof k.iterator?function(t){return"symbol"==typeof t}:function(t){return t instanceof k},Y=function defineProperty(t,n,r){return t===W&&Y(C,n,r),b(t),n=S(n,!0),b(r),i(D,n)?(r.enumerable?(i(t,T)&&t[T][n]&&(t[T][n]=!1),r=_(r,{enumerable:w(0,!1)})):(i(t,T)||I(t,T,w(1,{})),t[T][n]=!0),z(t,n,r)):I(t,n,r)},J=function defineProperties(t,n){b(t);for(var r,e=g(n=x(n)),i=0,o=e.length;o>i;)Y(t,r=e[i++],n[r]);return t},H=function create(t,n){return void 0===n?_(t):J(_(t),n)},X=function propertyIsEnumerable(t){var n=L.call(this,t=S(t,!0));return!(this===W&&i(D,t)&&!i(C,t))&&(!(n||!i(this,t)||!i(D,t)||i(this,T)&&this[T][t])||n)},$=function getOwnPropertyDescriptor(t,n){if(t=x(t),n=S(n,!0),t!==W||!i(D,n)||i(C,n)){var r=F(t,n);return!r||!i(D,n)||i(t,T)&&t[T][n]||(r.enumerable=!0),r}},Z=function getOwnPropertyNames(t){for(var n,r=A(x(t)),e=[],o=0;r.length>o;)i(D,n=r[o++])||n==T||n==a||e.push(n);return e},Q=function getOwnPropertySymbols(t){for(var n,r=t===W,e=A(r?C:x(t)),o=[],u=0;e.length>u;)!i(D,n=e[u++])||r&&!i(W,n)||o.push(D[n]);return o};U||(k=function Symbol(){if(this instanceof k)throw TypeError("Symbol is not a constructor!");var t=h(arguments.length>0?arguments[0]:void 0),n=function(r){this===W&&n.call(C,r),i(this,T)&&i(this[T],t)&&(this[T][t]=!1),z(this,t,w(1,r))};return o&&V&&z(W,t,{configurable:!0,set:n}),q(t)},c(k.prototype,"toString",function toString(){return this._k}),O.f=$,P.f=Y,t(77).f=E.f=Z,t(82).f=X,t(78).f=Q,o&&!t(60)&&c(W,"propertyIsEnumerable",X,!0),p.f=function(t){return q(v(t))}),u(u.G+u.W+u.F*!U,{Symbol:k});for(var tt="hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables".split(","),nt=0;tt.length>nt;)v(tt[nt++]);for(var rt=M(v.store),et=0;rt.length>et;)d(rt[et++]);u(u.S+u.F*!U,"Symbol",{for:function(t){return i(G,t+="")?G[t]:G[t]=k(t)},keyFor:function keyFor(t){if(K(t))return y(G,t);throw TypeError(t+" is not a symbol!")},useSetter:function(){V=!0},useSimple:function(){V=!1}}),u(u.S+u.F*!U,"Object",{create:H,defineProperty:Y,defineProperties:J,getOwnPropertyDescriptor:$,getOwnPropertyNames:Z,getOwnPropertySymbols:Q}),N&&u(u.S+u.F*(!U||f(function(){var t=k();return"[null]"!=j([t])||"{}"!=j({a:t})||"{}"!=j(Object(t))})),"JSON",{stringify:function stringify(t){if(void 0!==t&&!K(t)){for(var n,r,e=[t],i=1;arguments.length>i;)e.push(arguments[i++]);return n=e[1],"function"==typeof n&&(r=n),!r&&m(n)||(n=function(t,n){if(r&&(n=r.call(this,t,n)),!K(n))return n}),e[1]=n,j.apply(N,e)}}}),k.prototype[R]||t(42)(k.prototype,R,k.prototype.valueOf),l(k,"Symbol"),l(Math,"Math",!0),l(e.JSON,"JSON",!0)},{101:101,103:103,117:117,120:120,124:124,126:126,127:127,128:128,29:29,32:32,33:33,35:35,40:40,41:41,42:42,49:49,59:59,60:60,66:66,7:7,71:71,72:72,75:75,76:76,77:77,78:78,81:81,82:82,92:92,94:94}],255:[function(t,n,r){"use strict";var e=t(33),i=t(123),o=t(122),u=t(7),c=t(114),a=t(118),f=t(51),s=t(40).ArrayBuffer,l=t(104),h=o.ArrayBuffer,v=o.DataView,p=i.ABV&&s.isView,d=h.prototype.slice,y=i.VIEW;e(e.G+e.W+e.F*(s!==h),{ArrayBuffer:h}),e(e.S+e.F*!i.CONSTR,"ArrayBuffer",{isView:function isView(t){return p&&p(t)||f(t)&&y in t}}),e(e.P+e.U+e.F*t(35)(function(){return!new h(2).slice(1,void 0).byteLength}),"ArrayBuffer",{slice:function slice(t,n){if(void 0!==d&&void 0===n)return d.call(u(this),t);for(var r=u(this).byteLength,e=c(t,r),i=c(void 0===n?r:n,r),o=new(l(this,h))(a(i-e)),f=new v(this),s=new v(o),p=0;e<i;)s.setUint8(p++,f.getUint8(e++));return o}}),t(100)("ArrayBuffer")},{100:100,104:104,114:114,118:118,122:122,123:123,33:33,35:35,40:40,51:51,7:7}],256:[function(t,n,r){var e=t(33);e(e.G+e.W+e.F*!t(123).ABV,{DataView:t(122).DataView})},{122:122,123:123,33:33}],257:[function(t,n,r){t(121)("Float32",4,function(t){return function Float32Array(n,r,e){return t(this,n,r,e)}})},{121:121}],258:[function(t,n,r){t(121)("Float64",8,function(t){return function Float64Array(n,r,e){return t(this,n,r,e)}})},{121:121}],259:[function(t,n,r){t(121)("Int16",2,function(t){return function Int16Array(n,r,e){return t(this,n,r,e)}})},{121:121}],260:[function(t,n,r){t(121)("Int32",4,function(t){return function Int32Array(n,r,e){return t(this,n,r,e)}})},{121:121}],261:[function(t,n,r){t(121)("Int8",1,function(t){return function Int8Array(n,r,e){return t(this,n,r,e)}})},{121:121}],262:[function(t,n,r){t(121)("Uint16",2,function(t){return function Uint16Array(n,r,e){return t(this,n,r,e)}})},{121:121}],263:[function(t,n,r){t(121)("Uint32",4,function(t){return function Uint32Array(n,r,e){return t(this,n,r,e)}})},{121:121}],264:[function(t,n,r){t(121)("Uint8",1,function(t){return function Uint8Array(n,r,e){return t(this,n,r,e)}})},{121:121}],265:[function(t,n,r){t(121)("Uint8",1,function(t){return function Uint8ClampedArray(n,r,e){return t(this,n,r,e)}},!0)},{121:121}],266:[function(t,n,r){"use strict";var e,i=t(12)(0),o=t(94),u=t(66),c=t(70),a=t(21),f=t(51),s=t(35),l=t(125),h=u.getWeak,v=Object.isExtensible,p=a.ufstore,d={},y=function(t){return function WeakMap(){return t(this,arguments.length>0?arguments[0]:void 0)}},g={get:function get(t){if(f(t)){var n=h(t);return!0===n?p(l(this,"WeakMap")).get(t):n?n[this._i]:void 0}},set:function set(t,n){return a.def(l(this,"WeakMap"),t,n)}},m=n.exports=t(22)("WeakMap",y,g,a,!0,!0);s(function(){return 7!=(new m).set((Object.freeze||Object)(d),7).get(d)})&&(e=a.getConstructor(y,"WeakMap"),c(e.prototype,g),u.NEED=!0,i(["delete","has","get","set"],function(t){var n=m.prototype,r=n[t];o(n,t,function(n,i){if(f(n)&&!v(n)){this._f||(this._f=new e);var o=this._f[t](n,i);return"set"==t?this:o}return r.call(this,n,i)})}))},{12:12,125:125,21:21,22:22,35:35,51:51,66:66,70:70,94:94}],267:[function(t,n,r){"use strict";var e=t(21),i=t(125);t(22)("WeakSet",function(t){return function WeakSet(){return t(this,arguments.length>0?arguments[0]:void 0)}},{add:function add(t){return e.def(i(this,"WeakSet"),t,!0)}},e,!1,!0)},{125:125,21:21,22:22}],268:[function(t,n,r){"use strict";var e=t(33),i=t(38),o=t(119),u=t(118),c=t(3),a=t(15);e(e.P,"Array",{flatMap:function flatMap(t){var n,r,e=o(this);return c(t),n=u(e.length),r=a(e,0),i(r,e,e,n,0,1,t,arguments[1]),r}}),t(5)("flatMap")},{118:118,119:119,15:15,3:3,33:33,38:38,5:5}],269:[function(t,n,r){"use strict";var e=t(33),i=t(38),o=t(119),u=t(118),c=t(116),a=t(15);e(e.P,"Array",{flatten:function flatten(){var t=arguments[0],n=o(this),r=u(n.length),e=a(n,0);return i(e,n,n,r,0,void 0===t?1:c(t)),e}}),t(5)("flatten")},{116:116,118:118,119:119,15:15,33:33,38:38,5:5}],270:[function(t,n,r){"use strict";var e=t(33),i=t(11)(!0);e(e.P,"Array",{includes:function includes(t){return i(this,t,arguments.length>1?arguments[1]:void 0)}}),t(5)("includes")},{11:11,33:33,5:5}],271:[function(t,n,r){var e=t(33),i=t(68)(),o=t(40).process,u="process"==t(18)(o);e(e.G,{asap:function asap(t){var n=u&&o.domain;i(n?n.bind(t):t)}})},{18:18,33:33,40:40,68:68}],272:[function(t,n,r){var e=t(33),i=t(18);e(e.S,"Error",{isError:function isError(t){return"Error"===i(t)}})},{18:18,33:33}],273:[function(t,n,r){var e=t(33);e(e.G,{global:t(40)})},{33:33,40:40}],274:[function(t,n,r){t(97)("Map")},{97:97}],275:[function(t,n,r){t(98)("Map")},{98:98}],276:[function(t,n,r){var e=t(33);e(e.P+e.R,"Map",{toJSON:t(20)("Map")})},{20:20,33:33}],277:[function(t,n,r){var e=t(33);e(e.S,"Math",{clamp:function clamp(t,n,r){return Math.min(r,Math.max(n,t))}})},{33:33}],278:[function(t,n,r){var e=t(33);e(e.S,"Math",{DEG_PER_RAD:Math.PI/180})},{33:33}],279:[function(t,n,r){var e=t(33),i=180/Math.PI;e(e.S,"Math",{degrees:function degrees(t){return t*i}})},{33:33}],280:[function(t,n,r){var e=t(33),i=t(64),o=t(62);e(e.S,"Math",{fscale:function fscale(t,n,r,e,u){return o(i(t,n,r,e,u))}})},{33:33,62:62,64:64}],281:[function(t,n,r){var e=t(33);e(e.S,"Math",{iaddh:function iaddh(t,n,r,e){var i=t>>>0,o=n>>>0,u=r>>>0;return o+(e>>>0)+((i&u|(i|u)&~(i+u>>>0))>>>31)|0}})},{33:33}],282:[function(t,n,r){var e=t(33);e(e.S,"Math",{imulh:function imulh(t,n){var r=+t,e=+n,i=65535&r,o=65535&e,u=r>>16,c=e>>16,a=(u*o>>>0)+(i*o>>>16);return u*c+(a>>16)+((i*c>>>0)+(65535&a)>>16)}})},{33:33}],283:[function(t,n,r){var e=t(33);e(e.S,"Math",{isubh:function isubh(t,n,r,e){var i=t>>>0,o=n>>>0,u=r>>>0;return o-(e>>>0)-((~i&u|~(i^u)&i-u>>>0)>>>31)|0}})},{33:33}],284:[function(t,n,r){var e=t(33);e(e.S,"Math",{RAD_PER_DEG:180/Math.PI})},{33:33}],285:[function(t,n,r){var e=t(33),i=Math.PI/180;e(e.S,"Math",{radians:function radians(t){return t*i}})},{33:33}],286:[function(t,n,r){var e=t(33);e(e.S,"Math",{scale:t(64)})},{33:33,64:64}],287:[function(t,n,r){var e=t(33);e(e.S,"Math",{signbit:function signbit(t){return(t=+t)!=t?t:0==t?1/t==1/0:t>0}})},{33:33}],288:[function(t,n,r){var e=t(33);e(e.S,"Math",{umulh:function umulh(t,n){var r=+t,e=+n,i=65535&r,o=65535&e,u=r>>>16,c=e>>>16,a=(u*o>>>0)+(i*o>>>16);return u*c+(a>>>16)+((i*c>>>0)+(65535&a)>>>16)}})},{33:33}],289:[function(t,n,r){"use strict";var e=t(33),i=t(119),o=t(3),u=t(72);t(29)&&e(e.P+t(74),"Object",{__defineGetter__:function __defineGetter__(t,n){u.f(i(this),t,{get:o(n),enumerable:!0,configurable:!0})}})},{119:119,29:29,3:3,33:33,72:72,74:74}],290:[function(t,n,r){"use strict";var e=t(33),i=t(119),o=t(3),u=t(72);t(29)&&e(e.P+t(74),"Object",{__defineSetter__:function __defineSetter__(t,n){u.f(i(this),t,{set:o(n),enumerable:!0,configurable:!0})}})},{119:119,29:29,3:3,33:33,72:72,74:74}],291:[function(t,n,r){var e=t(33),i=t(84)(!0);e(e.S,"Object",{entries:function entries(t){return i(t)}})},{33:33,84:84}],292:[function(t,n,r){var e=t(33),i=t(85),o=t(117),u=t(75),c=t(24);e(e.S,"Object",{getOwnPropertyDescriptors:function getOwnPropertyDescriptors(t){for(var n,r,e=o(t),a=u.f,f=i(e),s={},l=0;f.length>l;)void 0!==(r=a(e,n=f[l++]))&&c(s,n,r);return s}})},{117:117,24:24,33:33,75:75,85:85}],293:[function(t,n,r){"use strict";var e=t(33),i=t(119),o=t(120),u=t(79),c=t(75).f;t(29)&&e(e.P+t(74),"Object",{__lookupGetter__:function __lookupGetter__(t){var n,r=i(this),e=o(t,!0);do{if(n=c(r,e))return n.get}while(r=u(r))}})},{119:119,120:120,29:29,33:33,74:74,75:75,79:79}],294:[function(t,n,r){"use strict";var e=t(33),i=t(119),o=t(120),u=t(79),c=t(75).f;t(29)&&e(e.P+t(74),"Object",{__lookupSetter__:function __lookupSetter__(t){var n,r=i(this),e=o(t,!0);do{if(n=c(r,e))return n.set}while(r=u(r))}})},{119:119,120:120,29:29,33:33,74:74,75:75,79:79}],295:[function(t,n,r){var e=t(33),i=t(84)(!1);e(e.S,"Object",{values:function values(t){return i(t)}})},{33:33,84:84}],296:[function(t,n,r){"use strict";var e=t(33),i=t(40),o=t(23),u=t(68)(),c=t(128)("observable"),a=t(3),f=t(7),s=t(6),l=t(93),h=t(42),v=t(39),p=v.RETURN,d=function(t){return null==t?void 0:a(t)},y=function(t){var n=t._c;n&&(t._c=void 0,n())},g=function(t){return void 0===t._o},m=function(t){g(t)||(t._o=void 0,y(t))},b=function(t,n){f(t),this._c=void 0,this._o=t,t=new x(this);try{var r=n(t),e=r;null!=r&&("function"==typeof r.unsubscribe?r=function(){e.unsubscribe()}:a(r),this._c=r)}catch(n){return void t.error(n)}g(this)&&y(this)};b.prototype=l({},{unsubscribe:function unsubscribe(){m(this)}});var x=function(t){this._s=t};x.prototype=l({},{next:function next(t){var n=this._s;if(!g(n)){var r=n._o;try{var e=d(r.next);if(e)return e.call(r,t)}catch(t){try{m(n)}finally{throw t}}}},error:function error(t){var n=this._s;if(g(n))throw t;var r=n._o;n._o=void 0;try{var e=d(r.error);if(!e)throw t;t=e.call(r,t)}catch(t){try{y(n)}finally{throw t}}return y(n),t},complete:function complete(t){var n=this._s;if(!g(n)){var r=n._o;n._o=void 0;try{var e=d(r.complete);t=e?e.call(r,t):void 0}catch(t){try{y(n)}finally{throw t}}return y(n),t}}});var S=function Observable(t){s(this,S,"Observable","_f")._f=a(t)};l(S.prototype,{subscribe:function subscribe(t){return new b(t,this._f)},forEach:function forEach(t){var n=this;return new(o.Promise||i.Promise)(function(r,e){a(t);var i=n.subscribe({next:function(n){try{return t(n)}catch(t){e(t),i.unsubscribe()}},error:e,complete:r})})}}),l(S,{from:function from(t){var n="function"==typeof this?this:S,r=d(f(t)[c]);if(r){var e=f(r.call(t));return e.constructor===n?e:new n(function(t){return e.subscribe(t)})}return new n(function(n){var r=!1;return u(function(){if(!r){try{if(v(t,!1,function(t){if(n.next(t),r)return p})===p)return}catch(t){if(r)throw t;return void n.error(t)}n.complete()}}),function(){r=!0}})},of:function of(){for(var t=0,n=arguments.length,r=Array(n);t<n;)r[t]=arguments[t++];return new("function"==typeof this?this:S)(function(t){var n=!1;return u(function(){if(!n){for(var e=0;e<r.length;++e)if(t.next(r[e]),n)return;t.complete()}}),function(){n=!0}})}}),h(S.prototype,c,function(){return this}),e(e.G,{Observable:S}),t(100)("Observable")},{100:100,128:128,23:23,3:3,33:33,39:39,40:40,42:42,6:6,68:68,7:7,93:93}],297:[function(t,n,r){"use strict";var e=t(33),i=t(23),o=t(40),u=t(104),c=t(91);e(e.P+e.R,"Promise",{finally:function(t){var n=u(this,i.Promise||o.Promise),r="function"==typeof t;return this.then(r?function(r){return c(n,t()).then(function(){return r})}:t,r?function(r){return c(n,t()).then(function(){throw r})}:t)}})},{104:104,23:23,33:33,40:40,91:91}],298:[function(t,n,r){"use strict";var e=t(33),i=t(69),o=t(90);e(e.S,"Promise",{try:function(t){var n=i.f(this),r=o(t);return(r.e?n.reject:n.resolve)(r.v),n.promise}})},{33:33,69:69,90:90}],299:[function(t,n,r){var e=t(67),i=t(7),o=e.key,u=e.set;e.exp({defineMetadata:function defineMetadata(t,n,r,e){u(t,n,i(r),o(e))}})},{67:67,7:7}],300:[function(t,n,r){var e=t(67),i=t(7),o=e.key,u=e.map,c=e.store;e.exp({deleteMetadata:function deleteMetadata(t,n){var r=arguments.length<3?void 0:o(arguments[2]),e=u(i(n),r,!1);if(void 0===e||!e.delete(t))return!1;if(e.size)return!0;var a=c.get(n);return a.delete(r),!!a.size||c.delete(n)}})},{67:67,7:7}],301:[function(t,n,r){var e=t(231),i=t(10),o=t(67),u=t(7),c=t(79),a=o.keys,f=o.key,s=function(t,n){var r=a(t,n),o=c(t);if(null===o)return r;var u=s(o,n);return u.length?r.length?i(new e(r.concat(u))):u:r};o.exp({getMetadataKeys:function getMetadataKeys(t){return s(u(t),arguments.length<2?void 0:f(arguments[1]))}})},{10:10,231:231,67:67,7:7,79:79}],302:[function(t,n,r){var e=t(67),i=t(7),o=t(79),u=e.has,c=e.get,a=e.key,f=function(t,n,r){if(u(t,n,r))return c(t,n,r);var e=o(n);return null!==e?f(t,e,r):void 0};e.exp({getMetadata:function getMetadata(t,n){return f(t,i(n),arguments.length<3?void 0:a(arguments[2]))}})},{67:67,7:7,79:79}],303:[function(t,n,r){var e=t(67),i=t(7),o=e.keys,u=e.key;e.exp({getOwnMetadataKeys:function getOwnMetadataKeys(t){return o(i(t),arguments.length<2?void 0:u(arguments[1]))}})},{67:67,7:7}],304:[function(t,n,r){var e=t(67),i=t(7),o=e.get,u=e.key;e.exp({getOwnMetadata:function getOwnMetadata(t,n){return o(t,i(n),arguments.length<3?void 0:u(arguments[2]))}})},{67:67,7:7}],305:[function(t,n,r){var e=t(67),i=t(7),o=t(79),u=e.has,c=e.key,a=function(t,n,r){if(u(t,n,r))return!0;var e=o(n);return null!==e&&a(t,e,r)};e.exp({hasMetadata:function hasMetadata(t,n){return a(t,i(n),arguments.length<3?void 0:c(arguments[2]))}})},{67:67,7:7,79:79}],306:[function(t,n,r){var e=t(67),i=t(7),o=e.has,u=e.key;e.exp({hasOwnMetadata:function hasOwnMetadata(t,n){return o(t,i(n),arguments.length<3?void 0:u(arguments[2]))}})},{67:67,7:7}],307:[function(t,n,r){var e=t(67),i=t(7),o=t(3),u=e.key,c=e.set;e.exp({metadata:function metadata(t,n){return function decorator(r,e){c(t,n,(void 0!==e?i:o)(r),u(e))}}})},{3:3,67:67,7:7}],308:[function(t,n,r){t(97)("Set")},{97:97}],309:[function(t,n,r){t(98)("Set")},{98:98}],310:[function(t,n,r){var e=t(33);e(e.P+e.R,"Set",{toJSON:t(20)("Set")})},{20:20,33:33}],311:[function(t,n,r){"use strict";var e=t(33),i=t(106)(!0);e(e.P,"String",{at:function at(t){return i(this,t)}})},{106:106,33:33}],312:[function(t,n,r){"use strict";var e=t(33),i=t(28),o=t(118),u=t(52),c=t(37),a=RegExp.prototype,f=function(t,n){this._r=t,this._s=n};t(54)(f,"RegExp String",function next(){var t=this._r.exec(this._s);return{value:t,done:null===t}}),e(e.P,"String",{matchAll:function matchAll(t){if(i(this),!u(t))throw TypeError(t+" is not a regexp!");var n=String(this),r="flags"in a?String(t.flags):c.call(t),e=new RegExp(t.source,~r.indexOf("g")?r:"g"+r);return e.lastIndex=o(t.lastIndex),new f(e,n)}})},{118:118,28:28,33:33,37:37,52:52,54:54}],313:[function(t,n,r){"use strict";var e=t(33),i=t(109);e(e.P,"String",{padEnd:function padEnd(t){return i(this,t,arguments.length>1?arguments[1]:void 0,!1)}})},{109:109,33:33}],314:[function(t,n,r){"use strict";var e=t(33),i=t(109);e(e.P,"String",{padStart:function padStart(t){return i(this,t,arguments.length>1?arguments[1]:void 0,!0)}})},{109:109,33:33}],315:[function(t,n,r){"use strict";t(111)("trimLeft",function(t){return function trimLeft(){return t(this,1)}},"trimStart")},{111:111}],316:[function(t,n,r){"use strict";t(111)("trimRight",function(t){return function trimRight(){return t(this,2)}},"trimEnd")},{111:111}],317:[function(t,n,r){t(126)("asyncIterator")},{126:126}],318:[function(t,n,r){t(126)("observable")},{126:126}],319:[function(t,n,r){var e=t(33);e(e.S,"System",{global:t(40)})},{33:33,40:40}],320:[function(t,n,r){t(97)("WeakMap")},{97:97}],321:[function(t,n,r){t(98)("WeakMap")},{98:98}],322:[function(t,n,r){t(97)("WeakSet")},{97:97}],323:[function(t,n,r){t(98)("WeakSet")},{98:98}],324:[function(t,n,r){for(var e=t(141),i=t(81),o=t(94),u=t(40),c=t(42),a=t(58),f=t(128),s=f("iterator"),l=f("toStringTag"),h=a.Array,v={CSSRuleList:!0,CSSStyleDeclaration:!1,CSSValueList:!1,ClientRectList:!1,DOMRectList:!1,DOMStringList:!1,DOMTokenList:!0,DataTransferItemList:!1,FileList:!1,HTMLAllCollection:!1,HTMLCollection:!1,HTMLFormElement:!1,HTMLSelectElement:!1,MediaList:!0,MimeTypeArray:!1,NamedNodeMap:!1,NodeList:!0,PaintRequestList:!1,Plugin:!1,PluginArray:!1,SVGLengthList:!1,SVGNumberList:!1,SVGPathSegList:!1,SVGPointList:!1,SVGStringList:!1,SVGTransformList:!1,SourceBufferList:!1,StyleSheetList:!0,TextTrackCueList:!1,TextTrackList:!1,TouchList:!1},p=i(v),d=0;d<p.length;d++){var y,g=p[d],m=v[g],b=u[g],x=b&&b.prototype;if(x&&(x[s]||c(x,s,h),x[l]||c(x,l,g),a[g]=h,m))for(y in e)x[y]||o(x,y,e[y],!0)}},{128:128,141:141,40:40,42:42,58:58,81:81,94:94}],325:[function(t,n,r){var e=t(33),i=t(113);e(e.G+e.B,{setImmediate:i.set,clearImmediate:i.clear})},{113:113,33:33}],326:[function(t,n,r){var e=t(40),i=t(33),o=t(46),u=t(88),c=e.navigator,a=!!c&&/MSIE .\./.test(c.userAgent),f=function(t){return a?function(n,r){return t(o(u,[].slice.call(arguments,2),"function"==typeof n?n:Function(n)),r)}:t};i(i.G+i.B+i.F*a,{setTimeout:f(e.setTimeout),setInterval:f(e.setInterval)})},{33:33,40:40,46:46,88:88}],327:[function(t,n,r){t(254),t(191),t(193),t(192),t(195),t(197),t(202),t(196),t(194),t(204),t(203),t(199),t(200),t(198),t(190),t(201),t(205),t(206),t(157),t(159),t(158),t(208),t(207),t(178),t(188),t(189),t(179),t(180),t(181),t(182),t(183),t(184),t(185),t(186),t(187),t(161),t(162),t(163),t(164),t(165),t(166),t(167),t(168),t(169),t(170),t(171),t(172),t(173),t(174),t(175),t(176),t(177),t(241),t(246),t(253),t(244),t(236),t(237),t(242),t(247),t(249),t(232),t(233),t(234),t(235),t(238),t(239),t(240),t(243),t(245),t(248),t(250),t(251),t(252),t(152),t(154),t(153),t(156),t(155),t(140),t(138),t(145),t(142),t(148),t(150),t(137),t(144),t(134),t(149),t(132),t(147),t(146),t(139),t(143),t(131),t(133),t(136),t(135),t(151),t(141),t(224),t(230),t(225),t(226),t(227),t(228),t(229),t(209),t(160),t(231),t(266),t(267),t(255),t(256),t(261),t(264),t(265),t(259),t(262),t(260),t(263),t(257),t(258),t(210),t(211),t(212),t(213),t(214),t(217),t(215),t(216),t(218),t(219),t(220),t(221),t(223),t(222),t(270),t(268),t(269),t(311),t(314),t(313),t(315),t(316),t(312),t(317),t(318),t(292),t(295),t(291),t(289),t(290),t(293),t(294),t(276),t(310),t(275),t(309),t(321),t(323),t(274),t(308),t(320),t(322),t(273),t(319),t(272),t(277),t(278),t(279),t(280),t(281),t(283),t(282),t(284),t(285),t(286),t(288),t(287),t(297),t(298),t(299),t(300),t(302),t(301),t(304),t(303),t(305),t(306),t(307),t(271),t(296),t(326),t(325),t(324),n.exports=t(23)},{131:131,132:132,133:133,134:134,135:135,136:136,137:137,138:138,139:139,140:140,141:141,142:142,143:143,144:144,145:145,146:146,147:147,148:148,149:149,150:150,151:151,152:152,153:153,154:154,155:155,156:156,157:157,158:158,159:159,160:160,161:161,162:162,163:163,164:164,165:165,166:166,167:167,168:168,169:169,170:170,171:171,172:172,173:173,174:174,175:175,176:176,177:177,178:178,179:179,180:180,181:181,182:182,183:183,184:184,185:185,
186:186,187:187,188:188,189:189,190:190,191:191,192:192,193:193,194:194,195:195,196:196,197:197,198:198,199:199,200:200,201:201,202:202,203:203,204:204,205:205,206:206,207:207,208:208,209:209,210:210,211:211,212:212,213:213,214:214,215:215,216:216,217:217,218:218,219:219,220:220,221:221,222:222,223:223,224:224,225:225,226:226,227:227,228:228,229:229,23:23,230:230,231:231,232:232,233:233,234:234,235:235,236:236,237:237,238:238,239:239,240:240,241:241,242:242,243:243,244:244,245:245,246:246,247:247,248:248,249:249,250:250,251:251,252:252,253:253,254:254,255:255,256:256,257:257,258:258,259:259,260:260,261:261,262:262,263:263,264:264,265:265,266:266,267:267,268:268,269:269,270:270,271:271,272:272,273:273,274:274,275:275,276:276,277:277,278:278,279:279,280:280,281:281,282:282,283:283,284:284,285:285,286:286,287:287,288:288,289:289,290:290,291:291,292:292,293:293,294:294,295:295,296:296,297:297,298:298,299:299,300:300,301:301,302:302,303:303,304:304,305:305,306:306,307:307,308:308,309:309,310:310,311:311,312:312,313:313,314:314,315:315,316:316,317:317,318:318,319:319,320:320,321:321,322:322,323:323,324:324,325:325,326:326}],328:[function(t,n,r){(function(t){!function(t){"use strict";function wrap(t,n,r,e){var i=n&&n.prototype instanceof Generator?n:Generator,o=Object.create(i.prototype),u=new Context(e||[]);return o._invoke=makeInvokeMethod(t,r,u),o}function tryCatch(t,n,r){try{return{type:"normal",arg:t.call(n,r)}}catch(t){return{type:"throw",arg:t}}}function Generator(){}function GeneratorFunction(){}function GeneratorFunctionPrototype(){}function defineIteratorMethods(t){["next","throw","return"].forEach(function(n){t[n]=function(t){return this._invoke(n,t)}})}function AsyncIterator(n){function invoke(t,r,e,o){var u=tryCatch(n[t],n,r);if("throw"!==u.type){var c=u.arg,a=c.value;return a&&"object"==typeof a&&i.call(a,"__await")?Promise.resolve(a.__await).then(function(t){invoke("next",t,e,o)},function(t){invoke("throw",t,e,o)}):Promise.resolve(a).then(function(t){c.value=t,e(c)},o)}o(u.arg)}function enqueue(t,n){function callInvokeWithMethodAndArg(){return new Promise(function(r,e){invoke(t,n,r,e)})}return r=r?r.then(callInvokeWithMethodAndArg,callInvokeWithMethodAndArg):callInvokeWithMethodAndArg()}"object"==typeof t.process&&t.process.domain&&(invoke=t.process.domain.bind(invoke));var r;this._invoke=enqueue}function makeInvokeMethod(t,n,r){var e=l;return function invoke(i,o){if(e===v)throw new Error("Generator is already running");if(e===p){if("throw"===i)throw o;return doneResult()}for(r.method=i,r.arg=o;;){var u=r.delegate;if(u){var c=maybeInvokeDelegate(u,r);if(c){if(c===d)continue;return c}}if("next"===r.method)r.sent=r._sent=r.arg;else if("throw"===r.method){if(e===l)throw e=p,r.arg;r.dispatchException(r.arg)}else"return"===r.method&&r.abrupt("return",r.arg);e=v;var a=tryCatch(t,n,r);if("normal"===a.type){if(e=r.done?p:h,a.arg===d)continue;return{value:a.arg,done:r.done}}"throw"===a.type&&(e=p,r.method="throw",r.arg=a.arg)}}}function maybeInvokeDelegate(t,n){var e=t.iterator[n.method];if(e===r){if(n.delegate=null,"throw"===n.method){if(t.iterator.return&&(n.method="return",n.arg=r,maybeInvokeDelegate(t,n),"throw"===n.method))return d;n.method="throw",n.arg=new TypeError("The iterator does not provide a 'throw' method")}return d}var i=tryCatch(e,t.iterator,n.arg);if("throw"===i.type)return n.method="throw",n.arg=i.arg,n.delegate=null,d;var o=i.arg;return o?o.done?(n[t.resultName]=o.value,n.next=t.nextLoc,"return"!==n.method&&(n.method="next",n.arg=r),n.delegate=null,d):o:(n.method="throw",n.arg=new TypeError("iterator result is not an object"),n.delegate=null,d)}function pushTryEntry(t){var n={tryLoc:t[0]};1 in t&&(n.catchLoc=t[1]),2 in t&&(n.finallyLoc=t[2],n.afterLoc=t[3]),this.tryEntries.push(n)}function resetTryEntry(t){var n=t.completion||{};n.type="normal",delete n.arg,t.completion=n}function Context(t){this.tryEntries=[{tryLoc:"root"}],t.forEach(pushTryEntry,this),this.reset(!0)}function values(t){if(t){var n=t[u];if(n)return n.call(t);if("function"==typeof t.next)return t;if(!isNaN(t.length)){var e=-1,o=function next(){for(;++e<t.length;)if(i.call(t,e))return next.value=t[e],next.done=!1,next;return next.value=r,next.done=!0,next};return o.next=o}}return{next:doneResult}}function doneResult(){return{value:r,done:!0}}var r,e=Object.prototype,i=e.hasOwnProperty,o="function"==typeof Symbol?Symbol:{},u=o.iterator||"@@iterator",c=o.asyncIterator||"@@asyncIterator",a=o.toStringTag||"@@toStringTag",f="object"==typeof n,s=t.regeneratorRuntime;if(s)return void(f&&(n.exports=s));s=t.regeneratorRuntime=f?n.exports:{},s.wrap=wrap;var l="suspendedStart",h="suspendedYield",v="executing",p="completed",d={},y={};y[u]=function(){return this};var g=Object.getPrototypeOf,m=g&&g(g(values([])));m&&m!==e&&i.call(m,u)&&(y=m);var b=GeneratorFunctionPrototype.prototype=Generator.prototype=Object.create(y);GeneratorFunction.prototype=b.constructor=GeneratorFunctionPrototype,GeneratorFunctionPrototype.constructor=GeneratorFunction,GeneratorFunctionPrototype[a]=GeneratorFunction.displayName="GeneratorFunction",s.isGeneratorFunction=function(t){var n="function"==typeof t&&t.constructor;return!!n&&(n===GeneratorFunction||"GeneratorFunction"===(n.displayName||n.name))},s.mark=function(t){return Object.setPrototypeOf?Object.setPrototypeOf(t,GeneratorFunctionPrototype):(t.__proto__=GeneratorFunctionPrototype,a in t||(t[a]="GeneratorFunction")),t.prototype=Object.create(b),t},s.awrap=function(t){return{__await:t}},defineIteratorMethods(AsyncIterator.prototype),AsyncIterator.prototype[c]=function(){return this},s.AsyncIterator=AsyncIterator,s.async=function(t,n,r,e){var i=new AsyncIterator(wrap(t,n,r,e));return s.isGeneratorFunction(n)?i:i.next().then(function(t){return t.done?t.value:i.next()})},defineIteratorMethods(b),b[a]="Generator",b[u]=function(){return this},b.toString=function(){return"[object Generator]"},s.keys=function(t){var n=[];for(var r in t)n.push(r);return n.reverse(),function next(){for(;n.length;){var r=n.pop();if(r in t)return next.value=r,next.done=!1,next}return next.done=!0,next}},s.values=values,Context.prototype={constructor:Context,reset:function(t){if(this.prev=0,this.next=0,this.sent=this._sent=r,this.done=!1,this.delegate=null,this.method="next",this.arg=r,this.tryEntries.forEach(resetTryEntry),!t)for(var n in this)"t"===n.charAt(0)&&i.call(this,n)&&!isNaN(+n.slice(1))&&(this[n]=r)},stop:function(){this.done=!0;var t=this.tryEntries[0],n=t.completion;if("throw"===n.type)throw n.arg;return this.rval},dispatchException:function(t){function handle(e,i){return u.type="throw",u.arg=t,n.next=e,i&&(n.method="next",n.arg=r),!!i}if(this.done)throw t;for(var n=this,e=this.tryEntries.length-1;e>=0;--e){var o=this.tryEntries[e],u=o.completion;if("root"===o.tryLoc)return handle("end");if(o.tryLoc<=this.prev){var c=i.call(o,"catchLoc"),a=i.call(o,"finallyLoc");if(c&&a){if(this.prev<o.catchLoc)return handle(o.catchLoc,!0);if(this.prev<o.finallyLoc)return handle(o.finallyLoc)}else if(c){if(this.prev<o.catchLoc)return handle(o.catchLoc,!0)}else{if(!a)throw new Error("try statement without catch or finally");if(this.prev<o.finallyLoc)return handle(o.finallyLoc)}}}},abrupt:function(t,n){for(var r=this.tryEntries.length-1;r>=0;--r){var e=this.tryEntries[r];if(e.tryLoc<=this.prev&&i.call(e,"finallyLoc")&&this.prev<e.finallyLoc){var o=e;break}}o&&("break"===t||"continue"===t)&&o.tryLoc<=n&&n<=o.finallyLoc&&(o=null);var u=o?o.completion:{};return u.type=t,u.arg=n,o?(this.method="next",this.next=o.finallyLoc,d):this.complete(u)},complete:function(t,n){if("throw"===t.type)throw t.arg;return"break"===t.type||"continue"===t.type?this.next=t.arg:"return"===t.type?(this.rval=this.arg=t.arg,this.method="return",this.next="end"):"normal"===t.type&&n&&(this.next=n),d},finish:function(t){for(var n=this.tryEntries.length-1;n>=0;--n){var r=this.tryEntries[n];if(r.finallyLoc===t)return this.complete(r.completion,r.afterLoc),resetTryEntry(r),d}},catch:function(t){for(var n=this.tryEntries.length-1;n>=0;--n){var r=this.tryEntries[n];if(r.tryLoc===t){var e=r.completion;if("throw"===e.type){var i=e.arg;resetTryEntry(r)}return i}}throw new Error("illegal catch attempt")},delegateYield:function(t,n,e){return this.delegate={iterator:values(t),resultName:n,nextLoc:e},"next"===this.method&&(this.arg=r),d}}}("object"==typeof t?t:"object"==typeof window?window:"object"==typeof self?self:this)}).call(this,"undefined"!=typeof global?global:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{}]},{},[1]);

(function() {
  'use strict';

  angular
    .module('storeLocator')
    .run(['$rootScope', '$anchorScroll', '$location', function ($rootScope, $anchorScroll, $location) {
        $rootScope.$on("$locationChangeSuccess", function () {
           $anchorScroll();
        });
    }]);
})();

(function() {
  'use strict';

  angular
    .module('storeLocator')
    .config(routerConfig)
    .run(function($rootScope) {

      $rootScope.$on('$viewContentLoaded' , function() {
        var firstInteractiveItem = angular.element("a.visually-hidden")[0];

        if (firstInteractiveItem) {
          firstInteractiveItem.focus();
        }
    });
  });

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider, STORE_LOCATOR, LOCAL_LANDING_PAGE, ROOT_PAGE, SITE_MAP_PAGE, CLIENT_ROUTE, CLIENT_ROUTE_TRAILING_SLASH, STORE_LOCATOR_ROUTES, HAS_MULTILINGUAL) {

    function getUrl(route) {
      return CLIENT_ROUTE == '' ? route : CLIENT_ROUTE + route;
    }

    $urlRouterProvider.otherwise(function($injector, $location) {
      var $state = $injector.get('$state');
      var path = $location.path();
      var language = HAS_MULTILINGUAL ? path.split('/')[1] : null;
      $state.go('root.home', { language: language });
    });

    $urlRouterProvider.when('/index.html', '/');

    if (!CLIENT_ROUTE_TRAILING_SLASH) {
      $urlRouterProvider.rule(function ($injector, $location) {
        var path = $location.url();
        if (path[path.length - 1] === '/') {
          return path.slice(0, -1);
        }
      });
    }

    $stateProvider
      .state('root', {
        templateUrl: ROOT_PAGE,
        controller: 'RootController',
        controllerAs: 'rootC',
        resolve: {
          'setLanguage': function (LanguageService, StoreFinderService) {
            return LanguageService.setLanguage().then(function (lang) {
              return StoreFinderService.getMessagesAndMeta(lang);
            });
          }
        },
      })
      .state('root.home', {
        url: getUrl(STORE_LOCATOR_ROUTES.home.url),
        templateUrl: STORE_LOCATOR,
        controller: 'storeLocatorController',
        controllerAs: 'storeLocatorCtrl',
        title: 'Store Locator'
      })
      .state('404', {
        url: '/404',
        templateUrl: 'app/errorPages/404.html',
        controller: '404errorCard',
        controllerAs: '404Ctrl'
      })
      .state('400', {
        url: '/400',
        templateUrl: 'app/errorPages/400.html',
        controller: '400errorCard',
        controllerAs: '400Ctrl'
      })
      .state('500', {
        url: '/500',
        templateUrl: 'app/errorPages/500.html',
        controller: '500errorCard',
        controllerAs: '500Ctrl'
      });

      if (STORE_LOCATOR_ROUTES.siteMap) {
        $stateProvider.state('root.siteMap', {
          url: getUrl(STORE_LOCATOR_ROUTES.siteMap.url),
          templateUrl: SITE_MAP_PAGE,
          controller: 'SiteMapController',
          controllerAs: 'siteMapC',
          title: 'Site Map',
          params: STORE_LOCATOR_ROUTES.siteMap.params || { continent: null}
        })
      }
      if(STORE_LOCATOR_ROUTES.siteMapAll) {
        $stateProvider.state('root.siteMapAll', {
          url: getUrl(STORE_LOCATOR_ROUTES.siteMapAll.url),
          templateUrl: SITE_MAP_PAGE,
          controller: 'SiteMapController',
          controllerAs: 'siteMapC',
          title: 'Site Map',
          params: STORE_LOCATOR_ROUTES.siteMapAll.params || { all: true }
        })
      }
      if(STORE_LOCATOR_ROUTES.siteMapCountry) {
        $stateProvider.state('root.siteMapCountry', {
            url: getUrl(STORE_LOCATOR_ROUTES.siteMapCountry.url),
            templateUrl: SITE_MAP_PAGE,
            controller: 'SiteMapController',
            controllerAs: 'siteMapC',
            title: 'Site Map',
            params: STORE_LOCATOR_ROUTES.siteMapCountry.params
          })
      }
      if(STORE_LOCATOR_ROUTES.siteMapRegion) {
        $stateProvider.state('root.siteMapRegion', {
          url: getUrl(STORE_LOCATOR_ROUTES.siteMapRegion.url),
          templateUrl: SITE_MAP_PAGE,
          controller: 'SiteMapController',
          controllerAs: 'siteMapC',
          title: 'Site Map',
          params: STORE_LOCATOR_ROUTES.siteMapRegion.params
        })
      }
      if(STORE_LOCATOR_ROUTES.siteMapLocality) {
        $stateProvider.state('root.siteMapLocality', {
          url: getUrl(STORE_LOCATOR_ROUTES.siteMapLocality.url),
          templateUrl: SITE_MAP_PAGE,
          controller: 'SiteMapController',
          controllerAs: 'siteMapC',
          title: 'Site Map',
          params: STORE_LOCATOR_ROUTES.siteMapLocality.params
        })
      }
      if (STORE_LOCATOR_ROUTES.localLanding) {
        $stateProvider.state('root.localLanding', {
          url: getUrl(STORE_LOCATOR_ROUTES.localLanding.url),
          templateUrl: LOCAL_LANDING_PAGE,
          controller: 'LocalLandingController',
          controllerAs: 'localLanding',
          params: STORE_LOCATOR_ROUTES.localLanding.params
        })
      }
      if (STORE_LOCATOR_ROUTES.localLandingWithName) {
        $stateProvider.state('root.localLandingWithName', {
          url: getUrl(STORE_LOCATOR_ROUTES.localLandingWithName.url),
          templateUrl: LOCAL_LANDING_PAGE,
          controller: 'LocalLandingController'
        })
      }
  }

})();

(function() { 
	'use strict'; 
	angular.module("storeLocator")
.constant("ENV", "prod")
.constant("GOOGLE_API_KEY", "AIzaSyDIfSyryL0vRpxCCDilpmgnYhC98A_E8EQ")
.constant("API_HOST", "https://uberall.com/api")
.constant("GOOGLE_GEOCODE_URL", "https://maps.googleapis.com/maps/api/geocode/json")
.constant("MAPBOX_KEY", "pk.eyJ1IjoibW9tZW50ZmVlZCIsImEiOiJPS21SYV80In0.rZ-uswLQiEx1hkfcj5fVhw")
.constant("MAPBOX_GEOCODE_URL", "https://api.mapbox.com/geocoding/v5/mapbox.places/%s.json")
.constant("HOURS_CARD_TEMPLATE", "app/localLanding/cards/hoursCard.directive.html")
.constant("PARTNER_REVIEWS_CARD_TEMPLATE", "app/localLanding/cards/partnerReviewsCard.directive.html")
.constant("STORE_LOCATOR_SEARCH_BAR_TEMPLATE", "app/storeLocator/directives/search.directive.html")
.constant("STORE_LOCATOR_SEARCH_BY_NAME_TEMPLATE", "app/storeLocator/directives/searchByName.directive.html")
.constant("ADDRESS_CARD_TEMPLATE", "app/localLanding/cards/addressCard.directive.html")
.constant("LOCATION_LIST_TEMPLATE", "app/siteMap/locationList.directive.html")
.constant("STORE_LOCATOR_MAP_TYPE", "Mapbox")
.constant("STORE_LOCATOR_GOOGLE_SEARCH_TYPE", "geocode")
.constant("STORE_LOCATOR_PIXEL", null)
.constant("STORE_LOCATOR_DEFAULT_SEARCH_FILTERS", null)
.constant("TAGS_CONDITION_TYPE", "AND")
.constant("CLIENT_ROUTE", "")
.constant("CLIENT_ROUTE_TRAILING_SLASH", true)
.constant("BUNDLE_PATH", "")
.constant("STORE_LOCATOR_MESSAGES", null)
.constant("META", {})
.constant("HAM_NAV_DATA", [])
.constant("HAM_NAV_TOGGLE", false)
.constant("STORE_LOCATOR_LOC_ID", "")
.constant("SITEMAP_SHOW_TEMP_CLOSED_LOCATIONS", true)
.constant("STORE_LOCATOR_MAP_CONFIGS", "")
.constant("STORE_LOCATOR_ZOOMOUT_ON_MOBILE_SEARCH", false)
.constant("DISABLE_SCRIPTS_ON_QA", true)
.constant("MAPBOX_BBOX", null)
.constant("DISPLAY_POPUP_ON_LOCATION_SHARED", false)
.constant("NOINDEX_PAGES", null)
.constant("NOINDEX_QA_ENV", true)
.constant("NOINDEX_PROD_ENV", true)
.constant("MAPBOX_CLUSTER", false)
.constant("DISPLAY_ALL_LOCATIONS_IN_MAP", false)
.constant("HAS_MULTILINGUAL", false)
.constant("DEFAULT_LANGUAGE", "en")
.constant("LANGUAGE_COOKIE", null)
.constant("SUPPORTED_LANGUAGES", ["en"])
.constant("LAYOUT_ASSETS_PATH", null)
.constant("DEFAULT_UNIT", "mi")
.constant("MAPBOX_STYLE", "momentfeed/ckekfnwp3079w19qmiwkaneut")
.constant("NO_ROUTING_PREFIX", false)
.constant("ORDER_RESULTS_LIST", false)
.constant("LAYOUT_LOCAL_LANDING_PATH", null)
.constant("SF_ANALYTICS_WEBSITE_QA", null)
.constant("SF_ANALYTICS_WEBSITE_PROD", null)
.constant("QUERY_BY_SLUG", false)
.constant("STORE_LOCATOR_ROUTES", {"home":{"url":"/"},"localLanding":{"url":"/ll/:country/:region/:locality/:address"},"localLandingWithName":{"url":"/ll/:name/:country/:region/:locality/:address"},"siteMap":{"url":"/site-map"},"siteMapAll":{"url":"/site-map/all"},"siteMapCountry":{"url":"/site-map/:country"},"siteMapRegion":{"url":"/site-map/:country/:region"},"siteMapLocality":{"url":"/site-map/:country/:region/:locality"}})
.constant("FIELD_MASK", []);
 })();
(function() {
  'use strict';

  angular
    .module('storeLocator')
    .config(config);

  /** @ngInject */
  function config($logProvider,
                  $locationProvider,
                  RestangularProvider,
                  API_HOST,
                  $analyticsProvider,
                  GOOGLE_ANALYTICS,
                  GOOGLE_ANALYTICS_CLIENT,
                  TEALIUM_HEAD_INJECTIONS,
                  TEALIUM_BODY_INJECTIONS,
                  GOOGLE_TAG_MANAGER,
                  GOOGLE_AD_WORDS,
                  FACEBOOK_PIXEL,
                  DISABLE_SCRIPTS_ON_QA
                  ) {

    // Enable log
    $logProvider.debugEnabled(true);

    RestangularProvider.setBaseUrl(API_HOST);

    $locationProvider.html5Mode(true);

    var url = window.location.href;
    var prodEnvironment = url.indexOf('localhost') === -1 && url.indexOf('llp.qa') === -1;

    // Scripts will be appended only if it's a Prod environment or the DISABLE_SCRIPTS_ON_QA config is false.
    // DISABLE_SCRIPTS_ON_QA defaults to true, and to enable scripts on QA is necessary to add in the client configs as 'false'
    if (prodEnvironment || !DISABLE_SCRIPTS_ON_QA) {
      // MF analytics start
      if (GOOGLE_ANALYTICS && GOOGLE_ANALYTICS.includes('UA-')) {
        (function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){(i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)})(window,document,'script','//www.google-analytics.com/analytics.js','ga');
            ga('create', GOOGLE_ANALYTICS, 'auto', {'allowLinker': true});  // where is this ga function coming from? can we use AnalyticsProvider instead?
      }
      // MF analytics end

      // Client analytics start
      // Assumes this is supplementary to GOOGLE_ANALYTICS and wouldn't exist otherwise.
      if (GOOGLE_ANALYTICS && GOOGLE_ANALYTICS.includes('UA-') && GOOGLE_ANALYTICS_CLIENT && GOOGLE_ANALYTICS_CLIENT.includes('UA-')) {
        ga('create', GOOGLE_ANALYTICS_CLIENT, 'auto', { 'name': 'clientTracker', 'allowLinker': true });
        // need this to integrate with angulartics
        $analyticsProvider.settings.ga.additionalAccountNames = ['clientTracker'];
      } else if(!GOOGLE_ANALYTICS && GOOGLE_ANALYTICS_CLIENT && GOOGLE_ANALYTICS_CLIENT.includes('UA-')) {
        // If !GOOGLE_ANALYTICS, add the script from line 21 on line 30.
        (function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){(i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)})(window,document,'script','//www.google-analytics.com/analytics.js','ga');
        ga('create', GOOGLE_ANALYTICS_CLIENT, 'auto', {'allowLinker': true});
      }
      // Client analytics end

      // Google Analytics 4 start
      if (GOOGLE_ANALYTICS && GOOGLE_ANALYTICS.includes('G-')) {
        var script = "<script async src='https://www.googletagmanager.com/gtag/js?id=\"" + GOOGLE_ANALYTICS + "\"'></script><script>window.dataLayer = window.dataLayer || [];function gtag(){dataLayer.push(arguments);}gtag('js', new Date());gtag('config', '" + GOOGLE_ANALYTICS + "'); </script>";
        if (GOOGLE_ANALYTICS_CLIENT && (GOOGLE_ANALYTICS_CLIENT.includes('G-') || GOOGLE_ANALYTICS_CLIENT.includes('DC-'))) {
          script = "<script async src='https://www.googletagmanager.com/gtag/js?id=\"" + GOOGLE_ANALYTICS + "\"'></script><script>window.dataLayer = window.dataLayer || [];function gtag(){dataLayer.push(arguments);}gtag('js', new Date());gtag('config', '" + GOOGLE_ANALYTICS + "');gtag('config', '" + GOOGLE_ANALYTICS_CLIENT + "'); </script>";
        } else if (GOOGLE_ANALYTICS_CLIENT && GOOGLE_ANALYTICS_CLIENT.includes('UA-')) {
          (function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){(i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)})(window,document,'script','//www.google-analytics.com/analytics.js','ga');
          ga('create', GOOGLE_ANALYTICS_CLIENT, 'auto', {'allowLinker': true});
        }
        $('head').append(script);
      }
      // Google Analytics 4 end

      // Optional client GTM
      if (GOOGLE_TAG_MANAGER) {
        $('head').append("<script>(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','" + GOOGLE_TAG_MANAGER + "');</script>");
        $('body').prepend('<noscript><iframe src="//www.googletagmanager.com/ns.html?id=' + GOOGLE_TAG_MANAGER + '" ' + 'height="0" width="0" style="display:none;visibility:hidden"></iframe></noscript>');
      }

      // END - Optional client GTM

      //Set up GOOGLE AD WORDS
      if (GOOGLE_AD_WORDS) {
        $('head').append("<script async src='https://www.googletagmanager.com/gtag/js?id=AW-"+GOOGLE_AD_WORDS+"'></script><script>window.dataLayer = window.dataLayer || [];function gtag(){dataLayer.push(arguments);}gtag('js', new Date());gtag('config', '"+GOOGLE_AD_WORDS+"');</script>");
      }
      //End googleAdWords

      //Set up FACEBOOK_PIXEL
      if (FACEBOOK_PIXEL) {
        $('head').append("<script>!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod? n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window, document,'script','https://connect.facebook.net/en_US/fbevents.js');fbq('init', '"+FACEBOOK_PIXEL+"');</script><noscript><img height='1' width='1' style='display:none'src='https://www.facebook.com/tr?id="+FACEBOOK_PIXEL+"&ev=PageView&noscript=1'/></noscript>");
      }
      //End facebookPixel

      if (TEALIUM_HEAD_INJECTIONS) {
        $('head').append(TEALIUM_HEAD_INJECTIONS);
      }

      if (TEALIUM_BODY_INJECTIONS) {
        $('body').prepend(TEALIUM_BODY_INJECTIONS);
      }
    }

  }


})();

(function() { 
    'use strict'; 
    /*
     This file hold all common fields for all clients.
     If any client has its own fields, put them to {client}/index.constants.js
     Client custom fields will overwritten common fields here with the same name.
    */
	angular.module("storeLocator")
    .constant("CUSTOM_DICTIONARY", {
        placeholder: "Zip Code or City, State",
        searchByNamePlaceholder: "Enter a location name",
        storeLocatorText: "Store Locator"
      });
 })();
angular.module("storeLocator").run(["$templateCache", function($templateCache) {$templateCache.put("app/root.html","<div class=\"container\"><nav class=\"navbar navbar-default\" id=\"main_navigation\"><div class=\"container-fluid\"><div class=\"navbar-header\"><button type=\"button\" class=\"navbar-toggle collapsed\" data-toggle=\"collapse\" data-target=\"#bs-example-navbar-collapse-1\" aria-expanded=\"false\"><span class=\"sr-only\">Toggle navigation</span> <span class=\"icon-bar\"></span> <span class=\"icon-bar\"></span> <span class=\"icon-bar\"></span></button> <a class=\"navbar-brand\" href=\"#\"><div></div><h2 id=\"location-finder-title\">Location Finder</h2></a></div><div class=\"collapse navbar-collapse\" id=\"bs-example-navbar-collapse-1\"><ul class=\"nav navbar-nav navbar-right\"><li><a href=\"#\">Menu</a></li><li><a href=\"#\">Gift Certificate</a></li><li><a href=\"#\">Locations</a></li><li><a href=\"/site-map\">Site Map</a></li></ul></div></div></nav><div ui-view=\"\"></div></div>");
$templateCache.put("app/errorPages/400.html","<div class=\"container\"><div class=\"col-lg-12 col-md-12 col-sm-12\"><h2 id=\"errorPageh2\">HTTP ERROR 400: (BAD REQUEST)</h2><hr><h4>The requested resource could not be reached. Sorry.</h4>Click <a href=\"\" ng-click=\"back()\">here</a> to return to the previous page.<hr></div></div><div class=\"row\"></div>");
$templateCache.put("app/errorPages/404.html","<div class=\"container\"><div class=\"col-lg-12 col-md-12 col-sm-12\"><h2 id=\"errorPageh2\">HTTP ERROR 404: (RESOURCE NOT FOUND)</h2><hr><h4>The requested resource could not be reached. Sorry.</h4>It might have been deleted or service temporarily suspended, please try again later for a resumption of service. Click <a href=\"\" ng-click=\"back()\">here</a> to return to the previous page.<hr></div></div><div class=\"row\"></div>");
$templateCache.put("app/errorPages/500.html","<div class=\"container\"><div class=\"col-lg-12 col-md-12 col-sm-12\"><h2 id=\"errorPageh2\">HTTP ERROR 500: INTERNAL SERVER ERROR</h2><hr><h4>An error was encountered while serving your content.</h4>Click <a href=\"\" ng-click=\"back()\">here</a> to return to the previous page.<hr></div></div><div class=\"row\"></div>");
$templateCache.put("app/siteMap/locationList.directive.html","<div class=\"site-map-list push-top-lg\"><br><div><h1 ng-if=\"locationListC.worldwideh1\">{{locationListC.locationsTitleText}}</h1></div><hr><div ng-if=\"locationListC.locations\"><div class=\"container\" ng-if=\"locationListC.position === \'global\'\" ng-repeat=\"(continent, locations) in locationListC.locations\"><div class=\"row push-top-md\"><h2><a class=\"bold\" title=\"{{(continent === \'Central American\') ? \'Central America\' : continent}}\">{{(continent === \'Central American\') ? \'Central America\' : continent}}</a></h2></div><div class=\"row\"><div ng-repeat=\"country in locationListC.getListOfCountries(locations).keys\"><div class=\"col-lg-4 country-locations\" ng-if=\"((locationListC.checkCountryInContinent(country)) === continent)\"><h3><a title=\"{{locationListC.getCountry(country)}}\" href=\"{{ locationListC.getLinkUrl(country) }}\">{{locationListC.getCountry(country)}}</a></h3></div></div></div><br></div><div ng-if=\"locationListC.position === \'continent\'\" ng-repeat=\"(country, locations) in locationListC.locations\"><div ng-if=\"((locationListC.checkCountryInContinent(country)) === continent)\"><h2><a class=\"bold\" title=\"{{locationListC.getCountry(country)}}\" href=\"{{ locationListC.getLinkUrl(locations[0].store_info.country) }}\">{{locationListC.getCountry(country)}}</a></h2></div></div><div ng-if=\"locationListC.position === \'country\'\" ng-repeat=\"(place, locations) in locationListC.locations\"><h2><a class=\"bold\" title=\"{{locationListC.getRegion(locations[0].store_info.region)}}\" href=\"{{ locationListC.getLinkUrl(locations[0].store_info.country + \'/\' + locations[0].store_info.region ) }}\">{{locationListC.getRegion(locations[0].store_info.country, locations[0].store_info.region)}}</a></h2><div class=\"region-locations\"><div ng-repeat=\"location in locations track by $index\" class=\"small\"><a class=\"sitemap-region\" href=\"{{ locationListC.getLinkUrl(locations[0].store_info.country + \'/\' + locations[0].store_info.region + \'/\' + location.store_info.locality ) }}\">{{location.store_info.locality}}</a>- <a class=\"sitemap-location\" href=\"{{ locationListC.languageService.updateLinkUrl(location.llp_url) }}\">{{location.store_info.address}} <span ng-if=\"location.store_info.address_extended\">, {{location.store_info.address_extended}}</span> <span class=\"coming-soon-text\" ng-if=\"location.open_or_closed === \'coming soon\' && locationListC.comingSoonText\">- {{locationListC.comingSoonText}}</span> <span class=\"coming-soon-text\" ng-if=\"location.open_or_closed === \'temp closed\'\">- Temporarily Closed</span></a></div></div></div><div ng-if=\"locationListC.position === \'region\'\"><div ng-repeat=\"(place, locations) in locationListC.others\"><h3><a class=\"bold\" title=\"{{place}}\" href=\"{{ locationListC.getLinkUrl(locations[0].store_info.country + \'/\' + locations[0].store_info.region + \'/\' + locations[0].store_info.locality ) }}\">{{place}}</a></h3><div class=\"region-locations\"><div ng-repeat=\"loc in locations\" class=\"small\"><a class=\"sitemap-region\" href=\"{{ locationListC.getLinkUrl(loc.store_info.country + \'/\' + loc.store_info.region + \'/\' + loc.store_info.locality ) }}\">{{loc.store_info.locality}}</a>- <a class=\"sitemap-location\" href=\"{{ locationListC.languageService.updateLinkUrl(loc.llp_url) }}\">{{loc.store_info.address}} <span ng-if=\"loc.store_info.address_extended\">, {{loc.store_info.address_extended}}</span> <span class=\"coming-soon-text\" ng-if=\"loc.open_or_closed === \'coming soon\' && locationListC.comingSoonText\">- {{locationListC.comingSoonText}}</span> <span class=\"coming-soon-text\" ng-if=\"loc.open_or_closed === \'temp closed\'\">- Temporarily Closed</span></a></div></div></div><div ng-if=\"locationListC.featured.length > 0\"><h1 class=\"bold\">Featured</h1><div ng-repeat=\"(place, locations) in locationListC.featured\"><h3><a class=\"bold\" title=\"{{place}}\" href=\"{{ locationListC.getLinkUrl(locations[0].store_info.country + \'/\' + locations[0].store_info.region + \'/\' + locations[0].store_info.locality ) }}\">{{place}}</a></h3><div class=\"region-locations\"><div ng-repeat=\"loc in locations\" class=\"small\"><a class=\"sitemap-region\" href=\"{{ locationListC.getLinkUrl(loc.store_info.country + \'/\' + loc.store_info.region + \'/\' + loc.store_info.locality ) }}\">{{loc.store_info.locality}}</a>- <a class=\"sitemap-location\" href=\"{{ locationListC.languageService.updateLinkUrl(loc.llp_url) }}\">{{loc.store_info.address}} <span ng-if=\"loc.store_info.address_extended\">, {{loc.store_info.address_extended}}</span> <span class=\"coming-soon-text\" ng-if=\"loc.open_or_closed === \'coming soon\' && locationListC.comingSoonText\">- {{locationListC.comingSoonText}}</span> <span class=\"coming-soon-text\" ng-if=\"loc.open_or_closed === \'temp closed\'\">- Temporarily Closed</span></a></div></div></div></div></div><div ng-if=\"locationListC.position === \'locality\'\" ng-repeat=\"(place, locations) in locationListC.locations\"><h3><a class=\"bold\" title=\"{{place}}\" href=\"{{ locationListC.getLinkUrl(locations[0].store_info.country + \'/\' + locations[0].store_info.region + \'/\' + locations[0].store_info.locality ) }}\">{{place}}</a></h3><div class=\"region-locations\"><div ng-repeat=\"loc in locations\" class=\"small\"><a class=\"sitemap-region\" href=\"{{ locationListC.getLinkUrl(loc.store_info.country + \'/\' + loc.store_info.region + \'/\' + loc.store_info.locality ) }}\">{{loc.store_info.locality}}</a>- <a class=\"sitemap-location\" href=\"{{ locationListC.languageService.updateLinkUrl(loc.llp_url) }}\">{{loc.store_info.address}} <span ng-if=\"loc.store_info.address_extended\">, {{loc.store_info.address_extended}}</span> <span class=\"coming-soon-text\" ng-if=\"loc.open_or_closed === \'coming soon\' && locationListC.comingSoonText\">- {{locationListC.comingSoonText}}</span> <span class=\"coming-soon-text\" ng-if=\"loc.open_or_closed === \'temp closed\'\">- Temporarily Closed</span></a></div></div></div><div class=\"container\" ng-if=\"locationListC.position === \'all\'\"><div ng-repeat=\"(region, locations) in locationListC.locations\" ng-if=\"locationListC.locations\"><h2><a class=\"bold\" title=\"{{region}}\" href=\"{{ locationListC.getLinkUrl(locations[0].store_info.country + \'/\' + locations[0].store_info.region ) }}\">{{region}}</a></h2><div class=\"region-locations\"><div ng-repeat=\"location in locations track by $index\" class=\"small\"><a class=\"sitemap-region\" href=\"{{ locationListC.getLinkUrl(locations[0].store_info.country + \'/\' + locations[0].store_info.region + \'/\' + location.store_info.locality ) }}\">{{location.store_info.locality}}</a>- <a class=\"sitemap-location\" href=\"{{ locationListC.languageService.updateLinkUrl(location.llp_url) }}\">{{location.store_info.address}} <span ng-if=\"location.store_info.address_extended\">, {{location.store_info.address_extended}}</span> <span class=\"coming-soon-text\" ng-if=\"loc.open_or_closed === \'coming soon\' && locationListC.comingSoonText\">- {{locationListC.comingSoonText}}</span> <span class=\"coming-soon-text\" ng-if=\"loc.open_or_closed === \'temp closed\'\">- Temporarily Closed</span></a></div></div></div></div></div></div>");
$templateCache.put("app/siteMap/siteMap.html","<div class=\"container site-map-container push-bottom-xl\" id=\"site-map\"><div class=\"site-map\"><h1 class=\"bold\">{{siteMapC.client_name}} {{siteMapC.locationsTitleText}}</h1><div class=\"site-map-breadcrumb\"><div class=\"store-locator-breadcrumb\"><span><a href=\"{{ siteMapC.languageService.updateLinkUrl(\'/\') }}\"><span class=\"less-than\">&lt;</span>{{siteMapC.backButtonText}}</a></span></div><div itemscope=\"\" itemtype=\"http://schema.org/BreadcrumbList\"><span ng-if=\"siteMapC.showBreadcrumb\" itemprop=\"itemListElement\" itemscope=\"\" itemtype=\"http://schema.org/ListItem\"><a itemprop=\"item\" href=\"{{ siteMapC.languageService.updateLinkUrl(\'site-map/all\') }}\"><span itemprop=\"name\">{{siteMapC.allButtonText}}</span></a><meta itemprop=\"position\" content=\"1\"></span> <span ng-if=\"siteMapC.showBreadcrumb && siteMapC.continent\" itemprop=\"itemListElement\" itemscope=\"\" itemtype=\"http://schema.org/ListItem\">&nbsp;|&nbsp;<a itemprop=\"item\" href=\"{{ siteMapC.languageService.updateLinkUrl(\'site-map\') }}\" ui-sref-opts=\"{reload: true}\"><span itemprop=\"name\">{{siteMapC.continent}}</span></a><meta itemprop=\"position\" content=\"2\"></span> <span ng-if=\"siteMapC.showBreadcrumb\" itemprop=\"itemListElement\" itemscope=\"\" itemtype=\"http://schema.org/ListItem\">&nbsp;|&nbsp;<a itemprop=\"item\" ng-class=\"{\'disabled\':siteMapC.position === \'country\'}\" href=\"{{ siteMapC.languageService.updateLinkUrl(\'site-map/\' + siteMapC.country) }}\"><span itemprop=\"name\">{{siteMapC.country}}</span></a><meta itemprop=\"position\" content=\"3\"></span> <span ng-if=\"siteMapC.region\" itemprop=\"itemListElement\" itemscope=\"\" itemtype=\"http://schema.org/ListItem\">&nbsp;|&nbsp;<a itemprop=\"item\" ng-class=\"{\'disabled\':siteMapC.position === \'region\'}\" href=\"{{ siteMapC.languageService.updateLinkUrl(\'site-map/\' + siteMapC.country + \'/\' + siteMapC.region ) }}\"><span itemprop=\"name\">{{siteMapC.region}}</span></a><meta itemprop=\"position\" content=\"4\"></span> <span ng-if=\"siteMapC.locality\" itemprop=\"itemListElement\" itemscope=\"\" itemtype=\"http://schema.org/ListItem\">&nbsp;|&nbsp;<a itemprop=\"item\" class=\"disabled\" href=\"{{ siteMapC.languageService.updateLinkUrl(\'site-map/\' + siteMapC.country + \'/\' + siteMapC.region ) }}\"><span itemprop=\"name\" ng-class=\"{\'capitalize\': siteMapC.client_name.toLowerCase().includes(\'burberry\')}\">{{siteMapC.normalizeLocality(siteMapC.locality)}}</span></a><meta itemprop=\"position\" content=\"5\"></span></div></div><div ng-show=\"!siteMapC.showPage\" class=\"push-top-xl\"><div class=\"mf-loader text-center mf-loading-list\"><i class=\"ico ico-spinner ico-spin\"></i></div></div><location-list ng-if=\"siteMapC.showPage\" locations=\"siteMapC.locList\" client-route=\"siteMapC.client_route\" position=\"siteMapC.position\" featured=\"siteMapC.featuredList\" others=\"siteMapC.othersList\" get-by-country=\"siteMapC.getByCountryForContinent(locList)\" translated-messages=\"siteMapC.storeFindersMessages\"></location-list><sitemap-error-card ng-if=\"siteMapC.showPage && !siteMapC.locList\"></sitemap-error-card></div></div>");
$templateCache.put("app/storeLocator/storeLocator.html","<div class=\"store-locator-container\"><div ng-if=\"storeLocatorCtrl.pixelCode\" data-ng-bind-html=\"storeLocatorCtrl.pixelCode\"></div><div class=\"store-locator-title\"><h1>{{storeLocatorCtrl.storeLocatorTitle}}</h1></div><div class=\"alert alert-danger\" role=\"alert\" data-ng-show=\"storeLocatorCtrl.locatorStates.errors\">{{storeLocatorCtrl.locatorStates.errors}}</div><div class=\"alert alert-info\" role=\"alert\" data-ng-show=\"storeLocatorCtrl.locatorStates.notifications\">{{storeLocatorCtrl.notifications}}</div><div id=\"js-breadcrumbs\" class=\"row breadcrumbs\"><div class=\"col-xs-8\"><div class=\"store-locator-crumbs section-breadcrumb\"><span id=\"locator-breadcrumb\" class=\"text-uppercase\"><a data-ui-sref=\"{{storeLocatorCtrl.siteMapLink}}\" title=\"Site Map\" aria-label=\"breadcrumbs\">{{storeLocatorCtrl.siteMapLinkText}}</a> | {{storeLocatorCtrl.storeLocatorText}}</span><h2>Find a Location by {{storeLocatorCtrl.searchLabel}}</h2></div></div><div class=\"col-xs-4\"><div class=\"clearfix text-right visible-xs\" id=\"filter-map-list\"><button type=\"button\" data-ng-click=\"storeLocatorCtrl.showList = !storeLocatorCtrl.showList\" class=\"btn btn-xs btn-text showList\"><span data-ng-show=\"storeLocatorCtrl.showList\"><i class=\"fa fa-map-o\" aria-hidden=\"true\" data-ng-show=\"storeLocatorCtrl.showIcons\"></i><span class=\"view-text\">{{storeLocatorCtrl.mapViewText}}</span></span> <span data-ng-show=\"!storeLocatorCtrl.showList\"><i class=\"fa fa-list\" aria-hidden=\"true\" data-ng-show=\"storeLocatorCtrl.showIcons\"></i><span class=\"view-text\">{{storeLocatorCtrl.listViewText}}</span></span></button></div></div></div><div class=\"store-locator-description\" ng-if=\"storeLocatorCtrl.storeLocatorDescription\"><p>{{storeLocatorCtrl.storeLocatorDescription}}</p></div><div class=\"clearfix push-bottom store-locator-content\"><div class=\"col-sm-6 locations-container\" data-ng-class=\"{\'show-list\': storeLocatorCtrl.showList}\"><h3 ng-if=\"storeLocatorCtrl.customSearchTitle\" class=\"locations-container-title\">{{storeLocatorCtrl.customSearchTitle}}</h3><search data-locator-states=\"storeLocatorCtrl.locatorStates\" data-map-obj=\"storeLocatorCtrl.mapObj\" data-is-google-maps-api-loaded=\"isGoogleMapsApiLoaded\"></search><tabs ng-if=\"storeLocatorCtrl.showTabs\" data-locator-states=\"storeLocatorCtrl.locatorStates\" data-map-obj=\"storeLocatorCtrl.mapObj\"></tabs><results ng-if=\"!storeLocatorCtrl.showTabs\" data-locator-states=\"storeLocatorCtrl.locatorStates\" data-map-obj=\"storeLocatorCtrl.mapObj\"></results></div><div id=\"global-locations-map-container\" class=\"col-sm-6 locations-map-container\" ng-class=\"{\'show-map\' : !storeLocatorCtrl.showList}\"><map data-locator-states=\"storeLocatorCtrl.locatorStates\" data-map-obj=\"storeLocatorCtrl.mapObj\" data-is-google-maps-api-loaded=\"isGoogleMapsApiLoaded\"></map></div></div></div>");
$templateCache.put("app/storeLocator/storeLocatorMulti.html","<div class=\"store-locator-container\" ng-if=\"storeLocatorCtrl.translatedMessages\"><div class=\"store-locator-title\"><h1>{{ storeLocatorCtrl.heading }}</h1></div><div class=\"alert alert-danger\" role=\"alert\" data-ng-show=\"storeLocatorCtrl.locatorStates.errors\">{{storeLocatorCtrl.locatorStates.errors}}</div><div class=\"alert alert-info\" role=\"alert\" data-ng-show=\"storeLocatorCtrl.locatorStates.notifications\">{{storeLocatorCtrl.notifications}}</div><div id=\"js-breadcrumbs\" class=\"row breadcrumbs\"><div class=\"col-xs-8\"><div class=\"store-locator-crumbs section-breadcrumb\"><span id=\"locator-breadcrumb\" class=\"text-uppercase\"><a href=\"{{ storeLocatorCtrl.languageService.updateLinkUrl(\'site-map\') }}\" title=\"Site Map\" aria-label=\"breadcrumbs\">{{ storeLocatorCtrl.sitemapButton }}</a> | {{storeLocatorCtrl.heading}}</span><h2>{{ storeLocatorCtrl.searchTitle }}</h2></div></div><div class=\"col-xs-4\"><div class=\"clearfix text-right visible-xs\" id=\"filter-map-list\"><button type=\"button\" data-ng-click=\"storeLocatorCtrl.showList = !storeLocatorCtrl.showList\" class=\"btn btn-xs btn-text showList\"><span data-ng-show=\"storeLocatorCtrl.showList\"><i class=\"fa fa-map-o\" aria-hidden=\"true\" data-ng-show=\"storeLocatorCtrl.showIcons\"></i><span class=\"view-text\">{{storeLocatorCtrl.showMapButton}}</span></span> <span data-ng-show=\"!storeLocatorCtrl.showList\"><i class=\"fa fa-list\" aria-hidden=\"true\" data-ng-show=\"storeLocatorCtrl.showIcons\"></i><span class=\"view-text\">{{storeLocatorCtrl.showListButton}}</span></span></button></div></div></div><div class=\"clearfix push-bottom store-locator-content\"><div class=\"col-sm-6 locations-container\" data-ng-class=\"{\'show-list\': storeLocatorCtrl.showList}\"><search-multi data-translated-messages=\"storeLocatorCtrl.translatedMessages\" data-locator-states=\"storeLocatorCtrl.locatorStates\" data-map-obj=\"storeLocatorCtrl.mapObj\" data-is-google-maps-api-loaded=\"isGoogleMapsApiLoaded\"></search-multi><tabs ng-if=\"storeLocatorCtrl.showTabs\" data-locator-states=\"storeLocatorCtrl.locatorStates\" data-map-obj=\"storeLocatorCtrl.mapObj\"></tabs><results-multi ng-if=\"!storeLocatorCtrl.showTabs\" data-translated-messages=\"storeLocatorCtrl.translatedMessages\" data-locator-states=\"storeLocatorCtrl.locatorStates\" data-map-obj=\"storeLocatorCtrl.mapObj\"></results-multi></div><div id=\"global-locations-map-container\" class=\"col-sm-6 locations-map-container\" ng-class=\"{\'show-map\' : !storeLocatorCtrl.showList}\"><map data-translated-messages=\"storeLocatorCtrl.translatedMessages\" data-locator-states=\"storeLocatorCtrl.locatorStates\" data-map-obj=\"storeLocatorCtrl.mapObj\" data-is-google-maps-api-loaded=\"isGoogleMapsApiLoaded\"></map></div></div></div>");
$templateCache.put("app/localLanding/cards/aboutCard.directive.html","<div class=\"push-bottom-xl text-center\"><h3 class=\"bold-500\" ng-if=\"aboutCardCtrl.hasTitle\">{{aboutCardCtrl.title}}</h3><h3 class=\"bold-500\" ng-if=\"!aboutCardCtrl.hasTitle\">About {{ aboutCardCtrl.location.store_info.name }}, {{ aboutCardCtrl.location.store_info.locality }}</h3><p data-ng-bind-html=\"aboutCardCtrl.description\" itemprop=\"description\"></p></div>");
$templateCache.put("app/localLanding/cards/addressBreadcrumbCard.directive.html","<div class=\"address-breadcrumb\" itemscope=\"\" itemtype=\"http://schema.org/BreadcrumbList\"><span ng-if=\"addressBreadcrumbCardC.hasSitemapLevel(\'country\')\" itemprop=\"itemListElement\" itemscope=\"\" itemtype=\"http://schema.org/ListItem\"><a itemprop=\"item\" class=\"text-uppercase\" title=\"{{location.country}}\" href=\"{{ addressBreadcrumbCardC.getSitemapLevelUrl(\'country\') }}\"><span itemprop=\"name\">{{ location.country }}</span></a><meta itemprop=\"position\" content=\"1\"></span> <span ng-if=\"addressBreadcrumbCardC.hasSitemapLevel(\'region\') && location.region\" itemprop=\"itemListElement\" itemscope=\"\" itemtype=\"http://schema.org/ListItem\"><span class=\"breadcrumb-separator\">&nbsp;{{addressBreadcrumbCardC.separator}}&nbsp;</span> <a itemprop=\"item\" class=\"text-uppercase\" title=\"{{location.region}}\" href=\"{{ addressBreadcrumbCardC.getSitemapLevelUrl(\'region\') }}\"><span itemprop=\"name\">{{ location.region}}</span></a><meta itemprop=\"position\" content=\"2\"></span> <span ng-if=\"addressBreadcrumbCardC.hasSitemapLevel(\'locality\') && location.locality\" itemprop=\"itemListElement\" itemscope=\"\" itemtype=\"http://schema.org/ListItem\"><span class=\"breadcrumb-separator\">&nbsp;{{addressBreadcrumbCardC.separator}}&nbsp;</span> <a itemprop=\"item\" title=\"{{location.locality}}\" href=\"{{ addressBreadcrumbCardC.getSitemapLevelUrl(\'locality\') }}\"><span itemprop=\"name\">{{ location.locality }}</span></a><meta itemprop=\"position\" content=\"3\"></span></div>");
$templateCache.put("app/localLanding/cards/addressCard.directive.html","<div class=\"push-bottom-lg address-card\"><div ng-if=\"location.status.toLowerCase() === \'temp closed\'\" class=\"no-margin temp-closed\">This location is temporarily closed</div><meta itemprop=\"name\" content=\"{{addressCardC.storeSEOName}}\"><h1 data-ng-bind-html=\"addressCardC.storeName\" itemprop=\"storeName\" aria-live=\"polite\" class=\"no-margin\"></h1><h3 data-ng-if=\"addressCardC.nameExtendedConfig\" ng-repeat=\"item in addressCardC.nameExtendedConfig track by $index\">{{item}}</h3><h3 data-ng-if=\"addressCardC.nameExtended && !nameExtendedConfig\">{{addressCardC.nameExtended}}</h3><div itemprop=\"address\" itemscope=\"\" itemtype=\"http://schema.org/PostalAddress\"><div class=\"no-bold line-height-bump\" ng-show=\"!addressLink && !addressLinkDesktop\"><span ng-if=\"addressCardC.addressExtended\" itemprop=\"streetAddress\">{{ location.store_info.address }}</span> <span ng-if=\"!addressCardC.addressExtended\" ng-style=\"{\'padding-top\':\'10px\',\'margin-bottom\':\'0px\',\'padding-bottom\':\'0px\'}\" itemprop=\"streetAddress\">{{ location.store_info.address }}</span><br><p ng-if=\"location.store_info.address_extended && addressCardC.showAddressExtended\" ng-style=\"{\'margin-bottom\':\'0px\'}\">{{ location.store_info.address_extended }}</p><span itemprop=\"addressLocality\">{{ location.store_info.locality }}</span>, <span itemprop=\"addressRegion\">{{ location.store_info.region }}</span> <span itemprop=\"postalCode\">{{ location.store_info.postcode }}</span></div><div class=\"no-bold line-height-bump\" ng-show=\"addressLink && !addressLinkDesktop\"><a ng-href=\"{{addressLink}}\" title=\"{{addressLinkTitle}}\" rel=\"noopener\" target=\"_blank\"><span itemprop=\"streetAddress\">{{ location.store_info.address }}<br ng-if=\"location.store_info.address_extended && addressCardC.showAddressExtended\"><span ng-if=\"addressCardC.showAddressExtended\">{{ location.store_info.address_extended }}</span></span><br><span itemprop=\"addressLocality\">{{ location.store_info.locality }}</span>, <span itemprop=\"addressRegion\">{{ location.store_info.region }}</span> <span itemprop=\"postalCode\">{{ location.store_info.postcode }}</span></a></div><div class=\"no-bold line-height-bump\" ng-if=\"!addressLink && addressLinkDesktop\"><a ng-href=\"{{addressLinkDesktop}}\" rel=\"noopener\" target=\"_blank\" class=\"hidden-xs\"><span itemprop=\"streetAddress\">{{ location.store_info.address }}<br ng-if=\"location.store_info.address_extended && addressCardC.showAddressExtended\"><span ng-if=\"addressCardC.showAddressExtended\">{{ location.store_info.address_extended }}</span></span><br><span itemprop=\"addressLocality\">{{ location.store_info.locality }}</span>, <span itemprop=\"addressRegion\">{{ location.store_info.region }}</span> <span itemprop=\"postalCode\">{{ location.store_info.postcode }}</span></a> <span class=\"visible-xs\"><span itemprop=\"streetAddress\">{{ location.store_info.address }}<br ng-if=\"location.store_info.address_extended && addressCardC.showAddressExtended\"><span ng-if=\"addressCardC.showAddressExtended\">{{ location.store_info.address_extended }}</span></span><br><span itemprop=\"addressLocality\">{{ location.store_info.locality }}</span>, <span itemprop=\"addressRegion\">{{ location.store_info.region }}</span> <span itemprop=\"postalCode\">{{ location.store_info.postcode }}</span></span></div><div ng-if=\"addressCardC.showPhone\" ng-class=\"{\'visible-xs\': !addressCardC.phoneAlwaysClickable}\"><a ng-href=\"tel:{{ location.store_info.phone }}\" analytics-event=\"Call\" analytics-label=\"{{ location | labelizeLocation }}\" analytics-category=\"LLP\" analytics-value=\"1\" analytics-on=\"click\" aria-label=\"telephone number\" title=\"Call\">{{ location.store_info.phone | telephone}}</a></div><div ng-if=\"!addressCardC.phoneAlwaysClickable && addressCardC.showPhone\" class=\"hidden-xs tel-number\" itemprop=\"telephone\"><span ng-if=\"addressCardC.mainPhoneTitle\">{{ addressCardC.mainPhoneTitle }}</span>{{ location.store_info.phone | telephone}}</div><div ng-if=\"addressCardC.altPhone && addressCardC.showPhone\" ng-class=\"{\'visible-xs\': !addressCardC.phoneAlwaysClickable}\"><a ng-href=\"tel:{{ addressCardC.altPhone }}\" analytics-event=\"Call\" analytics-label=\"{{ location | labelizeLocation }}\" analytics-category=\"LLP\" analytics-value=\"1\" analytics-on=\"click\" title=\"Call\">{{ addressCardC.altPhone | telephone}}</a></div><div class=\"hidden-xs tel-number\" itemprop=\"telephone\" ng-if=\"!addressCardC.phoneAlwaysClickable && addressCardC.altPhoneTitle && addressCardC.showPhone\"><span>{{ addressCardC.altPhoneTitle }}</span>{{ addressCardC.altPhone | telephone}}</div></div><span itemprop=\"geo\" itemscope=\"\" itemtype=\"http://schema.org/GeoCoordinates\"><meta itemprop=\"latitude\" content=\"{{ location.store_info.latitude }}\"><meta itemprop=\"longitude\" content=\"{{ location.store_info.longitude }}\"></span><partner-reviews-card ng-if=\"!hideReviews\" location=\"location\" partnertype=\"custom\"></partner-reviews-card><div class=\"push-top flex-buttons-nap\"><a ng-if=\"addressCardC.showGetDirections\" href=\"{{addressCardC.directionsUrl}}\" rel=\"noopener\" target=\"{{addressCardC.getDirectionsTarget}}\" class=\"btn btn-primary get-directions\" analytics-event=\"Get Directions\" analytics-label=\"{{ location | labelizeLocation }}\" analytics-category=\"LLP\" analytics-value=\"1\" analytics-on=\"click\" title=\"Get Directions\">Get Directions</a> <a ng-if=\"showCallButton\" href=\"tel:{{ location.store_info.phone }}\" rel=\"noopener\" target=\"_blank\" class=\"btn btn-primary\" analytics-event=\"Call\" analytics-label=\"{{ location | labelizeLocation }}\" analytics-category=\"LLP\" analytics-value=\"1\" analytics-on=\"click\" title=\"Call\">Call</a> <a ng-show=\"addressCardC.menuLink\" ng-href=\"{{addressCardC.menuLink.data}}\" rel=\"noopener\" target=\"_blank\" title=\"View the Menu\" class=\"btn btn-primary push-left-xs\" analytics-event=\"View the Menu\" analytics-label=\"{{ location | labelizeLocation }}\" analytics-category=\"LLP\" analytics-value=\"1\" analytics-on=\"click\">View the Menu</a><delivery-modal-card button-class=\"btn btn-primary delivery-modal\" location=\"location\" extended-delivery=\"deliveryModalExtendedDelivery\"></delivery-modal-card><a ng-show=\"addressCardC.customButtonLink\" ng-href=\"{{addressCardC.customButtonLink.data}}\" rel=\"noopener\" target=\"{{addressCardC.customButtonFieldTarget}}\" class=\"btn btn-primary custom-button\" analytics-event=\"{{addressCardC.customButtonText}}\" analytics-label=\"{{ location | labelizeLocation }}\" analytics-category=\"LLP\" analytics-value=\"1\" analytics-on=\"click\" title=\"{{addressCardC.customButtonText}}\">{{addressCardC.customButtonText}}</a> <a ng-show=\"addressCardC.customButton2Link\" ng-href=\"{{addressCardC.customButton2Link.data}}\" rel=\"noopener\" target=\"_blank\" class=\"btn btn-primary custom-button\" analytics-event=\"{{addressCardC.customButton2Text}}\" analytics-label=\"{{ location | labelizeLocation }}\" analytics-category=\"LLP\" analytics-value=\"1\" analytics-on=\"click\" title=\"{{addressCardC.customButton2Text}}\">{{addressCardC.customButton2Text}}</a></div></div>");
$templateCache.put("app/localLanding/cards/amenitiesCard.directive.html","<div class=\"amenities-card\" ng-if=\"amenitiesCardController.hasAmenities\"><div class=\"push-bottom\" ng-show=\"!amenitiesCardController.displayInOneLine\"><h3 class=\"title\">{{amenitiesCardController.title}}</h3></div><div class=\"amenities-with-no-icons\" ng-show=\"!amenitiesCardController.displayInOneLine && amenitiesCardController.amenitiesWithNoIcons.length\"><ul class=\"amenities-list\"><li ng-repeat=\"amenity in amenitiesCardController.amenitiesWithNoIcons\" class=\"push-bottom amenity\"><div class=\"amenity-with-no-icon\"><span>&bull; <span data-ng-bind-html=\"amenity.nameAmenity\"></span></span></div></li></ul></div><div class=\"amenities-with-icons\" ng-show=\"!amenitiesCardController.displayInOneLine && amenitiesCardController.amenitiesWithIcons.length\"><ul class=\"amenities-list\"><li ng-repeat=\"amenity in amenitiesCardController.amenitiesWithIcons\" class=\"push-bottom amenity\"><div class=\"amenity-with-icon\"><div class=\"image-container\"><img ng-if=\"!amenitiesCardController.defaultImage\" ng-src=\"/assets/images/clients/{{amenitiesCardController.client}}/{{amenity.name}}.png\" alt=\"{{amenity.tooltip}}\" title=\"{{amenity.tooltip}}\" data-at2x=\"/assets/images/clients/{{amenitiesCardController.client}}/{{amenity.name}}@2x.png\"> <img ng-if=\"amenitiesCardController.defaultImage\" ng-src=\"/assets/images/clients/{{amenitiesCardController.client}}/service_default.png\" alt=\"{{amenity.tooltip}}\" title=\"{{amenity.tooltip}}\" data-at2x=\"/assets/images/clients/{{amenitiesCardController.client}}/service_default.png\"></div><span data-ng-bind-html=\"amenity.nameAmenity\"></span></div></li></ul></div><div ng-show=\"amenitiesCardController.displayInOneLine\"><span class=\"title\">{{amenitiesCardController.title}}:</span> <span data-ng-bind-html=\"amenity.nameAmenity\" class=\"amenity\" ng-repeat=\"amenity in amenitiesCardController.amenities\"></span></div></div>");
$templateCache.put("app/localLanding/cards/buttonCard.directive.html","<a ng-show=\"buttonCardC.button\" ng-href=\"{{buttonCardC.buttonLink}}\" rel=\"noopener\" ng-target=\"{{buttonCardC.target}}\" data-analytics-label=\"{{ buttonCardC.location | labelizeLocation }}\" data-analytics-category=\"{{ buttonCardC.visibility }}\" data-analytics-event=\"{{ buttonCardC.customEvent || buttonCardC.buttonText }}\" data-analytics-on=\"click\" data-analytics-value=\"1\" aria-label=\"{{buttonCardC.ariaLabel}}\"><span class=\"button-text\">{{ buttonCardC.buttonText }}</span> <span class=\"transclude\"></span></a>");
$templateCache.put("app/localLanding/cards/carouselMenu.directive.html","<div class=\"carousel-menu-container\"><uib-carousel><uib-slide ng-repeat=\"slide in carouselMenuC.slides\" active=\"slide.active\" index=\"$index\"><div class=\"carousel-title-container\"><h2 class=\"carousel-title\" ng-bind-html=\"slide.slide_title\"></h2></div><div ng-repeat=\"card in slide.items\"><div class=\"col-md-4\"><div class=\"carousel-card-title-container\"><h3 class=\"carousel-card-title\" ng-bind-html=\"card.title\"></h3></div><div class=\"carousel-card-img-container\"><img class=\"carousel-card-img\" ng-src=\"{{card.image_url}}\" alt=\"\" role=\"presentation\"></div><div class=\"carousel-card-text-container\"><p class=\"carousel-card-text\" ng-bind-html=\"card.text\"></p></div><div class=\"carousel-card-btn-wrapper\" ng-if=\"card.link_text\"><a ng-href=\"card.link_url\" class=\"btn btn-secondary\">{{card.link_text}}</a></div></div></div></uib-slide></uib-carousel></div>");
$templateCache.put("app/localLanding/cards/customFieldsButton.directive.html","<a ng-href=\"{{customFieldsButtonC.link}}\" ng-show=\"customFieldsButtonC.link\" title=\"{{customFieldsButtonC.title}}\" rel=\"noopener\" target=\"{{customFieldsButtonC.buttonTarget}}\" class=\"btn btn-background dib\"><p class=\"bannerText\" data-ng-bind-html=\"customFieldsButtonC.buttonText\"></p></a>");
$templateCache.put("app/localLanding/cards/delivery.modal.html","<div class=\"modal\" aria-model=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\" tabindex=\"-1\"><div class=\"modal-header\"><h4 class=\"modal-title\">{{ deliveryModalCardCtrl.modalTitle }}</h4></div><div class=\"modal-body\"><ul><li ng-repeat=\"link in links\"><div class=\"col-3-lg col-3-md col-3-sm col-3-xs text-center link delivery-links\"><a ng-href=\"{{link}}\" target=\"_blank\" analytics-event=\"Delivery Services - {{ labels[links.indexOf(link)] }}\" analytics-label=\"{{ deliveryModalCardCtrl.location | labelizeLocation }}\" analytics-category=\"{{deliveryModalCardCtrl.pageCategory}}\" analytics-value=\"1\" analytics-on=\"click\"><img ng-src=\"{{logos[links.indexOf(link)]}}\" id=\"{{ labels[links.indexOf(link)] }}\" alt=\"{{ labels[links.indexOf(link)] }}\"></a></div></li></ul></div><button role=\"button\" id=\"delivery-modal-close\" ng-keypress=\"deliveryModalCardCtrl.closeModal($event)\">Close</button></div></div></div>");
$templateCache.put("app/localLanding/cards/deliveryModalCard.directive.html","<span ng-show=\"deliveryModalCardCtrl.validDelivery\"><a ng-if=\"!deliveryModalCardCtrl.extendedDelivery\" ng-class=\"deliveryModalCardCtrl.buttonClass || \'btn btn-primary\'\" type=\"button\" rel=\"noopener\" title=\"Order Online\" target=\"_blank\" ng-href=\"{{ deliveryModalCardCtrl.link }}\" analytics-event=\"Delivery Services Modal\" analytics-label=\"{{ deliveryModalCardCtrl.location | labelizeLocation }}\" analytics-category=\"{{deliveryModalCardCtrl.pageCategory}}\" analytics-value=\"1\" analytics-on=\"click\" data-sf-analytics-event=\"{{deliveryModalCardCtrl.text}}\">{{deliveryModalCardCtrl.text}}</a> <a ng-if=\"deliveryModalCardCtrl.extendedDelivery\" ng-class=\"deliveryModalCardCtrl.buttonClass || \'btn btn-primary\'\" type=\"button\" title=\"Order Online\" role=\"button\" tabindex=\"0\" ng-click=\"deliveryModalCardCtrl.showModal()\" ng-keypress=\"deliveryModalCardCtrl.keypressShowModal($event)\" analytics-event=\"Delivery Services Modal\" analytics-label=\"{{ deliveryModalCardCtrl.location | labelizeLocation }}\" analytics-category=\"{{deliveryModalCardCtrl.pageCategory}}\" analytics-value=\"1\" analytics-on=\"click\" data-sf-analytics-event=\"{{deliveryModalCardCtrl.text}}\">{{deliveryModalCardCtrl.text}}</a></span>");
$templateCache.put("app/localLanding/cards/errorCard.directive.html","<div class=\"container\"><div class=\"row\" ng-show=\"localLanding.error\"><div class=\"col-lg-12 col-md-12 col-sm-12\"><h2 id=\"errorPageh1\">{{ errorCardC.errorHeading }}</h2><hr><div class=\"store-locator-breadcrumb\"><span><a href=\"{{errorCardC.languageService.updateLinkUrl(errorCardC.customLocator || \'/\')}}\"><span class=\"less-than\">&lt;</span> {{ errorCardC.backButton }}</a></span></div><br><br><h4>{{ errorCardC.errorLine1 }}</h4><h4 ng-show=\"errorCardC.nearbyLocationsFlag\">{{ errorCardC.errorLine2 }}</h4><div data-ng-repeat=\"loc in errorCardC.location\"><a href=\"{{errorCardC.languageService.updateLinkUrl(loc.llp_url)}}\">{{loc.store_info.address}}</a> <span ng-if=\"errorCardC.auto_redirect\">( {{ errorCardC.errorRedirect }}. . . . . )</span></div><br><br><div ng-if=\"!errorCardC.storeFindersMessages\">Try <a style=\"font-style: italic;\" href=\"{{errorCardC.languageService.updateLinkUrl(errorCardC.customLocator || \'/\')}}\">searching</a> for the location.</div><div ng-if=\"errorCardC.storeFindersMessages\"><a style=\"font-style: italic;\" href=\"{{errorCardC.languageService.updateLinkUrl(errorCardC.customLocator || \'/\')}}\">{{ errorCardC.errorLine3 }}</a></div><hr></div></div><div class=\"row\"><div class=\"mf-route-loader mf-large-loader\" ng-show=\"!localLanding.error\"><i id=\"newLoaderIcon\" class=\"ico ico-spinner ico-spin\"></i></div></div></div>");
$templateCache.put("app/localLanding/cards/fatBrandsHoursCard.directive.html","<div class=\"hours-card\" ng-show=\"fatBrandsHoursCardC.locHours || fatBrandsHoursCardC.specialHours || fatBrandsHoursCardC.hoursNote\"><h2 class=\"hours-title\"><i class=\"ico ico-clock\"></i>&nbsp;Hours</h2><p ng-if=\"fatBrandsHoursCardC.locHours || fatBrandsHoursCardC.specialHours\" class=\"hours-status bold-500 push-top push-bottom\"><i ng-class=\"{\'opened\': !fatBrandsHoursCardC.closedNow , \'closed\': fatBrandsHoursCardC.closedNow}\" class=\"ico ico-clock\"></i> <span ng-if=\"fatBrandsHoursCardC.comingSoon\" ng-class=\"{\'inline\': fatBrandsHoursCardC.simplified}\"><span class=\"closed-store\">{{fatBrandsHoursCardC.comingSoon}}</span></span> <span ng-if=\"fatBrandsHoursCardC.closed24 && !fatBrandsHoursCardC.comingSoon\" ng-class=\"{\'inline\': fatBrandsHoursCardC.simplified}\"><span class=\"closed-store\">Closed Today</span></span> <span ng-if=\"!fatBrandsHoursCardC.closed24 && fatBrandsHoursCardC.closedNow\" ng-class=\"{\'inline\': fatBrandsHoursCardC.simplified}\"><span class=\"closed-store\">Closed Now</span><span ng-if=\"!fatBrandsHoursCardC.simplified\">Today\'s hours: <span>{{fatBrandsHoursCardC.openTimePeriod_0}}</span> - <span>{{fatBrandsHoursCardC.closeTimePeriod_0}}</span>&nbsp;</span></span> <span ng-if=\"!fatBrandsHoursCardC.simplified && !fatBrandsHoursCardC.closed24 && fatBrandsHoursCardC.closedNow && fatBrandsHoursCardC.openTimePeriod_1\"><span>{{fatBrandsHoursCardC.openTimePeriod_1}}</span> - <span>{{fatBrandsHoursCardC.closeTimePeriod_1}}</span></span> <span ng-if=\"!fatBrandsHoursCardC.closed24 && !fatBrandsHoursCardC.closedNow && !fatBrandsHoursCardC.open24 && !fatBrandsHoursCardC.customText && !fatBrandsHoursCardC.tempClosed\" class=\"opened-store\" ng-class=\"{\'inline\': fatBrandsHoursCardC.simplified}\">Open Until {{fatBrandsHoursCardC.closeToday}}</span> <span ng-if=\"fatBrandsHoursCardC.customText\" class=\"fatBrandsHoursCardC-customText\" ng-class=\"{\'inline\': fatBrandsHoursCardC.simplified}\">{{fatBrandsHoursCardC.customTextShow}}</span> <span ng-if=\"!fatBrandsHoursCardC.closed24 && fatBrandsHoursCardC.open24\" class=\"opened-store\" ng-class=\"{\'inline\': fatBrandsHoursCardC.simplified}\">Open 24 Hours</span> <span class=\"collapse-icon show-on-mobile\" ng-if=\"fatBrandsHoursCardC.collapsibleOn === \'mobile\'\" ng-click=\"fatBrandsHoursCardC.toggleCollapsibleHours()\"><i class=\"fa fa-chevron-up\"></i></span> <span class=\"collapse-icon hide-on-mobile\" ng-if=\"fatBrandsHoursCardC.collapsibleOn === \'desktop\'\" ng-click=\"fatBrandsHoursCardC.toggleCollapsibleHours()\"><i class=\"fa fa-chevron-up\"></i></span> <span class=\"collapse-icon show-on-mobile show-on-desktop\" ng-if=\"fatBrandsHoursCardC.collapsibleOn === \'all\'\" ng-click=\"fatBrandsHoursCardC.toggleCollapsibleHours()\"><i class=\"fa fa-chevron-up\"></i></span></p><div ng-class=\"{\'collapse-mobile\': fatBrandsHoursCardC.collapsibleOn === \'mobile\', \'collapse-desktop\': fatBrandsHoursCardC.collapsibleOn === \'desktop\', \'collapse-all\': fatBrandsHoursCardC.collapsibleOn === \'all\'}\" class=\"collapsible show\"><div class=\"hours-body\" ng-if=\"fatBrandsHoursCardC.locHours\"><dl class=\"dl-horizontal\" ng-if=\"!fatBrandsHoursCardC.onlyToday\" itemprop=\"openingHours\" content=\"{{fatBrandsHoursCardC.openingHours}}\"><dt ng-repeat-start=\"(day,hours) in fatBrandsHoursCardC.locHours\" ng-class=\"hours.highlightClass\"><span>{{hours.dayName}}</span></dt><dd ng-if=\"hours.highlightClass\"><div class=\"hours-column margin-left-day-hours\"><span ng-class=\"hours.highlightClass\" ng-if=\"!hours.closed\">{{fatBrandsHoursCardC.getOpenTimePeriodDisplayMessage(hours)}}</span> <span ng-class=\"hours.highlightClass\" ng-if=\"hours.closed\">{{hours.closedLabel}}</span></div></dd><dd ng-if=\"!hours.highlightClass\" ng-repeat-end=\"\" ng-repeat=\"i in hours.numberOfTimeFragments track by $index\" class=\"hours-location\"><div class=\"hours-column margin-left-day-hours\"><span ng-class=\"hours.highlightClass\" ng-if=\"!hours.closed && !hours.open24\">{{fatBrandsHoursCardC.getOpenTimePeriodDisplayMessage(hours, $index)}}</span> <span ng-class=\"hours.highlightClass\" ng-if=\"hours.open24\">Open 24 Hours</span> <span ng-class=\"hours.highlightClass\" ng-if=\"hours.closed\">{{hours.closedLabel}}</span></div></dd></dl></div><div class=\"hours-note\" ng-if=\"fatBrandsHoursCardC.hoursNote\">* {{ fatBrandsHoursCardC.hoursNote.data }}</div><div ng-if=\"fatBrandsHoursCardC.specialHours && !fatBrandsHoursCardC.tempClosed\" class=\"specialHours\"><p class=\"bold-500 push-top push-bottom\" id=\"specialHours\"><i ng-class=\"{\'opened\': !fatBrandsHoursCardC.closedNow , \'closed\': fatBrandsHoursCardC.closedNow}\" class=\"ico ico-clock\"></i> Special Hours</p><dl class=\"dl-horizontal special-hours-title\" itemprop=\"openingHoursSpecification\" itemscope=\"\" itemtype=\"http://schema.org/OpeningHoursSpecification\"><dt ng-repeat-start=\"(day,hours) in fatBrandsHoursCardC.specialHours\" ng-class=\"hours.highlightClass\"><span itemprop=\"validFrom validThrough\" datetime=\"{{hours.dayNameShort}}\">{{hours.dayNameShort}}</span></dt><dd ng-if=\"hours.highlightClass\"><span ng-class=\"hours.highlightClass\" ng-if=\"!hours.closed\">{{fatBrandsHoursCardC.getOpenTimePeriodDisplayMessage(hours)}}</span> <span ng-class=\"hours.highlightClass\" ng-if=\"hours.closed\" itemprop=\"closes\">Closed</span></dd><dd ng-if=\"!hours.highlightClass\" ng-repeat-end=\"\" ng-repeat=\"i in hours.numberOfTimeFragments track by $index\"><span ng-class=\"hours.highlightClass\" ng-if=\"!hours.closed && !hours.open24\">{{fatBrandsHoursCardC.getOpenTimePeriodDisplayMessage(hours, $index)}}</span> <span ng-class=\"hours.highlightClass\" ng-if=\"hours.open24\" itemprop=\"opens\" content=\"12:00 AM\">Open 24 Hours</span> <span ng-class=\"hours.highlightClass\" ng-if=\"hours.closed\" itemprop=\"closes\" content=\"12:00 AM\">Closed</span></dd></dl></div></div></div>");
$templateCache.put("app/localLanding/cards/fatBrandsMenuCard.directive.html","<section class=\"menu-card\" ng-show=\"fatBrandsMenuCardController.menu && fatBrandsMenuCardController.menu.length > 0\"><header><h2 ng-if=\"fatBrandsMenuCardController.customHeader\">{{ fatBrandsMenuCardController.customHeader }}</h2><h2 ng-if=\"!fatBrandsMenuCardController.customStoreName && !fatBrandsMenuCardController.customHeader\">{{fatBrandsMenuCardController.storeName + \' \' + fatBrandsMenuCardController.storeInfo.locality}}</h2><h2 ng-if=\"fatBrandsMenuCardController.customStoreName\">{{fatBrandsMenuCardController.customStoreNameData }}</h2><span>{{fatBrandsMenuCardController.address}}</span></header><div class=\"menu-content\" scrolling-tabs-wrapper=\"\" watch-tabs=\"fatBrandsMenuCardController.menu\" style=\"overflow:hidden;\"><tabset id=\"tabset\"><tab ng-repeat=\"category in fatBrandsMenuCardController.menu\" active=\"category.active\" heading=\"{{category.categoryName}}\"><div role=\"tabpanel\" class=\"content\"><ul class=\"menu-options\"><li ng-repeat=\"option in category.options\" class=\"option\"><div class=\"menu-option clearfix\"><div class=\"image\" ng-if=\"fatBrandsMenuCardController.showImage && option.photo\"><img ng-src=\"{{option.photo}}\" data-at2x=\"{{option.photo}}\" alt=\"{{option.name}} photo\" width=\"100%\"></div><div class=\"details\"><div class=\"price\"><span ng-if=\"option.price.amount && option.price.currencyCode == \'USD\'\">$</span>{{option.price.amount}}</div><div class=\"name\">{{option.name}}</div><div class=\"description\"><span>{{option.description.text}}</span><span ng-show=\"option.description.truncated\">...</span><a href=\"\" ng-click=\"option.description.truncated = false\" class=\"more\" ng-show=\"option.description.truncated\" title=\"More about {{ option.name }}\">More</a><span ng-show=\"!option.description.truncated\">{{option.description.truncatedText}}</span></div></div></div></li><li class=\"show-more\" ng-if=\"fatBrandsMenuCardController.initMenuItemsShown && category.options.length > fatBrandsMenuCardController.initMenuItemsShown\"><a ng-click=\"fatBrandsMenuCardController.numItemsToggle()\">{{ fatBrandsMenuCardController.showMoreLessText }}</a></li></ul></div></tab></tabset></div><div class=\"bottom-link\" ng-show=\"fatBrandsMenuCardController.link\"><i class=\"fa fa-arrow-circle-right custom\"></i> <a ng-href=\"{{fatBrandsMenuCardController.link}}\" title=\"{{fatBrandsMenuCardController.linkText}}\" target=\"_blank\" rel=\"noopener\">{{fatBrandsMenuCardController.linkText}}</a></div></section>");
$templateCache.put("app/localLanding/cards/fbWidgetCard.directive.html","<div class=\"fb-widget-card\" ng-show=\"fbWidgetCardC.fbProviderUrl\"><div class=\"border-bottom push-bottom clearfix\"><div class=\"pull-left\"><h2 id=\"facebook-heading\" tabindex=\"0\">Like us on Facebook</h2></div><div class=\"pull-right mf-social-icons single\"><a itemprop=\"sameAs\" class=\"btn btn-provider facebook-color\" data-sf-analytics-event=\"Facebook icon\" ng-href=\"{{fbWidgetCardC.fbProviderUrl}}\" target=\"_blank\" rel=\"noopener\" ng-attr-title=\"{{clientName ? clientName : \'Like us\'}} on Facebook\" aria-label=\"Facebook Button\" tabindex=\"0\"><i class=\"ico ico-facebook\"></i></a></div></div><div class=\"fb-widget-container push-bottom-lg\"><div class=\"fb-page\" data-href=\"{{fbWidgetCardC.fbProviderUrl}}\" data-tabs=\"timeline\" data-width=\"\" data-height=\"\" data-small-header=\"false\" data-adapt-container-width=\"true\" data-hide-cover=\"false\" data-show-facepile=\"true\"><blockquote cite=\"{{fbWidgetCardC.fbProviderUrl}}\" class=\"fb-xfbml-parse-ignore\"><a href=\"{{fbWidgetCardC.fbProviderUrl}}\" rel=\"noopener\">{{client_name}}</a></blockquote></div></div></div>");
$templateCache.put("app/localLanding/cards/hoursAdditionalCard.directive.html","<div class=\"hours-card hours-additional\"><h4 class=\"no-bold text-primary push-bottom\"><div ng-if=\"hoursAddCardC.hasPrimary || hoursAddCardC.hasPrimarySpecial\"><span>{{hoursAddCardC.titlePrimary}}:</span> <span ng-if=\"hoursAddCardC.closed24\"><span class=\"closed-store\">Closed Today</span></span> <span ng-if=\"!hoursAddCardC.closed24 && hoursAddCardC.closedNow\"><span class=\"closed-store\">Closed Now</span>Today\'s hours: <span>{{hoursAddCardC.openTimePeriod_0}}</span> - <span>{{hoursAddCardC.closeTimePeriod_0}}</span></span>&nbsp; <span ng-if=\"!hoursAddCardC.closed24 && hoursAddCardC.closedNow && hoursAddCardC.openTimeSecondPeriod\"><span>&&</span><span>{{hoursAddCardC.openTimePeriod_1}}</span> - <span>{{hoursAddCardC.closeTimePeriod_1}}</span></span> <span ng-if=\"!hoursAddCardC.closed24 && !hoursAddCardC.open24 && !hoursAddCardC.closedNow\" class=\"opened-store\">Open Until {{hoursAddCardC.closeToday}}</span> <span ng-if=\"!hoursAddCardC.closed24 && hoursAddCardC.open24\" class=\"opened-store\">Open 24 Hours</span></div></h4><h4 class=\"no-bold text-primary push-bottom\"><div ng-if=\"hoursAddCardC.hasAdditional || hoursAddCardC.hasAdditionalSpecial\"><span>{{hoursAddCardC.titleAdditional}}:</span> <span ng-if=\"hoursAddCardC.closed24Additional\"><span class=\"closed-store\">Closed Today</span></span> <span ng-if=\"!hoursAddCardC.closed24Additional && hoursAddCardC.closedNowAdditional\"><span class=\"closed-store\">Closed Now</span>Today\'s hours: <span>{{hoursAddCardC.openTodayAdditional}}</span> - <span>{{hoursAddCardC.closeTodayAdditional}}</span></span> <span ng-if=\"!hoursAddCardC.closed24Additional && !hoursAddCardC.open24Additional && !hoursAddCardC.closedNowAdditional\" class=\"opened-store\">Open Until {{hoursAddCardC.closeTodayAdditional}}</span> <span ng-if=\"!hoursAddCardC.closed24Additional && hoursAddCardC.open24Additional\" class=\"opened-store\">Open 24 Hours</span></div></h4><dl class=\"dl-horizontal\" itemprop=\"openingHours\" content=\"{{hoursAddCardC.openingHours}}\"><dt></dt><dd class=\"display-small\"><div ng-if=\"hoursAddCardC.hasPrimary && hoursAddCardC.hasAdditional\" class=\"hours-column dib push-right-xs bold-700\"><span>{{hoursAddCardC.titlePrimary}}</span></div><div ng-if=\"hoursAddCardC.hasAdditional\" class=\"hours-column dib bold-700 align-small-screen\"><span>{{hoursAddCardC.titleAdditional}}</span></div></dd><dt ng-repeat-start=\"(day,hours) in hoursAddCardC.regularHours\" ng-class=\"[hours.regular.highlightClass, hours.additional.highlightClass]\" class=\"text-overflow\">{{day}}</dt><dd ng-if=\"hours.regular.highlightClass || hours.additional.highlightClass\" class=\"display-small\"><div ng-if=\"hoursAddCardC.isUsedForPrimaryRegularHours && hours.regular\" class=\"hours-column dib push-right-xs open-close-align\"><span class=\"hours-column\" ng-class=\"hours.regular.highlightClass\" ng-if=\"!hours.regular.closed && !hours.regular.open24\">{{hoursAddCardC.getOpenTimePeriodDisplayMessage(hours.regular)}}</span> <span class=\"hours-column\" ng-class=\"hours.regular.highlightClass\" ng-if=\"hours.regular.closed\">{{hours.regular.closedLabel}}</span> <span class=\"hours-column\" ng-class=\"hours.regular.highlightClass\" ng-if=\"hours.regular.open24\">Open 24 Hours</span></div><div ng-if=\"hours.additional\" class=\"hours-column dib align-small-screen\"><span class=\"hours-column\" ng-class=\"hours.additional.highlightClass\">{{hoursAddCardC.getOpenTimePeriodDisplayMessage(hours.additional) || hours.additional.closedLabel}}</span></div></dd><dd ng-if=\"!hours.regular.highlightClass && !hours.additional.highlightClass\" ng-repeat-end=\"\" ng-repeat=\"i in hours.regular.numberOfTimeFragments track by $index\" class=\"display-small\"><div ng-if=\"hoursAddCardC.isUsedForPrimaryRegularHours && !hours.regular.highlightClass\" class=\"hours-column dib push-right-xs open-close-align\"><span ng-class=\"hours.regular.highlightClass\" ng-if=\"!hours.regular.closed && !hours.regular.open24\" itemprop=\"openingHours\" content=\"{{hoursAddCardC.getOpenTimePeriodDisplayMessage(hours.regular, $index)}}\">{{hoursAddCardC.getOpenTimePeriodDisplayMessage(hours.regular, $index)}}</span> <span ng-class=\"hours.regular.highlightClass\" ng-if=\"hours.regular.open24\">Open 24 Hours</span> <span ng-class=\"hours.regular.highlightClass\" ng-if=\"hours.regular.closed\">{{hours.regular.closedLabel}}</span></div><div ng-if=\"hours.additional && !hours.additional.highlightClass\" class=\"hours-column dib align-small-screen\"><span ng-class=\"hours.regular.highlightClass\" ng-if=\"!hours.additional.closed && !hours.additional.open24\" itemprop=\"openingHours\" content=\"{{hoursAddCardC.getOpenTimePeriodDisplayMessage(hours.additional, $index)}}\">{{hoursAddCardC.getOpenTimePeriodDisplayMessage(hours.additional, $index)}}</span> <span ng-class=\"hours.regular.highlightClass\" ng-if=\"hours.additional.open24\">Open 24 Hours</span> <span ng-class=\"hours.regular.highlightClass\" ng-if=\"hours.additional.closed\">{{hours.additional.closedLabel}}</span></div></dd></dl><h4 ng-if=\"hoursAddCardC.specialHours\" class=\"no-bold text-primary push-bottom\"><span>Special Hours</span></h4><dl ng-if=\"hoursAddCardC.specialHours\" class=\"dl-horizontal\" itemprop=\"openingHoursSpecification\" itemscope=\"\" itemtype=\"http://schema.org/OpeningHoursSpecification\"><dt></dt><dd><div class=\"hours-column dib push-right-xs bold-700\"><span>{{hoursAddCardC.titlePrimary}}</span></div><div class=\"hours-column dib bold-700\"><span>{{hoursAddCardC.titleAdditional}}</span></div></dd><dt ng-repeat-start=\"(day,hours) in hoursAddCardC.specialHours\" ng-class=\"[hours.regular.highlightClass, hours.additional.highlightClass]\" class=\"text-overflow\"><span itemprop=\"validFrom validThrough\" datetime=\"{{day}}\">{{day}}</span></dt><dd ng-repeat-end=\"\"><div ng-if=\"hours.regular || hours.additional\" class=\"hours-column dib push-right-xs\"><span ng-if=\"!hours.regular && hours.additional\">Regular Hours ({{hoursAddCardC.getStandardRegHours(hours.additional.dayOfTheWeek)}})</span> <span ng-class=\"hours.regular.highlightClass\" ng-if=\"hours.regular && !hours.regular.open24 && !hours.regular.closed\" itemprop=\"openingHours\" content=\"{{hours.regular.openDisplayTime}}\">{{hours.regular.openDisplayTime}} - {{hours.regular.closeDisplayTime}}</span> <span ng-class=\"hours.regular.highlightClass\" ng-if=\"hours.regular.open24\" itemprop=\"opens\" content=\"12:00 AM\">Open 24 Hours</span> <span ng-class=\"hours.regular.highlightClass\" ng-if=\"hours.regular.closed\" itemprop=\"closes\" content=\"12:00 AM\">{{hours.regular.closedLabel}}</span></div><div ng-if=\"hours.regular || hours.additional\" class=\"hours-column dib\"><span ng-if=\"hours.regular && !hours.additional\">Regular Hours ({{hoursAddCardC.getStandardAddtlHours(hours.regular.dayOfTheWeek)}})</span> <span ng-class=\"hours.additional.highlightClass\" ng-if=\"hours.additional && !hours.additional.closed && !hours.additional.open24\">{{hours.additional.openDisplayTime}} - {{hours.additional.closeDisplayTime}}</span> <span ng-class=\"hours.additional.highlightClass\" ng-if=\"hours.additional.open24\">Open 24 Hours</span> <span ng-class=\"hours.additional.highlightClass\" ng-if=\"hours.additional.closed\">{{hours.additional.closedLabel}}</span></div></dd></dl><div class=\"hours-note\" ng-if=\"hoursAddCardC.hoursNote\">* {{ hoursAddCardC.hoursNote.data }}</div></div>");
$templateCache.put("app/localLanding/cards/hoursCard.directive.html","<div class=\"hours-card\" ng-show=\"hoursCardC.locHours || hoursCardC.specialHours || hoursCardC.hoursNote\"><h2 class=\"hours-title\"><i class=\"ico ico-clock\"></i>&nbsp;Hours</h2><p ng-if=\"hoursCardC.locHours || hoursCardC.specialHours\" class=\"bold-500 push-top push-bottom\"><i ng-class=\"{\'opened\': !hoursCardC.closedNow , \'closed\': hoursCardC.closedNow}\" class=\"ico ico-clock\" aria-hidden=\"true\"></i> <span ng-if=\"hoursCardC.comingSoon\" ng-class=\"{\'inline\': hoursCardC.simplified}\"><span class=\"closed-store\">{{hoursCardC.comingSoon}}</span></span> <span ng-if=\"hoursCardC.closed24 && !hoursCardC.comingSoon\" ng-class=\"{\'inline\': hoursCardC.simplified}\"><span class=\"closed-store\">Closed Today</span></span> <span ng-if=\"!hoursCardC.closed24 && hoursCardC.closedNow\" ng-class=\"{\'inline\': hoursCardC.simplified}\"><span class=\"closed-store\">Closed Now</span><span ng-if=\"!hoursCardC.simplified\">Today\'s hours: <span>{{hoursCardC.openTimePeriod_0}}</span> - <span>{{hoursCardC.closeTimePeriod_0}}</span>&nbsp;</span></span> <span ng-if=\"!hoursCardC.simplified && !hoursCardC.closed24 && hoursCardC.closedNow && hoursCardC.openTimePeriod_1\"><span>{{hoursCardC.openTimePeriod_1}}</span> - <span>{{hoursCardC.closeTimePeriod_1}}</span></span> <span ng-if=\"!hoursCardC.closed24 && !hoursCardC.closedNow && !hoursCardC.open24 && !hoursCardC.customText && !hoursCardC.tempClosed\" class=\"opened-store\" ng-class=\"{\'inline\': hoursCardC.simplified}\">Open Until {{hoursCardC.closeToday}}</span> <span ng-if=\"hoursCardC.customText\" class=\"hoursCardC-customText\" ng-class=\"{\'inline\': hoursCardC.simplified}\">{{hoursCardC.customTextShow}}</span> <span ng-if=\"!hoursCardC.closed24 && hoursCardC.open24\" class=\"opened-store\" ng-class=\"{\'inline\': hoursCardC.simplified}\">Open 24 Hours</span> <span class=\"collapse-icon show-on-mobile\" ng-if=\"hoursCardC.collapsibleOn === \'mobile\'\" ng-click=\"hoursCardC.toggleCollapsibleHours()\"><i class=\"fa fa-chevron-up\"></i></span> <span class=\"collapse-icon hide-on-mobile\" ng-if=\"hoursCardC.collapsibleOn === \'desktop\'\" ng-click=\"hoursCardC.toggleCollapsibleHours()\"><i class=\"fa fa-chevron-up\"></i></span> <span class=\"collapse-icon show-on-mobile show-on-desktop\" ng-if=\"hoursCardC.collapsibleOn === \'all\'\" ng-click=\"hoursCardC.toggleCollapsibleHours()\"><i class=\"fa fa-chevron-up\"></i></span></p><div ng-class=\"{\'collapse-mobile\': hoursCardC.collapsibleOn === \'mobile\', \'collapse-desktop\': hoursCardC.collapsibleOn === \'desktop\', \'collapse-all\': hoursCardC.collapsibleOn === \'all\'}\" class=\"collapsible show\"><div ng-if=\"hoursCardC.locHours\"><dl class=\"dl-horizontal\" ng-if=\"!hoursCardC.onlyToday\" itemprop=\"openingHours\" content=\"{{hoursCardC.openingHours}}\"><dt ng-repeat-start=\"(day,hours) in hoursCardC.locHours\" ng-class=\"hours.highlightClass\"><span>{{hours.dayName}}</span></dt><dd ng-if=\"hours.highlightClass\"><div class=\"hours-column margin-left-day-hours\"><span ng-class=\"hours.highlightClass\" ng-if=\"!hours.closed\">{{hoursCardC.getOpenTimePeriodDisplayMessage(hours)}}</span> <span ng-class=\"hours.highlightClass\" ng-if=\"hours.closed\">{{hours.closedLabel}}</span></div></dd><dd ng-if=\"!hours.highlightClass\" ng-repeat-end=\"\" ng-repeat=\"i in hours.numberOfTimeFragments track by $index\" class=\"hours-location\"><div class=\"hours-column margin-left-day-hours\"><span ng-class=\"hours.highlightClass\" ng-if=\"!hours.closed && !hours.open24\">{{hoursCardC.getOpenTimePeriodDisplayMessage(hours, $index)}}</span> <span ng-class=\"hours.highlightClass\" ng-if=\"hours.open24\">Open 24 Hours</span> <span ng-class=\"hours.highlightClass\" ng-if=\"hours.closed\">{{hours.closedLabel}}</span></div></dd></dl></div><div class=\"hours-note\" ng-if=\"hoursCardC.hoursNote\">* {{ hoursCardC.hoursNote.data }}</div><div ng-if=\"hoursCardC.specialHours\" class=\"specialHours\"><p class=\"bold-500 push-top push-bottom\" id=\"specialHours\"><i ng-class=\"{\'opened\': !hoursCardC.closedNow , \'closed\': hoursCardC.closedNow}\" class=\"ico ico-clock\"></i> Special Hours</p><dl class=\"dl-horizontal\" itemprop=\"openingHoursSpecification\" itemscope=\"\" itemtype=\"http://schema.org/OpeningHoursSpecification\"><dt ng-repeat-start=\"(day,hours) in hoursCardC.specialHours\" ng-class=\"hours.highlightClass\"><span itemprop=\"validFrom validThrough\" datetime=\"{{hours.dayNameShort}}\">{{hours.dayNameShort}}</span></dt><dd ng-if=\"hours.highlightClass\"><span ng-class=\"hours.highlightClass\" ng-if=\"!hours.closed\">{{hoursCardC.getOpenTimePeriodDisplayMessage(hours)}}</span> <span ng-class=\"hours.highlightClass\" ng-if=\"hours.closed\" itemprop=\"closes\">Closed</span></dd><dd ng-if=\"!hours.highlightClass\" ng-repeat-end=\"\" ng-repeat=\"i in hours.numberOfTimeFragments track by $index\"><span ng-class=\"hours.highlightClass\" ng-if=\"!hours.closed && !hours.open24\">{{hoursCardC.getOpenTimePeriodDisplayMessage(hours, $index)}}</span> <span ng-class=\"hours.highlightClass\" ng-if=\"hours.open24\" itemprop=\"opens\" content=\"12:00 AM\">Open 24 Hours</span> <span ng-class=\"hours.highlightClass\" ng-if=\"hours.closed\" itemprop=\"closes\" content=\"12:00 AM\">Closed</span></dd></dl></div></div></div>");
$templateCache.put("app/localLanding/cards/hoursCollapseCard.directive.html","<div class=\"hours-card\"><div ng-if=\"hoursCardC.locHours\"><p class=\"bold-500 push-top push-bottom\"><i class=\"ico ico-clock\"></i> <span ng-if=\"hoursCardC.closedNow\">Closed Now<br>Today\'s hours: <span>{{hoursCardC.openToday}}</span> - <span>{{hoursCardC.closeToday}}</span></span> <span ng-if=\"!hoursCardC.closedNow\">Open Until {{hoursCardC.closeToday}}</span></p><dl class=\"dl-horizontal\" ng-if=\"!hoursCardC.onlyToday\"><div class=\"panel-group\" ng-model=\"panels.activePanel\" role=\"tablist\" aria-multiselectable=\"true\" bs-collapse=\"\"><div class=\"panel panel-default\"><div class=\"panel-heading\" role=\"tab\"><h4 class=\"panel-title\"><a bs-collapse-toggle=\"\"><span>View Hours <i class=\"ico ico-chevron-down ico-lg\"></i></span></a></h4></div><div class=\"panel-collapse\" role=\"tabpanel\" bs-collapse-target=\"\"><div class=\"panel-body\"><div class=\"dl-horizontal\" ng-if=\"!hoursCardC.onlyToday\" itemprop=\"openingHours\" content=\"{{hoursCardC.openingHours}}\"><dt ng-repeat-start=\"(day,hours) in hoursCardC.locHours\" ng-class=\"hours.highlightClass\"><span>{{hours.dayName}}</span></dt><dd ng-repeat-end=\"\"><span ng-class=\"hours.highlightClass\" ng-if=\"!hours.closedLabel\"><span>{{hours.openTime}}</span> - <span>{{hours.closeTime}}</span></span> <span ng-class=\"hours.highlightClass\" ng-if=\"hours.closedLabel\">{{hours.closedLabel}}</span></dd></div></div></div></div></div></dl></div><div class=\"hours-note\" ng-if=\"hoursCardC.hoursNote\">* {{ hoursCardC.hoursNote.data }}</div></div>");
$templateCache.put("app/localLanding/cards/htmlCard.directive.html","<div ng-show=\"htmlCardC.content.data\" class=\"html-container\"><div class=\"html-content\"><p data-ng-bind-html=\"htmlCardC.trustAsHtml(htmlCardC.content.data)\" itemprop=\"content\" aria-live=\"polite\"></p></div></div>");
$templateCache.put("app/localLanding/cards/imageCard.directive.html","<div ng-show=\"imageCardC.imageSrc\" class=\"text-center image-element\"><a ng-if=\"imageCardC.imageLink\" ng-href=\"{{imageCardC.imageLink}}\" rel=\"noopener\" target=\"{{imageCardC.target}}\" data-analytics-label=\"{{ imageCardC.location | labelizeLocation }}\" data-analytics-category=\"{{ imageCardC.visibility }}\" data-analytics-event=\"{{ imageCardC.imageText }}\" data-analytics-value=\"1\" analytics-on=\"click\" class=\"db text-center\"><img ng-if=\"!imageCardC.role\" ng-src=\"{{imageCardC.imageSrc}}\" data-at2x=\"{{imageCardC.imageSrc}}\" alt=\"{{imageCardC.imageTitle}}\" width=\"100%\"> <img ng-if=\"imageCardC.role\" ng-src=\"{{imageCardC.imageSrc}}\" data-at2x=\"{{imageCardC.imageSrc}}\" alt=\"{{imageCardC.imageTitle}}\" role=\"{{imageCardC.role}}\" width=\"100%\"></a> <img ng-if=\"!imageCardC.imageLink && !imageCardC.role\" ng-src=\"{{imageCardC.imageSrc}}\" data-at2x=\"{{imageCardC.imageSrc}}\" alt=\"{{imageCardC.imageTitle}}\" width=\"100%\"> <img ng-if=\"!imageCardC.imageLink && imageCardC.role\" ng-src=\"{{imageCardC.imageSrc}}\" data-at2x=\"{{imageCardC.imageSrc}}\" alt=\"{{imageCardC.imageTitle}}\" role=\"{{imageCardC.role}}\" width=\"100%\"></div>");
$templateCache.put("app/localLanding/cards/instagram9Card.directive.html","<div ng-show=\"instagram9CardC.photos\"><div class=\"border-bottom push-bottom clearfix\"><div class=\"pull-left\"><h2 id=\"instagram-heading\" tabindex=\"-1\">Find us on Instagram</h2></div><div class=\"pull-right mf-social-icons single\"><a class=\"btn btn-provider instagram-color\" href=\"{{ instagram9CardC.igData.url }}\" target=\"_blank\" rel=\"noopener\" title=\"{{instagram9CardC.title}} on Instagram\" aria-label=\"Instagram Button\"><i class=\"ico ico-instagram\"></i></a></div></div><div class=\"clearfix\"><div ng-repeat=\"photo in photos | limitTo:12\" class=\"instagram9grid\"><a ng-href=\"{{photo.permalink}}\" target=\"_blank\" rel=\"noopener\" class=\"instagram9\" title=\"{{photo.owner.username}} on Instagram\" analytics-event=\"Clicked Instagram Photo\" analytics-label=\"{{ location | labelizeLocation }}\" analytics-category=\"LLP\" analytics-value=\"1\" analytics-on=\"click\"><img width=\"100%\" ng-src=\"{{photo.trust_url}}\" alt=\"Instagram Photo\" image-fallback=\"{{photo.fallback_url}}\"></a></div></div></div>");
$templateCache.put("app/localLanding/cards/llpContentCard.directive.html","<div ng-show=\"llpContentCardLedoC.llpCardContent.body\" class=\"push-bottom-xl llp-card\"><div class=\"card-top\"><h3>From the Business</h3></div><div class=\"card-bottom clearfix\"><h4 class=\"media-heading\"><i class=\"small\">{{ llpContentCardC.published_date_tz }}</i></h4><div class=\"push-top\"><div ng-if=\"llpContentCardC.llpCardContent.body.length > 0\" class=\"push-top content-body\">{{ llpContentCardC.llpCardContent.body }}</div><span ng-if=\"!llpContentCardC.llpCardContent.image_url && llpContentCardC.llpCardContent.link_url\"><a ng-href=\"{{llpContentCardC.filteredLink}}\" target=\"_blank\">{{llpContentCardC.llpCardContent.link_url}}</a></span> <span ng-if=\"llpContentCardC.llpCardContent.image_url\"><img ng-if=\"!llpContentCardC.llpCardContent.link_url\" alt=\"{{ llpContentCardC.llpCardContent.body }}\" ng-src=\"{{ llpContentCardC.llpCardContent.image_url }}\" width=\"100%\" class=\"push-top\"> <a ng-if=\"llpContentCardC.llpCardContent.link_url\" ng-href=\"{{llpContentCardC.filteredLink}}\" target=\"_blank\"><img ng-src=\"{{ llpContentCardC.llpCardContent.image_url }}\" alt=\"{{ llpContentCardC.llpCardContent.body }}\" width=\"100%\" class=\"push-top\"></a></span></div></div></div>");
$templateCache.put("app/localLanding/cards/mapCard.directive.html","<div class=\"map-container push-bottom\" id=\"map-container\" window-width=\"localLanding.windowWidth\"><img ng-if=\"!mapCardC.isGoogleMapsEnabled && mapCardC.windowWidth >= 768\" data-at2x=\"https://api.mapbox.com/styles/v1/momentfeed/ckekfnwp3079w19qmiwkaneut/static/{{mapCardC.mapPin}}({{mapCardC.lng}},{{mapCardC.lat}})/{{mapCardC.getLongitudeWithOffset()}},{{mapCardC.lat}},15/{{mapCardC.getMapContainerWidth()}}x{{mapCardC.height}}@2x?access_token={{mapCardC.MAP_KEY}}\" ng-src=\"https://api.mapbox.com/styles/v1/momentfeed/ckekfnwp3079w19qmiwkaneut/static/{{mapCardC.mapPin}}({{mapCardC.lng}},{{mapCardC.lat}})/{{mapCardC.getLongitudeWithOffset()}},{{mapCardC.lat}},15/{{mapCardC.getMapContainerWidth()}}x{{mapCardC.height}}?access_token={{mapCardC.MAP_KEY}}\" alt=\"{{mapCardC.altText}}\" class=\"hidden-xs\" property=\"og:image\"> <img ng-if=\"mapCardC.isGoogleMapsEnabled && mapCardC.windowWidth >= 768\" data-at2x=\"https://maps.googleapis.com/maps/api/staticmap?center={{mapCardC.lat}},{{mapCardC.lng}}&zoom=15&scale=2&size={{mapCardC.getMapContainerWidth()}}x{{mapCardC.height}}&markers={{mapCardC.mapPin}}{{mapCardC.lat}},{{mapCardC.lng}}&key={{mapCardC.MAP_KEY}}\" ng-src=\"https://maps.googleapis.com/maps/api/staticmap?center={{mapCardC.lat}},{{mapCardC.lng}}&zoom=15&size={{mapCardC.getMapContainerWidth()}}x{{mapCardC.height}}&markers={{mapCardC.mapPin}}{{mapCardC.lat}},{{mapCardC.lng}}&key={{mapCardC.MAP_KEY}}\" alt=\"{{mapCardC.altText}}\" class=\"hidden-xs\" property=\"og:image\"><img ng-if=\"!mapCardC.isGoogleMapsEnabled && mapCardC.windowWidth < 768\" data-at2x=\"https://api.mapbox.com/styles/v1/momentfeed/ckekfnwp3079w19qmiwkaneut/static/{{mapCardC.mapPin}}({{mapCardC.lng}},{{mapCardC.lat}})/{{mapCardC.lng}},{{mapCardC.lat}},15/{{mapCardC.getMapContainerWidth()}}x{{mapCardC.mobileHeight}}@2x?access_token={{mapCardC.MAP_KEY}}\" ng-src=\"https://api.mapbox.com/styles/v1/momentfeed/ckekfnwp3079w19qmiwkaneut/static/{{mapCardC.mapPin}}({{mapCardC.lng}},{{mapCardC.lat}})/{{mapCardC.lng}},{{mapCardC.lat}},15/{{mapCardC.getMapContainerWidth()}}x{{mapCardC.mobileHeight}}?access_token={{mapCardC.MAP_KEY}}\" alt=\"{{mapCardC.altText}}\" class=\"visible-xs visible-map-xs\" property=\"og:image\"> <img ng-if=\"mapCardC.isGoogleMapsEnabled && mapCardC.windowWidth < 768\" data-at2x=\"https://maps.googleapis.com/maps/api/staticmap?center={{mapCardC.lat}},{{mapCardC.lng}}&zoom=15&scale=2&size={{mapCardC.getMapContainerWidth()}}x{{mapCardC.mobileHeight}}&markers={{mapCardC.mapPin}}{{mapCardC.lat}},{{mapCardC.lng}}&key={{mapCardC.MAP_KEY}}\" ng-src=\"https://maps.googleapis.com/maps/api/staticmap?center={{mapCardC.lat}},{{mapCardC.lng}}&zoom=15&size={{mapCardC.getMapContainerWidth()}}x{{mapCardC.mobileHeight}}&markers={{mapCardC.mapPin}}{{mapCardC.lat}},{{mapCardC.lng}}&key={{mapCardC.MAP_KEY}}\" alt=\"{{mapCardC.altText}}\" class=\"visible-xs visible-map-xs\" property=\"og:image\"></div>");
$templateCache.put("app/localLanding/cards/menuCard.directive.html","<section class=\"menu-card\" ng-show=\"menuCardController.menu && menuCardController.menu.length > 0\"><header><ng-switch on=\"menuCardController.headingTag || \'h2\'\"><h2 ng-switch-when=\"h2\" ng-if=\"menuCardController.customHeader\">{{ menuCardController.customHeader }}</h2><h2 ng-switch-when=\"h2\" ng-if=\"!menuCardController.customStoreName && !menuCardController.customHeader\">{{menuCardController.storeName + \' \' + menuCardController.storeInfo.locality}}</h2><h2 ng-switch-when=\"h2\" ng-if=\"menuCardController.customStoreName\">{{menuCardController.customStoreNameData }}</h2><h3 ng-switch-when=\"h3\" ng-if=\"menuCardController.customHeader\">{{ menuCardController.customHeader }}</h3><h3 ng-switch-when=\"h3\" ng-if=\"!menuCardController.customStoreName && !menuCardController.customHeader\">{{menuCardController.storeName + \' \' + menuCardController.storeInfo.locality}}</h3><h3 ng-switch-when=\"h3\" ng-if=\"menuCardController.customStoreName\">{{menuCardController.customStoreNameData }}</h3></ng-switch><span>{{menuCardController.address}}</span></header><div class=\"menu-content\" scrolling-tabs-wrapper=\"\" watch-tabs=\"menuCardController.menu\" style=\"overflow:hidden;\"><tabset id=\"tabset\"><tab ng-repeat=\"category in menuCardController.menu\" ng-click=\"menuCardController.tabClick()\" active=\"category.active\" heading=\"{{category.categoryName}}\"><div role=\"tabpanel\" class=\"content\"><ul class=\"menu-options\"><li ng-repeat=\"option in category.options\" class=\"option\"><div class=\"menu-option clearfix\"><div class=\"image\" ng-if=\"menuCardController.showImage && option.photo\"><img ng-src=\"{{option.photo}}\" data-at2x=\"{{option.photo}}\" alt=\"{{option.name}} photo\" width=\"100%\"></div><div class=\"details\"><div class=\"price\"><span ng-if=\"option.price.amount && option.price.currencyCode == \'USD\'\">$</span>{{option.price.amount}}</div><div class=\"name\">{{option.name}}</div><div class=\"description\"><span>{{option.description.text}}</span><span ng-show=\"option.description.truncated\">...</span><a href=\"\" ng-click=\"option.description.truncated = false\" class=\"more\" ng-show=\"option.description.truncated\" title=\"More about {{ option.name }}\">More</a><span ng-show=\"!option.description.truncated\">{{option.description.truncatedText}}</span></div></div></div></li><li class=\"show-more\" ng-if=\"menuCardController.initMenuItemsShown && category.options.length > menuCardController.initMenuItemsShown\"><a ng-click=\"menuCardController.numItemsToggle()\">{{ menuCardController.showMoreLessText }}</a></li></ul></div></tab></tabset></div><div class=\"bottom-link\" ng-show=\"menuCardController.link\"><i class=\"fa fa-arrow-circle-right custom\"></i> <a ng-href=\"{{menuCardController.link}}\" title=\"{{menuCardController.linkText}}\" target=\"_blank\" rel=\"noopener\">{{menuCardController.linkText}}</a></div></section>");
$templateCache.put("app/localLanding/cards/mfReviewsCard.directive.html","<div class=\"reviewCard\"><div class=\"row\"><div class=\"col-xs-12 form\" ng-if=\"RatingCtrl.enableForm\" ng-class=\"RatingCtrl.enableReviews?\'col-md-6\':\'col-md-12\'\"><div class=\"post-message animate-show-hide\" ng-show=\"RatingCtrl.postMessage\"><p>{{RatingCtrl.postMessage}}</p></div><div class=\"form-body animate-show-hide\" ng-show=\"!RatingCtrl.postMessage\"><h4>{{ RatingCtrl.title }}</h4><div class=\"card-rating text-center\"><ul class=\"star-rating\"><li data-ng-repeat=\"star in RatingCtrl.stars track by $index\" class=\"star\" data-ng-class=\"{\'filled\': $index <= RatingCtrl.activeIndex}\" aria-label=\"star_rating\" data-ng-click=\"RatingCtrl.toggle($index)\"><i class=\"ico ico-star\" aria-label=\"star_rating\"></i></li></ul><p class=\"help-block\" ng-show=\"RatingCtrl.activeIndex == null && RatingCtrl.isFormActive\">Please Rating</p></div><form name=\"reviewForm\" novalidate=\"\"><div class=\"form-group\" ng-class=\"{\'has-error\': !RatingCtrl.isInfoValid()&& RatingCtrl.isFormActive}\"><ng-form name=\"userFieldForm\"><div class=\"name-field\"><input aria-label=\"first-name\" type=\"text\" class=\"form-control\" name=\"first-name\" required=\"\" maxlength=\"60\" placeholder=\"What\'s your first name?*\" data-form-field=\"Name\" ng-model=\"formData.first_name\"> <input aria-label=\"last-name\" type=\"text\" class=\"form-control\" name=\"last-name\" required=\"\" maxlength=\"60\" placeholder=\"What\'s your last name?*\" data-form-field=\"Name\" ng-model=\"formData.last_name\"></div><div class=\"text-count\"></div><p class=\"help-block\" ng-show=\"(!formData.first_name ||!formData.last_name) && RatingCtrl.isFormActive\">Please Enter A Valid Name</p><input aria-label=\"email\" type=\"email\" class=\"form-control\" name=\"email\" required=\"\" maxlength=\"60\" placeholder=\"What\'s your email address?*\" data-form-field=\"Email\" ng-model=\"formData.email\"><div class=\"text-count\"></div><p class=\"help-block\" ng-show=\"!formData.email && RatingCtrl.isFormActive\">Please Enter A Valid Email</p><input aria-label=\"title\" type=\"text\" class=\"form-control\" name=\"title\" placeholder=\"Review Title*\" data-form-field=\"Message\" maxlength=\"60\" ng-model=\"formData.title\"><div class=\"text-count pull-right\">{{formData.title.length}}/60</div><p class=\"help-block\" ng-show=\"!formData.title && RatingCtrl.isFormActive\">Please Enter A Valid Title</p><textarea aria-label=\"review\" class=\"form-control review\" name=\"review\" placeholder=\"Review*\" rows=\"7\" ng-model=\"formData.text\" maxlength=\"1700\" data-form-field=\"Message\"></textarea><div class=\"text-count pull-right\">{{formData.text.length}}/1700</div><p class=\"help-block\" ng-show=\"!formData.text && RatingCtrl.isFormActive\">Please Enter A Valid Review</p></ng-form><div class=\"review-submitBtn\"><button type=\"submit\" class=\"btn btn-md\" ng-click=\"RatingCtrl.onSubmitClick()\" value=\"Submit form\">Submit</button></div></div></form></div><div class=\"review-logo\"><div class=\"logo-text\">Powered by</div><div class=\"svg-logo\"><svg xmlns=\"http://www.w3.org/2000/svg\" version=\"1\" viewbox=\"0 0 788 321\"><path d=\"M133 248v-38l-16 38h-12l-16-38v38H74v-66h19l18 45 20-45h17v66h-15zm49-50c14 0 25 8 25 25s-12 26-26 26c-15 0-25-8-25-25s11-26 26-26zm-1 38c6 0 9-3 9-12 0-10-3-13-9-13-5 0-9 4-9 13s4 12 9 12zm47-37v6c3-3 8-7 15-7 6 0 9 2 12 7 3-4 8-7 15-7 9 0 14 6 14 16v34h-16v-31c0-4-1-6-4-6s-6 2-7 3v34h-16v-30c0-4 0-7-4-7-3 0-6 2-7 4v33h-16v-49h14zm108 44c-6 4-12 6-20 6-16 0-25-9-25-25s10-26 25-26c14 0 22 8 22 23v7h-30c1 5 3 9 10 9 4 0 8-1 14-4l4 10zm-13-24c0-5-1-9-7-9s-8 5-8 8h15zm38-20v6c3-3 8-7 15-7 10 0 16 6 16 17v33h-16v-28c0-6-2-9-6-9s-7 3-8 4v33h-15v-49h14zm162 44c-6 4-13 6-21 6-15 0-24-9-24-25s9-26 24-26 23 8 23 23l-1 7h-30c1 5 4 9 10 9 5 0 9-1 15-4l4 10zm-13-24c0-5-2-9-7-9-6 0-9 5-9 8h16zm67 24c-6 4-13 6-21 6-15 0-24-9-24-25s9-26 24-26c14 0 22 8 22 23v7h-30c1 5 3 9 10 9 5 0 9-1 15-4l4 10zm-13-24c0-5-2-9-7-9-6 0-9 5-9 8h16zm56 23c-3 4-8 7-15 7-14 0-20-9-20-25 0-17 9-26 20-26 6 0 10 2 14 5v-21h15v66h-15l1-6zm-1-27c-2-2-5-4-9-4-5 0-9 4-9 13 0 7 3 12 9 12 4 0 7-2 9-4v-17zm-195 22c-3 0-4-1-4-3v-23h8v-12h-7v-14h-16v14h-7v12h7v26c0 7 4 12 12 12l12-2-1-10h-4zm14 11h15v-26h18v-12h-18v-15h28v-13h-43v66z\" class=\"st0\"></path><path d=\"M713 102l-13-23c-2-2-6-5-9-5H582l17 28c1 3 5 5 8 5h65c3 0 7 3 9 6l16 27 16-28c2-2 2-7 0-10z\" class=\"st1\"></path><path d=\"M675 121c-1-3-5-5-8-5h-71l16 28c2 3 6 5 9 5h27c3 0 7 2 8 5l16 28 17-28v-10l-14-23z\" class=\"st1\"></path></svg></div></div></div><div class=\"col-xs-12 reviews\" ng-if=\"RatingCtrl.enableReviews\" ng-class=\"RatingCtrl.enableForm?\'col-md-6\':\'col-md-12\'\"><div class=\"no-review\" ng-if=\"RatingCtrl.reviews.length == 0\"><div>No Reviews Collected yet...</div></div><ul class=\"review-ul\" ng-class=\"{\'review-mobile-hide\': !RatingCtrl.toggleExpand}\" ng-if=\"RatingCtrl.reviews.length != 0\"><li class=\"review-li\" ng-repeat=\"review in RatingCtrl.reviews\"><div class=\"review title\">{{review.title}}</div><ul class=\"star-rating\"><li data-ng-repeat=\"star in RatingCtrl.stars track by $index\" class=\"star\" data-ng-class=\"{\'filled\': $index < review.rating}\"><i class=\"ico ico-star\"></i></li></ul><div class=\"reviewer_name\">{{ review.author ? review.author : review.first_name + \" \" + review.last_name }}</div><p>{{review.text}}</p><div class=\"response\"><p ng-if=\"review.owner_response.text\" class=\"response_content\">{{review.owner_response.text}}</p></div></li></ul><div class=\"review-expand\" ng-click=\"RatingCtrl.loadMore()\" ng-if=\"RatingCtrl.reviews.length != 0\"><a>{{RatingCtrl.loadText}}</a></div></div></div></div>");
$templateCache.put("app/localLanding/cards/nearbyCard.directive.html","<div class=\"text-center push-top-xl push-bottom-xl\" ng-show=\"locations.length\"><h2>{{ nearbyCardC.title || \"Nearby Locations\" }}</h2><div class=\"text-center\"><div ng-repeat=\"location in locations\" class=\"dib width-third xs-full-width push-bottom\"><h3><span ng-if=\"!location.name.includes(\'®\')\" data-ng-bind-html=\"location.name\" itemprop=\"name\" aria-live=\"polite\"></span><span ng-if=\"location.name.includes(\'®\')\"><span data-ng-bind-html=\"location.name.slice(0, location.name.length - 1)\" itemprop=\"name\" aria-live=\"polite\"></span><sup>®</sup></span><span ng-if=\"nearbyCardC.includeLocality\">, {{ location.address_detail.locality }}</span></h3><h4 class=\"no-bold line-height-bump\">{{ location.address_detail.address }} {{ location.address_detail.address_extended }}<br>{{ location.address_detail.locality }}, {{ location.address_detail.region }} {{ location.address_detail.postcode }}<br></h4><h4 class=\"visible-xs\"><a ng-href=\"tel:{{ location.phone }}\" analytics-event=\"Call\" analytics-label=\"{{ location | labelizeLocation }}\" analytics-category=\"LLP\" analytics-value=\"1\" analytics-on=\"click\" title=\"Call\">{{ location.phone | telephone }}</a></h4><h4 class=\"hidden-xs\">{{ location.phone | telephone }}</h4><h4>{{ nearbyCardC.regionService.getDistanceString(location.distance) }}</h4><div class=\"push-top-lg\"><a class=\"btn btn-primary\" title=\"Local Page\" ng-show=\"!location.hideLocalPageButton && location.local_landing_page\" href=\"{{ nearbyCardC.getLocalPageUrl(location) }}\">{{ nearbyCardC.localPageBtn || \"Local Page\"}}</a> <a href=\"{{ nearbyCardC.getDirectionsUrl(location.address_detail) }}\" target=\"_blank\" rel=\"noopener\" title=\"Get Directions\" class=\"btn btn-primary\">Get Directions</a></div></div></div></div>");
$templateCache.put("app/localLanding/cards/partnerReviewsCard.directive.html","<div class=\"partner-reviews-card\"><div ng-if=\"partnerReviewsCardC.pData.ratingFraction > partnerReviewsCardC.minRating\"><div class=\"row review-wrapper\"><div class=\"float-left icon-container col-sm-2 col-md-2 col-lg-2 col-xs-2\"><div class=\"btn-provider {{partnerReviewsCardC.partnerName | lowercase}}-color\"><a itemprop=\"sameAs\" href=\"{{ partnerReviewsCardC.pData.url }}\" target=\"_blank\" rel=\"external noopener\" title=\"{{partnerReviewsCardC.title}} on {{partnerReviewsCardC.partnerName}}\" aria-label=\"{{partnerReviewsCardC.partnerName}} button\"><i class=\"ico ico-{{partnerReviewsCardC.partnerName | lowercase}}\"></i></a></div></div><div class=\"float-left ratings-container col-sm-8 col-md-8 col-lg-8 col-xs-8\"><div class=\"row\"><div ng-if=\"partnerReviewsCardC.partnerName===\'Yelp\'\"><img ng-src=\"{{partnerReviewsCardC.pData.yelpStarUrl}}\" alt=\"\"></div><div ng-if=\"partnerReviewsCardC.partnerName === \'Foursquare\'\"><span class=\"foursquare-rating venue-score\" style=\"background-color: {{partnerReviewsCardC.ratingColor}}\"><span>{{partnerReviewsCardC.pData.rating}}</span> <sup>/<span>10</span></sup></span></div><div ng-if=\"partnerReviewsCardC.partnerName===\'Google\'\"><div star-rating=\"\" rating-value=\"partnerReviewsCardC.pData.roundedRating\" max=\"5\"></div></div><div ng-if=\"partnerReviewsCardC.partnerName===\'Facebook\'\"><div class=\"circle\">{{partnerReviewsCardC.pData.rating}}</div><span class=\"bold-text\">out of 5</span></div><a ng-if=\"partnerReviewsCardC.pData.reviewCount\" class=\"review-count\" href=\"{{ partnerReviewsCardC.pData.url }}\" target=\"_blank\" rel=\"external noopener\">View {{partnerReviewsCardC.pData.reviewCount}} {{partnerReviewsCardC.partnerName}} Reviews</a> <a ng-if=\"!partnerReviewsCardC.pData.reviewCount\" class=\"review-count\" href=\"{{ partnerReviewsCardC.pData.url }}\" target=\"_blank\" rel=\"external noopener\">View {{partnerReviewsCardC.partnerName}} Reviews</a></div></div></div></div></div>");
$templateCache.put("app/localLanding/cards/promoCard.directive.html","<div class=\"carousel-container\"><div uib-carousel=\"\" interval=\"promoCardC.myInterval\"><div uib-slide=\"\" ng-repeat=\"object in promoCardC.promoObject\" active=\"object.active\"><li><div ng-if=\"object.url\"><a href=\"{{ object.url }}\" target=\"_blank\" data-tag=\"{{ object.analytics_ }}\" analytics-event=\"Clicked Promo Photo\" analytics-label=\"{{ promoCardC.location | labelizeLocation }}\" rel=\"noopener\" analytics-category=\"LLP\" analytics-value=\"1\" analytics-on=\"click\"><img src=\"{{object.image}}\" type=\"fetch\" dpr=\"auto\" class=\"cld-responsive\" alt=\"Promo Image\"></a></div><div ng-if=\"!object.url\"><img src=\"{{object.image}}\" type=\"fetch\" dpr=\"auto\" class=\"cld-responsive\" alt=\"Promo Image\"></div></li></div></div></div>");
$templateCache.put("app/localLanding/cards/singleImageCard.directive.html","<div ng-show=\"singleImageCardC.hasData\" title=\"{{singleImageCardC.title}}\" class=\"text-center\"><a ng-if=\"singleImageCardC.findLink\" ng-href=\"{{singleImageCardC.link}}\" rel=\"noopener\" target=\"{{singleImageCardC.singleImageTarget}}\" analytics-event=\"Clicked Single Photo\" analytics-label=\"{{ location | labelizeLocation }}\" analytics-category=\"LLP\" analytics-value=\"1\" analytics-on=\"click\" class=\"db text-center\"><img ng-src=\"{{singleImageCardC.src}}\" data-at2x=\"{{singleImageCardC.src}}\" alt=\"{{singleImageCardC.title}}\" width=\"100%\"></a> <img ng-if=\"!singleImageCardC.findLink\" ng-src=\"{{singleImageCardC.src}}\" data-at2x=\"{{singleImageCardC.src}}\" alt=\"{{singleImageCardC.title}}\" width=\"100%\"></div>");
$templateCache.put("app/localLanding/cards/sitemapErrorCard.directive.html","<div class=\"sitemapErrorCard\"><div class=\"\"><h2>We are unable to find locations in this area.</h2><p>We are redirecting you to find another location...</p></div></div>");
$templateCache.put("app/localLanding/cards/socialCard.directive.html","<div class=\"mf-social-icons\">{{ socialCardC.provider.master }}<ul class=\"list-unstyled no-margin\"><li ng-repeat=\"provider in socialCardC.providers\" class=\"dib {{provider._type | lowercase}}\"><a ng-if=\"(provider._type != \'Twitter\' && provider._type != \'Instagram\' && provider._type != \'Google\') && provider.url\" itemprop=\"sameAs\" class=\"btn btn-provider {{provider._type | lowercase}}-color\" analytics-event=\"Clicked Social Link {{ provider._type }}\" analytics-label=\"{{ location | labelizeLocation }}\" analytics-category=\"LLP\" analytics-value=\"1\" analytics-on=\"click\" aria-label=\"{{provider._type}} Button\" href=\"{{ provider.url }}\" rel=\"noopener\" target=\"_blank\" alt=\"{{location.store_info.name}} on {{provider._type}}\" title=\"{{location.store_info.name}} on {{provider._type}}\"><i class=\"ico ico-{{provider._type | lowercase}}\"></i></a> <a ng-if=\"provider._type == \'Google\' && (provider.url || location.provider_venues[\'google_page_url\'])\" itemprop=\"sameAs\" class=\"btn btn-provider {{provider._type | lowercase}}-color\" analytics-event=\"Clicked Social Link {{ provider._type }}\" analytics-label=\"{{ location | labelizeLocation }}\" analytics-category=\"LLP\" analytics-value=\"1\" analytics-on=\"click\" aria-label=\"{{provider._type}} Button\" ng-href=\"{{provider.url || location.provider_venues[\'google_page_url\']}}\" rel=\"noopener\" target=\"_blank\" alt=\"{{location.store_info.name}} on {{provider._type}}\" title=\"{{location.store_info.name}} on {{provider._type}}\"><i class=\"ico\" ng-class=\"{ \'ico ico-{{provider._type | lowercase}}\' : provider.url, \'ico ico-{{provider._type | lowercase}}-plus\' : !provider.url }\"></i></a> <a ng-if=\"provider._type == \'Instagram\'\"></a> <a ng-if=\"provider._type == \'Twitter\'\" itemprop=\"sameAs\" class=\"btn btn-provider {{provider._type | lowercase}}-color\" analytics-event=\"Clicked Social Link {{ provider._type }}\" analytics-label=\"{{ location | labelizeLocation }}\" analytics-category=\"LLP\" analytics-value=\"1\" analytics-on=\"click\" aria-label=\"{{provider._type}} Button\" href=\"https://twitter.com/{{ location.twitter_handle }}\" rel=\"noopener\" target=\"_blank\" alt=\"{{location.store_info.name}} on {{provider._type}}\" title=\"{{location.store_info.name}} on {{provider._type}}\"><i class=\"ico ico-{{provider._type | lowercase}}\"></i></a></li><li class=\"dib instagram\"><a ng-if=\"socialCardC.instagramHandle\" itemprop=\"sameAs\" class=\"btn btn-provider instagram-color\" analytics-event=\"Clicked Social Link Instagram\" analytics-label=\"{{ location | labelizeLocation }}\" analytics-category=\"LLP\" analytics-value=\"1\" analytics-on=\"click\" aria-label=\"Instagram Button\" href=\"{{ socialCardC.instagramURL }}\" rel=\"noopener\" target=\"_blank\" alt=\"{{location.store_info.name}} on Instagram\" title=\"{{location.store_info.name}} on Instagram\"><i class=\"ico ico-instagram\"></i></a></li></ul></div>");
$templateCache.put("app/localLanding/cards/storeLocatorAmenitiesCard.directive.html","<div class=\"amenities\" ng-show=\"storeLocatorAmenitiesCardController.amenities.length > 0\"><h5>{{storeLocatorAmenitiesCardController.title}}</h5><ul><li ng-repeat=\"amenity in storeLocatorAmenitiesCardController.amenities\"><img ng-src=\"/assets/images/clients/{{storeLocatorAmenitiesCardController.client}}/{{amenity.name}}.png\" alt=\"{{amenity.tooltip}}\" data-at2x=\"/assets/images/clients/{{storeLocatorAmenitiesCardController.client}}/{{amenity.name}}@2x.png\" ng-mouseover=\"storeLocatorAmenitiesCardController.showTooltip(amenity)\" ng-mouseleave=\"storeLocatorAmenitiesCardController.hideTooltip(amenity)\"><div class=\"amenity-tooltip\" ng-show=\"amenity.showTooltip\">{{amenity.tooltip}}</div></li></ul></div>");
$templateCache.put("app/localLanding/cards/videoEmbedCard.directive.html","<div class=\"video-card\"><div class=\"border-bottom push-bottom clearfix\"><div class=\"pull-left\"><h3>{{videoEmbedCardC.customHeaderText}}</h3></div><div class=\"pull-right mf-social-icons single\"><a ng-if=\"videoEmbedCardC.channel\" class=\"btn btn-provider youtube-color\" ng-href=\"{{videoEmbedCardC.channel}}\" title=\"Subscribe to YouTube channel\" target=\"_blank\" rel=\"noopener\"><i class=\"ico ico-youtube\"></i></a></div></div><div class=\"card-bottom clearfix\"><div class=\"push-top\"><iframe id=\"video_url\" title=\"Video Player\" width=\"100%\" ng-src=\"{{videoEmbedCardC.link}}\" frameborder=\"0\" allowfullscreen=\"\"></iframe></div></div></div>");
$templateCache.put("app/localLanding/cards/weatherCard.directive.html","<div class=\"push-bottom-lg\"><div class=\"card-header border-bottom push-bottom\"><h3>Current Weather</h3><p>{{weatherCardC.location.store_info.locality}}, {{weatherCardC.location.store_info.region}}</p></div><div class=\"row\"><div class=\"col-xs-6 weather-icon text-right\"><i class=\"ico ico-{{weatherCardC.weather.icon}} v-align-middle\"></i></div><div class=\"col-xs-6\"><div class=\"weather-card-temp\">{{weatherCardC.weather.temperature}}&deg;F</div><p>Feels like {{weatherCardC.weather.feelsLike}}&deg;F</p></div></div><div class=\"text-center push-top\"><p class=\"text-capitalize\">{{weatherCardC.weather.summary}} with a {{weatherCardC.weather.precipPercent}}% chance of {{weatherCardC.weather.precipType}}</p></div><small class=\"text-right db\"><a href=\"http://forecast.io/\" class=\"gray-text\" target=\"_blank\" rel=\"noopener\">Powered by Forecast</a></small></div>");
$templateCache.put("app/storeLocator/directives/map.directive.html","<div class=\"store-locator-map\" window-resize=\"\"><div data-ng-show=\"mapCtrl.isClusterActive && !mapCtrl.displayAllLocationsInMap && mapCtrl.locatorStates.isLoading && mapCtrl.locatorStates.showLoader\" class=\"mf-map-loading-container\"><div class=\"mf-loader text-center mf-loading-map\"><i class=\"ico ico-spinner ico-spin\"></i></div></div><mapbox data-ng-if=\"!mapCtrl.isGoogleMapsEnabled\" data-callback=\"mapCtrl.showMap\"></mapbox><div ng-if=\"isGoogleMapsApiLoaded\"><google-map data-ng-if=\"mapCtrl.isGoogleMapsEnabled\" data-callback=\"mapCtrl.showMap\"></google-map></div><div data-ng-show=\"mapCtrl.locatorStates.showSearchAreaBtn\" class=\"map-overlay\"><button id=\"searchAreaBtn\" type=\"button\" class=\"btn btn-primary\" data-ng-click=\"mapCtrl.searchArea($event)\" aria-hidden=\"true\" alt=\"{{mapCtrl.searchAreaBtnTooltip}}\" title=\"{{mapCtrl.searchAreaBtnTooltip}}\" data-analytics-event=\"Search Area\" data-analytics-label=\"Store Locator\" data-analytics-category=\"Store Locator\" data-analytics-value=\"1\" data-analytics-on=\"click\" data-sf-analytics-event=\"Search this area\">{{mapCtrl.searchAreaBtnText}}</button></div></div>");
$templateCache.put("app/storeLocator/directives/results.directive.html","<div class=\"results\"><div data-ng-show=\"resultsCtrl.locatorStates.isLoading\" class=\"text-center push-top-lg\"><div class=\"mf-loader text-center mf-loading-list push-top\"><i class=\"ico ico-spinner ico-spin\"></i></div><h5 data-ng-if=\"angular.equals({}, resultsCtrl.locatorStates.message)\">{{resultsCtrl.locatorStates.message}}</h5></div><div id=\"js-total\" class=\"results-total\" data-ng-show=\"resultsCtrl.locatorStates.current && !resultsCtrl.locatorStates.isLoading && resultsCtrl.showMessage\" role=\"alert\"><span>{{resultsCtrl.GetMessage()}}</span></div><div ng-if=\"!resultsCtrl.locatorStates.isLoading && resultsCtrl.locatorStates.locations.length && resultsCtrl.orderResultsList\" ng-init=\"resultsCtrl.getLocations(resultsCtrl.locatorStates.locations)\"><div ng-repeat=\"(title, result) in resultsCtrl.groupedData\"><div><div class=\"results-list-title\">{{ title }}</div><ul id=\"js-results\" class=\"results-list list-unstyled\"><results-li data-ng-repeat=\"location in result\" locator-states=\"resultsCtrl.locatorStates\" location=\"location\" map-obj=\"resultsCtrl.mapObj\" role=\"listitem\"></results-li></ul></div></div></div><ul id=\"js-results\" class=\"results-list list-unstyled\" ng-if=\"!resultsCtrl.locatorStates.isLoading && resultsCtrl.locatorStates.locations.length && !resultsCtrl.orderResultsList\"><results-li data-ng-repeat=\"location in resultsCtrl.locatorStates.locations\" locator-states=\"resultsCtrl.locatorStates\" location=\"location\" map-obj=\"resultsCtrl.mapObj\" role=\"listitem\"></results-li></ul></div>");
$templateCache.put("app/storeLocator/directives/search.directive.html","<div id=\"js-search\"><div class=\"search-container\" ng-class=\"{\'show-filters\': searchCtrl.showFilters}\"><form name=\"search\"><div id=\"search_box\" class=\"clearfix\"><div class=\"input-group\"><div class=\"input-group-btn v-align-top\"><button id=\"geoLocationBtn\" type=\"button\" class=\"btn btn-primary custom-client\" aria-label=\"Geo Locate Button\" data-ng-show=\"searchCtrl.locatorStates.geoEnabled != null\" data-ng-disabled=\"!searchCtrl.locatorStates.geoEnabled\" data-ng-click=\"searchCtrl.userLatLngSearch($event)\" aria-hidden=\"false\" title=\"Find Locations Near You\" alt=\"Find Locations Near You\" data-analytics-event=\"Get Geo Location\" data-analytics-label=\"Store Locator\" data-analytics-category=\"Store Locator\" data-analytics-value=\"1\" data-analytics-on=\"click\" data-sf-analytics-event=\"Share my location\"><i class=\"ico ico-location-arrow custom-client\" value=\"image\" aria-hidden=\"true\"></i></button></div><input id=\"searchField\" name=\"\" title=\"search\" role=\"combobox\" class=\"form-control v-align-top\" placeholder=\"{{searchCtrl.placeholder}}\" data-typeahead-on-select=\"searchCtrl.autoCompleteSelect(searchCtrl.locatorStates.searchInput)\" data-ng-model=\"searchCtrl.locatorStates.searchInput\" data-typeahead=\"place as place.name for place in searchCtrl.autoCompleteLocations($viewValue)\" autocomplete=\"off\" data-container=\"#js-search\" data-min-length=\"2\" maxlength=\"256\" ng-if=\"!searchCtrl.isGoogleMapsEnabled\"><div ng-if=\"isGoogleMapsApiLoaded\"><google-autocomplete place-changed-callback=\"searchCtrl.googlePlaceChanged\" data-ng-model=\"searchCtrl.locatorStates.searchInput\" ng-if=\"searchCtrl.isGoogleMapsEnabled\"></google-autocomplete></div><div class=\"input-group-btn v-align-top\"><button id=\"searchBtn\" title=\"search button\" ng-attr-type=\"{{searchCtrl.isGoogleMapsEnabled ? \'button\' : \'submit\'}}\" class=\"btn btn-primary pull-right\" aria-label=\"Search\" role=\"button\" data-ng-click=\"searchCtrl.hitSearchBtn()\" aria-hidden=\"false\" data-analytics-event=\"Search\" data-analytics-label=\"Store Locator\" data-analytics-category=\"Store Locator\" data-analytics-value=\"1\" data-analytics-on=\"click\" data-sf-analytics-event=\"Search\"><i class=\"ico ico-search\" aria-hidden=\"true\"></i></button></div><div ng-if=\"searchCtrl.hasFilters\" ng-show=\"searchCtrl.showFiltersForActiveTab()\" class=\"input-group-btn filter-btn\"><button id=\"toggleFiltersBtn\" type=\"button\" class=\"btn btn-filter\" data-ng-click=\"searchCtrl.showFilters = !searchCtrl.showFilters\" title=\"Toggle Filters Menu\" alt=\"Toggle Filters Menu\" aria-label=\"filter button\" aria-expanded=\"{{searchCtrl.showFilters}}\" data-analytics-event=\"Toggle Filters Menu\" data-analytics-label=\"Store Locator\" data-analytics-category=\"Store Locator\" data-analytics-value=\"1\" data-analytics-on=\"click\">Filter <i class=\"ico ico-chevron-down v-align-middle\" data-ng-hide=\"searchCtrl.locatorStates.selectedFilters.length\"></i><i class=\"ico ico-checkbox-marked-circle text-brand v-align-middle\" ng-show=\"searchCtrl.locatorStates.selectedFilters.length\"></i></button></div></div></div><div ng-show=\"searchCtrl.showFilters && searchCtrl.showFiltersForActiveTab()\" class=\"search-filters\"><div data-ng-repeat=\"filterType in searchCtrl.availableFilterTypes\" class=\"filter-type\"><h6>{{filterType}}</h6><ul class=\"list-unstyled\"><li data-ng-repeat=\"filter in searchCtrl.availableFilters | filter: {type: filterType} track by $index\" data-ng-attr-id=\"filterRow{{$index}}\" data-ng-class=\"{active: filter.active}\"><button data-ng-attr-id=\"filterBtn{{$index}}\" type=\"button\" aria-label=\"{{filterType}} button {{filter.label}}\" class=\"btn btn-ul\" data-ng-click=\"searchCtrl.addFilter(filter.label);\" role=\"checkbox\" aria-checked=\"{{filter.active}}\" data-analytics-event=\"Filter Drop Down\" data-analytics-label=\"{{ filter.label }}\" data-analytics-category=\"Store Locator\" data-analytics-value=\"1\" data-analytics-on=\"click\"><i ng-class=\"searchCtrl.useDefaultCheckIcon ? \'ico ico-checkbox-blank-circle-outline\' : \'fa fa-square-o\'\"></i> <i ng-class=\"searchCtrl.useDefaultCheckIcon ? \'ico ico-checkbox-marked-circle\' : \'fa fa-check-square-o\'\"></i> {{filter.label}}</button></li></ul></div></div></form></div></div>");
$templateCache.put("app/storeLocator/directives/searchByName.directive.html","<div id=\"js-search\"><h2 class=\"search-by-title\">Search by name</h2><div class=\"search-container\"><form name=\"search\"><div id=\"search_box\" class=\"clearfix\"><div class=\"input-group\"><input id=\"searchField\" name=\"\" title=\"search\" role=\"combobox\" class=\"form-control v-align-top\" placeholder=\"{{searchByNameCtrl.searchByNamePlaceholder}}\" data-typeahead-on-select=\"searchByNameCtrl.autoCompleteSelect()\" data-ng-model=\"searchByNameCtrl.locatorStates.searchByNameInput\" data-typeahead=\"location as location.store_info.name for location in searchByNameCtrl.autoCompleteLocations($viewValue)\" data-typeahead-wait-ms=\"400\" ng-change=\"searchByNameCtrl.inputChanged()\" autocomplete=\"off\" data-container=\"#js-search\" data-min-length=\"2\" maxlength=\"256\"><div class=\"input-group-btn v-align-top\"><button id=\"searchBtn\" title=\"search button\" type=\"submit\" class=\"btn btn-primary pull-right\" aria-label=\"Search\" role=\"button\" data-ng-click=\"searchByNameCtrl.hitSearchBtn()\" aria-hidden=\"false\" data-analytics-event=\"Search\" data-analytics-label=\"Store Locator\" data-analytics-category=\"Store Locator\" data-analytics-value=\"1\" data-analytics-on=\"click\" data-sf-analytics-event=\"Search\"><i class=\"ico ico-search\" aria-hidden=\"true\"></i></button></div></div></div></form></div></div>");
$templateCache.put("app/storeLocator/directives/tabs.directive.html","<div class=\"tabs\"><div class=\"show-desktop\"><ul class=\"nav nav-tabs\"><li ng-class=\"{active: tab.active}\" ng-repeat=\"tab in tabsCtrl.locatorStates.tabs track by $index\" ng-disabled=\"tabsCtrl.locatorStates.isLoading\"><a data-toggle=\"tab\" ng-click=\"tabsCtrl.loadData(tab)\" href=\"\"><span>{{tab.name}}</span></a></li></ul></div><div class=\"show-mobile clearfix\"><a ng-if=\"tabsCtrl.collapseForMobile\" href=\"\" ng-click=\"tabsCtrl.collapse = !tabsCtrl.collapse\" ng-attr-title=\"{{tabsCtrl.collapse ? \'Show\' : \'Hide\'}}\" class=\"toggle-tabs\"><i class=\"fa fa-filter\" aria-hidden=\"true\"></i> <span ng-show=\"tabsCtrl.collapse\">{{tabsCtrl.collapsedText}}</span></a><ul class=\"nav nav-tabs\" ng-show=\"!tabsCtrl.collapseForMobile || !tabsCtrl.collapse\"><li ng-class=\"{active: tab.active}\" ng-repeat=\"tab in tabsCtrl.locatorStates.tabs track by $index\" ng-disabled=\"tabsCtrl.locatorStates.isLoading\"><input aria-label=\"{{tab.shortName}}\" type=\"radio\" data-ng-value=\"true\" data-ng-model=\"tab.active\" name=\"tabs\" ng-click=\"tabsCtrl.loadData(tab)\"> <a data-toggle=\"tab\" ng-click=\"tabsCtrl.loadData(tab)\" href=\"\"><span>{{tab.shortName}}</span></a></li></ul></div><div class=\"tab-content\"><results data-locator-states=\"tabsCtrl.locatorStates\" data-map-obj=\"tabsCtrl.mapObj\"></results></div></div>");
$templateCache.put("app/storeLocator/templates/mapPopup.template.html","<div class=\"mf-popup-content\" data-ng-attr-id=\"loc_{{mapPopupCtrl.location.number}}\"><h4>{{mapPopupCtrl.location.name}}</h4><div>{{mapPopupCtrl.location.address}}<br><span ng-if=\"mapPopupCtrl.location.address_extended\">{{mapPopupCtrl.location.address_extended}}<br></span> {{mapPopupCtrl.location.locality}}, {{mapPopupCtrl.location.region}} {{mapPopupCtrl.location.postcode}}<br><span class=\"hidden-xs\">{{ mapPopupCtrl.location.phone | telephone}}</span> <a class=\"visible-xs\" analytics-event=\"Call\" analytics-label=\"{{ mapPopupCtrl.location.entire_location | labelizeLocation }}\" analytics-category=\"Store Locator\" analytics-value=\"1\" analytics-on=\"click\" title=\"Call\" ng-href=\"tel:{{ mapPopupCtrl.location.phone }}\">{{ mapPopupCtrl.location.phone | telephone}}</a></div><div class=\"push-top clearfix\"><a data-ng-attr-id=\"localPageMapBtn{{mapPopupCtrl.location.number}}\" data-ng-show=\"mapPopupCtrl.location.local_landing_page\" data-ng-href=\"{{mapPopupCtrl.client_route}}{{mapPopupCtrl.location.link}}\" class=\"btn btn-primary btn-sm push-right-xs\" role=\"button\" alt=\"Go to Local Page\" title=\"Go to Local Page\" data-analytics-event=\"Map Pin Local Page\" data-analytics-label=\"{{ mapPopupCtrl.location.entire_location | labelizeLocation }}\" data-analytics-category=\"Store Locator\" data-analytics-value=\"1\" data-analytics-on=\"click\" onclick=\"closeNav()\">View Local Page</a> <a data-ng-attr-id=\"callMapBtn{{mapPopupCtrl.location.number}}\" data-ng-href=\"tel:{{mapPopupCtrl.location.phone}}\" class=\"btn btn-primary btn-sm push-right-xs visible-xs-inline-block\" role=\"button\" ng-show=\"mapPopupCtrl.location.phone\" alt=\"Call this Location\" title=\"Call this Location\" data-analytics-event=\"Map Pin Call\" data-analytics-label=\"{{ mapPopupCtrl.location.entire_location | labelizeLocation }}\" data-analytics-category=\"Store Locator\" data-analytics-value=\"1\" data-analytics-on=\"click\">Call</a> <a data-ng-attr-id=\"getDirectionsMapBtn{{mapPopupCtrl.location.number}}\" data-ng-href=\"{{mapPopupCtrl.location.directionsUrl}}\" class=\"btn btn-primary btn-sm\" rel=\"noopener\" target=\"_blank\" role=\"button\" alt=\"Get Directions to this Location\" title=\"Get Directions to this Location\" data-analytics-event=\"Map Pin Get Directions\" data-analytics-label=\"{{ mapPopupCtrl.location.entire_location | labelizeLocation }}\" data-analytics-category=\"Store Locator\" data-analytics-value=\"1\" data-analytics-on=\"click\">Get Directions</a></div></div>");
$templateCache.put("app/storeLocator/templates/mapPopupMulti.template.html","<div class=\"mf-popup-content\" data-ng-attr-id=\"loc_{{mapPopupCtrl.location.number}}\"><h4>{{mapPopupCtrl.location.name}}</h4><div>{{mapPopupCtrl.location.address}}<br><span ng-if=\"mapPopupCtrl.location.address_extended\">{{mapPopupCtrl.location.address_extended}}<br></span> {{mapPopupCtrl.location.locality}}, {{mapPopupCtrl.location.region}} {{mapPopupCtrl.location.postcode}}<br><span class=\"hidden-xs\">{{ mapPopupCtrl.location.phone | telephone}}</span> <a class=\"visible-xs\" analytics-event=\"Call\" analytics-label=\"{{ mapPopupCtrl.location.entire_location | labelizeLocation }}\" analytics-category=\"Store Locator\" analytics-value=\"1\" analytics-on=\"click\" title=\"{{mapPopupCtrl.translatedMessages[\'mf.cta.callNowButton.tooltip\'] || \'Call\'}}\" ng-href=\"tel:{{ mapPopupCtrl.location.phone }}\">{{ mapPopupCtrl.location.phone | telephone}}</a></div><div class=\"push-top clearfix\"><a data-ng-attr-id=\"localPageMapBtn{{mapPopupCtrl.location.number}}\" data-ng-show=\"mapPopupCtrl.location.local_landing_page\" data-ng-href=\"{{mapPopupCtrl.location.llpUrlWithLanguage}}\" class=\"btn btn-primary btn-sm push-right-xs\" role=\"button\" title=\"{{mapPopupCtrl.translatedMessages[\'mf.storeLocator.localPageButton.tooltip\'] || \'View Local Page\'}}\" data-analytics-event=\"Map Pin Local Page\" data-analytics-label=\"{{ mapPopupCtrl.location.entire_location | labelizeLocation }}\" data-analytics-category=\"Store Locator\" data-analytics-value=\"1\" data-analytics-on=\"click\" onclick=\"closeNav()\">{{mapPopupCtrl.translatedMessages[\'mf.storeLocator.localPageButton.text\'] || \'Local Page\'}}</a> <a data-ng-attr-id=\"callMapBtn{{mapPopupCtrl.location.number}}\" data-ng-href=\"tel:{{mapPopupCtrl.location.phone}}\" class=\"btn btn-primary btn-sm push-right-xs visible-xs-inline-block\" role=\"button\" ng-show=\"mapPopupCtrl.location.phone\" title=\"{{mapPopupCtrl.translatedMessages[\'mf.cta.callNowButton.tooltip\'] || \'Call this Location\'}}\" data-analytics-event=\"Map Pin Call\" data-analytics-label=\"{{ mapPopupCtrl.location.entire_location | labelizeLocation }}\" data-analytics-category=\"Store Locator\" data-analytics-value=\"1\" data-analytics-on=\"click\">{{mapPopupCtrl.translatedMessages[\'mf.cta.callNowButton.text\'] || \'Call\'}}</a> <a data-ng-attr-id=\"getDirectionsMapBtn{{mapPopupCtrl.location.number}}\" data-ng-href=\"{{mapPopupCtrl.location.directionsUrl}}\" class=\"btn btn-primary btn-sm\" rel=\"noopener\" target=\"_blank\" role=\"button\" title=\"{{mapPopupCtrl.translatedMessages[\'mf.cta.getDirectionsButton.tooltip\'] || \'Get Directions to this Location\'}}\" data-analytics-event=\"Map Pin Get Directions\" data-analytics-label=\"{{ mapPopupCtrl.location.entire_location | labelizeLocation }}\" data-analytics-category=\"Store Locator\" data-analytics-value=\"1\" data-analytics-on=\"click\">{{mapPopupCtrl.translatedMessages[\'mf.cta.getDirectionsButton.text\'] || \'Get Directions\'}}</a></div></div>");
$templateCache.put("app/storeLocator/templates/resultsLi.template.html","<li data-ng-attr-id=\"{{resultsLiCtrl.location.id}}\" data-ng-click=\"resultsLiCtrl.showLocationPopup(resultsLiCtrl.location.number)\" class=\"location-li\"><div class=\"clearfix\"><div class=\"col-xs-2\"><div class=\"pr\"><div class=\"location-pin\"></div><div class=\"location-number\">{{resultsLiCtrl.location.number}}</div><div class=\"location-distance\">{{ resultsLiCtrl.regionService.getDistanceString(resultsLiCtrl.location.entire_location.distance) }}</div></div></div><div class=\"col-xs-10\"><div class=\"h3\">{{resultsLiCtrl.location.name}}</div><p>{{resultsLiCtrl.location.address}}</p><p data-ng-if=\"resultsLiCtrl.location.address_extended\">{{resultsLiCtrl.location.address_extended}}</p><p>{{resultsLiCtrl.location.locality}}, {{resultsLiCtrl.location.region}} {{resultsLiCtrl.location.postcode}}</p><p class=\"hidden-xs\">{{resultsLiCtrl.location.phone | telephone}}</p><p class=\"visible-xs\"><a ng-href=\"tel:{{ resultsLiCtrl.location.phone }}\" analytics-event=\"Call\" analytics-label=\"{{ resultsLiCtrl.location.entire_location | labelizeLocation }}\" analytics-category=\"Store Locator\" analytics-value=\"1\" analytics-on=\"click\" title=\"Call\">{{ resultsLiCtrl.location.phone | telephone}}</a></p><hours-card data-location=\"resultsLiCtrl.location.entire_location\" data-only-today=\"true\"></hours-card><div class=\"push-top clearfix store-buttons\"><a data-ng-show=\"resultsLiCtrl.location.local_landing_page\" data-ng-attr-id=\"localPageBtn{{resultsLiCtrl.location.number}}\" data-ng-href=\"{{resultsLiCtrl.client_route}}{{resultsLiCtrl.location.link}}\" class=\"btn btn-sm btn-primary\" role=\"button\" alt=\"Go to Local Page\" title=\"Go to Local Page\" data-analytics-event=\"Local Page\" data-analytics-label=\"{{ resultsLiCtrl.location.entire_location | labelizeLocation }}\" data-analytics-category=\"Store Locator\" data-analytics-value=\"1\" data-analytics-on=\"click\">Local Page</a> <a data-ng-attr-id=\"callBtn{{resultsLiCtrl.location.number}}\" data-ng-href=\"tel:{{ resultsLiCtrl.location.phone }}\" class=\"btn btn-sm btn-primary visible-xs-inline-block\" role=\"button\" ng-show=\"resultsLiCtrl.location.phone\" alt=\"Call this Location\" title=\"Call this Location\" data-analytics-event=\"Call\" data-analytics-label=\"{{ resultsLiCtrl.location.entire_location | labelizeLocation }}\" data-analytics-category=\"Store Locator\" data-analytics-value=\"1\" data-analytics-on=\"click\">Call</a> <a data-ng-attr-id=\"getDirectionsBtn{{resultsLiCtrl.location.number}}\" data-ng-href=\"{{resultsLiCtrl.location.directionsUrl}}\" rel=\"noopener\" target=\"_blank\" class=\"btn btn-sm btn-primary\" role=\"button\" alt=\"Get Directions to this Location\" title=\"Get Directions to this Location\" data-analytics-event=\"Get Directions\" data-analytics-label=\"{{ resultsLiCtrl.location.entire_location | labelizeLocation }}\" data-analytics-category=\"Store Locator\" data-analytics-value=\"1\" data-analytics-on=\"click\">Get Directions</a></div></div></div></li>");
$templateCache.put("app/custom/clients/burberry/layout.html","<div ng-controller=\"templateController as controller\" itemscope=\"\" itemtype=\"https://schema.org/ClothingStore\"><header class=\"header-visible\" id=\"header\"><a href=\"#customContainer\" class=\"sr-only\">Skip to Main Content</a> <a href=\"#footer\" class=\"sr-only\">Skip to Footer</a><div class=\"header-container\"><a target=\"_self\" href=\"https://www.burberry.com/\" title=\"Burberry\" aria-label=\"Click to return to the Burberry homepage\" class=\"header-logo\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewbox=\"0 1 124 20\" preserveaspectratio=\"xMinYMid meet\" class=\"logo-svg\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M91.2399 18.8959L86.4659 12.103C86.4439 12.0727 86.4294 12.0376 86.4237 12.0007C86.418 11.9637 86.4211 11.9259 86.4329 11.8904C86.4446 11.8548 86.4647 11.8226 86.4914 11.7963C86.5181 11.77 86.5507 11.7503 86.5865 11.739C87.6536 11.388 88.5818 10.7099 89.2384 9.80166C89.8949 8.89345 90.2462 7.80168 90.242 6.68259C90.242 6.68259 90.5783 1.00002 83.7755 1.00002C81.7869 0.968234 79.8175 1.39038 78.0182 2.2341V2.52896C78.3238 2.63504 78.5899 2.83108 78.7811 3.09111C78.9724 3.35114 79.0798 3.6629 79.0892 3.9851V18.885C79.1088 19.1802 79.0456 19.475 78.9069 19.7366C78.7681 19.9982 78.5592 20.2163 78.3033 20.3666V20.7306H82.4266V20.3666C82.4266 20.3666 81.8089 20.0026 81.8089 18.9105V12.4416C81.8089 12.345 81.8474 12.2525 81.9159 12.1842C81.9845 12.1159 82.0775 12.0776 82.1744 12.0776H83.0152C83.1113 12.0778 83.2061 12.1011 83.2913 12.1454C83.3766 12.1898 83.4499 12.2539 83.505 12.3324L89.2952 20.5705C89.3289 20.6163 89.3729 20.6537 89.4236 20.6797C89.4744 20.7056 89.5306 20.7193 89.5876 20.7197H92.8483V20.3557C92.2069 20.0054 91.6601 19.5058 91.2545 18.8995L91.2399 18.8959ZM83.2308 10.5996H82.1671C82.0701 10.5996 81.9772 10.5612 81.9086 10.493C81.8401 10.4247 81.8015 10.3321 81.8015 10.2356V3.44269C81.8004 3.29811 81.8527 3.15817 81.9484 3.04945C82.0441 2.94073 82.1766 2.8708 82.3206 2.85295C82.7108 2.80011 83.1039 2.77214 83.4977 2.76923C85.8189 2.76923 87.2847 4.20352 87.2847 6.68623C87.2847 9.46016 85.6727 10.5996 83.2308 10.5996ZM39.8188 12.103L44.5964 18.8959V18.8995C45.0038 19.5056 45.5517 20.005 46.1939 20.3557V20.7197H42.9405C42.8828 20.7199 42.8259 20.7064 42.7745 20.6805C42.723 20.6545 42.6785 20.6168 42.6444 20.5705L36.8579 12.3324C36.8021 12.2536 36.7282 12.1893 36.6423 12.145C36.5565 12.1006 36.4611 12.0775 36.3644 12.0776H35.5273C35.4303 12.0776 35.3373 12.1159 35.2688 12.1842C35.2002 12.2525 35.1617 12.345 35.1617 12.4416V18.9105C35.1617 20.0026 35.7831 20.3666 35.7831 20.3666V20.7306H31.6598V20.3666C31.915 20.2158 32.1232 19.9975 32.2613 19.736C32.3994 19.4744 32.462 19.1798 32.4421 18.885V3.9851C32.4327 3.6629 32.3253 3.35114 32.134 3.09111C31.9427 2.83108 31.6767 2.63504 31.371 2.52896V2.2341C33.1706 1.39124 35.1399 0.969136 37.1284 1.00002C43.9348 1.00002 43.5985 6.68259 43.5985 6.68259C43.6022 7.80155 43.2507 8.89305 42.5942 9.80116C41.9377 10.7093 41.0098 11.3875 39.943 11.739C39.9069 11.7499 39.874 11.7692 39.8468 11.7954C39.8197 11.8215 39.7992 11.8537 39.7871 11.8893C39.7749 11.9248 39.7715 11.9628 39.777 12C39.7825 12.0371 39.7968 12.0725 39.8188 12.103ZM35.5236 10.5996H36.591C39.0328 10.5996 40.6412 9.46016 40.6412 6.68623C40.6412 4.20352 39.1754 2.76923 36.8579 2.76923C36.4629 2.77214 36.0685 2.8001 35.6771 2.85295C35.5334 2.87155 35.4014 2.9417 35.3058 3.05025C35.2103 3.15881 35.1577 3.29833 35.1581 3.44269V10.2356C35.1581 10.3321 35.1966 10.4247 35.2651 10.493C35.3337 10.5612 35.4267 10.5996 35.5236 10.5996ZM10.0907 10.213C10.1144 10.2433 10.1452 10.2673 10.1804 10.2829V10.3011C12.0483 11.1092 13.3387 12.8712 13.3387 15.2811C13.3387 18.7357 10.8201 20.7416 7.7203 20.7416H0.28878V20.3775C0.543689 20.2264 0.751671 20.0081 0.889727 19.7466C1.02778 19.4851 1.09054 19.1907 1.07105 18.8959V4.11615C1.06167 3.79396 0.954237 3.4822 0.762973 3.22216C0.571709 2.96213 0.305638 2.76609 0 2.66002V2.36515C1.25382 1.6116 3.2899 1.00002 5.70615 1.00002C11.9496 1.00002 11.6389 6.21662 11.6389 6.21662C11.6556 6.90244 11.5287 7.5842 11.2663 8.21847C11.0039 8.85275 10.6116 9.42564 10.1146 9.90064C10.0866 9.927 10.0656 9.95984 10.0534 9.99625C10.0412 10.0326 10.0382 10.0715 10.0448 10.1093C10.0513 10.1471 10.0671 10.1828 10.0907 10.213ZM3.96999 2.95305C3.87518 3.06152 3.82316 3.20059 3.8236 3.3444H3.81628V9.42012C3.81628 9.51667 3.8548 9.60926 3.92335 9.67753C3.9919 9.7458 4.08488 9.78415 4.18183 9.78415H5.48682C7.65816 9.78415 9.12033 8.60832 9.12033 6.30035C9.12033 3.99238 7.7532 2.66002 5.59283 2.66002C5.17328 2.66452 4.75446 2.69614 4.33901 2.75466C4.19593 2.77407 4.06479 2.84457 3.96999 2.95305ZM4.2988 19.2454H6.42262L6.42993 19.2381C8.78769 19.2381 10.3413 17.731 10.3413 15.2556C10.3413 12.7292 8.78769 11.273 6.42993 11.273H4.18914C4.09219 11.273 3.99921 11.3114 3.93066 11.3797C3.86211 11.4479 3.8236 11.5405 3.8236 11.6371V18.7685C3.82359 18.8943 3.87354 19.0151 3.96256 19.1044C4.05157 19.1938 4.17244 19.2444 4.2988 19.2454ZM57.9351 10.2829C57.8999 10.2673 57.8691 10.2433 57.8455 10.213C57.8218 10.1828 57.806 10.1471 57.7995 10.1093C57.793 10.0715 57.7959 10.0326 57.8081 9.99625C57.8203 9.95984 57.8413 9.927 57.8693 9.90064C58.3664 9.42564 58.7586 8.85275 59.021 8.21847C59.2835 7.5842 59.4104 6.90244 59.3937 6.21662C59.3937 6.21662 59.708 1.00002 53.4609 1.00002C51.0556 1.00002 49.0122 1.6116 47.7547 2.36515V2.66002C48.0608 2.76594 48.3273 2.96183 48.5192 3.22182C48.7111 3.48181 48.8193 3.79365 48.8294 4.11615V18.8959C48.8486 19.1911 48.7853 19.4857 48.6465 19.7472C48.5078 20.0087 48.2991 20.2269 48.0435 20.3775V20.7416H55.475C58.5785 20.7416 61.0935 18.7357 61.0935 15.2811C61.0935 12.8712 59.8067 11.1092 57.9351 10.3011V10.2829ZM51.5783 3.3444C51.578 3.20004 51.6305 3.06052 51.7261 2.95196C51.8216 2.84341 51.9537 2.77326 52.0974 2.75466C52.5189 2.69507 52.9438 2.66345 53.3695 2.66002C55.5299 2.66002 56.8933 3.99238 56.8933 6.30035C56.8933 8.60832 55.4312 9.78415 53.2598 9.78415H51.9548C51.8579 9.78415 51.7649 9.7458 51.6964 9.67753C51.6278 9.60926 51.5893 9.51667 51.5893 9.42012V3.3444H51.5783ZM54.1773 19.2454H52.0462C51.9833 19.2454 51.9211 19.233 51.863 19.2091C51.8049 19.1851 51.7521 19.15 51.7076 19.1057C51.6632 19.0614 51.6279 19.0089 51.6038 18.951C51.5797 18.8931 51.5674 18.8311 51.5674 18.7685V11.6371C51.5674 11.5405 51.6059 11.4479 51.6744 11.3797C51.743 11.3114 51.836 11.273 51.9329 11.273H54.1737C56.5351 11.273 58.0887 12.7292 58.0887 15.2556C58.0887 17.731 56.5351 19.2381 54.1737 19.2381L54.1773 19.2454ZM25.7599 1.65892V1.29489H29.0352V1.65892C28.7796 1.80864 28.5708 2.0261 28.432 2.28706C28.2933 2.54802 28.23 2.84223 28.2493 3.1369V15.3247C28.2493 18.9505 26.2497 21 22.4006 21C18.5514 21 16.1059 18.9651 16.1059 15.3247V3.14782C16.1252 2.85315 16.0619 2.55894 15.9231 2.29798C15.7844 2.03702 15.5755 1.81956 15.32 1.66984V1.30581H19.4433V1.66984C19.4433 1.66984 18.8255 2.03388 18.8255 3.12598V14.8588C18.8255 17.9458 19.9697 19.2599 22.5651 19.2599C25.1604 19.2599 26.3777 17.9895 26.3777 15.1973V3.11506C26.374 2.02296 25.7599 1.65892 25.7599 1.65892ZM102.93 12.103L107.704 18.8959V18.8995C108.11 19.5058 108.656 20.0054 109.298 20.3557V20.7197H106.052C105.994 20.7199 105.937 20.7064 105.886 20.6805C105.834 20.6545 105.79 20.6168 105.756 20.5705L99.9691 12.3324C99.914 12.2539 99.8407 12.1898 99.7554 12.1454C99.6702 12.1011 99.5755 12.0778 99.4793 12.0776H98.6385C98.5416 12.0776 98.4486 12.1159 98.38 12.1842C98.3115 12.2525 98.273 12.345 98.273 12.4416V18.9105C98.273 20.0026 98.8907 20.3666 98.8907 20.3666V20.7306H94.7674V20.3666C95.0233 20.2163 95.2322 19.9982 95.371 19.7366C95.5098 19.475 95.5729 19.1802 95.5533 18.885V3.9851C95.5432 3.6626 95.435 3.35075 95.2431 3.09077C95.0512 2.83078 94.7847 2.63488 94.4786 2.52896V2.2341C96.2794 1.39082 98.2499 0.968709 100.24 1.00002C107.042 1.00002 106.706 6.68259 106.706 6.68259C106.71 7.80168 106.359 8.89344 105.702 9.80166C105.046 10.7099 104.118 11.388 103.051 11.739C103.015 11.7503 102.982 11.77 102.956 11.7963C102.929 11.8226 102.909 11.8548 102.897 11.8904C102.885 11.9259 102.882 11.9637 102.888 12.0007C102.894 12.0376 102.908 12.0727 102.93 12.103ZM98.6312 10.5996H99.6949C102.137 10.5996 103.749 9.46016 103.749 6.68623C103.749 4.20352 102.283 2.76923 99.9618 2.76923C99.5668 2.77214 99.1725 2.8001 98.7811 2.85295C98.6377 2.87162 98.5061 2.9419 98.4111 3.05054C98.3162 3.15918 98.2645 3.29867 98.2657 3.44269V10.2356C98.2657 10.3321 98.3042 10.4247 98.3727 10.493C98.4413 10.5612 98.5343 10.5996 98.6312 10.5996ZM120.293 1.28397V1.648C120.293 1.648 121.068 1.90283 120.407 3.10414L116.711 9.73683C116.69 9.77308 116.659 9.80316 116.623 9.82407C116.586 9.84497 116.545 9.85597 116.503 9.85597C116.461 9.85597 116.419 9.84497 116.383 9.82407C116.346 9.80316 116.316 9.77308 116.294 9.73683L112.588 3.08594C111.926 1.89919 112.701 1.6298 112.701 1.6298V1.26577H107.872V1.6298C108.553 1.92243 109.115 2.43555 109.466 3.08594L114.441 12.012C114.529 12.1716 114.575 12.3506 114.576 12.5326V18.885C114.596 19.1802 114.533 19.475 114.394 19.7366C114.255 19.9982 114.046 20.2163 113.79 20.3666V20.7306H118.071V20.3666C117.815 20.2163 117.606 19.9982 117.467 19.7366C117.329 19.475 117.265 19.1802 117.285 18.885V12.5617C117.286 12.3797 117.332 12.2007 117.42 12.0412L122.406 3.11506C122.757 2.46467 123.319 1.95155 124 1.65892V1.29489L120.293 1.28397ZM67.8524 19.2563H73.7449C74.0414 19.2758 74.3374 19.2129 74.6001 19.0747C74.8628 18.9365 75.0818 18.7284 75.2327 18.4736H75.5983V20.7416H63.8716V20.3775C64.1265 20.2264 64.3345 20.0081 64.4725 19.7466C64.6106 19.4851 64.6733 19.1907 64.6539 18.8959V3.1369C64.6735 2.8426 64.6108 2.54863 64.4727 2.28771C64.3346 2.02678 64.1265 1.80912 63.8716 1.65892V1.29489H74.7867V3.54826H74.4212C74.2682 3.29517 74.048 3.08914 73.7848 2.95294C73.5216 2.81674 73.2257 2.75568 72.9298 2.77651H67.8487C67.7217 2.77651 67.5999 2.82675 67.5101 2.91618C67.4203 3.00562 67.3699 3.12691 67.3699 3.25339V9.48564C67.3699 9.58219 67.4084 9.67478 67.4769 9.74305C67.5455 9.81132 67.6384 9.84968 67.7354 9.84968H70.9485C72.0452 9.84968 72.4107 9.22354 72.4107 9.22354H72.7762V11.9574H72.4107C72.4107 11.9574 72.0452 11.3277 70.9485 11.3277H67.739C67.6421 11.3277 67.5491 11.366 67.4806 11.4343C67.412 11.5025 67.3735 11.5951 67.3735 11.6917V18.7794C67.3735 18.9059 67.424 19.0272 67.5138 19.1166C67.6036 19.2061 67.7254 19.2563 67.8524 19.2563Z\" fill=\"currentColor\"></path></svg></a></div></header><div class=\"mf-style\" id=\"customContainer\"><div ui-view=\"\"></div></div><layout-footer data-language=\"{{currentLang}}\"></layout-footer><button class=\"back-to-top-btn\" ng-click=\"controller.backToTop()\" id=\"scrollBtn\" title=\"Go to top\"><i class=\"custom-icon chevron-large\"></i></button></div>");
$templateCache.put("app/custom/clients/burberry/localLanding.html","<div class=\"local-landing\" id=\"local-landing\"><div ng-if=\"localLanding.error\" class=\"mf-loading-container\"><error-card location-error=\"localLanding.error\"></error-card></div><div data-ng-show=\"!localLanding.location.store_info\" class=\"text-center push-bottom-lg\"><div class=\"mf-loader text-center mf-loading-list push-top\"><i class=\"ico ico-spinner ico-spin\"></i></div></div><div ng-show=\"!localLanding.error\"><div ng-if=\"localLanding.location.store_info\"><address-breadcrumb-card location=\"localLanding.location.store_info\" sitemap-levels=\"{{controller.getSitemapLevelsForLPBreadcrumb(localLanding.location.store_info)}}\" char-separator=\"&rsaquo;\"></address-breadcrumb-card><div class=\"hero-section\"><image-card class=\"hero-image\" id=\"hero\" location=\"localLanding.location\" visibility=\"LLP\" custom-field=\"store_image\" role=\"presentation\"></image-card><div class=\"hero-card\"><div class=\"border\"></div><div class=\"hero-content\"><p class=\"store-type\">{{controller.getStoreTypeFromTags(localLanding.location.tags)}}</p><h1 class=\"store-name\">{{controller.getCustomFieldValueByName(localLanding.location.custom_fields, \'store_name\')}}</h1><button-card location=\"localLanding.location\" visibility=\"LLP\" target=\"_blank\" custom-link=\"{{localLanding.location.store_info.directionsUrl}}\" snowplow-tracking=\"\" data-snowplow-context=\"Store Page\" data-snowplow-description=\"click to get directions to the store\" data-snowplow-name=\"get directions\" data-snowplow-component=\"cta-link\">{{localLanding.storeFindersMessages[\'mf.common.getDirections\'] || \'Get Directions\'}}</button-card></div></div></div><html-card class=\"pop-up-information\" location=\"localLanding.location\" html-content=\"pop_up_information\"></html-card><div class=\"section-container\"><div class=\"address-section\"><h2>{{localLanding.storeFindersMessages[\'mf.localPage.addressSection.address\'] || \'Address\'}}</h2><div class=\"address-information\"><span ng-if=\"localLanding.location.store_info.address_extended\">{{localLanding.location.store_info.address_extended}}</span> <span>{{localLanding.location.store_info.address}}</span> <span>{{localLanding.location.store_info.locality}}</span> <span>{{localLanding.location.store_info.region}}</span> <span>{{localLanding.location.store_info.postcode}}</span><button-card class=\"primary-cta\" target=\"_blank\" custom-field=\"book_appointment\" location=\"localLanding.location\" visibility=\"Store Locator\" custom-text=\"{{localLanding.storeFindersMessages[\'mf.common.bookAnAppointment\'] || \'Book an appointment\'}}\" snowplow-tracking=\"\" data-snowplow-context=\"Store Page\" data-snowplow-description=\"click to book an appointment in store\" data-snowplow-name=\"book an appointment\" data-snowplow-component=\"cta-button\"></button-card></div></div><div class=\"hours-section\" ng-if=\"!controller.getCustomFieldValueByName(localLanding.location.custom_fields, \'pop_up_information\')\"><h2>{{localLanding.storeFindersMessages[\'mf.localPage.hoursSection.openingTimes\'] || \'Opening times\'}}</h2><hours-card-burberry location=\"localLanding.location\" simplified=\"true\" data-translated-messages=\"localLanding.storeFindersMessages\"></hours-card-burberry></div></div><store-services-card location-tags=\"localLanding.location.tags\" window-width=\"localLanding.windowWidth\" translated-messages=\"localLanding.storeFindersMessages\"></store-services-card><about-card-burberry about-text=\"{{controller.getAboutTextByLanguage(localLanding.location.custom_fields)}}\" window-width=\"localLanding.windowWidth\" translated-messages=\"localLanding.storeFindersMessages\"></about-card-burberry><payment-options-card location-payment-options=\"{{controller.getCustomFieldValueByName(localLanding.location.custom_fields, \'payment_options\')}}\" translated-messages=\"localLanding.storeFindersMessages\"></payment-options-card><div class=\"contact-burberry\"><a href=\"https://www.burberry.com/customer-service/contact-us/\" target=\"_self\" snowplow-tracking=\"\" data-snowplow-context=\"Store Page\" data-snowplow-description=\"click to contact Burberry\" data-snowplow-name=\"contact Burberry\" data-snowplow-component=\"cta-button\">{{controller.getCtaContactText()}}</a></div><nearby-card-burberry locations=\"localLanding.nearbyLocations\" data-translated-messages=\"localLanding.storeFindersMessages\"></nearby-card-burberry></div></div></div>");
$templateCache.put("app/custom/clients/burberry/storeLocator.html","<div class=\"store-locator-container\" id=\"store-locator\"><div class=\"alert alert-danger\" role=\"alert\" data-ng-show=\"storeLocatorCtrl.locatorStates.errors\">{{storeLocatorCtrl.locatorStates.errors}}</div><div class=\"alert alert-info\" role=\"alert\" data-ng-show=\"storeLocatorCtrl.locatorStates.notifications\">{{storeLocatorCtrl.notifications}}</div><div id=\"global-locations-map-container\" class=\"col-xs-12 col-sm-8 col-md-8 col-xl-8 locations-map-container show-map\"><map data-locator-states=\"storeLocatorCtrl.locatorStates\" data-map-obj=\"storeLocatorCtrl.mapObj\" data-is-google-maps-api-loaded=\"isGoogleMapsApiLoaded\"></map><search-burberry hide-filter-button=\"true\" ng-if=\"storeLocatorCtrl.window.screen.availWidth <= 767\" data-hide-element-name=\"filters\" data-locator-states=\"storeLocatorCtrl.locatorStates\" data-map-obj=\"storeLocatorCtrl.mapObj\" data-is-google-maps-api-loaded=\"isGoogleMapsApiLoaded\" data-translated-messages=\"storeLocatorCtrl.translatedMessages\"></search-burberry></div><div class=\"search-container-burberry mobile-search-container col-xs-12 col-sm-4 col-md-4 col-xl-4\"><div class=\"column-heading\"><div class=\"store-locator-title\"><h1>{{storeLocatorCtrl.translatedMessages[\'mf.storeLocator.heading.title\'] || \'Find a Store\'}}</h1><search-burberry hide-filter-button=\"true\" ng-if=\"storeLocatorCtrl.window.screen.availWidth <= 767\" data-hide-element-name=\"search\" data-locator-states=\"storeLocatorCtrl.locatorStates\" data-map-obj=\"storeLocatorCtrl.mapObj\" data-is-google-maps-api-loaded=\"isGoogleMapsApiLoaded\" data-translated-messages=\"storeLocatorCtrl.translatedMessages\"></search-burberry><search-burberry hide-filter-button=\"true\" ng-if=\"storeLocatorCtrl.window.screen.availWidth > 767\" data-locator-states=\"storeLocatorCtrl.locatorStates\" data-map-obj=\"storeLocatorCtrl.mapObj\" data-is-google-maps-api-loaded=\"isGoogleMapsApiLoaded\" data-translated-messages=\"storeLocatorCtrl.translatedMessages\"></search-burberry></div></div><div class=\"clearfix push-bottom store-locator-content\"><div class=\"locations-container show-list\" ng-if=\"storeLocatorCtrl.translatedMessages\"><results-multi data-locator-states=\"storeLocatorCtrl.locatorStates\" data-map-obj=\"storeLocatorCtrl.mapObj\" data-translated-messages=\"storeLocatorCtrl.translatedMessages\"></results-multi></div></div><a href=\"{{storeLocatorCtrl.languageService.updateLinkUrl(\'site-map/all\')}}\" class=\"sitemap-link-container list-alignment\" aria-label=\"Discover all the Stores\" rel=\"noopener\" target=\"_self\"><span class=\"sitemap-link\">{{storeLocatorCtrl.translatedMessages[\'mf.storeLocator.resultList.discoverAllStores\'] || \'Discover all the Stores\'}}</span></a></div></div>");
$templateCache.put("app/localLanding/cards/aaa/aboutAaa.directive.html","<div class=\"agent-local-page\"><image-card class=\"visible-xs mobile-image-container\" location=\"location\" visibility=\"LLP\" custom-field=\"{{customFieldDescriptionImage}}\" role=\"presentation\"></image-card><div class=\"container\"><div class=\"agent-section\"><div class=\"description-container left\"><h3>{{title}}</h3><hr><div itemprop=\"description\" data-ng-bind-html=\"description\"></div></div><image-card class=\"visible-sm visible-md visible-lg desktop-img-container\" location=\"location\" visibility=\"LLP\" custom-field=\"{{customFieldDescriptionImage}}\" role=\"presentation\"></image-card></div></div></div>");
$templateCache.put("app/localLanding/cards/aaa/agentInfoAaa.directive.html","<div class=\"agent-info\"><contact-us-form-agent-aaa-acg show-modal=\"agentInfoCtrl.showContactUsFormModal\" recipient-email=\"agentInfoCtrl.recipientEmail\"></contact-us-form-agent-aaa-acg><quote-form-agent-aaa-acg show-modal=\"agentInfoCtrl.showQuoteFormModal\" recipient-email=\"agentInfoCtrl.recipientEmail\"></quote-form-agent-aaa-acg><div class=\"top-section\"><image-card class=\"agent-image\" location=\"location\" visibility=\"LLP\" custom-field=\"locator_agent_image\"></image-card><div class=\"agent-info-title\"><h1 ng-if=\"aaaType === \'meemic\'\">{{location.store_info.name}}</h1><h1 ng-if=\"aaaType === \'acg\'\" ng-bind-html=\"agentInfoCtrl.storeName | splitToTwoLines:\'-\'\"></h1><p ng-if=\"showDescription\">{{agentInfoCtrl.getCustomFieldValueByName(location.custom_fields, descriptionCustomField)}}</p></div></div><div class=\"info-section\"><div class=\"info-col address\"><a ng-href=\"{{agentInfoCtrl.getDirectionsUrl(location.store_info, directionIconClickableOnDesktop)}}\" ng-class=\"{\'disabled\': hideAddress}\"><img ng-src=\"{{agentInfoCtrl.getImageRoute(\'address-icon.svg\')}}\" alt=\"Address\"></a> <a class=\"mt-3\" ng-href=\"{{agentInfoCtrl.getDirectionsUrl(location.store_info, directionTextClickableOnDesktop)}}\" ng-class=\"{\'disabled\': hideAddress}\"><span ng-if=\"!hideAddress\">{{ location.store_info.address }}<span class=\"address-extended\" data-ng-if=\"showAddressExtended && location.store_info.address_extended\">, {{location.store_info.address_extended}}</span></span> <span>{{ location.store_info.locality }}, {{ location.store_info.region }} {{ location.store_info.postcode }}</span></a></div><div class=\"info-col email\" ng-if=\"location.store_info.email\"><span ng-click=\"agentInfoCtrl.openContactUsFormModal()\"><img ng-src=\"{{agentInfoCtrl.getImageRoute(\'email-icon.svg\')}}\" alt=\"Email\"></span> <span class=\"visible-xs email-label-mobile\" ng-click=\"agentInfoCtrl.openContactUsFormModal()\">Email</span> <span class=\"mt-3 hidden-xs\">Email:</span> <span class=\"hidden-xs show-meemic\" ng-click=\"agentInfoCtrl.openContactUsFormModal()\">{{location.store_info.email}}</span></div><div class=\"info-col phone hidden-xs\"><img ng-src=\"{{agentInfoCtrl.getImageRoute(\'call-icon.svg\')}}\" alt=\"Call\"> <span class=\"mt-3\">Call:</span> <span>{{ location.store_info.phone | telephone }}</span></div><div class=\"info-col get-quote hidden-xs\"><img ng-src=\"{{agentInfoCtrl.getImageRoute(\'quote-icon.svg\')}}\" ng-click=\"agentInfoCtrl.openQuoteFormModal()\" alt=\"Get a Quote\"> <span class=\"mt-3\" ng-click=\"agentInfoCtrl.openQuoteFormModal()\">{{agentInfoCtrl.getCustomFieldValueByName(location.custom_fields, quoteCtaTextCustomField)}}</span></div><div class=\"bottom-section\"><div class=\"info-col phone\"><a href=\"tel:{{ location.store_info.phone }}\" rel=\"noopener\" target=\"_blank\" title=\"Call\"><img ng-src=\"{{agentInfoCtrl.getImageRoute(\'call-icon.svg\')}}\" alt=\"Call\"></a> <span class=\"mt-3\">Call:</span> <a href=\"tel:{{ location.store_info.phone }}\" rel=\"noopener\" target=\"_blank\" title=\"Call\">{{ location.store_info.phone | telephone }}</a></div><div class=\"info-col\"><img ng-src=\"{{agentInfoCtrl.getImageRoute(\'quote-icon.svg\')}}\" ng-click=\"agentInfoCtrl.openQuoteFormModal()\" alt=\"Get a Cuote\"> <span class=\"mt-3\" ng-click=\"agentInfoCtrl.openQuoteFormModal()\">{{agentInfoCtrl.getCustomFieldValueByName(location.custom_fields, quoteCtaTextCustomField)}}</span></div></div></div></div>");
$templateCache.put("app/localLanding/cards/aaa/featuredProductsCard.directive.html","<div class=\"featured-products-card\" ng-show=\"cardCtrl.featuredProductsCustomFieldsArray.length > 0\"><quote-form-agent-aaa-acg show-modal=\"cardCtrl.showModal\" recipient-email=\"cardCtrl.recipientEmail\"></quote-form-agent-aaa-acg><h3 class=\"subtitle-text\" ng-class=\"cardCtrl.client === \'meemic\' ? \'bold-700\' : \'subtitle-weight\'\">{{cardCtrl.getCustomFieldValueByName(null, \'locator_product_subtitle_text\')}}</h3><h3 class=\"title-text\">{{cardCtrl.getCustomFieldValueByName(null, \'locator_product_title_text\')}}</h3><hr ng-class=\"cardCtrl.client === \'acg\' ? \'separator-line acg\' : \'separator-line meemic\'\"><div class=\"featured-products-card-list\"><div ng-repeat=\"featuredProduct in cardCtrl.featuredProductsCustomFieldsArray track by $index\" class=\"featured-products-card-item col-md-4 col-sm-6 col-xs-12\"><div class=\"featured-products-card-item-image\"><img ng-src=\"{{featuredProduct.source}}\" alt=\"{{featuredProduct.title}}\" ng-class=\"cardCtrl.client === \'meemic\' ? \'meemic\' : \'\'\"></div><div class=\"featured-products-card-item-content\"><div ng-class=\"cardCtrl.client === \'acg\' ? \'title\' : \'title meemic\'\">{{featuredProduct.title}}</div><html-card class=\"body-content\" location=\"cardCtrl.location\" html-content=\"{{featuredProduct.text_custom_field_name}}\"></html-card><div class=\"cta-button push-top\"><a ng-show=\"cardCtrl.showCTALink(featuredProduct) && featuredProduct.button_text\" ng-class=\"cardCtrl.client === \'acg\' ? \'acg\' : \'meemic\'\" href=\"{{featuredProduct.button_link}}\" target=\"_blank\">{{featuredProduct.button_text}}</a> <a ng-show=\"cardCtrl.showCTAModal(featuredProduct) && featuredProduct.button_text\" ng-class=\"cardCtrl.client === \'acg\' ? \'quote-link acg\' : \'quote-link meemic\'\" ng-click=\"cardCtrl.openQuoteFormModal()\">{{featuredProduct.button_text}}</a></div></div></div></div></div>");
$templateCache.put("app/localLanding/cards/multilingual/aboutCardMulti.directive.html","<div class=\"push-bottom-xl text-center\"><h3 class=\"bold-500\" ng-if=\"aboutCardMultiCtrl.hasTitle\">{{aboutCardMultiCtrl.title}}</h3><h3 class=\"bold-500\" ng-if=\"!aboutCardMultiCtrl.hasTitle\">{{aboutCardMultiCtrl.aboutText}} {{ aboutCardMultiCtrl.location.store_info.name }}, {{ aboutCardMultiCtrl.location.store_info.locality }}</h3><p data-ng-bind-html=\"aboutCardMultiCtrl.description\" itemprop=\"description\"></p></div>");
$templateCache.put("app/localLanding/cards/multilingual/addressCardMulti.directive.html","<div class=\"push-bottom-lg address-card\"><div ng-if=\"location.status.toLowerCase() === \'temp closed\'\" class=\"no-margin temp-closed\">{{ addressCardMultiC.tempClosedText }}</div><meta itemprop=\"name\" content=\"{{addressCardMultiC.storeSEOName}}\"><h1 data-ng-bind-html=\"addressCardMultiC.storeName\" itemprop=\"storeName\" aria-live=\"polite\" class=\"no-margin\"></h1><h3 data-ng-if=\"addressCardMultiC.nameExtendedConfig\" ng-repeat=\"item in addressCardMultiC.nameExtendedConfig track by $index\">{{item}}</h3><h3 data-ng-if=\"addressCardMultiC.nameExtended && !nameExtendedConfig\">{{addressCardMultiC.nameExtended}}</h3><div itemprop=\"address\" itemscope=\"\" itemtype=\"http://schema.org/PostalAddress\"><div class=\"no-bold line-height-bump\" ng-show=\"!addressLink\"><span ng-if=\"addressCardMultiC.addressExtended\" itemprop=\"streetAddress\">{{ location.store_info.address }}</span> <span ng-if=\"!addressCardMultiC.addressExtended\" ng-style=\"{\'padding-top\':\'10px\',\'margin-bottom\':\'0px\',\'padding-bottom\':\'0px\'}\" itemprop=\"streetAddress\">{{ location.store_info.address }}</span><br><p ng-if=\"location.store_info.address_extended\" ng-style=\"{\'margin-bottom\':\'0px\'}\">{{ location.store_info.address_extended }}</p><span itemprop=\"addressLocality\">{{ location.store_info.locality }}</span>, <span itemprop=\"addressRegion\">{{ location.store_info.region }}</span> <span itemprop=\"postalCode\">{{ location.store_info.postcode }}</span></div><div class=\"no-bold line-height-bump\" ng-show=\"addressLink\"><a ng-href=\"{{addressLink}}\" title=\"{{addressLinkTitle}}\" rel=\"noopener\" target=\"_blank\"><span itemprop=\"streetAddress\">{{ location.store_info.address }}<br ng-if=\"location.store_info.address_extended\">{{ location.store_info.address_extended }}</span><br><span itemprop=\"addressLocality\">{{ location.store_info.locality }}</span>, <span itemprop=\"addressRegion\">{{ location.store_info.region }}</span> <span itemprop=\"postalCode\">{{ location.store_info.postcode }}</span></a></div><div class=\"visible-xs\"><a ng-href=\"tel:{{ location.store_info.phone }}\" analytics-event=\"Call\" analytics-label=\"{{ location | labelizeLocation }}\" analytics-category=\"LLP\" analytics-value=\"1\" analytics-on=\"click\" aria-label=\"telephone number\" title=\"{{addressCardMultiC.callText}}\">{{ location.store_info.phone | telephone}}</a></div><div class=\"hidden-xs tel-number\" itemprop=\"telephone\"><span ng-if=\"addressCardMultiC.mainPhoneTitle\">{{ addressCardMultiC.mainPhoneTitle }}</span>{{ location.store_info.phone | telephone}}</div><div ng-if=\"addressCardMultiC.altPhone\" class=\"visible-xs\"><a ng-href=\"tel:{{ addressCardMultiC.altPhone }}\" analytics-event=\"Call\" analytics-label=\"{{ location | labelizeLocation }}\" analytics-category=\"LLP\" analytics-value=\"1\" analytics-on=\"click\" title=\"{{addressCardMultiC.callText}}\">{{ addressCardMultiC.altPhone | telephone}}</a></div><div class=\"hidden-xs tel-number\" itemprop=\"telephone\" ng-if=\"addressCardMultiC.altPhoneTitle\"><span>{{ addressCardMultiC.altPhoneTitle }}</span>{{ addressCardMultiC.altPhone | telephone}}</div></div><span itemprop=\"geo\" itemscope=\"\" itemtype=\"http://schema.org/GeoCoordinates\"><meta itemprop=\"latitude\" content=\"{{ location.store_info.latitude }}\"><meta itemprop=\"longitude\" content=\"{{ location.store_info.longitude }}\"></span><partner-reviews-card-multi location=\"location\" partnertype=\"custom\" data-translated-messages=\"addressCardMultiC.translatedMessages\"></partner-reviews-card-multi><div class=\"push-top flex-buttons-nap\"><a ng-if=\"addressCardMultiC.showGetDirections\" href=\"{{addressCardMultiC.directionsUrl}}\" rel=\"noopener\" target=\"_blank\" class=\"btn btn-primary get-directions\" analytics-event=\"Get Directions\" analytics-label=\"{{ location | labelizeLocation }}\" analytics-category=\"LLP\" analytics-value=\"1\" analytics-on=\"click\" title=\"{{ addressCardMultiC.getDirectionsText }}\">{{ addressCardMultiC.getDirectionsText }}</a> <a ng-show=\"addressCardMultiC.menuLink\" ng-href=\"{{addressCardMultiC.menuLink}}\" rel=\"noopener\" target=\"_blank\" class=\"btn btn-primary push-left-xs\" analytics-event=\"View the Menu\" analytics-label=\"{{ location | labelizeLocation }}\" analytics-category=\"LLP\" analytics-value=\"1\" analytics-on=\"click\" title=\"{{ addressCardMultiC.viewTheMenuText }}\">{{ addressCardMultiC.viewTheMenuText }}</a><delivery-modal-card button-class=\"btn btn-primary delivery-modal\" location=\"location\" extended-delivery=\"deliveryModalExtendedDelivery\"></delivery-modal-card><a ng-show=\"addressCardMultiC.customButtonLink\" ng-href=\"{{addressCardMultiC.customButtonLink}}\" rel=\"noopener\" target=\"_blank\" class=\"btn btn-primary custom-button\" analytics-event=\"{{addressCardMultiC.customButtonText}}\" analytics-label=\"{{ location | labelizeLocation }}\" analytics-category=\"LLP\" analytics-value=\"1\" analytics-on=\"click\" title=\"{{addressCardMultiC.customButtonText}}\">{{addressCardMultiC.customButtonText}}</a> <a ng-show=\"addressCardMultiC.customButton2Link\" ng-href=\"{{addressCardMultiC.customButton2Link}}\" rel=\"noopener\" target=\"_blank\" class=\"btn btn-primary custom-button\" analytics-event=\"{{addressCardMultiC.customButton2Text}}\" analytics-label=\"{{ location | labelizeLocation }}\" analytics-category=\"LLP\" analytics-value=\"1\" analytics-on=\"click\" title=\"{{addressCardMultiC.customButton2Text}}\">{{addressCardMultiC.customButton2Text}}</a></div></div>");
$templateCache.put("app/localLanding/cards/multilingual/amenitiesCardMulti.directive.html","<div class=\"amenities-card\"><div class=\"push-bottom\" ng-show=\"!amenitiesCardMultiC.displayInOneLine\"><h3 class=\"title\">{{amenitiesCardMultiC.title}}</h3></div><div class=\"amenities-with-no-icons\" ng-show=\"!amenitiesCardMultiC.displayInOneLine && amenitiesCardMultiC.amenitiesWithNoIcons.length\"><ul class=\"amenities-list\"><li ng-repeat=\"amenity in amenitiesCardMultiC.amenitiesWithNoIcons\" class=\"push-bottom amenity\"><div class=\"amenity-with-no-icon\"><span>&bull; <span data-ng-bind-html=\"amenity.nameAmenity\"></span></span></div></li></ul></div><div class=\"amenities-with-icons\" ng-show=\"!amenitiesCardMultiC.displayInOneLine && amenitiesCardMultiC.amenitiesWithIcons.length\"><ul class=\"amenities-list\"><li ng-repeat=\"amenity in amenitiesCardMultiC.amenitiesWithIcons\" class=\"push-bottom amenity\"><div class=\"amenity-with-icon\"><div class=\"image-container\"><img ng-if=\"!amenitiesCardMultiC.defaultImage\" ng-src=\"/assets/images/clients/{{amenitiesCardMultiC.client}}/{{amenity.name}}.png\" alt=\"{{amenity.tooltip}}\" title=\"{{amenity.tooltip}}\" data-at2x=\"/assets/images/clients/{{amenitiesCardMultiC.client}}/{{amenity.name}}@2x.png\"> <img ng-if=\"amenitiesCardMultiC.defaultImage\" ng-src=\"/assets/images/clients/{{amenitiesCardMultiC.client}}/service_default.png\" alt=\"{{amenity.tooltip}}\" title=\"{{amenity.tooltip}}\" data-at2x=\"/assets/images/clients/{{amenitiesCardMultiC.client}}/service_default.png\"></div><span data-ng-bind-html=\"amenity.nameAmenity\"></span></div></li></ul></div><div ng-show=\"amenitiesCardMultiC.displayInOneLine\"><span class=\"title\">{{amenitiesCardMultiC.title}}:</span> <span data-ng-bind-html=\"amenity.nameAmenity\" class=\"amenity\" ng-repeat=\"amenity in amenitiesCardMultiC.amenities\"></span></div></div>");
$templateCache.put("app/localLanding/cards/multilingual/fbWidgetCardMulti.directive.html","<div class=\"fb-widget-card\" ng-show=\"fbWidgetCardMultiC.fbProviderUrl\"><div class=\"border-bottom push-bottom clearfix\"><div class=\"pull-left\"><h2 id=\"facebook-heading\" tabindex=\"0\">{{ fbWidgetCardMultiC.faceBookGeneralTitleText }}</h2></div><div class=\"pull-right mf-social-icons single\"><a itemprop=\"sameAs\" class=\"btn btn-provider facebook-color\" ng-href=\"{{fbWidgetCardMultiC.fbProviderUrl}}\" target=\"_blank\" rel=\"noopener\" ng-attr-title=\"{{clientName ? clientName : \'Like us\'}} on Facebook\" aria-label=\"Facebook Button\" tabindex=\"0\"><i class=\"ico ico-facebook\"></i></a></div></div><div class=\"fb-widget-container push-bottom-lg\"><div class=\"fb-page\" data-href=\"{{fbWidgetCardMultiC.fbProviderUrl}}\" data-tabs=\"timeline\" data-width=\"\" data-height=\"\" data-small-header=\"false\" data-adapt-container-width=\"true\" data-hide-cover=\"false\" data-show-facepile=\"true\"><blockquote cite=\"{{fbWidgetCardMultiC.fbProviderUrl}}\" class=\"fb-xfbml-parse-ignore\"><a href=\"{{fbWidgetCardMultiC.fbProviderUrl}}\" rel=\"noopener\">{{client_name}}</a></blockquote></div></div></div>");
$templateCache.put("app/localLanding/cards/multilingual/hoursAdditionalCardMulti.directive.html","<div class=\"hours-card hours-additional\"><h4 class=\"no-bold text-primary push-bottom\"><div ng-if=\"hoursAddCardMultiC.hasPrimary || hoursAddCardMultiC.hasPrimarySpecial\"><span>{{hoursAddCardMultiC.titlePrimary}}:</span> <span ng-if=\"hoursAddCardMultiC.closed24\"><span class=\"closed-store\">{{ hoursAddCardMultiC.closedTodayText }}</span></span> <span ng-if=\"!hoursAddCardMultiC.closed24 && hoursAddCardMultiC.closedNow\"><span class=\"closed-store\">{{ hoursAddCardMultiC.closedNowText }}</span>{{ hoursAddCardMultiC.todaysHoursText }}: <span>{{hoursAddCardMultiC.openTimePeriod_0}}</span> - <span>{{hoursAddCardMultiC.closeTimePeriod_0}}</span></span>&nbsp; <span ng-if=\"!hoursAddCardMultiC.closed24 && hoursAddCardMultiC.closedNow && hoursAddCardMultiC.openTimeSecondPeriod\"><span>&&</span><span>{{hoursAddCardMultiC.openTimePeriod_1}}</span> - <span>{{hoursAddCardMultiC.closeTimePeriod_1}}</span></span> <span ng-if=\"!hoursAddCardMultiC.closed24 && !hoursAddCardMultiC.open24 && !hoursAddCardMultiC.closedNow\" class=\"opened-store\">{{ hoursAddCardMultiC.openUntilText }} {{hoursAddCardMultiC.closeToday}}</span> <span ng-if=\"!hoursAddCardMultiC.closed24 && hoursAddCardMultiC.open24\" class=\"opened-store\">{{ hoursAddCardMultiC.open24Text }}</span></div></h4><h4 class=\"no-bold text-primary push-bottom\"><div ng-if=\"hoursAddCardMultiC.hasAdditional || hoursAddCardMultiC.hasAdditionalSpecial\"><span>{{hoursAddCardMultiC.titleAdditional}}:</span> <span ng-if=\"hoursAddCardMultiC.closed24Additional\"><span class=\"closed-store\">{{ hoursAddCardMultiC.closedTodayText }}</span></span> <span ng-if=\"!hoursAddCardMultiC.closed24Additional && hoursAddCardMultiC.closedNowAdditional\"><span class=\"closed-store\">{{ hoursAddCardMultiC.closedNowText }}</span>{{ hoursAddCardMultiC.todaysHoursText }}: <span>{{hoursAddCardMultiC.openTodayAdditional}}</span> - <span>{{hoursAddCardMultiC.closeTodayAdditional}}</span></span> <span ng-if=\"!hoursAddCardMultiC.closed24Additional && !hoursAddCardMultiC.open24Additional && !hoursAddCardMultiC.closedNowAdditional\" class=\"opened-store\">{{ hoursAddCardMultiC.openUntilText }} {{hoursAddCardMultiC.closeTodayAdditional}}</span> <span ng-if=\"!hoursAddCardMultiC.closed24Additional && hoursAddCardMultiC.open24Additional\" class=\"opened-store\">{{ hoursAddCardMultiC.open24Text }}</span></div></h4><dl class=\"dl-horizontal\" itemprop=\"openingHours\" content=\"{{hoursAddCardMultiC.openingHours}}\"><dt></dt><dd class=\"display-small\"><div ng-if=\"hoursAddCardMultiC.hasPrimary && hoursAddCardMultiC.hasAdditional\" class=\"hours-column dib push-right-xs bold-700\"><span>{{hoursAddCardMultiC.titlePrimary}}</span></div><div ng-if=\"hoursAddCardMultiC.hasAdditional\" class=\"hours-column dib bold-700 align-small-screen\"><span>{{hoursAddCardMultiC.titleAdditional}}</span></div></dd><dt ng-repeat-start=\"(day,hours) in hoursAddCardMultiC.regularHours\" ng-class=\"[hours.regular.highlightClass, hours.additional.highlightClass]\" class=\"text-overflow\">{{day}}</dt><dd ng-if=\"hours.regular.highlightClass || hours.additional.highlightClass\" class=\"display-small\"><div ng-if=\"hoursAddCardMultiC.isUsedForPrimaryRegularHours && hours.regular\" class=\"hours-column dib push-right-xs open-close-align\"><span class=\"hours-column\" ng-class=\"hours.regular.highlightClass\" ng-if=\"!hours.regular.closed && !hours.regular.open24\">{{hoursAddCardMultiC.getOpenTimePeriodDisplayMessage(hours.regular)}}</span> <span class=\"hours-column\" ng-class=\"hours.regular.highlightClass\" ng-if=\"hours.regular.closed\">{{hours.regular.closedLabel}}</span> <span class=\"hours-column\" ng-class=\"hours.regular.highlightClass\" ng-if=\"hours.regular.open24\">{{ hoursAddCardMultiC.open24Text }}</span></div><div ng-if=\"hours.additional\" class=\"hours-column dib align-small-screen\"><span class=\"hours-column\" ng-class=\"hours.additional.highlightClass\">{{hoursAddCardMultiC.getOpenTimePeriodDisplayMessage(hours.additional) || hours.additional.closedLabel}}</span></div></dd><dd ng-if=\"!hours.regular.highlightClass && !hours.additional.highlightClass\" ng-repeat-end=\"\" ng-repeat=\"i in hours.regular.numberOfTimeFragments track by $index\" class=\"display-small\"><div ng-if=\"hoursAddCardMultiC.isUsedForPrimaryRegularHours && !hours.regular.highlightClass\" class=\"hours-column dib push-right-xs open-close-align\"><span ng-class=\"hours.regular.highlightClass\" ng-if=\"!hours.regular.closed && !hours.regular.open24\" itemprop=\"openingHours\" content=\"{{hoursAddCardMultiC.getOpenTimePeriodDisplayMessage(hours.regular, $index)}}\">{{hoursAddCardMultiC.getOpenTimePeriodDisplayMessage(hours.regular, $index)}}</span> <span ng-class=\"hours.regular.highlightClass\" ng-if=\"hours.regular.open24\">{{ hoursAddCardMultiC.open24Text }}</span> <span ng-class=\"hours.regular.highlightClass\" ng-if=\"hours.regular.closed\">{{hours.regular.closedLabel}}</span></div><div ng-if=\"hours.additional && !hours.additional.highlightClass\" class=\"hours-column dib align-small-screen\"><span ng-class=\"hours.regular.highlightClass\" ng-if=\"!hours.additional.closed && !hours.additional.open24\" itemprop=\"openingHours\" content=\"{{hoursAddCardMultiC.getOpenTimePeriodDisplayMessage(hours.additional, $index)}}\">{{hoursAddCardMultiC.getOpenTimePeriodDisplayMessage(hours.additional, $index)}}</span> <span ng-class=\"hours.regular.highlightClass\" ng-if=\"hours.additional.open24\">{{ hoursAddCardMultiC.open24Text }}</span> <span ng-class=\"hours.regular.highlightClass\" ng-if=\"hours.additional.closed\">{{hours.additional.closedLabel}}</span></div></dd></dl><h4 ng-if=\"hoursAddCardMultiC.specialHours\" class=\"no-bold text-primary push-bottom\"><span>{{ hoursAddCardMultiC.specialHoursText }}</span></h4><dl ng-if=\"hoursAddCardMultiC.specialHours\" class=\"dl-horizontal\" itemprop=\"openingHoursSpecification\" itemscope=\"\" itemtype=\"http://schema.org/OpeningHoursSpecification\"><dt></dt><dd><div class=\"hours-column dib push-right-xs bold-700\"><span>{{hoursAddCardMultiC.titlePrimary}}</span></div><div class=\"hours-column dib bold-700\"><span>{{hoursAddCardMultiC.titleAdditional}}</span></div></dd><dt ng-repeat-start=\"(day,hours) in hoursAddCardMultiC.specialHours\" ng-class=\"[hours.regular.highlightClass, hours.additional.highlightClass]\" class=\"text-overflow\"><span itemprop=\"validFrom validThrough\" datetime=\"{{day}}\">{{day}}</span></dt><dd ng-repeat-end=\"\"><div ng-if=\"hours.regular || hours.additional\" class=\"hours-column dib push-right-xs\"><span ng-if=\"!hours.regular && hours.additional\">{{hoursAddCardMultiC.regularHoursText}} ({{hoursAddCardMultiC.getStandardRegHours(hours.additional.dayOfTheWeek)}})</span> <span ng-class=\"hours.regular.highlightClass\" ng-if=\"hours.regular && !hours.regular.open24 && !hours.regular.closed\" itemprop=\"openingHours\" content=\"{{hours.regular.openDisplayTime}}\">{{hours.regular.openDisplayTime}} - {{hours.regular.closeDisplayTime}}</span> <span ng-class=\"hours.regular.highlightClass\" ng-if=\"hours.regular.open24\" itemprop=\"opens\" content=\"12:00 AM\">{{ hoursAddCardMultiC.open24Text }}</span> <span ng-class=\"hours.regular.highlightClass\" ng-if=\"hours.regular.closed\" itemprop=\"closes\" content=\"12:00 AM\">{{hours.regular.closedLabel}}</span></div><div ng-if=\"hours.regular || hours.additional\" class=\"hours-column dib\"><span ng-if=\"hours.regular && !hours.additional\">{{hoursAddCardMultiC.regularHoursText}} ({{hoursAddCardMultiC.getStandardAddtlHours(hours.regular.dayOfTheWeek)}})</span> <span ng-class=\"hours.additional.highlightClass\" ng-if=\"hours.additional && !hours.additional.closed && !hours.additional.open24\">{{hours.additional.openDisplayTime}} - {{hours.additional.closeDisplayTime}}</span> <span ng-class=\"hours.additional.highlightClass\" ng-if=\"hours.additional.open24\">{{ hoursAddCardMultiC.open24Text }}</span> <span ng-class=\"hours.additional.highlightClass\" ng-if=\"hours.additional.closed\">{{hours.additional.closedLabel}}</span></div></dd></dl><div class=\"hours-note\" ng-if=\"hoursAddCardMultiC.hoursNote\">* {{ hoursAddCardMultiC.hoursNote }}</div></div>");
$templateCache.put("app/localLanding/cards/multilingual/hoursCardMulti.directive.html","<div class=\"hours-card\" ng-show=\"hoursCardMultiC.locHours || hoursCardMultiC.specialHours || hoursCardMultiC.hoursNote\"><h2 class=\"hours-title\"><i class=\"ico ico-clock\"></i>&nbsp;{{hoursCardMultiC.titleText}}</h2><p ng-if=\"hoursCardMultiC.locHours || hoursCardMultiC.specialHours\" class=\"bold-500 push-top push-bottom\"><i ng-class=\"{\'opened\': !hoursCardMultiC.closedNow , \'closed\': hoursCardMultiC.closedNow}\" class=\"ico ico-clock\"></i> <span ng-if=\"hoursCardMultiC.comingSoon\" ng-class=\"{\'inline\': hoursCardMultiC.simplified}\"><span class=\"closed-store\">{{hoursCardMultiC.comingSoon}}</span></span> <span ng-if=\"hoursCardMultiC.closed24 && !hoursCardMultiC.comingSoon\" ng-class=\"{\'inline\': hoursCardMultiC.simplified}\"><span class=\"closed-store\">{{hoursCardMultiC.closedTodayText}}</span></span> <span ng-if=\"!hoursCardMultiC.closed24 && hoursCardMultiC.closedNow\" ng-class=\"{\'inline\': hoursCardMultiC.simplified}\"><span class=\"closed-store\">{{hoursCardMultiC.closedNowText}}</span><span ng-if=\"!hoursCardMultiC.simplified\">{{hoursCardMultiC.todaysHoursText}}: <span>{{hoursCardMultiC.openTimePeriod_0}}</span> - <span>{{hoursCardMultiC.closeTimePeriod_0}}</span>&nbsp;</span></span> <span ng-if=\"!hoursCardMultiC.simplified && !hoursCardMultiC.closed24 && hoursCardMultiC.closedNow && hoursCardMultiC.openTimePeriod_1\"><span>{{hoursCardMultiC.openTimePeriod_1}}</span> - <span>{{hoursCardMultiC.closeTimePeriod_1}}</span></span> <span ng-if=\"!hoursCardMultiC.closed24 && !hoursCardMultiC.closedNow && !hoursCardMultiC.open24 && !hoursCardMultiC.customText && !hoursCardMultiC.tempClosed\" class=\"opened-store\" ng-class=\"{\'inline\': hoursCardMultiC.simplified}\">{{hoursCardMultiC.openUntilText}} {{hoursCardMultiC.closeToday}}</span> <span ng-if=\"hoursCardMultiC.customText\" class=\"hoursCardMultiC-customText\" ng-class=\"{\'inline\': hoursCardMultiC.simplified}\">{{hoursCardMultiC.customTextShow}}</span> <span ng-if=\"!hoursCardMultiC.closed24 && hoursCardMultiC.open24\" class=\"opened-store\" ng-class=\"{\'inline\': hoursCardMultiC.simplified}\">{{hoursCardMultiC.open24Text}}</span> <span class=\"collapse-icon show-on-mobile\" ng-if=\"hoursCardMultiC.collapsibleOn === \'mobile\'\" ng-click=\"hoursCardMultiC.toggleCollapsibleHours()\"><i class=\"fa fa-chevron-up\"></i></span> <span class=\"collapse-icon hide-on-mobile\" ng-if=\"hoursCardMultiC.collapsibleOn === \'desktop\'\" ng-click=\"hoursCardMultiC.toggleCollapsibleHours()\"><i class=\"fa fa-chevron-up\"></i></span> <span class=\"collapse-icon show-on-mobile show-on-desktop\" ng-if=\"hoursCardMultiC.collapsibleOn === \'all\'\" ng-click=\"hoursCardMultiC.toggleCollapsibleHours()\"><i class=\"fa fa-chevron-up\"></i></span></p><div ng-class=\"{\'collapse-mobile\': hoursCardMultiC.collapsibleOn === \'mobile\', \'collapse-desktop\': hoursCardMultiC.collapsibleOn === \'desktop\', \'collapse-all\': hoursCardMultiC.collapsibleOn === \'all\'}\" class=\"collapsible show\"><div ng-if=\"hoursCardMultiC.locHours\"><dl class=\"dl-horizontal\" ng-if=\"!hoursCardMultiC.onlyToday\" itemprop=\"openingHours\" content=\"{{hoursCardMultiC.openingHours}}\"><dt ng-repeat-start=\"(day,hours) in hoursCardMultiC.locHours\" ng-class=\"hours.highlightClass\"><span>{{hours.dayName}}</span></dt><dd ng-if=\"hours.highlightClass\"><div class=\"hours-column margin-left-day-hours\"><span ng-class=\"hours.highlightClass\" ng-if=\"!hours.closed\">{{hoursCardMultiC.getOpenTimePeriodDisplayMessage(hours)}}</span> <span ng-class=\"hours.highlightClass\" ng-if=\"hours.closed\">{{hours.closedLabel}}</span></div></dd><dd ng-if=\"!hours.highlightClass\" ng-repeat-end=\"\" ng-repeat=\"i in hours.numberOfTimeFragments track by $index\" class=\"hours-location\"><div class=\"hours-column margin-left-day-hours\"><span ng-class=\"hours.highlightClass\" ng-if=\"!hours.closed && !hours.open24\">{{hoursCardMultiC.getOpenTimePeriodDisplayMessage(hours, $index)}}</span> <span ng-class=\"hours.highlightClass\" ng-if=\"hours.open24\">{{hoursCardMultiC.open24Text}}</span> <span ng-class=\"hours.highlightClass\" ng-if=\"hours.closed\">{{hours.closedLabel}}</span></div></dd></dl></div><div class=\"hours-note\" ng-if=\"hoursCardMultiC.hoursNote\">* {{ hoursCardMultiC.hoursNote }}</div><div ng-if=\"hoursCardMultiC.specialHours\" class=\"specialHours\"><p class=\"bold-500 push-top push-bottom\" id=\"specialHours\"><i ng-class=\"{\'opened\': !hoursCardMultiC.closedNow , \'closed\': hoursCardMultiC.closedNow}\" class=\"ico ico-clock\"></i> {{hoursCardMultiC.specialHoursText}}</p><dl class=\"dl-horizontal\" itemprop=\"openingHoursSpecification\" itemscope=\"\" itemtype=\"http://schema.org/OpeningHoursSpecification\"><dt ng-repeat-start=\"(day,hours) in hoursCardMultiC.specialHours\" ng-class=\"hours.highlightClass\"><span itemprop=\"validFrom validThrough\" datetime=\"{{hours.dayNameShort}}\">{{hours.dayNameShort}}</span></dt><dd ng-if=\"hours.highlightClass\"><span ng-class=\"hours.highlightClass\" ng-if=\"!hours.closed\">{{hoursCardMultiC.getOpenTimePeriodDisplayMessage(hours)}}</span> <span ng-class=\"hours.highlightClass\" ng-if=\"hours.closed\" itemprop=\"closes\">{{hoursCardMultiC.closedText}}</span></dd><dd ng-if=\"!hours.highlightClass\" ng-repeat-end=\"\" ng-repeat=\"i in hours.numberOfTimeFragments track by $index\"><span ng-class=\"hours.highlightClass\" ng-if=\"!hours.closed && !hours.open24\">{{hoursCardMultiC.getOpenTimePeriodDisplayMessage(hours, $index)}}</span> <span ng-class=\"hours.highlightClass\" ng-if=\"hours.open24\" itemprop=\"opens\" content=\"12:00 AM\">{{hoursCardMultiC.open24Text}}</span> <span ng-class=\"hours.highlightClass\" ng-if=\"hours.closed\" itemprop=\"closes\" content=\"12:00 AM\">{{hoursCardMultiC.closedText}}</span></dd></dl></div></div></div>");
$templateCache.put("app/localLanding/cards/multilingual/hoursCollapseCardMulti.directive.html","<div class=\"hours-card\"><div ng-if=\"hoursCardC.locHours\"><p class=\"bold-500 push-top push-bottom\"><i class=\"ico ico-clock\"></i> <span ng-if=\"hoursCardC.closedNow\">{{hoursCardC.closedNowText}}<br>{{hoursCardC.todaysHoursText}}: <span>{{hoursCardC.openToday}}</span> - <span>{{hoursCardC.closeToday}}</span></span> <span ng-if=\"!hoursCardC.closedNow\">{{hoursCardC.openUntilText}} {{hoursCardC.closeToday}}</span></p><dl class=\"dl-horizontal\" ng-if=\"!hoursCardC.onlyToday\"><div class=\"panel-group\" ng-model=\"panels.activePanel\" role=\"tablist\" aria-multiselectable=\"true\" bs-collapse=\"\"><div class=\"panel panel-default\"><div class=\"panel-heading\" role=\"tab\"><h4 class=\"panel-title\"><a bs-collapse-toggle=\"\"><span>{{hoursCardC.viewHoursText}} <i class=\"ico ico-chevron-down ico-lg\"></i></span></a></h4></div><div class=\"panel-collapse\" role=\"tabpanel\" bs-collapse-target=\"\"><div class=\"panel-body\"><div class=\"dl-horizontal\" ng-if=\"!hoursCardC.onlyToday\" itemprop=\"openingHours\" content=\"{{hoursCardC.openingHours}}\"><dt ng-repeat-start=\"(day,hours) in hoursCardC.locHours\" ng-class=\"hours.highlightClass\"><span>{{hours.dayName}}</span></dt><dd ng-repeat-end=\"\"><span ng-class=\"hours.highlightClass\" ng-if=\"!hours.closedLabel\"><span>{{hours.openTime}}</span> - <span>{{hours.closeTime}}</span></span> <span ng-class=\"hours.highlightClass\" ng-if=\"hours.closedLabel\">{{hours.closedLabel}}</span></dd></div></div></div></div></div></dl></div><div class=\"hours-note\" ng-if=\"hoursCardC.hoursNote\">* {{ hoursCardC.hoursNote }}</div></div>");
$templateCache.put("app/localLanding/cards/multilingual/instagram9CardMulti.directive.html","<div ng-show=\"instagram9CardMultiC.photos\"><div class=\"border-bottom push-bottom clearfix\"><div class=\"pull-left\"><h2 id=\"instagram-heading\" tabindex=\"-1\">{{ instagram9CardMultiC.instragramGeneralTitleText }}</h2></div><div class=\"pull-right mf-social-icons single\"><a class=\"btn btn-provider instagram-color\" href=\"{{ instagram9CardMultiC.igData.url }}\" target=\"_blank\" rel=\"noopener\" title=\"{{instagram9CardMultiC.title}} {{instagram9CardMultiC.onInstagramText}}\" aria-label=\"Instagram Button\"><i class=\"ico ico-instagram\"></i></a></div></div><div class=\"clearfix\"><div ng-repeat=\"photo in photos | limitTo:12\" class=\"instagram9grid\"><a ng-href=\"{{photo.permalink}}\" target=\"_blank\" rel=\"noopener\" class=\"instagram9\" title=\"{{photo.owner.username}} {{instagram9CardMultiC.onInstagramText}}\" analytics-event=\"Clicked Instagram Photo\" analytics-label=\"{{ location | labelizeLocation }}\" analytics-category=\"LLP\" analytics-value=\"1\" analytics-on=\"click\"><img width=\"100%\" ng-src=\"{{photo.trust_url}}\" alt=\"Instagram Photo\" image-fallback=\"{{photo.fallback_url}}\"></a></div></div></div>");
$templateCache.put("app/localLanding/cards/multilingual/instagramCardMulti.directive.html","<div ng-show=\"instagramCardMultiC.photos\"><div class=\"border-bottom push-bottom clearfix\"><div class=\"pull-left\"><h2 id=\"instagram-heading\">{{ instagramCardMultiC.instragramGeneralTitleText }}</h2></div><div class=\"pull-right mf-social-icons single\"><a class=\"btn btn-provider instagram-color\" href=\"{{ instagramCardMultiC.igData.url }}\" target=\"_blank\" rel=\"noopener\" title=\"{{instagramCardMultiC.title}} {{instagramCardMultiC.onInstagramText}}\"><i class=\"ico ico-instagram\"></i></a></div></div><div class=\"clearfix ig-flex\"><div ng-repeat=\"photo in photos | limitTo:12\" class=\"ig-square\"><a ng-href=\"{{photo.permalink}}\" target=\"_blank\" class=\"photo-block\" title=\"{{photo.owner.username}} {{instagramCardMultiC.onInstagramText}}\" analytics-event=\"Clicked Instagram Photo\" analytics-label=\"{{ location | labelizeLocation }}\" analytics-category=\"LLP\" analytics-value=\"1\" analytics-on=\"click\"><img width=\"100%\" ng-src=\"{{photo.media_url}}\"></a></div></div></div>");
$templateCache.put("app/localLanding/cards/multilingual/nearbyCardMulti.directive.html","<div class=\"text-center push-top-xl push-bottom-xl\" ng-show=\"locations.length\"><h2>{{ nearbyCardMultiC.nearbyLocationText }}</h2><div class=\"text-center\"><div ng-repeat=\"location in locations\" class=\"dib width-third xs-full-width push-bottom\"><h3><span ng-if=\"!location.name.includes(\'®\')\" data-ng-bind-html=\"location.name\" itemprop=\"name\" aria-live=\"polite\"></span><span ng-if=\"location.name.includes(\'®\')\"><span data-ng-bind-html=\"location.name.slice(0, location.name.length - 1)\" itemprop=\"name\" aria-live=\"polite\"></span><sup>®</sup></span><span ng-if=\"nearbyCardMultiC.includeLocality\">, {{ location.address_detail.locality }}</span></h3><h4 class=\"no-bold line-height-bump\">{{ location.address_detail.address }} {{ location.address_detail.address_extended }}<br>{{ location.address_detail.locality }}, {{ location.address_detail.region }} {{ location.address_detail.postcode }}<br></h4><h4 class=\"visible-xs\"><a ng-href=\"tel:{{ location.phone }}\" analytics-event=\"Call\" analytics-label=\"{{ location | labelizeLocation }}\" analytics-category=\"LLP\" analytics-value=\"1\" analytics-on=\"click\" title=\"Call\">{{ location.phone | telephone }}</a></h4><h4 class=\"hidden-xs\">{{ location.phone | telephone }}</h4><h4>{{ nearbyCardMultiC.regionService.getDistanceString(location.distance) }}</h4><div class=\"push-top-lg\"><a class=\"btn btn-primary\" title=\"nearbyCardMultiC.localPageText\" ng-show=\"!location.hideLocalPageButton && location.local_landing_page\" href=\"{{ nearbyCardMultiC.getLocalPageUrl(location) }}\">{{ nearbyCardMultiC.localPageText }}</a> <a href=\"{{ nearbyCardMultiC.getDirectionsUrl(location.address_detail) }}\" target=\"_blank\" rel=\"noopener\" title=\"nearbyCardMultiC.getDirectionsText\" class=\"btn btn-primary\">{{ nearbyCardMultiC.getDirectionsText }}</a></div></div></div></div>");
$templateCache.put("app/localLanding/cards/multilingual/partnerReviewsCardMulti.directive.html","<div class=\"partner-reviews-card\"><div ng-if=\"partnerReviewsCardMultiC.pData.ratingFraction > partnerReviewsCardMultiC.minRating\"><div class=\"row review-wrapper\"><div class=\"float-left icon-container col-sm-2 col-md-2 col-lg-2 col-xs-2\"><div class=\"btn-provider {{partnerReviewsCardMultiC.partnerName | lowercase}}-color\"><a itemprop=\"sameAs\" href=\"{{ partnerReviewsCardMultiC.pData.url }}\" target=\"_blank\" rel=\"external noopener\" title=\"{{partnerReviewsCardMultiC.title}} on {{partnerReviewsCardMultiC.partnerName}}\" aria-label=\"{{partnerReviewsCardMultiC.partnerName}} button\"><i class=\"ico ico-{{partnerReviewsCardMultiC.partnerName | lowercase}}\"></i></a></div></div><div class=\"float-left ratings-container col-sm-8 col-md-8 col-lg-8 col-xs-8\"><div class=\"row\"><div ng-if=\"partnerReviewsCardMultiC.partnerName===\'Yelp\'\"><img ng-src=\"{{partnerReviewsCardMultiC.pData.yelpStarUrl}}\" alt=\"\"></div><div ng-if=\"partnerReviewsCardMultiC.partnerName === \'Foursquare\'\"><span class=\"foursquare-rating venue-score\" ng-style=\"{\'background-color\':partnerReviewsCardMultiC.ratingColor}\"><span>{{partnerReviewsCardMultiC.pData.rating}}</span> <sup>/<span>10</span></sup></span></div><div ng-if=\"partnerReviewsCardMultiC.partnerName===\'Google\'\"><div star-rating=\"\" rating-value=\"partnerReviewsCardMultiC.pData.roundedRating\" max=\"5\"></div></div><div ng-if=\"partnerReviewsCardMultiC.partnerName===\'Facebook\'\"><div class=\"circle\">{{partnerReviewsCardMultiC.pData.rating}}</div><span class=\"bold-text\">{{partnerReviewsCardMultiC.outOf5Text}}</span></div><a ng-if=\"partnerReviewsCardMultiC.pData.reviewCount\" class=\"review-count\" href=\"{{ partnerReviewsCardMultiC.pData.url }}\" target=\"_blank\" rel=\"external noopener\">{{ partnerReviewsCardMultiC.reviewCountByPartnerNameText }}</a> <a ng-if=\"!partnerReviewsCardMultiC.pData.reviewCount\" class=\"review-count\" href=\"{{ partnerReviewsCardMultiC.pData.url }}\" target=\"_blank\" rel=\"external noopener\">{{ partnerReviewsCardMultiC.partnerNameText }}</a></div></div></div></div></div>");
$templateCache.put("app/localLanding/cards/multilingual/singleImageCardMulti.directive.html","<div ng-show=\"singleImageCardMultiC.hasData\" title=\"{{singleImageCardMultiC.title}}\" class=\"text-center\"><a ng-if=\"singleImageCardMultiC.findLink\" ng-href=\"{{singleImageCardMultiC.link}}\" rel=\"noopener\" target=\"{{singleImageCardMultiC.singleImageTarget}}\" analytics-event=\"Clicked Single Photo\" analytics-label=\"{{ location | labelizeLocation }}\" analytics-category=\"LLP\" analytics-value=\"1\" analytics-on=\"click\" class=\"db text-center\"><img ng-src=\"{{singleImageCardMultiC.src}}\" data-at2x=\"{{singleImageCardMultiC.src}}\" alt=\"{{singleImageCardMultiC.title}}\" width=\"100%\"></a> <img ng-if=\"!singleImageCardMultiC.findLink\" ng-src=\"{{singleImageCardMultiC.src}}\" data-at2x=\"{{singleImageCardMultiC.src}}\" alt=\"{{singleImageCardMultiC.title}}\" width=\"100%\"></div>");
$templateCache.put("app/localLanding/cards/multilingual/socialCardMulti.directive.html","<div class=\"mf-social-icons\">{{ socialCardMultiC.provider.master }}<ul class=\"list-unstyled no-margin\"><li ng-repeat=\"provider in socialCardMultiC.providers\" class=\"dib {{provider._type | lowercase}}\"><a ng-if=\"(provider._type != \'Twitter\' && provider._type != \'Instagram\' && provider._type != \'Google\') && provider.url\" itemprop=\"sameAs\" class=\"btn btn-provider {{provider._type | lowercase}}-color\" analytics-event=\"Clicked Social Link {{ provider._type }}\" analytics-label=\"{{ location | labelizeLocation }}\" analytics-category=\"LLP\" analytics-value=\"1\" analytics-on=\"click\" aria-label=\"{{provider._type}} Button\" href=\"{{ provider.url }}\" rel=\"noopener\" target=\"_blank\" alt=\"{{ provider.title }}\" title=\"{{ provider.title }}\"><i class=\"ico ico-{{provider._type | lowercase}}\"></i></a> <a ng-if=\"provider._type == \'Google\' && (provider.url || location.provider_venues[\'google_page_url\'])\" itemprop=\"sameAs\" class=\"btn btn-provider {{provider._type | lowercase}}-color\" analytics-event=\"Clicked Social Link {{ provider._type }}\" analytics-label=\"{{ location | labelizeLocation }}\" analytics-category=\"LLP\" analytics-value=\"1\" analytics-on=\"click\" aria-label=\"{{provider._type}} Button\" ng-href=\"{{provider.url || location.provider_venues[\'google_page_url\']}}\" rel=\"noopener\" target=\"_blank\" alt=\"{{ provider.title }}\" title=\"{{ provider.title }}\"><i class=\"ico\" ng-class=\"{ \'ico ico-{{provider._type | lowercase}}\' : provider.url, \'ico ico-{{provider._type | lowercase}}-plus\' : !provider.url }\"></i></a> <a ng-if=\"provider._type == \'Instagram\'\"></a> <a ng-if=\"provider._type == \'Twitter\'\" itemprop=\"sameAs\" class=\"btn btn-provider {{provider._type | lowercase}}-color\" analytics-event=\"Clicked Social Link {{ provider._type }}\" analytics-label=\"{{ location | labelizeLocation }}\" analytics-category=\"LLP\" analytics-value=\"1\" analytics-on=\"click\" aria-label=\"{{provider._type}} Button\" href=\"https://twitter.com/{{ location.twitter_handle }}\" rel=\"noopener\" target=\"_blank\" alt=\"{{socialCardMultiC.onTwitterText}}\" title=\"{{socialCardMultiC.onTwitterText}}\"><i class=\"ico ico-{{provider._type | lowercase}}\"></i></a></li><li class=\"dib instagram\"><a ng-if=\"socialCardMultiC.instagramHandle\" itemprop=\"sameAs\" class=\"btn btn-provider instagram-color\" analytics-event=\"Clicked Social Link Instagram\" analytics-label=\"{{ location | labelizeLocation }}\" analytics-category=\"LLP\" analytics-value=\"1\" analytics-on=\"click\" aria-label=\"Instagram Button\" href=\"{{ socialCardMultiC.instagramURL }}\" rel=\"noopener\" target=\"_blank\" alt=\"{{socialCardMultiC.onInstagramText}}\" title=\"{{socialCardMultiC.onInstagramText}}\"><i class=\"ico ico-instagram\"></i></a></li></ul></div>");
$templateCache.put("app/storeLocator/directives/multilingual/resultsMulti.directive.html","<div class=\"results\"><div data-ng-show=\"resultsMultiCtrl.locatorStates.isLoading\" class=\"text-center push-top-lg\"><div class=\"mf-loader text-center mf-loading-list push-top\"><i class=\"ico ico-spinner ico-spin\"></i></div><h5 data-ng-if=\"angular.equals({}, resultsMultiCtrl.locatorStates.message)\">{{resultsMultiCtrl.locatorStates.message}}</h5></div><div id=\"js-total\" class=\"results-total\" data-ng-show=\"resultsMultiCtrl.locatorStates.current && !resultsMultiCtrl.locatorStates.isLoading && resultsMultiCtrl.showMessage\" role=\"alert\"><span>{{resultsMultiCtrl.GetMessage()}}</span></div><div ng-if=\"!resultsMultiCtrl.locatorStates.isLoading && resultsMultiCtrl.locatorStates.locations.length && resultsMultiCtrl.orderResultsList\" ng-init=\"resultsMultiCtrl.getLocations(resultsMultiCtrl.locatorStates.locations)\"><div ng-repeat=\"(title, result) in resultsMultiCtrl.groupedData\"><div><div class=\"results-list-title\">{{ title }}</div><ul id=\"js-results\" class=\"results-list list-unstyled\"><results-li data-ng-repeat=\"location in result\" locator-states=\"resultsMultiCtrl.locatorStates\" location=\"location\" map-obj=\"resultsMultiCtrl.mapObj\" translated-messages=\"resultsMultiCtrl.translatedMessages\" role=\"listitem\"></results-li></ul></div></div></div><ul id=\"js-results\" class=\"results-list list-unstyled\" ng-if=\"!resultsMultiCtrl.locatorStates.isLoading && resultsMultiCtrl.locatorStates.locations.length && !resultsMultiCtrl.orderResultsList\"><results-li data-ng-repeat=\"location in resultsMultiCtrl.locatorStates.locations\" locator-states=\"resultsMultiCtrl.locatorStates\" location=\"location\" map-obj=\"resultsMultiCtrl.mapObj\" translated-messages=\"resultsMultiCtrl.translatedMessages\" role=\"listitem\"></results-li></ul></div>");
$templateCache.put("app/storeLocator/directives/multilingual/searchMulti.directive.html","<div id=\"js-search\"><div class=\"search-container\" ng-class=\"{\'show-filters\': searchMultiCtrl.showFilters}\"><form name=\"search\"><div id=\"search_box\" class=\"clearfix\"><div class=\"input-group\"><div class=\"input-group-btn v-align-top\"><button id=\"geoLocationBtn\" type=\"button\" class=\"btn btn-primary custom-client\" aria-label=\"Geo Locate Button\" data-ng-show=\"searchMultiCtrl.locatorStates.geoEnabled != null\" data-ng-disabled=\"!searchMultiCtrl.locatorStates.geoEnabled\" data-ng-click=\"searchMultiCtrl.userLatLngSearch($event)\" aria-hidden=\"false\" title=\"{{searchMultiCtrl.nearMeButtonTooltip}}\" alt=\"{{searchMultiCtrl.nearMeButtonTooltip}}\" data-analytics-event=\"Get Geo Location\" data-analytics-label=\"Store Locator\" data-analytics-category=\"Store Locator\" data-analytics-value=\"1\" data-analytics-on=\"click\" data-sf-analytics-event=\"Share my location\"><i class=\"ico ico-location-arrow custom-client\" value=\"image\"></i></button></div><input id=\"searchField\" name=\"\" title=\"{{searchMultiCtrl.searchInputTooltip}}\" role=\"combobox\" class=\"form-control v-align-top\" placeholder=\"{{searchMultiCtrl.placeholder}}\" data-typeahead-on-select=\"searchMultiCtrl.autoCompleteSelect(searchMultiCtrl.locatorStates.searchInput)\" data-ng-model=\"searchMultiCtrl.locatorStates.searchInput\" data-typeahead=\"place as place.name for place in searchMultiCtrl.autoCompleteLocations($viewValue)\" autocomplete=\"off\" data-container=\"#js-search\" data-min-length=\"2\" maxlength=\"256\" ng-if=\"!searchMultiCtrl.isGoogleMapsEnabled\"><div ng-if=\"isGoogleMapsApiLoaded\"><google-autocomplete messages=\"searchMultiCtrl.translatedMessages\" place-changed-callback=\"searchMultiCtrl.googlePlaceChanged\" data-ng-model=\"searchMultiCtrl.locatorStates.searchInput\" ng-if=\"searchMultiCtrl.isGoogleMapsEnabled\"></google-autocomplete></div><div class=\"input-group-btn v-align-top\"><button id=\"searchBtn\" title=\"{{searchMultiCtrl.searchButtonTooltip}}\" ng-attr-type=\"{{searchMultiCtrl.isGoogleMapsEnabled ? \'button\' : \'submit\'}}\" class=\"btn btn-primary pull-right\" aria-label=\"{{searchMultiCtrl.searchButtonLabel}}\" role=\"button\" data-ng-click=\"searchMultiCtrl.hitSearchBtn()\" aria-hidden=\"false\" data-analytics-event=\"Search\" data-analytics-label=\"Store Locator\" data-analytics-category=\"Store Locator\" data-analytics-value=\"1\" data-analytics-on=\"click\" data-sf-analytics-event=\"Search\"><i class=\"ico ico-search\"></i></button></div><div ng-if=\"searchMultiCtrl.hasFilters()\" ng-show=\"searchMultiCtrl.showFiltersForActiveTab()\" class=\"input-group-btn filter-btn\"><button id=\"toggleFiltersBtn\" type=\"button\" class=\"btn btn-filter\" data-ng-click=\"searchMultiCtrl.showFilters = !searchMultiCtrl.showFilters\" title=\"{{searchMultiCtrl.filtersButtonTooltip}}\" aria-label=\"{{searchMultiCtrl.filtersButtonLabel}}\" aria-expanded=\"{{searchMultiCtrl.showFilters}}\" data-analytics-event=\"Toggle Filters Menu\" data-analytics-label=\"Store Locator\" data-analytics-category=\"Store Locator\" data-analytics-value=\"1\" data-analytics-on=\"click\">{{searchMultiCtrl.filtersButtonText}} <i class=\"ico ico-chevron-down v-align-middle\" data-ng-hide=\"searchMultiCtrl.locatorStates.selectedFilters.length\"></i><i class=\"ico ico-checkbox-marked-circle text-brand v-align-middle\" ng-show=\"searchMultiCtrl.locatorStates.selectedFilters.length\"></i></button></div></div></div><div ng-show=\"searchMultiCtrl.showFilters && searchMultiCtrl.showFiltersForActiveTab()\" class=\"search-filters\"><div data-ng-repeat=\"filterType in searchMultiCtrl.availableFilterTypes\" class=\"filter-type\"><h6>{{filterType}}</h6><ul class=\"list-unstyled\"><li data-ng-repeat=\"filter in searchMultiCtrl.availableFilters | filter: {type: filterType} track by $index\" data-ng-attr-id=\"filterRow{{$index}}\" data-ng-class=\"{active: filter.active}\"><button data-ng-attr-id=\"filterBtn{{$index}}\" type=\"button\" aria-label=\"{{filterType}} button {{filter.label}}\" class=\"btn btn-ul\" data-ng-click=\"searchMultiCtrl.addFilter(filter.label);\" role=\"checkbox\" aria-checked=\"{{filter.active}}\" data-analytics-event=\"Filter Drop Down\" data-analytics-label=\"{{ filter.label }}\" data-analytics-category=\"Store Locator\" data-analytics-value=\"1\" data-analytics-on=\"click\"><i class=\"ico ico-checkbox-blank-circle-outline\"></i> <i class=\"ico ico-checkbox-marked-circle\"></i> {{filter.label}}</button></li></ul></div></div></form></div></div>");
$templateCache.put("app/custom/clients/burberry/directives/aboutCardBurberry.directive.html","<div class=\"section-container\" ng-show=\"aboutCardBurberryC.aboutTextHtml\"><h2>{{aboutCardBurberryC.translatedMessages[\'mf.localPage.aboutCard.aboutTheStore\'] || \'About the store\'}}</h2><p class=\"about-text\" data-ng-bind-html=\"aboutCardBurberryC.aboutTextHtml\" itemprop=\"content\" aria-live=\"polite\"></p><button ng-if=\"aboutCardBurberryC.showReadBtn\" ng-click=\"aboutCardBurberryC.readMore()\" id=\"read-btn\">{{aboutCardBurberryC.translatedMessages[\'mf.localPage.aboutCard.readMore\'] || \'Read more\'}}</button></div>");
$templateCache.put("app/custom/clients/burberry/directives/changeLanguage.modal.html","<div id=\"language-modal\" class=\"modal\"><div class=\"modal-dialog modal-sm\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" ng-click=\"controller.closeChangeLanguageModal()\" data-dismiss=\"modal\" aria-label=\"Close\"><svg width=\"1em\" height=\"1em\" viewbox=\"0 0 14 14\"><path d=\"M5.6 7L0 1.4 1.4 0 7 5.6 12.6 0 14 1.4 8.4 7l5.6 5.6-1.4 1.4L7 8.4 1.4 14 0 12.6 5.6 7z\"></path></svg></button><h4 class=\"modal-title\" id=\"sbModalLabel\">{{controller.getTextTranslationByKey(\'header\')}}</h4></div><div class=\"modal-body\"><p>{{controller.getTextTranslationByKey(\'content\')}}</p><div class=\"select-language-container\"><label class=\"choose-language-select-label\">{{controller.getTextTranslationByKey(\'select_label\')}}</label><div class=\"select-language-wrapper\"><select id=\"language-picker-modal-selector\" aria-invalid=\"false\" class=\"select-language\" ng-model=\"currentLang\"><option value=\"de\">Deutsch</option><option value=\"en\" selected=\"\">English</option><option value=\"es\">Español</option><option value=\"fr\">Français</option><option value=\"it\">Italiano</option><option value=\"pt\">Português</option><option value=\"ru\">Русский</option><option value=\"ko\">한국어</option><option value=\"ja\">日本語</option><option value=\"zh-cn\">简体中文</option><option value=\"zh-tw\">繁體中文</option></select><svg width=\"0.675em\" viewbox=\"0 0 1 0.6\" fill=\"currentColor\" class=\"select-arrow\"><path d=\"M.07.07L0 .14l.25.25.25.25.25-.25L1 .14.93.07.86 0 .68.18.5.36.32.18.14 0 .07.07\"></path></svg><div class=\"select-border\"></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"modal-button\" ng-click=\"changeLanguage(currentLang);controller.closeChangeLanguageModal()\" data-dismiss=\"modal\">{{controller.getTextTranslationByKey(\'button\')}}</button></div></div></div></div>");
$templateCache.put("app/custom/clients/burberry/directives/hoursCardBurberry.directive.html","<div class=\"hours-card\" ng-show=\"hoursCardBurberryC.locHours || hoursCardBurberryC.specialHours || hoursCardBurberryC.hoursNote\"><div ng-class=\"{\'collapse-mobile\': hoursCardBurberryC.collapsibleOn === \'mobile\', \'collapse-desktop\': hoursCardBurberryC.collapsibleOn === \'desktop\', \'collapse-all\': hoursCardBurberryC.collapsibleOn === \'all\'}\" class=\"collapsible show\"><div ng-if=\"hoursCardBurberryC.locHours\"><dl class=\"dl-horizontal\" ng-if=\"!hoursCardBurberryC.onlyToday\" itemprop=\"openingHours\" content=\"{{hoursCardBurberryC.openingHours}}\"><dt ng-repeat-start=\"(day,hours) in hoursCardBurberryC.locHours\" ng-class=\"hours.highlightClass\"><span>{{hours.dayName}}</span></dt><dd ng-if=\"hours.highlightClass\" ng-repeat=\"i in hours.numberOfTimeFragments track by $index\"><div class=\"hours-column margin-left-day-hours\"><span ng-class=\"hours.highlightClass\" ng-if=\"!hours.closed\"><span ng-show=\"$index > 0\">&</span> {{hoursCardBurberryC.getOpenTimePeriodDisplayMessage(hours,$index)}}</span> <span ng-class=\"hours.highlightClass\" ng-if=\"hours.closed\">{{hours.closedLabel}}</span></div></dd><dd ng-if=\"!hours.highlightClass\" ng-repeat-end=\"\" ng-repeat=\"i in hours.numberOfTimeFragments track by $index\" class=\"hours-location\"><div class=\"hours-column margin-left-day-hours\"><span ng-class=\"hours.highlightClass\" ng-if=\"!hours.closed && !hours.open24\"><span ng-show=\"$index > 0\">&</span> {{hoursCardBurberryC.getOpenTimePeriodDisplayMessage(hours, $index)}}</span> <span ng-class=\"hours.highlightClass\" ng-if=\"hours.open24\">{{hoursCardBurberryC.translatedMessages[\'mf.localPage.hours.open24\'] || \'Open 24 Hours\'}}</span> <span ng-class=\"hours.highlightClass\" ng-if=\"hours.closed\">{{hours.closedLabel}}</span></div></dd></dl></div><div class=\"hours-note\" ng-if=\"hoursCardBurberryC.hoursNote\">* {{ hoursCardBurberryC.hoursNote.data }}</div><div ng-if=\"hoursCardBurberryC.specialHours\" class=\"specialHours\"><p class=\"bold-500 push-top push-bottom\" id=\"specialHours\"><i ng-class=\"{\'opened\': !hoursCardBurberryC.closedNow , \'closed\': hoursCardBurberryC.closedNow}\" class=\"ico ico-clock\"></i> Special Hours</p><dl class=\"dl-horizontal\" itemprop=\"openingHoursSpecification\" itemscope=\"\" itemtype=\"http://schema.org/OpeningHoursSpecification\"><dt ng-repeat-start=\"(day,hours) in hoursCardBurberryC.specialHours\" ng-class=\"hours.highlightClass\"><span itemprop=\"validFrom validThrough\" datetime=\"{{hours.dayNameShort}}\">{{hours.dayNameShort}}</span></dt><dd ng-if=\"hours.highlightClass\"><span ng-class=\"hours.highlightClass\" ng-if=\"!hours.closed\">{{hoursCardBurberryC.getOpenTimePeriodDisplayMessage(hours)}}</span> <span ng-class=\"hours.highlightClass\" ng-if=\"hours.closed\" itemprop=\"closes\">{{hoursCardBurberryC.translatedMessages[\'mf.localPage.hours.closed\'] || \'Closed\'}}</span></dd><dd ng-if=\"!hours.highlightClass\" ng-repeat-end=\"\" ng-repeat=\"i in hours.numberOfTimeFragments track by $index\"><span ng-class=\"hours.highlightClass\" ng-if=\"!hours.closed && !hours.open24\">{{hoursCardBurberryC.getOpenTimePeriodDisplayMessage(hours, $index)}}</span> <span ng-class=\"hours.highlightClass\" ng-if=\"hours.open24\" itemprop=\"opens\" content=\"12:00 AM\">{{hoursCardBurberryC.translatedMessages[\'mf.localPage.hours.open24\'] || \'Open 24 Hours\'}}</span> <span ng-class=\"hours.highlightClass\" ng-if=\"hours.closed\" itemprop=\"closes\" content=\"12:00 AM\">{{hoursCardBurberryC.translatedMessages[\'mf.localPage.hours.closed\'] || \'Closed\'}}</span></dd></dl></div></div></div>");
$templateCache.put("app/custom/clients/burberry/directives/listHoursCard.directive.html","<div class=\"list-hours-card\"><p ng-if=\"listHoursCardC.displayLabel\" class=\"bold-500 push-top push-bottom\"><span class=\"closed-store\">{{listHoursCardC.displayLabel}}</span></p></div>");
$templateCache.put("app/custom/clients/burberry/directives/nearbyCardBurberry.directive.html","<div class=\"nearby-section section-container\" ng-show=\"nearbyCardBurberryC.nearbyLocations.length\"><h2>{{nearbyCardBurberryC.translatedMessages[\'mf.localPage.nearbyCard.nearbyStores\'] || \'Nearby stores\'}}</h2><div class=\"nearby-card\"><div class=\"nearby-card-item\" ng-repeat=\"location in nearbyCardBurberryC.nearbyLocations\"><button-card class=\"icon-cta h5\" location=\"location\" visibility=\"Store Locator\" custom-link=\"{{nearbyCardBurberryC.getLocalPageUrl(location)}}\" custom-text=\"{{nearbyCardBurberryC.getCustomFieldValueByName(location.customFields, \'store_name\') || location.name}}\"></button-card><hours-card-multi ng-if=\"nearbyCardBurberryC.hoursLocations[location.corporate_id]\" data-location=\"nearbyCardBurberryC.hoursLocations[location.corporate_id]\" data-only-today=\"true\" translated-messages=\"nearbyCardBurberryC.translatedMessages\"></hours-card-multi><button-card ng-if=\"nearbyCardBurberryC.hoursLocations[location.corporate_id]\" class=\"icon-cta\" target=\"_blank\" location=\"nearbyCardBurberryC.hoursLocations[location.corporate_id]\" visibility=\"Local Page\" custom-link=\"{{nearbyCardBurberryC.getDirectionsUrl(location.address_detail)}}\" custom-text=\"{{nearbyCardBurberryC.translatedMessages[\'mf.common.getDirections\'] || \'Get directions\'}}\"></button-card><store-services-local-store-card location-tags=\"location.tags\" location-id=\"{{location.id}}\" translated-messages=\"nearbyCardBurberryC.translatedMessages\"></store-services-local-store-card></div></div></div>");
$templateCache.put("app/custom/clients/burberry/directives/paymentOptionsCard.directive.html","<div class=\"section-container payment-methods\" ng-show=\"paymentOptionsC.locationPaymentOptions\"><h2>{{paymentOptionsC.translatedMessages[\'mf.localPage.paymentOptionsCard.paymentMethods\'] || \'Payment Methods\'}}</h2><div class=\"payment-options\"><div class=\"payment-options-item\" ng-repeat=\"payment_option in paymentOptionsC.paymentOptions\"><img ng-src=\"{{payment_option.image}}\"> <span>{{payment_option.label}}</span></div></div></div>");
$templateCache.put("app/custom/clients/burberry/directives/searchBurberry.directive.html","<div id=\"js-search\"><div class=\"search-container\" ng-class=\"{ \'hide-search\': searchBurberryCtrl.hideElementName === \'search\' }\"><form name=\"search\"><div class=\"search-above-placeholder\" ng-show=\"searchBurberryCtrl.locatorStates.searchInput != \'\'\">{{searchBurberryCtrl.translatedMessages[\'mf.storeLocator.search.searchForLocation\'] || \'Search for locations\'}}</div><div id=\"search_box\" class=\"clearfix\"><div class=\"input-group\"><div class=\"input-group-btn\"><button id=\"searchBtn\" title=\"search button\" type=\"submit\" class=\"btn btn-primary pull-right\" aria-label=\"Search\" role=\"button\" data-ng-click=\"searchBurberryCtrl.hitSearchBtn()\" aria-hidden=\"false\" data-analytics-event=\"Search\" data-analytics-label=\"Store Locator\" data-analytics-category=\"Store Locator\" data-analytics-value=\"1\" data-analytics-on=\"click\"><svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" width=\"20\" height=\"20\"><g clip-path=\"url(#a)\"><path fill=\"#000\" fill-rule=\"evenodd\" d=\"M12.5 7a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0Zm-1.112 5.454a7 7 0 1 1 1.061-1.06L20 18.939 18.94 20l-7.551-7.545Z\" clip-rule=\"evenodd\"></path></g><defs><clippath id=\"a\"><path fill=\"#fff\" d=\"M0 0h20v20H0z\"></path></clippath></defs></svg></button></div><input id=\"searchField\" tabindex=\"0\" name=\"\" role=\"combobox\" aria-label=\"Search for locations\" class=\"form-control v-align-top\" placeholder=\"{{searchBurberryCtrl.translatedMessages[\'mf.storeLocator.search.searchForLocation\'] || \'Search for locations\'}}\" data-typeahead-on-select=\"searchBurberryCtrl.autoCompleteSelect(searchBurberryCtrl.locatorStates.searchInput)\" data-ng-model=\"searchBurberryCtrl.locatorStates.searchInput\" data-typeahead=\"place as place.name for place in searchBurberryCtrl.autoCompleteLocations($viewValue)\" data-typeahead-min-length=\"0\" autocomplete=\"off\" data-container=\"#js-search\" data-min-length=\"2\" maxlength=\"256\"><div class=\"input-group-btn v-align-top\"><button id=\"clearInputBtn\" type=\"button\" class=\"btn btn-primary custom-client\" data-ng-show=\"searchBurberryCtrl.locatorStates.searchInput && searchBurberryCtrl.locatorStates.searchInput !== \'\'\" data-ng-click=\"searchBurberryCtrl.clearInput()\" aria-hidden=\"false\" title=\"{{searchBurberryCtrl.translatedMessages[\'mf.storeLocator.search.clearSearchInput\'] || \'Clear search input\'}}\" alt=\"Clear search input\"><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"20\" height=\"20\" fill=\"none\"><path fill=\"#000\" fill-rule=\"evenodd\" d=\"m9.995 8.939 4.94-4.94 1.062 1.06-4.94 4.94L16 14.939 14.94 16l-4.944-4.94-4.933 4.931L4 14.931 8.935 10 4 5.067l1.06-1.061 4.936 4.933Z\" clip-rule=\"evenodd\"></path></svg></button> <button id=\"geoLocationBtn\" type=\"button\" class=\"btn btn-primary custom-client\" aria-label=\"Geo Locate Button\" data-ng-show=\"searchBurberryCtrl.locatorStates.geoEnabled != null\" data-ng-disabled=\"!searchBurberryCtrl.locatorStates.geoEnabled\" data-ng-click=\"searchBurberryCtrl.userLatLngSearch($event)\" aria-hidden=\"false\" title=\"{{searchBurberryCtrl.translatedMessages[\'mf.storeLocator.search.findLocationsNearYou\'] || \'Find Locations Near You\'}}\" alt=\"Find Locations Near You\" data-analytics-event=\"Get Geo Location\" data-analytics-label=\"Store Locator\" data-analytics-category=\"Store Locator\" data-analytics-value=\"1\" data-analytics-on=\"click\"><svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" width=\"20\" height=\"20\"><path stroke=\"#000\" stroke-width=\"1.5\" d=\"M10.63 15 15 5 5 8.757l4.741 1.483.889 4.76Z\"></path></svg></button></div></div></div></form></div><div class=\"store-locator-filters\" ng-class=\"{ \'hide-filters\': searchBurberryCtrl.hideElementName === \'filters\' }\" ng-if=\"!searchBurberryCtrl.isFirstApplyFilter || searchBurberryCtrl.locatorStates.locations.length > 0 || searchBurberryCtrl.quantityOfFilters > 0\"><span class=\"results-count\">{{searchBurberryCtrl.locatorStates.locations.length}}</span> <span>{{(searchBurberryCtrl.locatorStates.locations.length === 1 ? \' \'+(searchBurberryCtrl.translatedMessages[\'mf.storeLocator.search.store\'] || \'store\') : \' \'+(searchBurberryCtrl.translatedMessages[\'mf.storeLocator.search.stores\'] || \'stores\'))}}</span> <span class=\"filter-link\" ng-if=\"!searchBurberryCtrl.hideFilterButton\" data-ng-click=\"searchBurberryCtrl.setAccordionIsOpen()\">{{searchBurberryCtrl.translatedMessages[\'mf.storeLocator.search.filters\'] || \'Filters\'}}<sup ng-if=\"searchBurberryCtrl.quantityOfFilters > 0\">{{searchBurberryCtrl.quantityOfFilters}}</sup></span></div></div><div ng-if=\"searchBurberryCtrl.showFilters\" class=\"modal-filters-burberry\"><div class=\"modal-content-burberry\"><div class=\"modal-content-burberry-header\"><h1>{{searchBurberryCtrl.translatedMessages[\'mf.storeLocator.search.filters\'] || \'Filters\'}}</h1><button data-ng-click=\"searchBurberryCtrl.closeModal()\"><img src=\"/assets/images/clients/burberry/close.m.svg\" alt=\"close filters\"></button></div><div class=\"modal-content-burberry-body\"><div class=\"accordion\" ng-repeat=\"filterType in searchBurberryCtrl.availableFilterTypes\"><div class=\"accordion-header\" ng-click=\"searchBurberryCtrl.toggleAccordion($index)\" role=\"none\"><span ng-class=\"searchBurberryCtrl.accordionIsOpen[$index] ? \'filter-type-open\' : \'filter-type-close\'\">{{ filterType }}</span> <img class=\"accordion-open-close\" src=\"/assets/images/clients/burberry/chevron-down.svg\" alt=\"open accordion\" ng-show=\"!searchBurberryCtrl.accordionIsOpen[$index]\"> <img class=\"accordion-open-close\" src=\"/assets/images/clients/burberry/chevron-up-blue.svg\" alt=\"close accordion\" ng-show=\"searchBurberryCtrl.accordionIsOpen[$index]\"></div><div class=\"accordion-content\" ng-show=\"searchBurberryCtrl.activeIndex === $index\" ng-class=\"{ \'active\': searchBurberryCtrl.activeIndex === $index }\"><div class=\"accordion-content-list\"><div class=\"accordion-content-list-element\" data-ng-repeat=\"filter in searchBurberryCtrl.availableFilters | filter: {type: filterType} track by $index\" data-ng-attr-id=\"filterRow{{$index}}\" data-ng-class=\"{active: filter.active}\"><span data-ng-attr-id=\"filterBtn{{$index}}\" data-ng-click=\"searchBurberryCtrl.addPreFilter(filter.label)\" class=\"accordion-content-list-element-span\" ng-class=\"{\'accordion-content-list-element-underline\': searchBurberryCtrl.isItemSelected(filter.label) }\" role=\"none\">{{filter.label}}</span></div></div></div></div></div></div><div class=\"modal-content-burberry-footer\"><div class=\"modal-content-burberry-footer-filters\" ng-if=\"!searchBurberryCtrl.isFirstApplyFilter || searchBurberryCtrl.preFilters.length > 0\"><div class=\"modal-content-burberry-footer-clear-all\" ng-click=\"searchBurberryCtrl.clearPreFilter()\" role=\"none\">{{searchBurberryCtrl.translatedMessages[\'mf.storeLocator.filterModal.clearAll\'] || \'Clear&nbsp;All\'}}</div><div data-ng-repeat=\"preFilter in searchBurberryCtrl.preFilters\" class=\"modal-content-burberry-footer-pre-filter\"><span>{{preFilter}}</span><span><img src=\"/assets/images/clients/burberry/close.s.svg\" alt=\"close filters\" ng-click=\"searchBurberryCtrl.deletePreFilterByIndex($index)\"></span></div></div><div class=\"modal-content-burberry-footer-apply\"><button data-ng-disabled=\"searchBurberryCtrl.isFirstApplyFilter && searchBurberryCtrl.preFilters.length === 0\" ng-click=\"searchBurberryCtrl.applyFilters()\">{{searchBurberryCtrl.translatedMessages[\'mf.storeLocator.filterModal.applyFilter\'] || \'Apply Filters\'}}</button></div></div></div>");
$templateCache.put("app/custom/clients/burberry/directives/storeServicesCard.directive.html","<div class=\"store-services-section local-services\" ng-show=\"storeServicesC.storeServices.length > 0\"><h2>{{storeServicesC.translatedMessages[\'mf.localPage.storeServiceCard.whatThisStoreOffers\'] || \'What this store offers\'}}</h2><ul class=\"store-services\"><li class=\"store-service-item\" ng-repeat=\"store_service in storeServicesC.storeServices track by $index\" ng-class=\"($index > 3 && storeServicesC.windowWidth < 768) ? \'hidden\' : \'\'\"><a target=\"_self\" data-ng-href=\"{{store_service.url}}\">{{store_service.label}}</a></li></ul><button ng-if=\"storeServicesC.showMoreBtn && storeServicesC.windowWidth < 768\" ng-click=\"storeServicesC.showMore(\'show-btn\', storeServicesC.translatedMessages[\'mf.common.showMore\'])\" id=\"show-btn\">{{storeServicesC.translatedMessages[\'mf.common.showMore\'] || \'Show more\'}}</button></div>");
$templateCache.put("app/custom/clients/burberry/directives/storeServicesLocalStoreCard.directive.html","<div class=\"store-services-section\" ng-show=\"storeServicesLocalStoreC.hasTranscludeData || storeServicesLocalStoreC.storeServices.length > 0\"><button class=\"services-btn\" ng-click=\"storeServicesLocalStoreC.showServicesAvailable();$event.stopPropagation();\">{{ storeServicesLocalStoreC.isExpanded ? storeServicesLocalStoreC.translatedMessages[\'mf.storeLocator.resultList.hideServicesAvailables\'] || \'Hide\' : storeServicesLocalStoreC.translatedMessages[\'mf.storeLocator.resultList.showServicesAvailables\'] || \'Show\' }} <i class=\"custom-icon\" ng-class=\"storeServicesLocalStoreC.isExpanded ? \'chevron-up\' : \'chevron-down\'\"></i></button><ul class=\"store-services\" ng-show=\"storeServicesLocalStoreC.isExpanded\"><li class=\"{{\'store-service-item\'}}\" ng-repeat=\"store_service in storeServicesLocalStoreC.storeServices track by $index\" ng-class=\"$index > (storeServicesLocalStoreC.maxServicesToShowWithoutShowMore - 1) && storeServicesLocalStoreC.showMoreBtn ? \'hidden\' : \'\'\"><span>{{store_service.label}}</span></li></ul><button ng-if=\"storeServicesLocalStoreC.storeServices.length > storeServicesLocalStoreC.maxServicesToShowWithoutShowMore && storeServicesLocalStoreC.isExpanded\" ng-click=\"storeServicesLocalStoreC.showMore($event)\" id=\"show-btn\"><span ng-show=\"storeServicesLocalStoreC.showMoreBtn\">{{storeServicesLocalStoreC.translatedMessages[\'mf.common.showMore\'] || \'Show more\'}}</span> <span ng-show=\"!storeServicesLocalStoreC.showMoreBtn\">{{storeServicesLocalStoreC.translatedMessages[\'mf.common.showLess\'] || \'Show less\'}}</span></button><div ng-show=\"storeServicesLocalStoreC.isExpanded && storeServicesLocalStoreC.hasTranscludeData\"><div class=\"transclude\"></div></div></div>xa");
$templateCache.put("app/custom/clients/burberry/templates/locationList.template.html","<div class=\"site-map-list push-top-lg\"><br><div><h1 ng-if=\"locationListC.worldwideh1\">{{locationListC.locationsTitleText}}</h1></div><hr><div ng-if=\"locationListC.locations\"><div class=\"container\" ng-if=\"locationListC.position === \'global\'\" ng-repeat=\"(continent, locations) in locationListC.locations\"><div class=\"row push-top-md\"><h2><a class=\"bold\" title=\"{{(continent === \'Central American\') ? \'Central America\' : continent}}\">{{(continent === \'Central American\') ? \'Central America\' : continent}}</a></h2></div><div class=\"row\"><div ng-repeat=\"country in locationListC.getListOfCountries(locations).keys\"><div class=\"col-lg-4 country-locations\" ng-if=\"((locationListC.checkCountryInContinent(country)) === continent)\"><h3><a title=\"{{locationListC.getCountry(country)}}\" href=\"{{ locationListC.languageService.updateLinkUrl(\'site-map/\' + country) }}\">{{locationListC.getCountry(country)}}</a></h3></div></div></div><br></div><div ng-if=\"locationListC.position === \'continent\'\" ng-repeat=\"(country, locations) in locationListC.locations\"><div ng-if=\"((locationListC.checkCountryInContinent(country)) === continent)\"><h2><a class=\"bold\" title=\"{{locationListC.getCountry(country)}}\" href=\"{{ locationListC.languageService.updateLinkUrl(\'site-map/\' + locations[0].store_info.country) }}\">{{locationListC.getCountry(country)}}</a></h2></div></div><div ng-if=\"locationListC.position === \'country\'\" ng-repeat=\"(place, locations) in locationListC.locations\"><h2><a ng-if=\"locationListC.getCountry(locations[0].store_info.country) === \'United States\'\" class=\"bold\" title=\"{{locationListC.getRegion(locations[0].store_info.region)}}\" href=\"{{ locationListC.languageService.updateLinkUrl(\'site-map/\' + locations[0].store_info.country + \'/\' + locations[0].store_info.region ) }}\">{{locationListC.getRegion(locations[0].store_info.country, locations[0].store_info.region)}}</a> <span class=\"bold\" ng-if=\"locationListC.getCountry(locations[0].store_info.country) !== \'United States\'\">{{locationListC.getRegion(locations[0].store_info.country, locations[0].store_info.region)}}</span></h2><div class=\"region-locations\"><div ng-repeat=\"location in locations track by $index\" class=\"small\"><a class=\"sitemap-region\" href=\"{{ locationListC.languageService.updateLinkUrl(\'site-map/\' + locations[0].store_info.country + \'/\' + (locationListC.getCountry(locations[0].store_info.country) === \'United States\' ? locations[0].store_info.region + \'/\' : \'\') + location.store_info.locality ) }}\">{{location.store_info.locality}}</a>- <a class=\"sitemap-location\" href=\"{{ locationListC.languageService.updateLinkUrl(location.llp_url) }}\">{{location.store_info.address}} <span ng-if=\"location.store_info.address_extended\">, {{location.store_info.address_extended}}</span> <span class=\"coming-soon-text\" ng-if=\"location.open_or_closed === \'coming soon\' && locationListC.comingSoonText\">- {{locationListC.comingSoonText}}</span> <span class=\"coming-soon-text\" ng-if=\"location.open_or_closed === \'temp closed\'\">- Temporarily Closed</span></a></div></div></div><div ng-if=\"locationListC.position === \'region\'\"><div ng-repeat=\"(place, locations) in locationListC.others\"><h3><a class=\"bold\" title=\"{{place}}\" href=\"{{ locationListC.languageService.updateLinkUrl(\'site-map/\' + locations[0].store_info.country + \'/\' + locations[0].store_info.region + \'/\' + locations[0].store_info.locality ) }}\">{{place}}</a></h3><div class=\"region-locations\"><div ng-repeat=\"loc in locations\" class=\"small\"><a class=\"sitemap-region\" href=\"{{ locationListC.languageService.updateLinkUrl(\'site-map/\' + loc.store_info.country + \'/\' + loc.store_info.region + \'/\' + loc.store_info.locality ) }}\">{{loc.store_info.locality}}</a>- <a class=\"sitemap-location\" href=\"{{ locationListC.languageService.updateLinkUrl(loc.llp_url) }}\">{{loc.store_info.address}} <span ng-if=\"loc.store_info.address_extended\">, {{loc.store_info.address_extended}}</span> <span class=\"coming-soon-text\" ng-if=\"loc.open_or_closed === \'coming soon\' && locationListC.comingSoonText\">- {{locationListC.comingSoonText}}</span> <span class=\"coming-soon-text\" ng-if=\"loc.open_or_closed === \'temp closed\'\">- Temporarily Closed</span></a></div></div></div><div ng-if=\"locationListC.featured.length > 0\"><h1 class=\"bold\">Featured</h1><div ng-repeat=\"(place, locations) in locationListC.featured\"><h3><a class=\"bold\" title=\"{{place}}\" href=\"{{ locationListC.languageService.updateLinkUrl(\'site-map/\' + locations[0].store_info.country + \'/\' + locations[0].store_info.region + \'/\' + locations[0].store_info.locality ) }}\">{{place}}</a></h3><div class=\"region-locations\"><div ng-repeat=\"loc in locations\" class=\"small\"><a class=\"sitemap-region\" href=\"{{ locationListC.languageService.updateLinkUrl(\'site-map/\' + loc.store_info.country + \'/\' + loc.store_info.region + \'/\' + loc.store_info.locality ) }}\">{{loc.store_info.locality}}</a>- <a class=\"sitemap-location\" href=\"{{ locationListC.languageService.updateLinkUrl(loc.llp_url) }}\">{{loc.store_info.address}} <span ng-if=\"loc.store_info.address_extended\">, {{loc.store_info.address_extended}}</span> <span class=\"coming-soon-text\" ng-if=\"loc.open_or_closed === \'coming soon\' && locationListC.comingSoonText\">- {{locationListC.comingSoonText}}</span> <span class=\"coming-soon-text\" ng-if=\"loc.open_or_closed === \'temp closed\'\">- Temporarily Closed</span></a></div></div></div></div></div><div ng-if=\"locationListC.position === \'locality\'\" ng-repeat=\"(place, locations) in locationListC.locations\"><h3><a class=\"bold\" title=\"{{place}}\" href=\"{{ locationListC.languageService.updateLinkUrl(\'site-map/\' + locations[0].store_info.country + \'/\' + (locationListC.getCountry(locations[0].store_info.country) === \'United States\' ? locations[0].store_info.region + \'/\' : \'\') + locations[0].store_info.locality ) }}\">{{place}}</a></h3><div class=\"region-locations\"><div ng-repeat=\"loc in locations\" class=\"small\"><a class=\"sitemap-region\" href=\"{{ locationListC.languageService.updateLinkUrl(\'site-map/\' + loc.store_info.country + \'/\' + (locationListC.getCountry(locations[0].store_info.country) === \'United States\' ? locations[0].store_info.region + \'/\' : \'\') + loc.store_info.locality ) }}\">{{loc.store_info.locality}}</a>- <a class=\"sitemap-location\" href=\"{{ locationListC.languageService.updateLinkUrl(loc.llp_url) }}\">{{loc.store_info.address}} <span ng-if=\"loc.store_info.address_extended\">, {{loc.store_info.address_extended}}</span> <span class=\"coming-soon-text\" ng-if=\"loc.open_or_closed === \'coming soon\' && locationListC.comingSoonText\">- {{locationListC.comingSoonText}}</span> <span class=\"coming-soon-text\" ng-if=\"loc.open_or_closed === \'temp closed\'\">- Temporarily Closed</span></a></div></div></div><div class=\"container\" ng-if=\"locationListC.position === \'all\'\"><div ng-repeat=\"(region, locations) in locationListC.locations\" ng-if=\"locationListC.locations\"><h2><a ng-if=\"locationListC.getCountry(locations[0].store_info.country) === \'United States\'\" class=\"bold\" title=\"{{region}}\" href=\"{{ locationListC.languageService.updateLinkUrl(\'site-map/\' + locations[0].store_info.country + \'/\' + locations[0].store_info.region ) }}\">{{region}}</a> <span class=\"bold\" ng-if=\"locationListC.getCountry(locations[0].store_info.country) !== \'United States\'\">{{locationListC.getRegion(locations[0].store_info.country, locations[0].store_info.region)}}</span></h2><div class=\"region-locations\"><div ng-repeat=\"location in locations track by $index\" class=\"small\"><a class=\"sitemap-region\" href=\"{{ locationListC.languageService.updateLinkUrl(\'site-map/\' + locations[0].store_info.country + \'/\' + (locationListC.getCountry(locations[0].store_info.country) === \'United States\' ? locations[0].store_info.region + \'/\' : \'\') + location.store_info.locality ) }}\">{{location.store_info.locality}}</a>- <a class=\"sitemap-location\" href=\"{{ locationListC.languageService.updateLinkUrl(location.llp_url) }}\">{{location.store_info.address}} <span ng-if=\"location.store_info.address_extended\">, {{location.store_info.address_extended}}</span> <span class=\"coming-soon-text\" ng-if=\"loc.open_or_closed === \'coming soon\' && locationListC.comingSoonText\">- {{locationListC.comingSoonText}}</span> <span class=\"coming-soon-text\" ng-if=\"loc.open_or_closed === \'temp closed\'\">- Temporarily Closed</span></a></div></div></div></div></div></div>");
$templateCache.put("app/custom/clients/burberry/templates/mapPopup.template.html","<div class=\"mf-popup-content\" data-ng-attr-id=\"loc_{{mapPopupCtrl.location.number}}\"><image-card class=\"store-image\" location=\"mapPopupCtrl.location.entire_location\" visibility=\"LLP\" custom-field=\"store_image\"></image-card><div class=\"store-info\"><div><h4>{{mapPopupCtrl.getCustomFieldValue(\'store_name\') || mapPopupCtrl.location.name}}</h4><list-hours-card ng-if=\"!mapPopupCtrl.getCustomFieldValue(\'pop_up_information\')\" data-location=\"mapPopupCtrl.location.entire_location\" translated-messages=\"mapPopupCtrl.translatedMessages\"></list-hours-card></div><div class=\"clearfix\"><button-card class=\"icon-cta\" location=\"mapPopupCtrl.location.entire_location\" visibility=\"Store Locator\" custom-link=\"{{mapPopupCtrl.location.directionsUrl}}\" custom-text=\"{{mapPopupCtrl.translatedMessages[\'mf.common.getDirections\'] || \'Get directions\'}}\"><i class=\"custom-icon chevron-right pull-right\"></i></button-card><button-card ng-if=\"mapPopupCtrl.location.local_landing_page\" class=\"icon-cta\" location=\"mapPopupCtrl.location.entire_location\" visibility=\"Store Locator\" custom-link=\"{{mapPopupCtrl.client_route}}{{mapPopupCtrl.location.link}}\" custom-text=\"{{mapPopupCtrl.translatedMessages[\'mf.storeLocator.mapPopup.moreDetails\'] || \'More details\'}}\"><i class=\"custom-icon arrow-right pull-right\"></i></button-card></div></div></div>");
$templateCache.put("app/custom/clients/burberry/templates/resultsLi.template.html","<li data-ng-attr-id=\"{{resultsLiCtrl.location.id}}\" data-ng-click=\"resultsLiCtrl.showLocationPopup(resultsLiCtrl.location.number)\" class=\"location-li\"><div class=\"clearfix\"><button-card class=\"icon-cta h5\" location=\"resultsLiCtrl.location.entire_location\" visibility=\"Store Locator\" custom-link=\"{{resultsLiCtrl.location.local_landing_page ? resultsLiCtrl.location.llpUrlWithLanguage : \'#\'}}\" custom-text=\"{{resultsLiCtrl.getCustomFieldValue(\'store_name\') || resultsLiCtrl.location.name}}\"><span class=\"pull-right\"><span class=\"distance\">{{resultsLiCtrl.location.entire_location.distance | number:1 }} {{resultsLiCtrl.translatedMessages[\'mf.storeLocator.resultList.milesAway\'] || \'miles away\'}}</span></span></button-card><list-hours-card ng-if=\"!resultsLiCtrl.getCustomFieldValue(\'pop_up_information\')\" data-location=\"resultsLiCtrl.location.entire_location\" translated-messages=\"resultsLiCtrl.translatedMessages\"></list-hours-card><html-card location=\"resultsLiCtrl.location.entire_location\" html-content=\"pop_up_information\"></html-card><button-card class=\"icon-cta\" target=\"_blank\" location=\"resultsLiCtrl.location.entire_location\" visibility=\"Store Locator\" custom-link=\"{{resultsLiCtrl.location.directionsUrl}}\" custom-text=\"{{resultsLiCtrl.translatedMessages[\'mf.common.getDirections\'] || \'Get directions\'}}\"></button-card><store-services-local-store-card location-tags=\"resultsLiCtrl.location.entire_location.tags\" location-id=\"{{resultsLiCtrl.location.entire_location.id}}\" translated-messages=\"resultsLiCtrl.translatedMessages\"><button-card class=\"primary-cta\" target=\"_blank\" custom-field=\"book_appointment\" location=\"resultsLiCtrl.location.entire_location\" visibility=\"Store Locator\" custom-text=\"{{resultsLiCtrl.translatedMessages[\'mf.common.bookAnAppointment\'] || \'Book an appointment\'}}\" ng-click=\"$event.stopPropagation();\" snowplow-tracking=\"\" data-snowplow-context=\"Store Locator Page\" data-snowplow-description=\"click to book an appointment in store\" data-snowplow-name=\"book an appointment\" data-snowplow-component=\"cta-button\"></button-card></store-services-local-store-card></div><script type=\"text/javascript\">\n  </script></li>");
$templateCache.put("app/custom/clients/burberry/layout/footer/de.html","<footer id=\"footer\"><div class=\"footer-menu-container\"><div class=\"menu-section\"><a href=\"/\" title=\"Einen Store suchen\" data-title=\"Einen Store suchen\">Einen Store suchen</a></div><div class=\"menu-section\"><button id=\"footer-services\" aria-expanded=\"false\" aria-controls=\"footer-services-list\" class=\"menu-item\" ng-click=\"controller.toggleFooter(\'footer-services\')\"><span>Burberry-Services</span><div class=\"icon-wrapper\"><svg role=\"img\" width=\"7\" height=\"10\" viewbox=\"6.5 5 7 10\"><title>chevron-down</title><path fill=\"none\" stroke=\"currentColor\" stroke-miterlimit=\"10\" stroke-width=\"1.5\" d=\"M12.125 5.75 7.875 10l4.25 4.25\"></path></svg></div></button><div id=\"footer-services-list\"><ul class=\"menu-item-list\" style=\"height: 0;\"><li><a href=\"https://www.burberry.com/appointment-booking/\" target=\"_self\">Termin vereinbaren</a></li><li><a href=\"https://www.burberry.com/c/stores/bespoke-trench-service/\" target=\"_self\">Trenchcoat Bespoke</a></li><li><a href=\"https://www.burberry.com/burberry-aftercare/\" target=\"_self\">Pflegeservice</a></li><li><a href=\"https://www.burberry.com/c/personalisation-and-monogramming/\" target=\"_self\">Personalisierung</a></li><li><a href=\"https://www.burberry.com/c/burberry-services/\" target=\"_self\">Alle Services</a></li></ul></div><button id=\"footer-customer-support\" aria-expanded=\"false\" aria-controls=\"footer-customer-support-list\" class=\"menu-item\" ng-click=\"controller.toggleFooter(\'footer-customer-support\')\"><span>Kundenservice</span><div class=\"icon-wrapper\"><svg role=\"img\" width=\"7\" height=\"10\" viewbox=\"6.5 5 7 10\"><title>chevron-down</title><path fill=\"none\" stroke=\"currentColor\" stroke-miterlimit=\"10\" stroke-width=\"1.5\" d=\"M12.125 5.75 7.875 10l4.25 4.25\"></path></svg></div></button><div id=\"footer-customer-support-list\"><ul class=\"menu-item-list\" style=\"height: 0;\"><li><a href=\"https://www.burberry.com/customer-service/contact-us/\" target=\"_self\">Kontakt</a></li><li><a href=\"https://www.burberry.com/customer-service/shipping/\" target=\"_self\">Versand</a></li><li><a href=\"https://www.burberry.com/customer-service/payment/\" target=\"_self\">Bestellungen und Bezahlung</a></li><li><a href=\"https://www.burberry.com/customer-service/returns/\" target=\"_self\">Rückgaben</a></li></ul></div><button id=\"footer-about\" aria-expanded=\"false\" aria-controls=\"footer-about-list\" class=\"menu-item\" ng-click=\"controller.toggleFooter(\'footer-about\')\"><span>Mehr zu Burberry</span><div class=\"icon-wrapper\"><svg role=\"img\" width=\"7\" height=\"10\" viewbox=\"6.5 5 7 10\"><title>chevron-down</title><path fill=\"none\" stroke=\"currentColor\" stroke-miterlimit=\"10\" stroke-width=\"1.5\" d=\"M12.125 5.75 7.875 10l4.25 4.25\"></path></svg></div></button><div id=\"footer-about-list\"><ul class=\"menu-item-list\" style=\"height: 0;\"><li><a href=\"https://www.burberry.com/c/burberry-heritage/\" target=\"_self\">Unsere Tradition</a></li><li><a href=\"https://www.burberry.com/c/stories/\" target=\"_self\">Storys</a></li><li><a href=\"https://www.burberry.com/c/values/sustainability/\" target=\"_self\">Nachhaltigkeit</a></li><li><a href=\"https://www.burberryplc.com/impact/Our-Approach\" target=\"_self\" rel=\"noopener noreferrer\">Unternehmerische Verantwortung</a></li><li><a href=\"https://www.burberryplc.com/\" target=\"_self\" rel=\"noopener noreferrer\">Burberry Group Plc.</a></li><li><a href=\"https://burberrycareers.com\" target=\"_self\" rel=\"noopener noreferrer\">Karriere</a></li></ul></div><button id=\"footer-legal\" aria-expanded=\"false\" aria-controls=\"footer-legal-list\" class=\"menu-item\" ng-click=\"controller.toggleFooter(\'footer-legal\')\"><span>Rechtliche Hinweise und Cookies</span><div class=\"icon-wrapper\"><svg role=\"img\" width=\"7\" height=\"10\" viewbox=\"6.5 5 7 10\"><title>chevron-down</title><path fill=\"none\" stroke=\"currentColor\" stroke-miterlimit=\"10\" stroke-width=\"1.5\" d=\"M12.125 5.75 7.875 10l4.25 4.25\"></path></svg></div></button><div id=\"footer-legal-list\"><ul class=\"menu-item-list\" style=\"height: 0;\"><li><a href=\"https://www.burberry.com/legal-cookies/terms-conditions/\" target=\"_self\">Teilnahmebedingungen</a></li><li><a href=\"https://www.burberry.com/c/legal-cookies/terms-conditions/4gift/\" target=\"_self\">Geschäftsbedingungen für Burberry x 4Gift</a></li><li><a href=\"https://www.burberry.com/legal-cookies/privacy-policy/\" target=\"_self\">Datenschutzrichtlinie</a></li><li><a href=\"https://www.burberry.com/legal-cookies/cookie-policy/\" target=\"_self\">Cookie-Richtlinie</a></li><li><a href=\"https://www.burberry.com/c/legal-cookies/accessibility-statement/\" target=\"_self\">Barrierefreiheit</a></li><li><a href=\"https://www.burberry.com/c/customer-service/4gifts-faqs/\" target=\"_self\">Häufig gestellte Fragen zu 4Gift</a></li><li><a href=\"https://www.burberry.com/c/legal-cookies/transparency-in-the-supply-chain-modern-slavery-statements/\" target=\"_self\">Erklärung zu Sklaverei und Menschenhandel</a></li><li><a href=\"https://www.burberry.com/legal-cookies/do-not-sell-my-personal-information/\" target=\"_self\">Meine persönlichen Daten dürfen nicht verkauft werden</a></li><li><a href=\"https://www.burberry.com/site-map/\" target=\"_self\">Sitemap</a></li></ul></div><button id=\"footer-language\" aria-controls=\"language-picker-modal\" aria-label=\"Klicken Sie auf , um das Sprachfenster zu öffnen und die Sprache zu ändern\" class=\"menu-item\" ng-click=\"controller.openChangeLanguageModal()\"><span>Sprache<span class=\"current-language\">{{controller.getTextTranslationByKey(\'language\')}}</span></span></button></div></div><div class=\"legal-copy\"><div>Falls Sie einen Screenreader verwenden und Probleme bei der Nutzung dieser Website haben, rufen Sie uns unter <a href=\"tel:+1 877 217 4085\">+1 877 217 4085</a>&nbsp;an <a href=\"https://www.burberry.com/customer-service/contact-us/\" target=\"_self\">oder ​​kontaktieren Sie uns</a>, um Hilfe zu erhalten.</div></div></footer>");
$templateCache.put("app/custom/clients/burberry/layout/footer/en.html","<footer id=\"footer\"><div class=\"footer-menu-container\"><div class=\"menu-section\"><a href=\"/\" title=\"Find a Store\" data-title=\"Find a Store\">Find a Store</a></div><div class=\"menu-section\"><button id=\"footer-services\" aria-expanded=\"false\" aria-controls=\"footer-services-list\" class=\"menu-item\" ng-click=\"controller.toggleFooter(\'footer-services\')\"><span>Burberry Services</span><div class=\"icon-wrapper\"><svg role=\"img\" width=\"7\" height=\"10\" viewbox=\"6.5 5 7 10\"><title>chevron-down</title><path fill=\"none\" stroke=\"currentColor\" stroke-miterlimit=\"10\" stroke-width=\"1.5\" d=\"M12.125 5.75 7.875 10l4.25 4.25\"></path></svg></div></button><div id=\"footer-services-list\"><ul class=\"menu-item-list\" style=\"height: 0;\"><li><a href=\"https://www.burberry.com/appointment-booking/\" target=\"_self\">Book an Appointment</a></li><li><a href=\"https://www.burberry.com/c/stores/bespoke-trench-service/\" target=\"_self\">Trench Bespoke</a></li><li><a href=\"https://www.burberry.com/burberry-aftercare/\" target=\"_self\">Aftercare</a></li><li><a href=\"https://www.burberry.com/c/personalisation-and-monogramming/\" target=\"_self\">Personalisation</a></li><li><a href=\"https://www.burberry.com/c/burberry-services/\" target=\"_self\">All Services</a></li></ul></div><button id=\"footer-customer-support\" aria-expanded=\"false\" aria-controls=\"footer-customer-support-list\" class=\"menu-item\" ng-click=\"controller.toggleFooter(\'footer-customer-support\')\"><span>Customer Support</span><div class=\"icon-wrapper\"><svg role=\"img\" width=\"7\" height=\"10\" viewbox=\"6.5 5 7 10\"><title>chevron-down</title><path fill=\"none\" stroke=\"currentColor\" stroke-miterlimit=\"10\" stroke-width=\"1.5\" d=\"M12.125 5.75 7.875 10l4.25 4.25\"></path></svg></div></button><div id=\"footer-customer-support-list\"><ul class=\"menu-item-list\" style=\"height: 0;\"><li><a href=\"https://www.burberry.com/customer-service/contact-us/\" target=\"_self\">Contact Us</a></li><li><a href=\"https://www.burberry.com/customer-service/shipping/\" target=\"_self\">Shipping</a></li><li><a href=\"https://www.burberry.com/customer-service/payment/\" target=\"_self\">Ordering &amp; Payment</a></li><li><a href=\"https://www.burberry.com/customer-service/returns/\" target=\"_self\">Returns</a></li></ul></div><button id=\"footer-about\" aria-expanded=\"false\" aria-controls=\"footer-about-list\" class=\"menu-item\" ng-click=\"controller.toggleFooter(\'footer-about\')\"><span>About Burberry</span><div class=\"icon-wrapper\"><svg role=\"img\" width=\"7\" height=\"10\" viewbox=\"6.5 5 7 10\"><title>chevron-down</title><path fill=\"none\" stroke=\"currentColor\" stroke-miterlimit=\"10\" stroke-width=\"1.5\" d=\"M12.125 5.75 7.875 10l4.25 4.25\"></path></svg></div></button><div id=\"footer-about-list\"><ul class=\"menu-item-list\" style=\"height: 0;\"><li><a href=\"https://www.burberry.com/c/burberry-heritage/\" target=\"_self\">Burberry Heritage</a></li><li><a href=\"https://www.burberry.com/c/stories/\" target=\"_self\">Stories</a></li><li><a href=\"https://www.burberry.com/c/values/sustainability/\" target=\"_self\">Sustainability</a></li><li><a href=\"https://www.burberryplc.com/impact/Our-Approach\" target=\"_self\" rel=\"noopener noreferrer\">Corporate Responsibility</a></li><li><a href=\"https://www.burberryplc.com/\" target=\"_self\" rel=\"noopener noreferrer\">Burberry Group Plc</a></li><li><a href=\"https://burberrycareers.com\" target=\"_self\" rel=\"noopener noreferrer\">Careers</a></li></ul></div><button id=\"footer-legal\" aria-expanded=\"false\" aria-controls=\"footer-legal-list\" class=\"menu-item\" ng-click=\"controller.toggleFooter(\'footer-legal\')\"><span>Legal &amp; Cookies</span><div class=\"icon-wrapper\"><svg role=\"img\" width=\"7\" height=\"10\" viewbox=\"6.5 5 7 10\"><title>chevron-down</title><path fill=\"none\" stroke=\"currentColor\" stroke-miterlimit=\"10\" stroke-width=\"1.5\" d=\"M12.125 5.75 7.875 10l4.25 4.25\"></path></svg></div></button><div id=\"footer-legal-list\"><ul class=\"menu-item-list\" style=\"height: 0;\"><li><a href=\"https://www.burberry.com/legal-cookies/terms-conditions/\" target=\"_self\">Terms &amp; Conditions</a></li><li><a href=\"https://www.burberry.com/c/legal-cookies/terms-conditions/4gift/\" target=\"_self\">Burberry x 4Gift – Terms &amp; Conditions</a></li><li><a href=\"https://www.burberry.com/legal-cookies/privacy-policy/\" target=\"_self\">Privacy Policy</a></li><li><a href=\"https://www.burberry.com/legal-cookies/cookie-policy/\" target=\"_self\">Cookie Policy</a></li><li><a href=\"https://www.burberry.com/c/legal-cookies/accessibility-statement/\" target=\"_self\">Accessibility Statement</a></li><li><a href=\"https://www.burberry.com/c/customer-service/4gifts-faqs/\" target=\"_self\">4Gift FAQ</a></li><li><a href=\"https://www.burberry.com/c/legal-cookies/transparency-in-the-supply-chain-modern-slavery-statements/\" target=\"_self\">Modern Slavery Statement</a></li><li><a href=\"https://www.burberry.com/legal-cookies/do-not-sell-my-personal-information/\" target=\"_self\">Do not sell my personal information</a></li><li><a href=\"https://www.burberry.com/site-map/\" target=\"_self\">Site Map</a></li></ul></div><button id=\"footer-language\" aria-controls=\"language-picker-modal\" aria-label=\"Click to open the language window and change the language\" class=\"menu-item\" ng-click=\"controller.openChangeLanguageModal()\"><span>Language<span class=\"current-language\">{{controller.getTextTranslationByKey(\'language\')}}</span></span></button></div></div><div class=\"legal-copy\"><div>If you are using a screen-reader and are having problems using this website, please call&nbsp;<a href=\"tel:+1 877 217 4085\">+1 877 217 4085</a>&nbsp;or <a href=\"https://www.burberry.com/customer-service/contact-us/\" target=\"_self\">contact us</a> for assistance.</div></div></footer>");
$templateCache.put("app/custom/clients/burberry/layout/footer/es.html","<footer id=\"footer\"><div class=\"footer-menu-container\"><div class=\"menu-section\"><a href=\"/\" title=\"Buscar una tienda\" data-title=\"Buscar una tienda\">Buscar una tienda</a></div><div class=\"menu-section\"><button id=\"footer-services\" aria-expanded=\"false\" aria-controls=\"footer-services-list\" class=\"menu-item\" ng-click=\"controller.toggleFooter(\'footer-services\')\"><span>Servicios de Burberry</span><div class=\"icon-wrapper\"><svg role=\"img\" width=\"7\" height=\"10\" viewbox=\"6.5 5 7 10\"><title>chevron-down</title><path fill=\"none\" stroke=\"currentColor\" stroke-miterlimit=\"10\" stroke-width=\"1.5\" d=\"M12.125 5.75 7.875 10l4.25 4.25\"></path></svg></div></button><div id=\"footer-services-list\"><ul class=\"menu-item-list\" style=\"height: 0;\"><li><a href=\"https://www.burberry.com/appointment-booking/\" target=\"_self\">Concertar cita</a></li><li><a href=\"https://www.burberry.com/c/stores/bespoke-trench-service/\" target=\"_self\">Tu trench coat exclusivo</a></li><li><a href=\"https://www.burberry.com/burberry-aftercare/\" target=\"_self\">Cuidados posventa</a></li><li><a href=\"https://www.burberry.com/c/personalisation-and-monogramming/\" target=\"_self\">Personalización</a></li><li><a href=\"https://www.burberry.com/c/burberry-services/\" target=\"_self\">Servicios</a></li></ul></div><button id=\"footer-customer-support\" aria-expanded=\"false\" aria-controls=\"footer-customer-support-list\" class=\"menu-item\" ng-click=\"controller.toggleFooter(\'footer-customer-support\')\"><span>Atención al cliente</span><div class=\"icon-wrapper\"><svg role=\"img\" width=\"7\" height=\"10\" viewbox=\"6.5 5 7 10\"><title>chevron-down</title><path fill=\"none\" stroke=\"currentColor\" stroke-miterlimit=\"10\" stroke-width=\"1.5\" d=\"M12.125 5.75 7.875 10l4.25 4.25\"></path></svg></div></button><div id=\"footer-customer-support-list\"><ul class=\"menu-item-list\" style=\"height: 0;\"><li><a href=\"https://www.burberry.com/customer-service/contact-us/\" target=\"_self\">Contacto</a></li><li><a href=\"https://www.burberry.com/customer-service/shipping/\" target=\"_self\">Envíos</a></li><li><a href=\"https://www.burberry.com/customer-service/payment/\" target=\"_self\">Pedidos y pagos</a></li><li><a href=\"https://www.burberry.com/customer-service/returns/\" target=\"_self\">Devoluciones</a></li></ul></div><button id=\"footer-about\" aria-expanded=\"false\" aria-controls=\"footer-about-list\" class=\"menu-item\" ng-click=\"controller.toggleFooter(\'footer-about\')\"><span>Acerca de Burberry</span><div class=\"icon-wrapper\"><svg role=\"img\" width=\"7\" height=\"10\" viewbox=\"6.5 5 7 10\"><title>chevron-down</title><path fill=\"none\" stroke=\"currentColor\" stroke-miterlimit=\"10\" stroke-width=\"1.5\" d=\"M12.125 5.75 7.875 10l4.25 4.25\"></path></svg></div></button><div id=\"footer-about-list\"><ul class=\"menu-item-list\" style=\"height: 0;\"><li><a href=\"https://www.burberry.com/c/burberry-heritage/\" target=\"_self\">El legado de Burberry</a></li><li><a href=\"https://www.burberry.com/c/stories/\" target=\"_self\">Historias</a></li><li><a href=\"https://www.burberry.com/c/values/sustainability/\" target=\"_self\">Sostenibilidad</a></li><li><a href=\"https://www.burberryplc.com/impact/Our-Approach\" target=\"_self\" rel=\"noopener noreferrer\">Responsabilidad corporativa</a></li><li><a href=\"https://www.burberryplc.com/\" target=\"_self\" rel=\"noopener noreferrer\">Burberry Group Plc</a></li><li><a href=\"https://burberrycareers.com\" target=\"_self\" rel=\"noopener noreferrer\">Trabaja con nosotros</a></li></ul></div><button id=\"footer-legal\" aria-expanded=\"false\" aria-controls=\"footer-legal-list\" class=\"menu-item\" ng-click=\"controller.toggleFooter(\'footer-legal\')\"><span>Legal y cookies</span><div class=\"icon-wrapper\"><svg role=\"img\" width=\"7\" height=\"10\" viewbox=\"6.5 5 7 10\"><title>chevron-down</title><path fill=\"none\" stroke=\"currentColor\" stroke-miterlimit=\"10\" stroke-width=\"1.5\" d=\"M12.125 5.75 7.875 10l4.25 4.25\"></path></svg></div></button><div id=\"footer-legal-list\"><ul class=\"menu-item-list\" style=\"height: 0;\"><li><a href=\"https://www.burberry.com/legal-cookies/terms-conditions/\" target=\"_self\">Términos y condiciones</a></li><li><a href=\"https://www.burberry.com/c/legal-cookies/terms-conditions/4gift/\" target=\"_self\">Términos y condiciones de los regalos de Burberry</a></li><li><a href=\"https://www.burberry.com/legal-cookies/privacy-policy/\" target=\"_self\">Política de privacidad</a></li><li><a href=\"https://www.burberry.com/legal-cookies/cookie-policy/\" target=\"_self\">Política de cookies</a></li><li><a href=\"https://www.burberry.com/c/legal-cookies/accessibility-statement/\" target=\"_self\">Declaración de accesibilidad</a></li><li><a href=\"https://www.burberry.com/c/customer-service/4gifts-faqs/\" target=\"_self\">Preguntas frecuentes sobre 4Gift</a></li><li><a href=\"https://www.burberry.com/c/legal-cookies/transparency-in-the-supply-chain-modern-slavery-statements/\" target=\"_self\">Declaración sobre esclavitud moderna</a></li><li><a href=\"https://www.burberry.com/legal-cookies/do-not-sell-my-personal-information/\" target=\"_self\">No vender mi información personal</a></li><li><a href=\"https://www.burberry.com/site-map/\" target=\"_self\">Mapa del sitio</a></li></ul></div><button id=\"footer-language\" aria-controls=\"language-picker-modal\" aria-label=\"Haga clic para abrir la ventana de idioma y cambiar el idioma\" class=\"menu-item\" ng-click=\"controller.openChangeLanguageModal()\"><span>Idioma<span class=\"current-language\">{{controller.getTextTranslationByKey(\'language\')}}</span></span></button></div></div><div class=\"legal-copy\"><div>Si usas un lector de pantalla y tienes problemas para navegar por este sitio web, llámanos al <a href=\"tel:+1 877 217 4085\">+1 877 217 4085</a>&nbsp;o <a href=\"https://www.burberry.com/customer-service/contact-us/\" target=\"_self\">contáctanos</a> para obtener asistencia.</div></div></footer>");
$templateCache.put("app/custom/clients/burberry/layout/footer/fr.html","<footer id=\"footer\"><div class=\"footer-menu-container\"><div class=\"menu-section\"><a href=\"/\" title=\"Trouver un magasin\" data-title=\"Trouver un magasin\">Trouver un magasin</a></div><div class=\"menu-section\"><button id=\"footer-services\" aria-expanded=\"false\" aria-controls=\"footer-services-list\" class=\"menu-item\" ng-click=\"controller.toggleFooter(\'footer-services\')\"><span>Les services Burberry</span><div class=\"icon-wrapper\"><svg role=\"img\" width=\"7\" height=\"10\" viewbox=\"6.5 5 7 10\"><title>chevron-down</title><path fill=\"none\" stroke=\"currentColor\" stroke-miterlimit=\"10\" stroke-width=\"1.5\" d=\"M12.125 5.75 7.875 10l4.25 4.25\"></path></svg></div></button><div id=\"footer-services-list\"><ul class=\"menu-item-list\" style=\"height: 0;\"><li><a href=\"https://www.burberry.com/appointment-booking/\" target=\"_self\">Prendre rendez-vous</a></li><li><a href=\"https://www.burberry.com/c/stores/bespoke-trench-service/\" target=\"_self\">Trench sur mesure</a></li><li><a href=\"https://www.burberry.com/burberry-aftercare/\" target=\"_self\">Nos services d\'entretien</a></li><li><a href=\"https://www.burberry.com/c/personalisation-and-monogramming/\" target=\"_self\">Personnalisation</a></li><li><a href=\"https://www.burberry.com/c/burberry-services/\" target=\"_self\">Tous les services</a></li></ul></div><button id=\"footer-customer-support\" aria-expanded=\"false\" aria-controls=\"footer-customer-support-list\" class=\"menu-item\" ng-click=\"controller.toggleFooter(\'footer-customer-support\')\"><span>Service clientèle</span><div class=\"icon-wrapper\"><svg role=\"img\" width=\"7\" height=\"10\" viewbox=\"6.5 5 7 10\"><title>chevron-down</title><path fill=\"none\" stroke=\"currentColor\" stroke-miterlimit=\"10\" stroke-width=\"1.5\" d=\"M12.125 5.75 7.875 10l4.25 4.25\"></path></svg></div></button><div id=\"footer-customer-support-list\"><ul class=\"menu-item-list\" style=\"height: 0;\"><li><a href=\"https://www.burberry.com/customer-service/contact-us/\" target=\"_self\">Contact</a></li><li><a href=\"https://www.burberry.com/customer-service/shipping/\" target=\"_self\">Livraison</a></li><li><a href=\"https://www.burberry.com/customer-service/payment/\" target=\"_self\">Commandes et paiement</a></li><li><a href=\"https://www.burberry.com/customer-service/returns/\" target=\"_self\">Retours</a></li></ul></div><button id=\"footer-about\" aria-expanded=\"false\" aria-controls=\"footer-about-list\" class=\"menu-item\" ng-click=\"controller.toggleFooter(\'footer-about\')\"><span>À propos de Burberry</span><div class=\"icon-wrapper\"><svg role=\"img\" width=\"7\" height=\"10\" viewbox=\"6.5 5 7 10\"><title>chevron-down</title><path fill=\"none\" stroke=\"currentColor\" stroke-miterlimit=\"10\" stroke-width=\"1.5\" d=\"M12.125 5.75 7.875 10l4.25 4.25\"></path></svg></div></button><div id=\"footer-about-list\"><ul class=\"menu-item-list\" style=\"height: 0;\"><li><a href=\"https://www.burberry.com/c/burberry-heritage/\" target=\"_self\">Héritage Burberry</a></li><li><a href=\"https://www.burberry.com/c/stories/\" target=\"_self\">Nos news</a></li><li><a href=\"https://www.burberry.com/c/values/sustainability/\" target=\"_self\">Durabilité</a></li><li><a href=\"https://www.burberryplc.com/impact/Our-Approach\" target=\"_self\" rel=\"noopener noreferrer\">Responsabilité de l\'entreprise</a></li><li><a href=\"https://www.burberryplc.com/\" target=\"_self\" rel=\"noopener noreferrer\">Burberry Group plc</a></li><li><a href=\"https://burberrycareers.com\" target=\"_self\" rel=\"noopener noreferrer\">Carrières</a></li></ul></div><button id=\"footer-legal\" aria-expanded=\"false\" aria-controls=\"footer-legal-list\" class=\"menu-item\" ng-click=\"controller.toggleFooter(\'footer-legal\')\"><span>Mentions légales & cookies</span><div class=\"icon-wrapper\"><svg role=\"img\" width=\"7\" height=\"10\" viewbox=\"6.5 5 7 10\"><title>chevron-down</title><path fill=\"none\" stroke=\"currentColor\" stroke-miterlimit=\"10\" stroke-width=\"1.5\" d=\"M12.125 5.75 7.875 10l4.25 4.25\"></path></svg></div></button><div id=\"footer-legal-list\"><ul class=\"menu-item-list\" style=\"height: 0;\"><li><a href=\"https://www.burberry.com/legal-cookies/terms-conditions/\" target=\"_self\">Conditions générales</a></li><li><a href=\"https://www.burberry.com/c/legal-cookies/terms-conditions/4gift/\" target=\"_self\">Burberry x 4Gift – Conditions générales</a></li><li><a href=\"https://www.burberry.com/legal-cookies/privacy-policy/\" target=\"_self\">Politique de confidentialité</a></li><li><a href=\"https://www.burberry.com/legal-cookies/cookie-policy/\" target=\"_self\">Politique en matière de cookies</a></li><li><a href=\"https://www.burberry.com/c/legal-cookies/accessibility-statement/\" target=\"_self\">Politique d\'accessibilité</a></li><li><a href=\"https://www.burberry.com/c/customer-service/4gifts-faqs/\" target=\"_self\">FAQ sur 4Gift</a></li><li><a href=\"https://www.burberry.com/c/legal-cookies/transparency-in-the-supply-chain-modern-slavery-statements/\" target=\"_self\">Communication relative à l\'esclavage moderne</a></li><li><a href=\"https://www.burberry.com/legal-cookies/do-not-sell-my-personal-information/\" target=\"_self\">Ne pas vendre mes informations personnelles</a></li><li><a href=\"https://www.burberry.com/site-map/\" target=\"_self\">Plan du site</a></li></ul></div><button id=\"footer-language\" aria-controls=\"language-picker-modal\" aria-label=\"Cliquez sur pour ouvrir la fenêtre des langues et changer la langue\" class=\"menu-item\" ng-click=\"controller.openChangeLanguageModal()\"><span>Langue<span class=\"current-language\">{{controller.getTextTranslationByKey(\'language\')}}</span></span></button></div></div><div class=\"legal-copy\"><div>Si vous utilisez un lecteur d\'écran et que vous rencontrez des problèmes lors de l\'utilisation de ce site Web, veuillez appeler le <a href=\"tel:+1 877 217 4085\">+1 877 217 4085</a>&nbsp;ou <a href=\"https://www.burberry.com/customer-service/contact-us/\" target=\"_self\">nous contacter</a> pour obtenir de l\'aide.</div></div></footer>");
$templateCache.put("app/custom/clients/burberry/layout/footer/it.html","<footer id=\"footer\"><div class=\"footer-menu-container\"><div class=\"menu-section\"><a href=\"/\" title=\"Trova boutique\" data-title=\"Trova boutique\">Trova boutique</a></div><div class=\"menu-section\"><button id=\"footer-services\" aria-expanded=\"false\" aria-controls=\"footer-services-list\" class=\"menu-item\" ng-click=\"controller.toggleFooter(\'footer-services\')\"><span>Servizi Burberry</span><div class=\"icon-wrapper\"><svg role=\"img\" width=\"7\" height=\"10\" viewbox=\"6.5 5 7 10\"><title>chevron-down</title><path fill=\"none\" stroke=\"currentColor\" stroke-miterlimit=\"10\" stroke-width=\"1.5\" d=\"M12.125 5.75 7.875 10l4.25 4.25\"></path></svg></div></button><div id=\"footer-services-list\"><ul class=\"menu-item-list\" style=\"height: 0;\"><li><a href=\"https://www.burberry.com/appointment-booking/\" target=\"_self\">Prenota un appuntamento</a></li><li><a href=\"https://www.burberry.com/c/stores/bespoke-trench-service/\" target=\"_self\">Un trench unico come te</a></li><li><a href=\"https://www.burberry.com/burberry-aftercare/\" target=\"_self\">Servizi post vendita</a></li><li><a href=\"https://www.burberry.com/c/personalisation-and-monogramming/\" target=\"_self\">Personalizzazione</a></li><li><a href=\"https://www.burberry.com/c/burberry-services/\" target=\"_self\">Tutti i servizi</a></li></ul></div><button id=\"footer-customer-support\" aria-expanded=\"false\" aria-controls=\"footer-customer-support-list\" class=\"menu-item\" ng-click=\"controller.toggleFooter(\'footer-customer-support\')\"><span>Assistenza clienti</span><div class=\"icon-wrapper\"><svg role=\"img\" width=\"7\" height=\"10\" viewbox=\"6.5 5 7 10\"><title>chevron-down</title><path fill=\"none\" stroke=\"currentColor\" stroke-miterlimit=\"10\" stroke-width=\"1.5\" d=\"M12.125 5.75 7.875 10l4.25 4.25\"></path></svg></div></button><div id=\"footer-customer-support-list\"><ul class=\"menu-item-list\" style=\"height: 0;\"><li><a href=\"https://www.burberry.com/customer-service/contact-us/\" target=\"_self\">Contattaci</a></li><li><a href=\"https://www.burberry.com/customer-service/shipping/\" target=\"_self\">Spedizione</a></li><li><a href=\"https://www.burberry.com/customer-service/payment/\" target=\"_self\">Ordini e pagamenti</a></li><li><a href=\"https://www.burberry.com/customer-service/returns/\" target=\"_self\">Restituzioni</a></li></ul></div><button id=\"footer-about\" aria-expanded=\"false\" aria-controls=\"footer-about-list\" class=\"menu-item\" ng-click=\"controller.toggleFooter(\'footer-about\')\"><span>Info su Burberry</span><div class=\"icon-wrapper\"><svg role=\"img\" width=\"7\" height=\"10\" viewbox=\"6.5 5 7 10\"><title>chevron-down</title><path fill=\"none\" stroke=\"currentColor\" stroke-miterlimit=\"10\" stroke-width=\"1.5\" d=\"M12.125 5.75 7.875 10l4.25 4.25\"></path></svg></div></button><div id=\"footer-about-list\"><ul class=\"menu-item-list\" style=\"height: 0;\"><li><a href=\"https://www.burberry.com/c/burberry-heritage/\" target=\"_self\">Burberry Heritage</a></li><li><a href=\"https://www.burberry.com/c/stories/\" target=\"_self\">Storie</a></li><li><a href=\"https://www.burberry.com/c/values/sustainability/\" target=\"_self\">Sustainability</a></li><li><a href=\"https://www.burberryplc.com/impact/Our-Approach\" target=\"_self\" rel=\"noopener noreferrer\">Responsabilità aziendale</a></li><li><a href=\"https://www.burberryplc.com/\" target=\"_self\" rel=\"noopener noreferrer\">Burberry Group plc</a></li><li><a href=\"https://burberrycareers.com\" target=\"_self\" rel=\"noopener noreferrer\">Carriere</a></li></ul></div><button id=\"footer-legal\" aria-expanded=\"false\" aria-controls=\"footer-legal-list\" class=\"menu-item\" ng-click=\"controller.toggleFooter(\'footer-legal\')\"><span>Note legali e cookie</span><div class=\"icon-wrapper\"><svg role=\"img\" width=\"7\" height=\"10\" viewbox=\"6.5 5 7 10\"><title>chevron-down</title><path fill=\"none\" stroke=\"currentColor\" stroke-miterlimit=\"10\" stroke-width=\"1.5\" d=\"M12.125 5.75 7.875 10l4.25 4.25\"></path></svg></div></button><div id=\"footer-legal-list\"><ul class=\"menu-item-list\" style=\"height: 0;\"><li><a href=\"https://www.burberry.com/legal-cookies/terms-conditions/\" target=\"_self\">Termini e condizioni</a></li><li><a href=\"https://www.burberry.com/c/legal-cookies/terms-conditions/4gift/\" target=\"_self\">Burberry x 4Gift – Termini e condizioni</a></li><li><a href=\"https://www.burberry.com/legal-cookies/privacy-policy/\" target=\"_self\">Informativa sulla privacy</a></li><li><a href=\"https://www.burberry.com/legal-cookies/cookie-policy/\" target=\"_self\">Informativa sui cookie</a></li><li><a href=\"https://www.burberry.com/c/legal-cookies/accessibility-statement/\" target=\"_self\">Dichiarazione di accessibilità</a></li><li><a href=\"https://www.burberry.com/c/customer-service/4gifts-faqs/\" target=\"_self\">Domande frequenti su 4Gift</a></li><li><a href=\"https://www.burberry.com/c/legal-cookies/transparency-in-the-supply-chain-modern-slavery-statements/\" target=\"_self\">Dichiarazione sulla schiavitù moderna</a></li><li><a href=\"https://www.burberry.com/legal-cookies/do-not-sell-my-personal-information/\" target=\"_self\">Non consentire la vendita dei miei dati personali</a></li><li><a href=\"https://www.burberry.com/site-map/\" target=\"_self\">Mappa del sito</a></li></ul></div><button id=\"footer-language\" aria-controls=\"language-picker-modal\" aria-label=\"Fare clic per aprire la finestra della lingua e cambiare la lingua\" class=\"menu-item\" ng-click=\"controller.openChangeLanguageModal()\"><span>Lingua<span class=\"current-language\">{{controller.getTextTranslationByKey(\'language\')}}</span></span></button></div></div><div class=\"legal-copy\"><div>Se utilizzi uno screen reader e riscontri problemi nell\'utilizzo di questo sito web, ti invitiamo a chiamare il numero <a href=\"tel:+1 877 217 4085\">+1 877 217 4085</a>&nbsp;in alternativa, <a href=\"https://www.burberry.com/customer-service/contact-us/\" target=\"_self\">contattaci</a> per richiedere assistenza.</div></div></footer>");
$templateCache.put("app/custom/clients/burberry/layout/footer/ja.html","<footer id=\"footer\"><div class=\"footer-menu-container\"><div class=\"menu-section\"><a href=\"/\" title=\"ストア検索\" data-title=\"ストア検索\">ストア検索</a></div><div class=\"menu-section\"><button id=\"footer-services\" aria-expanded=\"false\" aria-controls=\"footer-services-list\" class=\"menu-item\" ng-click=\"controller.toggleFooter(\'footer-services\')\"><span>バーバリーサービス</span><div class=\"icon-wrapper\"><svg role=\"img\" width=\"7\" height=\"10\" viewbox=\"6.5 5 7 10\"><title>chevron-down</title><path fill=\"none\" stroke=\"currentColor\" stroke-miterlimit=\"10\" stroke-width=\"1.5\" d=\"M12.125 5.75 7.875 10l4.25 4.25\"></path></svg></div></button><div id=\"footer-services-list\"><ul class=\"menu-item-list\" style=\"height: 0;\"><li><a href=\"https://www.burberry.com/appointment-booking/\" target=\"_self\">アポイントメントを予約</a></li><li><a href=\"https://www.burberry.com/c/stores/bespoke-trench-service/\" target=\"_self\">トレンチビスポーク</a></li><li><a href=\"https://www.burberry.com/burberry-aftercare/\" target=\"_self\">アフターケア</a></li><li><a href=\"https://www.burberry.com/c/personalisation-and-monogramming/\" target=\"_self\">パーソナライゼーション</a></li><li><a href=\"https://www.burberry.com/c/burberry-services/\" target=\"_self\">すべてのサービス</a></li></ul></div><button id=\"footer-customer-support\" aria-expanded=\"false\" aria-controls=\"footer-customer-support-list\" class=\"menu-item\" ng-click=\"controller.toggleFooter(\'footer-customer-support\')\"><span>カスタマーサポート</span><div class=\"icon-wrapper\"><svg role=\"img\" width=\"7\" height=\"10\" viewbox=\"6.5 5 7 10\"><title>chevron-down</title><path fill=\"none\" stroke=\"currentColor\" stroke-miterlimit=\"10\" stroke-width=\"1.5\" d=\"M12.125 5.75 7.875 10l4.25 4.25\"></path></svg></div></button><div id=\"footer-customer-support-list\"><ul class=\"menu-item-list\" style=\"height: 0;\"><li><a href=\"https://www.burberry.com/customer-service/contact-us/\" target=\"_self\">カスタマーサービス</a></li><li><a href=\"https://www.burberry.com/customer-service/shipping/\" target=\"_self\">配送</a></li><li><a href=\"https://www.burberry.com/customer-service/payment/\" target=\"_self\">ご注文＆お支払い方法</a></li><li><a href=\"https://www.burberry.com/customer-service/returns/\" target=\"_self\">返品</a></li></ul></div><button id=\"footer-about\" aria-expanded=\"false\" aria-controls=\"footer-about-list\" class=\"menu-item\" ng-click=\"controller.toggleFooter(\'footer-about\')\"><span>バーバリーについて</span><div class=\"icon-wrapper\"><svg role=\"img\" width=\"7\" height=\"10\" viewbox=\"6.5 5 7 10\"><title>chevron-down</title><path fill=\"none\" stroke=\"currentColor\" stroke-miterlimit=\"10\" stroke-width=\"1.5\" d=\"M12.125 5.75 7.875 10l4.25 4.25\"></path></svg></div></button><div id=\"footer-about-list\"><ul class=\"menu-item-list\" style=\"height: 0;\"><li><a href=\"https://www.burberry.com/c/burberry-heritage/\" target=\"_self\">バーバリー ヘリテージ</a></li><li><a href=\"https://www.burberry.com/c/stories/\" target=\"_self\">ストーリー</a></li><li><a href=\"https://www.burberry.com/c/values/sustainability/\" target=\"_self\">サステイナビリティ</a></li><li><a href=\"https://www.burberryplc.com/impact/Our-Approach\" target=\"_self\" rel=\"noopener noreferrer\">企業責任</a></li><li><a href=\"https://www.burberryplc.com/\" target=\"_self\" rel=\"noopener noreferrer\">Burberry Group Plc</a></li><li><a href=\"https://burberrycareers.com\" target=\"_self\" rel=\"noopener noreferrer\">キャリア</a></li></ul></div><button id=\"footer-legal\" aria-expanded=\"false\" aria-controls=\"footer-legal-list\" class=\"menu-item\" ng-click=\"controller.toggleFooter(\'footer-legal\')\"><span>法的事項＆クッキー</span><div class=\"icon-wrapper\"><svg role=\"img\" width=\"7\" height=\"10\" viewbox=\"6.5 5 7 10\"><title>chevron-down</title><path fill=\"none\" stroke=\"currentColor\" stroke-miterlimit=\"10\" stroke-width=\"1.5\" d=\"M12.125 5.75 7.875 10l4.25 4.25\"></path></svg></div></button><div id=\"footer-legal-list\"><ul class=\"menu-item-list\" style=\"height: 0;\"><li><a href=\"https://www.burberry.com/legal-cookies/terms-conditions/\" target=\"_self\">利用規約</a></li><li><a href=\"https://www.burberry.com/c/legal-cookies/terms-conditions/4gift/\" target=\"_self\">バーバリー x 4Gift – 利用規約</a></li><li><a href=\"https://www.burberry.com/legal-cookies/privacy-policy/\" target=\"_self\">プライバシーポリシー</a></li><li><a href=\"https://www.burberry.com/legal-cookies/cookie-policy/\" target=\"_self\">Cookieポリシー</a></li><li><a href=\"https://www.burberry.com/c/legal-cookies/accessibility-statement/\" target=\"_self\">アクセシビリティ声明</a></li><li><a href=\"https://www.burberry.com/c/customer-service/4gifts-faqs/\" target=\"_self\">4Giftに関するよくある質問</a></li><li><a href=\"https://www.burberry.com/c/legal-cookies/transparency-in-the-supply-chain-modern-slavery-statements/\" target=\"_self\">現代の奴隷労働に関するステートメント</a></li><li><a href=\"https://www.burberry.com/legal-cookies/do-not-sell-my-personal-information/\" target=\"_self\">カリフォルニア州消費者プライバシー法について</a></li><li><a href=\"https://www.burberry.com/site-map/\" target=\"_self\">サイトマップ</a></li></ul></div><button id=\"footer-language\" aria-controls=\"language-picker-modal\" aria-label=\"クリックして言語ウィンドウを開き、言語を変更する\" class=\"menu-item\" ng-click=\"controller.openChangeLanguageModal()\"><span>言語<span class=\"current-language\">{{controller.getTextTranslationByKey(\'language\')}}</span></span></button></div></div><div class=\"legal-copy\"><div>スクリーンリーダーを使用する際に、このウェブサイトの使用に問題がある場合は、<a href=\"tel:+1 877 217 4085\">+1 877 217 4085</a><a href=\"https://www.burberry.com/customer-service/contact-us/\" target=\"_self\">にお電話いただくか、</a> お気軽にお問い合わせください。</div></div></footer>");
$templateCache.put("app/custom/clients/burberry/layout/footer/ko.html","<footer id=\"footer\"><div class=\"footer-menu-container\"><div class=\"menu-section\"><a href=\"/\" title=\"매장 찾기\" data-title=\"매장 찾기\">매장 찾기</a></div><div class=\"menu-section\"><button id=\"footer-services\" aria-expanded=\"false\" aria-controls=\"footer-services-list\" class=\"menu-item\" ng-click=\"controller.toggleFooter(\'footer-services\')\"><span>버버리 서비스</span><div class=\"icon-wrapper\"><svg role=\"img\" width=\"7\" height=\"10\" viewbox=\"6.5 5 7 10\"><title>chevron-down</title><path fill=\"none\" stroke=\"currentColor\" stroke-miterlimit=\"10\" stroke-width=\"1.5\" d=\"M12.125 5.75 7.875 10l4.25 4.25\"></path></svg></div></button><div id=\"footer-services-list\"><ul class=\"menu-item-list\" style=\"height: 0;\"><li><a href=\"https://www.burberry.com/appointment-booking/\" target=\"_self\">어포인트먼트 예약하기</a></li><li><a href=\"https://www.burberry.com/c/stores/bespoke-trench-service/\" target=\"_self\">트렌치 비스포크</a></li><li><a href=\"https://www.burberry.com/burberry-aftercare/\" target=\"_self\">애프터케어</a></li><li><a href=\"https://www.burberry.com/c/personalisation-and-monogramming/\" target=\"_self\">퍼스널라이제이션</a></li><li><a href=\"https://www.burberry.com/c/burberry-services/\" target=\"_self\">전체 서비스</a></li></ul></div><button id=\"footer-customer-support\" aria-expanded=\"false\" aria-controls=\"footer-customer-support-list\" class=\"menu-item\" ng-click=\"controller.toggleFooter(\'footer-customer-support\')\"><span>고객 지원</span><div class=\"icon-wrapper\"><svg role=\"img\" width=\"7\" height=\"10\" viewbox=\"6.5 5 7 10\"><title>chevron-down</title><path fill=\"none\" stroke=\"currentColor\" stroke-miterlimit=\"10\" stroke-width=\"1.5\" d=\"M12.125 5.75 7.875 10l4.25 4.25\"></path></svg></div></button><div id=\"footer-customer-support-list\"><ul class=\"menu-item-list\" style=\"height: 0;\"><li><a href=\"https://www.burberry.com/customer-service/contact-us/\" target=\"_self\">문의하기</a></li><li><a href=\"https://www.burberry.com/customer-service/shipping/\" target=\"_self\">배송</a></li><li><a href=\"https://www.burberry.com/customer-service/payment/\" target=\"_self\">주문 및 결제</a></li><li><a href=\"https://www.burberry.com/customer-service/returns/\" target=\"_self\">반품</a></li></ul></div><button id=\"footer-about\" aria-expanded=\"false\" aria-controls=\"footer-about-list\" class=\"menu-item\" ng-click=\"controller.toggleFooter(\'footer-about\')\"><span>버버리 소개</span><div class=\"icon-wrapper\"><svg role=\"img\" width=\"7\" height=\"10\" viewbox=\"6.5 5 7 10\"><title>chevron-down</title><path fill=\"none\" stroke=\"currentColor\" stroke-miterlimit=\"10\" stroke-width=\"1.5\" d=\"M12.125 5.75 7.875 10l4.25 4.25\"></path></svg></div></button><div id=\"footer-about-list\"><ul class=\"menu-item-list\" style=\"height: 0;\"><li><a href=\"https://www.burberry.com/c/burberry-heritage/\" target=\"_self\">버버리 헤리티지</a></li><li><a href=\"https://www.burberry.com/c/stories/\" target=\"_self\">스토리</a></li><li><a href=\"https://www.burberry.com/c/values/sustainability/\" target=\"_self\">지속 가능성</a></li><li><a href=\"https://www.burberryplc.com/impact/Our-Approach\" target=\"_self\" rel=\"noopener noreferrer\">기업 책임</a></li><li><a href=\"https://www.burberryplc.com/\" target=\"_self\" rel=\"noopener noreferrer\">버버리 그룹 PLC</a></li><li><a href=\"https://burberrycareers.com\" target=\"_self\" rel=\"noopener noreferrer\">커리어</a></li></ul></div><button id=\"footer-legal\" aria-expanded=\"false\" aria-controls=\"footer-legal-list\" class=\"menu-item\" ng-click=\"controller.toggleFooter(\'footer-legal\')\"><span>법적 고지 및 쿠키</span><div class=\"icon-wrapper\"><svg role=\"img\" width=\"7\" height=\"10\" viewbox=\"6.5 5 7 10\"><title>chevron-down</title><path fill=\"none\" stroke=\"currentColor\" stroke-miterlimit=\"10\" stroke-width=\"1.5\" d=\"M12.125 5.75 7.875 10l4.25 4.25\"></path></svg></div></button><div id=\"footer-legal-list\"><ul class=\"menu-item-list\" style=\"height: 0;\"><li><a href=\"https://www.burberry.com/legal-cookies/terms-conditions/\" target=\"_self\">이용약관</a></li><li><a href=\"https://www.burberry.com/c/legal-cookies/terms-conditions/4gift/\" target=\"_self\">Burberry x 4Gift – 이용약관</a></li><li><a href=\"https://www.burberry.com/legal-cookies/privacy-policy/\" target=\"_self\">개인정보처리방침</a></li><li><a href=\"https://www.burberry.com/legal-cookies/cookie-policy/\" target=\"_self\">쿠키 정책</a></li><li><a href=\"https://www.burberry.com/c/legal-cookies/accessibility-statement/\" target=\"_self\">접근성 정책</a></li><li><a href=\"https://www.burberry.com/c/customer-service/4gifts-faqs/\" target=\"_self\">4Gift 자주묻는질문</a></li><li><a href=\"https://www.burberry.com/c/legal-cookies/transparency-in-the-supply-chain-modern-slavery-statements/\" target=\"_self\">현대판 노예방지 선언</a></li><li><a href=\"https://www.burberry.com/legal-cookies/do-not-sell-my-personal-information/\" target=\"_self\">개인정보 판매 거부</a></li><li><a href=\"https://www.burberry.com/site-map/\" target=\"_self\">사이트맵</a></li></ul></div><button id=\"footer-language\" aria-controls=\"language-picker-modal\" aria-label=\"클릭하여 언어 창을 열고 언어를 변경합니다.\" class=\"menu-item\" ng-click=\"controller.openChangeLanguageModal()\"><span>언어<span class=\"current-language\">{{controller.getTextTranslationByKey(\'language\')}}</span></span></button></div></div><div class=\"legal-copy\"><div>본 웹사이트에서 스크린 리더를 사용하는 것에 문제가 있을 경우, <a href=\"tel:+1 877 217 4085\">+1 877 217 4085</a> <a href=\"https://www.burberry.com/customer-service/contact-us/\" target=\"_self\">(으)로 전화하거나 ​문의하기​로 연락해주시기 바랍니다.​</a></div></div></footer>");
$templateCache.put("app/custom/clients/burberry/layout/footer/pt.html","<footer id=\"footer\"><div class=\"footer-menu-container\"><div class=\"menu-section\"><a href=\"/\" title=\"Localizador de lojas\" data-title=\"Localizador de lojas\">Localizador de lojas</a></div><div class=\"menu-section\"><button id=\"footer-services\" aria-expanded=\"false\" aria-controls=\"footer-services-list\" class=\"menu-item\" ng-click=\"controller.toggleFooter(\'footer-services\')\"><span>Serviços Burberry</span><div class=\"icon-wrapper\"><svg role=\"img\" width=\"7\" height=\"10\" viewbox=\"6.5 5 7 10\"><title>chevron-down</title><path fill=\"none\" stroke=\"currentColor\" stroke-miterlimit=\"10\" stroke-width=\"1.5\" d=\"M12.125 5.75 7.875 10l4.25 4.25\"></path></svg></div></button><div id=\"footer-services-list\"><ul class=\"menu-item-list\" style=\"height: 0;\"><li><a href=\"https://www.burberry.com/appointment-booking/\" target=\"_self\">Agendar uma visita</a></li><li><a href=\"https://www.burberry.com/c/stores/bespoke-trench-service/\" target=\"_self\">Trench coat personalizado</a></li><li><a href=\"https://www.burberry.com/burberry-aftercare/\" target=\"_self\">Serviços pós-venda</a></li><li><a href=\"https://www.burberry.com/c/personalisation-and-monogramming/\" target=\"_self\">Personalização</a></li><li><a href=\"https://www.burberry.com/c/burberry-services/\" target=\"_self\">Todos os serviços</a></li></ul></div><button id=\"footer-customer-support\" aria-expanded=\"false\" aria-controls=\"footer-customer-support-list\" class=\"menu-item\" ng-click=\"controller.toggleFooter(\'footer-customer-support\')\"><span>Atendimento ao cliente</span><div class=\"icon-wrapper\"><svg role=\"img\" width=\"7\" height=\"10\" viewbox=\"6.5 5 7 10\"><title>chevron-down</title><path fill=\"none\" stroke=\"currentColor\" stroke-miterlimit=\"10\" stroke-width=\"1.5\" d=\"M12.125 5.75 7.875 10l4.25 4.25\"></path></svg></div></button><div id=\"footer-customer-support-list\"><ul class=\"menu-item-list\" style=\"height: 0;\"><li><a href=\"https://www.burberry.com/customer-service/contact-us/\" target=\"_self\">Entrar em contato conosco</a></li><li><a href=\"https://www.burberry.com/customer-service/shipping/\" target=\"_self\">Envio</a></li><li><a href=\"https://www.burberry.com/customer-service/payment/\" target=\"_self\">Pedidos e pagamentos</a></li><li><a href=\"https://www.burberry.com/customer-service/returns/\" target=\"_self\">Devoluções</a></li></ul></div><button id=\"footer-about\" aria-expanded=\"false\" aria-controls=\"footer-about-list\" class=\"menu-item\" ng-click=\"controller.toggleFooter(\'footer-about\')\"><span>Sobre a Burberry</span><div class=\"icon-wrapper\"><svg role=\"img\" width=\"7\" height=\"10\" viewbox=\"6.5 5 7 10\"><title>chevron-down</title><path fill=\"none\" stroke=\"currentColor\" stroke-miterlimit=\"10\" stroke-width=\"1.5\" d=\"M12.125 5.75 7.875 10l4.25 4.25\"></path></svg></div></button><div id=\"footer-about-list\"><ul class=\"menu-item-list\" style=\"height: 0;\"><li><a href=\"https://www.burberry.com/c/burberry-heritage/\" target=\"_self\">Burberry Heritage</a></li><li><a href=\"https://www.burberry.com/c/stories/\" target=\"_self\">Stories</a></li><li><a href=\"https://www.burberry.com/c/values/sustainability/\" target=\"_self\">Sustentabilidade</a></li><li><a href=\"https://www.burberryplc.com/impact/Our-Approach\" target=\"_self\" rel=\"noopener noreferrer\">Responsabilidade corporativa</a></li><li><a href=\"https://www.burberryplc.com/\" target=\"_self\" rel=\"noopener noreferrer\">Burberry Group plc</a></li><li><a href=\"https://burberrycareers.com\" target=\"_self\" rel=\"noopener noreferrer\">Carreiras</a></li></ul></div><button id=\"footer-legal\" aria-expanded=\"false\" aria-controls=\"footer-legal-list\" class=\"menu-item\" ng-click=\"controller.toggleFooter(\'footer-legal\')\"><span>Legal e cookies</span><div class=\"icon-wrapper\"><svg role=\"img\" width=\"7\" height=\"10\" viewbox=\"6.5 5 7 10\"><title>chevron-down</title><path fill=\"none\" stroke=\"currentColor\" stroke-miterlimit=\"10\" stroke-width=\"1.5\" d=\"M12.125 5.75 7.875 10l4.25 4.25\"></path></svg></div></button><div id=\"footer-legal-list\"><ul class=\"menu-item-list\" style=\"height: 0;\"><li><a href=\"https://www.burberry.com/legal-cookies/terms-conditions/\" target=\"_self\">Termos e condições</a></li><li><a href=\"https://www.burberry.com/c/legal-cookies/terms-conditions/4gift/\" target=\"_self\">Burberry x 4Gift – Termos e condições</a></li><li><a href=\"https://www.burberry.com/legal-cookies/privacy-policy/\" target=\"_self\">Política de privacidade</a></li><li><a href=\"https://www.burberry.com/legal-cookies/cookie-policy/\" target=\"_self\">Política de Cookies</a></li><li><a href=\"https://www.burberry.com/c/legal-cookies/accessibility-statement/\" target=\"_self\">Declaração de acessibilidade</a></li><li><a href=\"https://www.burberry.com/c/customer-service/4gifts-faqs/\" target=\"_self\">Perguntas frequentes 4Gift</a></li><li><a href=\"https://www.burberry.com/c/legal-cookies/transparency-in-the-supply-chain-modern-slavery-statements/\" target=\"_self\">Declaração sobre a escravidão moderna</a></li><li><a href=\"https://www.burberry.com/legal-cookies/do-not-sell-my-personal-information/\" target=\"_self\">Não vender minhas informações pessoais</a></li><li><a href=\"https://www.burberry.com/site-map/\" target=\"_self\">Mapa do site</a></li></ul></div><button id=\"footer-language\" aria-controls=\"language-picker-modal\" aria-label=\"Clique para abrir a janela de idioma e alterar o idioma\" class=\"menu-item\" ng-click=\"controller.openChangeLanguageModal()\"><span>Idioma<span class=\"current-language\">{{controller.getTextTranslationByKey(\'language\')}}</span></span></button></div></div><div class=\"legal-copy\"><div>Se você estiver usando um leitor de tela e estiver com problemas para usar este site, ligue para <a href=\"tel:+1 877 217 4085\">+1 877 217 4085</a> ou <a href=\"https://www.burberry.com/customer-service/contact-us/\" target=\"_self\">entre em contato conosco</a> para obter ajuda.</div></div></footer>");
$templateCache.put("app/custom/clients/burberry/layout/footer/ru.html","<footer id=\"footer\"><div class=\"footer-menu-container\"><div class=\"menu-section\"><a href=\"/\" title=\"Поиск магазина\" data-title=\"Поиск магазина\">Поиск магазина</a></div><div class=\"menu-section\"><button id=\"footer-services\" aria-expanded=\"false\" aria-controls=\"footer-services-list\" class=\"menu-item\" ng-click=\"controller.toggleFooter(\'footer-services\')\"><span>Услуги Burberry</span><div class=\"icon-wrapper\"><svg role=\"img\" width=\"7\" height=\"10\" viewbox=\"6.5 5 7 10\"><title>chevron-down</title><path fill=\"none\" stroke=\"currentColor\" stroke-miterlimit=\"10\" stroke-width=\"1.5\" d=\"M12.125 5.75 7.875 10l4.25 4.25\"></path></svg></div></button><div id=\"footer-services-list\"><ul class=\"menu-item-list\" style=\"height: 0;\"><li><a href=\"https://www.burberry.com/appointment-booking/\" target=\"_self\">Договориться о встрече</a></li><li><a href=\"https://www.burberry.com/c/stores/bespoke-trench-service/\" target=\"_self\">Тренч на заказ</a></li><li><a href=\"https://www.burberry.com/burberry-aftercare/\" target=\"_self\">Уход за изделиями</a></li><li><a href=\"https://www.burberry.com/c/personalisation-and-monogramming/\" target=\"_self\">Персонализация изделий</a></li><li><a href=\"https://www.burberry.com/c/burberry-services/\" target=\"_self\">Все услуги</a></li></ul></div><button id=\"footer-customer-support\" aria-expanded=\"false\" aria-controls=\"footer-customer-support-list\" class=\"menu-item\" ng-click=\"controller.toggleFooter(\'footer-customer-support\')\"><span>Поддержка клиентов</span><div class=\"icon-wrapper\"><svg role=\"img\" width=\"7\" height=\"10\" viewbox=\"6.5 5 7 10\"><title>chevron-down</title><path fill=\"none\" stroke=\"currentColor\" stroke-miterlimit=\"10\" stroke-width=\"1.5\" d=\"M12.125 5.75 7.875 10l4.25 4.25\"></path></svg></div></button><div id=\"footer-customer-support-list\"><ul class=\"menu-item-list\" style=\"height: 0;\"><li><a href=\"https://www.burberry.com/customer-service/contact-us/\" target=\"_self\">Свяжитесь с нами</a></li><li><a href=\"https://www.burberry.com/customer-service/shipping/\" target=\"_self\">Доставка</a></li><li><a href=\"https://www.burberry.com/customer-service/payment/\" target=\"_self\">Заказ и оплата</a></li><li><a href=\"https://www.burberry.com/customer-service/returns/\" target=\"_self\">Возврат товаров</a></li></ul></div><button id=\"footer-about\" aria-expanded=\"false\" aria-controls=\"footer-about-list\" class=\"menu-item\" ng-click=\"controller.toggleFooter(\'footer-about\')\"><span>О компании Burberry</span><div class=\"icon-wrapper\"><svg role=\"img\" width=\"7\" height=\"10\" viewbox=\"6.5 5 7 10\"><title>chevron-down</title><path fill=\"none\" stroke=\"currentColor\" stroke-miterlimit=\"10\" stroke-width=\"1.5\" d=\"M12.125 5.75 7.875 10l4.25 4.25\"></path></svg></div></button><div id=\"footer-about-list\"><ul class=\"menu-item-list\" style=\"height: 0;\"><li><a href=\"https://www.burberry.com/c/burberry-heritage/\" target=\"_self\">Наследие Burberry</a></li><li><a href=\"https://www.burberry.com/c/stories/\" target=\"_self\">Истории Burberry</a></li><li><a href=\"https://www.burberry.com/c/values/sustainability/\" target=\"_self\">Экологическая рациональность</a></li><li><a href=\"https://www.burberryplc.com/impact/Our-Approach\" target=\"_self\" rel=\"noopener noreferrer\">Корпоративная ответственность</a></li><li><a href=\"https://www.burberryplc.com/\" target=\"_self\" rel=\"noopener noreferrer\">Burberry Group plc</a></li><li><a href=\"https://burberrycareers.com\" target=\"_self\" rel=\"noopener noreferrer\">Вакансии</a></li></ul></div><button id=\"footer-legal\" aria-expanded=\"false\" aria-controls=\"footer-legal-list\" class=\"menu-item\" ng-click=\"controller.toggleFooter(\'footer-legal\')\"><span>Юридическая информация и Политика использования файлов cookie</span><div class=\"icon-wrapper\"><svg role=\"img\" width=\"7\" height=\"10\" viewbox=\"6.5 5 7 10\"><title>chevron-down</title><path fill=\"none\" stroke=\"currentColor\" stroke-miterlimit=\"10\" stroke-width=\"1.5\" d=\"M12.125 5.75 7.875 10l4.25 4.25\"></path></svg></div></button><div id=\"footer-legal-list\"><ul class=\"menu-item-list\" style=\"height: 0;\"><li><a href=\"https://www.burberry.com/legal-cookies/terms-conditions/\" target=\"_self\">Условия участия</a></li><li><a href=\"https://www.burberry.com/c/legal-cookies/terms-conditions/4gift/\" target=\"_self\">Burberry и 4Gift: Условия и положения</a></li><li><a href=\"https://www.burberry.com/legal-cookies/privacy-policy/\" target=\"_self\">Политика конфиденциальности</a></li><li><a href=\"https://www.burberry.com/legal-cookies/cookie-policy/\" target=\"_self\">Политика использования файлов cookie</a></li><li><a href=\"https://www.burberry.com/c/legal-cookies/accessibility-statement/\" target=\"_self\">Удобство использования</a></li><li><a href=\"https://www.burberry.com/c/customer-service/4gifts-faqs/\" target=\"_self\">4Gift: ЧАСТО ЗАДАВАЕМЫЕ ВОПРОСЫ</a></li><li><a href=\"https://www.burberry.com/c/legal-cookies/transparency-in-the-supply-chain-modern-slavery-statements/\" target=\"_self\">Заявление о современном рабстве</a></li><li><a href=\"https://www.burberry.com/legal-cookies/do-not-sell-my-personal-information/\" target=\"_self\">Запрещение продажи персональных данных</a></li><li><a href=\"https://www.burberry.com/site-map/\" target=\"_self\">Карта сайта</a></li></ul></div><button id=\"footer-language\" aria-controls=\"language-picker-modal\" aria-label=\"Нажмите, чтобы открыть окно языка и изменить язык\" class=\"menu-item\" ng-click=\"controller.openChangeLanguageModal()\"><span>Язык<span class=\"current-language\">{{controller.getTextTranslationByKey(\'language\')}}</span></span></button></div></div><div class=\"legal-copy\"><div>Если вы используете программу для чтения экрана и у вас возникли проблемы с этим веб-сайтом, обратитесь за помощью по телефону <a href=\"tel:+1 877 217 4085\">+1 877 217 4085</a> <a href=\"https://www.burberry.com/customer-service/contact-us/\" target=\"_self\">или свяжитесь с нами.</a></div></div></footer>");
$templateCache.put("app/custom/clients/burberry/layout/footer/zh-cn.html","<footer id=\"footer\"><div class=\"footer-menu-container\"><div class=\"menu-section\"><a href=\"/\" title=\"查找店铺\" data-title=\"查找店铺\">查找店铺</a></div><div class=\"menu-section\"><button id=\"footer-services\" aria-expanded=\"false\" aria-controls=\"footer-services-list\" class=\"menu-item\" ng-click=\"controller.toggleFooter(\'footer-services\')\"><span>Burberry 尊享服务</span><div class=\"icon-wrapper\"><svg role=\"img\" width=\"7\" height=\"10\" viewbox=\"6.5 5 7 10\"><title>chevron-down</title><path fill=\"none\" stroke=\"currentColor\" stroke-miterlimit=\"10\" stroke-width=\"1.5\" d=\"M12.125 5.75 7.875 10l4.25 4.25\"></path></svg></div></button><div id=\"footer-services-list\"><ul class=\"menu-item-list\" style=\"height: 0;\"><li><a href=\"https://www.burberry.com/appointment-booking/\" target=\"_self\">登记私人预约</a></li><li><a href=\"https://www.burberry.com/c/stores/bespoke-trench-service/\" target=\"_self\">专属风衣定制服务</a></li><li><a href=\"https://www.burberry.com/burberry-aftercare/\" target=\"_self\">售后保养</a></li><li><a href=\"https://www.burberry.com/c/personalisation-and-monogramming/\" target=\"_self\">私人印记服务</a></li><li><a href=\"https://www.burberry.com/c/burberry-services/\" target=\"_self\">尊享服务</a></li></ul></div><button id=\"footer-customer-support\" aria-expanded=\"false\" aria-controls=\"footer-customer-support-list\" class=\"menu-item\" ng-click=\"controller.toggleFooter(\'footer-customer-support\')\"><span>顾客支持</span><div class=\"icon-wrapper\"><svg role=\"img\" width=\"7\" height=\"10\" viewbox=\"6.5 5 7 10\"><title>chevron-down</title><path fill=\"none\" stroke=\"currentColor\" stroke-miterlimit=\"10\" stroke-width=\"1.5\" d=\"M12.125 5.75 7.875 10l4.25 4.25\"></path></svg></div></button><div id=\"footer-customer-support-list\"><ul class=\"menu-item-list\" style=\"height: 0;\"><li><a href=\"https://www.burberry.com/customer-service/contact-us/\" target=\"_self\">联系我们</a></li><li><a href=\"https://www.burberry.com/customer-service/shipping/\" target=\"_self\">配送服务</a></li><li><a href=\"https://www.burberry.com/customer-service/payment/\" target=\"_self\">订单及付款</a></li><li><a href=\"https://www.burberry.com/customer-service/returns/\" target=\"_self\">退货</a></li></ul></div><button id=\"footer-about\" aria-expanded=\"false\" aria-controls=\"footer-about-list\" class=\"menu-item\" ng-click=\"controller.toggleFooter(\'footer-about\')\"><span>关于 Burberry</span><div class=\"icon-wrapper\"><svg role=\"img\" width=\"7\" height=\"10\" viewbox=\"6.5 5 7 10\"><title>chevron-down</title><path fill=\"none\" stroke=\"currentColor\" stroke-miterlimit=\"10\" stroke-width=\"1.5\" d=\"M12.125 5.75 7.875 10l4.25 4.25\"></path></svg></div></button><div id=\"footer-about-list\"><ul class=\"menu-item-list\" style=\"height: 0;\"><li><a href=\"https://www.burberry.com/c/burberry-heritage/\" target=\"_self\">品牌历史</a></li><li><a href=\"https://www.burberry.com/c/stories/\" target=\"_self\">博柏利故事</a></li><li><a href=\"https://www.burberry.com/c/values/sustainability/\" target=\"_self\">可持续性</a></li><li><a href=\"https://www.burberryplc.com/impact/Our-Approach\" target=\"_self\" rel=\"noopener noreferrer\">企业责任</a></li><li><a href=\"https://www.burberryplc.com/\" target=\"_self\" rel=\"noopener noreferrer\">Burberry 集团公司</a></li><li><a href=\"https://burberrycareers.com\" target=\"_self\" rel=\"noopener noreferrer\">工作机会</a></li></ul></div><button id=\"footer-legal\" aria-expanded=\"false\" aria-controls=\"footer-legal-list\" class=\"menu-item\" ng-click=\"controller.toggleFooter(\'footer-legal\')\"><span>法律声明及 Cookie 政策</span><div class=\"icon-wrapper\"><svg role=\"img\" width=\"7\" height=\"10\" viewbox=\"6.5 5 7 10\"><title>chevron-down</title><path fill=\"none\" stroke=\"currentColor\" stroke-miterlimit=\"10\" stroke-width=\"1.5\" d=\"M12.125 5.75 7.875 10l4.25 4.25\"></path></svg></div></button><div id=\"footer-legal-list\"><ul class=\"menu-item-list\" style=\"height: 0;\"><li><a href=\"https://www.burberry.com/legal-cookies/terms-conditions/\" target=\"_self\">细则及条款</a></li><li><a href=\"https://www.burberry.com/c/legal-cookies/terms-conditions/4gift/\" target=\"_self\">Burberry x 4Gift – 细则及条款</a></li><li><a href=\"https://www.burberry.com/legal-cookies/privacy-policy/\" target=\"_self\">隐私政策</a></li><li><a href=\"https://www.burberry.com/legal-cookies/cookie-policy/\" target=\"_self\">Cookie 政策</a></li><li><a href=\"https://www.burberry.com/c/legal-cookies/accessibility-statement/\" target=\"_self\">可访问性声明</a></li><li><a href=\"https://www.burberry.com/c/customer-service/4gifts-faqs/\" target=\"_self\">4Gift 赠礼服务常见问题</a></li><li><a href=\"https://www.burberry.com/c/legal-cookies/transparency-in-the-supply-chain-modern-slavery-statements/\" target=\"_self\">现代反奴隶制声明</a></li><li><a href=\"https://www.burberry.com/legal-cookies/do-not-sell-my-personal-information/\" target=\"_self\">不要出售我的个人信息</a></li><li><a href=\"https://www.burberry.com/site-map/\" target=\"_self\">站点地图</a></li></ul></div><button id=\"footer-language\" aria-controls=\"language-picker-modal\" aria-label=\"点击打开语言窗口并更改语言\" class=\"menu-item\" ng-click=\"controller.openChangeLanguageModal()\"><span>语言<span class=\"current-language\">{{controller.getTextTranslationByKey(\'language\')}}</span></span></button></div></div><div class=\"legal-copy\"><div>如果您正在使用屏幕阅读器功能，并在使用本网站时遇到问题，请致电 <a href=\"tel:+1 877 217 4085\">+1 877 217 4085</a> <a href=\"https://www.burberry.com/customer-service/contact-us/\" target=\"_self\">或联系我们获取帮助。</a></div></div></footer>");
$templateCache.put("app/custom/clients/burberry/layout/footer/zh-tw.html","<footer id=\"footer\"><div class=\"footer-menu-container\"><div class=\"menu-section\"><a href=\"/\" title=\"尋找店櫃\" data-title=\"尋找店櫃\">尋找店櫃</a></div><div class=\"menu-section\"><button id=\"footer-services\" aria-expanded=\"false\" aria-controls=\"footer-services-list\" class=\"menu-item\" ng-click=\"controller.toggleFooter(\'footer-services\')\"><span>Burberry 服務</span><div class=\"icon-wrapper\"><svg role=\"img\" width=\"7\" height=\"10\" viewbox=\"6.5 5 7 10\"><title>chevron-down</title><path fill=\"none\" stroke=\"currentColor\" stroke-miterlimit=\"10\" stroke-width=\"1.5\" d=\"M12.125 5.75 7.875 10l4.25 4.25\"></path></svg></div></button><div id=\"footer-services-list\"><ul class=\"menu-item-list\" style=\"height: 0;\"><li><a href=\"https://www.burberry.com/appointment-booking/\" target=\"_self\">安排預約</a></li><li><a href=\"https://www.burberry.com/c/stores/bespoke-trench-service/\" target=\"_self\">訂製風衣</a></li><li><a href=\"https://www.burberry.com/burberry-aftercare/\" target=\"_self\">售後保養</a></li><li><a href=\"https://www.burberry.com/c/personalisation-and-monogramming/\" target=\"_self\">個性化服務</a></li><li><a href=\"https://www.burberry.com/c/burberry-services/\" target=\"_self\">Burberry 服務</a></li></ul></div><button id=\"footer-customer-support\" aria-expanded=\"false\" aria-controls=\"footer-customer-support-list\" class=\"menu-item\" ng-click=\"controller.toggleFooter(\'footer-customer-support\')\"><span>顧客協助</span><div class=\"icon-wrapper\"><svg role=\"img\" width=\"7\" height=\"10\" viewbox=\"6.5 5 7 10\"><title>chevron-down</title><path fill=\"none\" stroke=\"currentColor\" stroke-miterlimit=\"10\" stroke-width=\"1.5\" d=\"M12.125 5.75 7.875 10l4.25 4.25\"></path></svg></div></button><div id=\"footer-customer-support-list\"><ul class=\"menu-item-list\" style=\"height: 0;\"><li><a href=\"https://www.burberry.com/customer-service/contact-us/\" target=\"_self\">與我們聯絡</a></li><li><a href=\"https://www.burberry.com/customer-service/shipping/\" target=\"_self\">商品運送</a></li><li><a href=\"https://www.burberry.com/customer-service/payment/\" target=\"_self\">訂購與付款</a></li><li><a href=\"https://www.burberry.com/customer-service/returns/\" target=\"_self\">退貨服務</a></li></ul></div><button id=\"footer-about\" aria-expanded=\"false\" aria-controls=\"footer-about-list\" class=\"menu-item\" ng-click=\"controller.toggleFooter(\'footer-about\')\"><span>關於 Burberry</span><div class=\"icon-wrapper\"><svg role=\"img\" width=\"7\" height=\"10\" viewbox=\"6.5 5 7 10\"><title>chevron-down</title><path fill=\"none\" stroke=\"currentColor\" stroke-miterlimit=\"10\" stroke-width=\"1.5\" d=\"M12.125 5.75 7.875 10l4.25 4.25\"></path></svg></div></button><div id=\"footer-about-list\"><ul class=\"menu-item-list\" style=\"height: 0;\"><li><a href=\"https://www.burberry.com/c/burberry-heritage/\" target=\"_self\">Burberry 品牌歷史</a></li><li><a href=\"https://www.burberry.com/c/stories/\" target=\"_self\">品牌故事</a></li><li><a href=\"https://www.burberry.com/c/values/sustainability/\" target=\"_self\">永續性</a></li><li><a href=\"https://www.burberryplc.com/impact/Our-Approach\" target=\"_self\" rel=\"noopener noreferrer\">企業責任</a></li><li><a href=\"https://www.burberryplc.com/\" target=\"_self\" rel=\"noopener noreferrer\">Burberry Group plc</a></li><li><a href=\"https://burberrycareers.com\" target=\"_self\" rel=\"noopener noreferrer\">工作機會</a></li></ul></div><button id=\"footer-legal\" aria-expanded=\"false\" aria-controls=\"footer-legal-list\" class=\"menu-item\" ng-click=\"controller.toggleFooter(\'footer-legal\')\"><span>法律資訊及 Cookie 政策</span><div class=\"icon-wrapper\"><svg role=\"img\" width=\"7\" height=\"10\" viewbox=\"6.5 5 7 10\"><title>chevron-down</title><path fill=\"none\" stroke=\"currentColor\" stroke-miterlimit=\"10\" stroke-width=\"1.5\" d=\"M12.125 5.75 7.875 10l4.25 4.25\"></path></svg></div></button><div id=\"footer-legal-list\"><ul class=\"menu-item-list\" style=\"height: 0;\"><li><a href=\"https://www.burberry.com/legal-cookies/terms-conditions/\" target=\"_self\">條款與條件</a></li><li><a href=\"https://www.burberry.com/c/legal-cookies/terms-conditions/4gift/\" target=\"_self\">Burberry x 4Gift – 條款與條件</a></li><li><a href=\"https://www.burberry.com/legal-cookies/privacy-policy/\" target=\"_self\">隱私政策</a></li><li><a href=\"https://www.burberry.com/legal-cookies/cookie-policy/\" target=\"_self\">Cookie 政策</a></li><li><a href=\"https://www.burberry.com/c/legal-cookies/accessibility-statement/\" target=\"_self\">無障礙網頁聲明</a></li><li><a href=\"https://www.burberry.com/c/customer-service/4gifts-faqs/\" target=\"_self\">4Gift 常見問答</a></li><li><a href=\"https://www.burberry.com/c/legal-cookies/transparency-in-the-supply-chain-modern-slavery-statements/\" target=\"_self\">現代反奴隸制聲明</a></li><li><a href=\"https://www.burberry.com/legal-cookies/do-not-sell-my-personal-information/\" target=\"_self\">不要出售我的個人資訊</a></li><li><a href=\"https://www.burberry.com/site-map/\" target=\"_self\">網站地圖</a></li></ul></div><button id=\"footer-language\" aria-controls=\"language-picker-modal\" aria-label=\"點擊打開語言窗口並更改語言\" class=\"menu-item\" ng-click=\"controller.openChangeLanguageModal()\"><span>語言<span class=\"current-language\">{{controller.getTextTranslationByKey(\'language\')}}</span></span></button></div></div><div class=\"legal-copy\"><div>如果您使用螢幕助讀程式且在使用本網站時遇到問題，請致電 <a href=\"tel:+1 877 217 4085\">+1 877 217 4085</a> <a href=\"https://www.burberry.com/customer-service/contact-us/\" target=\"_self\">或與我們聯絡以取得協助。</a></div></div></footer>");}]);